import { h } from 'preact';

export function Icon({ children, fill = 'currentColor', stroke, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill={fill}
      stroke={stroke}
    >
      {children}
    </svg>
  );
}

export function IconPlus(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="none"
      viewBox="0 0 10 10"
    >
      <path stroke="currentColor" strokeLinecap="round" d="M5 1v8M9 5H1"></path>
    </Icon>
  );
}

export function IconMinus(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="none"
      viewBox="0 0 10 10"
      {...props}
    >
      <path stroke="currentColor" d="M.818 5h8"></path>
    </Icon>
  );
}

export function IconPlay(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <circle cx="17" cy="17" r="17" fill="white" />
      <circle cx="17" cy="17" r="16.5" stroke="white" strokeOpacity="0.8" />
      <path
        d="M23.6854 17.5226L13.9434 22.9191C13.8478 22.9721 13.7393 23 13.6289 23C13.5185 23 13.41 22.9721 13.3144 22.9192C13.2188 22.8662 13.1394 22.79 13.0842 22.6983C13.029 22.6065 13 22.5025 13 22.3965V11.6035C13 11.4975 13.029 11.3935 13.0842 11.3017C13.1394 11.21 13.2188 11.1338 13.3144 11.0808C13.41 11.0279 13.5185 11 13.6289 11C13.7393 11 13.8478 11.0279 13.9434 11.0809L23.6854 16.4774C23.7811 16.5304 23.8605 16.6065 23.9157 16.6983C23.9709 16.79 24 16.8941 24 17C24 17.1059 23.9709 17.21 23.9157 17.3017C23.8605 17.3935 23.7811 17.4696 23.6854 17.5226Z"
        fill="#2D2926"
      />
    </Icon>
  );
}

export function IconPause(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      fill="none"
      viewBox="0 0 34 34"
    >
      <circle cx="17" cy="17" r="17" fill="white" />
      <circle cx="17" cy="17" r="16.5" stroke="white" strokeOpacity="0.8" />
      <line
        x1="13.92"
        y1="12"
        x2="13.92"
        y2="22"
        stroke="#2D2926"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="20.04"
        y1="12"
        x2="20.04"
        y2="22"
        stroke="#2D2926"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
}

export function IconClose({ width = '18', height = '18', ...props }) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        d="M19.582 2.00012L1.87213 20"
        stroke="#2D2926"
        strokeLinecap="round"
      />
      <path
        d="M19.8719 19.9999L2.16205 1.99997"
        stroke="#2D2926"
        strokeLinecap="round"
      />
    </Icon>
  );
}
export function IconLeftArrow(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="9"
      fill="none"
      viewBox="0 0 6 9"
    >
      <path
        d="M4.90909 8.31812L1.09091 4.49993L4.90909 0.681751"
        stroke="#2D2926"
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function SizeChart(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      fill="none"
      viewBox="0 0 14 15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.239984 11.1699C0.085851 11.0163 -0.000605105 10.8076 4.59023e-06 10.5899C-0.000725883 10.3726 0.0857545 10.1641 0.240009 10.0111L9.51077 0.739985C9.66392 0.585609 9.87246 0.499153 10.0899 0.500006H10.0904C10.3078 0.499398 10.5164 0.585852 10.6698 0.739985L13.7599 3.8302C13.9137 3.98372 14 4.19225 14 4.40955C14 4.62685 13.9137 4.83526 13.7599 4.9889L9.89838 8.85042L9.89728 8.852L9.8957 8.8531L7.96659 10.7822L7.9655 10.7838L7.96391 10.7849L6.03556 12.7132L6.03446 12.7148L6.03287 12.7159L4.48898 14.2598C4.33593 14.4142 4.1273 14.5009 3.90988 14.5002H3.90939C3.69187 14.5005 3.48323 14.4141 3.32995 14.2598L0.239984 11.1699ZM9.89735 1.12648L0.626276 10.3972L0.626215 10.3974C0.519516 10.504 0.519516 10.6769 0.626215 10.7836L3.71618 13.8735C3.76727 13.925 3.83678 13.9539 3.90933 13.9535H3.90982C3.98213 13.9538 4.05152 13.9249 4.10236 13.8735L5.45455 12.5217L4.48914 11.5563C4.38561 11.4491 4.38719 11.2787 4.49256 11.1734C4.59792 11.068 4.76827 11.0666 4.87546 11.1701V11.17L5.84087 12.1354L7.38585 10.5904L6.42044 9.62451C6.31606 9.51745 6.31716 9.34649 6.42288 9.24076C6.52861 9.13504 6.69956 9.13395 6.80663 9.2382L7.77204 10.2041L9.31777 8.65848L8.35189 7.69307C8.24836 7.58587 8.24981 7.41552 8.35518 7.31016C8.46055 7.2048 8.6309 7.20322 8.73809 7.30675L9.70397 8.27216L13.3735 4.60262C13.4802 4.49605 13.4802 4.32314 13.3735 4.21644L10.2835 1.12648C10.2324 1.07502 10.1629 1.04612 10.0904 1.04648H10.0899C10.0176 1.04624 9.9482 1.07514 9.89735 1.12648ZM11.1723 5.23907C10.9144 5.57612 10.5143 5.77391 10.09 5.77428L10.09 5.77426C9.72794 5.77501 9.38041 5.63148 9.12433 5.37552C8.82399 5.07581 8.68009 4.65342 8.73509 4.23258C8.79009 3.81175 9.03749 3.44045 9.40478 3.2279C9.77208 3.01536 10.2174 2.98573 10.6096 3.14767C11.0018 3.30974 11.2963 3.64495 11.4067 4.05467C11.5169 4.46451 11.4303 4.90214 11.1723 5.23907ZM10.0902 3.58934C9.87279 3.58934 9.66426 3.67579 9.51062 3.82944V3.82969C9.35612 3.98297 9.26917 4.19162 9.26917 4.40926C9.26917 4.62691 9.35612 4.83543 9.51062 4.98871C9.66423 5.14248 9.87277 5.22893 10.0902 5.22893C10.3076 5.22893 10.5161 5.14248 10.6699 4.98883C10.8237 4.83509 10.91 4.62656 10.91 4.40914C10.91 4.19171 10.8237 3.98321 10.6699 3.82944C10.5161 3.67579 10.3076 3.58934 10.0902 3.58934Z"
        fill="#2D2926"
      />
    </Icon>
  );
}

export function IconRightArrow(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
    >
      <rect width="42" height="42" rx="21" fill="white" />
      <path
        d="M18 27L24 21L18 15"
        stroke="#2D2926"
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function ZoomIn(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.48416 8.50983C7.37341 8.4024 7.19657 8.40493 7.08893 8.51568L1.57881 14.0258C1.62755 12.3125 1.6763 10.599 1.72504 8.88555L1.72524 8.88536C1.72894 8.81029 1.70243 8.73678 1.65134 8.6816C1.60026 8.62642 1.52909 8.59406 1.45402 8.59191C1.37876 8.58977 1.30583 8.61784 1.25183 8.6701C1.19762 8.72236 1.16701 8.7943 1.16643 8.86937C1.11105 10.8171 1.05548 12.7645 1.00011 14.7119C0.997964 14.7888 1.0276 14.8632 1.08181 14.9176C1.1362 14.972 1.21049 15.0015 1.28751 14.9993C3.23574 14.9445 5.18383 14.8898 7.13207 14.8348V14.835C7.20694 14.8338 7.27811 14.803 7.32997 14.749C7.38184 14.695 7.40972 14.6224 7.40757 14.5476C7.40562 14.4727 7.37345 14.4019 7.31886 14.3508C7.26407 14.2997 7.19115 14.2728 7.11627 14.2761C5.40219 14.3245 3.68811 14.3727 1.97402 14.4208L7.48415 8.91069C7.53835 8.85804 7.56896 8.78571 7.56896 8.71006C7.56877 8.6346 7.53815 8.56226 7.48395 8.50962L7.48416 8.50983Z"
        fill="#2D2926"
        stroke="#2D2926"
        strokeWidth="0.35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9204 1.0846C14.8658 1.02864 14.7903 0.998028 14.7121 1.00037L8.86956 1.16669V1.16649C8.7943 1.16708 8.72255 1.19788 8.67029 1.25189C8.61804 1.30609 8.58996 1.37883 8.59211 1.45409C8.59425 1.52915 8.62642 1.60032 8.6816 1.65141C8.73698 1.70249 8.81029 1.72901 8.88536 1.72531L14.0256 1.57907L8.51549 7.08919H8.51568C8.46265 7.14145 8.43281 7.21281 8.43262 7.2873C8.43242 7.36159 8.46187 7.43314 8.51451 7.48579C8.56715 7.53843 8.63852 7.56787 8.713 7.56768C8.78748 7.56729 8.85865 7.53746 8.9111 7.48462L14.4212 1.97449L14.2766 7.11674H14.2764C14.2732 7.19142 14.3001 7.26434 14.3512 7.31894C14.4023 7.37373 14.4731 7.40571 14.5478 7.40785C14.6226 7.4098 14.6952 7.38192 14.7492 7.33024C14.8032 7.27838 14.8342 7.20721 14.8352 7.13234L14.9997 1.28779C15.0019 1.21233 14.9732 1.13901 14.9206 1.08481L14.9204 1.0846Z"
        fill="#2D2926"
        stroke="#2D2926"
        strokeWidth="0.35"
      />
    </Icon>
  );
}

export function IconArrow({ direction = 'left' }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
      fill="none"
      viewBox="0 0 6 10"
      className={`transition-transform ${
        direction === 'right' ? 'rotate-180 origin-center' : ''
      } ${direction === 'bottom' ? '-rotate-90 origin-center' : ''} ${
        direction === 'top' ? 'rotate-90 origin-center' : ''
      }`}
    >
      <path
        stroke="#2D2926"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="16"
        d="M5 9.495l-4-4 4-4"
      ></path>
    </Icon>
  );
}

export function IconHeart({ filled, ...props }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      fill="none"
      viewBox="0 0 22 19"
      className="w-full h-full"
      {...props}
    >
      {filled ? (
        <path
          fill="#565351"
          stroke="#565351"
          strokeWidth="0.3"
          d="M15.554.334c2.847 0 5.121 2.298 5.413 5.466.023.14.117.877-.17 2.077-.415 1.733-1.373 3.308-2.77 4.556l-7.087 6.234-6.968-6.234c-1.396-1.248-2.354-2.824-2.769-4.556-.287-1.2-.193-1.937-.17-2.077C1.325 2.632 3.6.333 6.446.333c1.866 0 3.53.986 4.499 2.62a5.395 5.395 0 014.61-2.62z"
        ></path>
      ) : (
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.3"
          d="M18.97 5.42C18.708 2.57 16.66.5 14.1.5c-1.707 0-3.27.906-4.149 2.357C9.08 1.387 7.58.5 5.901.5 3.34.5 1.292 2.569 1.03 5.42c-.02.126-.106.789.153 1.87.373 1.558 1.235 2.977 2.492 4.1L9.946 17l6.379-5.61c1.257-1.123 2.119-2.541 2.492-4.1.259-1.081.174-1.744.153-1.87zm-.827 1.713c-.34 1.424-1.13 2.721-2.281 3.75L9.95 16.081l-5.81-5.198c-1.153-1.03-1.942-2.327-2.283-3.751-.245-1.023-.144-1.6-.144-1.605l.005-.034c.225-2.498 1.984-4.311 4.183-4.311 1.623 0 3.05.983 3.729 2.564l.319.745.318-.745c.668-1.557 2.171-2.564 3.832-2.564 2.199 0 3.958 1.813 4.188 4.344 0 .005.101.583-.144 1.606z"
        ></path>
      )}
    </Icon>
  );
}

export function IconTruck(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="12"
      fill="none"
      viewBox="0 0 26 12"
      {...props}
    >
      <path
        fill="#2D2926"
        fillRule="evenodd"
        d="M6.985.667a.385.385 0 00-.389.38v1.01c0 .101.04.198.114.27a.396.396 0 00.553 0 .374.374 0 00.114-.27v-.632h10.707v7.909h-5.658a1.985 1.985 0 00-3.89 0h-1.55a.385.385 0 00-.39.377c0 .1.04.197.114.269a.398.398 0 00.275.112h1.552c.182.892.981 1.575 1.942 1.575s1.763-.683 1.945-1.575h7.425a1.986 1.986 0 001.944 1.575c.961 0 1.762-.683 1.944-1.575h1.374c.216-.001.39-.172.389-.38V5.992c0-.07-.02-.138-.057-.198l-2.11-3.292a.393.393 0 00-.332-.18h-4.136V1.047c0-.209-.174-.38-.39-.38H6.986zm11.88 2.414h3.917l1.937 3.022v3.23h-.979a1.985 1.985 0 00-1.947-1.588c-.965 0-1.77.69-1.947 1.589h-.981V3.08zm-13.007.345a.397.397 0 00-.276.11.375.375 0 00-.116.267c.001.1.042.197.116.268.073.07.173.11.276.11H9.75c.103 0 .203-.04.276-.11a.373.373 0 00.116-.268c0-.1-.042-.197-.116-.267a.396.396 0 00-.276-.11H5.858zM3.374 5.523c-.215 0-.39.17-.39.379 0 .1.04.197.114.268a.397.397 0 00.276.112h5.134c.104 0 .204-.04.277-.111a.374.374 0 000-.538.397.397 0 00-.277-.11H3.374zM.889 7.622a.397.397 0 00-.276.112.373.373 0 00-.113.268c0 .208.175.377.39.378h6.375c.103 0 .203-.04.276-.11a.373.373 0 00.002-.537.397.397 0 00-.278-.111H.889zm9.56.878h.03a1.2 1.2 0 011.202 1.206c0 .674-.54 1.203-1.202 1.203A1.194 1.194 0 019.28 9.706c0-.663.52-1.19 1.168-1.206zm11.313 0h.031a1.2 1.2 0 011.202 1.206c0 .674-.539 1.203-1.202 1.203a1.197 1.197 0 01-1.202-1.203 1.2 1.2 0 011.17-1.206h.001z"
        clipRule="evenodd"
      ></path>
    </Icon>
  );
}

export function IconTime(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      fill="none"
      viewBox="0 0 16 18"
      {...props}
    >
      <path
        fill="#2D2926"
        stroke="#2D2926"
        strokeWidth="0.2"
        d="M15.366 11.82a7.51 7.51 0 00-.53-5.32.259.259 0 00-.355-.113.274.274 0 00-.115.363 6.965 6.965 0 01.493 4.934c-.982 3.665-4.69 5.868-8.264 4.91C3.02 15.636.91 11.874 1.893 8.21c.982-3.665 4.69-5.868 8.264-4.91a6.51 6.51 0 011.788.778l-2.45.188a.27.27 0 00-.236.2.306.306 0 00-.01.09c.01.147.134.258.28.247l3.466-.265a.272.272 0 00.203-.42l-1.92-2.93a.259.259 0 00-.366-.07.275.275 0 00-.073.374l1.401 2.14a7.04 7.04 0 00-1.943-.848C6.443 1.75 2.445 4.126 1.387 8.078c-1.06 3.951 1.215 8.004 5.068 9.036 3.854 1.033 7.852-1.343 8.911-5.294h0z"
      ></path>
      <path
        stroke="#2D2926"
        strokeLinecap="round"
        strokeWidth="0.8"
        d="M8 7.21v3.214h3.214"
      ></path>
    </Icon>
  );
}

export function IconStar({ classes, ...props }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 16 15"
      className={classes}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 0l1.88 5.411 5.728.117-4.565 3.46 1.66 5.484L8 11.2l-4.702 3.272L4.957 8.99.392 5.528l5.727-.117L8 0z"
      ></path>
    </Icon>
  );
}

export function IconHalfStar({ classes, ...props }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 16 15"
      className={classes}
      {...props}
    >
      <path
        d="M8 0L9.88091 5.41115L15.6085 5.52786L11.0434 8.98885L12.7023 14.4721L8 11.2L3.29772 14.4721L4.95662 8.98885L0.391548 5.52786L6.11909 5.41115L8 0Z"
        fill="currentColor"
      />
      <mask
        id="mask0_2205_11001"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="8"
        y="0"
        width="8"
        height="16"
      >
        <rect
          width="8"
          height="16"
          transform="matrix(-1 0 0 1 16 0)"
          fill="currentColor"
        />
      </mask>
      <g mask="url(#mask0_2205_11001)">
        <path
          d="M8 0L6.11909 5.41115L0.391548 5.52786L4.95662 8.98885L3.29772 14.4721L8 11.2L12.7023 14.4721L11.0434 8.98885L15.6085 5.52786L9.88091 5.41115L8 0Z"
          fill="#ABA9A8"
        />
      </g>
    </Icon>
  );
}

export function IconShippingAlert(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="19"
      fill="none"
      viewBox="0 0 17 19"
      {...props}
    >
      <path
        fill="#837367"
        fillRule="evenodd"
        d="M8.146 4.01l-.019-.115c-.025-.154-.026-.31-.027-.469 0-.1 0-.2-.008-.3-.016-.233-.019-.466-.022-.699-.004-.26-.007-.52-.03-.78-.008-.102.007-.198.022-.292.014-.092.029-.183.02-.275C8.067.934 8.073.787 8.08.64c.004-.09.008-.182.007-.274a.68.68 0 00-.002-.035c-.002-.044-.004-.09.026-.13a.384.384 0 00.04-.085c.024-.062.047-.122.112-.115.11.006.165.138.193.23l.033.114c.1.346.2.695.26 1.05.052.306.09.62.069.941-.007.078.002.164.012.25.005.045.01.092.012.137l.03.496c.021.387.043.773.077 1.16.02.22.032.44.045.66l.024.395a1.1 1.1 0 01-.023.263c-.009.053-.018.107-.022.161-.003.073-.034.152-.145.156-.134.003-.203-.07-.238-.176a6.67 6.67 0 01-.085-.279c-.025-.085-.05-.173-.08-.263-.14-.427-.21-.858-.278-1.286zM5.53 5.134c-.111-.176-.223-.352-.374-.504-.084-.133-.168-.263-.252-.392a17.252 17.252 0 01-.383-.608 3.435 3.435 0 00-.23-.331c-.091-.122-.183-.244-.257-.38a1.476 1.476 0 00-.296-.342 6.332 6.332 0 01-.08-.076.27.27 0 00-.3-.065c-.083.036-.077.127-.071.21l.002.038a.43.43 0 00.038.162c.06.125.11.254.16.382.081.208.162.416.282.609.08.13.135.272.19.414.056.144.111.287.193.417.566.897 1.204 1.735 1.987 2.46.096.09.204.088.312.087l.047-.001a.1.1 0 00.093-.12 2.641 2.641 0 00-.314-.867 7.125 7.125 0 00-.518-.755 4.082 4.082 0 01-.23-.338zm10.796 12.868c-.766-.3-1.51-.59-2.266-.88-2.856-1.334-5.65-2.765-8.436-4.19l-.59-.302c.056-.024.097-.04.139-.055.129-.046.26-.082.391-.119.22-.06.44-.121.647-.23.414-.213.825-.44 1.211-.706.248-.17.494-.34.74-.512.195-.136.39-.272.585-.406.386-.27.749-.562 1.107-.866.131-.111.243-.24.354-.369.103-.119.205-.237.322-.342.218-.196.435-.403.632-.62.12-.133.22-.282.321-.43.117-.172.235-.345.383-.495.09-.093.174-.194.257-.295.078-.094.156-.188.24-.274.237-.249.393-.525.475-.85.02-.073.01-.145 0-.218a.724.724 0 01-.01-.174c.028-.328-.134-.504-.462-.511a1.16 1.16 0 00-.449.08c-.266.101-.519.23-.772.357-.141.07-.282.142-.425.208-.352.166-.68.383-.986.618-.136.103-.275.202-.415.3a8.193 8.193 0 00-.696.531c-.067.059-.142.113-.216.167-.106.076-.211.153-.298.244-.157.16-.33.3-.504.44a5.405 5.405 0 00-.524.46c-.237.25-.495.476-.753.703-.282.246-.563.493-.817.77-.06.066-.117.135-.173.203a2.872 2.872 0 01-.351.377c-.363.31-.649.676-.763 1.155-.02.09-.027.173.048.21.067.035.106-.014.148-.065.008-.01.016-.021.025-.03.085-.095.16-.2.237-.304.147-.204.295-.409.518-.545a.39.39 0 00.087-.083c.225-.305.511-.55.797-.792l.18-.154c.166-.144.345-.275.523-.406.25-.184.501-.368.721-.59a.347.347 0 01.066-.056l.244-.18a8.08 8.08 0 00.508-.389c.316-.273.647-.523.98-.775l.148-.112c.366-.276.745-.527 1.125-.78.254-.17.528-.296.806-.423.197-.09.396-.181.591-.29-.039.262-.193.437-.344.608-.065.074-.13.147-.184.227-.117.172-.296.31-.49.417a2.22 2.22 0 00-.448.352c-.118.112-.233.227-.348.342-.154.153-.307.305-.466.451-.08.073-.167.139-.254.204-.135.101-.268.202-.37.328-.23.28-.513.5-.793.716l-.143.112c-.432.34-.887.655-1.34.969h-.001c-.172.12-.344.238-.515.359l-.259.187c-.205.15-.411.3-.627.43l-.202.121c-.193.114-.384.228-.56.366-.125.096-.125.272.027.38-.097-.014-.142.016-.155.092-.018.087.03.145.093.187l.056.039c.316.218.633.437.972.62.299.163.598.33.897.496l.448.249c.064.035.127.072.19.108h.001c.183.105.366.21.558.292a9.96 9.96 0 011.125.548c.338.196.692.362 1.046.528.22.102.44.205.654.314.221.113.435.236.65.36.359.208.718.415 1.106.568.14.056.27.132.402.21.074.042.147.085.223.125.072.037.144.072.217.107.151.073.302.146.442.235.257.163.53.287.804.41l.113.052c.163.073.327.145.491.216.405.177.81.354 1.2.56.165.086.355.114.541.107.114-.003.252-.09.238-.204a.607.607 0 01.013-.174c.01-.058.02-.114.012-.174a22.764 22.764 0 01-.032-.228c-.048-.345-.095-.687-.213-1.018a9.931 9.931 0 01-.289-1.055c-.051-.219-.103-.439-.163-.656l-.164-.587c-.082-.294-.165-.588-.243-.882-.04-.142-.073-.285-.107-.428-.054-.225-.108-.45-.18-.67-.07-.214-.131-.43-.192-.645a24.518 24.518 0 00-.463-1.486c-.107-.31-.219-.619-.33-.927-.087-.239-.173-.477-.257-.715a11.781 11.781 0 01-.08-.237c-.07-.216-.141-.432-.247-.636-.132-.252-.263-.504-.376-.76a6.54 6.54 0 00-.233-.45 6.07 6.07 0 01-.25-.491l-.007-.016c-.02-.049-.048-.119-.135-.122-.027.061-.01.119.007.177l.014.05c.042.175.058.353.075.53.018.199.036.397.09.592.09.317.17.636.25.955.17.67.34 1.34.585 1.988.129.342.236.692.344 1.04.069.223.138.446.212.667.061.183.112.37.164.556.07.255.14.51.236.755.245.638.441 1.29.624 1.95a35.059 35.059 0 00.553 1.802c.055.155.113.316.137.502zM3.232 8.09c-.394-.269-.79-.527-1.218-.765a37.72 37.72 0 01-.369-.206c-.159-.09-.316-.177-.476-.264-.104-.055-.225-.093-.318 0-.096.097-.076.232-.01.332.2.3.441.572.759.738.277.144.532.322.787.5.207.146.414.29.634.418.098.055.193.117.288.178.176.114.352.228.547.305l.056.024c.114.051.243.11.358-.021.072-.08.01-.3-.114-.431a.048.048 0 00-.01-.014 61.037 61.037 0 01-.08-.077c-.266-.254-.527-.504-.834-.717z"
        clipRule="evenodd"
      ></path>
    </Icon>
  );
}

export function IconChecked(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
      {...props}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.833 8l3.111 3.333 6.223-6.666"
      ></path>
    </Icon>
  );
}

export function IconArrowCurvy({ classes, ...props }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="108"
      fill="none"
      viewBox="0 0 112 108"
      className={classes}
      {...props}
    >
      <g clipPath="url(#clip0_2453_13714)">
        <path
          fill="#837367"
          d="M.433 56.605C5.493 48.199 15.81 44.207 27.1 43.934c6.153-.148 12.582.681 18.976 1.977 3.791.769 11.537 1.503 13.422 5.984 1.61 3.823-2.548 7.22-5.837 7.797-3.853.678-9.045-1.667-10.798-5.72-1.756-4.061.358-7.671 3.643-9.237 4.507-2.153 10.96-1.899 16.475-1.719 14.432.47 29.326 3.787 44.066 7.1 1.136.255 2.097 1.637 1.443 2.413-2.216 2.625-5.005 4.48-8.427 5.807-.509-.871-1.027-1.742-1.537-2.614 2.568-.601 6.225-1.52 7.702-3.483 1.248-1.655-.367-2.38-2.117-3.582-1.543-1.06-3.095-2.12-4.638-3.18-1.851-1.267-.303-3.438 1.538-2.145 2.545 1.785 5.566 3.505 7.867 5.568 1.197 1.064 1.845 2.108 1.582 3.37-.351 1.68-2.512 2.793-3.915 3.61-1.953 1.13-4.131 1.924-6.482 2.456-1.694.389-3.117-2.016-1.537-2.614 2.988-1.139 5.302-2.882 7.183-5.187.48.803.959 1.606 1.444 2.413-11.644-2.69-23.343-5.388-34.898-6.67-6.125-.678-12.287-.996-18.143-.589-3.13.22-6.59.72-8.336 2.97-1.814 2.334-1.327 6.178 2.48 8.115 3.601 1.83 6.948.362 8.388-2.113 2.421-4.148-5.359-5.3-8.26-5.962-6.017-1.38-12.054-2.387-17.93-2.566-11.909-.358-23.043 2.848-28.596 11.5-.467.724-1.865-.292-1.428-1.024l.003-.004z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2453_13714">
          <path
            fill="#fff"
            d="M0 0H87.183V70.245H0z"
            transform="scale(-1 1) rotate(-35.642 23.125 199.266)"
          ></path>
        </clipPath>
      </defs>
    </Icon>
  );
}

export function IconArrowDown(props) {
  const { direction, ctaButton } = props;
  const rotation = direction === 'top' ? '180deg' : '0deg';
  const arrowColor = ctaButton !== 'black' ? 'rgb(45, 41, 38)' : 'white';

  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      fill="none"
      viewBox="0 0 23 22"
      {...props}
      style={{
        transform: `rotate(${rotation})`,
        transition: 'transform 0.3s ease',
      }}
    >
      <path
        d="M5.5 8L11.5 14L17.5 8"
        stroke={arrowColor}
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function IconWool({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="23 35 51 39"
      className={classes}
      {...props}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #989898; }`}
          {`.cls-2 { fill: #424242; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m45.79,66.02c.02-.07.03-.15.05-.22.12-.08.12-.19.08-.31.02-.11,0-.24.06-.34.39-.71.55-1.54,1.04-2.2.49-.2.42-.67.51-1.07,0,0,0,0,0,0,.25-.07.36-.26.45-.48.28-.69.64-1.33,1.03-1.97.21-.33.63-.61.53-1.1.27-.37.49-.78.65-1.22.17-.01.25-.14.32-.27.21-.41.49-.76.81-1.11.33-.35.62-.76.74-1.26.06-.12.12-.25.18-.37.15-.08.27-.18.35-.34.02-.03.03-.05.05-.08.19-.07.31-.19.33-.4.02-.02.04-.04.07-.06.24-.08.43-.24.63-.39.11-.06.22-.07.37-.03-.21.31-.42.61-.63.91-.14.03-.17.13-.16.26,0,0,0,.01,0,.01-.13,0-.2.1-.3.15-.49.28-.61.83-.83,1.27-.19.39-.47.78-.52,1.25-.03.03-.06.06-.09.09-.25.02-.26.19-.23.38-.44.47-.51,1.12-.84,1.65-.15.06-.29-.12-.44-.04v.66c-.06.09-.12.19-.18.28-.33.21-.61.45-.61.88-.2.2-.24.47-.36.7-.39.2-.42.68-.71.96-.07.07.06.14.12.19-.23.47-.56.87-.83,1.31-.33.55-.59,1.13-.78,1.74-.14.47-.26.96-.51,1.4-.04.08-.08.14-.1.23-.06.28-.22.66-.02.83.23.18.58-.04.85-.18.28-.14.58-.17.87-.21.63-.08,1.25-.25,1.89-.16.33.04.59-.23.92-.2.48-.11.96-.21,1.44-.32.17-.04.34-.06.45-.22.07-.03.15-.06.22-.09.42.08.7-.19,1-.4.43-.03.72-.39,1.12-.48.17.03.47-.22.47.2,0,0,0,0,0,0-.2-.05-.29.1-.38.22-.98.69-2,1.32-3.15,1.71-.62.21-1.28.52-1.89.47-.66-.06-1.19.23-1.78.31-.3.13-.67-.02-.94.21-.06,0-.12.02-.18.03,0-.14-.14-.17-.22-.15-.43.09-.9-.05-1.28.26-.83.02-1.52.38-2.15.89-.57.11-.95.43-1.13.98-.18.08-.27.34-.52.27-.06-.01-.09.02-.09.08h0c-.39.27-.8.5-1.25.68-.15.06-.35.08-.45.24-.11.01-.22.02-.33.04-.13-.11-.22-.06-.28.07-.05,0-.1.01-.16.02-.25-.12-.53-.08-.77-.03-1.08.2-2.14.17-3.22-.02-.49-.08-.96-.28-1.45-.27-.28,0-.53-.09-.74-.23-.17-.12-.34-.15-.53-.14-.27.01-.56.1-.69-.27-.04-.11-.26-.13-.31-.07-.3.36-.69.05-1.03.16-.14.05-.33-.07-.44.11-.06,0-.11-.02-.17-.03-.23-.43-.66-.25-.98-.26-.45-.01-.93.03-1.32.35-.22.02-.45.05-.67.07-.17-.06-.34-.13-.47.07-.05,0-.1.02-.14.03-.37-.1-.65.02-.84.36-.02.01-.04.02-.06.03-.2-.01-.39,0-.47.24-.06.03-.11.06-.17.1-.21-.12-.15.08-.19.16-.23.2-.38.42-.45.74-.11.52-.27.54-.63.16.3-.49.37-1.11.87-1.48.04-.03.02-.14.02-.21.1-.12.21-.23.36-.28.29.12.38.08.52-.26.99-.22,1.96-.56,3-.55.27,0,.58.19.81-.13.24,0,.48.02.72.03.04.13.15.13.25.12.52-.04,1.01.08,1.49.23.19.06.34.02.47-.12,1.06.45,2.19.67,3.32.85.15.02.32-.02.48-.03.04.03.09.1.13.1,1.04.04,2.08.08,3.11-.14.11-.02.21-.04.21-.18.14-.04.28-.08.42-.12.43.07.81-.14,1.21-.24.12-.03.26-.14.24-.32h0c.14.02.21-.05.26-.18.17-.13.34-.26.51-.39.34-.04.58-.21.7-.54.47-.37.93-.75,1.53-.9.2-.05.39-.18.58-.27.27-.12.59-.1.85-.27.15-.14.02-.32.08-.48.03-.01.09-.02.1-.04,0-.07-.05-.06-.1-.07.01-.23.02-.46.03-.7.12-.06.14-.16.1-.28.02-.06.05-.11.07-.17.09-.06.04-.12.01-.19.01-.05.03-.1.04-.16.07,0,.09-.04.1-.1Z"
      />
      <path
        className="cls-2"
        d="m71.85,61.55s-.02.04-.04.06c-.34.21-.55.51-.58.91-.01.02-.02.04-.03.06-.43.29-.71.69-.82,1.2-.02.14-.1.25-.21.33-.44.27-.79.65-1.15.99-.31.3-.59.58-1.01.73-.22.08-.45.17-.63.31-1.06.85-2.33,1.4-3.32,2.36-.14.14-.36.2-.54.29-1.02.51-2.08.91-3.17,1.27-.24.08-.47.17-.71.23-.1.03-.28.06-.27-.12.02-.35.28-.6.38-.93.05-.17.3-.16.47-.18.98-.16,1.86-.61,2.79-.91.71-.23,1.36-.62,1.99-1.03.21-.14.29-.26.25-.48-.12-.78-.4-1.49-.91-2.1-.23-.27-.15-.84.08-.97.23-.14.41.03.39.15-.05.37.27.49.4.73-.15.38.1.59.35.79.06.29.23.55.2.87-.06.25.1.24.25.21.51-.12.85-.53,1.26-.81.15-.1.02-.26-.12-.35-.12-.76-.36-1.46-.77-2.11-.43-.68-.71-1.45-1.24-2.08-.04-.05-.03-.14-.04-.21.11-.15,0-.44.3-.47.72.8,1.33,1.67,1.72,2.67.22.55.36,1.13.54,1.7.01.08-.02.26.12.18.23-.14.55-.2.63-.52.02-.02.04-.03.06-.04,1.15-.8,1.85-1.93,2.31-3.23.04-.12.07-.25.15-.36.42-.53.68-1.14.91-1.77.15-.42.11-.93.41-1.28.25-.29.17-.47-.01-.7,0-.05,0-.1,0-.14.2-.7.17-1.43.3-2.14.07-.4.23-.83.08-1.25.03-.05.06-.11.08-.16q.22-.51.74-.2c-.19-.39-.03-.72-.08-1.06-.02-.13-.09-.29.09-.33.19-.04.22.12.26.28.12.47.04.96.04,1.43,0,.45.04.95-.17,1.42-.1.22-.18.59.07.86-.02.7-.32,1.34-.41,2.03-.23.36-.29.78-.37,1.18-.04.23-.35.38-.17.65,0,.05-.02.1-.02.15-.24.2-.28.47-.28.76-.03.07-.06.14-.09.21-.17.15-.29.33-.28.57-.02.05-.04.09-.06.14-.11.04-.15.11-.1.22Z"
      />
      <path
        className="cls-2"
        d="m70.05,40.06s.06.07.08.1c.02.25.01.52.33.62,0,.03.02.05.03.08-.02.13-.04.26.15.26.21.39.42.78.63,1.17.06.33.18.64.43.88.2.19.35.46.33.7-.06.57.24,1,.45,1.47.29.65.59,1.29.69,2.02.07.5.23.98.2,1.5-.02.35.36.77-.22,1-.02,0-.06.05-.05.07.15.35.01.81.36,1.09.09.08.16.13.1.24-.05.1-.15.15-.26.11-.24-.1-.25.04-.24.21,0,.11,0,.23,0,.39-.16-.19-.26-.32-.26-.53,0-.43-.01-.86-.06-1.29-.05-.47-.26-.96-.2-1.41.08-.54-.07-1.08.05-1.61.02-.09.01-.18-.09-.23-.3-.13-.21-.42-.15-.57.16-.4-.16-.6-.34-.75-.18-.14-.18-.2-.13-.37.11-.34-.13-.63-.15-.96-.46,0-.3-.65-.74-.71-.09-.01-.03-.37-.31-.31-.02-.02-.03-.03-.04-.06.05-.11.02-.19-.1-.22-.03-.07-.05-.15-.08-.22.02-.2,0-.37-.19-.49-.33-.49-.63-.99-.93-1.5-.16-.27-.41-.48-.62-.72-.14-.16-.29-.06-.43-.02-.47.15-.95.3-1.42.46-.2.07-.41.02-.61.06-.61.1-1.16.35-1.73.58-1.05.42-2.03,1.04-3.18,1.2-.18.03-.35.09-.45-.14.16-.06.29-.15.32-.33.06-.03.12-.06.18-.09.08,0,.14-.03.16-.11.05,0,.11,0,.16,0,.19.06.26-.06.3-.2.64-.31,1.27-.63,1.91-.94.4-.04.77-.15,1.08-.4.44-.25.92-.09,1.38-.17.27-.04.55-.03.82-.04.07.19.16.22.28.04.11-.02.22-.04.33-.07.1.13.14.03.18-.05.09-.08.36.02.24-.26-.04-.43-.38-.52-.71-.61-.65-.67-1.48-1.07-2.27-1.53-.59-.35-1.24-.55-1.85-.84-.18-.09-.38-.07-.58.04-.63.38-1.26.75-1.91,1.09-.41.21-.86.35-1.29.52-.11.05-.2,0-.29-.03-.06-.19.18-.27.15-.45.27-.28.66-.35.99-.51.39.13.63-.06.82-.37.43-.22.88-.41,1.42-.56-.89-.35-1.75-.48-2.6-.67-.36-.26-.8-.26-1.21-.37,0,0-.02.05-.04.07-.34-.06-.68-.12-1.02-.19-.07-.13-.14-.13-.22,0-.35.25-.67.08-1-.05,0-.06,0-.12,0-.18.25-.05.5-.1.76-.14.28.05.56.13.82-.05.4-.14.81,0,1.21,0,.07.09.17.11.28.1.31.02.62.04.93.06.18.19.38.11.59.07.71.17,1.42.29,2.1.58-.01.11.03.22.14.24.44.1.82.39,1.29.35.1.08.21.16.31.23.16.35.49.21.76.28.1.05.21.1.31.15.46.45,1.01.73,1.6.96.34.22.52.6.88.8.04.37.25.57.61.63,0,.02,0,.05.02.07-.02.15.04.2.19.16.05.05.09.09.14.14.15.17.16.46.45.51Z"
      />
      <path
        className="cls-1"
        d="m65.26,66.63c.04.23-.04.34-.25.48-.63.41-1.28.8-1.99,1.03-.93.31-1.81.76-2.79.91-.16.03-.41.01-.47.18-.1.32-.37.58-.38.93,0,.18.17.15.27.12.24-.06.48-.15.71-.23,1.08-.36,2.15-.76,3.17-1.27.18-.09.4-.15.54-.29.98-.96,2.26-1.51,3.32-2.36.18-.14.41-.24.63-.31.41-.15.69-.43,1.01-.73.36-.34.71-.73,1.15-.99-.08.44-.35.77-.66,1.03-.41.34-.75.75-1.2,1.05-.35.24-.74.4-1.1.63-.33.22-.63.46-.92.73-.27.25-.55.47-.92.57-.4.1-.73.41-1,.64-.58.49-1.28.65-1.92.91-1.52.61-3.04,1.25-4.68,1.51-.82.13-1.65.34-2.46.29-.9-.05-1.81.11-2.71-.12-.13-.03-.26-.05-.32-.19.37-.06.72.11,1.09.1.9-.04,1.8-.07,2.7-.18.95-.11,1.89-.24,2.79-.58.38-.15.31-.48.33-.78,0-.09.07-.25-.06-.27-.28-.04-.31.27-.47.4-.03.03-.04.08-.11.04-.06-.26-.24-.31-.49-.23-.33.1-.68.09-1,.23.11-.43.51-.34.79-.41.39-.11.81-.13,1.21-.21.32-.06.37-.35.39-.61.1-1.05.18-2.11.27-3.17.02-.25.27-.3.41-.32.17-.03.12.21.11.32-.13,1.01-.04,2.05-.41,3.03-.04.11-.06.25,0,.34.1.13.17-.03.25-.06.87-.23,1.63-.73,2.48-1,.13-.04.15-.13.14-.24-.04-.6.11-1.19.12-1.79,0-.7.11-1.4.22-2.09.04-.27.05-.53.04-.79-.04-.87.19-1.72.18-2.58,0-.25-.02-.5-.02-.75,0-.14,0-.28.19-.27.24.02.13.22.16.34.03.12-.06.31.12.32.15.01.19-.17.21-.3.03-.14.04-.29.03-.44-.11-.81-.12-1.61,0-2.42.05-.37.01-.76.01-1.14.21.05.16.22.16.36,0,.37,0,.73,0,1.1,0,1.73-.01,3.46-.15,5.19-.01.16-.02.32-.13.45-.25-.16.02-.37-.06-.55-.05-.11.09-.33-.17-.31-.18.02-.26.13-.27.33-.01.21.07.39.05.6-.06.86-.13,1.72-.25,2.57-.01.07-.16.62.35.42.09.41-.13.74-.25,1.1-.08.23-.28.54-.09.68.16.12.46-.06.7-.21.45-.29.84-.7,1.4-.79Z"
      />
      <path
        className="cls-1"
        d="m45.34,68.2c-.25.18-.57.16-.85.27.09-.38-.24-.51-.45-.62-.62-.32-1.25-.62-1.82-1.02-.88-.62-1.64-1.36-2.2-2.29-.23-.38-.47-.74-.71-1.11-.59-.89-.8-1.96-1.42-2.83-.1-.14-.15-.32-.18-.49-.16-.81-.63-1.53-.68-2.37-.06-.95-.68-1.8-.49-2.79-.65-1.16-.25-2.44-.36-3.66-.06-.63.09-1.36.47-1.99.25-.41.26-.95.36-1.44.13-.62.21-1.25.46-1.84.02-.06.1-.09.16-.14,0,.31.21.59.14.92-.32.21-.24.59-.34.89-.29.81-.34,1.69-.6,2.52-.12.4.15.72.27,1.07-.18.08-.47.06-.43.37.03.24.1.47.15.71-.13.29-.16.61-.09.88.31,1.23.37,2.51.76,3.73.17.55.16,1.16.49,1.67.06.09.06.22.08.34-.25-.18-.36-.47-.5-.73-.05-.09-.1-.14-.19-.14-.08,0-.13.09-.1.16.15.31.17.67.49.91.25.18.44.42.66.64.01.06,0,.13.1.13h0c.01.69.4,1.25.66,1.87.07.17.15.04.21-.02.09.15.18.01.27,0-.21,1.04.37,1.77.96,2.49.07.08.16.04.25.05.08.15-.04.27-.05.41-.02.25.05.43.35.4.46.24.78.65,1.15.99.1.09.15.28.34.15.12.17.3.09.46.1.02.47.45.56.74.76.35.23.68.46.96.78.13.15.32.24.53.28Z"
      />
      <path
        className="cls-2"
        d="m58.14,55.34c.01.57.2,1.12.26,1.68-.37.05-.53-.16-.63-.48-.27-.85-.46-1.72-.51-2.61-.01-.23-.08-.4-.3-.48-.09-.15-.15-.32-.16-.5-.14-.46-.3-.9-.4-1.37-.06-.28-.09-.56-.29-.79-.13-.27-.24-.55-.25-.85-.01-.22.05-.47-.2-.62-.03-.33-.35-.54-.35-.88.07-.06.03-.13.02-.2-.08-.46-.22-.92-.19-1.37.02-.31-.07-.3-.28-.29-.29-.31-.22-.74-.4-1.1-.25-.51-.38-1.09-.56-1.64.12-.18-.05-.32-.05-.49,0-.08-.07-.18.07-.2.11-.02.18.07.14.16-.12.3.1.3.28.34h0c0,.26.1.49.32.64,0,0,0,0,0,0,0,.22.06.41.27.52.12.26.24.52.37.79.17.45.36.9.51,1.36.11.34.11.72.44.95.03.21.1.41.2.6.03.28.02.58.1.84.1.31.07.71.47.86.18.55.34,1.1.44,1.67-.23.56.13,1.06.15,1.59,0,.1.13.09.22.1.03.2.06.41.09.61-.04.4,0,.79.2,1.15Z"
      />
      <path
        className="cls-1"
        d="m70.7,43.22c.28-.06.22.3.31.31.44.06.28.71.74.71.02.32.26.62.15.96-.06.17-.05.23.13.37.19.15.5.35.34.75-.06.16-.15.44.15.57.1.04.11.14.09.23-.12.53.03,1.07-.05,1.61-.06.45.14.94.2,1.41.05.43.06.86.06,1.29,0,.21.11.35.26.53,0-.16,0-.28,0-.39,0-.17,0-.3.24-.21.11.04.21,0,.26-.11.06-.11,0-.17-.1-.24-.34-.28-.2-.73-.36-1.09,0-.01.03-.06.05-.07.58-.23.2-.64.22-1,.02-.52-.13-1-.2-1.5-.1-.73-.4-1.37-.69-2.02-.21-.47-.52-.9-.45-1.47.03-.24-.13-.5-.33-.7-.25-.24-.37-.54-.43-.88.19-.01.23.16.3.28.85,1.34,1.37,2.82,1.74,4.35.16.66.46,1.33.42,1.99-.04.81.26,1.54.33,2.32.08.77-.06,1.52-.06,2.28,0,.61-.16,1.21-.24,1.82-.02.12-.04.23-.13.31-.26-.26-.17-.64-.07-.86.21-.47.16-.97.17-1.42,0-.46.08-.95-.04-1.43-.04-.15-.07-.32-.26-.28-.18.04-.11.2-.09.33.05.34-.12.68.08,1.06q-.52-.31-.74.2c-.28-.2-.28-.49-.26-.78.07-.93-.23-1.47-1.08-1.88-.14-.07-.26-.13-.31-.28-.01-.09.01-.17.07-.24.38.1.54.48.87.65.09.05.17.22.29.08.08-.09.18-.17.16-.34-.13-.99-.22-1.98-.37-2.97-.1-.63-.28-1.24-.44-1.86-.02-.07-.11-.13-.16-.2.08-.18-.1-.2-.17-.3.16-.44-.15-.78-.29-1.14-.1-.25-.22-.49-.3-.75Z"
      />
      <path
        className="cls-1"
        d="m59.27,43.93c.35.62.5,1.33.71,2,.22.69.52,1.35.62,2.08.11.78.28,1.55.39,2.32.05.4.25.75.3,1.14.14,1.05.12,2.13.25,3.17.11.89.2,1.78.32,2.67.17,1.28.22,2.58.18,3.87-.02.5-.07,1.01-.08,1.51,0,.12-.01.24-.18.25-.17,0-.2-.11-.19-.24.09-.89-.19-1.76-.04-2.67.09-.54.04-1.13-.17-1.67-.04-.1-.06-.24-.04-.34.17-.72-.13-1.43-.05-2.15.04-.34-.23-.58-.25-.94-.05-.82.05-1.65-.17-2.47-.16-.61-.12-1.25-.27-1.87-.24-.98-.34-1.99-.6-2.97-.28-1.03-.54-2.07-.97-3.05-.07-.17-.07-.37-.1-.56.11-.03.23-.07.34-.1Z"
      />
      <path
        className="cls-2"
        d="m41.17,65.15c-.3.02-.37-.15-.35-.4.01-.14.13-.26.05-.41-.02-.46-.03-.93-.05-1.39.44-.24.2-.6.18-.93.03-.05.06-.09.09-.14.14-.1.14-.19-.02-.26,0-.06,0-.12,0-.18.29-.4.36-.85.35-1.33,0-.06.02-.12.03-.17.03-.04.08-.08.1-.13.2-.37.29-.85.5-1.13.33-.43.25-.9.45-1.32.08-.16.12-.33.08-.51,0-.03,0-.06.01-.08.28-.18.38-.47.45-.78,0,0,0,0,0,0,.06,0,.15,0,.16-.02.27-.63.69-1.19.85-1.87,0-.02.02-.04.03-.06.11-.03.14-.11.12-.22.23-.37.5-.71.64-1.13.21-.04.23-.2.24-.37l.14-.23c.1-.04.14-.11.12-.22.01-.02.03-.04.04-.06.12-.02.15-.1.14-.21.01-.02.02-.04.04-.06.11-.02.17-.07.16-.19.31-1,1.09-1.69,1.65-2.53.1-.02.15-.08.14-.19.05-.05.09-.09.14-.14.19.09.09.27.13.4-.67.89-1.31,1.8-1.8,2.82-.56,1.17-1.14,2.32-1.71,3.49-.03.06-.04.14-.05.21-.18.1-.23.27-.24.46,0,0,0,0,0,0-.23.08-.22.27-.22.46,0,0-.02.03-.02.03-.23-.04-.3.12-.38.28-.1.21-.03.43-.08.65-.28.47-.33,1.03-.64,1.49-.17.12-.27.27-.18.49-.05.11-.11.21-.16.32-.12.02-.17.07-.08.18-.4.87-.61,1.78-.71,2.73-.09.89-.23,1.77-.35,2.66Z"
      />
      <path
        className="cls-2"
        d="m48.79,54.83c-.73,1.16-1.57,2.23-2.22,3.46-.32.61-.74,1.22-1.13,1.82-.36.57-.62,1.16-.81,1.8-.09,0-.17.01-.26.03-.07.01-.15.05-.19-.04-.02-.06-.03-.16.01-.21.35-.41.28-.96.48-1.41.04-.17-.04-.37.12-.51.09-.07.21-.13.26-.22.65-1,1.29-2.01,1.77-3.11,0,0,.02-.02.02-.02.3-.1.39-.37.49-.63.15-.54.61-.88.87-1.35.45-.3.67-.74.8-1.24.07-.1.14-.21.26-.27.53-.21.75-.65.88-1.15.07-.08.13-.17.2-.25.29-.16.51-.38.62-.7.04-.05.09-.11.13-.16.1-.01.15-.06.15-.16.17-.16.34-.32.5-.49.27-.12.55-.23.73-.5.08-.03.18-.1.25-.03.08.09,0,.2-.05.27-.35.46-.73.88-1.06,1.36-.16.23-.32.47-.45.72-.2-.07-.22.07-.22.21-.06.06-.12.11-.19.17-.16.02-.18.14-.17.27-.03.03-.06.06-.09.09-.2.04-.32.15-.35.35-.22.5-.76.77-.9,1.32-.23.13-.49.23-.48.57Z"
      />
      <path
        className="cls-2"
        d="m39.66,61.79c-.09,0-.19.15-.27,0,.02-.27.02-.54.08-.81.08-.36.11-.77-.43-.85-.02-.09.01-.17.11-.2.21.17.36.19.35-.15.46-.18.2-.54.21-.83-.08-.67.16-1.28.28-1.92.11-.58.36-1.1.54-1.65.27-.83.57-1.65,1.01-2.4.4-.68.81-1.35,1.21-2.03.13-.04.2-.12.18-.26h0c.31-.1.32-.4.43-.63.21-.16.3-.41.45-.61.12-.01.16-.08.15-.2h0c.14.01.19-.04.17-.18h0c.3-.24.61-.47.73-.86h0c.24-.1.38-.28.44-.53.08-.26.46-.3.45-.62h0c.14.11.17-.07.26-.1.1.03.2.07.29.1-.54.65-1.02,1.33-1.62,1.93-.49.5-.85,1.12-1.23,1.71-.6.94-1.19,1.89-1.71,2.89-.32.62-.54,1.28-.74,1.94-.34,1.08-.64,2.17-.82,3.29-.14.85-.29,1.7-.44,2.54-.03.15-.06.31-.1.46Z"
      />
      <path
        className="cls-2"
        d="m71.29,45.11c.07.09.25.12.17.3-.87.29-1.78.22-2.67.3-.7.07-1.35.36-2.06.38-.12,0-.26-.01-.38.03-.09-.1-.15-.06-.2.04-.22,0-.43.02-.65.02-.12-.01-.26-.07-.31.11-.4.12-.8.16-1.22.11-.15-.13-.34-.15-.51-.18-.18-.03-.3-.07-.29-.27,0,0,0,0,0,0,.11.03.18-.01.21-.13.07-.03.14-.05.21-.08.22-.05.48.05.64-.18.15-.02.29-.03.44-.05.63-.09,1.25-.17,1.88-.28.13-.02.29-.06.35-.22,1.47-.05,2.94-.18,4.4.09Z"
      />
      <path
        className="cls-2"
        d="m57.06,69.92c.32-.15.67-.14,1-.23.25-.08.43-.03.49.23.07.03.08-.02.11-.04.16-.14.19-.44.47-.4.13.02.07.18.06.27-.02.29.05.63-.33.78-.9.34-1.84.47-2.79.58-.9.11-1.8.14-2.7.18-.37.01-.72-.16-1.09-.1-.13,0-.24-.02-.34-.1.03-.06.05-.11.08-.17.51-.34,1.14-.25,1.68-.47.23.1.5.02.73.16.06.04.15.03.19-.05.32-.51.87-.33,1.26-.29.33.03.36-.09.47-.26.23-.01.44-.23.7-.08Z"
      />
      <path
        className="cls-2"
        d="m64.85,43.02c.07-.01.15-.03.22-.04.32-.07.65-.08.94-.26.08-.01.17-.02.25-.03.35.07.6-.18.88-.3.17,0,.33-.01.5-.02.59-.16,1.2-.22,1.81-.21.12.01.31-.06.32.13.01.18-.18.13-.3.17-.38.14-.73.35-1.11.5-.63.24-1.28.41-1.89.67-1.13.48-2.35.36-3.48.73-.09-.08-.19-.05-.29-.05-.12,0-.25,0-.3-.13-.06-.18.13-.15.2-.22.19-.21.5-.23.66-.47.46-.14.92-.27,1.38-.41.1.07.18.08.21-.06Z"
      />
      <path
        className="cls-2"
        d="m54.88,62.71c.05-.01.1-.02.16-.03.12.22.33.21.49.13.28-.14.58-.27.74-.57h.33c-.32.34-.52.78-.96.97-.07,0-.15-.02-.21,0-.53.21-1,.55-1.57.64-.03,0-.05.09-.08.14-.13.11-.29.09-.44.11-.08-.2-.21-.31-.36-.07-.1.16-.25.23-.39.22-.32-.01-.54.17-.78.31-.05.01-.1.02-.15.04-.36.07-.74-.05-1.09.13-.57.13-1.15.18-1.74.08-.22-.04-.45-.08-.45-.37,0-.29.22-.23.39-.29.22-.08.43-.17.67-.16.73.04,1.47,0,2.17-.21.8-.23,1.59-.49,2.41-.66.19-.04.32-.11.42-.28.08-.02.16-.05.23-.07.11.11.16.04.2-.07Z"
      />
      <path
        className="cls-2"
        d="m68.3,55.95c.32.14.5.45.78.63.02.12.02.24.18.26.06.06.12.12.18.17,0,.17.06.29.27.26.28.53.57,1.06.85,1.6.04.07,0,.17,0,.26-.14,0-.28,0-.42,0-.6-.95-1.35-1.74-2.27-2.42-.94-.69-1.94-1.33-2.71-2.24.03-.18-.09-.43.1-.53.22-.12.36.12.53.23.24.15.48.31.71.47.18.26.54.26.71.53.18.25.43.37.72.43.06.06.12.12.17.18,0,.13.01.22.18.18Z"
      />
      <path
        className="cls-1"
        d="m55.21,40.14c.23.12.3.35.37.56.19.59.59,1.06.93,1.56.46.68.68,1.46.94,2.22.3.87.63,1.75.86,2.64.17.64.24,1.34.48,1.93.4.99.35,2.02.58,3.02-.45.04-.18.39-.25.6-.3.05-.2-.21-.21-.32-.07-.63-.06-1.27-.17-1.9-.17-.97-.49-1.9-.69-2.86-.3-1.47-.95-2.83-1.37-4.27-.09-.29-.28-.58-.48-.81-.54-.63-.92-1.34-1.26-2.09.21.04.32-.03.26-.26Z"
      />
      <path
        className="cls-2"
        d="m44.09,43.4c.29.26.26.63.33.96.09.47.29.87.56,1.24-.02.2.07.47-.29.46-.2-.25-.41-.49-.53-.8.07-.19-.03-.31-.19-.39-.03-.13-.05-.27-.08-.4.03-.16.03-.3-.15-.38h0c-.01-.18-.08-.31-.27-.35-.02-.05-.04-.09-.06-.14.03-.3-.02-.57-.3-.74-.11-.26-.23-.53-.34-.79,0-.44-.09-.85-.42-1.17-.16-.26-.27-.54-.33-.84.04-.54-.07-1.09.11-1.63.03-.03.06-.06.09-.09.16-.03.3.06.44.12-.02,1,.39,1.89.68,2.81.16.53.43,1.03.49,1.59-.1.03-.24.02-.24.18,0,.13.06.21.19.25.11.03.21.06.32.09Z"
      />
      <path
        className="cls-2"
        d="m61.87,48.17c.14-.21-.22-.36-.05-.57.1-.02.26-.05.16-.17-.16-.19-.1-.39-.12-.58-.02-.14.04-.35-.03-.42-.37-.36-.23-.83-.36-1.3.21.14.33.3.51.34.04.17.08.34.12.5-.14.13-.03.16.08.19,0,.12,0,.24,0,.36.05.3-.03.65.26.88.1.41.19.81.29,1.22,0,.46.1.9.42,1.25,0,.05,0,.11.01.16-.24.26-.18.56.16.87.04.21.09.42.13.63-.15.27-.06.51.13.72.04.26.08.52.12.78-.14.12-.08.21.04.29.04.34.08.68.11,1.03-.57.29-.62.26-.62-.4,0-.22-.06-.43-.1-.64-.06-.34-.21-.67-.22-1-.02-.73-.21-1.44-.2-2.17,0-.17-.08-.28-.27-.27h0c-.08-.46-.27-.89-.26-1.37,0-.18-.1-.33-.33-.34Z"
      />
      <path
        className="cls-2"
        d="m70.59,56.23c-.22-.34-.55-.56-.84-.82-.56-.52-1.13-1.03-1.73-1.5-.41-.32-.88-.58-1.33-.84-.72-.42-1.45-.81-2.09-1.36-.22-.51-.19-.58.26-.61.15.08.25.24.44.26.24.19.47.39.78.46,0,0,0,0,0,0,.12.2.31.27.54.25.03.03.06.05.1.08.3.45.81.61,1.24.88l.87.72c.06.1.12.19.26.18.03.06.06.12.09.18-.04.15.03.23.17.27.61.31.88.95,1.35,1.4.06.06.12.12.18.18.03.22-.06.31-.27.27Z"
      />
      <path
        className="cls-2"
        d="m53.02,68.63c.38-.13.76-.23,1.09-.49.46-.37,1.04-.46,1.61-.58-.83.58-1.68,1.1-2.45,1.74-.25.13-.58.12-.71.43-.02.01-.04.02-.06.04-.5.12-.99.24-1.43.51-.05,0-.11.01-.16.02-.11-.05-.2.02-.3.04-.46.1-.91.3-1.4.17-.3-.08-.46-.18-.26-.49l1.31-.46c.15.07.28.03.39-.09.05-.02.11-.04.16-.07.79-.1,1.55-.3,2.22-.77Z"
      />
      <path
        className="cls-2"
        d="m65.47,49.07c.58.16,1.23.17,1.65.71.26.33.71.37,1.02.67.45.44,1,.81,1.44,1.25.45.44.98.69,1.47,1.05.42.3.94.48,1.21.96,0,0,0-.01,0-.01-.04.01-.1.05-.12.03-1.21-.79-2.58-1.3-3.73-2.19-.67-.52-1.33-1.04-2.08-1.44-.29-.16-.6-.31-.94-.33-.35-.28.05-.46.08-.69Z"
      />
      <path
        className="cls-2"
        d="m49.94,61.41s.05-.03.07-.04c.16.04.29,0,.35-.17.41-.19.86-.13,1.29-.23.14,0,.33.1.38-.14.02-.01.04-.03.06-.03.24.01.34-.12.37-.33.1-.05.2-.1.3-.15.34-.11.7-.18.95-.47.27-.03.46-.22.68-.34.48-.24.97-.44,1.53-.7-.32.96-1.17,1.18-1.77,1.67-.32.14-.66.24-.9.51-.99.42-1.96.89-3.06.92-.02-.02-.03-.06-.05-.07-.2-.09-.4.31-.53.07-.11-.19.31-.26.31-.51Z"
      />
      <path
        className="cls-1"
        d="m56.97,53.45c.22.09.28.26.3.48.05.89.24,1.76.51,2.61.1.31.26.53.63.48.26.15.23.43.23.65-.02.68.22,1.33.29,2,.04.39-.03.76,0,1.13.04.55.09,1.1.12,1.64,0,.12.05.3-.14.32-.19.02-.24-.15-.24-.3,0-.94-.36-1.84-.35-2.79,0-.31-.13-.67-.25-.99-.06-.17-.08-.33-.1-.5-.03-.4.01-.76-.22-1.17-.3-.52-.4-1.16-.51-1.76-.11-.59-.29-1.18-.26-1.8Z"
      />
      <path
        className="cls-1"
        d="m60.15,58.08s.09.09.09.14c.04,1.53.19,3.06.09,4.6-.03.46.02.93.03,1.4,0,.01,0,.03,0,.04-.04.28.06.7-.36.71-.45,0-.25-.42-.26-.65-.03-.6-.06-1.21,0-1.81.07-.81.05-1.63.04-2.43,0-.44-.13-.9-.15-1.36,0-.1.02-.2.03-.3.27.04.43-.09.5-.34Z"
      />
      <path
        className="cls-2"
        d="m56.27,54.99c.08.23.12.46.08.7-.12.08-.05.16,0,.26.23.42.38.88.46,1.35.02.13.08.33-.1.38-.23.06-.19-.2-.22-.3-.23-.74-.55-1.44-.83-2.17-.01-.11-.02-.22-.03-.33.02-.23,0-.46-.16-.64,0-.08-.01-.16-.02-.25,0-.51-.11-.98-.4-1.4-.04-.14-.08-.28-.12-.42.05-.33-.1-.61-.23-.9-.04-.24-.2-.45-.2-.7.11-.27-.2-.55.03-.82.09.09.17.18.26.28.02.03.04.07.06.1,0,.14-.08.32.15.37.02.02.03.04.04.06-.03.09,0,.17.09.21,0,.08.02.16.03.24-.08.17-.09.3.13.35.17.75.35,1.49.63,2.21-.03.51.13.97.34,1.42Z"
      />
      <path
        className="cls-2"
        d="m37.77,46.8c.07-.32-.15-.6-.14-.92,0-.02.02-.05.02-.07.18-.03.32,0,.34.22.01.16.07.28.24.31.02.14.02.28.08.43.23.6.43,1.22.67,1.81.2.5.46.97.69,1.46.04.23.01.49.27.62.17.3.34.6.5.9.04.07.05.15,0,.2-.07.07-.17.06-.23,0-.29-.3-.64-.57-.86-.91-.28-.45-.43-.97-.73-1.42-.36-.56-.39-1.23-.66-1.82-.12-.26-.19-.52-.18-.8Z"
      />
      <path
        className="cls-2"
        d="m71.11,50.05c-.06.07-.09.15-.07.24-1.03-.56-2.07-1.09-3.16-1.54-1.29-.54-2.61-.71-3.99-.69-.13-.19-.18-.3.14-.37.36-.08.75.1,1.08-.16.08,0,.16-.02.23-.03.22.02.41.19.65.14.72-.03,1.33.27,1.93.62.41.24.87.36,1.27.63.41.28.85.52,1.26.79.21.14.54.06.66.36Z"
      />
      <path
        className="cls-2"
        d="m54.68,56.49c.33-.06.54-.47.97-.33-.05.17-.06.35-.18.5-.12,0-.19.05-.17.18-.01.02-.03.04-.04.06-.22.16-.54.17-.65.48-.63.35-1.22.78-1.89,1.06-.51.22-1.08.26-1.58.5-.12.06-.27,0-.3-.17-.05-.22.14-.36.27-.39.68-.16,1.22-.59,1.81-.92.22-.12.57-.04.63-.4.05-.02.09-.04.14-.06.4-.03.68-.3.99-.51Z"
      />
      <path
        className="cls-1"
        d="m70.16,59.14c.14,0,.28,0,.42,0,.09.33.17.67.26,1.03.36-.33.33-.84.52-1.24.27-.56.44-1.16.65-1.74.04-.11.1-.21.22-.25.18.23.26.41.01.7-.3.34-.26.85-.41,1.28-.23.63-.49,1.23-.91,1.77-.08.1-.11.23-.15.36-.46,1.3-1.16,2.43-2.31,3.23-.04-.17.09-.27.17-.38.58-.76,1.12-1.54,1.54-2.39.11-.21.38-.24.42-.53.05-.33.08-.61-.09-.92-.15-.28-.24-.6-.36-.9Z"
      />
      <path
        className="cls-2"
        d="m58.66,38.91c-.4-.61-.79-1.22-1.19-1.83.07-.12.16-.21.32-.21.43.67.94,1.28,1.31,1.99.23.44.44.9.66,1.35,0,.19-.02.4.23.47.17.55.25,1.13.65,1.59.21.24.2.62.45.85-.04.19.01.33.21.4.04.08.08.16.12.24-.04.08-.03.15.06.19.01.06.02.12.03.18-.19.02-.37.04-.41-.23-.02-.11-.09-.21-.23-.21h0c.01-.14-.05-.19-.18-.17,0,0,0,0,0,0-.08-.21.25-.59-.25-.62-.33-.55-.64-1.11-.84-1.72-.22-.68-.42-1.36-.76-2,.09-.05.11-.14.08-.22-.05-.14-.17,0-.25-.04Z"
      />
      <path
        className="cls-2"
        d="m59.27,43.93c-.11.03-.23.07-.34.1-.32-.64-.48-1.35-.83-1.98-.07-.13-.06-.31-.09-.47.1-.66-.16-1.19-.63-1.64-.24-.46-.74-.74-.86-1.28.13-.26-.13-.35-.21-.53-.06-.12-.19-.28.11-.26.48.65,1.06,1.25,1.41,1.97.35.71.81,1.39.95,2.21.09.54.33,1.06.53,1.58.05.13.06.21-.04.3Z"
      />
      <path
        className="cls-1"
        d="m48.94,70.01c-.2.32-.04.41.26.49.5.13.94-.07,1.4-.17.1-.02.19-.09.3-.04-.01.16-.23.13-.26.3.24.12.51.14.78.15.21,0,.44-.02.62.15-.03.06-.05.11-.08.17-1.18-.02-2.33-.29-3.45-.59-.79-.21-1.58-.53-2.27-1.01-.27-.19-.61-.27-.83-.54.38-.31.85-.18,1.28-.26.08-.02.21,0,.22.15-.19.12-.53-.13-.58.11-.04.21.31.3.5.41.49.26,1,.48,1.49.72.13.06.22-.02.33-.05.09-.02.2-.19.29,0Z"
      />
      <path
        className="cls-1"
        d="m45.58,35.88c-.15.26-.46.28-.74.53.54.02.97.09,1.35.41.39.33.88.54,1.28.86.71.58,1.39,1.2,2.07,1.8.04.03.05.1.08.15-.15-.04-.25.02-.27.18-.4-.26-.68-.65-1.04-.95-1.03-.9-2.09-1.75-3.39-2.26-.35-.14-.51.12-.74.22-.14.06-.2.25-.47.27.57-.62,1.14-1.1,1.88-1.35,0,.05,0,.1,0,.15Z"
      />
      <path
        className="cls-2"
        d="m63.97,55.69c0,.38.04.77-.01,1.14-.11.81-.1,1.61,0,2.42.02.14,0,.29-.03.44-.03.12-.06.31-.21.3-.18-.01-.1-.21-.12-.32-.03-.12.08-.32-.16-.34-.01-.05-.03-.1-.04-.15.26-.75.18-1.51.06-2.27.02-.15-.04-.28-.13-.4,0-.42.13-.85-.1-1.25,0-.05,0-.1,0-.15.08-.39.27-.52.63-.28.04.29.08.58.11.87Z"
      />
      <path
        className="cls-2"
        d="m67.33,58.96c.74.85,1.47,1.71,1.42,2.94-.43-.49-.34-1.22-.83-1.68.03-.19-.1-.2-.23-.21-.83-.81-1.63-1.65-2.39-2.53.17-.04.33-.08.36-.29.56.44,1.02.98,1.49,1.51,0,.13-.02.27.19.25Z"
      />
      <path
        className="cls-1"
        d="m29.85,71.44c.11-.19.3-.06.44-.11.33-.11.72.2,1.03-.16.05-.06.27-.04.31.07.14.37.43.28.69.27.19,0,.36.02.53.14.21.14.46.24.74.23.5,0,.97.19,1.45.27,1.08.19,2.14.22,3.22.02.25-.05.52-.09.77.03-.51.35-1.11.21-1.66.28-1.22.16-2.41-.09-3.61-.34-.5-.1-.99-.26-1.54-.25-.31,0-.74.02-1.08-.2-.26-.17-.59.05-.89-.06-.14-.05-.32-.04-.42-.19Z"
      />
      <path
        className="cls-1"
        d="m38.23,46.34c-.17-.03-.23-.15-.24-.31-.02-.22-.16-.24-.34-.22.43-1.49,1.01-2.91,1.9-4.19.02.02.04.04.06.06-.07.17-.12.3,0,.52.14.27.19.67.14.91-.06.32-.06.63-.1.94-.23-.08-.18-.28-.18-.44,0-.28,0-.57-.11-.84-.03.02-.06.04-.07.06-.39.47-.52,1.07-.75,1.61-.26.6-.67,1.2-.3,1.91Z"
      />
      <path
        className="cls-1"
        d="m57.25,59.41c.21.05.16.22.17.36.08.98.15,1.95.23,2.93.01.17-.05.31-.12.46-.09.18-.21.2-.34.06-.14-.15-.28-.31-.29-.53-.04-.7-.07-1.4-.1-2.11,0-.07,0-.15.06-.2.3.03.41-.14.39-.41,0-.18,0-.37,0-.55Zm-.12,1.27s-.03-.06-.04-.08c-.03.02-.06.05-.08.08,0,.02.01.05.02.07.03-.02.06-.05.09-.07Z"
      />
      <path
        className="cls-2"
        d="m53.4,46.06c.04.09.09.18.13.27-.13.14-.13.24.08.27.04.08.08.16.13.24-.07.27.07.45.22.64.03.27.2.51.18.79-.17-.03-.25.17-.41.17-.17-.5-.35-.99-.52-1.49.13-.36-.16-.66-.16-1,0-.08-.14-.08-.23-.05-.29-.28-.31-.7-.48-1.03-.01-.26.06-.55-.28-.67-.14-.17-.33-.32-.27-.58.08-.07.16-.14.25-.21.24.44.47.88.71,1.33.07.28.05.6.39.74.02.04.05.09.07.13-.09.21,0,.35.17.47Z"
      />
      <path
        className="cls-2"
        d="m51.23,35.02c.61.53.91,1.31,1.51,1.86.06.14.05.34.28.34,0,0,0,0,0,0,0,.17.07.28.25.28.18.39.57.63.73,1.04-.04.08-.07.15-.11.23-.24-.02-.32-.24-.45-.39-.85-1.03-1.83-1.96-2.58-3.07.02-.23.15-.31.37-.28Z"
      />
      <path
        className="cls-1"
        d="m57.53,63.78s0,.03,0,.04c-.1.48-.18.95-.15,1.46.03.54-.08,1.09-.22,1.64-.14.52-.34,1.03-.45,1.56-.02.1-.02.23-.16.2-.14-.03-.08-.15-.06-.25.09-.36.03-.77.33-1.06.03-.02.03-.08.02-.12-.13-.82.09-1.61.17-2.42.03-.34-.02-.69-.03-1.04,0-.2.09-.34.31-.33.23,0,.24.17.24.34Z"
      />
      <path
        className="cls-2"
        d="m67.8,46.6c.49.38,1.1.27,1.64.42.21.06.43.09.63.19-.01.24-.05.51.35.36.35.09.81.4,1.25.88-.42-.04-.72-.21-1.01-.35-.55-.25-1.09-.53-1.69-.63-.42-.07-.87-.02-1.28-.18-.21-.27-.12-.5.12-.69Z"
      />
      <path
        className="cls-1"
        d="m59.63,53.23c.29.09.21.38.22.55.09,1.16.35,2.3.32,3.47,0,.23-.11.45-.04.68-.15,0-.24-.05-.21-.24.14-.85.07-1.69-.14-2.55-.16.28-.18.55-.09.83.11.36-.03.71-.07,1.06-.12.01-.16-.07-.16-.16.04-1.13-.12-2.24-.23-3.35,0-.05.05-.1.07-.15.19.15.33.17.34-.14Z"
      />
      <path
        className="cls-1"
        d="m51.89,39.96c-.72-1.01-1.56-1.9-2.49-2.71-.09-.07-.14-.19-.2-.28.15-.09.09-.23.09-.36.45.21.69.64,1.02.97.48.47.89,1.01,1.41,1.44.27.23.47.52.56.87-.14-.05-.25.08-.39.08Z"
      />
      <path
        className="cls-2"
        d="m63.5,65.84c-.51.2-.36-.35-.35-.42.12-.85.19-1.71.25-2.57.01-.21-.06-.4-.05-.6.01-.2.09-.31.27-.33.26-.03.13.2.17.31.08.18-.2.39.06.55,0,.22,0,.44-.01.67-.33.17-.05.43-.1.64-.01.12-.03.24-.04.36-.14.2-.13.4-.03.62,0,.08-.02.16-.02.24-.18.12-.15.29-.12.46,0,.03-.01.05-.02.08Z"
      />
      <path
        className="cls-2"
        d="m43.11,66.39c-.16-.01-.34.07-.46-.1.12-.56.11-1.14.37-1.67.23-.31.18-.72.38-1.04.06-.08.13-.23.26-.21.14.02.14.17.16.28-.13.94-.52,1.81-.72,2.73Z"
      />
      <path
        className="cls-1"
        d="m42.12,38.45c-.18.53-.06,1.09-.11,1.63-.21-.1-.09-.32-.17-.47-.05-.08,0-.23-.14-.25-.11-.01-.12.12-.18.17-.48.35-.69.92-1.08,1.35-.31.35-.47.73-.21,1.19.05.1.09.25-.02.37-.11-.03-.12-.08-.14-.2-.05-.27.01-.61-.31-.77-.02-.02-.03-.03-.05-.05.36-.51.72-1.01,1.12-1.5.42-.51.95-.92,1.31-1.47Z"
      />
      <path
        className="cls-2"
        d="m49.51,43.68c-.61.85-1.31,1.62-2.1,2.3-.33.28-.61.61-.92.91-.24-.22.17-.35.07-.55.91-.9,1.81-1.79,2.72-2.69.08,0,.15.02.23.03Z"
      />
      <path
        className="cls-1"
        d="m60.86,43.68c.14,0,.22.09.23.21.04.27.22.25.41.23.29.4.32.9.46,1.35-.19-.05-.3-.2-.51-.34.13.47,0,.94.36,1.3.08.07.02.28.03.42.02.19-.04.39.12.58.1.12-.07.15-.16.17-.22-.51-.3-1.06-.42-1.6-.13-.6-.21-1.21-.47-1.78-.08-.18-.11-.35-.05-.54Z"
      />
      <path
        className="cls-1"
        d="m55.65,55.22c.27.72.6,1.43.83,2.17.03.1,0,.36.22.3.18-.05.12-.25.1-.38-.08-.47-.23-.93-.46-1.35-.05-.09-.12-.17,0-.26.33.2.34.57.44.87.18.55.4,1.09.35,1.69-.12.01-.13-.08-.16-.16-.04-.12-.06-.3-.24-.24-.16.05-.08.23-.09.35,0,.07.01.15.05.21.21.36.15.73.08,1.1-.06,0-.12-.03-.13-.1-.1-1.33-.55-2.57-.97-3.82-.04-.11-.11-.25-.01-.37Z"
      />
      <path
        className="cls-1"
        d="m47.8,48.9c-.03-.14.06-.31-.13-.4.01-.19.11-.32.24-.45.45-.46.77-1.03,1.33-1.38,0,.19,0,.39.23.48-.31.5-.74.88-1.16,1.27-.17.16-.19.48-.51.48Z"
      />
      <path
        className="cls-2"
        d="m49.47,47.14c-.22-.09-.22-.29-.23-.48-.01-.02,0-.04.02-.05.24.05.34-.09.38-.3h0c.1-.03.09-.1.09-.18.39-.44.84-.8,1.36-1.07.09-.05.2-.14.27-.06.08.09,0,.22-.07.3-.31.38-.61.78-.96,1.12-.2.19-.21.52-.5.63-.1-.14-.15-.08-.19.04-.05.01-.11.03-.16.04Z"
      />
      <path
        className="cls-1"
        d="m63.86,54.82c-.36-.24-.55-.12-.63.28-.28-.52-.26-1.1-.33-1.67-.09-.7-.12-1.4-.31-2.09-.13-.46-.09-.98-.13-1.47.18,0,.27.1.27.27,0,.73.19,1.44.2,2.17,0,.33.16.66.22,1,.04.21.1.42.1.64,0,.66.05.69.62.4.05.16.05.31,0,.47Z"
      />
      <path
        className="cls-2"
        d="m51.89,39.96c.14,0,.25-.13.39-.08.46.86.91,1.73,1.48,2.52-.04.22-.15.35-.39.29-.35-.45-.59-.97-.8-1.5.03-.26.15-.58-.32-.55-.14-.22-.29-.43-.36-.68Z"
      />
      <path
        className="cls-2"
        d="m47.26,42.35c.35.26.49.67.73,1.01.09.13.13.26,0,.39-.16.16-.34.08-.46-.03-.3-.28-.64-.55-.78-.96-.06-.18-.15-.3-.28-.42,0-.46.34-.19.52-.26h0c-.02.19.07.28.26.27Z"
      />
      <path
        className="cls-1"
        d="m53.73,48.43c.16,0,.24-.2.41-.17.4.46.47,1.08.73,1.6.04.08,0,.14-.08.17-.09-.09-.17-.18-.26-.28-.23.27.07.55-.03.82-.38-.67-.64-1.38-.77-2.14Z"
      />
      <path
        className="cls-1"
        d="m58.81,62.85c0,.33.21.47.21.7-.01,1.1-.01,2.2-.02,3.3,0,.08-.05.16-.14.24-.05-1.38-.25-2.76-.05-4.25Z"
      />
      <path
        className="cls-2"
        d="m59.61,57.02c.04-.35.18-.7.07-1.06-.08-.28-.06-.54.09-.83.21.86.28,1.7.14,2.55-.03.19.06.23.21.24,0,.05.01.11.02.16-.07.25-.22.38-.5.34-.15-.46-.06-.93-.04-1.4Z"
      />
      <path
        className="cls-1"
        d="m72.26,53.69s0,.01,0,.01c.17-.05.12-.34.35-.31.16.43,0,.85-.08,1.25-.13.71-.09,1.44-.3,2.14-.28-.14-.44-.55-.26-.83.11-.17.13-.29.06-.47-.05-.12-.03-.27.05-.38.32-.44.11-.95.18-1.42Z"
      />
      <path
        className="cls-1"
        d="m56.41,37.87c-.3-.02-.16.14-.11.26.08.17.34.27.21.53-.25-.24-.49-.48-.63-.82-.34-.82-.84-1.53-1.53-2.1-.05-.04-.08-.08-.06-.15.32,0,1.52,1.28,2.12,2.28Z"
      />
      <path
        className="cls-1"
        d="m49.54,58.33c.1.5-.32.77-.53,1.1-.4.63-.75,1.28-1.03,1.97-.09.23-.2.42-.45.48.08-.41.26-.79.47-1.14.47-.83.88-1.7,1.54-2.41Z"
      />
      <path
        className="cls-1"
        d="m54.45,62.85c-.09.16-.23.24-.42.28-.82.17-1.61.43-2.41.66-.7.2-1.43.24-2.17.21.17-.24.44-.21.67-.21.77,0,1.49-.13,2.22-.4.67-.25,1.4-.36,2.1-.53Z"
      />
      <path
        className="cls-2"
        d="m56.76,59.52c.07-.37.13-.75-.08-1.1-.04-.06-.05-.14-.05-.21,0-.12-.07-.3.09-.35.18-.06.2.13.24.24.03.08.04.17.16.16.04.38.07.77.11,1.15,0,.19,0,.37,0,.55.01.28-.09.44-.39.41,0-.05-.02-.09-.03-.14.08-.17.18-.34-.04-.48,0-.08-.02-.16-.02-.25Z"
      />
      <path
        className="cls-2"
        d="m49.34,39.81c.03-.16.12-.22.27-.18.34.64.86,1.18,1.18,1.84-.01.06.01.09.07.1.04.05.07.11.11.16-.09.12-.23.06-.35.08l-1.29-2Z"
      />
      <path
        className="cls-1"
        d="m65.47,49.07c-.03.23-.44.42-.08.69-.57-.14-1.14-.29-1.74-.44.61-.35,1.17-.65,1.82-.26Z"
      />
      <path
        className="cls-1"
        d="m59.97,40.68c-.25-.07-.23-.28-.23-.47.32-.02.42-.33.63-.49.32-.24.63-.5,1.01-.65.02.13.07.23.19.28-.14.36-.46.48-.78.63-.33.15-.71.29-.83.71Z"
      />
      <path
        className="cls-1"
        d="m52.05,54.49c-.12.49-.41.9-.74,1.26-.32.34-.59.7-.81,1.11-.07.13-.15.26-.32.27.01-.41.25-.73.49-1.01.34-.39.56-.84.87-1.24.13-.17.26-.36.51-.38Z"
      />
      <path
        className="cls-1"
        d="m42.58,56.85c.04.18,0,.35-.08.51-.2.42-.12.89-.45,1.32-.21.27-.3.76-.5,1.13-.03.05-.07.09-.1.13-.02-.05-.07-.12-.06-.15.42-.88.6-1.84.98-2.73.04-.1.11-.17.21-.21Z"
      />
      <path
        className="cls-2"
        d="m61.58,39.35c-.12-.05-.17-.15-.19-.28.07-.11.16-.2.29-.25.08.03.14,0,.17-.07.06-.03.12-.07.19-.1.33,0,.59-.21.89-.29.25-.06.44-.07.42.27-.12.11-.26.19-.43.19-.3-.08-.53,0-.64.31-.25,0-.42.26-.68.22Z"
      />
      <path
        className="cls-1"
        d="m51.59,56.67c.05-.47.32-.86.52-1.25.21-.44.34-.99.83-1.27.1-.06.17-.16.3-.15.07.22-.15.29-.23.44-.36.7-.77,1.37-1.21,2.02-.06.08-.09.19-.2.21Z"
      />
      <path
        className="cls-2"
        d="m44.98,37.52c.17.83.36,1.65.66,2.44-.07,0-.13-.01-.2-.02-.31-.55-.55-1.12-.63-1.75.07-.14.17-.3-.08-.37,0-.11,0-.21,0-.32.08,0,.17,0,.25.01Z"
      />
      <path
        className="cls-1"
        d="m46.84,56.45c-.49,1.09-1.13,2.1-1.77,3.11-.06.09-.18.15-.26.22.11-.45.38-.8.64-1.17.41-.57.65-1.24,1.05-1.82.09-.13.11-.35.35-.34Z"
      />
      <path
        className="cls-1"
        d="m27.37,71.5c.39-.31.87-.36,1.32-.35.32,0,.75-.17.98.26-.77.11-1.53.26-2.31.09Z"
      />
      <path
        className="cls-1"
        d="m61.65,66.21c-.28-.31.02-.6.02-.91,0-.6,0-1.19,0-1.79,0-.13.03-.25.17-.27.13-.03.2.08.18.19-.17.88.01,1.79-.27,2.65-.01.04-.05.07-.08.13Z"
      />
      <path
        className="cls-2"
        d="m53.12,55.47c.07-.05.15-.1.22-.15.29-.03.53-.17.75-.36.12-.05.23-.14.35-.15.08,0,.17.08.25.13,0,0-.03.12-.07.14-.52.26-.9.76-1.51.84-.12-.16-.1-.31,0-.46Z"
      />
      <path
        className="cls-1"
        d="m44.68,60.28c-.2.46-.13,1.01-.48,1.41-.04.04-.03.15-.01.21.03.09.12.05.19.04.08-.02.17-.02.26-.03,0,.13-.06.21-.19.24-.18,0-.37,0-.55-.01.08-.52.24-1.01.45-1.49.07-.16.14-.33.34-.37Z"
      />
      <path
        className="cls-1"
        d="m56.37,70c-.11.16-.14.29-.47.26-.39-.04-.95-.22-1.26.29-.05.08-.14.08-.19.05-.23-.14-.5-.06-.73-.16.41-.25.9-.24,1.34-.3.46-.06.88-.14,1.26-.42.08.08.06.19.06.28Z"
      />
      <path
        className="cls-1"
        d="m39.04,71.43c0,.14-.1.15-.21.18-1.03.22-2.07.18-3.11.14-.05,0-.09-.06-.13-.1,1.15-.03,2.3-.12,3.45-.22Z"
      />
      <path
        className="cls-1"
        d="m43.83,63.66c-.02-.11-.03-.26-.16-.28-.13-.02-.2.12-.26.21-.21.31-.16.73-.38,1.04.02-.71.22-1.36.59-1.96,0,.33.08.55.48.39-.03.23-.05.46-.27.61Z"
      />
      <path
        className="cls-2"
        d="m45.58,35.88s0-.1,0-.15c.59-.38,1.27-.48,1.93-.61-.02.09-.05.17-.07.26-.6.23-1.23.38-1.87.5Z"
      />
      <path
        className="cls-1"
        d="m53.36,42.7c.24.06.35-.07.39-.29.17.43.62.73.58,1.26-.18-.04-.4-.04-.28-.34.04-.09-.03-.18-.14-.16-.14.02-.07.12-.07.2,0,.16.18.31.05.49-.18-.38-.36-.77-.54-1.15Z"
      />
      <path
        className="cls-2"
        d="m44.09,63.05c-.4.16-.48-.06-.48-.39.06-.19.09-.4.28-.53.18,0,.37,0,.55.01-.06.32-.17.63-.35.9Z"
      />
      <path
        className="cls-2"
        d="m49.29,36.61c0,.13.06.27-.09.36-.36-.32-.86-.42-1.23-.72.01-.24.35-.02.36-.26.36.15.68.34.96.62Z"
      />
      <path
        className="cls-2"
        d="m59.63,53.23c0,.3-.14.29-.34.14-.06-.24-.18-.46-.17-.71.07-.2-.2-.55.25-.6.09.11.05.24.08.36-.13.1-.09.16.05.2.08.19.11.4.12.61Z"
      />
      <path
        className="cls-2"
        d="m46.1,40.76c.11.32.53.46.5.86-.18-.01-.21.28-.42.2-.18-.31-.32-.64-.42-.98.11-.03.22-.05.33-.08Z"
      />
      <path
        className="cls-1"
        d="m65.11,47.54c-.32.26-.72.08-1.08.16-.32.07-.27.18-.14.37-.23.01-.46.02-.69.03.13-.53,1.04-.73,1.91-.56Z"
      />
      <path
        className="cls-1"
        d="m66.52,54.64c-.24-.16-.47-.31-.71-.47-.17-.11-.31-.34-.53-.23-.19.1-.07.35-.1.53-.2-.09-.41-.17-.29-.47.1-.26.33-.34.53-.23.41.22.97.28,1.1.86Z"
      />
      <path
        className="cls-2"
        d="m55.21,40.14c.05.23-.05.3-.26.26-.26-.37-.38-.82-.72-1.14.03-.09.07-.19.1-.28.46.26.57.79.88,1.16Z"
      />
      <path
        className="cls-1"
        d="m31.79,70.83c-.13.14-.27.18-.47.12-.48-.15-.97-.27-1.49-.23-.1,0-.21,0-.25-.12.76-.13,1.5-.1,2.21.24Z"
      />
      <path
        className="cls-1"
        d="m63.26,43.49c-.16.24-.47.26-.66.47-.07.07-.26.05-.2.22.05.13.17.14.3.13.1,0,.2-.03.29.05-.12.09-.26.12-.41.12-.21,0-.37-.09-.44-.28-.07-.2.08-.29.23-.37.28-.15.52-.42.89-.34Z"
      />
      <path
        className="cls-1"
        d="m67.8,46.6c-.24.19-.33.42-.12.69-.32-.02-.57-.15-.73-.46-.12-.23.06-.42.17-.39.23.08.51-.09.69.15Z"
      />
      <path
        className="cls-1"
        d="m66.89,45.02c-.06.17-.22.2-.35.22-.62.11-1.25.19-1.88.28.03-.14.14-.17.25-.2.65-.15,1.31-.22,1.98-.3Z"
      />
      <path
        className="cls-1"
        d="m63.46,56.9c.12.76.2,1.52-.06,2.27-.22-.04-.2-.23-.16-.34.21-.52.03-1.04.07-1.56.01-.14-.03-.3.15-.37Z"
      />
      <path
        className="cls-1"
        d="m67.15,65.15c.14.09.27.25.12.35-.41.28-.74.69-1.26.81-.15.04-.32.04-.25-.21.5.08.66-.45,1.05-.6.13-.05.33-.14.34-.36Z"
      />
      <path
        className="cls-1"
        d="m56.28,62.23c-.16.31-.46.43-.74.57-.17.08-.37.09-.49-.13.34-.36.78-.42,1.24-.45Z"
      />
      <path
        className="cls-1"
        d="m57.04,50.23c-.41-.15-.37-.55-.47-.86-.09-.26-.07-.56-.1-.84.41.49.54,1.08.58,1.7Z"
      />
      <path
        className="cls-1"
        d="m56.26,47.93c-.33-.23-.34-.61-.44-.95-.15-.46-.34-.91-.51-1.36.36.22.38.63.52.97.18.43.29.9.43,1.34Z"
      />
      <path
        className="cls-1"
        d="m54.86,46.59c.21,0,.3-.02.28.29-.03.45.12.91.19,1.37.01.07.05.14-.02.2-.33-.57-.42-1.21-.45-1.86Z"
      />
      <path
        className="cls-1"
        d="m65.39,60.27c-.3.03-.18.32-.3.47-.29-.06-.31-.33-.37-.53-.04-.13.03-.32.21-.39.19-.06.3.03.36.21.03.08.06.16.1.24Z"
      />
      <path
        className="cls-1"
        d="m48.33,36c-.02.24-.35.02-.36.26-.49.08-.58-.28-.73-.69.39.2.8.15,1.1.44Z"
      />
      <path
        className="cls-1"
        d="m53.02,68.63c-.67.47-1.43.67-2.22.77.18-.28.52-.22.78-.31.48-.16.94-.38,1.45-.46Z"
      />
      <path
        className="cls-1"
        d="m44.07,54.09c-.16.68-.58,1.24-.85,1.87-.01.03-.11.02-.16.02-.08-.35.27-.51.36-.8.13-.4.36-.77.66-1.09Z"
      />
      <path
        className="cls-2"
        d="m63.61,38.11c.37-.1.71-.32,1.23-.23-.41.33-.83.47-1.23.66-.13-.14-.03-.29,0-.43Z"
      />
      <path
        className="cls-1"
        d="m52.05,43.39c-.08.07-.16.14-.25.21-.23-.26-.34-.59-.48-.9.06-.03.12-.06.18-.09.41.1.43.47.54.78Z"
      />
      <path
        className="cls-1"
        d="m53.8,64s.04-.13.08-.14c.57-.1,1.04-.44,1.57-.64.06-.02.14,0,.21,0-.54.45-1.15.73-1.86.79Z"
      />
      <path
        className="cls-1"
        d="m72.69,59.49c-.18-.27.13-.43.17-.65.07-.4.14-.82.37-1.18.32.2.02.4-.03.56-.16.43-.08.96-.51,1.28Z"
      />
      <path
        className="cls-1"
        d="m42.65,38.47c-.14-.06-.27-.15-.44-.12.43-.42.84-.87,1.38-1.24.03.28-.16.31-.26.41-.29.27-.7.46-.68.95Z"
      />
      <path
        className="cls-1"
        d="m56.11,50.8c.2.22.23.5.29.79.1.46.26.91.4,1.37-.33-.17-.35-.54-.44-.82-.14-.42-.33-.86-.25-1.34Z"
      />
      <path
        className="cls-1"
        d="m39.81,72.08c.11-.16.3-.18.45-.24.44-.18.86-.41,1.25-.68.04.17-.03.31-.16.38-.49.25-.97.52-1.54.54Z"
      />
      <path
        className="cls-1"
        d="m64.85,51.09c-.44.03-.47.1-.26.61-.28,0-.39-.24-.5-.42-.14-.25.02-.38.27-.4.19-.01.38.03.49.22Z"
      />
      <path
        className="cls-1"
        d="m50.17,51.8c-.13.51-.35.95-.88,1.15.14-.5.44-.88.88-1.15Z"
      />
      <path
        className="cls-1"
        d="m24.18,71.77c0,.07.01.18-.02.21-.51.37-.57,1-.87,1.48-.02-.02-.06-.03-.06-.05-.05-.46.53-1.43.96-1.64Z"
      />
      <path
        className="cls-1"
        d="m57.85,53.58c-.09,0-.21,0-.22-.1-.02-.53-.38-1.03-.15-1.59.28.33.16.77.29,1.15.06.17.05.36.08.54Z"
      />
      <path
        className="cls-1"
        d="m42.13,70.8c.19-.55.57-.87,1.13-.98-.29.43-.66.76-1.13.98Z"
      />
      <path
        className="cls-1"
        d="m63.61,38.11c-.04.14-.14.29,0,.43-.07.1-.16.11-.27.09.02-.34-.17-.33-.42-.27-.3.08-.56.29-.89.29.47-.35.98-.59,1.58-.54Z"
      />
      <path
        className="cls-1"
        d="m50.63,41.81c.12-.02.25.04.35-.08.24.21.44.44.45.78-.08,0-.16.02-.24.03-.37-.1-.39-.47-.55-.72Z"
      />
      <path
        className="cls-1"
        d="m56.67,35.9c-.06-.08-.14-.16-.17-.25-.04-.11-.06-.26.05-.33.17-.11.17.1.23.17.17.18.32.38.48.56-.14.01-.28.02-.39.11-.02-.03-.04-.06-.06-.08.13-.19.01-.2-.14-.18Z"
      />
      <path
        className="cls-1"
        d="m52.42,66.64c-.11.16-.28.18-.45.22-.48.11-.96.21-1.44.32.14-.29.45-.24.68-.3.4-.11.81-.16,1.21-.24Z"
      />
      <path
        className="cls-1"
        d="m67.77,37.74c-.59-.23-1.14-.51-1.6-.96.62.18,1.2.42,1.6.96Z"
      />
      <path
        className="cls-1"
        d="m46.1,40.76c-.11.03-.22.05-.33.08-.11-.3-.3-.58-.34-.9.07,0,.13.01.2.02.3.18.35.51.47.81Z"
      />
      <path
        className="cls-1"
        d="m49.94,61.41c0,.24-.42.32-.31.51.13.24.33-.16.53-.07.02,0,.03.05.05.07-.31.24-.63.34-1,.06.25-.19.36-.54.74-.57Z"
      />
      <path
        className="cls-1"
        d="m47.45,35.38c.02-.09.05-.17.07-.26.23-.23.55-.14.82-.2.07-.02.15,0,.16.1,0,.08-.05.13-.13.15-.31.07-.59.25-.93.21Z"
      />
      <path
        className="cls-1"
        d="m69.46,42.16c-.61,0-1.22.05-1.81.21.52-.4,1.41-.5,1.81-.21Z"
      />
      <path
        className="cls-1"
        d="m57.38,39.94c.46.45.72.98.63,1.64-.21-.55-.42-1.09-.63-1.64Z"
      />
      <path
        className="cls-1"
        d="m61.87,48.17c.22,0,.33.16.33.34-.01.48.18.91.26,1.37-.19-.03-.2-.19-.24-.33-.12-.46-.23-.92-.35-1.38Z"
      />
      <path
        className="cls-1"
        d="m70.37,63.77c.12-.51.4-.9.82-1.2-.06.55-.38.91-.82,1.2Z"
      />
      <path
        className="cls-1"
        d="m51.83,64.57c.24-.15.46-.32.78-.31.14,0,.29-.06.39-.22.15-.24.27-.13.36.07-.48.25-.99.4-1.53.46Z"
      />
      <path
        className="cls-1"
        d="m49.02,53.22c-.13.5-.35.95-.8,1.24-.02-.02-.06-.05-.06-.05.31-.38.47-.86.85-1.19Z"
      />
      <path
        className="cls-1"
        d="m40.91,70.74c.01.18-.12.29-.24.32-.4.1-.78.31-1.21.24.43-.32,1-.31,1.45-.56Z"
      />
      <path
        className="cls-1"
        d="m65.66,57.19c-.03.21-.19.25-.36.29-.12-.09-.34-.1-.34-.3,0-.08.11-.19.19-.22.22-.08.38.05.51.23Z"
      />
      <path
        className="cls-1"
        d="m67.95,53.04c-.43-.27-.94-.43-1.24-.88.5.18.96.4,1.24.88Z"
      />
      <path
        className="cls-1"
        d="m41.42,60.11c0,.48-.06.93-.35,1.33-.03-.48.13-.92.35-1.33Z"
      />
      <path
        className="cls-1"
        d="m55.05,52.6c.29.42.4.9.4,1.4-.18,0-.21-.17-.21-.28,0-.39-.32-.72-.19-1.12Z"
      />
      <path
        className="cls-1"
        d="m48.24,62.41c-.06-.05-.19-.13-.12-.19.29-.28.32-.76.71-.96-.03.47-.43.76-.59,1.16Z"
      />
      <path
        className="cls-1"
        d="m64.79,36.12c-.47.04-.86-.25-1.29-.35-.11-.03-.15-.13-.14-.24.48.19,1.02.23,1.43.59Z"
      />
      <path
        className="cls-1"
        d="m46.19,41.83c.21.08.24-.22.42-.2.11.17.32.26.39.46-.18.07-.53-.2-.52.26-.2-.11-.23-.32-.28-.51Z"
      />
      <path
        className="cls-1"
        d="m63.16,45.96c0,.2.11.24.29.27.17.03.37.04.51.18-.29.11-.59.15-.86-.04-.21-.15-.28-.31.05-.41Z"
      />
      <path
        className="cls-2"
        d="m45.33,46.22c.09.09.18.18.27.27-.04.11-.08.22-.11.33-.22-.16-.5-.27-.59-.58.14,0,.29-.01.43-.02Z"
      />
      <path
        className="cls-1"
        d="m56.27,54.99c-.21-.45-.37-.91-.34-1.42.26.44.33.92.34,1.42Z"
      />
      <path
        className="cls-1"
        d="m51.06,70.28c.44-.27.93-.39,1.43-.51-.44.26-.88.55-1.43.51Z"
      />
      <path
        className="cls-2"
        d="m56.87,36.16c.12-.09.25-.1.39-.11.06.09.12.18.18.27-.04.14.06.36-.2.38-.15-.16-.29-.33-.36-.54Z"
      />
      <path
        className="cls-1"
        d="m47.53,61.89c-.09.4-.02.87-.51,1.07.05-.41.23-.77.51-1.07Z"
      />
      <path
        className="cls-1"
        d="m51.23,35.02c-.22-.03-.35.05-.37.28-.23-.33-.59-.3-.93-.32.25-.05.5-.07.75-.13.18-.04.45-.14.55.17Z"
      />
      <path
        className="cls-1"
        d="m58.91,35.34s.03-.07.04-.07c.41.1.85.1,1.21.37-.43-.04-.88-.02-1.25-.29Z"
      />
      <path
        className="cls-1"
        d="m58.88,68.77c0-.43-.1-.87.08-1.29.02.43.12.87-.08,1.29Z"
      />
      <path
        className="cls-1"
        d="m63.16,49.87c-.33-.35-.42-.79-.42-1.25.27.37.36.81.42,1.25Z"
      />
      <path
        className="cls-1"
        d="m63.24,55.25c.24.4.1.83.1,1.25-.08,0-.16-.02-.16-.11.01-.38-.07-.76.05-1.14Z"
      />
      <path
        className="cls-1"
        d="m58.14,55.34c-.2-.36-.24-.75-.2-1.15.27.35.25.74.2,1.15Z"
      />
      <path
        className="cls-1"
        d="m43.29,57.29c.05-.21-.02-.44.08-.65.08-.16.16-.32.38-.28-.19.29-.18.69-.47.93Z"
      />
      <path
        className="cls-1"
        d="m49.2,60.55c0-.43.28-.67.61-.88-.15.33-.3.66-.61.88Z"
      />
      <path
        className="cls-1"
        d="m40.99,62.02c.02.33.27.69-.18.93.03-.32-.14-.67.18-.93Z"
      />
      <path
        className="cls-1"
        d="m65.04,40.08c-.32.25-.69.36-1.08.4.28-.34.68-.38,1.08-.4Z"
      />
      <path
        className="cls-1"
        d="m61.34,36.86c-.19.31-.43.5-.82.37.23-.21.46-.44.82-.37Z"
      />
      <path
        className="cls-1"
        d="m45.33,46.22c-.14,0-.29.01-.43.02-.13.02-.22-.01-.21-.17.36,0,.26-.26.29-.46.23.14.24.41.35.62Z"
      />
      <path
        className="cls-2"
        d="m55.4,65.43c.19-.13.41-.11.66-.21-.1.4-.45.4-.67.55,0-.12,0-.23,0-.35Z"
      />
      <path
        className="cls-1"
        d="m71.23,62.52c.04-.41.24-.7.58-.91-.04.4-.25.7-.58.91Z"
      />
      <path
        className="cls-1"
        d="m57.23,36.71c.27-.02.16-.24.2-.38.2.13.22.37.34.54-.15,0-.24.09-.32.21-.08-.12-.15-.24-.23-.36Z"
      />
      <path
        className="cls-1"
        d="m54.33,38.98c-.03.09-.07.19-.1.28-.16-.14-.33-.27-.35-.5.04-.08.07-.15.11-.23.15.12.35.2.34.44Z"
      />
      <path
        className="cls-1"
        d="m44.09,43.4c-.11-.03-.22-.06-.32-.09-.13-.04-.18-.12-.19-.25,0-.17.14-.15.24-.18.13.15.26.3.27.52Z"
      />
      <path
        className="cls-1"
        d="m52.83,45.89c.09-.03.23-.03.23.05,0,.35.29.64.16,1-.13-.35-.26-.7-.39-1.06Z"
      />
      <path
        className="cls-1"
        d="m70.59,56.23c.22.03.31-.06.27-.27.03.01.07.02.07.03.07.2.38.43.2.57-.23.17-.41-.13-.55-.33Z"
      />
      <path
        className="cls-1"
        d="m50.59,64.74c.35-.18.73-.06,1.09-.13-.34.26-.72.14-1.09.13Z"
      />
      <path
        className="cls-1"
        d="m47.08,68.79c.28-.23.64-.08.94-.21-.23.44-.61.24-.94.21Z"
      />
      <path
        className="cls-1"
        d="m67.57,38.93c.33.09.67.17.71.61-.28-.15-.55-.31-.71-.61Z"
      />
      <path
        className="cls-1"
        d="m49.99,59.39v-.66c.15-.08.29.11.44.04-.17.19-.16.5-.44.61Z"
      />
      <path
        className="cls-1"
        d="m47.36,55.8c-.1.26-.2.52-.49.63.14-.23-.03-.7.49-.63Z"
      />
      <path
        className="cls-1"
        d="m54.68,56.49c-.31.21-.59.47-.99.51.3-.23.56-.52.99-.51Z"
      />
      <path
        className="cls-1"
        d="m25.24,72.03c.19-.34.47-.46.84-.36-.26.18-.52.32-.84.36Z"
      />
      <path
        className="cls-1"
        d="m63.33,50.91c-.34-.32-.4-.62-.16-.87.01.3.24.56.16.87Z"
      />
      <path
        className="cls-1"
        d="m53.71,59.84c-.26.28-.61.36-.95.47.28-.24.56-.47.95-.47Z"
      />
      <path
        className="cls-1"
        d="m53.64,66.15c-.3.2-.58.48-1,.4.3-.21.62-.39,1-.4Z"
      />
      <path
        className="cls-1"
        d="m66.01,42.73c-.29.17-.62.19-.94.26.25-.33.59-.3.94-.26Z"
      />
      <path
        className="cls-1"
        d="m67.15,42.39c-.29.13-.53.37-.88.3.25-.22.54-.34.88-.3Z"
      />
      <path
        className="cls-1"
        d="m46.56,46.34c.09.2-.32.33-.07.55,0,.11-.06.16-.17.15-.1-.03-.2-.07-.29-.1.16-.22.26-.5.54-.6Z"
      />
      <path
        className="cls-1"
        d="m53.26,60.99c.24-.27.58-.37.9-.51-.21.33-.54.45-.9.51Z"
      />
      <path
        className="cls-1"
        d="m50.98,50.85c-.1.32-.33.54-.62.7.09-.33.27-.59.62-.7Z"
      />
      <path
        className="cls-1"
        d="m62.44,47.4c-.29-.23-.21-.57-.26-.88.3.23.3.55.26.88Z"
      />
      <path
        className="cls-1"
        d="m68.41,64.31c-.09.32-.4.38-.63.52-.14.09-.1-.1-.12-.18.28-.04.43-.38.75-.34Z"
      />
      <path
        className="cls-1"
        d="m65.56,65.23c-.25-.2-.49-.41-.35-.79.12.26.3.5.35.79Z"
      />
      <path
        className="cls-1"
        d="m43.04,55.99c-.06.31-.16.6-.45.78,0-.34.14-.61.45-.78Z"
      />
      <path
        className="cls-1"
        d="m66.07,51.82c-.31-.07-.54-.27-.78-.46.35,0,.6.18.78.46Z"
      />
      <path
        className="cls-1"
        d="m55.4,65.43c0,.12,0,.23,0,.35-.02.09-.08.11-.16.1,0-.43-.3-.17-.47-.2.15-.25.4-.22.64-.24Z"
      />
      <path
        className="cls-1"
        d="m54.61,57.39c.1-.31.43-.32.65-.48-.05.39-.36.42-.65.48Z"
      />
      <path
        className="cls-1"
        d="m52.49,49.54c-.18.26-.45.38-.73.5.13-.34.39-.47.73-.5Z"
      />
      <path
        className="cls-1"
        d="m49.51,43.68c-.08,0-.15-.02-.23-.03.2-.19.41-.39.7-.43l.02.02c-.09.23-.28.36-.5.44Z"
      />
      <path
        className="cls-1"
        d="m42.39,69.65c-.12.33-.36.5-.7.54.19-.24.37-.48.7-.54Z"
      />
      <path
        className="cls-1"
        d="m58.25,34.72c-.26.19-.54.1-.82.05.26-.21.54-.12.82-.05Z"
      />
      <path
        className="cls-1"
        d="m28.87,70.56c-.22.32-.53.12-.81.13.24-.22.53-.16.81-.13Z"
      />
      <path
        className="cls-1"
        d="m70.47,40.78c-.32-.1-.31-.37-.33-.62.28.12.31.37.33.62Z"
      />
      <path
        className="cls-1"
        d="m52.55,69.73c.13-.31.46-.3.71-.43-.12.34-.45.33-.71.43Z"
      />
      <path
        className="cls-1"
        d="m62.26,39.13c.11-.31.34-.39.64-.31-.18.18-.35.37-.64.31Z"
      />
      <path
        className="cls-1"
        d="m67.95,55.6c-.29-.06-.54-.18-.72-.43.3.04.57.13.72.43Z"
      />
      <path
        className="cls-1"
        d="m69.26,39.17c-.36-.06-.57-.26-.61-.63.26.15.48.35.61.63Z"
      />
      <path
        className="cls-1"
        d="m54.7,51.28c.12.29.28.57.23.9-.15-.28-.33-.56-.23-.9Z"
      />
      <path
        className="cls-1"
        d="m53.15,45.46c-.34-.14-.32-.47-.39-.74.25.18.29.48.39.74Z"
      />
      <path
        className="cls-1"
        d="m54.66,44.31c-.23-.15-.32-.38-.32-.64.37.08.27.4.32.64Z"
      />
      <path
        className="cls-1"
        d="m53.56,57.07c-.07.36-.42.28-.63.4.13-.26.37-.36.63-.4Z"
      />
      <path
        className="cls-1"
        d="m70.05,40.06c-.29-.04-.3-.34-.45-.51.42-.07.39.26.45.51Z"
      />
      <path
        className="cls-1"
        d="m52.24,40.64c.47-.02.35.29.32.55-.27-.09-.24-.35-.32-.55Z"
      />
      <path
        className="cls-1"
        d="m65.86,36.63c-.26-.06-.6.07-.76-.28.27.06.57,0,.76.28Z"
      />
      <path
        className="cls-1"
        d="m53.12,55.47c-.11.15-.12.31,0,.46-.12.03-.3.08-.29-.1,0-.14,0-.41.29-.37Z"
      />
      <path
        className="cls-1"
        d="m52.07,44.18c.34.12.27.41.28.67-.2-.18-.28-.41-.28-.67Z"
      />
      <path
        className="cls-1"
        d="m56.67,34.92c0,.06,0,.12,0,.18-.1.09-.21.1-.31.01-.05-.05-.07-.15-.01-.2.1-.08.22-.07.32,0Z"
      />
      <path
        className="cls-1"
        d="m60.42,42.89c.5.04.18.41.25.62-.2-.16-.21-.4-.25-.62Z"
      />
      <path
        className="cls-1"
        d="m53.65,52.84c-.2.15-.39.31-.63.39.08-.34.31-.44.63-.39Z"
      />
      <path
        className="cls-1"
        d="m48.79,54.83c-.01-.33.25-.44.48-.57-.05.29-.26.43-.48.57Z"
      />
      <path
        className="cls-1"
        d="m54.09,54.96c-.22.18-.46.33-.75.36.21-.2.44-.38.75-.36Z"
      />
      <path
        className="cls-1"
        d="m63.59,52.26c-.19-.22-.27-.45-.13-.72.13.23.2.46.13.72Z"
      />
      <path
        className="cls-1"
        d="m70.42,47.57c-.4.15-.36-.12-.35-.36.22.02.33.15.35.36Z"
      />
      <path
        className="cls-1"
        d="m53.96,47.47c-.15-.18-.3-.37-.22-.64.16.18.29.38.22.64Z"
      />
      <path
        className="cls-1"
        d="m63.67,65.06c-.1-.21-.11-.42.03-.62.11.21.11.42-.03.62Z"
      />
      <path
        className="cls-1"
        d="m72.39,60.4c0-.29.04-.56.28-.76,0,.29-.04.56-.28.76Z"
      />
      <path
        className="cls-1"
        d="m52.96,53.3c-.02.21-.14.33-.33.4-.05-.27.01-.44.33-.4Z"
      />
      <path
        className="cls-1"
        d="m64.23,45.58c-.16.23-.43.13-.64.18.17-.22.39-.26.64-.18Z"
      />
      <path
        className="cls-1"
        d="m66,47.65c-.24.05-.43-.12-.65-.14.26-.14.47-.06.65.14Z"
      />
      <path
        className="cls-1"
        d="m45.49,46.81c.04-.11.08-.22.11-.33.2.15.19.35.16.56,0,0,0,0,0,0-.13-.02-.22-.11-.28-.22Z"
      />
      <path
        className="cls-1"
        d="m66.61,52.08c-.23.02-.41-.05-.54-.25.22,0,.44-.02.54.25Z"
      />
      <path
        className="cls-1"
        d="m25.06,71.24c-.14.33-.22.38-.52.26.15-.14.32-.23.52-.26Z"
      />
      <path
        className="cls-1"
        d="m55.46,54.25c.16.19.18.41.16.64-.17-.18-.32-.38-.16-.64Z"
      />
      <path
        className="cls-1"
        d="m63.74,64.09c.04-.21-.23-.47.1-.64,0,.22.1.45-.1.64Z"
      />
      <path
        className="cls-1"
        d="m55.67,49.32c.25.15.18.4.2.62-.2-.17-.18-.4-.2-.62Z"
      />
      <path
        className="cls-1"
        d="m53.4,46.06c-.17-.11-.26-.26-.17-.47.07.15.33.23.17.47Z"
      />
      <path
        className="cls-1"
        d="m72.02,61.18c-.01-.24.11-.42.28-.57.06.26-.01.46-.28.57Z"
      />
      <path
        className="cls-1"
        d="m61.24,41.83c-.03.18-.15.28-.32.33-.07-.28.07-.36.32-.33Z"
      />
      <path
        className="cls-1"
        d="m59.53,37.74c.03.18-.22.26-.15.45-.13.03-.19-.03-.19-.15,0-.23.18-.25.35-.29Z"
      />
      <path
        className="cls-1"
        d="m61.26,34.95c-.2.04-.41.12-.59-.07.21-.06.41-.12.59.07Z"
      />
      <path
        className="cls-1"
        d="m54.94,44.83c-.21-.11-.27-.3-.27-.52.24.1.3.28.27.52Z"
      />
      <path
        className="cls-1"
        d="m24.72,72.3c.07-.24.26-.25.47-.24-.09.2-.27.24-.47.24Z"
      />
      <path
        className="cls-1"
        d="m42.47,59.26c-.09-.22,0-.37.18-.49.06.21-.06.35-.18.49Z"
      />
      <path
        className="cls-1"
        d="m50.17,52.95c.03-.2.16-.31.35-.35-.03.21-.13.34-.35.35Z"
      />
      <path
        className="cls-1"
        d="m43.78,56.34c0-.19,0-.38.22-.46.01.19-.06.35-.22.46Z"
      />
      <path
        className="cls-1"
        d="m52.46,60.45c-.02.22-.13.35-.37.33.03-.21.15-.32.37-.33Z"
      />
      <path
        className="cls-1"
        d="m49.64,46.32c-.04.21-.13.35-.38.3.09-.15.17-.3.38-.3Z"
      />
      <path
        className="cls-1"
        d="m26.23,71.65c.13-.2.3-.13.47-.07-.14.13-.3.12-.47.07Z"
      />
      <path
        className="cls-1"
        d="m70.29,42.24c.19.11.21.29.19.49-.18-.12-.3-.26-.19-.49Z"
      />
      <path
        className="cls-1"
        d="m56.79,59.76c.22.14.12.31.04.48-.18-.15-.17-.31-.04-.48Z"
      />
      <path
        className="cls-1"
        d="m51.27,57.14c-.03-.19-.02-.36.23-.38-.02.16-.08.3-.23.38Z"
      />
      <path
        className="cls-1"
        d="m58.66,38.91c.08.05.2-.1.25.04.03.07.01.17-.08.22-.12-.04-.17-.14-.17-.26Z"
      />
      <path
        className="cls-1"
        d="m52.58,53.77c-.07.16-.2.26-.35.34-.04-.27.11-.35.35-.34Z"
      />
      <path
        className="cls-1"
        d="m63.52,65.77c-.03-.17-.06-.35.12-.46.06.18.08.35-.12.46Z"
      />
      <path
        className="cls-1"
        d="m44,55.88c0-.19.06-.36.24-.46.02.2-.04.37-.24.46Z"
      />
      <path
        className="cls-1"
        d="m61.29,43.52c-.19-.07-.25-.21-.21-.4.19.07.25.21.21.4Z"
      />
      <path
        className="cls-1"
        d="m55,50.5c-.22-.06-.15-.23-.15-.37.22.06.15.23.15.37Z"
      />
      <path
        className="cls-2"
        d="m51.19,42.53c.08,0,.16-.02.24-.03.02.04.05.07.07.11-.06.03-.12.06-.18.09-.1-.02-.15-.07-.14-.18Z"
      />
      <path
        className="cls-1"
        d="m45.1,52.31c0,.17-.03.33-.24.37.05-.15.09-.29.24-.37Z"
      />
      <path
        className="cls-1"
        d="m53.01,37.22c-.23,0-.22-.2-.28-.34.21.01.22.2.28.34Z"
      />
      <path
        className="cls-1"
        d="m47.26,42.35c-.19,0-.28-.08-.26-.27.19-.01.27.08.26.27Z"
      />
      <path
        className="cls-1"
        d="m44.72,37.83c.26.07.15.22.08.37-.2-.08-.1-.23-.08-.37Z"
      />
      <path
        className="cls-1"
        d="m52.03,60.82c-.05.25-.24.14-.38.14.05-.24.23-.16.38-.14Z"
      />
      <path
        className="cls-1"
        d="m55.3,51.37c-.22-.05-.22-.18-.13-.35.16.07.14.21.13.35Z"
      />
      <path
        className="cls-1"
        d="m54.85,66.1c.1-.13.18-.28.38-.22-.04.23-.22.2-.38.22Z"
      />
      <path
        className="cls-1"
        d="m53.26,37.5c-.18,0-.26-.1-.25-.28.17.02.22.14.25.28Z"
      />
      <path
        className="cls-1"
        d="m62.04,41.42c-.05.15-.12.26-.3.2.07-.12.12-.26.3-.2Z"
      />
      <path
        className="cls-1"
        d="m50.36,61.19c-.06.17-.19.21-.35.17.04-.22.22-.14.35-.17Z"
      />
      <path
        className="cls-1"
        d="m50.64,69.46c-.11.11-.24.16-.39.09.1-.16.24-.13.39-.09Z"
      />
      <path
        className="cls-1"
        d="m70.65,41.12c-.19,0-.17-.13-.15-.26.08.07.28.07.15.26Z"
      />
      <path
        className="cls-1"
        d="m39.2,72.18c.07-.13.16-.18.28-.07-.07.11-.17.12-.28.07Z"
      />
      <path
        className="cls-1"
        d="m45.92,65.49c.04.12.04.23-.08.31-.1-.14-.05-.24.08-.31Z"
      />
      <path
        className="cls-1"
        d="m63.74,53.33c-.12-.08-.17-.17-.04-.29.13.08.09.18.04.29Z"
      />
      <path
        className="cls-1"
        d="m44.98,37.52c-.08,0-.17,0-.25-.01,0-.11.08-.19.18-.17.08.01.13.1.07.19Z"
      />
      <path
        className="cls-1"
        d="m59.74,34.82c-.11.02-.21,0-.28-.1.14-.09.24-.08.28.1Z"
      />
      <path
        className="cls-1"
        d="m45.56,66.64c.04.12.02.22-.1.28-.1-.14-.01-.22.1-.28Z"
      />
      <path
        className="cls-1"
        d="m67.52,39.91c-.12.18-.21.15-.28-.04.1-.04.2-.03.28.04Z"
      />
      <path
        className="cls-1"
        d="m65.18,46.29c.05-.18.19-.12.31-.11-.06.15-.18.15-.31.11Z"
      />
      <path
        className="cls-1"
        d="m41.07,61.62c.16.08.16.17.02.26-.11-.08-.12-.17-.02-.26Z"
      />
      <path
        className="cls-1"
        d="m53.61,46.6c-.22-.03-.22-.13-.08-.27.08.07.11.17.08.27Z"
      />
      <path
        className="cls-1"
        d="m69.72,57.28c-.21.04-.26-.09-.27-.26.13.05.22.13.27.26Z"
      />
      <path
        className="cls-1"
        d="m69.09,53.93c-.14.02-.2-.07-.26-.18.13,0,.25,0,.26.18Z"
      />
      <path
        className="cls-1"
        d="m53.24,53.98c-.02-.13.02-.22.16-.26.04.14.03.25-.16.26Z"
      />
      <path
        className="cls-1"
        d="m24.36,72.56c.04-.08-.02-.28.19-.16-.03.09-.07.17-.19.16Z"
      />
      <path
        className="cls-1"
        d="m69.34,54.38c-.14-.04-.21-.11-.17-.27.17.02.16.15.17.27Z"
      />
      <path
        className="cls-1"
        d="m50.61,52.51c0-.13,0-.25.17-.27.01.13-.02.24-.17.27Z"
      />
      <path
        className="cls-1"
        d="m41.18,70.57c-.04.12-.11.2-.26.17.02-.16.14-.15.26-.17Z"
      />
      <path
        className="cls-1"
        d="m50.97,52.07c0-.15.01-.28.22-.21-.04.1-.1.19-.22.21Z"
      />
      <path
        className="cls-1"
        d="m67.69,60.01c.13,0,.26.02.23.21-.11-.04-.21-.07-.23-.21Z"
      />
      <path
        className="cls-1"
        d="m69.27,56.84c-.16-.01-.17-.14-.18-.26.15.02.2.12.18.26Z"
      />
      <path
        className="cls-1"
        d="m67.33,58.96c-.21.02-.18-.13-.19-.25.13.03.17.14.19.25Z"
      />
      <path
        className="cls-1"
        d="m45.64,66.28c.03.07.08.13-.01.19-.17-.07-.07-.13.01-.19Z"
      />
      <path
        className="cls-1"
        d="m59.51,52.62c-.14-.03-.18-.09-.05-.2.11.04.08.12.05.2Z"
      />
      <path
        className="cls-1"
        d="m49.63,47.1c.04-.12.09-.18.19-.04-.05.08-.12.06-.19.04Z"
      />
      <path
        className="cls-1"
        d="m71.85,61.55c-.05-.11,0-.18.1-.22.08.12.03.19-.1.22Z"
      />
      <path
        className="cls-1"
        d="m47.54,48.64c.01.11-.04.16-.14.19-.05-.13.01-.19.14-.19Z"
      />
      <path
        className="cls-1"
        d="m45.79,66.02c-.01.06-.03.11-.1.1-.01-.03-.04-.08-.03-.1.03-.05.09-.04.14,0Z"
      />
      <path
        className="cls-1"
        d="m61.58,41.63c-.02.08-.08.12-.16.11,0-.12.03-.19.16-.11Z"
      />
      <path
        className="cls-1"
        d="m42.23,59.76c-.09-.11-.04-.16.08-.18.01.08-.02.14-.08.18Z"
      />
      <path
        className="cls-1"
        d="m44.22,53.81c.02.11,0,.18-.12.22-.02-.11.01-.18.12-.22Z"
      />
      <path
        className="cls-1"
        d="m68.04,39.79c-.04.08-.08.18-.18.05.04-.09.11-.07.18-.05Z"
      />
      <path
        className="cls-1"
        d="m55.3,56.84c-.03-.14.05-.18.17-.18.02.13-.06.17-.17.18Z"
      />
      <path
        className="cls-1"
        d="m61.48,43.94c-.09-.04-.1-.1-.06-.19.13.03.16.08.06.19Z"
      />
      <path
        className="cls-1"
        d="m69.47,39.41c-.14.04-.21-.02-.19-.16.11,0,.2.02.19.16Z"
      />
      <path
        className="cls-1"
        d="m66.15,46.16c.05-.1.11-.14.2-.04-.05.09-.12.1-.2.04Z"
      />
      <path
        className="cls-1"
        d="m51.26,50.53c0,.1-.06.15-.15.16-.04-.14.01-.19.15-.16Z"
      />
      <path
        className="cls-1"
        d="m55.14,50.78c-.09-.04-.12-.12-.09-.21.13.03.17.1.09.21Z"
      />
      <path
        className="cls-1"
        d="m64.85,43.02c-.04.14-.12.13-.21.06.05-.1.1-.17.21-.06Z"
      />
      <path
        className="cls-1"
        d="m61.84,38.75c-.03.08-.09.1-.17.07.02-.11.06-.18.17-.07Z"
      />
      <path
        className="cls-1"
        d="m70.56,42.94c.12.03.15.11.1.22-.11-.04-.16-.1-.1-.22Z"
      />
      <path
        className="cls-1"
        d="m45.75,51.36c.01.12-.05.17-.16.19-.03-.13.04-.18.16-.19Z"
      />
      <path
        className="cls-1"
        d="m68.3,55.95c-.17.05-.19-.05-.18-.18.11,0,.15.08.18.18Z"
      />
      <path
        className="cls-1"
        d="m63.37,45.84c-.03.11-.1.16-.21.13.02-.13.09-.17.21-.13Z"
      />
      <path
        className="cls-1"
        d="m45.55,51.6c.01.11-.02.18-.14.21,0-.11.04-.18.14-.21Z"
      />
      <path
        className="cls-1"
        d="m62.17,46.17c-.11-.03-.22-.06-.08-.19.12.02.11.1.08.19Z"
      />
      <path
        className="cls-1"
        d="m60.68,43.52c.14-.03.19.03.18.17-.12.01-.2-.03-.18-.17Z"
      />
      <path
        className="cls-1"
        d="m45.37,51.87c.02.11-.02.18-.12.22-.03-.11.01-.18.12-.22Z"
      />
      <path
        className="cls-1"
        d="m54.88,62.71c-.04.11-.08.18-.2.07.04-.11.11-.1.2-.07Z"
      />
      <path
        className="cls-1"
        d="m57.67,35.14c.08-.12.15-.13.22,0-.07,0-.15,0-.22,0Z"
      />
      <path
        className="cls-1"
        d="m39.55,41.62c.02-.09.05-.17.14-.21.02.01.04.03.05.05-.02.09-.06.17-.13.22-.02-.02-.04-.04-.06-.06Z"
      />
      <path className="cls-2" d="m56.67,35.9c.15-.02.27-.01.14.18l-.14-.18Z" />
      <path
        className="cls-1"
        d="m49.73,46.14c0,.08.01.15-.09.18-.03-.09-.09-.19.09-.18Z"
      />
      <path
        className="cls-1"
        d="m49.98,43.22c0-.06,0-.12.06-.15.01,0,.06.02.06.04,0,.07-.03.11-.09.13,0,0-.02-.02-.02-.02Z"
      />
      <path
        className="cls-1"
        d="m45.42,67.62s.11,0,.1.07c0,.02-.06.03-.1.04,0-.04,0-.07,0-.11Z"
      />
      <path className="cls-1" d="m41.51,71.15c0-.06.03-.09.09-.08l-.09.08Z" />
      <path
        className="cls-1"
        d="m50.87,41.57c-.06,0-.09-.04-.07-.1.02.03.05.07.07.1Z"
      />
      <path
        className="cls-2"
        d="m38.02,53.77c.26,1.13.89,2.04,1.84,2.84-.85.07-1.24-.45-1.61-.91-.66-.82-.95-1.81-1.16-2.82-.04-.22-.21-.34-.27-.54-.05-.24-.13-.47-.15-.71-.03-.31.25-.29.43-.37.32.6.26,1.34.67,1.92-.03.08-.03.16.05.21.03.05.07.1.1.15-.02.1,0,.18.09.23Z"
      />
      <path
        className="cls-2"
        d="m38.6,59.94s-.06-.01-.09,0c0,0,0,0,0,0-.03-.04-.06-.09-.1-.13-.22-.22-.42-.46-.66-.64-.32-.23-.34-.6-.49-.91-.03-.07.01-.16.1-.16.09,0,.14.05.19.14.14.26.25.55.5.73.22.23.43.46.65.68-.08.08.13.27-.11.29Z"
      />
      <path
        className="cls-1"
        d="m44.15,49.04c.12-.39.37-.67.73-.85-.12.39-.43.62-.73.85Z"
      />
      <path
        className="cls-1"
        d="m39.5,59.77c.15-.26-.07-.61.21-.83-.01.29.25.65-.21.83Z"
      />
      <path
        className="cls-1"
        d="m38.6,59.94c.24-.02.03-.21.11-.29.19.02.3.15.43.27-.1.04-.12.11-.11.2-.16-.02-.3-.1-.44-.18Z"
      />
      <path
        className="cls-1"
        d="m42.94,50.66c.07-.26.17-.5.43-.63-.11.23-.12.53-.43.63Z"
      />
      <path
        className="cls-1"
        d="m44.88,48.19c.04-.26.15-.47.44-.53-.06.25-.2.43-.44.53Z"
      />
      <path
        className="cls-1"
        d="m42.76,50.93c-.04-.16.05-.22.18-.26.02.14-.04.23-.18.26Z"
      />
      <path
        className="cls-1"
        d="m43.97,49.22c0-.1.06-.16.17-.17.02.14-.03.19-.17.17Z"
      />
      <path
        className="cls-1"
        d="m43.81,49.42c0-.11.04-.17.15-.2.01.11-.03.18-.15.2Z"
      />
      <path
        className="cls-1"
        d="m42.76,42.08c-.23-.36-.35-.75-.42-1.17.33.32.41.73.42,1.17Z"
      />
      <path
        className="cls-1"
        d="m43.41,43.62c-.18-.21-.34-.44-.3-.74.29.17.33.44.3.74Z"
      />
      <path
        className="cls-1"
        d="m43.74,44.1c-.18-.05-.27-.16-.27-.34.19.04.25.17.27.34Z"
      />
      <path
        className="cls-1"
        d="m43.89,44.48c-.18-.07-.14-.23-.15-.38.18.07.17.22.15.38Z"
      />
      <path
        className="cls-1"
        d="m44.16,45.27c-.13-.09-.28-.18-.19-.39.16.08.26.19.19.39Z"
      />
      <path
        className="cls-1"
        d="m39.66,50.03c.22.15.3.36.27.62-.26-.14-.23-.39-.27-.62Z"
      />
      <path
        className="cls-2"
        d="m40.36,43.42c.27.75.53,1.5.81,2.25.1.27.19.54.39.79.23.3.4.69.42,1.1-.01.07.02.1.09.09,0,0,0,0,0,0,.08.3.17.6.43.81.04.28.4.27.47.53.04.13.17.25,0,.38-.15.12-.26.03-.38-.06-1-.73-1.56-1.78-2.1-2.84-.08-.15-.14-.32-.21-.48.22-.26.09-.42-.16-.54-.01-.02-.02-.04-.03-.07-.07-.39-.11-.78-.4-1.09,0-.08-.02-.16-.03-.25.04-.31.03-.62.1-.94.05-.24,0-.64-.14-.91-.11-.21-.07-.35,0-.52.08-.05.12-.13.13-.22.32.17.26.5.31.77.02.12.04.17.14.2,0,.05.02.1.03.15,0,.28-.19.6.13.83Z"
      />
      <path
        className="cls-2"
        d="m57.13,60.68s-.06.05-.09.07c0-.03-.03-.06-.02-.07.02-.03.05-.05.08-.08.01.02.02.05.04.08Z"
      />
      <path
        className="cls-1"
        d="m39.68,44.28c.29.31.32.71.4,1.09-.27-.32-.29-.72-.4-1.09Z"
      />
      <path
        className="cls-1"
        d="m42.48,48.45c-.25-.21-.35-.5-.43-.81.3.19.41.47.43.81Z"
      />
      <path
        className="cls-1"
        d="m40.36,43.42c-.32-.23-.12-.55-.13-.83.22.25.1.55.13.83Z"
      />
      <path
        className="cls-1"
        d="m40.1,45.44c.24.13.38.28.16.54-.13-.16-.13-.35-.16-.54Z"
      />
      <path
        className="cls-1"
        d="m38.02,53.77c-.1-.05-.12-.13-.09-.23.1.05.15.12.09.23Z"
      />
      <path
        className="cls-1"
        d="m37.83,53.4c-.08-.06-.08-.13-.05-.21.07.06.14.12.05.21Z"
      />
      <path
        className="cls-1"
        d="m42.05,47.64c-.07,0-.1-.02-.09-.09.03.03.06.06.09.09Z"
      />
    </Icon>
  );
}

export function IconSuede({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="10 41 78 26"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #2d2d2d; }`}
          {`.cls-2 { fill: #515050; }`}
        </style>
      </defs>
      <g>
        <path
          className="cls-2"
          d="m10.73,58.61c.1.52.08,1.06.3,1.56.08.17.17.31.29.44.03.29.28.45.45.64.4.45.75.97,1.37,1.18,0,0,0,0,0,0,.44.41,1.02.45,1.56.59.27.23.62.13.93.22.17.18.38.13.59.12.05.01.11.03.16.04.13.3.39.15.6.16.44.01.88.02,1.31.03.43.24.9.14,1.36.15.15.01.31.03.46.04.6.37,1.27.31,1.93.35.06,0,.12.02.18.03.05.09.09.18.2.06,1.32.23,2.66.27,3.99.41.26.03.52.15.79.1.53.21,1.08.18,1.63.1.06,0,.12,0,.17,0,.05.04.1.11.15.11,1.17.03,2.32.36,3.5.34.71-.01,1.42.04,2.12.16-.28.07-.61-.02-.89.23.51,0,.99,0,1.46,0,.61-.01,1.23-.13,1.82-.14.87-.01,1.75,0,2.62.04.15,0,.32.07.44-.09.85.01,1.7.03,2.56.04.08.19.2.19.34.08,3.59.07,7.19.07,10.78-.03.1.12.2.11.29,0,1.69-.03,3.38-.05,5.07-.08.76.16,1.53.07,2.29.05.04,0,.08-.09.11-.13.63-.01,1.27-.02,1.9-.03.33.13.67.24.97-.07.09,0,.18,0,.27-.01,0,.16-.02.28-.22.29-.38.02-.76.05-1.14.1-.79.11-1.59.06-2.38.1-2.14.11-4.28.27-6.42.36-1.23.05-2.46,0-3.68.01-.83,0-1.66.08-2.48.06-1.19-.03-2.38-.01-3.57.01-2.16.05-4.33.13-6.49.18-1.63.04-3.27-.19-4.9-.31-.14-.01-.28-.07-.42.01-.06,0-.11,0-.17,0-.31-.21-.63-.13-.95-.05-.6-.04-1.19-.09-1.79-.13-.05-.12-.17-.12-.28-.14-.58-.08-1.15-.18-1.7-.36-.37-.12-.74-.16-1.12-.11-.35-.04-.7-.08-1.05-.12-.05-.09-.13-.09-.21-.05-.15-.01-.31-.03-.46-.04-.07-.09-.13-.08-.19,0-.87,0-1.72-.21-2.58-.33-.48-.07-.96-.16-1.44-.24-.05-.09-.13-.09-.21-.05-.14,0-.28-.01-.42-.02-.12-.16-.28-.14-.44-.08-.06-.01-.12-.02-.17-.04-.44-.12-.89-.21-1.36-.16-.46-.05-.93-.11-1.39-.16-.28-.23-.6-.14-.91-.1-.18,0-.35-.02-.53-.02-.1-.05-.2-.07-.3,0-.29-.02-.57-.03-.86-.05-.4-.31-.88-.38-1.36-.45-.86-.15-1.63-.54-2.36-1.01-.23-.37-.25-.86-.65-1.14-.02-.05-.03-.1-.05-.16-.05-.29-.09-.59-.32-.8-.04-1.07.22-2.12.26-3.18.01-.27.02-.54.03-.8.17-.3.23-.62.12-.95,0-.09.02-.18.02-.28.25-.21.27-.48.18-.78,0-.06,0-.12.01-.18.13-.03.2-.09.07-.21.07-.26.14-.51.2-.77.13-.05.09-.13.05-.22,0-.06,0-.11.01-.17.13-.02.18-.09.22-.21.18-.62.4-1.23.56-1.86.11-.42.22-.85.16-1.3.05-.15.11-.29.16-.44.37-.19.31-.62.52-.9.14-.19.22-.45.53-.25-.11.31-.22.62-.32.93-.15.08-.22.17-.06.31-.08.28-.16.55-.24.83-.27.35-.33.76-.32,1.19-.03.09-.07.18-.1.27-.28.65-.41,1.34-.46,2.04-.01.06-.03.12-.04.17-.09.05-.09.12-.05.21-.01.12-.03.24-.04.37-.08.05-.09.13-.05.21-.01.06-.03.12-.04.17-.08.06-.09.13-.05.21-.02.09-.03.18-.05.27-.08.04-.1.1-.08.19-.12.83-.3,1.65-.3,2.49-.14.32-.14.64,0,.96Z"
        />
        <path
          className="cls-2"
          d="m26.54,51.79c-.65-.07-1.24-.42-1.89-.48-.07-.19-.19-.29-.4-.2-.05-.01-.1-.02-.16-.04-.17-.18-.42-.21-.63-.3-.12-.05-.35-.02-.29-.21.05-.16.24-.09.37-.04.79.29,1.64.32,2.41.67.33.15.68.25,1.04.33,1.59.36,3.24.25,4.85.56.05.01.11-.04.17-.06.4.02.8.03,1.21.05.25.23.53.16.8.05.18.01.36.03.54.04.38.25.78.12,1.18.09.21,0,.43,0,.64,0,.07.15.17.21.32.09.15,0,.3,0,.45,0,.38.28.82.3,1.27.26.09,0,.17.01.26.02.07.15.17.21.32.08.05,0,.11.02.16.03.11.19.25.18.42.07l.48.1c.05.09.12.08.19.06.43.02.87.04,1.3.06.18.21.39.15.61.06.18,0,.36.02.54.03.18.22.39.15.61.08.28,0,.57.01.85.02.28.2.61.18.93.23.07.01.17.01.19-.09.02-.09-.05-.15-.13-.18-.72-.33-.74-1.07-.94-1.68-.08-.24-.18-.36-.38-.43.05-.2.29-.26.26-.47,0,0,0,0,0,0,.08-.01.18,0,.22-.04.6-.68,1.14-1.39,1.36-2.3.29-.64.55-1.3.69-1.99.27-.23.26-.57.36-.87.35-1.08.47-2.23,1.05-3.24.29-.52.62-.71,1.13-.61-.01.16-.32.21-.17.43-.22.44-.44.87-.66,1.31-.23.46-.38.95-.41,1.46-.13.43-.33.84-.43,1.29-.22.97-.47,1.93-.84,2.86-.6.91-.97,1.95-1.46,2.91-.16.51.18.67.57.78.05.09.12.1.2.06.19.04.37.08.56.13.06.09.13.09.21.04l.55.15c.47.29.94.61,1.54.54.51.05,1.01.1,1.52.15.12.24.14.44-.17.56-.1.04-.16.18-.24.28-.31.07-.62-.02-.92-.04-.09-.1-.19-.1-.3-.05-.12-.02-.24-.03-.37-.05-.46-.19-.92-.4-1.44-.35-.91-.11-1.83-.18-2.73-.36-.09-.13-.22-.1-.35-.11-1.71-.06-3.4-.26-5.09-.54-.38-.06-.8.1-1.2.15-.22-.01-.44-.03-.65-.04-.07-.25-.25-.19-.42-.14-.08,0-.16,0-.25,0-.36-.24-1,.21-1.18-.48,0,0-.06,0-.09,0-.45.21-.93.07-1.38.03-.69-.06-1.39,0-2.08-.05-.31,0-.63-.01-.94-.02-.11-.24-.29-.2-.48-.12-.05,0-.11-.01-.16-.02-.18-.2-.39-.17-.6-.07-.05,0-.11-.01-.16-.02-.3-.19-.63-.24-.98-.18-.05,0-.11,0-.16-.01-.08-.13-.19-.17-.32-.07-.05-.01-.1-.03-.16-.04-.06-.08-.12-.16-.23-.06-.05,0-.11-.02-.16-.02-.08-.13-.18-.18-.32-.07Z"
        />
        <path
          className="cls-2"
          d="m33.11,66.12c.14-.08.28-.02.42-.01,1.63.12,3.27.35,4.9.31,2.16-.05,4.33-.13,6.49-.18,1.19-.03,2.38-.04,3.57-.01.82.02,1.65-.06,2.48-.06,1.23,0,2.46.04,3.68-.01,2.14-.09,4.28-.24,6.42-.36.79-.04,1.59.01,2.38-.1.38-.05.76-.08,1.14-.1.2-.01.23-.13.22-.29.08,0,.16,0,.24-.01.39.43.93.25,1.38.29.96.07,1.93-.03,2.89-.06-.32.35-.79.31-1.18.33-1.33.09-2.63.39-3.96.49-.49.04-.98.1-1.47.1-1.48.01-2.94.22-4.42.27-1.36.04-2.73.07-4.1-.03-.52-.04-1.08,0-1.61.07-1.08.15-2.16.07-3.24.08-1.76.02-3.53.02-5.29,0-.46,0-.91,0-1.37,0-1.83-.02-3.66-.03-5.49-.1-1.11-.04-2.21-.17-3.31-.29-.26-.03-.57-.07-.77-.32Z"
        />
        <path
          className="cls-2"
          d="m68.07,50.57c.13,0,.25.02.38.02.54.28,1.14.28,1.73.36,1.14.24,2.28.46,3.44.62,1,.27,2,.57,2.99.86.73.21,1.5.31,2.27.19.7.02,1.4.04,2.11.07.39.2.87.12,1.25.37.08.05.18.09.16.2-.02.1-.11.1-.19.1-1.28-.02-2.58.13-3.85-.07-1.11-.18-2.19-.48-3.29-.7-.6-.12-1.21-.24-1.84-.17-.09,0-.18-.01-.27-.02-.05-.19-.21-.22-.36-.25-.34-.06-.68-.13-1.02-.16-.82-.08-1.63-.32-2.46-.34-1.27-.22-2.54-.44-3.82-.66-.05-.1-.12-.12-.19-.02-.22-.02-.43-.03-.65-.05-.11-.18-.25-.17-.4-.05-.41-.05-.82-.1-1.22-.15-.05-.11-.11-.18-.21-.04-.12-.01-.25-.03-.37-.04-.07-.15-.17-.21-.3-.06-.12-.01-.24-.03-.36-.04-.05-.11-.1-.19-.21-.05-.25-.05-.5-.1-.75-.15-.45-.18-.63-.43-.24-.85.03-.04.02-.12.02-.18,1.66.42,3.35.66,5.05.82.09.13.19.17.31.05.18.02.36.04.55.05.06.1.12.15.22.04.12,0,.25.02.37.03.05.09.09.21.2.05.09.02.18.04.27.06.2.16.43.23.69.16Z"
        />
        <path
          className="cls-2"
          d="m59.17,55.35c-1.54-.08-3.05-.35-4.59-.48-.02-.16-.26-.23-.18-.44.22,0,.44.04.65.04.8,0,1.58.33,2.39.22.23.14.47.07.71,0,.05.01.11.02.16.04.05.09.11.13.19.03.12.01.24.03.37.04.05.1.1.18.21.04,1.04.09,2.06.34,3.09.38,2.79.12,5.59.26,8.38.01.35.08.69-.08,1.04-.08,1.78-.02,3.57.07,5.35-.08.5-.04,1.01-.04,1.47-.28.31-.08.63-.02.95-.07.96-.15,1.88-.52,2.86-.58.47.06.76-.25,1.08-.51.15-.12.3-.19.47-.07.07.05.21.07.19.19-.04.18-.22.21-.37.27-1.18.49-2.42.79-3.67,1.07-.13.03-.3-.02-.38.15-.69.25-1.42.32-2.15.4-1.96.19-3.92-.02-5.88.09-.23-.08-.45-.13-.67.03-.21.01-.43.02-.64.03-.6-.04-1.2-.14-1.78.09-1.34.09-2.67.07-4.01-.02-1.01-.07-2.02-.12-3.03-.22-.39-.04-.78-.11-1.17-.1-.16-.25-.36-.22-.57-.07-.06-.02-.11-.05-.17-.07-.08-.12-.18-.16-.31-.07Z"
        />
        <path
          className="cls-2"
          d="m37.83,50.1c.26,0,.52-.04.77.04.74.37,1.57.38,2.37.52.28.05.59.1.88-.04.05,0,.11,0,.16,0,.09.22.3.12.45.16.14.03.32.05.3.23-.02.16-.2.11-.32.12-.42.01-.85.01-1.27.02-.13-.01-.27.02-.38-.08-.09-.09-.19-.05-.29-.01-.16-.02-.31-.03-.47-.05-.05-.1-.12-.09-.2-.05-.12-.01-.24-.02-.36-.03-.02-.14-.12-.17-.24-.17-1.51-.04-3.01-.19-4.5-.38-1.87-.24-3.75-.48-5.62-.73-.93-.12-1.85-.31-2.79-.19-.06-.01-.11-.02-.17-.03-.06-.12-.19-.1-.29-.12-.64-.13-1.3-.19-1.91-.41-1.15-.41-2.26-.91-3.39-1.35-.51-.2-1.02-.38-1.58-.34-.09,0-.18,0-.27,0-.24-.28-.54-.31-.88-.2l-1.23-.18v-.34c.26,0,.5,0,.75,0,.06.09.13.09.19,0,.15.02.29.04.44.05.09.11.19.17.32.05.09,0,.17,0,.26.01.14.2.32.18.51.07.08.01.17.03.25.04.06.09.12.16.23.06.05.01.1.02.16.03.42.36.99.38,1.47.59.37.16.72.39,1.15.4.06.01.11.02.17.03.68.41,1.42.67,2.22.74.55.17,1.12.19,1.69.23.05.11.11.19.22.04.18.02.36.05.54.07.03.04.06.1.09.1.84.09,1.69.17,2.53.25.31.01.61.02.92.03.4.44.91.2,1.38.23.09,0,.18.02.27.03.07.17.17.23.31.06.18.01.37.03.55.04.11.2.25.2.4.05,1.27.11,2.53.23,3.8.34.11.23.25.2.41.06Z"
        />
        <path
          className="cls-2"
          d="m69.33,65.52c-.97.03-1.94.13-2.89.06-.45-.03-.99.14-1.38-.29.07-.02.14-.04.21-.06.78.13,1.56.06,2.34,0,.23-.02.51.12.69-.16,1.38-.09,2.76-.22,4.12-.52.86-.19,1.74-.3,2.61-.37,1.29-.1,2.5-.46,3.69-.93.76-.3,1.55-.49,2.32-.76.86-.31,1.69-.69,2.54-1.03.86-.34,1.68-.78,2.52-1.17.34-.16.66-.36.93-.63.24.1.3-.22.5-.24-.02.14-.03.27-.05.4-.91.94-2.13,1.35-3.26,1.88-1.13.54-2.29,1.04-3.48,1.44-.76.26-1.53.56-2.34.67-.44-.02-.84.07-1.18.37-.05.02-.11.04-.16.05-.03,0-.06,0-.09,0-.03,0-.06,0-.09,0-.09,0-.2-.03-.28,0-.63.22-1.25.44-1.93.41-.09,0-.19.1-.28.15-.06.01-.12.02-.18.04-.1-.05-.21-.05-.31,0-1.18.06-2.32.43-3.48.62-.36.06-.73.04-1.09.05Z"
        />
        <path
          className="cls-2"
          d="m58.41,48.65c.28.11.56.21.84.32.23.27.03.48-.11.67-.14.18-.36.1-.52.02-.68-.32-1.34-.67-2.01-1-.1-.07-.19-.13-.29-.2-.05-.13-.13-.21-.28-.19-.26-.19-.51-.39-.77-.58,0-.06,0-.15-.03-.19-.75-.84-1.53-1.66-2.49-2.27-.1-.12-.32-.11-.37-.3-.02-.17-.06-.34-.25-.4l-.12-.11c-.39-.54-.55-1.18-.78-1.79-.03-.07-.1-.14-.03-.21.09-.09.17,0,.25.05.25.18.37.52.71.59.41.51.83,1.03,1.24,1.54.02.15.11.25.26.29.08.09.15.18.23.27.04.22.16.34.38.38.1.1.19.19.29.29.2.21.33.51.67.57.16.16.32.32.48.48.16.17.31.37.5.49.48.31.81.85,1.44.91,0,0,0,0,0,0,.19.26.47.34.76.38Z"
        />
        <path
          className="cls-2"
          d="m16.6,46.49c0,.11,0,.23,0,.34-.27.02-.54.03-.91.05.9.76,1.88,1.06,2.85,1.41.55.2,1.13.34,1.58.75-.29,0-.65.13-.86,0-.93-.55-1.99-.76-2.93-1.26-.17-.09-.4-.19-.5.11-.34.02-.69-.08-.94-.26-.72-.51-1.33-.42-1.93.17-.31-.19-.39.07-.53.25-.21.28-.15.72-.52.9.11-1.4,1.37-2.4,2.63-2.32.48.03.93-.2,1.41-.19.22,0,.44.03.66.04Z"
        />
        <path
          className="cls-2"
          d="m31.99,52.03c-.06.02-.12.07-.17.06-1.6-.31-3.25-.2-4.85-.56-.35-.08-.71-.18-1.04-.33-.77-.35-1.63-.38-2.41-.67-.13-.05-.33-.12-.37.04-.05.19.17.16.29.21.21.09.46.12.63.3-.33.07-.63-.09-.9-.21-.62-.29-1.24-.56-1.9-.74-.12-.03-.25-.07-.3-.21.25-.13.58.28.72-.03.12-.27-.36-.29-.44-.53.34.03.71.01,1.01.18,1.13.62,2.38.84,3.58,1.23.67.22,1.33.57,2.02.62.85.07,1.7.17,2.54.27.54.06,1.11.02,1.59.37Z"
        />
        <path
          className="cls-2"
          d="m79.54,55.25c.08-.17.24-.12.38-.15,1.25-.27,2.48-.57,3.67-1.07.14-.06.33-.08.37-.27.02-.11-.12-.14-.19-.19-.17-.12-.32-.05-.47.07-.32.25-.61.57-1.08.51.07-.13.22-.12.32-.18.13-.08.35-.13.31-.31-.04-.15-.24-.11-.38-.11-.83,0-1.66-.02-2.48-.02-.71,0-1.42,0-2.13-.15-1.1-.24-2.21-.42-3.31-.66-.43-.1-.92-.01-1.3-.32.62-.07,1.23.05,1.84.17,1.1.22,2.19.52,3.29.7,1.27.21,2.57.05,3.85.07.08,0,.17,0,.19-.1.02-.12-.08-.15-.16-.2-.38-.26-.85-.18-1.25-.37.8-.2,1.52.05,2.23.39.48.23.95.48,1.34.9-.52.24-1.09.33-1.64.5-.96.29-1.92.56-2.9.75-.16.03-.31.07-.47.03Z"
        />
        <path
          className="cls-2"
          d="m52.16,43.04c-.34-.07-.46-.41-.71-.59-.08-.05-.15-.13-.25-.05-.07.07,0,.14.03.21.24.61.39,1.25.78,1.79-.13.05-.2-.04-.29-.1-.39-.27-.43-.72-.58-1.12-.48-1.28-1.43-1.75-2.43-1.19-.15-.22.15-.27.17-.43-.51-.1-.83.09-1.13.61-.57,1.01-.69,2.16-1.05,3.24-.1.3-.09.64-.36.87-.18-.18-.03-.37.02-.53.35-1.07.45-2.22.98-3.22.2-.37.35-.78.68-1.08.71-.65,1.55-.58,2.32-.27.83.35,1.33,1.12,1.82,1.87Z"
        />
        <path
          className="cls-2"
          d="m56.6,48.65c.67.34,1.34.68,2.01,1,.16.08.39.16.52-.02.14-.19.34-.4.11-.67.4.08.85-.03,1.15.35,0,.06.01.15-.02.18-.39.42-.21.67.24.85-.3.12-.54-.07-.79-.17,0-.05,0-.1.03-.14.11-.32-.15-.38-.33-.44-.25-.08-.25.12-.28.31-.04.23-.16.44-.29.64-.51.77-.76,1.66-.99,2.53-.08.31-.25.77.26.98.08.22-.12.41-.07.63-.24.06-.47.13-.71,0,.14-.25.21-.51.18-.8-.02-.19,0-.37.06-.56.29-1,.61-2,1.08-2.93.17-.35.07-.47-.24-.59-.34-.13-.69-.24-.99-.44-.27-.17-.45-.12-.65.06-.03-.23-.15-.38-.4-.41.04-.13.08-.25.13-.38Z"
        />
        <path
          className="cls-2"
          d="m54.4,54.43c-.08.21.16.28.18.44-.65-.09-1.31-.07-1.95-.25-.18-.05-.37-.03-.56,0-.69.14-1.38.14-2.07.04-.13-.02-.25-.05-.34-.15.08-.1.14-.24.24-.28.32-.12.29-.32.17-.56.08-.31.17-.62.45-.83-.02.14-.05.27-.07.41-.04.29.07.42.37.36.04.14,0,.33.25.33,1.14-.02,2.2.45,3.33.49Z"
        />
        <path
          className="cls-2"
          d="m40.22,65.5c-.12.16-.29.09-.44.09-.87-.03-1.75-.05-2.62-.04-.59,0-1.21.13-1.82.14-.47.01-.95,0-1.46,0,.28-.25.6-.16.89-.23-.71-.12-1.41-.17-2.12-.16-1.18.02-2.32-.31-3.5-.34-.05,0-.1-.07-.15-.11.96-.14,1.89.12,2.84.21.65.06,1.3.08,1.95.06,2.08-.06,4.14.32,6.23.27.08,0,.16.02.21.09Z"
        />
        <path
          className="cls-2"
          d="m41.17,51.16c.42,0,.85,0,1.27-.02.12,0,.3.05.32-.12.02-.18-.16-.2-.3-.23-.16-.04-.36.05-.45-.16.26-.09.54-.07.8,0,.43.11.84.08,1.26-.02.03.21-.21.27-.26.47.2.07.3.19.38.43.2.61.23,1.35.94,1.68.07.03.14.09.13.18-.02.1-.12.1-.19.09-.32-.05-.65-.03-.93-.23.1-.08.25.01.36-.14-.33-.3-.45-.71-.52-1.13-.07-.37-.27-.53-.65-.54-.6,0-1.2-.06-1.8-.09-.14,0-.3.03-.35-.17Z"
        />
        <path
          className="cls-2"
          d="m87.48,59.84c.02-.13.03-.26.05-.4-.21.02-.26.34-.5.24.44-.6.51-1.18.07-1.83-.38-.56-.54-1.26-.96-1.8-.22-.28-.48-.53-.48-.94.43.36.9.69,1.16,1.18.4.78.75,1.6,1.07,2.42.23.58.11.81-.41,1.14Z"
        />
        <path
          className="cls-2"
          d="m21.25,49.36c.08.24.56.26.44.53-.14.3-.47-.1-.72.03-.08-.02-.16-.04-.25-.06-.17-.2-.39-.21-.63-.2-.06-.01-.11-.03-.17-.04-.3-.37-.72-.41-1.15-.4-.41-.16-.82-.31-1.23-.47-.32-.41-.8-.51-1.26-.64-.16-.07-.31-.14-.47-.21.11-.31.33-.2.5-.11.94.5,2.01.72,2.93,1.26.21.13.57,0,.86,0,0,0,0,0,0,0,.26.3.57.44.96.28.06.01.12.03.17.04Z"
        />
        <path
          className="cls-2"
          d="m37.26,53.17c.4-.06.82-.22,1.2-.15,1.69.28,3.38.48,5.09.54.13,0,.26-.02.35.11-.87.12-1.75.11-2.61-.05-1.05-.2-2.11-.15-3.17-.27-.29-.03-.59,0-.86-.17Z"
        />
        <path
          className="cls-2"
          d="m31.22,52.5c.69.04,1.38,0,2.08.05.45.04.92.18,1.38-.03.03-.01.09,0,.09,0,.17.69.82.25,1.18.48-.08.17-.24.14-.38.13-.97-.08-1.96-.1-2.92-.29-.35-.07-.72-.12-1.08-.15-.15-.01-.28-.03-.35-.18Z"
        />
        <path
          className="cls-2"
          d="m78.88,52.61c-.77.12-1.54.02-2.27-.19-1-.29-1.99-.59-2.99-.86.05-.1.16-.12.25-.09.67.24,1.39.31,2.08.49.88.24,1.8.36,2.7.53.09.02.19.01.24.11Z"
        />
        <path
          className="cls-2"
          d="m11.74,49.39c.06.45-.06.88-.16,1.3-.16.63-.38,1.24-.56,1.86-.04.13-.09.2-.22.21-.02-.04-.06-.09-.05-.12.21-.91.44-1.81.63-2.73.05-.24.15-.4.35-.53Z"
        />
        <path
          className="cls-2"
          d="m41.85,50.62c-.29.14-.6.09-.88.04-.8-.14-1.62-.14-2.37-.52.33-.24.63.05.94.08.73.06,1.45.18,2.17.29.05,0,.09.07.14.11Z"
        />
        <path
          className="cls-2"
          d="m45.65,48.26c-.22.91-.76,1.62-1.36,2.3-.04.04-.15.03-.22.04.55-.69,1-1.44,1.38-2.24.02-.05.13-.06.2-.09Z"
        />
        <path
          className="cls-2"
          d="m74.39,64.82c.09-.05.19-.16.28-.15.68.03,1.3-.19,1.93-.41.08-.03.19,0,.28,0-.18.44-.56.48-.96.51-.51.04-1.01.2-1.53.05Z"
        />
        <path
          className="cls-2"
          d="m68.29,65.07c-.17.28-.46.14-.69.16-.78.06-1.56.14-2.34,0,.04-.03.07-.08.11-.08.97,0,1.94-.21,2.92-.08Z"
        />
        <path
          className="cls-2"
          d="m27.1,65.32c.38-.05.75,0,1.12.11.55.18,1.13.28,1.7.36.11.02.22.01.28.14-.7.14-1.34-.14-1.99-.31-.37-.09-.8,0-1.11-.3Z"
        />
        <path
          className="cls-2"
          d="m57.65,48.27c-.63-.06-.96-.6-1.44-.91-.19-.12-.33-.33-.5-.49.15-.01.27.03.39.13.5.44,1.11.75,1.55,1.28Z"
        />
        <path
          className="cls-2"
          d="m29.79,49.25c-.84-.08-1.69-.16-2.53-.25-.03,0-.06-.07-.09-.1.85-.12,1.68.07,2.51.21.04,0,.07.09.11.14Z"
        />
        <path
          className="cls-2"
          d="m13.14,62.44c-.62-.2-.97-.73-1.37-1.18-.17-.19-.41-.35-.45-.64.52.23.73.78,1.13,1.14.24.21.61.3.69.68Z"
        />
        <path
          className="cls-2"
          d="m22.33,47.79c-.43,0-.78-.24-1.15-.4-.49-.21-1.05-.23-1.47-.59.72.05,1.35.38,2.01.62.22.08.52.06.62.36Z"
        />
        <path
          className="cls-2"
          d="m11.44,53.37c.06-.7.19-1.38.46-2.04.05.04.14.08.13.11-.16.66-.17,1.36-.6,1.93Z"
        />
        <path
          className="cls-2"
          d="m61.67,65.43s-.08.13-.11.13c-.77.01-1.53.11-2.29-.05.2-.2.45-.1.67-.1.58,0,1.16.01,1.74.02Z"
        />
        <path
          className="cls-2"
          d="m22.04,64.15c-.66-.04-1.33.02-1.93-.35.51.06,1.02.11,1.53.17.15.02.32,0,.4.18Z"
        />
        <path
          className="cls-2"
          d="m24.72,48.56c-.8-.07-1.53-.33-2.22-.74.78.14,1.51.4,2.22.74Z"
        />
        <path
          className="cls-2"
          d="m68.42,55.89c.58-.23,1.18-.13,1.78-.09-.58.24-1.18.12-1.78.09Z"
        />
        <path
          className="cls-2"
          d="m70.18,50.95c-.59-.07-1.19-.07-1.73-.36.6.01,1.2.02,1.73.36Z"
        />
        <path
          className="cls-2"
          d="m28.83,64.85c-.55.08-1.1.11-1.63-.1.55-.03,1.09-.09,1.63.1Z"
        />
        <path
          className="cls-2"
          d="m10.22,61.26c.4.28.42.77.65,1.14-.42-.15-.74-.69-.65-1.14Z"
        />
        <path
          className="cls-2"
          d="m18.78,49.21c.43-.01.85.03,1.15.4-.43,0-.83-.09-1.15-.4Z"
        />
        <path
          className="cls-2"
          d="m46.63,54.03c.52-.04.98.16,1.44.35-.54.11-.99-.12-1.44-.35Z"
        />
        <path
          className="cls-2"
          d="m14.7,63.03c-.54-.14-1.12-.19-1.56-.59.53.17,1.11.23,1.56.59Z"
        />
        <path
          className="cls-2"
          d="m32.09,49.52c-.47-.04-.98.21-1.38-.23.46.1.96-.07,1.38.23Z"
        />
        <path
          className="cls-2"
          d="m16.29,48.1c.46.13.94.24,1.26.64-.49-.09-.92-.29-1.26-.64Z"
        />
        <path
          className="cls-2"
          d="m18.57,64.19c.46-.05.91.04,1.36.16-.48.16-.92.06-1.36-.16Z"
        />
        <path
          className="cls-2"
          d="m13.22,63.41c.48.07.96.14,1.36.45-.47-.09-.96-.13-1.36-.45Z"
        />
        <path
          className="cls-2"
          d="m19.65,63.76c-.46-.01-.93.09-1.36-.15.46-.03.93-.1,1.36.15Z"
        />
        <path
          className="cls-2"
          d="m12,51.06c0-.43.05-.84.32-1.19-.03.42-.04.84-.32,1.19Z"
        />
        <path
          className="cls-2"
          d="m77.22,64.2c.34-.3.74-.39,1.18-.37-.35.26-.76.34-1.18.37Z"
        />
        <path
          className="cls-2"
          d="m10.26,55.36c.11.34.05.65-.12.95-.14-.34-.08-.66.12-.95Z"
        />
        <path
          className="cls-2"
          d="m10.73,58.61c-.15-.32-.14-.64,0-.96.17.32.15.64,0,.96Z"
        />
        <path
          className="cls-2"
          d="m64.54,65.33c-.3.31-.63.2-.97.07.31-.18.64-.08.97-.07Z"
        />
        <path
          className="cls-2"
          d="m31.99,66.06c.32-.08.65-.16.95.05-.32.09-.64.13-.95-.05Z"
        />
        <path
          className="cls-2"
          d="m27.88,52.07c.35-.06.68,0,.98.18-.35.07-.68,0-.98-.18Z"
        />
        <path
          className="cls-2"
          d="m58.41,48.65c-.3-.04-.57-.12-.76-.38.32,0,.59.09.76.38Z"
        />
        <path
          className="cls-2"
          d="m16.27,63.93c.31-.04.63-.12.91.1-.31.04-.63.12-.91-.1Z"
        />
        <path
          className="cls-2"
          d="m55.23,46.38c-.34-.05-.47-.35-.67-.57.38,0,.55.25.67.57Z"
        />
        <path
          className="cls-2"
          d="m9.84,60.3c.24.22.28.51.32.8-.54-.09-.25-.52-.32-.8Z"
        />
        <path
          className="cls-2"
          d="m68.07,50.57c-.26.08-.48,0-.69-.16.24,0,.52-.16.69.16Z"
        />
        <path
          className="cls-2"
          d="m10.46,54.31c.09.29.07.56-.18.78-.04-.28,0-.55.18-.78Z"
        />
        <path
          className="cls-2"
          d="m70.85,55.76c.22-.16.44-.11.67-.03-.22.13-.44.12-.67.03Z"
        />
        <path
          className="cls-2"
          d="m16.97,63.58c-.21-.02-.46.14-.6-.16.21,0,.46-.11.6.16Z"
        />
        <path
          className="cls-2"
          d="m16.22,63.37c-.21.01-.42.06-.59-.12.21-.03.45-.22.59.12Z"
        />
        <path
          className="cls-2"
          d="m29.02,52.27c.22-.09.42-.12.6.07-.21.05-.42.1-.6-.07Z"
        />
        <path
          className="cls-2"
          d="m59.65,55.49c.21-.15.41-.18.57.07-.19,0-.39.08-.57-.07Z"
        />
        <path
          className="cls-2"
          d="m20.1,49.65c.23-.01.46,0,.63.2-.25.06-.46,0-.63-.2Z"
        />
        <path
          className="cls-2"
          d="m54.27,45.52c-.21-.04-.34-.17-.38-.38.24.02.38.13.38.38Z"
        />
        <path
          className="cls-2"
          d="m19.07,46.67c-.19.11-.36.13-.51-.07.18-.05.36-.1.51.07Z"
        />
        <path
          className="cls-2"
          d="m29.79,52.36c.19-.08.37-.13.48.12-.17.02-.35.03-.48-.12Z"
        />
        <path
          className="cls-2"
          d="m20.11,64.39c.16-.05.32-.08.44.08-.17.09-.32.11-.44-.08Z"
        />
        <path
          className="cls-2"
          d="m36.18,53c.17-.05.35-.11.42.14-.17.04-.33.06-.42-.14Z"
        />
        <path
          className="cls-2"
          d="m33.62,49.7c-.16.14-.29.15-.4-.05.14-.05.28-.08.4.05Z"
        />
        <path
          className="cls-2"
          d="m24.24,51.11c.21-.09.33,0,.4.2-.16,0-.32-.04-.4-.2Z"
        />
        <path
          className="cls-2"
          d="m37.83,50.1c-.16.14-.3.17-.41-.06.15-.05.29-.1.41.06Z"
        />
        <path
          className="cls-2"
          d="m53.66,44.87c-.15-.04-.24-.13-.26-.29.21-.02.31.07.26.29Z"
        />
        <path
          className="cls-2"
          d="m26.54,51.79c.13-.11.24-.06.32.07-.12.06-.23.06-.32-.07Z"
        />
        <path
          className="cls-2"
          d="m54.19,65.59c-.09.12-.19.13-.29,0,.09-.13.19-.13.29,0Z"
        />
        <path
          className="cls-2"
          d="m65.77,50.18c-.12.12-.23.09-.31-.05.11-.04.23-.09.31.05Z"
        />
        <path
          className="cls-2"
          d="m43.12,65.63c-.15.11-.27.11-.34-.08.14-.07.26-.07.34.08Z"
        />
        <path
          className="cls-2"
          d="m18.3,46.59c-.13.12-.23.05-.32-.05.12-.08.24-.09.32.05Z"
        />
        <path
          className="cls-2"
          d="m48.43,54.43c.11-.05.22-.05.3.05-.13.14-.23.11-.3-.05Z"
        />
        <path
          className="cls-2"
          d="m27.4,51.98c.13-.1.23-.06.32.07-.12.06-.23.06-.32-.07Z"
        />
        <path
          className="cls-2"
          d="m73.9,64.85c.11-.05.21-.05.31,0-.01.11-.07.18-.18.16-.1-.01-.12-.09-.13-.17Z"
        />
        <path
          className="cls-2"
          d="m12.57,49.04c-.16-.14-.1-.23.06-.31.03.11.1.23-.06.31Z"
        />
        <path
          className="cls-2"
          d="m59.17,55.35c.13-.09.23-.05.31.07-.12.05-.23.04-.31-.07Z"
        />
        <path
          className="cls-2"
          d="m15.44,63.91c.1-.08.2-.05.3,0-.09.17-.19.21-.3,0Z"
        />
        <path
          className="cls-2"
          d="m32.66,49.6c-.14.17-.23.11-.31-.06.11-.04.22-.06.31.06Z"
        />
        <path
          className="cls-2"
          d="m10.8,52.94c.04.08.08.17-.05.22-.15-.11-.09-.17.05-.22Z"
        />
        <path
          className="cls-2"
          d="m26.63,48.83c-.1.15-.16.07-.22-.04.08-.05.16-.05.22.04Z"
        />
        <path
          className="cls-2"
          d="m22.42,64.24c-.11.12-.16.03-.2-.06.08-.03.16-.03.2.06Z"
        />
        <path
          className="cls-2"
          d="m11.35,53.75c-.04-.08-.03-.16.05-.21.13.11.06.16-.05.21Z"
        />
        <path
          className="cls-2"
          d="m66.54,50.28c-.1.11-.16.05-.22-.04.08-.04.16-.06.22.04Z"
        />
        <path
          className="cls-2"
          d="m20.96,64.49c.09-.04.16-.04.21.05-.11.14-.16.05-.21-.05Z"
        />
        <path
          className="cls-2"
          d="m67.11,50.35c-.11.17-.15.04-.2-.05.08-.03.15-.05.2.05Z"
        />
        <path
          className="cls-2"
          d="m17.54,46.48c-.07.09-.13.08-.19,0,.07-.1.13-.11.19,0Z"
        />
        <path
          className="cls-2"
          d="m25.2,65.11c.06-.09.13-.1.19,0-.06.11-.13.08-.19,0Z"
        />
        <path
          className="cls-2"
          d="m10.54,53.92c.13.12.07.17-.07.21-.04-.09-.03-.16.07-.21Z"
        />
        <path
          className="cls-2"
          d="m25.85,65.15c.08-.04.16-.04.21.05-.11.14-.16.06-.21-.05Z"
        />
        <path
          className="cls-2"
          d="m19.55,46.77c-.11.1-.17.04-.23-.06.1-.06.17-.05.23.06Z"
        />
        <path
          className="cls-2"
          d="m11.25,54.32c-.03-.08-.03-.16.05-.21.13.11.05.16-.05.21Z"
        />
        <path
          className="cls-2"
          d="m11.17,54.71c-.04-.08-.03-.16.05-.21.12.1.05.16-.05.21Z"
        />
        <path
          className="cls-2"
          d="m11.03,55.17c-.02-.08,0-.15.08-.19.15.14,0,.15-.08.19Z"
        />
        <path
          className="cls-2"
          d="m27.01,51.89c.11-.11.17-.03.23.06-.09.05-.17.04-.23-.06Z"
        />
        <path
          className="cls-2"
          d="m76.97,64.26s.06,0,.09,0c0,.02-.02.04-.03.07-.02-.02-.05-.04-.07-.06Z"
        />
        <path
          className="cls-2"
          d="m46.38,48.91c.17.39-.14.67-.29.95-.25.48-.48.96-.67,1.46-.1.24-.2.47-.5.5.5-.97.86-2,1.46-2.91Z"
        />
        <path
          className="cls-2"
          d="m47.02,52.98c.06-.11.17-.12.25-.08.43.2.86.42,1.29.62-.6.06-1.07-.25-1.54-.54Z"
        />
        <path
          className="cls-2"
          d="m48.05,43.3c.03.53-.14,1.01-.41,1.46.03-.52.18-1,.41-1.46Z"
        />
        <path
          className="cls-2"
          d="m37.13,52.34c.43.05.89-.01,1.27.26-.45.04-.89.02-1.27-.26Z"
        />
        <path
          className="cls-2"
          d="m34.54,52.17c.4-.03.8-.19,1.18.09-.4.03-.8.16-1.18-.09Z"
        />
        <path
          className="cls-2"
          d="m33.2,52.08c.27-.07.54-.11.8.05-.27.11-.55.18-.8-.05Z"
        />
        <path
          className="cls-2"
          d="m41.53,53.02c.21-.05.42-.12.61.06-.21.09-.42.15-.61-.06Z"
        />
        <path
          className="cls-2"
          d="m42.68,53.11c.21-.04.42-.12.61.08-.21.07-.43.14-.61-.08Z"
        />
        <path
          className="cls-2"
          d="m39.14,52.73c.15-.04.3-.08.42.07-.16.11-.3.12-.42-.07Z"
        />
        <path
          className="cls-2"
          d="m38.66,52.63c.12-.05.23-.05.32.08-.14.13-.24.07-.32-.08Z"
        />
        <path
          className="cls-2"
          d="m36.36,52.25c.13-.06.25-.06.32.09-.15.12-.24.06-.32-.09Z"
        />
        <path
          className="cls-2"
          d="m45.48,52.6c.11-.13.17-.06.2.06-.08.04-.16.03-.2-.06Z"
        />
        <path
          className="cls-2"
          d="m40.03,52.9c.13-.2.15-.04.19.06-.08.02-.15.03-.19-.06Z"
        />
        <path
          className="cls-2"
          d="m46.25,52.79c.1-.13.16-.07.21.04-.08.05-.16.05-.21-.04Z"
        />
        <path
          className="cls-2"
          d="m72.95,52.39c-.82-.01-1.62-.2-2.41-.37-.48-.1-1.01-.05-1.43-.38.83.01,1.63.26,2.46.34.34.03.68.1,1.02.16.15.03.32.06.36.25Z"
        />
        <path
          className="cls-2"
          d="m64.45,50.93c-.14.05-.28.07-.4-.05.15-.12.29-.13.4.05Z"
        />
        <path
          className="cls-2"
          d="m62.25,50.65c-.11.04-.22.06-.3-.06.13-.15.23-.09.3.06Z"
        />
        <path
          className="cls-2"
          d="m62.83,50.73c-.08.05-.16.05-.21-.04.1-.14.16-.07.21.04Z"
        />
        <path
          className="cls-2"
          d="m61.58,50.55c-.08.04-.16.04-.21-.05.1-.14.16-.07.21.05Z"
        />
        <path
          className="cls-2"
          d="m65.29,50.99c-.07.08-.13.08-.19-.02.07-.1.13-.09.19.02Z"
        />
        <path
          className="cls-2"
          d="m70.55,55.24c0-.27.14-.36.39-.36,1.18,0,2.37.04,3.55-.03.89-.05,1.79-.02,2.68-.11.39-.04.84-.15,1.24.05-.46.24-.98.24-1.47.28-1.78.15-3.57.06-5.35.08-.35,0-.69.16-1.04.08Z"
        />
        <path
          className="cls-2"
          d="m58.87,54.81c.08-.03.15-.03.21.04-.1.14-.16.06-.21-.04Z"
        />
        <path
          className="cls-2"
          d="m58.31,54.74c.08-.07.14-.06.19.03-.08.1-.14.06-.19-.03Z"
        />
        <path
          className="cls-2"
          d="m39.47,50.93c-1.47,0-2.93-.14-4.4-.32-.94-.11-1.89-.17-2.82-.32-1.19-.19-2.38-.36-3.57-.52-.63-.08-1.26-.11-1.89-.17-.16-.02-.36.07-.47-.13.94-.12,1.86.07,2.79.19,1.87.25,3.75.49,5.62.73,1.49.19,2.99.34,4.5.38.12,0,.22.03.24.17Z"
        />
        <path
          className="cls-2"
          d="m26.15,49.43c-.51.14-.99-.09-1.47-.15-.68-.09-1.31-.36-1.94-.62-1.21-.5-2.4-1.04-3.68-1.35-.03,0-.06-.07-.09-.1.56-.04,1.08.15,1.58.34,1.14.44,2.25.95,3.39,1.35.61.22,1.27.28,1.91.41.1.02.23,0,.29.12Z"
        />
        <path
          className="cls-2"
          d="m18.7,47.21c-.3-.02-.61-.03-.88-.2.33-.11.63-.08.88.2Z"
        />
        <path
          className="cls-2"
          d="m40.79,51.08c-.1.19-.2.18-.29-.01.1-.04.2-.08.29.01Z"
        />
        <path
          className="cls-2"
          d="m40.03,51.02c-.11.15-.16.09-.2-.05.08-.04.15-.05.2.05Z"
        />
        <path
          className="cls-2"
          d="m55.27,47.68c-.24.01-.34-.2-.5-.33-.15-.13-.2-.15-.33.08-.18.35-.37.72-.73.95-.04-.28.15-.47.29-.68.08-.11.14-.23,0-.33-.14-.11-.27-.02-.32.09-.17.4-.51.68-.75,1.03-.35.52-.62,1.12-1.14,1.51,0-.06-.01-.14.02-.18.47-.74.91-1.5,1.43-2.21.2-.28.29-.66.7-.8.16-.05-.05-.23-.14-.32-.37-.41-.79-.77-1.05-1.26.96.62,1.74,1.43,2.49,2.27.03.04.02.12.03.19Z"
        />
        <path
          className="cls-2"
          d="m52.39,44.91c-.24-.03-.28-.2-.25-.4.19.07.23.23.25.4Z"
        />
        <path
          className="cls-2"
          d="m56.31,48.45c-.15.02-.28,0-.28-.19.15-.02.23.07.28.19Z"
        />
        <path
          className="cls-2"
          d="m59.83,50.18c-.37.3-.49.74-.67,1.15-.13.06-.15.19-.2.3-.29.57-.25,1.22-.46,1.81-.04.23-.14.44-.28.62-.51-.21-.35-.67-.26-.98.23-.88.49-1.76.99-2.53.13-.2.25-.41.29-.64.03-.18.03-.39.28-.31.19.06.45.12.33.44-.02.04-.02.09-.03.14Z"
        />
        <path
          className="cls-2"
          d="m56.88,49.43c-.31.55-.61,1.11-.94,1.64-.09.14-.12.28-.19.42-.15.06-.29.2-.46.03-.16-.16-.16-.33-.1-.52.05-.15.16-.27.14-.44.26-.41.54-.81.77-1.24.1-.18.21-.26.38-.29.25.02.37.17.4.41Z"
        />
        <path
          className="cls-2"
          d="m51.8,50c.53-.39.79-.99,1.14-1.51.24-.35.58-.63.75-1.03.05-.11.18-.2.32-.09.13.1.07.22,0,.33-.14.2-.33.39-.29.68l-.27.31c-.5.26-.52.81-.76,1.23-.07.12-.14.24-.21.37-.1.03-.19.08-.16.21-.49,1.04-.99,2.08-1.48,3.13-.3.06-.41-.07-.37-.36.02-.14.05-.27.07-.41.42-.95.66-1.99,1.28-2.85Z"
        />
        <path
          className="cls-2"
          d="m20.12,49.05c.34,0,.65.14.96.28-.39.16-.7.02-.96-.28Z"
        />
        <path
          className="cls-2"
          d="m58.5,53.45c.21-.59.17-1.24.46-1.81.06-.11.08-.24.2-.3-.1.52-.18,1.04-.3,1.55-.05.21-.09.47-.36.56Z"
        />
        <path
          className="cls-2"
          d="m55.32,50.56c.03.17-.09.29-.14.44-.06.19-.06.36.1.52.17.17.31.03.46-.03.1.29.02.53-.24.7-.2.13-.36,0-.51-.11-.24-.18-.28-.42-.15-.67.14-.29.17-.64.47-.84Z"
        />
        <path
          className="cls-2"
          d="m52.68,49.92c.24-.42.26-.97.76-1.23-.18.46-.32.94-.76,1.23Z"
        />
        <path
          className="cls-2"
          d="m52.3,50.49c-.03-.14.06-.18.16-.21,0,.11-.05.19-.16.21Z"
        />
      </g>
      <g>
        <path
          className="cls-1"
          d="m11.32,58.54c.1.51.08,1.04.3,1.54.08.17.17.3.28.44.03.29.28.45.44.63.39.45.75.96,1.36,1.16,0,0,0,0,0,0,.44.4,1.01.44,1.55.59.27.22.62.13.92.22.17.18.38.13.58.12.05.01.1.03.16.04.13.29.39.14.59.16.43.01.87.02,1.3.03.43.23.89.13,1.35.15.15.01.31.03.46.04.59.36,1.26.31,1.92.34.06,0,.12.02.18.03.05.09.09.18.2.06,1.31.22,2.64.26,3.96.41.26.03.51.14.79.1.53.21,1.07.17,1.61.1.06,0,.11,0,.17,0,.05.04.1.1.14.11,1.17.03,2.3.36,3.47.33.71-.01,1.4.04,2.11.15-.28.07-.6-.02-.88.23.51,0,.98,0,1.45,0,.6-.01,1.22-.13,1.8-.14.86-.01,1.73,0,2.6.04.15,0,.32.07.44-.09.85.01,1.69.03,2.54.04.07.19.2.19.34.08,3.57.07,7.13.06,10.7-.03.1.12.19.11.28,0,1.68-.03,3.36-.05,5.03-.08.76.16,1.52.07,2.28.05.04,0,.08-.09.11-.13.63-.01,1.26-.02,1.88-.03.33.13.66.24.96-.07.09,0,.18,0,.27-.01,0,.16-.02.27-.22.28-.38.02-.75.05-1.13.1-.79.11-1.58.06-2.37.1-2.12.11-4.25.26-6.37.35-1.22.05-2.44,0-3.66.01-.82,0-1.65.08-2.46.06-1.18-.03-2.36-.01-3.55.01-2.15.05-4.29.13-6.44.17-1.62.04-3.24-.19-4.86-.31-.14-.01-.28-.07-.42.01-.06,0-.11,0-.17,0-.31-.21-.63-.13-.95-.05-.59-.04-1.18-.09-1.77-.13-.05-.12-.17-.12-.28-.14-.57-.08-1.14-.18-1.69-.35-.37-.12-.73-.16-1.11-.11-.35-.04-.69-.08-1.04-.12-.05-.08-.13-.08-.21-.05-.15-.01-.3-.03-.46-.04-.07-.09-.13-.08-.19,0-.87,0-1.71-.2-2.56-.33-.48-.07-.95-.16-1.43-.24-.05-.09-.13-.09-.21-.05-.14,0-.28-.01-.42-.02-.12-.16-.27-.14-.44-.08-.06-.01-.11-.02-.17-.04-.44-.12-.89-.21-1.35-.16-.46-.05-.92-.11-1.38-.16-.28-.22-.6-.14-.91-.1-.18,0-.35-.02-.53-.02-.1-.04-.2-.07-.29,0-.28-.02-.57-.03-.85-.05-.4-.31-.87-.38-1.35-.44-.86-.15-1.62-.53-2.34-.99-.23-.37-.25-.85-.65-1.13-.02-.05-.03-.1-.05-.15-.05-.29-.09-.58-.32-.79-.04-1.06.21-2.09.26-3.14.01-.26.02-.53.03-.79.17-.3.22-.61.12-.94,0-.09.02-.18.02-.27.25-.21.27-.48.18-.77,0-.06,0-.12.01-.17.13-.03.2-.09.07-.2.07-.25.13-.5.2-.75.13-.05.09-.13.05-.21,0-.06,0-.11.01-.17.13-.02.18-.09.21-.21.18-.61.4-1.22.55-1.83.11-.42.22-.84.16-1.28.05-.14.11-.29.16-.43.37-.18.31-.61.51-.89.14-.19.22-.44.53-.25-.11.31-.21.61-.32.92-.15.08-.22.17-.06.31-.08.27-.16.55-.24.82-.27.35-.33.75-.32,1.17-.03.09-.07.18-.1.26-.27.64-.4,1.31-.46,2-.01.06-.03.11-.04.17-.09.05-.09.12-.05.21-.01.12-.03.24-.04.36-.08.05-.09.12-.05.21-.01.06-.03.11-.04.17-.08.05-.09.13-.05.21-.02.09-.03.17-.05.26-.08.04-.1.1-.08.19-.12.82-.3,1.62-.3,2.45-.13.32-.14.63,0,.94Z"
        />
        <path
          className="cls-1"
          d="m27,51.83c-.65-.07-1.23-.42-1.88-.48-.07-.19-.19-.28-.4-.19-.05-.01-.1-.02-.16-.03-.17-.18-.42-.2-.63-.3-.12-.05-.35-.02-.29-.21.05-.16.24-.08.37-.04.78.28,1.63.31,2.39.66.33.15.68.25,1.03.32,1.58.35,3.22.25,4.81.55.05,0,.11-.04.17-.06.4.02.8.03,1.2.05.25.22.52.16.8.05.18.01.36.03.54.04.37.25.77.12,1.17.09.21,0,.43,0,.64,0,.07.14.17.2.32.09.15,0,.3,0,.45,0,.38.28.82.3,1.26.26.09,0,.17.01.26.02.07.15.17.2.31.08.05,0,.11.02.16.03.11.19.25.18.41.07l.48.1c.05.09.12.08.19.06.43.02.86.04,1.29.06.18.21.39.15.6.06.18,0,.36.02.54.03.18.21.39.15.6.07.28,0,.56.01.84.02.28.2.61.18.92.23.07.01.17.01.19-.09.02-.09-.05-.15-.12-.18-.71-.32-.74-1.05-.94-1.65-.08-.24-.18-.35-.38-.42.05-.2.29-.26.26-.47,0,0,0,0,0,0,.08-.01.18,0,.22-.04.59-.67,1.13-1.37,1.35-2.26.29-.63.55-1.28.69-1.96.26-.22.26-.56.36-.85.35-1.06.47-2.19,1.04-3.19.29-.51.62-.7,1.12-.6-.01.16-.32.21-.17.43-.22.43-.43.86-.65,1.29-.22.46-.38.93-.41,1.44-.13.43-.32.83-.42,1.27-.22.96-.47,1.9-.83,2.82-.6.9-.96,1.92-1.45,2.87-.16.51.18.66.57.77.05.09.12.09.2.06.19.04.37.08.56.12.06.09.13.09.21.04l.55.15c.47.29.93.6,1.53.54.5.05,1.01.1,1.51.15.12.24.14.43-.17.55-.1.04-.16.18-.24.27-.31.07-.61-.02-.92-.04-.09-.1-.19-.09-.3-.05-.12-.02-.24-.03-.36-.05-.46-.19-.92-.39-1.43-.35-.91-.11-1.82-.18-2.71-.36-.09-.12-.22-.1-.34-.11-1.7-.06-3.38-.26-5.05-.53-.38-.06-.79.1-1.19.15-.22-.01-.43-.03-.65-.04-.07-.24-.25-.18-.42-.14-.08,0-.16,0-.24,0-.36-.23-.99.21-1.17-.48,0,0-.06,0-.09,0-.45.21-.92.07-1.37.03-.69-.06-1.38,0-2.06-.05-.31,0-.62-.01-.94-.02-.11-.24-.29-.2-.48-.11-.05,0-.11-.01-.16-.02-.18-.2-.38-.16-.6-.07-.05,0-.11-.01-.16-.02-.3-.19-.63-.24-.98-.18-.05,0-.11,0-.16-.01-.08-.13-.18-.17-.32-.07-.05-.01-.1-.03-.16-.04-.06-.08-.12-.16-.22-.05-.05,0-.11-.02-.16-.02-.08-.13-.18-.17-.32-.07Z"
        />
        <path
          className="cls-1"
          d="m33.53,65.93c.14-.08.27-.02.42-.01,1.62.12,3.24.34,4.86.31,2.15-.05,4.29-.13,6.44-.17,1.18-.03,2.36-.04,3.55-.01.81.02,1.64-.05,2.46-.06,1.22,0,2.44.04,3.66-.01,2.12-.09,4.25-.24,6.37-.35.79-.04,1.58.01,2.37-.1.37-.05.75-.08,1.13-.1.2-.01.23-.13.22-.28.08,0,.16,0,.24-.01.38.42.92.25,1.37.28.95.07,1.91-.03,2.87-.06-.32.35-.78.3-1.17.33-1.32.09-2.61.38-3.93.49-.49.04-.97.1-1.46.1-1.47.01-2.92.22-4.38.26-1.35.04-2.71.07-4.07-.03-.52-.04-1.07,0-1.6.07-1.07.15-2.15.07-3.22.08-1.75.02-3.5.02-5.25,0-.45,0-.9,0-1.36,0-1.82-.02-3.63-.03-5.45-.1-1.1-.04-2.19-.17-3.29-.29-.26-.03-.57-.07-.76-.31Z"
        />
        <path
          className="cls-1"
          d="m68.22,50.62c.13,0,.25.02.38.02.54.28,1.14.28,1.72.35,1.13.23,2.27.46,3.41.61,1,.26,1.98.56,2.97.85.72.21,1.49.3,2.25.19.7.02,1.39.04,2.09.07.39.19.86.11,1.24.37.08.05.18.09.16.2-.02.1-.11.1-.19.1-1.27-.02-2.56.13-3.82-.07-1.1-.18-2.17-.47-3.27-.69-.6-.12-1.2-.24-1.82-.17-.09,0-.18-.01-.27-.02-.05-.19-.21-.22-.36-.25-.34-.06-.67-.13-1.01-.16-.82-.08-1.61-.32-2.44-.33-1.26-.22-2.52-.43-3.79-.65-.05-.1-.12-.12-.19-.02-.21-.02-.43-.03-.64-.05-.11-.18-.25-.17-.4-.05-.4-.05-.81-.1-1.21-.14-.05-.11-.11-.18-.21-.04-.12-.01-.24-.03-.36-.04-.07-.15-.17-.21-.3-.06-.12-.01-.24-.03-.36-.04-.05-.11-.1-.19-.21-.05-.25-.05-.5-.1-.74-.15-.45-.18-.63-.42-.24-.84.03-.04.02-.12.02-.18,1.65.41,3.33.65,5.02.81.09.13.19.16.31.04.18.02.36.03.54.05.06.09.12.15.22.04.12,0,.25.02.37.02.05.09.09.21.2.05.09.02.18.04.27.06.2.16.43.23.68.15Z"
        />
        <path
          className="cls-1"
          d="m59.39,55.33c-1.53-.07-3.03-.35-4.55-.47-.02-.16-.26-.23-.18-.43.22,0,.44.04.65.04.8,0,1.57.32,2.37.21.23.14.47.07.7,0,.05.01.1.02.16.04.05.09.11.12.19.03.12.01.24.02.36.04.05.1.1.18.2.04,1.03.09,2.05.33,3.07.37,2.77.12,5.54.25,8.31.01.35.08.68-.08,1.03-.08,1.77-.02,3.54.07,5.31-.08.49-.04,1-.04,1.46-.28.31-.08.62-.02.94-.07.95-.14,1.86-.51,2.83-.57.46.06.75-.25,1.07-.5.15-.12.3-.18.47-.07.07.05.21.07.19.18-.04.18-.22.2-.36.26-1.17.48-2.4.78-3.64,1.05-.13.03-.29-.02-.37.15-.69.25-1.41.32-2.13.39-1.94.19-3.89-.02-5.83.09-.22-.08-.45-.13-.66.03-.21.01-.43.02-.64.03-.59-.04-1.19-.14-1.77.09-1.33.09-2.65.07-3.98-.02-1-.07-2-.12-3-.21-.39-.04-.77-.11-1.16-.09-.16-.25-.36-.22-.56-.06-.06-.02-.11-.05-.17-.07-.08-.12-.18-.16-.31-.06Z"
        />
        <path
          className="cls-1"
          d="m38.21,50.15c.25,0,.51-.04.76.04.74.37,1.56.37,2.35.51.28.05.59.1.87-.04.05,0,.11,0,.16,0,.09.21.29.12.45.16.13.03.32.05.3.23-.02.16-.2.11-.31.12-.42.01-.84.01-1.26.02-.13-.01-.27.02-.38-.07-.09-.09-.19-.05-.29-.01-.15-.02-.31-.03-.46-.05-.04-.1-.12-.09-.2-.05-.12-.01-.24-.02-.35-.03-.02-.14-.12-.17-.24-.17-1.5-.04-2.98-.19-4.47-.37-1.86-.23-3.72-.47-5.58-.72-.92-.12-1.83-.3-2.77-.18-.06-.01-.11-.02-.17-.03-.06-.12-.19-.1-.29-.12-.63-.13-1.29-.19-1.89-.4-1.14-.4-2.24-.9-3.37-1.33-.5-.19-1.01-.38-1.57-.34-.09,0-.18,0-.27,0-.24-.27-.54-.31-.87-.2l-1.22-.18v-.33c.25,0,.5,0,.75,0,.06.08.12.09.19,0,.15.02.29.04.44.05.09.1.19.17.32.05.09,0,.17,0,.26.01.14.2.32.18.5.07.08.01.17.03.25.04.06.09.12.16.23.05.05.01.1.02.16.03.42.36.98.37,1.46.58.37.16.72.39,1.14.39.06,0,.11.02.17.03.68.41,1.41.66,2.2.73.55.17,1.12.19,1.68.23.05.11.11.19.21.04.18.02.36.05.54.07.03.04.06.1.09.1.84.08,1.67.16,2.51.24.3.01.61.02.91.03.4.43.9.19,1.37.23.09,0,.18.02.27.03.07.17.17.23.3.06.18.01.37.03.55.04.11.2.25.19.4.05,1.26.11,2.52.22,3.77.34.11.23.25.19.41.06Z"
        />
        <path
          className="cls-1"
          d="m69.47,65.35c-.96.03-1.92.13-2.87.06-.44-.03-.99.14-1.37-.28.07-.02.14-.04.21-.06.77.13,1.55.06,2.32,0,.22-.02.51.12.68-.16,1.37-.09,2.74-.22,4.09-.51.85-.18,1.72-.3,2.59-.36,1.28-.1,2.48-.45,3.66-.91.75-.3,1.54-.48,2.3-.75.85-.31,1.68-.68,2.52-1.01.85-.34,1.66-.77,2.5-1.15.34-.16.65-.36.93-.62.24.1.29-.22.5-.23-.02.14-.03.27-.05.4-.9.93-2.11,1.33-3.24,1.85-1.13.53-2.27,1.03-3.45,1.42-.76.25-1.51.55-2.32.66-.43-.02-.84.07-1.17.37-.05.02-.11.04-.16.05-.03,0-.06,0-.09,0-.03,0-.06,0-.09,0-.09,0-.2-.03-.28,0-.62.21-1.24.43-1.91.4-.09,0-.18.1-.28.15-.06.01-.12.02-.18.04-.1-.05-.21-.05-.31,0-1.18.06-2.3.42-3.45.61-.35.06-.72.04-1.08.05Z"
        />
        <path
          className="cls-1"
          d="m58.64,48.73c.28.1.55.21.83.31.23.26.03.47-.11.66-.13.18-.36.1-.52.02-.67-.32-1.33-.66-2-.99-.1-.07-.19-.13-.29-.2-.05-.12-.12-.21-.27-.19-.25-.19-.51-.38-.76-.57,0-.06,0-.14-.03-.18-.74-.83-1.52-1.63-2.47-2.24-.1-.12-.32-.11-.36-.3-.02-.17-.06-.33-.25-.4l-.12-.11c-.39-.53-.54-1.17-.78-1.77-.03-.07-.1-.14-.03-.21.09-.09.17,0,.24.05.25.18.37.51.71.58.41.51.82,1.01,1.23,1.52.02.15.11.25.26.28.08.09.15.18.23.26.03.21.16.34.37.38.1.1.19.19.29.29.2.21.33.5.66.56.16.16.32.32.48.48.16.16.31.36.5.48.47.3.8.84,1.43.9,0,0,0,0,0,0,.19.25.47.33.76.37Z"
        />
        <path
          className="cls-1"
          d="m17.15,46.6c0,.11,0,.22,0,.33-.27.02-.54.03-.9.05.89.74,1.87,1.04,2.83,1.39.54.2,1.12.34,1.57.74-.29,0-.65.12-.86,0-.92-.54-1.97-.75-2.91-1.25-.17-.09-.39-.19-.5.11-.34.02-.69-.08-.93-.26-.71-.5-1.32-.41-1.91.16-.31-.19-.39.06-.53.25-.21.28-.15.71-.51.89.11-1.38,1.36-2.37,2.61-2.29.48.03.92-.2,1.39-.19.22,0,.44.03.66.04Z"
        />
        <path
          className="cls-1"
          d="m32.42,52.06c-.06.02-.12.07-.17.06-1.59-.31-3.23-.2-4.81-.55-.35-.08-.7-.18-1.03-.32-.76-.35-1.61-.38-2.39-.66-.13-.05-.32-.12-.37.04-.05.19.17.16.29.21.21.09.46.12.63.3-.33.07-.63-.08-.89-.21-.62-.28-1.23-.55-1.89-.73-.12-.03-.25-.07-.3-.2.24-.12.58.27.71-.03.12-.27-.36-.28-.44-.52.34.03.7.01,1,.18,1.12.61,2.36.83,3.56,1.21.67.21,1.32.56,2,.61.84.06,1.68.17,2.52.26.53.06,1.11.02,1.58.37Z"
        />
        <path
          className="cls-1"
          d="m79.61,55.23c.08-.16.24-.12.37-.15,1.24-.27,2.46-.56,3.64-1.05.14-.06.33-.08.36-.26.02-.11-.12-.13-.19-.18-.17-.12-.32-.05-.47.07-.31.25-.6.56-1.07.5.07-.13.22-.12.32-.18.13-.08.35-.13.3-.31-.04-.15-.24-.11-.38-.11-.82,0-1.64-.02-2.47-.02-.71,0-1.41,0-2.12-.15-1.09-.24-2.2-.41-3.29-.65-.43-.09-.91-.01-1.29-.31.62-.07,1.22.05,1.82.17,1.09.21,2.17.51,3.27.69,1.26.2,2.55.05,3.82.07.08,0,.17,0,.19-.1.02-.11-.08-.15-.16-.2-.37-.26-.85-.18-1.24-.37.79-.2,1.51.05,2.21.38.48.22.94.47,1.33.89-.51.23-1.08.32-1.63.49-.95.29-1.91.55-2.88.74-.16.03-.31.07-.47.03Z"
        />
        <path
          className="cls-1"
          d="m52.43,43.2c-.34-.07-.46-.41-.71-.58-.08-.05-.15-.13-.24-.05-.07.07,0,.14.03.21.24.6.39,1.23.78,1.77-.13.05-.2-.04-.29-.1-.39-.27-.43-.71-.58-1.1-.47-1.26-1.42-1.72-2.41-1.17-.15-.22.15-.27.17-.43-.5-.1-.83.09-1.12.6-.57.99-.69,2.13-1.04,3.19-.1.29-.09.63-.36.85-.18-.18-.03-.36.02-.52.35-1.05.44-2.18.97-3.17.2-.37.35-.77.68-1.06.7-.64,1.54-.57,2.3-.26.82.34,1.32,1.11,1.8,1.84Z"
        />
        <path
          className="cls-1"
          d="m56.84,48.73c.66.33,1.33.67,2,.99.16.08.39.16.52-.02.14-.18.34-.4.11-.66.39.07.85-.03,1.15.35,0,.06.01.14-.02.18-.39.41-.21.66.24.84-.3.12-.53-.06-.78-.17,0-.05,0-.09.03-.14.11-.31-.15-.37-.33-.43-.25-.08-.25.12-.28.3-.04.23-.16.43-.29.63-.5.76-.76,1.63-.99,2.5-.08.31-.25.76.26.97.08.22-.12.41-.07.62-.23.06-.47.13-.7,0,.14-.25.21-.5.18-.79-.02-.18,0-.37.06-.55.29-.99.6-1.97,1.07-2.89.17-.34.07-.47-.24-.58-.34-.12-.69-.24-.99-.43-.27-.17-.45-.12-.65.06-.03-.23-.15-.38-.4-.4.04-.12.08-.25.12-.37Z"
        />
        <path
          className="cls-1"
          d="m54.66,54.43c-.08.2.16.27.18.43-.64-.09-1.3-.07-1.94-.24-.18-.05-.37-.03-.56,0-.68.14-1.37.14-2.05.04-.13-.02-.24-.05-.34-.15.08-.09.14-.24.24-.27.31-.12.29-.32.17-.55.08-.31.17-.61.44-.81-.02.14-.05.27-.07.41-.04.28.07.41.37.35.03.14,0,.33.24.32,1.13-.02,2.19.44,3.31.48Z"
        />
        <path
          className="cls-1"
          d="m40.58,65.32c-.12.16-.29.09-.44.09-.87-.03-1.74-.05-2.6-.04-.58,0-1.2.12-1.8.14-.47.01-.94,0-1.45,0,.28-.25.6-.15.88-.23-.7-.12-1.4-.17-2.11-.15-1.17.02-2.31-.31-3.47-.33-.05,0-.1-.07-.14-.11.95-.14,1.88.12,2.81.21.65.06,1.29.08,1.93.06,2.07-.05,4.11.32,6.18.27.08,0,.16.02.2.09Z"
        />
        <path
          className="cls-1"
          d="m41.53,51.2c.42,0,.84,0,1.26-.02.12,0,.3.05.31-.12.02-.18-.16-.2-.3-.23-.16-.04-.36.05-.45-.16.26-.09.54-.07.79,0,.43.11.84.08,1.25-.02.03.21-.21.26-.26.47.2.07.3.18.38.42.2.6.23,1.33.94,1.65.07.03.14.09.12.18-.02.1-.12.1-.19.09-.31-.05-.64-.03-.92-.23.1-.08.25.01.35-.13-.32-.3-.45-.69-.52-1.11-.07-.37-.26-.52-.64-.53-.59,0-1.19-.06-1.78-.09-.14,0-.3.03-.34-.16Z"
        />
        <path
          className="cls-1"
          d="m87.48,59.75c.02-.13.03-.26.05-.4-.21.02-.26.33-.5.23.44-.59.5-1.16.07-1.8-.38-.56-.53-1.24-.95-1.78-.22-.28-.47-.52-.47-.93.42.35.9.68,1.15,1.17.4.77.75,1.58,1.06,2.39.22.57.11.8-.41,1.12Z"
        />
        <path
          className="cls-1"
          d="m21.76,49.43c.08.24.56.26.44.52-.14.3-.47-.1-.71.03-.08-.02-.16-.04-.24-.06-.16-.2-.39-.21-.62-.2-.06-.01-.11-.03-.17-.04-.3-.36-.71-.4-1.14-.39-.41-.15-.82-.31-1.22-.46-.32-.4-.79-.5-1.26-.63-.15-.07-.31-.14-.46-.2.11-.3.33-.2.5-.11.94.49,1.99.7,2.91,1.25.21.12.57,0,.86,0,0,0,0,0,0,0,.26.29.56.43.95.27.06.01.11.03.17.04Z"
        />
        <path
          className="cls-1"
          d="m37.64,53.18c.4-.06.81-.21,1.19-.15,1.68.27,3.35.47,5.05.53.12,0,.26-.02.34.11-.87.12-1.74.11-2.59-.05-1.04-.2-2.1-.15-3.14-.27-.29-.03-.59,0-.86-.16Z"
        />
        <path
          className="cls-1"
          d="m31.65,52.52c.69.04,1.37,0,2.06.05.44.04.92.18,1.37-.03.03-.01.09,0,.09,0,.17.68.81.24,1.17.48-.08.17-.24.13-.37.12-.97-.08-1.94-.1-2.9-.29-.35-.07-.71-.11-1.07-.15-.15-.01-.28-.03-.35-.18Z"
        />
        <path
          className="cls-1"
          d="m78.95,52.63c-.77.11-1.53.02-2.25-.19-.99-.29-1.97-.58-2.97-.85.05-.1.16-.12.24-.09.67.23,1.38.3,2.06.49.88.24,1.78.36,2.68.53.09.02.19,0,.24.11Z"
        />
        <path
          className="cls-1"
          d="m12.32,49.46c.06.44-.06.87-.16,1.28-.16.62-.37,1.22-.55,1.83-.04.12-.09.19-.21.21-.02-.04-.06-.09-.05-.12.21-.9.43-1.79.63-2.69.05-.23.15-.4.35-.52Z"
        />
        <path
          className="cls-1"
          d="m42.2,50.67c-.28.14-.59.09-.87.04-.79-.14-1.61-.14-2.35-.51.33-.24.62.05.93.08.72.06,1.44.18,2.15.28.05,0,.09.07.14.11Z"
        />
        <path
          className="cls-1"
          d="m45.97,48.34c-.21.89-.75,1.59-1.35,2.26-.04.04-.15.03-.22.04.55-.68.99-1.42,1.37-2.21.02-.05.13-.06.2-.09Z"
        />
        <path
          className="cls-1"
          d="m74.49,64.65c.09-.05.19-.15.28-.15.67.03,1.29-.19,1.91-.4.08-.03.19,0,.28,0-.18.43-.55.47-.95.5-.51.04-1.01.2-1.52.05Z"
        />
        <path
          className="cls-1"
          d="m68.44,64.9c-.17.28-.46.14-.68.16-.77.06-1.55.14-2.32,0,.04-.03.07-.08.11-.08.97,0,1.92-.21,2.89-.08Z"
        />
        <path
          className="cls-1"
          d="m27.57,65.15c.38-.05.74,0,1.11.11.55.17,1.12.27,1.69.35.11.02.22.01.28.14-.69.13-1.33-.14-1.97-.3-.37-.09-.79,0-1.1-.3Z"
        />
        <path
          className="cls-1"
          d="m57.88,48.35c-.63-.06-.95-.59-1.43-.9-.19-.12-.33-.32-.5-.48.15-.01.27.03.38.13.5.43,1.11.74,1.54,1.26Z"
        />
        <path
          className="cls-1"
          d="m30.23,49.33c-.84-.08-1.67-.16-2.51-.24-.03,0-.06-.07-.09-.1.84-.12,1.66.07,2.49.21.04,0,.07.09.11.14Z"
        />
        <path
          className="cls-1"
          d="m13.71,62.31c-.61-.2-.97-.71-1.36-1.16-.16-.19-.41-.34-.44-.63.52.22.72.76,1.12,1.12.23.21.61.3.68.67Z"
        />
        <path
          className="cls-1"
          d="m22.83,47.88c-.42,0-.78-.23-1.14-.39-.48-.21-1.04-.22-1.46-.58.71.05,1.34.37,1.99.61.22.08.52.06.61.36Z"
        />
        <path
          className="cls-1"
          d="m12.03,53.38c.06-.69.18-1.36.46-2,.05.04.14.08.13.1-.16.65-.17,1.34-.59,1.9Z"
        />
        <path
          className="cls-1"
          d="m61.87,65.25s-.07.13-.11.13c-.76.01-1.52.11-2.28-.05.19-.2.44-.1.66-.1.58,0,1.15.01,1.73.02Z"
        />
        <path
          className="cls-1"
          d="m22.54,63.99c-.65-.04-1.32.02-1.92-.34.5.05,1.01.11,1.51.16.15.02.32,0,.4.18Z"
        />
        <path
          className="cls-1"
          d="m25.2,48.64c-.79-.07-1.52-.32-2.2-.73.77.14,1.5.39,2.2.73Z"
        />
        <path
          className="cls-1"
          d="m68.57,55.86c.58-.23,1.17-.13,1.77-.09-.58.23-1.17.12-1.77.09Z"
        />
        <path
          className="cls-1"
          d="m70.32,50.99c-.58-.07-1.18-.07-1.72-.35.59.01,1.19.02,1.72.35Z"
        />
        <path
          className="cls-1"
          d="m29.28,64.68c-.54.08-1.09.11-1.61-.1.54-.03,1.09-.08,1.61.1Z"
        />
        <path
          className="cls-1"
          d="m10.81,61.15c.39.28.42.76.65,1.13-.42-.14-.73-.68-.65-1.13Z"
        />
        <path
          className="cls-1"
          d="m19.31,49.28c.43-.01.84.03,1.14.39-.43,0-.82-.09-1.14-.39Z"
        />
        <path
          className="cls-1"
          d="m46.94,54.03c.52-.04.97.16,1.43.35-.53.1-.98-.11-1.43-.35Z"
        />
        <path
          className="cls-1"
          d="m15.26,62.9c-.54-.14-1.11-.18-1.55-.59.53.17,1.1.22,1.55.59Z"
        />
        <path
          className="cls-1"
          d="m32.51,49.59c-.46-.04-.97.2-1.37-.23.45.1.95-.07,1.37.23Z"
        />
        <path
          className="cls-1"
          d="m16.83,48.19c.46.13.93.23,1.26.63-.48-.09-.91-.28-1.26-.63Z"
        />
        <path
          className="cls-1"
          d="m19.1,64.03c.46-.05.91.04,1.35.16-.47.16-.92.06-1.35-.16Z"
        />
        <path
          className="cls-1"
          d="m13.79,63.27c.48.07.95.14,1.35.44-.47-.09-.96-.13-1.35-.44Z"
        />
        <path
          className="cls-1"
          d="m20.16,63.61c-.45-.01-.92.09-1.35-.15.46-.03.92-.1,1.35.15Z"
        />
        <path
          className="cls-1"
          d="m12.58,51.11c0-.42.05-.82.32-1.17-.03.41-.04.83-.32,1.17Z"
        />
        <path
          className="cls-1"
          d="m77.31,64.05c.33-.3.74-.38,1.17-.37-.35.26-.75.34-1.17.37Z"
        />
        <path
          className="cls-1"
          d="m10.85,55.34c.11.33.05.64-.12.94-.14-.34-.08-.65.12-.94Z"
        />
        <path
          className="cls-1"
          d="m11.32,58.54c-.15-.31-.14-.63,0-.94.17.31.15.63,0,.94Z"
        />
        <path
          className="cls-1"
          d="m64.72,65.15c-.3.31-.63.2-.96.07.31-.18.64-.08.96-.07Z"
        />
        <path
          className="cls-1"
          d="m32.42,65.88c.32-.08.64-.16.95.05-.32.09-.64.13-.95-.05Z"
        />
        <path
          className="cls-1"
          d="m28.33,52.09c.35-.06.68,0,.98.18-.35.07-.68,0-.98-.18Z"
        />
        <path
          className="cls-1"
          d="m58.64,48.73c-.29-.04-.57-.12-.76-.37.31,0,.59.09.76.37Z"
        />
        <path
          className="cls-1"
          d="m16.82,63.77c.31-.04.63-.12.91.1-.31.04-.63.12-.91-.1Z"
        />
        <path
          className="cls-1"
          d="m55.48,46.49c-.33-.05-.46-.35-.66-.56.38,0,.55.25.66.56Z"
        />
        <path
          className="cls-1"
          d="m10.44,60.2c.24.21.27.5.32.79-.53-.09-.25-.51-.32-.79Z"
        />
        <path
          className="cls-1"
          d="m68.22,50.62c-.26.07-.48,0-.68-.15.24,0,.52-.16.68.15Z"
        />
        <path
          className="cls-1"
          d="m11.05,54.3c.09.29.07.55-.18.77-.04-.28,0-.54.18-.77Z"
        />
        <path
          className="cls-1"
          d="m70.98,55.73c.22-.16.44-.11.66-.03-.22.13-.44.11-.66.03Z"
        />
        <path
          className="cls-1"
          d="m17.51,63.43c-.21-.02-.46.13-.59-.16.21,0,.45-.11.59.16Z"
        />
        <path
          className="cls-1"
          d="m16.76,63.23c-.2.01-.42.06-.58-.12.21-.03.45-.22.58.12Z"
        />
        <path
          className="cls-1"
          d="m29.47,52.3c.21-.09.42-.12.6.07-.21.05-.42.1-.6-.07Z"
        />
        <path
          className="cls-1"
          d="m59.87,55.46c.21-.15.4-.18.56.06-.19,0-.39.07-.56-.06Z"
        />
        <path
          className="cls-1"
          d="m20.62,49.72c.23-.01.46,0,.62.2-.25.06-.45,0-.62-.2Z"
        />
        <path
          className="cls-1"
          d="m54.52,45.65c-.21-.04-.34-.17-.37-.38.24.02.37.13.37.38Z"
        />
        <path
          className="cls-1"
          d="m19.59,46.78c-.19.1-.36.12-.5-.07.18-.05.36-.1.5.07Z"
        />
        <path
          className="cls-1"
          d="m30.23,52.39c.19-.08.37-.13.48.11-.17.02-.35.03-.48-.11Z"
        />
        <path
          className="cls-1"
          d="m20.62,64.23c.16-.05.32-.08.44.08-.17.09-.32.11-.44-.08Z"
        />
        <path
          className="cls-1"
          d="m36.58,53.01c.17-.05.34-.11.42.14-.17.04-.33.06-.42-.14Z"
        />
        <path
          className="cls-1"
          d="m34.03,49.76c-.15.14-.29.14-.4-.05.14-.05.28-.08.4.05Z"
        />
        <path
          className="cls-1"
          d="m24.73,51.16c.21-.09.33,0,.4.19-.16,0-.31-.04-.4-.19Z"
        />
        <path
          className="cls-1"
          d="m38.21,50.15c-.16.14-.3.17-.41-.06.14-.05.29-.1.41.06Z"
        />
        <path
          className="cls-1"
          d="m53.92,45c-.15-.04-.24-.13-.26-.28.21-.02.31.07.26.28Z"
        />
        <path
          className="cls-1"
          d="m27,51.83c.13-.1.23-.06.32.07-.12.06-.23.06-.32-.07Z"
        />
        <path
          className="cls-1"
          d="m54.45,65.41c-.09.12-.19.13-.28,0,.09-.12.19-.12.28,0Z"
        />
        <path
          className="cls-1"
          d="m65.94,50.24c-.12.12-.22.09-.31-.04.11-.04.22-.08.31.04Z"
        />
        <path
          className="cls-1"
          d="m43.46,65.45c-.15.1-.27.1-.34-.08.14-.06.26-.07.34.08Z"
        />
        <path
          className="cls-1"
          d="m18.83,46.7c-.13.12-.23.05-.32-.05.12-.08.23-.09.32.05Z"
        />
        <path
          className="cls-1"
          d="m48.73,54.42c.11-.05.22-.05.3.05-.13.14-.22.11-.3-.05Z"
        />
        <path
          className="cls-1"
          d="m27.86,52.01c.13-.1.23-.06.32.07-.12.06-.23.06-.32-.07Z"
        />
        <path
          className="cls-1"
          d="m74,64.68c.1-.05.21-.05.31,0-.01.11-.07.17-.18.16-.1-.01-.12-.08-.13-.17Z"
        />
        <path
          className="cls-1"
          d="m13.14,49.12c-.16-.14-.09-.23.06-.31.03.11.1.23-.06.31Z"
        />
        <path
          className="cls-1"
          d="m59.39,55.33c.13-.09.23-.05.31.06-.12.04-.22.04-.31-.06Z"
        />
        <path
          className="cls-1"
          d="m15.99,63.76c.1-.08.19-.05.29,0-.09.17-.19.21-.29,0Z"
        />
        <path
          className="cls-1"
          d="m33.08,49.67c-.14.17-.23.11-.3-.06.11-.04.22-.06.3.06Z"
        />
        <path
          className="cls-1"
          d="m11.38,52.96c.04.08.08.17-.05.21-.15-.11-.09-.17.05-.21Z"
        />
        <path
          className="cls-1"
          d="m27.1,48.91c-.1.15-.16.07-.21-.04.08-.04.16-.05.21.04Z"
        />
        <path
          className="cls-1"
          d="m22.92,64.08c-.11.12-.15.03-.2-.06.08-.03.16-.03.2.06Z"
        />
        <path
          className="cls-1"
          d="m11.93,53.75c-.04-.08-.03-.16.05-.21.13.11.06.16-.05.21Z"
        />
        <path
          className="cls-1"
          d="m66.7,50.33c-.1.11-.16.05-.22-.04.08-.04.16-.06.22.04Z"
        />
        <path
          className="cls-1"
          d="m21.47,64.33c.08-.04.16-.04.21.05-.11.13-.16.05-.21-.05Z"
        />
        <path
          className="cls-1"
          d="m67.27,50.4c-.11.16-.15.04-.2-.05.08-.03.15-.05.2.05Z"
        />
        <path
          className="cls-1"
          d="m18.08,46.59c-.06.09-.13.08-.19,0,.06-.1.13-.11.19,0Z"
        />
        <path
          className="cls-1"
          d="m25.67,64.94c.06-.09.12-.1.19,0-.06.1-.12.08-.19,0Z"
        />
        <path
          className="cls-1"
          d="m11.13,53.92c.13.12.07.17-.07.2-.04-.09-.03-.16.07-.2Z"
        />
        <path
          className="cls-1"
          d="m26.32,64.98c.08-.04.15-.04.21.05-.11.14-.16.06-.21-.05Z"
        />
        <path
          className="cls-1"
          d="m20.07,46.88c-.1.1-.17.04-.23-.05.09-.06.17-.04.23.05Z"
        />
        <path
          className="cls-1"
          d="m11.84,54.32c-.03-.08-.03-.15.05-.21.13.11.05.16-.05.21Z"
        />
        <path
          className="cls-1"
          d="m11.75,54.7c-.04-.08-.03-.16.05-.21.12.1.05.16-.05.21Z"
        />
        <path
          className="cls-1"
          d="m11.61,55.15c-.02-.08,0-.15.08-.19.15.14,0,.15-.08.19Z"
        />
        <path
          className="cls-1"
          d="m27.48,51.92c.11-.11.17-.03.22.05-.09.05-.17.04-.22-.05Z"
        />
        <path
          className="cls-1"
          d="m77.05,64.1s.06,0,.09,0c0,.02-.02.04-.03.07-.02-.02-.04-.04-.07-.06Z"
        />
        <path
          className="cls-1"
          d="m46.69,48.99c.17.39-.14.66-.29.94-.25.47-.47.95-.67,1.44-.1.24-.2.46-.49.49.49-.95.85-1.97,1.45-2.87Z"
        />
        <path
          className="cls-1"
          d="m47.33,53c.06-.1.17-.12.25-.08.43.2.86.41,1.28.62-.6.06-1.06-.25-1.53-.54Z"
        />
        <path
          className="cls-1"
          d="m48.36,43.46c.03.53-.14,1-.41,1.44.03-.51.18-.99.41-1.44Z"
        />
        <path
          className="cls-1"
          d="m37.52,52.36c.43.05.88-.01,1.26.26-.45.04-.88.02-1.26-.26Z"
        />
        <path
          className="cls-1"
          d="m34.95,52.19c.39-.03.8-.18,1.17.09-.39.03-.8.16-1.17-.09Z"
        />
        <path
          className="cls-1"
          d="m33.62,52.1c.27-.07.54-.11.8.05-.27.1-.54.17-.8-.05Z"
        />
        <path
          className="cls-1"
          d="m41.88,53.03c.21-.05.42-.12.6.06-.21.09-.42.14-.6-.06Z"
        />
        <path
          className="cls-1"
          d="m43.02,53.13c.21-.04.42-.11.6.07-.21.07-.42.14-.6-.07Z"
        />
        <path
          className="cls-1"
          d="m39.51,52.75c.15-.04.3-.08.41.07-.16.11-.3.12-.41-.07Z"
        />
        <path
          className="cls-1"
          d="m39.04,52.64c.12-.05.23-.05.31.08-.14.13-.24.07-.31-.08Z"
        />
        <path
          className="cls-1"
          d="m36.75,52.28c.13-.05.24-.06.32.09-.15.12-.24.06-.32-.09Z"
        />
        <path
          className="cls-1"
          d="m45.81,52.62c.11-.13.17-.06.2.06-.08.04-.16.03-.2-.06Z"
        />
        <path
          className="cls-1"
          d="m40.4,52.92c.13-.2.15-.04.19.06-.08.02-.15.03-.19-.06Z"
        />
        <path
          className="cls-1"
          d="m46.57,52.81c.1-.13.16-.07.21.04-.08.05-.16.05-.21-.04Z"
        />
        <path
          className="cls-1"
          d="m73.07,52.42c-.81-.01-1.6-.2-2.39-.36-.48-.1-1-.05-1.42-.37.83.01,1.62.25,2.44.33.34.03.68.1,1.01.16.15.03.31.06.36.25Z"
        />
        <path
          className="cls-1"
          d="m64.63,50.97c-.14.04-.28.07-.4-.05.15-.12.29-.13.4.05Z"
        />
        <path
          className="cls-1"
          d="m62.44,50.7c-.11.04-.22.06-.3-.06.13-.14.23-.09.3.06Z"
        />
        <path
          className="cls-1"
          d="m63.02,50.78c-.08.05-.16.05-.21-.04.1-.14.16-.07.21.04Z"
        />
        <path
          className="cls-1"
          d="m61.78,50.6c-.08.04-.16.04-.21-.05.1-.14.16-.06.21.05Z"
        />
        <path
          className="cls-1"
          d="m65.47,51.03c-.07.08-.13.07-.19-.02.07-.1.13-.09.19.02Z"
        />
        <path
          className="cls-1"
          d="m70.68,55.22c0-.27.14-.35.39-.35,1.17,0,2.35.04,3.52-.03.88-.05,1.77-.02,2.66-.11.39-.04.83-.14,1.23.05-.46.24-.97.24-1.46.28-1.77.14-3.54.06-5.31.08-.35,0-.68.16-1.03.08Z"
        />
        <path
          className="cls-1"
          d="m59.09,54.79c.08-.03.15-.03.2.04-.1.13-.16.06-.2-.04Z"
        />
        <path
          className="cls-1"
          d="m58.54,54.72c.08-.07.14-.06.19.03-.08.09-.14.06-.19-.03Z"
        />
        <path
          className="cls-1"
          d="m39.84,50.98c-1.46,0-2.91-.14-4.36-.31-.93-.11-1.87-.17-2.8-.32-1.18-.19-2.36-.36-3.54-.51-.62-.08-1.25-.11-1.88-.17-.16-.02-.36.06-.47-.13.94-.12,1.85.06,2.77.18,1.86.24,3.72.48,5.58.72,1.48.18,2.97.34,4.47.37.12,0,.22.03.24.17Z"
        />
        <path
          className="cls-1"
          d="m26.62,49.5c-.51.14-.98-.09-1.46-.15-.67-.09-1.3-.35-1.92-.61-1.2-.5-2.38-1.03-3.65-1.33-.03,0-.06-.07-.09-.1.56-.04,1.07.15,1.57.34,1.13.43,2.23.93,3.37,1.33.6.21,1.26.27,1.89.4.1.02.23,0,.29.12Z"
        />
        <path
          className="cls-1"
          d="m19.23,47.31c-.3-.02-.6-.03-.87-.2.33-.11.63-.07.87.2Z"
        />
        <path
          className="cls-1"
          d="m41.15,51.12c-.1.19-.2.17-.29-.01.1-.04.2-.08.29.01Z"
        />
        <path
          className="cls-1"
          d="m40.39,51.06c-.11.14-.16.08-.2-.05.08-.04.15-.05.2.05Z"
        />
        <path
          className="cls-1"
          d="m55.52,47.77c-.24.01-.34-.2-.49-.32-.15-.12-.2-.15-.32.08-.18.34-.37.71-.72.93-.04-.28.14-.46.28-.67.08-.11.14-.22,0-.33-.14-.1-.27-.02-.31.09-.17.4-.51.67-.74,1.02-.35.51-.61,1.1-1.14,1.48,0-.06-.01-.14.02-.18.46-.73.9-1.48,1.41-2.18.2-.27.29-.65.69-.79.16-.05-.05-.23-.14-.32-.36-.4-.78-.75-1.04-1.24.95.61,1.72,1.41,2.47,2.24.03.04.02.12.03.18Z"
        />
        <path
          className="cls-1"
          d="m52.66,45.05c-.24-.03-.27-.2-.25-.39.19.06.23.22.25.39Z"
        />
        <path
          className="cls-1"
          d="m56.56,48.53c-.15.02-.27,0-.27-.19.15-.02.22.07.27.19Z"
        />
        <path
          className="cls-1"
          d="m60.05,50.24c-.37.29-.48.73-.67,1.13-.13.06-.14.18-.2.29-.29.56-.25,1.2-.46,1.78-.04.23-.14.43-.28.61-.51-.21-.34-.66-.26-.97.23-.87.48-1.73.99-2.5.13-.2.25-.4.29-.63.03-.18.03-.38.28-.3.18.06.44.12.33.43-.02.04-.02.09-.03.14Z"
        />
        <path
          className="cls-1"
          d="m57.12,49.5c-.31.54-.6,1.09-.93,1.62-.08.13-.12.28-.19.41-.15.06-.29.2-.46.03-.16-.15-.16-.32-.1-.51.05-.14.16-.27.14-.43.26-.41.54-.8.77-1.23.09-.18.21-.25.38-.29.25.02.37.17.4.4Z"
        />
        <path
          className="cls-1"
          d="m52.08,50.06c.53-.38.79-.97,1.14-1.48.24-.35.57-.62.74-1.02.05-.11.18-.2.31-.09.13.1.07.21,0,.33-.14.2-.33.39-.28.67l-.27.3c-.5.26-.52.8-.76,1.22-.07.12-.14.24-.21.36-.1.03-.19.07-.16.21-.49,1.03-.98,2.05-1.47,3.08-.3.06-.41-.07-.37-.35.02-.14.04-.27.07-.41.42-.94.66-1.96,1.27-2.81Z"
        />
        <path
          className="cls-1"
          d="m20.64,49.12c.34,0,.65.14.95.27-.39.16-.69.02-.95-.27Z"
        />
        <path
          className="cls-1"
          d="m58.72,53.45c.21-.58.17-1.22.46-1.78.06-.11.08-.23.2-.29-.1.51-.18,1.02-.3,1.53-.05.21-.09.46-.36.55Z"
        />
        <path
          className="cls-1"
          d="m55.57,50.61c.03.17-.09.29-.14.43-.06.19-.06.36.1.51.17.17.31.03.46-.03.09.29.02.52-.24.68-.2.13-.35,0-.5-.11-.24-.18-.28-.41-.15-.66.14-.28.17-.63.47-.83Z"
        />
        <path
          className="cls-1"
          d="m52.95,49.98c.24-.41.26-.96.76-1.22-.18.45-.32.93-.76,1.22Z"
        />
        <path
          className="cls-1"
          d="m52.57,50.55c-.03-.13.06-.18.16-.21,0,.11-.05.18-.16.21Z"
        />
      </g>
    </Icon>
  );
}

export function IconLeather({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="30 28 39 48"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #7d7d7d; }`}
          {`.cls-2 { fill: #2c2c2c; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m62.09,62.24c-.13-.12-.17-.3-.26-.44.09-.11.1-.19-.07-.21-.08-.08-.05-.18-.05-.27.03-.06.01-.1-.04-.13-.11-.48-.22-.97-.33-1.45.01-.01.03-.02.04-.04-.01,0-.03-.01-.04-.02,0-.13-.01-.25-.02-.38.05,0,.15,0,.13-.05-.15-.33,0-.67-.07-1,0-.01,0-.03.01-.04.06,0,.12-.02.09-.09-.06-.15-.04-.29,0-.44.02-.06.04-.15-.07-.17,0-.03,0-.07,0-.1.12,0,.11-.09.12-.17,0-.11.02-.22.03-.32.05-.52.17-1.02.29-1.53.02-.09,0-.18.05-.26.11-.09.08-.19.04-.29,0-.03,0-.06.01-.09.09-.03.1-.11.12-.19.06-.23.12-.47.2-.69.15-.39.22-.8.43-1.17.22-.38.23-.84.4-1.25.11-.25.25-.5.32-.77,0-.11-.03-.23.05-.33.2-.05.17-.26.23-.38.11-.23.34-.43.3-.72,0-.01,0-.03.02-.04.08-.1.22-.18.14-.35,0-.03,0-.06,0-.09.1-.12.23-.23.31-.36.27-.48.5-1,.8-1.46.24-.35.37-.76.68-1.08.14-.14.31-.3.38-.5.04-.13.09-.25.21-.33.08-.06.15-.13.13-.25.11-.12.21-.24.32-.36.08-.02.14-.07.13-.16.12-.21.29-.37.48-.51.16.04.4-.09.47.19-.19.41-.46.76-.77,1.08-.18.19-.18.48-.4.64-.2.18-.36.4-.42.67-.06.12-.12.24-.18.36-.26.15-.41.38-.46.68-.19.46-.44.89-.69,1.31-.33.56-.56,1.16-.86,1.74-.48.92-.84,1.9-1.2,2.87-.04.12-.16.21-.16.36-.09.05-.21.08-.11.22,0,.03,0,.07-.01.1-.13.06-.18.15-.1.28-.18.56-.38,1.12-.53,1.69-.12.47-.2.95-.28,1.43-.11.62-.19,1.25-.24,1.88-.01.15.06.31-.03.45-.01.01-.03.02-.04.03.01,0,.02.01.04.02.01.01.02.03.01.04,0,.11-.1.26.1.3.07.19.08.41.09.6.03.54.23,1,.56,1.42.07.09.17.15.26.22.3.22.51.53.82.73.06.2-.06.28-.22.33-.15,0-.18-.13-.26-.2-.22-.2-.44-.42-.66-.62,0-.19-.07-.32-.28-.31Z"
      />
      <path
        className="cls-2"
        d="m56.78,31.39c-.18-.36-.15-.75-.2-1.13.09-.04.08-.08,0-.12-.01-.03-.03-.06-.04-.1.08-.04.08-.07,0-.11,0-.07.02-.14.03-.21.14-.04.05-.17.09-.25.09-.17.03-.48.37-.46.14.49.1,1,.23,1.49.17.63.32,1.27.6,1.87.04.25.21.47.23.73,0,.11.13.07.2.09,0,.01.01.03.02.04-.01.08,0,.15.09.18,0,.01,0,.03.01.04-.01.09,0,.16.1.17,0,.09.1.17.04.27-.02.14,0,.24.16.26.08,0,.16.03.17.1.02.21.15.11.25.09.23.32.41.67.68.97.05.08.1.17.16.24.08.08.09.26.27.19h0c0,.09-.01.19.13.12,0,0,.02.02.02.02-.04.04-.12.12-.06.14.2.08.31.37.59.29.01,0,.03,0,.04.02,0,.1.04.18.16.16.09.05.19.1.28.15,0,.13.07.13.16.11.05.04.11.07.16.11-.01.1.03.13.12.09,0,0,.01.01.01.01-.05.19.09.16.2.17.09.04.17.08.26.12.2.21.46.32.73.41.03,0,.06,0,.09.01.03.04.06.09.1.12.26.13.51.3.79.35.29.06.49.29.78.31.08.16.27.16.39.18.3.05.59.18.9.23.23.03.55.07.77.33-.42.07-.8.02-1.18.01-.11-.22-.26-.22-.44-.09-.03-.01-.07-.02-.1-.03-.03-.06.08-.15-.04-.18-.1-.03-.17.02-.19.13-.07,0-.14-.02-.22-.02-.03-.05-.05-.09-.11-.03-.86-.23-1.69-.54-2.5-.92-.12-.14-.23-.3-.46-.22-.02,0-.03-.02-.03-.03.02-.21-.14-.1-.22-.13h0c-.08-.24-.29-.28-.49-.32h0c0-.11-.08-.12-.16-.11h0c-.04-.16-.09-.32-.3-.33-.08,0-.13-.06-.17-.12-.13-.23-.4-.3-.55-.51-.06-.09-.17-.04-.25,0-.09-.05-.18-.11-.24-.2,0-.14-.03-.24-.19-.24-.08-.17-.26-.26-.32-.44,0-.05,0-.07-.06-.05,0,0,0,0,0,0,0-.12.03-.26-.11-.33-.18-.09-.23-.21-.13-.39.04-.08.1-.2-.09-.2-.01,0-.03,0-.04,0,.04-.15-.36-.19-.09-.4-.02-.02-.03-.06-.05-.06-.23,0-.31-.24-.49-.32-.01-.03-.02-.05-.04-.08.02-.06.02-.1-.04-.13,0-.04,0-.07,0-.11,0,0,.02,0,.03,0,0,0,.01-.02.01-.02-.14-.21-.29-.43-.43-.64-.02-.03-.03-.06-.05-.09,0-.24-.12-.46-.16-.69-.03-.19-.01-.39-.21-.52Z"
      />
      <path
        className="cls-2"
        d="m35.05,50.78c-.19-.39-.47-.72-.72-1.05-.29-.39-.55-.8-.85-1.18-.37-.47-.85-.83-1.22-1.29-.07-.09-.22-.08-.29-.18-.06-.21.07-.23.22-.22.26.13.41.39.65.52.39.2.62.58.91.87.28.29.55.63.78.99.14.22.23.48.46.66.2.16.25.47.42.68.04.05.12.07.14.14-.02.02-.07.06-.07.07.04.06.09.03.13,0,0,0,.02.02.02.02-.02.04-.05.08-.05.12,0,.07-.17.06-.08.15.05.05.13.11.22.08.04-.01.08-.04.12-.06.02,0,.03.01.03.03-.03.1-.14.12-.2.21.23.03.22.28.35.36.46.3.46.86.76,1.25.01.02.01.05,0,.08-.06.2.08.23.22.25.1.27.19.54.29.81.02.13-.1.31.13.36,0,0,0,0,0,0-.13.38.22.74.04,1.12.27.13.15.4.19.6.11.53.18,1.07.17,1.62,0,.18-.11.43.11.59,0,.05,0,.1.01.16-.06.24-.11.48.03.71,0,.16,0,.32,0,.48-.04,0-.08.02-.08.06-.03.49-.05.99-.07,1.48,0,.08,0,.15.11.16-.12,1.34-.41,2.65-.7,3.96-.11,0-.11.08-.11.16h0c-.15.02-.1.13-.11.22-.1.09-.22.16-.21.33-.08.03-.14.07-.11.17-.04.07-.09.13-.17.15-.09-.08-.17-.08-.22.05-.13.3-.14.3-.35.05.07-.26.13-.54.34-.74.14.02.2-.04.18-.19-.01-.11-.01-.21.09-.29.27-.22.26-.52.23-.83,0-.02.01-.03.02-.05.12-.08.2-.19.26-.33.06-.14.1-.33.17-.4.25-.24.21-.54.19-.8-.06-.57,0-1.1.21-1.63.06-.15.04-.3.03-.45-.03-.36-.14-.73.08-1.07.03-.04.05-.08.01-.12-.04-.05-.08,0-.12.02-.04.03-.08.05-.1,0,.1-.35-.06-.69-.03-1.03.05-.57-.09-1.13-.07-1.7,0-.16.01-.35-.17-.45-.02-.03-.04-.06-.05-.09.11-.05.1-.11,0-.17,0-.02,0-.04.01-.06,0-.25,0-.49-.15-.7,0-.31-.25-.56-.25-.87.05-.02.08-.05.06-.1-.09-.22-.17-.45-.22-.69-.02-.08-.07-.19-.19-.2.03-.13-.1-.21-.12-.32.07-.17-.09-.36.06-.53.02-.02-.38-.38-.44-.38-.24-.28-.32-.65-.54-.94-.05-.06-.08-.14-.12-.21,0-.07,0-.12-.09-.13-.01,0-.02-.02-.03-.03-.02-.11,0-.25-.17-.27Zm1.88,14.2c.13,0,.25.02.29-.12.01-.04-.02-.1-.07-.1-.12,0-.19.08-.22.22Z"
      />
      <path
        className="cls-2"
        d="m49.41,73.61c.02.1.11.11.17.16.1.3.2.59.5.75.12.21.23.42.26.67-.04.09.09.21-.04.26-.13.06-.15-.1-.23-.14-.02,0-.03-.02-.05-.03-.37-.54-.73-1.09-1.25-1.51-.18-.15-.4-.26-.6-.39-.11-.28-.33-.39-.6-.43-.38-.29-.81-.48-1.24-.67-.48-.22-1.01-.31-1.48-.55-.28-.14-.6-.18-.91-.26-.01-.03-.02-.08-.04-.09-.25-.18-.54-.26-.82-.37-.12-.05-.35-.08-.34.19-.51-.08-1.03-.06-1.54-.13-.57-.08-1.15.05-1.72.06-.04-.05-.08-.05-.11.01-.07,0-.14,0-.22.01-.07-.08-.12-.04-.17.03-.2.15-.44.04-.65.07-.03,0-.07-.03-.08-.06-.01-.05.04-.07.08-.09.38-.21.79-.31,1.2-.44.44-.14.89-.13,1.34-.19.38.05.77.02,1.15.08.3.05.6.11.91.02.05,0,.09.01.14.02.05.09.12.07.19.03.49,0,.92.26,1.39.39.56.15,1.09.38,1.64.57.02.07-.01.14-.05.21.15-.13.32.02.46-.05.03.02.06.03.09.05.02.14.12.16.24.13.12.07.24.13.35.2,0,.09.03.12.12.1.11.03.12.19.25.19,0,.09.03.16.14.13.1.1.29.03.37.18.02.14.04.28.05.42,0,.07.02.14.11.11.07-.02.06-.09.02-.13-.11-.14-.01-.16.1-.18.09.06.23.02.27.17.11.3.36.42.64.5Zm-1.3-.61s.03-.04.04-.06c0,0-.01,0-.02-.01,0,.02-.01.05-.02.07-.02,0-.07-.03-.06.04l.05-.04Z"
      />
      <path
        className="cls-2"
        d="m47.46,29.21c.28.08.58.13.86.15.35.03.72-.01,1.08-.01.31,0,.62.03.94.04.17.19.49.24.75.1.18-.1.39-.18.56-.11.21.08.39.04.6.02.37-.03.72-.22,1.13-.11.1.03.45.03.5-.28.04,0,.07-.02.11-.03.12.13.26.07.39.04.07-.02.15-.05.19.03.04.1-.07.09-.11.13-.13.14-.36.09-.47.25-.03,0-.07,0-.1,0-.05,0-.11,0-.16,0-.6.03-1.17.23-1.77.22-.05,0-.08.03-.09.08-.03,0-.07.02-.1.02-.12-.08-.23-.1-.34.03-.34.04-.69,0-1.02.07-.02-.01-.04-.04-.06-.04-.89,0-1.77,0-2.66,0-.67-.06-1.32-.18-1.95-.39-.14-.2-.32-.26-.54-.15-.54-.08-1.08-.16-1.62-.25.02-.11-.07-.15-.14-.2-.1-.06-.14-.14-.13-.26.45.06.9.02,1.35.03.03.05.05.15.11.02.18.01.37,0,.52.12.19.15.44.2.62.37.04.04.18.06.21-.08.05,0,.11,0,.16,0,0,.17.1.21.24.21.24,0,.48.02.7.13.2.09.26-.02.25-.2Zm1.93.3s-.06,0-.08,0c-.03,0-.03.03,0,.04.01,0,.03,0,.05,0,0,0,.02-.02.03-.04Zm-.49-.04h.01s0,0,0,0h-.02Z"
      />
      <path
        className="cls-2"
        d="m37.68,38.36c.36-.23.65-.55.93-.87.31-.22.62-.44.65-.87h0c.16,0,.2-.11.27-.22.26-.46.53-.91.92-1.27.08-.08.14-.17.19-.28.13-.28.15-.66.56-.75.08-.02.08-.11.09-.19.06-.41.02-.86.41-1.15.02-.01,0-.06.02-.08.18-.22.18-.5.25-.76.08-.33.18-.66.19-1,0-.02.01-.03.02-.05.05,0,.09-.04.09-.08-.06-.44.18-.85.11-1.29,0-.01.02-.02.03-.03.04.02.1.03.11-.03.01-.06-.02-.1-.09-.11-.06-.08-.06-.17-.03-.27.17-.03.09-.22.19-.3.12.04,0,.23.17.24,0,.03,0,.07,0,.1-.12.02-.11.12-.09.19.07.34-.04.68-.04,1.01,0,.17-.24.42.09.54,0,.03-.01.07-.02.1-.13.06-.12.14-.03.23-.01.05-.02.1-.03.15-.12.11-.13.25-.13.4-.02.03-.05.06-.05.09.06.56-.29.98-.51,1.44-.12.25-.25.5-.38.74-.12.11-.22.24-.27.4-.07.21-.35.33-.38.49-.07.34-.37.53-.48.83-.01.04-.07.18-.18.07-.05-.04-.1-.03-.14.02-.07.09.01.09.07.12.08.05,0,.14.04.2h0c-.08,0-.12.03-.11.11-.08.12-.14.25-.27.33-.3.15-.37.47-.54.71-.19.2-.38.39-.57.59-.25.27-.54.5-.84.72-.17,0-.26-.05-.18-.23Z"
      />
      <path
        className="cls-2"
        d="m33.55,41.15c.21-.16.31-.41.49-.59.1-.1.23-.11.32-.05.11.07.03.2-.02.29-.27.48-.56.96-.84,1.44-.3.26-.56.55-.68.95h0c-.15.02-.17.14-.21.26-.44.41-.92.76-1.39,1.13-.26.01-.47.15-.67.3-.08.03-.16.06-.24.1-.05.02-.09.07-.12,0-.01-.03.02-.08.04-.12,0-.02,0-.04.01-.06h0c.18-.16.3-.36.39-.58.03-.15.22-.15.27-.28.13,0,.2-.12.3-.17.18-.1.29-.3.51-.33,0,0,.01,0,.02.01,0,0-.01,0-.02,0,0-.06.01-.11.07-.17.31-.32.73-.53.94-.96.04-.07.11-.13.09-.23.02-.05.04-.1.11-.11.16-.04.2-.17.23-.31,0-.01.02-.02.04-.03.24-.07.39-.21.39-.47Z"
      />
      <path
        className="cls-2"
        d="m64.02,69.74c-.05.24-.09.49-.34.62-.27-.14-.33-.35-.23-.63,0-.02,0-.03,0-.05.09.01.1-.05.12-.11.11-.31.23-.62.42-.89.15-.21.33-.4.21-.69,0-.02,0-.03,0-.05.27-.2.4-.5.53-.79,0-.02-.03-.06-.05-.08,0-.03.01-.07.02-.1.11-.02.1-.09.09-.17.07-.09.15-.18.22-.27.24-.17.23-.48.38-.71.09-.14.15-.3.33-.36.06-.02.12-.03.17.02.07.06,0,.1,0,.16-.12.44-.35.84-.51,1.26-.31.79-.7,1.55-1.04,2.32-.26.08-.3.3-.33.51Z"
      />
      <path
        className="cls-2"
        d="m37.72,71.22c0,.11,0,.22,0,.33,0,.06.02.14-.06.16-.07.02-.12-.04-.16-.08-.2-.23-.39-.47-.46-.77-.05-.21-.15-.38-.25-.56-.04-.24-.04-.49-.28-.64-.18-.19-.24-.45-.37-.67-.23-.37-.36-.8-.66-1.13.08-.2.26-.1.39-.12.27.29.56.57.68.96.04.11.12.16.18.24.3.48.57.97.73,1.52.02.28.02.56.24.77Z"
      />
      <path
        className="cls-1"
        d="m55.88,70.25c.01-.12.12-.12.2-.14.49-.12.98-.23,1.46-.37.98-.29,1.98-.22,2.97-.18.67.02,1.33.09,2,.07.09,0,.16-.09.29,0-.17.06-.31.16-.48.18-.36.02-.72.04-1.08.06-.48.02-.95.03-1.43.04.11-.15.1-.23-.12-.21-.46.04-.92.05-1.38.15-.15.04-.19.09-.19.22-.3,0-.55.21-.85.18-.02-.09-.04-.17-.06-.27-.28.15-.59.15-.87.19-.15.03-.29.23-.47.07Z"
      />
      <path
        className="cls-1"
        d="m37.27,56.46c.18.1.17.29.17.45-.03.57.12,1.14.07,1.7-.03.34.12.68.03,1.03.03.04.06.02.1,0,.04-.02.07-.07.12-.02.04.04.02.08-.01.12-.22.34-.11.71-.08,1.07.01.15.03.3-.03.45-.21.52-.27,1.06-.21,1.63.02.25.07.56-.19.8-.07.07-.11.26-.17.4-.06.14-.14.24-.26.33-.01-.36.22-.65.33-.97.06-.18.14-.35.11-.54-.07-.44.03-.88.1-1.3.11-.65,0-1.29.06-1.92.04-.45-.28-.81-.15-1.24.1-.32.02-.65.05-.98.02-.23-.07-.48-.07-.72,0-.1-.03-.19.03-.28Z"
      />
      <path
        className="cls-1"
        d="m42.14,30.92c0,.34-.1.67-.19,1-.06.26-.07.53-.25.76-.02.02,0,.06-.02.08-.39.29-.35.74-.41,1.15-.01.07-.01.17-.09.19-.41.09-.43.47-.56.75-.05.11-.11.21-.19.28-.39.36-.66.82-.92,1.27-.06.11-.11.23-.27.22.13-.42.33-.82.62-1.14.34-.38.55-.83.87-1.23.29-.37.31-.89.55-1.31.34-.56.47-1.19.6-1.83.02-.1.07-.23.24-.2Z"
      />
      <path
        className="cls-2"
        d="m67.85,40c.06.32.23.59.38.87-.22.25.12.22.17.33,0,.02,0,.03,0,.05.08.24.22.44.42.61,0,.02,0,.03.01.05.07.1,0,.27.16.33.03.26-.19.19-.25.14-.35-.3-.77-.54-.95-1-.03-.19-.07-.38-.25-.5-.01-.03-.03-.05-.04-.08.06-.12.02-.19-.09-.24-.02-.03-.04-.06-.06-.09-.05-.22.06-.44.02-.66-.04-.22,0-.33.26-.27,0,.03,0,.07,0,.1-.1.22.02.32.21.38Z"
      />
      <path
        className="cls-2"
        d="m55.88,70.25c.18.16.31-.05.47-.07.29-.05.59-.04.87-.19.02.1.04.18.06.27-.34.19-.75.14-1.11.31-.12.06-.25.09-.37.13-.3.03-.56.14-.78.34-.47.19-.84.53-1.3.73-.18-.04-.29.02-.27.22h0c-.15-.1-.1-.18,0-.28.08-.07.22-.1.22-.25.03-.04.07-.08.1-.13.23.1.31-.18.49-.2.28-.02.41-.25.61-.38.05-.03.09-.06.14-.09.09.02.14,0,.11-.11.01-.01.02-.02.04-.02.08.05.13.04.14-.06.06-.03.14.03.18-.05.14,0,.3.07.32-.16.02,0,.05,0,.07,0Z"
      />
      <path
        className="cls-1"
        d="m53.99,29.44c.11-.16.34-.11.47-.25.04-.04.15-.04.11-.13-.04-.08-.12-.05-.19-.03-.14.03-.27.09-.39-.04.08-.15.22-.08.34-.08.42.03.77-.23,1.18-.26.31-.02.61-.16.93-.12.08,0,.19.03.21.09.03.1-.09.11-.16.14-.6.21-1.19.44-1.82.55-.22.04-.41.22-.66.14Z"
      />
      <path
        className="cls-2"
        d="m63.99,63.6c.4.35.8.7,1.19,1.06.09.08.2.14.3.21.04.03.14.11.09.18-.04.06-.13.11-.24.04-.17-.11-.37-.17-.52-.31-.28-.25-.63-.42-.87-.71-.03-.21-.19-.31-.32-.44-.04-.04-.07-.08-.06-.14.02-.07.08-.06.13-.06.05,0,.11.01.16.02.01.01.02.02.03.04-.01.08.01.12.1.12Z"
      />
      <path
        className="cls-1"
        d="m66.71,44.78c.03.12-.05.19-.13.25-.12.08-.17.2-.21.33-.07.2-.24.36-.38.5-.31.32-.44.73-.68,1.08-.31.46-.53.97-.8,1.46-.08.13-.2.24-.31.36-.06-.28.15-.46.26-.67.33-.65.77-1.24,1.13-1.88.24-.42.55-.8.84-1.19.07-.1.15-.2.29-.23Z"
      />
      <path
        className="cls-1"
        d="m63.46,50.66c-.07.27-.21.52-.32.77-.18.41-.19.87-.4,1.25-.21.37-.29.78-.43,1.17-.08.22-.14.46-.2.69-.02.08-.03.16-.12.19-.05-.3.07-.57.14-.85.1-.39.3-.75.39-1.12.11-.48.29-.93.47-1.38.09-.23.26-.41.33-.65.02-.07.09-.08.16-.07Z"
      />
      <path
        className="cls-2"
        d="m51.6,73.44s.01-.03.02-.04c.08,0,.1-.05.09-.12,0-.02.02-.03.03-.04.16-.11.31-.24.35-.44.02-.02.04-.04.06-.05.17-.08.32-.16.32-.38l.1-.07c.12,0,.17-.11.27-.15.07-.02.1-.17.21-.1.09.06.06.16.06.24-.11.09-.21.19-.32.28-.19.01-.23.16-.29.3h0c-.13.06-.24.13-.26.28-.2.26-.4.51-.59.77-.26-.04-.27-.08-.12-.28.05-.07.09-.13.07-.21Z"
      />
      <path
        className="cls-2"
        d="m61.67,52.01s0-.06,0-.08c.05-.18.1-.4.33-.38.26.02.16.26.14.39-.06.39-.15.79-.43,1.1-.12.13-.25.17-.29-.07.04-.24.09-.48.13-.72-.01-.08.04-.13.1-.17.03,0,.07.02.08-.02,0,0-.04-.02-.06-.03Z"
      />
      <path
        className="cls-1"
        d="m53.88,29.01c-.05.3-.39.31-.5.28-.4-.11-.76.07-1.13.11-.2.02-.38.06-.6-.02-.17-.07-.38.02-.56.11-.26.14-.58.09-.75-.1.4-.05.8-.15,1.19-.15.51.01.99-.14,1.49-.16.28,0,.57-.05.85-.08Z"
      />
      <path
        className="cls-2"
        d="m55.89,31.13s.05-.06.09-.07c.05,0,.11.02.16.03.05.55.18,1.09.27,1.63,0,.05.04.11-.01.14-.06.04-.09-.03-.13-.06-.18-.15-.24-.38-.31-.58-.08-.22-.17-.46-.15-.72.05-.12.1-.24.07-.37Z"
      />
      <path
        className="cls-1"
        d="m37.94,58.38c-.22-.16-.11-.41-.11-.59,0-.55-.06-1.09-.17-1.62-.04-.2.07-.47-.19-.6.18-.38-.18-.74-.04-1.12.12.09.12.24.14.37.08.52.21,1.03.26,1.56.07.64.13,1.28.14,1.93,0,.02-.02.05-.03.08Z"
      />
      <path
        className="cls-1"
        d="m63.53,48.53c.21-.43.4-.87.63-1.28.11-.19.23-.39.34-.58.06-.1.16-.2.26-.13.13.08,0,.18-.05.27-.3.51-.61,1.02-.9,1.54-.06.11-.13.17-.28.18Z"
      />
      <path
        className="cls-2"
        d="m56.77,33.91c.09-.02.2,0,.2.08,0,.43.28.75.42,1.13.03.09.08.18,0,.24-.08.05-.18-.02-.23-.09-.15-.2-.35-.36-.46-.59.03-.26.05-.51.08-.77Z"
      />
      <path
        className="cls-2"
        d="m64.77,39.99c-.23.02-.45.03-.68.05-.15.01-.22-.08-.28-.2-.06-.1,0-.16.04-.22.08-.14.2-.05.29-.02.32.09.67.02.99.16.06.03.16,0,.16.1,0,.1-.12.08-.17.1-.11.04-.23.02-.35.03h0Z"
      />
      <path
        className="cls-2"
        d="m50.78,30.47s.07-.01.11-.02c.07.1.13.08.17-.02.11-.03.18.04.34.11-.29.1-.51.24-.76.28-.22.04-.4.2-.64.2-.01,0-.02.06-.03.1-.09.01-.18.02-.26.03q-.28-.16-.06-.42s0-.02,0-.03l.48-.02c.24,0,.46-.07.65-.21Z"
      />
      <path
        className="cls-1"
        d="m32.79,42.07c.02.1-.06.15-.09.23-.21.43-.62.64-.94.96-.05.05-.06.1-.07.17h0c-.22.02-.33.23-.51.33-.1.05-.17.16-.3.17,0-.13.11-.18.19-.25.58-.44,1.03-1.02,1.56-1.51.04-.04.07-.11.15-.09Z"
      />
      <path
        className="cls-1"
        d="m65.8,45.11c.18-.36.36-.72.54-1.07.06-.11.17-.14.28-.1.12.05.05.18.03.24-.14.33-.23.69-.57.89-.12-.15-.18.09-.28.05Z"
      />
      <path
        className="cls-2"
        d="m50.71,75.22c.07-.2.04-.43.17-.62.18-.12.23-.32.28-.51h0c.13-.13.25-.05.37,0-.02.25-.26.36-.34.6-.09.27-.19.55-.31.81-.24.02-.13-.18-.17-.29Z"
      />
      <path
        className="cls-2"
        d="m58.77,37.34c-.07-.06-.08-.14-.2-.18-.15-.05-.26-.19-.28-.37.04-.15.15-.23.29-.29,0,0,0,0,0,0-.03.07-.02.13.08.13.15.16.3.33.44.49.03.13.1.21.24.2-.03.09.31.34-.11.27-.12-.14-.28-.2-.45-.25Z"
      />
      <path
        className="cls-1"
        d="m39,61.01c-.02.12-.05.26-.06.41,0,.09-.01.16-.13.17-.12,0-.16-.09-.17-.18,0-.17,0-.34,0-.51,0-.18.02-.35.04-.53,0-.07,0-.16.09-.17.09,0,.12.09.14.15.07.21.06.42.07.66Z"
      />
      <path
        className="cls-2"
        d="m46.38,30.51s.09.02.12.06c.03.04.06.03.1.02.17.09.36.03.54.07.03.12.14.09.22.1.12.01.19.05.16.18-.39.11-.78.2-1.18.01.04-.15-.02-.31.05-.45Z"
      />
      <path
        className="cls-2"
        d="m38.6,38.85c.2-.24.52-.29.74-.49.05-.05.11-.07.16-.03.07.07.01.15-.03.19-.26.2-.4.51-.64.73-.12.01-.25.11-.35-.02-.09-.11.08-.18.09-.28,0-.03.01-.07.02-.1Z"
      />
      <path
        className="cls-1"
        d="m40.18,36.13c-.03-.06.04-.15-.04-.2-.05-.03-.13-.03-.07-.12.04-.05.09-.07.14-.02.11.11.16-.03.18-.07.11-.3.4-.49.48-.83.03-.16.31-.28.38-.49.06-.16.15-.29.27-.4.03.24-.15.41-.24.6-.13.28-.28.56-.5.79-.22.23-.35.53-.6.74Z"
      />
      <path
        className="cls-2"
        d="m36.92,40.17c-.1.13-.24.11-.37.1-.13-.01-.23-.13-.23-.23.01-.13.13-.25.24-.31.1-.05.22-.04.34-.06.05,0,.11,0,.16-.01.08-.02.18-.08.22.05.03.09,0,.15-.11.2-.1.05-.21.14-.25.26Z"
      />
      <path
        className="cls-2"
        d="m37.98,53.47c-.15-.29-.28-.58-.39-.89-.02-.06-.06-.15.03-.18.07-.02.11.04.15.09.08.12.15.24.22.36,0,.07.02.13.09.16,0,.02.01.04.02.05.05.13.09.27.2.37,0,.06,0,.11,0,.17-.15.07-.2-.13-.33-.12Z"
      />
      <path
        className="cls-2"
        d="m38.58,57.87c.02-.07,0-.17.08-.18.09-.01.11.09.13.15.11.31.19.63.23.96.01.08-.06.15-.12.15-.1,0-.21.02-.26-.11-.04-.08-.06-.17-.05-.26.04-.24.03-.48,0-.71Z"
      />
      <path
        className="cls-2"
        d="m58.12,70.07c0-.13.04-.19.19-.22.45-.1.91-.12,1.38-.15.22-.02.23.05.12.21-.56.01-1.12.1-1.68.17Z"
      />
      <path
        className="cls-2"
        d="m36.16,39.26c.16-.1.35-.13.52-.2.13.05.22-.04.32-.1.17-.12.35-.24.54-.37,0,.09.01.15.02.21-.4.33-.84.6-1.35.72-.15-.06-.08-.16-.05-.25Z"
      />
      <path
        className="cls-2"
        d="m60.45,60.32s-.04-.09-.06-.13c.04-.18-.1-.34-.06-.52.02-.09-.05-.22.07-.26.15-.05.1.15.18.18.04.33.19.65.19.99,0,.1.02.27-.09.28-.12.01-.15-.14-.17-.26,0-.04-.02-.09-.03-.13.03-.06.03-.11-.04-.14Z"
      />
      <path
        className="cls-2"
        d="m59.75,68.86c-.57-.08-1.14-.03-1.71-.06.59-.23,1.18-.32,1.8-.11-.06.04-.1.09-.09.17Z"
      />
      <path
        className="cls-2"
        d="m61.26,62.19c.12.23.19.49.35.71.05.07.06.15.04.23-.02.11-.11.11-.15.04-.22-.35-.48-.68-.62-1.07.02-.08.04-.15.06-.25.08.17.13.32.32.35Z"
      />
      <path
        className="cls-2"
        d="m34.52,48.05c.24.06.32.32.52.44.05.03.06.15,0,.19-.07.05-.18.05-.25-.02-.11-.1-.23-.2-.32-.33-.18-.25-.44-.43-.55-.76.22.06.32.25.48.34,0,.07-.02.17.11.15Z"
      />
      <path
        className="cls-2"
        d="m42.84,32.54c.01-.25.18-.43.31-.63-.04.46.08.94-.25,1.34-.08-.02-.17.11-.24,0-.06-.08.03-.14.06-.21.06-.16.09-.34.13-.51Z"
      />
      <path
        className="cls-1"
        d="m37.79,68.94c.17.03.23.2.28.33.07.17.36.25.23.5-.04.08-.08.2-.21.17-.11-.02-.18-.07-.2-.19-.04-.22-.22-.4-.21-.64,0-.08,0-.14.12-.16Z"
      />
      <path
        className="cls-2"
        d="m38.43,63.43c.01-.15-.03-.37.17-.36.23,0,.09.23.1.36.01.19-.01.38-.1.56-.03.03-.03.06-.02.09,0,.02-.02.03-.03.05-.08,0-.1.05-.08.12-.04.06-.03.16-.14.14-.08-.33.1-.63.09-.95Z"
      />
      <path
        className="cls-1"
        d="m37,53.28c-.14-.03-.27-.06-.22-.25,0-.02,0-.06,0-.08-.3-.39-.3-.95-.76-1.25-.13-.08-.11-.33-.35-.36.06-.09.17-.11.2-.21.27.32.49.69.65,1.06.16.36.4.69.47,1.09Z"
      />
      <path
        className="cls-2"
        d="m60.78,56.8c.01.09,0,.17-.02.25-.09.04-.16.11-.13.2.07.19.01.39.05.58,0,.11,0,.22,0,.32,0,.06.04.14-.05.16-.08.02-.14-.01-.16-.1.05-.22.11-.43-.11-.6-.05-.25.11-.46.11-.7.1,0,.15-.07.2-.15.07-.12.07.03.11.04Z"
      />
      <path
        className="cls-1"
        d="m60.92,68.79c.49-.15.86.1,1.26.19.09.02.11.12.12.2,0,.04-.06.09-.12.08-.44-.05-.86-.18-1.26-.47Z"
      />
      <path
        className="cls-2"
        d="m63.56,64.68c-.41-.08-.77-.24-1.1-.47-.09-.06-.13-.15-.05-.25.07-.1.13-.02.2,0,.29.11.53.32.79.48.07.05.15.1.16.23Z"
      />
      <path
        className="cls-2"
        d="m52.74,30.53c.39-.11.78-.08,1.26-.03-.37.3-.79.27-1.14.4-.06-.12-.14-.23-.11-.37Z"
      />
      <path
        className="cls-2"
        d="m64.24,65.54s-.05-.03-.08-.04c0-.08-.04-.11-.12-.1,0,0,0,0,0,0,0-.07,0-.15,0-.22.02-.05.08-.07.11-.04.25.19.56.18.84.3.1.04.24.07.22.18-.01.08-.16.12-.27.11-.04,0-.09,0-.13,0-.03-.11-.08-.14-.17-.04-.03-.01-.06-.03-.09-.04-.08-.1-.19-.13-.31-.09Z"
      />
      <path
        className="cls-2"
        d="m34.32,42.36c.09-.03.17,0,.12.09-.17.38-.33.78-.66,1.06-.04.04-.12.03-.18.05,0-.07,0-.15-.08-.2.07-.22.32-.27.41-.48.03-.07.08-.2.18-.27.19.02.2-.12.21-.26Z"
      />
      <path
        className="cls-2"
        d="m38.54,55.44c.05.2.19.38.16.6-.02.04-.02.07.02.09.1.17.1.35.04.53-.08,0-.15.03-.22.08-.04-.14-.09-.28-.13-.41,0-.24.02-.48.03-.73,0-.08-.03-.18.11-.17Z"
      />
      <path
        className="cls-1"
        d="m61.4,38.78c.4.21.9.09,1.27.37-.02.1-.09.08-.14.08-.37-.01-.74-.03-1.1-.05-.08,0-.14-.03-.17-.11.26,0,.09-.2.14-.3Z"
      />
      <path
        className="cls-2"
        d="m52.2,71.7c.16-.25.41-.38.74-.53-.17.47-.52.71-.78,1.02-.2-.04-.21-.14-.09-.28.05-.07.15-.11.13-.22Z"
      />
      <path
        className="cls-2"
        d="m56.39,69.04c.25-.14.5-.28.83-.21-.14.26-.37.37-.62.47-.01-.02-.02-.04-.04-.06,0,.02,0,.05-.01.07h0c-.14-.01-.24.07-.35.12-.08.03-.18.09-.22,0-.06-.1.06-.14.13-.2.09-.07.23-.07.27-.2Z"
      />
      <path
        className="cls-1"
        d="m61.87,55.37c-.13.5-.24,1.01-.29,1.53-.01.11-.02.21-.03.32,0,.08,0,.17-.12.17-.11-.17,0-.33.02-.49.08-.42.01-.86.2-1.26.05-.11.06-.25.22-.27Z"
      />
      <path
        className="cls-1"
        d="m47.68,29.83c.89,0,1.77,0,2.66,0,.02,0,.04.03.06.04-.06.12-.17.07-.26.07-.74,0-1.47,0-2.21,0-.1,0-.2.01-.25-.1Z"
      />
      <path
        className="cls-1"
        d="m64.21,68c.12.29-.06.48-.21.69-.19.27-.31.58-.42.89-.02.06-.03.12-.12.11-.04-.01-.06-.04-.05-.08.17-.57.5-1.06.76-1.58,0-.01.03-.02.04-.03Z"
      />
      <path
        className="cls-2"
        d="m54.9,30.08c.16-.23.45-.18.66-.3.06-.03.2-.14.25-.02.04.09-.05.2-.16.25-.21.1-.36.3-.59.37-.09-.08-.22-.14-.18-.3Z"
      />
      <path
        className="cls-1"
        d="m39.77,69.88c-.28.29-.64.36-1.01.44-.06.01-.11-.02-.12-.09-.01-.07.02-.13.08-.15.33-.12.67-.23,1.04-.2Z"
      />
      <path
        className="cls-1"
        d="m53.12,72.29c0-.09.04-.19-.06-.24-.11-.07-.14.08-.21.1-.1.03-.15.15-.27.15,0-.05,0-.09.04-.12.3-.24.59-.48.88-.72.05-.04.11-.06.17-.01,0,.15-.13.18-.22.25-.1.09-.16.18,0,.28-.09.13-.18.25-.33.32Z"
      />
      <path
        className="cls-2"
        d="m36.59,50.65c-.14-.25-.4-.43-.45-.77.35.07.55.3.72.55,0,.1.12.2.03.29-.09.09-.16-.08-.25-.07-.02,0-.03,0-.05,0Z"
      />
      <path
        className="cls-1"
        d="m42.68,30.86c-.32-.13-.09-.37-.09-.54,0-.34.11-.67.04-1.01-.01-.07-.03-.17.09-.19.13.59.12,1.17-.05,1.74Z"
      />
      <path
        className="cls-1"
        d="m49.37,72.67c0,.08-.06.08-.11.06-.32-.12-.55-.36-.77-.61-.03-.04-.02-.08.01-.12.04-.04.09-.06.12-.03.27.18.51.41.73.65.01.01,0,.03.01.05Z"
      />
      <path
        className="cls-1"
        d="m64.8,38.48c-.29-.02-.49-.25-.78-.31-.27-.05-.53-.23-.79-.35-.04-.02-.07-.08-.1-.12.19-.07.32.08.46.13.37.15.73.32,1.09.48.07.03.14.06.12.16Z"
      />
      <path
        className="cls-1"
        d="m59.47,36.32c.08-.04.18-.1.25,0,.15.21.42.28.55.51.04.06.09.12.17.12.21.02.26.17.3.33-.31-.11-.53-.36-.77-.55-.16-.14-.39-.2-.5-.41Z"
      />
      <path
        className="cls-2"
        d="m37.93,65.45c-.12.36-.26.72-.46,1.04-.02.03-.05.11-.12.07-.04-.03-.11-.07-.09-.12.18-.35.29-.75.67-.99Z"
      />
      <path
        className="cls-1"
        d="m60.6,59.58c-.09-.03-.04-.23-.18-.18-.12.04-.06.17-.07.26-.04.18.1.34.06.52-.28-.37-.29-.66-.06-1,.06-.09.13-.13.22-.11.1.03.07.13.07.21,0,.1-.02.2-.03.29Z"
      />
      <path
        className="cls-1"
        d="m42.73,71.2c0-.27.22-.23.34-.19.28.1.57.19.82.37.02.02.03.06.04.09-.4-.09-.8-.18-1.2-.27Z"
      />
      <path
        className="cls-2"
        d="m47.19,71.32c.04.19-.12.11-.16.09-.22-.1-.48-.08-.68-.25-.04-.03-.09-.04-.14-.06.11-.19-.19-.22-.15-.38.22.02.36.24.59.22,0,.18.11.17.23.15h0c-.02.25.17.2.31.23Z"
      />
      <path
        className="cls-1"
        d="m36.16,39.26c-.03.09-.1.19.05.25-.05.08-.13.06-.2.07-.07-.25-.23-.07-.35-.06-.15,0-.06.11-.05.17-.23.16-.42.12-.59-.14.43.06.73-.31,1.14-.28Z"
      />
      <path
        className="cls-1"
        d="m47.46,29.21c0,.18-.06.29-.25.2-.23-.11-.46-.14-.7-.13-.14,0-.25-.04-.24-.21.41-.02.8.06,1.2.14Z"
      />
      <path
        className="cls-1"
        d="m42.92,70.58c-.3.09-.61.02-.91-.02-.38-.06-.77-.03-1.15-.08.25-.16.53-.09.78-.08.43.03.87,0,1.28.18Z"
      />
      <path
        className="cls-1"
        d="m44.37,70.22c-.22,0-.43.01-.65,0-.16-.01-.34-.02-.37-.25.37-.1.71.03,1.06.11.02.06-.02.1-.05.14Z"
      />
      <path
        className="cls-1"
        d="m36.92,40.17c.04-.13.15-.21.25-.26.1-.05.14-.11.11-.2-.04-.13-.14-.07-.22-.05-.05.01-.1,0-.16.01.14-.23.39-.19.59-.18.18,0,.22.24.05.35-.2.13-.42.23-.63.34Z"
      />
      <path
        className="cls-1"
        d="m32.24,44.82c-.07,0-.12-.04-.07-.15.1-.22.28-.35.5-.42.14-.05.12.06.11.14-.02.16-.33.42-.54.43Z"
      />
      <path
        className="cls-1"
        d="m51.86,29.75s.05-.08.09-.08c.6,0,1.17-.19,1.77-.22.05,0,.11,0,.16,0-.19.16-.44.15-.66.18-.45.05-.9.23-1.37.13Z"
      />
      <path
        className="cls-1"
        d="m36.85,67.63c0-.1.09-.09.17-.04.19.12.27.34.43.5.07.06-.02.12-.1.12-.22.01-.49-.27-.5-.58Z"
      />
      <path
        className="cls-1"
        d="m36.79,64.46c.03.31.04.61-.23.83-.1.08-.1.19-.09.29.02.14-.03.2-.18.19-.11-.08-.05-.18,0-.26.16-.33.41-.63.43-1.02,0-.01.05-.02.07-.03Z"
      />
      <path
        className="cls-1"
        d="m41.59,69.55c.26-.05.52-.04.77.01.07.01.14.03.14.1,0,.05-.07.06-.12.09-.24.1-.5.03-.74.1l-.05-.3Z"
      />
      <path
        className="cls-1"
        d="m44.8,30.53c-.23.11-.47.1-.7-.02-.16-.08-.15-.19-.06-.3.09-.1.19-.25.35-.06.05.1.19.2-.01.28.14.11.31-.01.42.1Z"
      />
      <path
        className="cls-2"
        d="m61.4,38.78c-.04.1.13.3-.14.3-.09-.03-.17-.07-.22-.16.02-.12,0-.21-.14-.24,0-.08,0-.16,0-.24,0-.1.09-.11.14-.13.06-.03.12.04.12.1,0,.18.16.25.24.37Z"
      />
      <path
        className="cls-1"
        d="m51.15,72.94c0,.35-.3.57-.33.88,0,.05-.05.1-.12.08-.07-.02-.08-.08-.09-.15-.02-.29.19-.47.33-.67.04-.06.09-.13.2-.15Z"
      />
      <path
        className="cls-2"
        d="m44.8,30.53c-.12-.11-.28,0-.42-.1.21-.09.07-.19.01-.28.28-.04.53.08.78.16.03.01.07.07.07.1,0,.05-.05.06-.1.07-.11.02-.23.03-.34.05Z"
      />
      <path
        className="cls-2"
        d="m66.88,42.23c.09-.02.11.07.16.11-.03.13.02.23.1.33.06.15,0,.28,0,.45-.2-.12-.29-.28-.37-.45.13-.12,0-.31.11-.43Z"
      />
      <path
        className="cls-1"
        d="m61.16,54.73c0,.28-.06.55-.14.81-.02.06-.02.13-.11.11-.09-.02-.08-.1-.07-.15.08-.29,0-.59.07-.88.1,0,.14.13.25.11Z"
      />
      <path
        className="cls-1"
        d="m64.04,49.22c.04.3-.19.49-.3.72-.06.12-.03.33-.23.38-.06-.11-.06-.2.02-.32.12-.2.21-.42.32-.62.04-.07.07-.17.19-.16Z"
      />
      <path
        className="cls-1"
        d="m63.86,63.45c-.05,0-.11-.02-.16-.02-.05,0-.11,0-.13.06-.02.06.02.1.06.14.13.13.3.23.32.44-.29-.16-.47-.43-.66-.69.16-.05.28-.13.22-.33.16.1.27.23.35.4Z"
      />
      <path
        className="cls-1"
        d="m50.71,75.22c.05.1-.07.3.17.29,0,.18-.05.35-.1.52-.03.12-.11.11-.18.05-.09-.08,0-.75.11-.85Z"
      />
      <path
        className="cls-1"
        d="m64.06,66.92c.05-.26.26-.44.33-.68,0-.02.1-.03.15-.03.08,0,.11.12.1.13-.12.22-.11.5-.31.69-.03-.09.06-.2-.06-.26-.08.05-.11.15-.21.15Z"
      />
      <path
        className="cls-1"
        d="m67.63,39.51c-.25-.06-.29.06-.26.27.04.22-.07.44-.02.66-.24-.21-.28-.82-.07-1.01.12-.1.3-.06.34.08Z"
      />
      <path
        className="cls-2"
        d="m32.7,46.3c-.4,0-.64-.23-.87-.46.33.02.66.05.87.46Z"
      />
      <path
        className="cls-1"
        d="m57.65,33.68c.18.08.26.31.49.32.02,0,.03.04.05.06-.27.2.13.25.09.4-.08.1-.13.03-.19-.03-.21-.21-.38-.44-.45-.74Z"
      />
      <path
        className="cls-2"
        d="m64.06,66.92c.11,0,.14-.11.21-.15.12.07.03.18.06.26-.13.31-.21.38-.48.47-.03-.23.13-.39.21-.58Z"
      />
      <path
        className="cls-1"
        d="m42.35,29.5c.07.44-.17.85-.11,1.29,0,.04-.04.08-.09.08-.18-.46.08-.88.11-1.33,0-.04.05-.05.09-.04Z"
      />
      <path
        className="cls-1"
        d="m37.56,38.79c0-.06-.01-.12-.02-.21-.19.13-.37.25-.54.37-.1.06-.19.15-.32.1.32-.25.64-.49.99-.7-.08.18.01.24.18.23-.06.12-.15.19-.29.2Z"
      />
      <path
        className="cls-2"
        d="m63.51,68.55c0,.11-.06.19-.11.27-.05.08-.14.14-.24.1-.13-.05-.1-.18-.07-.27.03-.1.1-.18.15-.27.13,0,.28-.04.28.17Z"
      />
      <path
        className="cls-1"
        d="m37.94,61.42c-.1-.01-.11-.08-.11-.16.02-.49.04-.99.07-1.48,0-.04.04-.06.08-.06.05.57-.04,1.13-.05,1.7Z"
      />
      <path
        className="cls-2"
        d="m54.65,69.92s.05,0,.08,0c.11-.03.28-.13.33-.01.05.12-.08.25-.23.3-.04.01-.08.03-.12.04-.1-.06-.2.07-.3.01,0-.08.07-.15.03-.23h0c.09.01.2.06.22-.1Z"
      />
      <path
        className="cls-2"
        d="m35.06,41.02c0,.17,0,.32-.17.42-.06.03-.1.04-.15-.04-.11-.18.02-.3.07-.44.03-.08.1-.17.2-.14.1.03.02.14.05.2Z"
      />
      <path
        className="cls-1"
        d="m42.73,29.01c-.16,0-.05-.2-.17-.24-.09.08-.01.27-.19.3-.07-.1-.02-.18.02-.28.06-.16-.03-.47.18-.45.13.01.18.35.18.56,0,.03-.01.07-.02.1Z"
      />
      <path
        className="cls-2"
        d="m63.04,49.91c0,.21-.23.32-.25.52-.08-.05-.23.19-.27-.06.05-.1.09-.2.14-.31.09,0,.07-.08.1-.13.08-.15.17-.2.28-.03Z"
      />
      <path
        className="cls-1"
        d="m56.39,69.04c-.05.13-.18.13-.27.2-.07.05-.19.09-.13.2.04.08.14.03.22,0,.11-.05.22-.13.35-.12-.19.19-.41.29-.68.28-.05,0-.11.02-.14-.04-.03-.07,0-.12.04-.17.17-.18.37-.29.61-.33Z"
      />
      <path
        className="cls-2"
        d="m31.8,46.9c-.17-.12-.35-.23-.45-.42.02-.06.05-.12.07-.18.21.04.33.21.48.33-.03.09-.07.18-.1.26Z"
      />
      <path
        className="cls-1"
        d="m61.38,58.26c.06.33-.08.67.07,1,.02.04-.08.05-.13.05-.15-.25-.11-.88.06-1.04Z"
      />
      <path
        className="cls-1"
        d="m57.02,29.02c-.34-.02-.28.28-.37.46-.04.08.05.21-.09.25-.04-.22-.03-.44.04-.65.04-.12.13-.2.25-.22.09-.01.16.06.17.16Z"
      />
      <path
        className="cls-2"
        d="m66.5,40.48c.09.16.05.33.04.5,0,.05-.02.15-.12.15-.09,0-.13-.06-.14-.13-.02-.1-.02-.2-.04-.3.08-.08.11-.22.25-.22Z"
      />
      <path
        className="cls-1"
        d="m54.87,70.74c-.2.14-.33.36-.61.38-.18.01-.26.3-.49.2-.02-.16.15-.12.22-.19.17-.16.42-.19.58-.36.07-.07.19-.1.3-.03Z"
      />
      <path
        className="cls-1"
        d="m58.33,34.46c.19,0,.13.12.09.2-.1.19-.05.31.13.39.15.07.11.21.11.33-.23-.13-.34-.37-.47-.58-.07-.11.07-.23.14-.34Z"
      />
      <path
        className="cls-1"
        d="m35.99,52.35c.05,0,.46.36.44.38-.15.17.01.36-.06.53-.11-.31-.31-.58-.38-.91Z"
      />
      <path
        className="cls-1"
        d="m40.82,36.78c-.06.19-.2.33-.38.44-.04.03-.09,0-.1-.05-.06-.18.18-.51.37-.51.07,0,.13,0,.11.11Z"
      />
      <path
        className="cls-1"
        d="m54.43,70.02c.04.08-.04.15-.03.23.1.06.2-.07.3-.01-.13.24-.39.19-.6.24-.14.03-.15-.11-.07-.2.1-.12.23-.22.4-.25Z"
      />
      <path
        className="cls-1"
        d="m31.42,46.3c-.02.06-.05.12-.07.18-.22-.1-.33-.32-.51-.47-.03-.02-.08-.06-.03-.11.04-.04.08-.05.12-.01.14.16.38.2.49.41Z"
      />
      <path
        className="cls-1"
        d="m39.26,36.62c-.03.43-.34.65-.65.87.17-.32.39-.61.65-.87Z"
      />
      <path
        className="cls-1"
        d="m50.02,75.29s.03.02.05.03c.08.04.1.2.23.14.13-.06,0-.18.04-.26.02.02.06.03.06.05.06.17.11.45-.04.48-.24.05-.28-.24-.35-.43Z"
      />
      <path
        className="cls-1"
        d="m64.7,67.08s.05.07.05.08c-.13.29-.26.59-.53.79.02-.23.19-.4.29-.6.05-.1.13-.18.19-.27Z"
      />
      <path
        className="cls-1"
        d="m56.78,31.39c.19.12.18.33.21.52.04.23.15.45.16.69-.15-.14-.19-.32-.22-.51-.04-.23-.09-.47-.14-.7Z"
      />
      <path
        className="cls-2"
        d="m61.16,54.73c-.11.02-.16-.1-.25-.11.02-.16.04-.33.14-.47.02-.03.1-.07.13-.05.06.02.05.09.02.13-.08.16-.02.33-.04.5Z"
      />
      <path
        className="cls-1"
        d="m32.83,43.18c.12-.39.38-.69.68-.95-.19.34-.39.68-.68.95Z"
      />
      <path
        className="cls-1"
        d="m59.13,34.36c-.1.02-.22.12-.25-.09,0-.07-.1-.09-.17-.1-.16-.02-.19-.12-.16-.26.26.06.49.17.58.45Z"
      />
      <path
        className="cls-1"
        d="m46.11,29.07c-.03.14-.17.12-.21.08-.18-.18-.43-.22-.62-.37.33-.05.59.11.83.3Z"
      />
      <path
        className="cls-1"
        d="m42.84,32.54c-.04.17-.07.34-.13.51-.02.07-.12.13-.06.21.07.1.16-.03.24,0-.02.16-.11.22-.26.16-.15-.05-.16-.18-.1-.28.1-.2.12-.44.31-.59Z"
      />
      <path
        className="cls-1"
        d="m63.04,49.91c-.11-.18-.21-.12-.28.03-.03.05-.01.13-.1.13-.03-.27.18-.4.33-.57.04-.05.13-.03.13.07,0,.12.07.25-.07.34Z"
      />
      <path
        className="cls-1"
        d="m51.53,74.09c-.12-.06-.25-.13-.37,0,.11-.24.17-.52.44-.65.03.09-.01.14-.07.21-.16.2-.14.24.12.28.01.09-.06.13-.12.17Z"
      />
      <path
        className="cls-1"
        d="m63.51,68.55c0-.21-.15-.17-.28-.17,0-.08,0-.17.02-.24.04-.1.12-.15.24-.14.13.01.08.12.09.19,0,.12.03.25-.06.36Z"
      />
      <path
        className="cls-1"
        d="m38.43,63.43c0,.32-.17.62-.09.95-.17-.02-.14-.16-.14-.26,0-.25.09-.48.23-.69Z"
      />
      <path
        className="cls-1"
        d="m36.59,50.65s.03.01.05,0c.1-.01.16.16.25.07.09-.09-.03-.19-.03-.29.26.11.21.34.2.56-.2-.07-.37-.15-.47-.34Z"
      />
      <path
        className="cls-1"
        d="m49.65,30.71s0,.02,0,.03q-.22.26.06.42c-.19.06-.34-.02-.45-.16-.14-.18.07-.22.16-.28.05-.04.15,0,.23,0Z"
      />
      <path
        className="cls-2"
        d="m41.59,69.55l.05.3s-.09.03-.14.04c-.06-.03-.11-.04-.15.04-.03.01-.06.03-.1.04-.19-.08-.04-.21-.05-.32.12-.04.24-.09.37-.09Z"
      />
      <path
        className="cls-1"
        d="m38.54,55.44c-.14,0-.1.09-.11.17,0,.24-.02.48-.03.73-.05-.02-.08-.04-.08-.09-.02-.34,0-.68.11-1.02.1.06.11.14.11.23Z"
      />
      <path
        className="cls-1"
        d="m61.26,62.19c-.18-.03-.24-.18-.32-.35-.02.1-.04.17-.06.25-.25-.13-.06-.28-.01-.42.02-.06.13-.06.15.02.04.19.22.31.24.5Z"
      />
      <path
        className="cls-1"
        d="m35.96,66.51c.22.24.23.24.35-.05.05-.12.12-.13.22-.05-.06.14-.11.28-.26.36-.09.05-.2.06-.27-.02-.06-.06-.16-.14-.04-.25Z"
      />
      <path
        className="cls-2"
        d="m41.75,35.04c.07-.21.1-.44.3-.62.08.27.03.48-.13.67-.06-.02-.11-.04-.17-.05Z"
      />
      <path
        className="cls-1"
        d="m35.89,67.73c-.14.02-.31-.08-.39.12-.28-.15-.02-.32.03-.4.08-.13.19.03.27.1.05.04.06.12.09.19Z"
      />
      <path
        className="cls-1"
        d="m36.49,53.59c.12.01.17.12.19.2.06.24.13.46.22.69.02.05-.01.08-.06.1-.21-.3-.24-.66-.36-.98Z"
      />
      <path
        className="cls-1"
        d="m43.29,28.59c-.02.12.03.2.13.26.07.04.16.08.14.2-.21.08-.31-.13-.48-.18-.05-.02-.02-.11,0-.17.04-.1.09-.15.2-.1Z"
      />
      <path
        className="cls-1"
        d="m46.38,30.51c-.07.14,0,.3-.05.45-.11-.04-.27-.04-.21-.23.04-.13.04-.31.26-.23Z"
      />
      <path
        className="cls-1"
        d="m47.51,30.94c.03-.13-.04-.17-.16-.18-.08,0-.19.02-.22-.1.26-.04.51-.03.71.2-.11.07-.21.11-.33.08Z"
      />
      <path
        className="cls-1"
        d="m38.6,38.85s-.02.07-.02.1c-.01.1-.18.16-.09.28.1.13.23.03.35.02-.08.16-.23.17-.38.15-.09,0-.12-.08-.13-.18-.02-.21.11-.31.28-.37Z"
      />
      <path
        className="cls-1"
        d="m58.28,33.2c-.07-.02-.19.02-.2-.09-.02-.26-.18-.48-.23-.73.28.2.31.53.43.82Z"
      />
      <path
        className="cls-1"
        d="m39.25,37.28c.18-.24.25-.56.54-.71-.1.3-.24.56-.54.71Z"
      />
      <path
        className="cls-1"
        d="m50.08,74.52c-.3-.16-.4-.46-.5-.75.25.2.36.48.5.75Z"
      />
      <path
        className="cls-1"
        d="m41.22,69.64c0,.11-.14.24.05.32-.11.1-.22.07-.33,0-.05-.03-.06-.11-.04-.15.08-.11.16-.22.32-.17Z"
      />
      <path
        className="cls-1"
        d="m41.75,35.04c.06.02.11.04.17.05.03.15,0,.26-.16.31-.06.02-.11.11-.17.02-.05-.08-.1-.17.04-.23.03.03.06.06.09.09.01-.01.03-.02.03-.03,0-.06-.07-.05-.09-.08-.01-.08.05-.11.11-.13Z"
      />
      <path
        className="cls-1"
        d="m60.92,36.33c-.28.08-.38-.21-.59-.29-.06-.02.02-.1.06-.14.21.11.39.24.53.43Z"
      />
      <path
        className="cls-1"
        d="m65.41,65.83c-.14.23-.14.53-.38.71-.04-.32.16-.52.38-.71Z"
      />
      <path
        className="cls-1"
        d="m63.04,37.69c-.27-.09-.53-.2-.73-.41.29.05.57.12.73.41Z"
      />
      <path
        className="cls-1"
        d="m56.77,33.91c-.03.26-.05.51-.08.77-.09-.11-.14-.65-.07-.75.04-.05.1-.03.15-.02Z"
      />
      <path
        className="cls-1"
        d="m30.54,44.87c.2-.15.41-.29.67-.3-.17.22-.39.32-.67.3Z"
      />
      <path
        className="cls-1"
        d="m65.88,47.36c.04-.3.19-.53.46-.68-.07.28-.25.49-.46.68Z"
      />
      <path
        className="cls-1"
        d="m52.2,71.7c.02.11-.08.15-.13.22-.12.14-.11.24.09.28-.06.14-.19.13-.25.05-.07-.09-.08-.24.02-.34.08-.08.15-.18.27-.21Z"
      />
      <path
        className="cls-1"
        d="m60.68,57.84c-.04-.19.02-.39-.05-.58-.04-.1.04-.16.13-.2-.01.26.11.53-.07.78Z"
      />
      <path
        className="cls-1"
        d="m63.45,69.74c-.1.27-.03.49.23.63-.22.08-.33-.09-.37-.24-.04-.13-.09-.33.14-.39Z"
      />
      <path
        className="cls-1"
        d="m58.57,36.5c-.13.06-.25.14-.29.29-.22-.15-.1-.27.04-.38.12-.1.21-.06.25.09Z"
      />
      <path
        className="cls-1"
        d="m61.42,57.5c.1.03.09.11.07.17-.05.15-.06.29,0,.44.03.07-.03.09-.09.09-.11-.24-.12-.48.03-.71Z"
      />
      <path
        className="cls-1"
        d="m57.19,32.69c.14.21.29.43.43.64,0,0,0,.01-.01.02,0,0-.02,0-.03,0-.25-.15-.36-.39-.39-.67Z"
      />
      <path
        className="cls-1"
        d="m60.78,56.8s-.04-.16-.11-.04c-.05.08-.1.14-.2.15.04-.09.09-.19.13-.28.04-.1.1-.24.21-.19.1.04.05.18,0,.28-.01.02-.01.05-.02.08Z"
      />
      <path
        className="cls-1"
        d="m55.02,71.02c.22-.2.49-.31.78-.34-.22.2-.51.26-.78.34Z"
      />
      <path
        className="cls-1"
        d="m68.83,41.85c-.2-.16-.34-.36-.42-.61.2.16.38.33.42.61Z"
      />
      <path
        className="cls-1"
        d="m61.55,52.23c-.04.24-.09.48-.13.72-.12-.29-.07-.55.13-.72Z"
      />
      <path
        className="cls-1"
        d="m68.1,43.93c-.07-.28-.3-.15-.47-.19.11-.11.26-.18.4-.11.1.05.15.17.06.29Z"
      />
      <path
        className="cls-1"
        d="m49.41,73.61c-.28-.08-.53-.2-.64-.5.21.17.49.25.64.5Z"
      />
      <path
        className="cls-1"
        d="m60.36,57.61c.23.16.16.38.11.6-.1-.19-.16-.38-.11-.6Z"
      />
      <path
        className="cls-1"
        d="m62.52,50.37c.04.25.19,0,.27.06.02.08-.06.1-.1.15-.07.07-.11.25-.24.13-.11-.1-.08-.24.07-.33Z"
      />
      <path
        className="cls-1"
        d="m37.1,55.44c.14.21.15.46.15.7-.18-.21-.18-.45-.15-.7Z"
      />
      <path
        className="cls-1"
        d="m47.57,72.96c.27.04.5.16.6.43-.2-.14-.44-.24-.6-.43Z"
      />
      <path
        className="cls-1"
        d="m35.85,51.09s-.08.05-.12.06c-.09.03-.17-.03-.22-.08-.09-.09.08-.08.08-.15,0-.04.03-.08.05-.12.09.08.16.18.2.3Z"
      />
      <path
        className="cls-1"
        d="m66.52,46.32c.06-.27.22-.48.42-.67-.05.28-.22.48-.42.67Z"
      />
      <path
        className="cls-1"
        d="m37.72,71.22c-.22-.21-.22-.49-.24-.77.12.25.2.5.24.77Z"
      />
      <path
        className="cls-1"
        d="m46.06,70.73c-.04.16.26.19.15.38-.11,0-.2-.07-.28-.14-.06-.06-.06-.13-.04-.2.03-.08.1-.05.16-.04Z"
      />
      <path
        className="cls-2"
        d="m65.8,45.11c.1.04.16-.2.28-.05-.04.06-.07.12-.12.17-.07.07-.14.22-.25.12-.09-.08.04-.17.09-.25Z"
      />
      <path
        className="cls-1"
        d="m37.98,53.47c.13,0,.18.19.33.12.09.13-.05.16-.11.19-.08.05-.1-.05-.13-.1-.04-.07-.06-.15-.09-.22Z"
      />
      <path
        className="cls-1"
        d="m36.52,69.64c.24.15.23.41.28.64-.13-.2-.24-.41-.28-.64Z"
      />
      <path
        className="cls-1"
        d="m64.02,69.74c.03-.22.07-.44.33-.51-.07.2-.18.37-.33.51Z"
      />
      <path
        className="cls-1"
        d="m45.18,29.29c.23-.11.4-.04.54.15-.21.05-.37-.07-.54-.15Z"
      />
      <path
        className="cls-1"
        d="m48.51,72.94c-.11.02-.21.04-.1.18.04.05.05.11-.02.13-.09.03-.1-.04-.11-.11-.01-.14-.03-.28-.05-.42.15,0,.2.12.27.22Z"
      />
      <path
        className="cls-1"
        d="m38.58,57.87c.03.24.05.48,0,.71-.13-.15-.13-.54,0-.71Z"
      />
      <path
        className="cls-1"
        d="m49.96,31.12s.02-.1.03-.1c.23,0,.42-.16.64-.2-.16.23-.43.24-.67.3Z"
      />
      <path
        className="cls-1"
        d="m37.98,59.24c-.15-.23-.1-.47-.03-.71.11.23.06.47.03.71Z"
      />
      <path
        className="cls-1"
        d="m30.62,44.2c-.09.22-.21.42-.39.58.08-.23.13-.48.39-.58Z"
      />
      <path
        className="cls-1"
        d="m66.88,42.23c-.11.13.01.31-.11.43-.09-.1-.12-.22-.11-.34.02-.14.08-.22.22-.09Z"
      />
      <path
        className="cls-2"
        d="m35.61,39.68c-.01-.07-.11-.17.05-.17.12,0,.28-.18.35.06-.13.06-.25.12-.4.11Z"
      />
      <path
        className="cls-1"
        d="m52.74,30.53c-.03.14.05.26.11.37-.13-.03-.29-.05-.31-.21-.01-.09.06-.19.19-.16Z"
      />
      <path
        className="cls-1"
        d="m33.55,41.15c0,.26-.16.4-.39.47.12-.17.22-.35.39-.47Z"
      />
      <path
        className="cls-1"
        d="m60.24,35.76c-.18.07-.2-.11-.27-.19-.06-.07-.11-.16-.16-.24.27.02.36.22.44.43Z"
      />
      <path
        className="cls-1"
        d="m31.8,46.9c.03-.09.07-.18.1-.26.11.05.22.09.29.2-.16,0-.28.02-.22.22-.07-.03-.14-.08-.17-.16Z"
      />
      <path
        className="cls-1"
        d="m50.78,30.47c-.19.14-.41.2-.65.21.18-.19.41-.2.65-.21Z"
      />
      <path
        className="cls-2"
        d="m49.73,73.09c-.05.06-.08.15-.18.14-.09-.01-.15-.06-.14-.16.02-.1.09-.11.18-.12.1,0,.09.09.13.14Z"
      />
      <path
        className="cls-1"
        d="m60.89,37.39c.21.04.42.08.49.32-.21-.03-.35-.18-.49-.32Z"
      />
      <path
        className="cls-1"
        d="m52.09,72.79c-.05.2-.19.33-.35.44.05-.2.17-.35.35-.44Z"
      />
      <path
        className="cls-1"
        d="m67.85,40c-.19-.06-.31-.16-.21-.38.13.1.16.25.21.38Z"
      />
      <path
        className="cls-1"
        d="m66.5,40.48c-.15,0-.17.14-.25.22-.19-.15.04-.22.08-.31.02-.03.18-.08.17.09Z"
      />
      <path
        className="cls-1"
        d="m51.16,74.09c-.05.19-.09.39-.28.51.01-.21.12-.38.28-.51Z"
      />
      <path
        className="cls-1"
        d="m46.68,71.75c-.14.08-.31-.08-.46.05.04-.08.07-.14.05-.21.16-.01.3.04.41.16Z"
      />
      <path
        className="cls-1"
        d="m59.75,68.86c-.01-.08.03-.13.09-.17.08.1.34-.01.28.17-.05.15-.24-.04-.37,0Z"
      />
      <path
        className="cls-1"
        d="m67.55,40.86c.18.12.22.31.25.5-.16-.13-.2-.32-.25-.5Z"
      />
      <path
        className="cls-1"
        d="m65.25,39.14c.18-.12.33-.12.44.09-.14-.07-.31,0-.44-.09Z"
      />
      <path
        className="cls-1"
        d="m68.4,41.19c-.05-.11-.39-.08-.17-.33.15.06.14.21.17.33Z"
      />
      <path
        className="cls-1"
        d="m52.47,72.36c0,.22-.15.3-.32.38.01-.2.19-.27.32-.38Z"
      />
      <path
        className="cls-1"
        d="m61.64,37.87c.22-.08.34.08.46.22-.18-.01-.32-.12-.46-.22Z"
      />
      <path
        className="cls-1"
        d="m64.92,39.06c.02-.11.09-.16.19-.13.11.03,0,.12.04.18-.08,0-.16,0-.23-.05Z"
      />
      <path
        className="cls-1"
        d="m58.77,37.34c.17.04.33.11.45.25-.18-.03-.35-.08-.45-.25Z"
      />
      <path
        className="cls-1"
        d="m62.09,62.24c.22,0,.28.12.28.31-.15-.05-.22-.18-.28-.31Z"
      />
      <path
        className="cls-1"
        d="m54.9,30.08c-.04.16.09.22.18.3-.14.13-.21,0-.26-.09-.05-.07-.07-.19.08-.21Z"
      />
      <path
        className="cls-1"
        d="m55.89,31.13c.03.13-.03.25-.07.37-.14-.16-.12-.25.07-.37Z"
      />
      <path
        className="cls-1"
        d="m38.31,53.43c-.11-.1-.15-.24-.2-.37.12.09.24.19.2.37Z"
      />
      <path
        className="cls-1"
        d="m52.51,72.88c.06-.14.1-.29.29-.3-.09.1-.11.28-.29.3Z"
      />
      <path
        className="cls-1"
        d="m47.19,71.32c-.14-.02-.34.03-.31-.23.13.04.27.07.31.23Z"
      />
      <path
        className="cls-1"
        d="m53.45,71.97c-.02-.2.09-.26.27-.22-.07.09-.13.21-.27.22Z"
      />
      <path
        className="cls-1"
        d="m37.42,54.44c-.23-.05-.12-.23-.13-.36.1.1.11.23.13.36Z"
      />
      <path
        className="cls-1"
        d="m52.24,73.15c.02-.15.13-.22.26-.27-.03.15-.14.21-.26.27Z"
      />
      <path
        className="cls-1"
        d="m42.46,31.73c0-.15.01-.29.13-.4.04.16-.01.29-.13.4Z"
      />
      <path
        className="cls-1"
        d="m61.77,60.08c-.2-.04-.1-.19-.1-.3.1.08.17.17.1.3Z"
      />
      <path
        className="cls-1"
        d="m64.19,48.84c.08.17-.06.24-.14.35-.06-.16,0-.27.14-.35Z"
      />
      <path
        className="cls-1"
        d="m38.54,56.75c.06-.05.14-.08.22-.08.04.05.05.11-.02.13-.07.03-.16.04-.2-.05Z"
      />
      <path
        className="cls-2"
        d="m44.37,70.22s.07-.08.05-.14c.07,0,.14.01.21.02h0c-.03.15-.14.14-.26.12Z"
      />
      <path
        className="cls-1"
        d="m55.8,70.25c-.02.23-.18.17-.32.16.06-.14.19-.14.32-.16Z"
      />
      <path
        className="cls-1"
        d="m33.12,41.65c-.03.14-.07.27-.23.31.05-.12.08-.26.23-.31Z"
      />
      <path
        className="cls-1"
        d="m62.75,54.24c-.09-.13-.04-.22.1-.28.02.11,0,.21-.1.28Z"
      />
      <path
        className="cls-1"
        d="m32.6,43.44c.04-.11.06-.24.21-.25-.03.12-.06.24-.21.25Z"
      />
      <path
        className="cls-1"
        d="m51.42,29.8c.1-.13.22-.11.34-.03-.1.11-.22.05-.34.03Z"
      />
      <path
        className="cls-1"
        d="m34.32,42.36c0,.13-.01.27-.21.26.01-.13.09-.21.21-.26Z"
      />
      <path
        className="cls-1"
        d="m60.9,38.69c.14.02.17.12.14.24-.18,0-.16-.12-.14-.24Z"
      />
      <path
        className="cls-1"
        d="m69,42.23c-.16-.06-.09-.23-.16-.33.17.06.13.21.16.33Z"
      />
      <path
        className="cls-1"
        d="m59.33,37.32c-.14,0-.21-.07-.24-.2.11.03.19.09.24.2Z"
      />
      <path
        className="cls-1"
        d="m67.14,42.66c-.08-.09-.13-.2-.1-.33.14.07.12.2.1.33Z"
      />
      <path
        className="cls-1"
        d="m61.96,54.82c.04.11.08.21-.04.29-.09-.11-.08-.21.04-.29Z"
      />
      <path
        className="cls-1"
        d="m62.85,53.86c-.1-.14.02-.17.11-.22.04.11,0,.18-.11.22Z"
      />
      <path
        className="cls-1"
        d="m59.04,35.87c.16,0,.2.11.19.24-.13-.03-.15-.14-.19-.24Z"
      />
      <path
        className="cls-1"
        d="m35.05,50.78c.17.02.14.16.17.27-.1-.06-.14-.16-.17-.27Z"
      />
      <path
        className="cls-1"
        d="m61.39,37.71c.08.03.25-.08.22.13-.09-.02-.2,0-.22-.13Z"
      />
      <path
        className="cls-1"
        d="m64.24,65.54c.13-.05.23-.01.31.09-.12.03-.22-.01-.31-.09Z"
      />
      <path
        className="cls-1"
        d="m67.41,40.54c.11.05.15.13.09.24-.07-.06-.14-.13-.09-.24Z"
      />
      <path
        className="cls-1"
        d="m61.76,61.59c.17.02.16.1.07.21-.1-.05-.06-.14-.07-.21Z"
      />
      <path
        className="cls-1"
        d="m47,71.93c-.12.03-.21,0-.24-.13.1,0,.19.03.24.13Z"
      />
      <path
        className="cls-1"
        d="m33.52,43.37c.08.05.07.13.08.2-.03.04-.08.05-.11,0-.04-.07-.06-.15.03-.21Z"
      />
      <path
        className="cls-1"
        d="m42.63,31.18c-.09-.09-.1-.17.03-.23.03.08.06.16-.03.23Z"
      />
      <path
        className="cls-1"
        d="m62.05,37.15c-.1-.01-.25.02-.2-.17.1.02.19.05.2.17Z"
      />
      <path
        className="cls-1"
        d="m37.02,65.77c0-.09-.04-.2.11-.22.02.1.02.19-.11.22Z"
      />
      <path
        className="cls-1"
        d="m67.16,44.25c.01.1-.05.14-.13.16-.05-.12.04-.15.13-.16Z"
      />
      <path
        className="cls-1"
        d="m46.87,71.1c-.12.02-.23.03-.23-.15.08.05.15.1.23.15Z"
      />
      <path
        className="cls-1"
        d="m61.12,36.51c-.12.01-.16-.06-.16-.16.12,0,.17.04.16.16Z"
      />
      <path
        className="cls-1"
        d="m36.7,66.26c-.03-.1.03-.14.11-.17.06.12-.06.12-.11.17Z"
      />
      <path
        className="cls-1"
        d="m43.25,70.63c-.07.04-.14.06-.19-.03.08-.08.13-.04.19.03Z"
      />
      <path
        className="cls-1"
        d="m56.15,31.09c-.05,0-.11-.02-.16-.03,0-.06.02-.1.08-.1.08,0,.11.05.07.12Z"
      />
      <path
        className="cls-1"
        d="m64.05,65.17c0,.07,0,.15,0,.22-.15-.08-.14-.15,0-.22Z"
      />
      <path
        className="cls-1"
        d="m58.39,33.42c-.1-.02-.1-.1-.09-.18.14,0,.11.09.09.18Z"
      />
      <path
        className="cls-1"
        d="m37.23,56.2c.09.06.1.12,0,.17-.07-.06-.08-.11,0-.17Z"
      />
      <path
        className="cls-1"
        d="m64.65,65.66c.09-.1.14-.06.17.04-.06,0-.13.05-.17-.04Z"
      />
      <path
        className="cls-1"
        d="m51.06,30.43c-.04.1-.1.12-.17.02.05-.05.11-.04.17-.02Z"
      />
      <path
        className="cls-1"
        d="m54.65,69.92c-.02.16-.13.11-.22.1.05-.08.12-.12.22-.1Z"
      />
      <path
        className="cls-1"
        d="m35.63,50.78s-.09.06-.13,0c0,0,.04-.04.07-.07.05,0,.06.03.06.07Z"
      />
      <path
        className="cls-1"
        d="m61.56,36.78c-.09.02-.17.02-.16-.11.09-.01.15.02.16.11Z"
      />
      <path
        className="cls-1"
        d="m60.38,35.88c-.15.07-.13-.04-.13-.12.08,0,.12.05.13.12Z"
      />
      <path
        className="cls-1"
        d="m34.52,48.05c-.13.02-.11-.08-.11-.15.1,0,.12.07.11.15Z"
      />
      <path
        className="cls-1"
        d="m44.75,28.65c-.06.12-.08.03-.11-.02.05-.06.09-.05.11.02Z"
      />
      <path
        className="cls-1"
        d="m58.51,33.63c-.1-.02-.11-.09-.1-.17.08.03.14.07.1.17Z"
      />
      <path
        className="cls-1"
        d="m47.87,72.54c-.11.03-.13-.04-.14-.13.15-.07.13.04.14.13Z"
      />
      <path
        className="cls-1"
        d="m60.73,37.28c.09-.01.16,0,.16.11-.09.01-.14-.03-.16-.11Z"
      />
      <path
        className="cls-1"
        d="m37.13,65.55c0-.08,0-.16.11-.16.02.09,0,.15-.11.16Z"
      />
      <path
        className="cls-1"
        d="m64.81,66.8c.01.08.01.16-.09.17-.04-.09.01-.14.09-.17Z"
      />
      <path
        className="cls-1"
        d="m42.4,29.34c.07,0,.1.05.09.11-.01.06-.06.05-.11.03,0-.05.01-.09.02-.14Z"
      />
      <path
        className="cls-1"
        d="m38.09,53c-.07-.03-.1-.08-.09-.16.08.02.08.1.09.16Z"
      />
      <path
        className="cls-1"
        d="m38.98,71.2c.05-.07.09-.12.17-.03-.05.05-.11.04-.17.03Z"
      />
      <path
        className="cls-1"
        d="m56.57,30.14c.08.04.09.08,0,.12-.06-.04-.04-.08,0-.12Z"
      />
      <path
        className="cls-1"
        d="m63.99,63.6c-.09,0-.11-.04-.1-.12.07,0,.1.05.1.12Z"
      />
      <path
        className="cls-1"
        d="m60.45,60.32c.07.03.07.08.04.14-.06-.03-.08-.08-.04-.14Z"
      />
      <path
        className="cls-1"
        d="m56.53,29.93c.08.04.08.07,0,.11-.06-.04-.06-.07,0-.11Z"
      />
      <path
        className="cls-1"
        d="m39.36,71.15c.03-.06.07-.06.11-.01-.03.05-.07.05-.11.01Z"
      />
      <path
        className="cls-1"
        d="m61.67,61.19c.05.03.07.07.04.13-.07-.02-.09-.06-.04-.13Z"
      />
      <path
        className="cls-1"
        d="m61.85,36.97c-.09.04-.13.01-.12-.09.07-.02.11.01.12.09Z"
      />
      <path
        className="cls-1"
        d="m55.12,70.54c.03.1-.02.13-.11.11,0-.08.03-.12.11-.11Z"
      />
      <path
        className="cls-1"
        d="m58.65,36.63c-.09,0-.1-.06-.08-.13.08.01.1.06.08.13Z"
      />
      <path
        className="cls-1"
        d="m38.72,56.14s-.04-.06-.02-.09c.02.02.05.04.06.07,0,.02-.01.04-.04.03Z"
      />
      <path
        className="cls-1"
        d="m57.57,33.47c.06.03.07.07.04.13-.05-.03-.09-.06-.04-.13Z"
      />
      <path
        className="cls-1"
        d="m64.6,39c.05-.06.08-.02.11.03-.05.04-.08.01-.11-.03Z"
      />
      <path
        className="cls-1"
        d="m64.05,65.4c.08-.01.12.02.12.1-.08.01-.11-.03-.12-.1Z"
      />
      <path
        className="cls-1"
        d="m47.48,72.23c-.09.02-.13,0-.12-.1.08-.02.13,0,.12.1Z"
      />
      <path
        className="cls-1"
        d="m35.24,51.08c.08,0,.09.06.09.13-.07-.02-.1-.05-.09-.13Z"
      />
      <path
        className="cls-1"
        d="m55.3,70.47c-.02.1-.07.11-.14.06.02-.09.07-.1.14-.06Z"
      />
      <path
        className="cls-1"
        d="m46.59,30.59s-.07.02-.1-.02c-.02-.03.01-.05.03-.05.03.01.04.04.07.06Z"
      />
      <path
        className="cls-1"
        d="m51.71,73.28c.01.07-.01.11-.09.12-.01-.07.02-.11.09-.12Z"
      />
      <path
        className="cls-1"
        d="m40.07,36.24c-.02-.09.03-.11.11-.11.01.08-.06.09-.11.11Z"
      />
      <path
        className="cls-1"
        d="m41.36,69.92c.03-.08.09-.07.15-.04-.04.05-.09.08-.15.04Z"
      />
      <path
        className="cls-1"
        d="m38.49,64.24c-.02-.07,0-.12.08-.12.01.07-.05.08-.08.12Z"
      />
      <path
        className="cls-1"
        d="m38.59,64.08s-.02-.06.02-.09c.07.04,0,.06-.02.09Z"
      />
      <path
        className="cls-1"
        d="m56.55,69.31s0-.05.01-.07c.01.02.02.04.04.06h-.02s-.03.01-.03.01Z"
      />
      <path
        className="cls-1"
        d="m61.67,52.01s.06.03.06.03c-.01.05-.05.03-.08.02,0-.02.01-.04.02-.05Z"
      />
      <path
        className="cls-1"
        d="m61.33,59.68s.03.01.04.02c-.01.01-.03.02-.04.04,0-.02,0-.04,0-.05Z"
      />
      <path
        className="cls-1"
        d="m61.65,59.74s-.02-.01-.04-.02c.01-.01.03-.02.04-.03,0,.02,0,.04,0,.05Z"
      />
      <path className="cls-1" d="m44.63,70.1h0s.01,0,.02,0c0,0-.01,0-.02,0Z" />
      <path
        className="cls-1"
        d="m30.23,44.78s0,.04-.01.06c-.01-.02-.02-.03-.03-.05h.04Z"
      />
      <path
        className="cls-1"
        d="m58.66,35.38s.06,0,.06.05c-.02-.02-.04-.03-.06-.05Z"
      />
      <path
        className="cls-1"
        d="m36.93,64.98c.03-.14.11-.21.22-.22.04,0,.08.06.07.1-.04.15-.16.12-.29.12Z"
      />
      <path
        className="cls-1"
        d="m48.12,73.01s.01-.05.02-.07c0,0,.01,0,.02.01-.01.02-.03.04-.04.06h0Z"
      />
      <path
        className="cls-1"
        d="m48.12,73s-.04.03-.05.04c-.01-.06.04-.03.06-.04,0,0,0,0,0,0Z"
      />
      <path
        className="cls-1"
        d="m49.39,29.51s-.02.04-.03.04c-.02,0-.03,0-.05,0-.02-.01-.02-.03,0-.04.02,0,.05,0,.08,0Z"
      />
      <polygon
        className="cls-1"
        points="48.9 29.47 48.91 29.46 48.91 29.48 48.9 29.47"
      />
      <path
        className="cls-1"
        d="m31.69,43.42s.01,0,.02,0c0,0-.01,0-.02-.01,0,0,0,0,0,0Z"
      />
      <path
        className="cls-2"
        d="m41.64,35.18s.09.02.09.08c0,.01-.02.02-.03.03-.03-.03-.06-.06-.09-.09,0-.01.01-.02.02-.02Z"
      />
    </Icon>
  );
}

export function IconRaffia({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="18 27 63 46"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #919191; }`}
          {`.cls-2 { fill: #555; }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m33.16,38.56c.39.11.74-.07,1.1-.15,1.62-.38,3.24-.79,4.86-1.18,1.37-.33,2.75-.65,4.12-.97.15-.04.19-.08.16-.24-.08-.58-.1-1.17-.26-1.74-.06-.23-.05-.46-.01-.74.33.42.31.9.38,1.33.05.31.15.62.19.93.02.17.14.29.34.24.69-.18,1.38-.33,2.09-.44.11-.02.14-.08.17-.16.12-.04.23.07.34.01.22.05.4-.1.6-.15,1.26-.26,2.51-.54,3.76-.81,1.89-.42,3.78-.85,5.68-1.25.33-.07.43-.19.37-.54-.16-.93-.28-1.87-.39-2.81-.04-.29,0-.58,0-.99.16.44.3.77.32,1.13.06.89.23,1.76.4,2.63.06.32.17.36.47.28.59-.15,1.19-.26,1.79-.4.16-.04.35-.04.44-.23.19.04.36.02.53-.07.35.02.67-.11,1-.18.56-.12,1.13-.25,1.7-.31-.09.2-.29.16-.44.19-2.48.57-4.97,1.12-7.45,1.71-1.52.36-3.05.71-4.58,1.06-.4.09-.81.15-1.18.37.06.03.13.05.18.03,1.14-.25,2.27-.51,3.41-.76.19-.04.38-.17.59-.04-.03.08-.1.1-.17.12-2.07.46-4.14.91-6.2,1.38-.24.05-.56,0-.66.35-.19-.12-.21-.02-.23.15-.03.27.18.53.03.81-.12-.24-.14-.51-.19-.77-.02-.13-.04-.29-.24-.25-.68.15-1.36.3-2.04.45-.15.03-.23.09-.22.27.02.75.33,1.44.45,2.16.02.15.13.15.26.12.65-.16,1.31-.32,1.97-.48.15-.03.2-.12.22-.25.14.03.27.13.41,0,.57.03,1.13-.14,1.65-.29,1.52-.45,3.07-.75,4.6-1.12,1.25-.31,2.51-.58,3.77-.88.17-.04.31-.1.27-.31-.1-.62-.16-1.24-.32-1.84-.05-.18-.13-.25-.31-.21-.25.05-.5.11-.76.15-.6.1-1.17.34-1.79.35.01-.11.09-.12.18-.14.66-.14,1.31-.31,1.98-.42.57-.1,1.11-.33,1.7-.31-.04.09-.13.12-.21.12-.28.02-.37.11-.37.43-.01.57.2,1.1.24,1.65.02.2.14.35.44.27.63-.16,1.26-.32,1.9-.43.17-.03.45,0,.51-.27.18.15.36.04.53,0,.68-.03,1.32-.28,1.98-.41.82-.16,1.64-.36,2.46-.55.04,0,.1.01.14.02-.01.09-.08.11-.16.13-.58.14-1.16.3-1.75.43-1.97.46-3.94.91-5.91,1.37-.07.02-.21,0-.21.18.49-.11.96-.23,1.44-.32.22-.04.43-.2.67-.05-.2.22-.49.17-.74.25-.38.11-.79.11-1.12.35-.26-.03-.32.1-.26.32.05.16.07.33.04.5-.16-.02-.14-.14-.15-.25-.05-.53-.09-.56-.61-.43-1.16.3-2.35.47-3.51.79-1.9.52-3.83.93-5.74,1.38-.26.06-.43.15-.4.45-.11-.04-.06-.28-.23-.22-.17.06-.07.23-.09.35-.02.13.12.25,0,.37-.1-.08-.1-.2-.1-.31-.01-.36-.17-.43-.5-.33-.54.16-1.1.27-1.65.4-.15.03-.29.06-.39.18-.23-.04-.3.1-.32.29-.19-.27-.44-.26-.71-.14-.07.03-.14.04-.21.05-2.99.69-5.97,1.39-8.96,2.07-.25.06-.49.09-.4.45-.15-.05-.35-.32-.39.09-.12-.38-.38-.35-.68-.25-.2.07-.42.13-.63.15-.39.03-.64.15-.6.59-.1-.13-.13-.37-.39-.23-.49-.05-.94.12-1.41.22-2.29.48-4.55,1.15-6.86,1.55-.39.07-.75.3-1.28.16.28-.11.47-.21.68-.25,1-.16,1.94-.53,2.92-.76.52-.12,1.06-.16,1.58-.31.89-.25,1.77-.52,2.69-.68.41-.07.8-.22,1.2-.31.19-.05.25-.14.23-.34-.07-.69-.27-1.36-.39-2.04-.05-.27-.22-.2-.39-.15-1.74.47-3.49.95-5.23,1.41-2.09.54-4.14,1.26-6.25,1.74-.34.08-.65.27-1.07.17.19-.17.36-.27.55-.29.37-.03.69-.18,1.02-.3,1.01-.37,2.06-.57,3.08-.9,1.85-.58,3.7-1.17,5.58-1.65.7-.18,1.4-.38,2.1-.58.44-.13.54-.05.41-.63-.2-.87-.3-1.76-.51-2.63-.14-.61-.21-1.23-.32-1.84-.02-.11-.07-.3.05-.33.16-.04.19.16.22.27.3,1.1.43,2.24.7,3.35.11.45.13.91.31,1.34.06.14.12.21.27.16.54-.17,1.11-.19,1.63-.42.1-.04.15-.11.21-.19.1.02.19,0,.28-.05Zm-.17,1.1c-.11-.21-.14-.54-.5-.4-.44.18-.9.29-1.36.41-.17.05-.19.14-.18.3.05.72.3,1.39.43,2.09.04.18.12.21.29.16.48-.12.96-.23,1.43-.33.1-.02.14-.08.16-.17.13,0,.26.02.38-.06.13.05.24.06.39.03,1.44-.36,2.88-.73,4.33-1.05,1.75-.39,3.48-.83,5.21-1.26.21-.05.38-.09.33-.37-.11-.66-.21-1.32-.31-1.98-.04-.25-.17-.38-.43-.31-.24.07-.48.18-.72.24-2.69.59-5.34,1.29-8.04,1.84-.39.08-.82.15-1.14.43-.38-.06-.15.3-.28.42Z"
      />
      <path
        className="cls-2"
        d="m76.23,60.5c-.16,0-.31.05-.43-.17-.12-.2-.4-.1-.57-.05-.46.14-.92.09-1.38.14-.77.1-1.56.1-2.34.18-.82.09-1.63.21-2.44.34-.2.03-.39.03-.59.03-.46,0-.54.15-.41.59.28.95.57,1.9.78,2.87-.01.05-.02.1.03.14.2.42.29.87.35,1.33.03.21.06.42.14.62,0,.22,0,.43.18.6.26.96.38,1.95.55,2.93-.29-.08-.43.28-.71.23-.07-.36-.14-.71-.2-1.07.05-.13.09-.26-.07-.34-.05-.26-.1-.51-.15-.77.05-.08.04-.14-.04-.18-.32-1.34-.64-2.67-.97-4.01-.17-.7-.44-1.36-.54-2.08-.07-.53-.25-.63-.8-.55-.62.09-1.25.18-1.86.32-.35.08-.72-.04-1.04.16-.02,0-.04,0-.06,0h.06c.38,1.81.83,3.58,1.26,5.36.2.86.41,1.71.68,2.54-.2-.05-.39-.05-.59-.01l-.65-2.31c.05-.63-.22-1.2-.33-1.8-.04-.22-.02-.49-.24-.66-.02-.11-.05-.21-.07-.32.06-.11.03-.17-.09-.19-.17-.81-.34-1.63-.51-2.44.08-.06.21-.03.26-.19-.15-.01-.3-.09-.37.11-.32-.1-.55.17-.85.19-.13,0-.26.04-.39.04-.06-.07-.1-.06-.15.01-.06.01-.12.02-.19.03-.45-.02-.89,0-1.29.25-.12,0-.24,0-.35.01-.44.04-.88.04-1.27.28-1.02.21-2.03.43-3.05.63-.33.07-.68.08-1.01.15-.63.14-1.26.31-1.89.46-.08.02-.17.01-.26.02-.25,0-.5-.03-.68.21-.51.11-1.03.2-1.53.33-.11.03-.22,0-.32.03-.25-.05-.49-.05-.67.17-.69.04-1.32.33-1.99.43-.05-.05-.1-.05-.17-.04-.53.12-1.06.24-1.6.35-.08.02-.12.06-.16.13-.8.17-1.6.33-2.39.53-.98.23-1.95.49-2.93.74-.27-.01-.54-.01-.76.17-.13.03-.26.06-.4.09-.21-.04-.4-.02-.57.14-.05,0-.09.02-.14.03-.36-.03-.68.06-.97.29-1.27.31-2.54.62-3.82.93-.91.22-1.81.42-2.72.64-.16.04-.33.09-.49.13-.07-.09-.12-.04-.16.03-.07.02-.14.03-.21.05-.08-.1-.13-.05-.16.04-.04,0-.09.02-.13.03-.17-.15-.35.11-.53-.02.29-.19.65-.2.92-.42.04-.01.09-.02.13-.04.17.08.28.01.38-.12.05,0,.09-.01.14-.02.29.12.52-.06.75-.18.04-.01.09-.03.13-.04.08.09.13.03.16-.05.04-.01.09-.02.13-.04.16.08.28,0,.38-.11.04-.01.09-.03.13-.04.68-.04,1.3-.29,1.93-.5.05,0,.09-.02.14-.03.08.09.13.04.16-.04.92-.24,1.84-.5,2.77-.73.58-.14,1.16-.26,1.73-.43.33.03.62-.07.89-.23.39-.1.79-.19,1.18-.29.08.09.13.04.16-.05l.14-.03c.08.09.12.04.16-.05.05-.01.09-.02.14-.03.08.09.12.04.16-.05l.14-.03c.24.02.47.05.67-.13.52-.13,1.03-.26,1.55-.4.08.09.12.05.16-.04.05,0,.09-.02.14-.03.28.04.53-.03.75-.19.85-.22,1.71-.42,2.56-.65.44-.12.91-.07,1.34-.26.25,0,.5.01.69-.19.42-.08.84-.16,1.25-.24.1,0,.22.06.3-.05.12-.04.24-.07.35-.11.39-.02.79-.03,1.13-.28.55-.04,1.09-.19,1.63-.31.42.01.82-.07,1.2-.26.07-.01.14-.02.21-.03.42,0,.82-.08,1.2-.26.95-.17,1.89-.37,2.85-.53,1.04-.17,2.06-.43,3.11-.55.27.08.47-.09.68-.19.16-.02.31-.04.47-.06.86-.11,1.69-.38,2.57-.4.22,0,.45.04.65-.03.2-.07.47.07.62-.19.95-.06,1.86-.32,2.81-.41.25.19.46.11.67-.07.05,0,.09.01.14.02.38,0,.76-.02,1.12-.14.21,0,.43-.02.64-.02.23-.02.5.15.69-.13.05,0,.1,0,.15-.01.09.11.17.1.24-.02.93-.07,1.86-.15,2.79-.08.02.29-.21.24-.38.28q-.58.13-.51.63Z"
      />
      <path
        className="cls-2"
        d="m31.15,42.84c.26-.14.29.1.39.23.06.3.11.59.17.89-.01.11-.04.23.09.31.01.05.02.09.03.14-.09.1-.06.17.04.23,0,.05.02.09.03.14-.05.32.05.61.18.9,0,.05.02.09.03.14-.07.17.02.3.09.43.06.48.25.93.24,1.42.11.64.21,1.29.42,1.91.06.33.12.67.18,1,.03.15.11.22.26.18.51-.14,1.02-.29,1.52-.43.22.03.43.02.59-.16.55-.14,1.1-.26,1.64-.41,1.27-.34,2.55-.69,3.83-.96.08.09.12.04.16-.04.12-.02.24-.03.36-.07,1.02-.31,2.07-.47,3.1-.74.09.01.19.03.24-.08.17-.04.34-.08.5-.12.28.03.53-.03.75-.2.09-.01.19-.02.28-.03.09.1.13.04.16-.05.05,0,.09-.02.14-.02.04.06.1.06.16.04.46-.12.93-.2,1.39-.3.24-.05.58,0,.74-.29.12-.02.24-.03.37-.05.11.11.18.08.23-.05.07,0,.14-.02.2-.03.14,0,.32.08.38-.14.05,0,.1,0,.15,0,.49.07.92-.19,1.39-.26.15-.03.36.03.46-.17.05,0,.1-.01.15-.02.14.12.28,0,.41-.03.88-.18,1.75-.38,2.62-.56.75-.15,1.5-.29,2.21-.57.07-.01.15-.02.22-.03.35.06.68-.09,1.01-.13.1-.01.24.03.26-.14.21-.03.35-.08.24-.35-.07-.17-.07-.37-.1-.56,0-.04,0-.08-.01-.13-.09-.06-.07-.15-.08-.23.04-.24-.02-.46-.13-.68-.11-.51-.21-1.03-.32-1.54.03-.11.05-.22-.05-.3,0-.05-.02-.09-.02-.14.03-.09.04-.17-.05-.23-.13-.49-.23-.98-.29-1.48.09-.25,0-.47-.12-.68,0-.05-.02-.09-.03-.14.07-.21.05-.4-.17-.52,0-.12,0-.24-.01-.36.03-.17,0-.33-.04-.5-.06-.22,0-.35.26-.32.01.06.03.13.04.19-.05.07-.04.13.02.18.15.81.26,1.62.44,2.43.37,1.66.62,3.35,1.04,5,.05.18.07.2.25.16.8-.18,1.61-.32,2.42-.48.38.06.73,0,1.04-.24.05,0,.1,0,.14,0,.1.12.18.09.23-.05.32-.07.64-.15.96-.22.12.09.23.09.31-.06.05,0,.09-.01.14-.02.1.1.18.08.23-.05.05,0,.09-.01.14-.02.08.09.13.05.16-.04.19-.04.39-.07.58-.11.08.1.13.06.16-.04.07-.01.14-.02.21-.04.2.07.38.03.53-.11.07-.01.14-.02.21-.03.08.1.13.05.16-.04.05,0,.09-.01.14-.02.1.09.18.07.23-.05.05,0,.09-.01.14-.02.27.06.51-.02.74-.15.06-.01.13-.03.19-.04.07.04.13.04.18-.03.49-.11.96-.29,1.47-.23.5-.01.97-.19,1.46-.28.24-.05.51,0,.7-.21.07,0,.14-.02.2-.03.29.1.56-.02.81-.09.4-.11.84-.07,1.2-.33.07-.01.14-.02.21-.03.19.09.37-.02.55-.04.07-.01.15-.03.19.06.03.08-.01.14-.06.2-.1.13-.25.13-.39.18-.1.04-.26-.03-.28.15-1.82.39-3.64.78-5.46,1.16-.72.15-1.45.25-2.18.39-.96.19-1.92.41-2.88.63-.1.02-.19.02-.29.03-.09-.1-.21-.06-.31-.04-1.46.3-2.92.6-4.38.9-.15.03-.29.08-.27.28-.08-.08-.18-.11-.29-.09-.28-.14-.52.04-.77.09-1.56.31-3.12.64-4.67.97-.14.03-.34-.01-.4.19-.16.01-.32,0-.48.04-.82.18-1.65.37-2.47.56-.46-.02-.88.17-1.33.24-.16.03-.38.03-.47.23-.13.02-.27.03-.4.06-.65.16-1.29.33-1.95.43-.27,0-.55-.04-.75.21-.14.02-.28.03-.43.07-.39.11-.79.17-1.19.24-.64.03-1.24.28-1.86.39-.03,0-.05.08-.08.12-.57-.02-1.07.3-1.63.36-.05-.05-.1-.05-.17-.04-1.26.31-2.53.62-3.79.93-.08.02-.18.02-.19.13-.12.02-.24.05-.36.07-.3-.04-.57.04-.82.21h-.13c-.05-.05-.08-.03-.08.03-.46.13-.91.33-1.39.39-.23-.04-.42.04-.61.15-1.7.46-3.39.93-5.09,1.39-.42.12-.82.3-1.26.3-.1-.01-.19-.03-.24.09-.04.01-.09.02-.13.03-.11-.09-.18-.07-.23.06-.04.01-.09.03-.13.04-.11-.18.02-.21.15-.27.3-.12.65-.13.89-.38.29-.08.59-.15.88-.23.08.09.13.04.16-.04.12-.03.24-.07.36-.1.08.09.13.03.16-.05,1.29-.36,2.57-.72,3.86-1.07.55-.15.55-.14.48-.68.11-.08.07-.13-.04-.16-.01-.07-.02-.14-.04-.21.11-.08.07-.13-.04-.16-.01-.07-.02-.14-.03-.21.11-.08.06-.13-.04-.16-.01-.07-.02-.14-.04-.21.11-.08.06-.13-.04-.16-.02-.09-.03-.19-.05-.28.11-.08.07-.13-.04-.16-.01-.07-.02-.14-.03-.21.11-.08.07-.13-.04-.16-.01-.07-.02-.14-.03-.21.11-.08.07-.13-.04-.16-.02-.09-.03-.19-.05-.28.12-.08.07-.13-.04-.16-.01-.07-.02-.14-.03-.21.11-.08.07-.13-.04-.16-.01-.07-.02-.14-.03-.21.12-.11.09-.18-.05-.23-.01-.07-.02-.14-.03-.21.07-.03.06-.09.05-.15-.17-.92-.33-1.84-.51-2.76-.03-.14.06-.37-.19-.42,0-.1-.05-.21.03-.3Z"
      />
      <path
        className="cls-2"
        d="m72.18,44.26c-.19.1-.37.24-.6.22-.04-.06-.1-.05-.16-.04-1.23.29-2.46.57-3.69.85-.08.02-.14.05-.14.14-1.12.32-2.26.55-3.4.79-.28.06-.33.13-.24.43.22.78.33,1.6.54,2.39.22.82.43,1.65.62,2.48.18.8.45,1.6.7,2.39,0,.14-.09.32.14.38.26.88.51,1.76.77,2.64-.18.23-.43.17-.67.16-.04-.13-.07-.26-.11-.4.09-.18.04-.31-.13-.41l-.04-.14c.12-.17.04-.28-.11-.37-.18-.63-.36-1.27-.54-1.9,0-.49-.13-.93-.36-1.35,0-.02,0-.05,0-.07.03-.4-.03-.78-.29-1.11-.09-.63-.42-1.19-.5-1.82.07-.09.05-.15-.05-.2-.02-.07-.03-.14-.05-.21.08-.21.04-.38-.14-.52,0-.07,0-.14-.01-.21.06-.24-.09-.41-.2-.6,0-.05-.02-.09-.03-.14.03-.06.03-.12-.04-.16-.01-.07-.03-.14-.04-.2.03-.07.03-.12-.04-.17l-.03-.14c.03-.09.04-.17-.05-.24l-.02-.13c.03-.11.01-.19-.13-.17-.46.09-.92.2-1.37.33-.49.14-.99.3-1.52.33-.36,0-.72,0-1.04.23-.49.1-.98.21-1.47.31-.4,0-.78.05-1.12.28-.27.05-.53.11-.8.16-.44.04-.88.09-1.27.32-.78.11-1.52.41-2.29.57-.43-.07-.82.06-1.19.28-.13-.01-.25.04-.37.09-.31-.09-.58,0-.82.2-.16.11-.34.07-.51.08-.27,0-.53.07-.79.13-1.25.3-2.5.59-3.74.92-.4.11-.84.13-1.19.39-.07.03-.13.07-.2.09-1.71.45-3.42.91-5.14,1.35-.73.19-1.48.32-2.18.6-.33,0-.65.05-.91.27-.05.01-.09.02-.14.04-.25-.11-.43.01-.61.17-.05.02-.09.03-.14.05-.42-.06-.77.11-1.1.32-.89.24-1.78.5-2.66.79-1.07.35-2.13.73-3.23.98-.1-.07-.17-.04-.19.08-.05,0-.09.01-.14.02-.05-.07-.1-.14-.15-.22.05-.02.1-.04.15-.07.17.08.29.02.38-.13.56-.2,1.13-.4,1.69-.59.09.09.17.07.24-.04.04-.01.09-.02.13-.04.17.08.28.01.38-.12.18-.03.32-.17.51-.16.08.08.12.03.16-.05.12-.04.24-.08.35-.11.36-.06.75-.02,1.04-.3.05-.01.09-.02.14-.03.09.12.13.05.16-.05.08-.07.19-.08.29-.1.04.07.09.06.16.04.48-.15.96-.28,1.44-.44.1-.03.23-.02.26-.17l.13-.02c.29.06.56-.08.82-.17.43-.15.9-.17,1.27-.47l.14-.03c.17.1.29.03.38-.12.12-.03.24-.07.36-.1.09.12.13.05.16-.05.05-.01.09-.02.14-.03.17.11.29.03.38-.12.05-.01.09-.02.14-.03.09.12.13.05.16-.04.2-.1.43-.13.65-.17.26-.03.55.05.75-.22.06-.08.15-.04.23-.07.09.11.13.05.16-.05.12-.03.24-.07.36-.1.09.11.13.05.16-.05.05,0,.09-.02.14-.03.2.15.34.06.45-.12.12-.03.24-.07.36-.1.09.11.13.05.16-.05.05,0,.09-.02.14-.03.09.11.13.05.16-.05.05-.01.09-.02.14-.03.25.09.43-.02.6-.18.24-.06.49-.12.73-.18.09.11.13.05.16-.05.05,0,.09-.02.14-.03.39.14.67-.08.97-.27.05,0,.09,0,.14-.01.66,0,1.25-.26,1.87-.42.02,0,.04-.06.05-.09.05-.01.09-.02.14-.03.09.12.13.05.16-.04.05-.01.09-.02.14-.03.07.11.15.04.23.02,1.48-.37,2.96-.74,4.44-1.11.1-.02.2-.02.22-.15.24.03.43-.16.66-.16.21.09.38.03.53-.13.22-.05.45-.1.67-.15.45-.09.92-.11,1.32-.36.17-.03.34-.07.5-.1.14,0,.3.07.39-.1.05,0,.09-.02.14-.02.08.09.13.04.16-.05.04,0,.09-.02.13-.03.11.09.18.07.23-.06.05,0,.09-.02.14-.02.18.05.33.04.46-.12.05,0,.09-.02.14-.02.09.1.13.04.16-.05.27-.06.53-.13.8-.19.08.1.13.06.16-.04.24-.06.49-.12.73-.18.21.08.38.04.52-.14.07,0,.15-.01.22-.02.46-.05.93-.08,1.35-.34.05,0,.09-.02.14-.02.09.1.13.04.16-.05.04,0,.09-.02.13-.02.07.09.15.04.23.02.59-.14,1.19-.27,1.78-.43.12-.03.32.02.36-.19.62-.14,1.24-.28,1.86-.42.07-.02.14-.02.21-.03.08.1.13.05.16-.04.07-.01.14-.02.21-.04.09.1.13.05.16-.05.05,0,.09-.02.14-.02.09.1.13.04.16-.05.05,0,.09-.02.14-.02.08.09.13.04.16-.05.81-.19,1.62-.39,2.43-.58.4-.09.8-.18,1.2-.25.25-.04.42-.32.71-.22-.03.2.2.31.17.51Z"
      />
      <path
        className="cls-1"
        d="m33.27,53.99c.34-.22.69-.38,1.1-.32-.14.18-.5.02-.53.36-.32-.05-.49.04-.35.4.02.06.02.12.04.18.46,1.9.89,3.8,1.39,5.69.29,1.12.52,2.25.86,3.35.15.5.17.5.67.35.09.12.22.08.34.06.36-.08.72-.21,1.08-.27.29-.05.39-.2.38-.46.36.26.47.25.58-.07.2.23.47.21.7.11.17-.07.34-.12.52-.16,1.62-.35,3.21-.79,4.83-1.14.95-.2,1.89-.48,2.84-.71.56-.14.56-.12.49-.67-.03-.22-.08-.43-.13-.65-.03-.15-.19-.31-.04-.48.12.05.14.15.16.26.05.26.08.53.17.79.05.16-.03.46.28.43.3-.03.05-.31.16-.44.03.04.08.07.09.11.03.37.23.39.53.28.24-.09.49-.12.74-.18.2-.05.45-.05.59-.17.19-.16-.08-.39-.03-.6,0-.01,0-.02.01-.04.09.02.12.08.12.16.02.39.24.42.54.29.06.02.13.06.17.05.41-.16.85-.21,1.28-.31,1.06-.24,2.11-.51,3.17-.76,1.05-.24,2.1-.48,3.16-.71.66-.14,1.3-.36,1.98-.38-.26.26-.63.25-.94.32-3.02.72-6.06,1.4-9.08,2.1-.65.15-1.29.31-1.97.48.11.11.17.07.24.06,1.19-.28,2.38-.56,3.58-.81.17-.04.36-.19.55-.03-.07.1-.17.13-.28.15-.43.09-.86.2-1.3.28-.24.04-.36.14-.34.38-.1-.07-.1-.29-.31-.19-.19.09-.13.22-.11.37.03.26.25.5.09.79-.12-.2-.12-.45-.2-.66-.11-.29-.24-.47-.61-.33-.32.12-.67.16-1,.21-.21.03-.33.13-.37.33-.19-.12-.39-.09-.58,0-.11-.06-.22-.08-.35-.05-1.96.53-3.97.86-5.94,1.39-.94.25-1.88.47-2.83.67-.22.05-.3.15-.28.35-.12-.1-.25-.21-.42-.12-.19.1-.04.29-.1.42-.02,0-.06-.01-.07-.03-.09-.5-.41-.34-.71-.25-.17.05-.35.09-.53.13-.25.06-.49.07-.49.45,0,.28-.5.39-.7.13-.19-.24-.37-.21-.61-.15-1.64.41-3.3.77-4.93,1.21-1.03.28-2.08.44-3.12.65-.59.12-1.17.27-1.8.13.41-.1.82-.25,1.23-.3.54-.07,1.06-.22,1.58-.34,1-.22,2-.44,3-.68.9-.22,1.79-.51,2.7-.7.46-.09.88-.29,1.34-.36.13-.02.26-.05.19-.26-.51-1.64-.92-3.32-1.29-5-.36-1.63-.76-3.25-1.11-4.88-.02-.07,0-.15,0-.22Zm15.72,7.33s-.04-.03-.06-.02c-.01,0-.02.04-.03.06.02,0,.04.03.06.02.01,0,.02-.04.03-.06Z"
      />
      <path
        className="cls-2"
        d="m53.53,60.45c-.19-.16-.38-.01-.55.03-1.2.26-2.39.54-3.58.81-.07.02-.13.05-.24-.06.68-.17,1.33-.33,1.97-.48,3.03-.7,6.06-1.38,9.08-2.1.31-.07.68-.06.94-.32.05,0,.09-.01.14-.02.48.06.91-.18,1.37-.23.07,0,.11-.05.11-.12.48-.04.92-.27,1.41-.24.57-.05,1.1-.23,1.66-.33.02,0,.03-.06.05-.09.05-.01.09-.02.14-.03.04.1.11.06.18.04.47-.1.95-.2,1.43-.31.24-.06.51,0,.7-.21.07-.01.14-.02.21-.04.09.12.13.06.16-.05.05,0,.09,0,.14,0,.09.1.13.05.16-.05.05,0,.09-.01.14-.02.11.1.18.08.23-.06.05,0,.09-.01.14-.02.11.1.18.08.23-.06.05,0,.09-.01.14-.02.11.11.18.08.23-.06.05,0,.09-.01.14-.02.11.1.18.08.23-.06.05,0,.09-.01.14-.02.33.11.63-.07.94-.12.26-.05.56,0,.77-.23.07,0,.14-.02.21-.03.09.1.13.05.16-.05.07,0,.14-.02.21-.03.11.1.18.08.23-.05.07,0,.14-.02.21-.02.11.11.18.08.23-.05.05,0,.09-.01.14-.02.24.05.48.06.68-.13.07,0,.14-.02.21-.02.09.11.13.06.16-.05.07,0,.14-.02.21-.02.11.11.18.09.23-.05.05,0,.09-.01.14-.02.11.1.18.09.23-.05.22-.03.44-.07.65-.1.12.1.23.11.31-.06.05,0,.09-.01.14-.02.12.1.23.11.31-.06.05,0,.09-.01.14-.02.12.1.23.11.31-.06.05,0,.09-.01.14-.02.12.1.23.11.31-.06.07,0,.14-.01.21-.02.11.11.18.09.23-.05.07,0,.14-.01.21-.02.12.1.23.11.31-.06.07,0,.14-.01.21-.02.12.1.23.11.31-.05.34-.01.68-.07,1.01.09.07.03.18.03.16.16-.02.11-.11.07-.17.1-.56.23-1.16.21-1.74.31-.07-.13-.19-.09-.29-.07-.6.09-1.21.16-1.8.29-.34.08-.73,0-1.03.26-.05.01-.09.02-.14.04-.06-.12-.16-.08-.26-.06-1.58.29-3.17.58-4.75.88-.15.03-.39-.05-.47.19-.22.03-.44.06-.65.09-.12,0-.25-.02-.37,0-.93.19-1.86.39-2.79.58-.09.02-.17.02-.19.14-.05,0-.09.02-.14.03-.4-.09-.77.01-1.11.22-.48.01-.91.29-1.4.29-.29.03-.61-.05-.83.24l-.51.07c-.03-.07-.08-.08-.15-.06-.82.18-1.64.37-2.46.55-.1.02-.2.02-.22.15-.19.03-.39.06-.58.09-.36.04-.75-.01-1.04.28-.37-.01-.72.19-1.09.17-.14,0-.31-.1-.39.12-.05,0-.09.01-.14.02-.31-.07-.58,0-.82.21-.05,0-.09,0-.14.01-.34,0-.67.02-.96.22-.11.07-.24.07-.37.08Z"
      />
      <path
        className="cls-2"
        d="m58.19,33.38c-.59-.02-1.13.21-1.7.31-.66.11-1.32.28-1.98.42-.09.02-.17.04-.18.14-.17.03-.34.06-.51.09-.2-.13-.4,0-.59.04-1.14.24-2.27.5-3.41.76-.06.01-.12,0-.18-.03.37-.21.78-.27,1.18-.37,1.53-.35,3.05-.69,4.58-1.06,2.48-.59,4.97-1.14,7.45-1.71.15-.04.35,0,.44-.19.05,0,.09-.02.14-.02.31.07.58,0,.82-.2.07-.01.14-.02.21-.03.09.11.13.06.16-.05.05,0,.09-.02.14-.02.09.11.13.05.16-.05.07-.01.14-.02.21-.03.18.08.34.06.45-.12.05,0,.09-.02.14-.02.11.12.18.09.23-.05.05,0,.09-.02.14-.02.09.11.13.06.16-.05.05,0,.09-.02.14-.02.09.11.13.05.16-.05.05,0,.09-.02.14-.02.09.11.13.05.16-.05.07-.01.14-.02.21-.03.09.11.13.06.16-.05.05,0,.09-.02.14-.02.09.11.13.05.16-.05.05,0,.09-.02.14-.02.11.13.24.02.33,0,.39-.11.81-.09,1.16-.34.05,0,.09-.02.14-.02.09.11.13.05.16-.05l.14-.03c.12.13.18.08.23-.06.49-.1.98-.21,1.47-.31.3.05.58,0,.83-.19.05,0,.09-.01.14-.02.15.09.36.14.28.39-.04.01-.09.02-.13.03-.18-.12-.32-.04-.44.1-.05,0-.1,0-.14-.01-.39.03-.77.11-1.11.3-.36-.01-.68.18-1.03.22-.3-.05-.59-.05-.82.21-.91.21-1.83.42-2.74.64-.09.02-.19.03-.29.04-.39-.1-.72.14-1.09.16-.11,0-.28.01-.32.19-.34.07-.69.14-1.03.22-.3-.07-.56,0-.81.17-.17.04-.35.08-.52.13-.04-.06-.1-.06-.16-.05-1.01.22-2.01.44-3.02.65-.08.02-.13.06-.15.14-.17.03-.34.06-.51.09Z"
      />
      <path
        className="cls-2"
        d="m52.28,66.59s-.02-.09-.02-.13c.03-.45-.02-.89-.27-1.28-.06-.24-.12-.47-.18-.71,0-.36.21-.45.53-.39.4,1.73.83,3.45,1.18,5.19.15.73.29,1.47.45,2.21-.28.04-.5.14-.45.48.01.08-.03.14-.11.16-.29-.86-.31-1.78-.54-2.66.02-.1.04-.2-.05-.28,0-.04-.01-.07-.02-.11,0-.09.03-.19-.05-.26,0-.04-.01-.07-.02-.11,0-.09.03-.19-.05-.26-.01-.08-.03-.15-.04-.23-.05-.56-.13-1.11-.36-1.63Z"
      />
      <path
        className="cls-2"
        d="m61.37,35.82c.2.83.38,1.67.59,2.5.37,1.41.64,2.85,1.01,4.26.1.38.23.76.27,1.16-.33.17-.57.07-.75-.22-.1-.51-.21-1.02-.29-1.54-.17-1.1-.65-2.13-.7-3.25-.05-.51-.06-1.04-.35-1.5-.07-.3-.15-.59-.22-.89q0-.55.44-.52Z"
      />
      <path
        className="cls-2"
        d="m59.89,35.95c-.23-.15-.45.02-.67.05-.48.08-.95.21-1.44.32,0-.19.14-.17.21-.18,1.97-.46,3.94-.91,5.91-1.37.59-.14,1.17-.29,1.75-.43.08-.02.14-.04.16-.13.05,0,.09-.01.14-.02.33.06.63,0,.9-.2.05,0,.09-.01.14-.02.09.11.13.06.16-.05.05,0,.09-.01.14-.02.43.03.83-.04,1.19-.27.05,0,.09-.01.14-.02.21.1.38.03.53-.13.05,0,.09-.01.14-.02.11.11.18.09.23-.06.05,0,.09-.01.14-.02.09.11.13.05.16-.05l.21-.03c.09.11.13.05.16-.05.05,0,.09-.01.14-.02.09.11.13.05.16-.05.07,0,.14-.02.21-.03.09.11.13.05.16-.05.05,0,.09-.01.14-.02.49,0,.99.02,1.48-.04.15-.02.34-.14.44.1-.87.3-1.79.38-2.68.59-.09.02-.19.05-.28.08-.36-.11-.67.03-.97.2-.02,0-.04.02-.06.03-.02,0-.05,0-.07,0-.03,0-.05,0-.08,0-.03-.02-.06-.05-.09-.05-1.37.29-2.73.58-4.1.87-.07.02-.09.07-.11.13-.66.03-1.27.3-1.92.39-.24-.14-.43-.07-.6.13-.02,0-.05.01-.07.02-.13-.13-.23-.14-.3.06-.02,0-.05,0-.07.01-.04-.06-.09-.08-.15-.07-.41.09-.82.19-1.23.28-.09.02-.16.04-.18.15-.02,0-.04,0-.07,0Z"
      />
      <path
        className="cls-2"
        d="m50.3,70.2c0-.14-.01-.29-.02-.43.11-.11.08-.18-.05-.23,0-.05-.02-.09-.03-.14.11-.08.06-.13-.04-.16,0-.05-.02-.09-.03-.14.1-.08.06-.13-.04-.16-.01-.07-.03-.14-.04-.21.11-.08.06-.13-.04-.16,0-.05-.02-.09-.03-.14.11-.08.06-.13-.04-.16-.01-.07-.03-.14-.04-.21.11-.08.07-.13-.04-.16-.01-.07-.03-.14-.04-.21.11-.08.07-.13-.04-.16,0-.05-.02-.09-.03-.14.11-.08.06-.12-.03-.15-.03-.13-.06-.27-.09-.4.07-.09.05-.16-.05-.2-.11-.51-.23-1.03-.34-1.54.1-.08.06-.12-.03-.15,0-.07-.02-.15-.02-.22.2.02.38-.24.6-.06.4,1.7.8,3.4,1.19,5.09.07.29.12.58.18.87-.12-.05-.24-.12-.32-.23-.14-.18-.32-.25-.54-.22Z"
      />
      <path
        className="cls-2"
        d="m40.59,71.03c-.52-1.19-.88-2.44-1.21-3.69.11-.22.18-.52.54-.3.28,1.19.66,2.34,1.1,3.48.13.35.36.66.45,1.02-.26.05-.5-.02-.72-.15,0,0,0,0,0,0-.01-.14.07-.31-.15-.36Z"
      />
      <path
        className="cls-2"
        d="m66.91,57.72c.27.61.38,1.28.6,1.91.09.25.15.5.23.75-.57.19-.64.15-.83-.43-.07-.21-.1-.43-.16-.63-.1-.31-.06-.69-.35-.93.02-.17-.06-.3-.12-.45.17-.21.38-.28.64-.22Z"
      />
      <path
        className="cls-1"
        d="m64.48,45.52c-.04.2-.24.16-.36.19-.59.15-1.19.28-1.78.43-.08.02-.16.07-.23-.02.14-.19.38-.14.57-.21.16-.05.34-.1.28-.31-.09-.34-.01-.74-.33-1-.03-.03-.11.01-.17.03-.51.1-1.02.2-1.52.3-.4.08-.83.05-1.19.29-.2-.06-.21.15-.31.22-.08-.02-.07-.08-.06-.14-.02-.2.12-.25.27-.28,1.46-.3,2.92-.6,4.38-.9.1-.02.22-.06.31.04-.18.14-.4.14-.6.16-.12.02-.25,0-.3.15-.2,0-.52-.14-.48.22.03.27.07.55.12.83.05.27.22.21.38.21.25,0,.17-.18.16-.32.15.26.38.23.61.14.09-.04.18-.08.27-.04Z"
      />
      <path
        className="cls-1"
        d="m26.61,52.56c-.25.25-.6.25-.89.38-.14.06-.26.09-.15.27-.67.26-1.36.41-2.06.57-.48.11-.93.32-1.44.31-.08,0-.2.05-.23-.05-.03-.13.1-.14.19-.16,1.14-.32,2.28-.64,3.43-.97.38-.11.74-.33,1.15-.34Z"
      />
      <path
        className="cls-2"
        d="m60.6,32.26c-.17.08-.35.1-.53.07-.01-.07-.03-.14-.04-.21.11-.08.07-.12-.03-.16-.04-.17-.08-.34-.11-.5.12-.13.12-.23-.05-.3,0-.18-.03-.35-.09-.51.13-.11.09-.18-.05-.23-.04-.24-.08-.49-.13-.73.18-.08.05-.21.04-.32-.02-.21-.06-.43.23-.51.22,1.02.44,2.04.66,3.07.03.12.07.23.11.34Z"
      />
      <path
        className="cls-1"
        d="m26.9,55.64c.05.07.1.14.15.22-.5.22-1.03.37-1.55.53-.66.2-1.32.39-1.97.6-.16.05-.31.06-.48.06.17-.28,2.87-1.26,3.85-1.4Z"
      />
      <path
        className="cls-2"
        d="m38.58,64.45c.06-.14-.08-.33.1-.42.17-.09.29.03.42.12.17.72.36,1.44.6,2.14-.19.1-.39.09-.59.07-.22-.63-.39-1.27-.53-1.91Z"
      />
      <path
        className="cls-2"
        d="m61.23,35.15c-.18.04-.35.15-.53,0-.1-.52-.35-1.01-.34-1.56.06-.06.03-.13.02-.2-.09-.4-.06-.43.37-.38.08.73.35,1.42.48,2.13Z"
      />
      <path
        className="cls-1"
        d="m76.23,60.5q-.07-.5.51-.63c.17-.04.4,0,.38-.28.18-.08.34.02.5.05.2.04.26.21.27.38,0,.19-.11.29-.29.33-.45.09-.91.15-1.37.15Z"
      />
      <path
        className="cls-1"
        d="m32.7,37.36c-.12-.2-.15-.43-.16-.66-.06-.89-.1-1.79-.14-2.68,0-.16.02-.31.17-.51.15,1.01.27,1.95.31,2.91-.17.05-.1.19-.12.3-.03.21.06.43-.05.64Z"
      />
      <path
        className="cls-1"
        d="m72.91,33.15c-.1-.24-.28-.12-.44-.1-.49.06-.99.03-1.48.04.75-.3,1.51-.55,2.32-.6.17-.01.29.04.32.22.03.17-.07.28-.23.32-.16.05-.31.13-.49.12Z"
      />
      <path
        className="cls-1"
        d="m29.8,68.93c-.26.22-.63.23-.92.42.18.13.36-.13.53.02-.62.24-1.27.34-1.9.51-.32.09-.64.26-1.01.15.06-.18.22-.23.37-.27.94-.29,1.89-.57,2.83-.85.03,0,.07,0,.11.02Z"
      />
      <path
        className="cls-1"
        d="m53.41,72.12c.08-.02.12-.08.11-.16-.05-.35.17-.44.45-.48.17.33.22.7.3,1.05.05.2,0,.38-.22.43-.21.06-.4.01-.48-.21-.07-.2-.19-.4-.15-.63Z"
      />
      <path
        className="cls-1"
        d="m34.38,53.29c-.02.15-.16.14-.26.17-.48.15-.96.29-1.44.44-.07.02-.12.02-.16-.04.08-.1.2-.12.31-.15.18-.05.32-.14.3-.37.4.12.45.07.36-.34-.06-.26-.11-.53-.17-.79-.05-.23-.1-.45-.16-.68-.03-.09-.08-.2-.21-.16-.12.03-.13.12-.09.23.04.09.05.19-.05.26-.15-.17-.11-.39-.16-.58.19-.11.38-.19.61-.15.06.54.17,1.07.33,1.6.19.64.17.64.78.56Z"
      />
      <path
        className="cls-1"
        d="m59.83,28.85c-.28.08-.24.29-.23.51,0,.11.13.24-.04.32-.25-.68-.25-1.39-.34-2.1-.02-.14-.06-.38.16-.39.18,0,.26.21.26.36,0,.45.16.86.19,1.3Z"
      />
      <path
        className="cls-1"
        d="m69.87,56.96c.08-.24.32-.16.47-.19,1.58-.31,3.17-.59,4.75-.88.09-.02.2-.06.26.06-.42.19-.89.2-1.33.29-1.26.25-2.53.48-3.79.72-.12.02-.24.04-.36.01Z"
      />
      <path
        className="cls-2"
        d="m46.64,35.45c-.12.06-.23-.05-.34-.01-.07-.47-.14-.94-.21-1.4.1-.17.03-.35.01-.53-.02-.21-.14-.44.07-.64.17.86.41,1.7.47,2.57Z"
      />
      <path
        className="cls-2"
        d="m32.82,51.87c.1-.07.09-.18.05-.26-.05-.12-.03-.2.09-.23.13-.04.18.07.21.16.06.22.11.45.16.68.06.26.11.53.17.79.09.41.04.46-.36.34,0-.05-.02-.09-.03-.14.15-.22.09-.39-.12-.53,0-.05-.02-.09-.03-.14.13-.11.1-.18-.05-.23,0-.05-.02-.09-.03-.14.12-.08.07-.13-.04-.16,0-.05-.02-.09-.02-.14Z"
      />
      <path
        className="cls-1"
        d="m46.17,32.87c-.21.19-.09.42-.07.64.02.18.09.35-.01.53-.23-.22-.14-.53-.16-.78-.06-.59-.17-1.18-.23-1.77-.02-.17,0-.33.05-.51.33.59.33,1.26.43,1.9Z"
      />
      <path
        className="cls-1"
        d="m67.59,45.45c0-.09.05-.12.14-.14,1.23-.28,2.46-.57,3.69-.85.06-.02.12-.03.16.04-.53.24-1.11.32-1.68.46-.69.17-1.39.33-2.09.49-.07.02-.15,0-.22,0Z"
      />
      <path
        className="cls-2"
        d="m63.6,45.42c.01.14.09.31-.16.32-.16,0-.33.06-.38-.21-.05-.27-.09-.55-.12-.83-.04-.36.28-.23.48-.22.06.31.12.63.18.94Z"
      />
      <path
        className="cls-1"
        d="m50.3,70.2c.22-.03.4.04.54.22.08.11.2.17.32.23.15.23.11.41-.14.55-.25.13-.4,0-.5-.2-.13-.25-.26-.5-.22-.8Z"
      />
      <path
        className="cls-2"
        d="m32.7,37.36c.11-.21.02-.43.05-.64.02-.11-.06-.25.12-.3.06.51.11,1.03.25,1.52.06.2.06.41.04.61-.09.04-.18.07-.28.05-.01-.04-.02-.09-.03-.13.08-.08.03-.12-.04-.16-.01-.07-.03-.14-.04-.21.09-.11.08-.21-.03-.31l-.04-.44Z"
      />
      <path
        className="cls-1"
        d="m66.4,58.38c.29.24.25.62.35.93.06.2.1.42.16.63.18.58.26.62.83.43.05.03.1.05.14.08-.14.25-.41.12-.62.19-.2.07-.43.02-.65.03.26-.16.29-.36.18-.64-.17-.44-.21-.93-.44-1.35-.05-.09-.08-.21.03-.3Z"
      />
      <path
        className="cls-1"
        d="m75.13,41.96c.02-.18.18-.11.28-.15.13-.05.29-.05.39-.18.05-.06.09-.12.06-.2-.04-.09-.11-.07-.19-.06-.18.03-.36.14-.55.04.38-.21.8-.23,1.22-.2.15.01.17.16.18.28.02.17-.12.23-.25.27-.37.12-.77.11-1.15.19Z"
      />
      <path
        className="cls-1"
        d="m60.75,33.02c-.43-.05-.46-.02-.37.38.02.07.04.14-.02.2-.03-.04-.07-.08-.07-.12-.06-.38-.25-.45-.62-.34-.3.09-.63.22-.96.15.02-.08.06-.12.15-.14,1.01-.21,2.01-.43,3.02-.65.06-.01.12-.01.16.05-.3.18-.66.16-.98.27-.12.04-.28.02-.31.2Z"
      />
      <path
        className="cls-1"
        d="m64.47,34.99c.01-.06.03-.12.11-.13,1.37-.29,2.73-.58,4.1-.87.03,0,.06.03.09.05-.24.25-.58.19-.88.26-1.07.25-2.16.48-3.23.71-.06.01-.12,0-.18-.01Z"
      />
      <path
        className="cls-1"
        d="m66.91,57.72c-.26-.06-.47.01-.64.22-.06-.23-.26-.12-.4-.16.01-.11.1-.12.19-.14.93-.19,1.86-.39,2.79-.58.12-.02.24,0,.37,0-.43.25-.93.23-1.39.38-.3.1-.66.04-.91.29Z"
      />
      <path
        className="cls-1"
        d="m31.12,43.14c.25.05.16.28.19.42.19.92.34,1.84.51,2.76.01.07.02.12-.05.15-.24-.37-.23-.81-.31-1.22-.13-.61-.24-1.22-.35-1.82-.02-.09,0-.19,0-.29Z"
      />
      <path
        className="cls-1"
        d="m63.83,64.88c.22.17.2.43.24.66.11.6.37,1.17.33,1.8-.17-.08-.13-.26-.15-.39-.15-.69-.42-1.35-.42-2.07Z"
      />
      <path
        className="cls-1"
        d="m75.49,55.91c.3-.25.68-.18,1.03-.26.59-.13,1.2-.2,1.8-.29.1-.02.22-.06.29.07-.46.09-.91.19-1.37.27-.51.09-1.02.17-1.53.24-.07.01-.14-.02-.21-.03Z"
      />
      <path
        className="cls-1"
        d="m59.96,35.95c.01-.1.09-.13.18-.15.41-.09.82-.18,1.23-.28.07-.01.12,0,.15.07-.05.07-.1.14-.15.22q-.44-.03-.44.52c-.15-.16-.58-.34-.86-.35-.03,0-.07-.02-.1-.03Z"
      />
      <path
        className="cls-1"
        d="m68.34,56.78c-.19.21-.46.16-.7.21-.47.11-.95.2-1.43.31-.07.02-.14.05-.18-.04,0-.05.01-.1.02-.15.24,0,.49.06.67-.16.31.12.6-.05.89-.09.24-.03.47-.15.72-.08Z"
      />
      <path
        className="cls-1"
        d="m65.05,69.64c.2-.04.39-.04.59.01.08.1.11.22.1.34,0,.13-.04.25-.18.28-.14.03-.28.02-.36-.12-.09-.16-.18-.32-.15-.52Z"
      />
      <path
        className="cls-1"
        d="m72.52,30.15c.08-.26-.13-.3-.28-.39.2-.13.43-.1.65-.15.16-.03.26.05.29.21.03.16-.09.21-.21.25-.15.05-.29.11-.46.08Z"
      />
      <path
        className="cls-1"
        d="m72.7,41.9c-.19.21-.46.16-.7.21-.49.09-.96.27-1.46.28.01-.03.02-.1.04-.1.71-.14,1.39-.37,2.12-.39Z"
      />
      <path
        className="cls-1"
        d="m69.37,70.28c.28.05.43-.31.71-.23.04.13.05.27,0,.39-.06.17-.2.22-.38.21-.24-.02-.33-.16-.34-.38Z"
      />
      <path
        className="cls-1"
        d="m40.74,71.39c.22.13.46.2.72.15.08.12.14.24,0,.35-.13.09-.28.11-.41.02-.17-.13-.3-.28-.3-.51Z"
      />
      <path
        className="cls-1"
        d="m74.91,41.45c-.36.26-.8.22-1.2.33-.26.07-.53.19-.81.09.66-.21,1.32-.37,2.01-.42Z"
      />
      <path
        className="cls-1"
        d="m34.09,67.81c-.63.21-1.26.46-1.93.5.63-.24,1.26-.45,1.93-.5Z"
      />
      <path
        className="cls-1"
        d="m45.24,65.56c.03-.07.08-.11.16-.13.53-.11,1.06-.23,1.6-.35.06-.01.12-.01.17.04-.63.18-1.26.38-1.92.44Z"
      />
      <path
        className="cls-1"
        d="m72.33,55.97c-.21.22-.51.18-.77.23-.31.06-.61.23-.94.12.55-.22,1.12-.32,1.71-.35Z"
      />
      <path
        className="cls-1"
        d="m62.49,43.5c.19.3.43.4.75.22.04,0,.06.02.05.06-.31.24-.66.3-1.04.24.2-.12.36-.26.23-.52Z"
      />
      <path
        className="cls-1"
        d="m51.98,65.18c.25.39.31.82.27,1.28-.17-.41-.34-.82-.27-1.28Z"
      />
      <path
        className="cls-1"
        d="m64.4,32.04c.03-.18.21-.18.32-.19.37-.03.71-.26,1.09-.16-.06.14-.18.14-.3.15-.38.02-.72.24-1.11.2Z"
      />
      <path
        className="cls-1"
        d="m52.28,66.59c.23.52.31,1.07.36,1.63-.19-.07-.13-.26-.15-.38-.07-.42-.25-.81-.21-1.25Z"
      />
      <path
        className="cls-1"
        d="m69.15,30.44c-.34.25-.77.23-1.16.34-.1.03-.22.14-.33,0,.47-.22.97-.32,1.49-.35Z"
      />
      <path
        className="cls-1"
        d="m58.56,62.67c.39-.25.84-.24,1.27-.28-.4.22-.83.25-1.27.28Z"
      />
      <path
        className="cls-1"
        d="m60.19,62.37c.4-.24.84-.27,1.29-.25-.42.13-.85.24-1.29.25Z"
      />
      <path
        className="cls-1"
        d="m39.92,67.03c-.36-.23-.43.08-.54.3-.1-.09-.08-.26-.21-.34.23-.19.49-.19.76-.17,0,.07-.01.14-.02.21Z"
      />
      <path
        className="cls-1"
        d="m68.48,33.62c-.36.24-.77.31-1.19.27.37-.22.79-.23,1.19-.27Z"
      />
      <path
        className="cls-1"
        d="m72.61,59.85c-.36.12-.74.14-1.12.14.35-.22.73-.23,1.12-.14Z"
      />
      <path
        className="cls-1"
        d="m70.69,30.57c.35-.19.72-.28,1.11-.3-.33.24-.72.29-1.11.3Z"
      />
      <path
        className="cls-1"
        d="m68.84,31c.23-.25.52-.25.82-.21-.24.18-.52.25-.82.21Z"
      />
      <path
        className="cls-1"
        d="m31.94,54.03c-.29.28-.68.24-1.04.3.32-.21.68-.24,1.04-.3Z"
      />
      <path
        className="cls-1"
        d="m72.18,44.26c.02-.2-.2-.31-.17-.51.19-.06.31,0,.36.19.04.16,0,.29-.19.32Z"
      />
      <path
        className="cls-1"
        d="m66.85,33.99c-.27.2-.57.27-.9.2.27-.19.58-.22.9-.2Z"
      />
      <path
        className="cls-1"
        d="m37.1,67.54c.28-.23.61-.32.97-.29-.31.13-.63.24-.97.29Z"
      />
      <path
        className="cls-1"
        d="m68.98,34.01c.3-.16.61-.31.97-.2-.32.11-.63.24-.97.2Z"
      />
      <path
        className="cls-1"
        d="m52.33,64.08c-.32-.06-.53.03-.53.39-.16-.06-.12-.2-.12-.33.18-.23.43-.21.68-.21,0,.05-.02.09-.03.14Z"
      />
      <path
        className="cls-1"
        d="m39.12,66.36c.2.02.4.03.59-.07.04,0,.06.01.06.06-.27.17-.56.27-.89.23.07-.09.22-.08.23-.22Z"
      />
      <path
        className="cls-1"
        d="m49.78,64.68c-.22-.18-.4.08-.6.06-.01-.01-.02-.02-.03-.04,0,0,0-.01.01-.02.18-.22.42-.22.67-.17-.02.06-.03.12-.05.18Z"
      />
      <path
        className="cls-1"
        d="m71.36,59.98c-.21.18-.43.26-.67.07.22-.05.43-.23.67-.07Z"
      />
      <path
        className="cls-1"
        d="m72.11,29.78c-.25.18-.53.23-.83.19.25-.17.54-.19.83-.19Z"
      />
      <path
        className="cls-1"
        d="m62.55,32.42c.25-.16.52-.24.81-.17-.26.13-.52.21-.81.17Z"
      />
      <path
        className="cls-1"
        d="m64.27,31.55c-.24.19-.52.27-.82.2.26-.13.53-.2.82-.2Z"
      />
      <path
        className="cls-1"
        d="m68.69,42.7c-.23.13-.47.22-.74.15.23-.14.47-.19.74-.15Z"
      />
      <path
        className="cls-1"
        d="m74.4,55.59c-.2.19-.43.18-.68.13.2-.15.43-.18.68-.13Z"
      />
      <path
        className="cls-1"
        d="m31.21,68.58c-.24.13-.46.3-.75.18.24-.11.48-.19.75-.18Z"
      />
      <path
        className="cls-1"
        d="m73.94,59.7c-.18.28-.45.11-.69.13.19-.24.45-.11.69-.13Z"
      />
      <path
        className="cls-1"
        d="m69.53,67.12c-.17-.17-.18-.38-.18-.6.22.15.19.38.18.6Z"
      />
      <path
        className="cls-1"
        d="m61.96,35.51c.17-.2.36-.27.6-.13-.19.1-.38.18-.6.13Z"
      />
      <path
        className="cls-1"
        d="m32.99,52.67c.21.14.27.31.12.53-.12-.16-.13-.34-.12-.53Z"
      />
      <path
        className="cls-1"
        d="m38.2,67.22c.16-.16.36-.18.57-.14-.18.1-.36.15-.57.14Z"
      />
      <path
        className="cls-1"
        d="m69.15,33.48c-.15.16-.32.22-.53.13.16-.11.34-.15.53-.13Z"
      />
      <path
        className="cls-1"
        d="m67.08,43.02c-.15.15-.33.19-.53.11.16-.11.34-.15.53-.11Z"
      />
      <path
        className="cls-1"
        d="m71.95,30.28c.13-.13.26-.22.44-.1-.14.07-.27.19-.44.1Z"
      />
      <path
        className="cls-1"
        d="m63.06,61.85c.07-.2.21-.13.37-.11-.05.15-.18.13-.26.19-.06,0-.09-.02-.11-.07Z"
      />
      <path
        className="cls-1"
        d="m65.6,31.25c-.12.17-.27.2-.45.12.14-.1.28-.16.45-.12Z"
      />
      <path
        className="cls-1"
        d="m40.59,71.03c.22.05.14.23.15.36-.18-.07-.15-.22-.15-.36Z"
      />
      <path
        className="cls-1"
        d="m65.96,54.31c-.23-.06-.14-.24-.14-.38.13.09.16.23.14.38Z"
      />
      <path
        className="cls-1"
        d="m30.32,68.78c-.1.13-.22.2-.38.12.11-.11.24-.14.38-.12Z"
      />
      <path
        className="cls-1"
        d="m32.02,68.35c-.11.11-.22.19-.38.11.11-.11.24-.14.38-.11Z"
      />
      <path
        className="cls-1"
        d="m29.87,54.65c-.1.13-.22.2-.38.12.11-.11.23-.15.38-.12Z"
      />
      <path
        className="cls-1"
        d="m27.43,55.44c-.09.16-.21.21-.38.13.11-.1.23-.16.38-.13Z"
      />
      <path
        className="cls-1"
        d="m64.93,43.47c-.08.15-.18.15-.31.06.08-.11.19-.09.31-.06Z"
      />
      <path
        className="cls-1"
        d="m52.82,69.19c.08.08.07.18.05.28-.2-.06-.22-.15-.05-.28Z"
      />
      <path
        className="cls-1"
        d="m52.68,68.45c.08.07.06.17.05.26-.23-.04-.22-.14-.05-.26Z"
      />
      <path
        className="cls-1"
        d="m77.43,55.07c-.07.16-.18.16-.31.06.08-.13.2-.07.31-.06Z"
      />
      <path
        className="cls-1"
        d="m77.88,55c-.07.16-.18.16-.31.06.08-.13.2-.08.31-.06Z"
      />
      <path
        className="cls-1"
        d="m76.99,55.15c-.07.17-.18.16-.31.06.08-.13.2-.07.31-.06Z"
      />
      <path
        className="cls-1"
        d="m61.59,35.59c.07-.19.17-.18.3-.06-.08.13-.2.06-.3.06Z"
      />
      <path
        className="cls-1"
        d="m59.82,31.15c.18.07.17.18.05.3-.12-.08-.06-.2-.05-.3Z"
      />
      <path
        className="cls-1"
        d="m32.74,37.8c.1.09.11.2.03.31-.1-.09-.1-.2-.03-.31Z"
      />
      <path
        className="cls-1"
        d="m78.84,54.85c-.08.16-.18.16-.31.06.08-.12.2-.07.31-.06Z"
      />
      <path
        className="cls-1"
        d="m79.36,54.78c-.08.16-.18.15-.31.05.08-.12.2-.07.31-.05Z"
      />
      <path
        className="cls-1"
        d="m76.55,55.22c-.07.17-.18.16-.31.06.08-.12.2-.07.31-.06Z"
      />
      <path
        className="cls-1"
        d="m52.75,68.82c.08.08.06.17.05.26-.23-.05-.22-.14-.05-.26Z"
      />
      <path
        className="cls-1"
        d="m69.09,68.87c.16.09.12.21.07.34-.12-.1-.12-.21-.07-.34Z"
      />
      <path
        className="cls-1"
        d="m74.33,59.67c-.07.12-.15.13-.24.02.07-.07.15-.07.24-.02Z"
      />
      <path
        className="cls-1"
        d="m29.36,54.81c-.06.11-.14.12-.24.04.07-.09.15-.09.24-.04Z"
      />
      <path
        className="cls-1"
        d="m50.22,69.54c.13.05.16.13.05.23-.1-.06-.09-.14-.05-.23Z"
      />
      <path
        className="cls-1"
        d="m25.7,53.17c.05-.13.12-.16.23-.06-.06.09-.14.1-.23.06Z"
      />
      <path
        className="cls-1"
        d="m78.32,54.93c-.05.14-.13.16-.23.05.06-.11.15-.07.23-.05Z"
      />
      <path
        className="cls-1"
        d="m67.82,42.88c-.05.13-.13.15-.23.05.06-.1.15-.08.23-.05Z"
      />
      <path
        className="cls-1"
        d="m65.3,43.39c-.05.13-.13.15-.23.05.06-.1.15-.08.23-.05Z"
      />
      <path
        className="cls-1"
        d="m32.91,52.3c.15.05.18.12.05.23-.1-.06-.09-.14-.05-.23Z"
      />
      <path
        className="cls-1"
        d="m75.59,55.38c-.05.14-.13.16-.23.05.06-.11.14-.08.23-.05Z"
      />
      <path
        className="cls-1"
        d="m63.67,43.75c-.05.13-.13.16-.23.05.06-.11.15-.06.23-.05Z"
      />
      <path
        className="cls-1"
        d="m75.21,55.45c-.05.14-.13.16-.23.05.06-.11.15-.08.23-.05Z"
      />
      <path
        className="cls-1"
        d="m69.81,30.28c-.04.14-.11.19-.23.06.05-.12.14-.07.23-.06Z"
      />
      <path
        className="cls-1"
        d="m73.59,55.74c-.05.14-.12.17-.23.05.06-.11.15-.07.23-.05Z"
      />
      <path
        className="cls-1"
        d="m73.14,55.82c-.05.14-.13.16-.23.05.05-.12.14-.08.23-.05Z"
      />
      <path
        className="cls-1"
        d="m31.81,46.68c.14.05.17.13.05.23-.1-.06-.09-.14-.05-.23Z"
      />
      <path
        className="cls-1"
        d="m70.48,56.34c-.05.14-.13.16-.23.06.05-.11.14-.08.23-.06Z"
      />
      <path
        className="cls-1"
        d="m70.11,56.41c-.05.14-.13.16-.23.06.06-.11.14-.08.23-.06Z"
      />
      <path
        className="cls-1"
        d="m69.74,56.49c-.05.14-.13.16-.23.06.05-.11.14-.08.23-.06Z"
      />
      <path
        className="cls-1"
        d="m59.68,30.41c.14.05.19.12.05.23-.11-.06-.08-.14-.05-.23Z"
      />
      <path
        className="cls-1"
        d="m69.37,56.56c-.05.14-.13.16-.23.06.05-.11.14-.08.23-.06Z"
      />
      <path
        className="cls-1"
        d="m69.52,33.4c-.05.14-.12.17-.23.06.05-.12.14-.08.23-.06Z"
      />
      <path
        className="cls-1"
        d="m65.97,31.18c-.05.15-.12.17-.23.05.06-.11.15-.07.23-.05Z"
      />
      <path
        className="cls-1"
        d="m26.07,53.07c.05-.12.15-.1.24-.09-.06.1-.13.14-.24.09Z"
      />
      <path
        className="cls-1"
        d="m67.22,30.88c-.03.1-.07.16-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m32.41,49.86c.1.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m70.85,33.1c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m70.18,33.25c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m32.34,49.49c.1.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m32.48,50.23c.1.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m32.27,49.12c.1.04.14.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m66.26,31.1c-.03.1-.07.16-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m66.56,31.03c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m32.18,48.67c.11.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m32.11,48.3c.1.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m66.86,30.96c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m69.82,33.33c-.03.1-.07.16-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m32.04,47.93c.1.04.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m68.7,56.7c-.02.11-.06.17-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m31.96,47.49c.11.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m69,56.64c-.03.1-.07.15-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m30.54,54.44c-.04.07-.08.13-.16.05.04-.07.09-.09.16-.05Z"
      />
      <path
        className="cls-1"
        d="m67.52,30.81c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m31.89,47.12c.1.03.15.08.04.16-.08-.04-.08-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m32.81,38.31c.07.04.12.08.04.16-.08-.04-.09-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m61.67,62.09c.04-.08.09-.08.15-.01-.05.04-.1.07-.15.01Z"
      />
      <path
        className="cls-1"
        d="m72.7,55.9c-.03.1-.07.15-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m69.45,30.37c-.03.1-.07.15-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m27.18,55.84c.03-.11.09-.15.19-.08-.04.09-.1.13-.19.08Z"
      />
      <path
        className="cls-1"
        d="m63.67,64.37c.12.02.15.08.09.19-.1-.03-.12-.1-.09-.19Z"
      />
      <path
        className="cls-1"
        d="m68.87,64.58s-.04-.09-.03-.14c.01.05.2.06.03.14Z"
      />
      <path
        className="cls-1"
        d="m67.15,33.92c-.03.1-.07.16-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m32.84,52.01c.11.03.15.08.04.16-.08-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m49.2,64.96c.09.03.14.07.03.15-.08-.04-.09-.09-.03-.15Z"
      />
      <path
        className="cls-1"
        d="m66.71,45.03c-.03.09-.08.14-.16.04.04-.08.1-.07.16-.04Z"
      />
      <path
        className="cls-1"
        d="m67.08,44.94c-.03.09-.07.15-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m64.63,31.47c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m67.37,44.87c-.03.09-.07.14-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m28.17,52.14c-.04.08-.08.13-.16.05.04-.07.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m67.67,44.8c-.03.09-.08.14-.16.05.03-.08.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m49.57,66.65c.1.04.12.11.05.2-.08-.05-.11-.11-.05-.2Z"
      />
      <path
        className="cls-1"
        d="m74.77,55.52c-.03.1-.07.15-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m27.66,52.29c-.04.08-.08.13-.16.04.04-.07.09-.08.16-.04Z"
      />
      <path
        className="cls-1"
        d="m49.71,67.25c.1.03.14.07.03.15-.08-.04-.09-.09-.03-.15Z"
      />
      <path
        className="cls-1"
        d="m49.78,67.54c.11.03.15.08.04.16-.07-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m34.39,67.74c-.04.08-.08.13-.16.04.04-.06.09-.08.16-.04Z"
      />
      <path
        className="cls-1"
        d="m49.86,67.91c.1.03.15.08.04.16-.07-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m68.9,67.92c.09.05.09.11.04.18-.07-.05-.13-.1-.04-.18Z"
      />
      <path
        className="cls-1"
        d="m65.6,43.32c-.03.09-.08.14-.16.04.04-.08.09-.08.16-.04Z"
      />
      <path
        className="cls-1"
        d="m49.94,68.28c.1.03.14.08.04.16-.08-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m31.5,68.49c-.04.08-.08.13-.16.05.04-.07.09-.09.16-.05Z"
      />
      <path
        className="cls-1"
        d="m66.34,43.17c-.03.1-.08.14-.16.04.04-.07.1-.07.16-.04Z"
      />
      <path
        className="cls-1"
        d="m50.01,68.57c.1.03.15.08.04.16-.07-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m67.45,42.95c-.03.09-.08.14-.16.04.04-.08.1-.07.16-.04Z"
      />
      <path
        className="cls-1"
        d="m59.99,31.96c.1.04.14.08.03.16-.07-.04-.07-.1-.03-.16Z"
      />
      <path
        className="cls-1"
        d="m32.23,53.95c-.03.1-.06.17-.16.05.03-.08.09-.06.16-.05Z"
      />
      <path
        className="cls-1"
        d="m50.09,68.94c.09.04.14.08.04.16-.08-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m29.91,69.27c.04-.07.09-.12.16-.03-.04.06-.1.08-.16.03Z"
      />
      <path
        className="cls-1"
        d="m69.06,42.62c-.05.08-.11.08-.18.03.05-.06.1-.12.18-.03Z"
      />
      <path
        className="cls-1"
        d="m29.54,69.35c.04-.09.08-.14.16-.04-.04.07-.09.08-.16.04Z"
      />
      <path
        className="cls-1"
        d="m50.16,69.24c.1.03.15.08.04.16-.08-.04-.08-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m64.93,31.4c-.03.1-.07.16-.16.05.03-.09.09-.07.16-.05Z"
      />
      <path
        className="cls-1"
        d="m70.48,33.18c-.03.1-.07.16-.16.05.03-.09.09-.08.16-.05Z"
      />
      <path
        className="cls-1"
        d="m68.84,34.04s.05,0,.07,0c0,.02-.01.04-.02.05-.02-.02-.03-.04-.05-.05Z"
      />
      <path className="cls-1" d="m63.69,61.76h-.06s.04,0,.06,0c0,0,0,0,0,0Z" />
      <path
        className="cls-2"
        d="m48.27,46.47c-.01-.54-.21-1.04-.26-1.57-.11-.99-.4-1.94-.48-2.93,0-.27.05-.55-.2-.76-.12-.46-.19-.93-.24-1.4.12-.12-.02-.25,0-.37.02-.12-.08-.29.09-.35.17-.06.12.18.23.22.01.05.02.09.03.14-.07.08-.04.15.02.22.22,1.11.4,2.23.66,3.33.2.84.25,1.7.45,2.54.07.28.1.57.15.86-.03.1,0,.18.09.24,0,.06.01.13.02.19-.16.03-.32.14-.48.01,0-.07-.02-.13-.03-.2.03-.07.03-.14-.05-.18Z"
      />
      <path
        className="cls-2"
        d="m44.44,39.76c.05.9.33,1.76.45,2.65.11.84.3,1.67.47,2.5.17.87.36,1.73.53,2.6-.29.09-.35-.14-.45-.31,0-.05-.02-.09-.03-.14,0-.36-.02-.72-.2-1.05,0-.05-.02-.09-.03-.14.09-.1.06-.17-.04-.24-.01-.07-.03-.14-.04-.21.09-.1.06-.17-.04-.24,0-.05-.02-.09-.02-.14.09-.1.06-.17-.04-.24-.01-.07-.03-.14-.04-.21.1-.1.07-.17-.04-.24,0-.05-.02-.09-.02-.14.09-.1.06-.17-.04-.24-.01-.04-.03-.09-.04-.13.1-.13.1-.24-.08-.3,0-.07-.01-.14-.02-.22.12-.08.06-.13-.04-.16,0-.07,0-.14,0-.21.09-.1.06-.17-.04-.24-.01-.07-.03-.14-.04-.21.07-.17.02-.3-.15-.37-.02-.72-.22-1.42-.31-2.13.02-.19.09-.33.32-.29Z"
      />
      <path
        className="cls-2"
        d="m33.63,43.88c.01-.45-.17-.87-.18-1.31.04-.41.24-.14.39-.09,0,.68.23,1.32.33,1.98.13.85.32,1.7.5,2.54.17.82.35,1.65.54,2.47.03.13.02.26.05.39-.03.1,0,.26-.13.27-.15.01-.13-.15-.17-.25-.04-.1-.04-.22-.08-.32-.09-.19.01-.45-.22-.59,0-.05,0-.1,0-.14.04-.45-.07-.86-.27-1.26-.01-.07-.03-.14-.04-.21.03-.06.02-.12-.04-.16-.01-.07-.03-.14-.04-.21.03-.07.02-.12-.05-.16,0-.1-.02-.19-.02-.29.01-.03.04-.07.04-.1-.17-.83-.33-1.66-.51-2.49,0-.03-.07-.05-.11-.08Z"
      />
      <path
        className="cls-2"
        d="m33.05,40.03c-.02-.13-.03-.25-.05-.38.13-.11-.1-.47.28-.42.08.82.36,1.61.39,2.43-.12.07-.25.05-.38.06-.07-.32-.18-.63-.14-.96.07-.08.07-.15-.03-.22-.01-.09-.02-.18-.04-.27.05-.09.06-.18-.03-.25Z"
      />
      <path
        className="cls-2"
        d="m46.81,38.4c.01-.43-.2-.83-.21-1.26.14-.27-.06-.53-.03-.81.02-.17.04-.27.23-.15.14.74.29,1.48.43,2.22-.14.12-.28.02-.41,0Z"
      />
      <path
        className="cls-1"
        d="m51.59,63.54c0-.06,0-.12,0-.18.22.03.45.07.48-.26.16.32.41.2.66.16-.34.25-.73.26-1.13.28Z"
      />
      <path
        className="cls-1"
        d="m55.75,62.66c.38-.18.78-.25,1.2-.26-.38.18-.78.26-1.2.26Z"
      />
      <path
        className="cls-1"
        d="m54.34,62.95c.38-.16.78-.25,1.2-.26-.38.19-.78.27-1.2.26Z"
      />
      <path
        className="cls-1"
        d="m49.59,63.86c.06,0,.09.03.09.09-.19.21-.44.19-.69.19-.05-.09-.08-.18-.04-.29.21.14.42.16.64,0Z"
      />
      <path
        className="cls-1"
        d="m63.5,61.04c.05,0,.08.03.08.09-.22.09-.42.27-.68.19.01-.09.03-.19.04-.28.19.11.37.08.56,0Z"
      />
      <path
        className="cls-1"
        d="m44.35,65.24c.22-.16.48-.21.75-.19-.22.17-.47.23-.75.19Z"
      />
      <path
        className="cls-1"
        d="m41.84,65.84c.21-.14.43-.16.67-.13-.2.18-.44.14-.67.13Z"
      />
      <path
        className="cls-1"
        d="m50.94,63.7c.08-.12.17-.18.3-.05-.08.11-.19.06-.3.05Z"
      />
      <path
        className="cls-1"
        d="m44.06,65.31c.04-.08.1-.06.16-.04-.03.09-.08.13-.16.04Z"
      />
      <path
        className="cls-1"
        d="m41.54,65.91c.03-.08.09-.07.16-.05-.03.08-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m41.25,65.99c.03-.08.09-.06.16-.05-.03.08-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m40.95,66.06c.03-.08.09-.08.16-.05-.03.08-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m59.08,45.21c-.55.27-1.16.32-1.75.43-1.24.25-2.47.53-3.7.79-.13.03-.26.06-.4.03.06-.21.26-.16.4-.19,1.56-.33,3.11-.66,4.67-.97.25-.05.5-.23.77-.09Z"
      />
      <path
        className="cls-1"
        d="m52.2,46.17c.02-.11.12-.1.2-.12,1.61-.35,3.23-.71,4.84-1.07.07-.02.14-.04.2.03-.72.28-1.47.41-2.21.57-.88.18-1.75.38-2.62.56-.13.03-.27.15-.41.03Z"
      />
      <path
        className="cls-1"
        d="m46.4,49.8c.18.08.37-.1.55,0-.02.03-.03.09-.05.09-.62.16-1.22.43-1.87.42.16-.24.43-.18.65-.26.18-.06.26-.13.21-.34-.11-.45-.2-.9-.28-1.35-.03-.15-.14-.1-.22-.14.2-.24.48-.21.75-.21-.03.05-.07.1-.1.15-.28-.02-.31.14-.27.35.07.35.16.69.2,1.05.04.3.17.35.42.23Z"
      />
      <path
        className="cls-1"
        d="m40.21,49.41c-.46.21-.96.27-1.44.39-.9.23-1.81.43-2.71.64.02-.11.11-.11.19-.13,1.26-.31,2.53-.62,3.79-.93.06-.02.12-.02.17.04Z"
      />
      <path
        className="cls-1"
        d="m48.35,46.84c.16.12.32.02.48-.01.01.02.03.04.04.07-.17.29-.5.24-.74.29-.46.1-.93.18-1.39.3-.06.02-.12.01-.16-.04.42-.24.9-.24,1.34-.37.16-.05.34-.05.42-.23Z"
      />
      <path
        className="cls-1"
        d="m34.66,48.98c.23.13.13.39.22.59.04.1.04.22.08.32.04.09.02.26.17.25.14-.01.11-.17.13-.27.13.06.14.17.14.29-.16.17-.37.19-.59.16.06-.46-.22-.87-.15-1.33Z"
      />
      <path
        className="cls-1"
        d="m50.21,46.62c.08-.16.25-.14.39-.16.49-.08.95-.3,1.46-.27-.1.2-.3.14-.46.17-.46.08-.9.33-1.39.26Z"
      />
      <path
        className="cls-1"
        d="m32.44,47.67s.09.03.09.06c.14.61.34,1.21.33,1.85-.22-.62-.31-1.26-.42-1.91Z"
      />
      <path
        className="cls-1"
        d="m43.77,48.55c-.19.2-.47.17-.71.23-.4.11-.82.18-1.23.27.02-.04.04-.11.08-.12.62-.12,1.22-.36,1.86-.39Z"
      />
      <path
        className="cls-1"
        d="m48.49,47.57v-.02s0-.02,0-.02c.1-.2.31-.2.47-.23.44-.07.87-.26,1.33-.24-.27.22-.62.18-.92.29-.14.05-.3.06-.43.15-.16-.04-.3.06-.45.06Z"
      />
      <path
        className="cls-1"
        d="m57.67,44.98c.4-.2.83-.28,1.27-.27-.02.17-.16.13-.26.14-.34.04-.66.19-1.01.13Z"
      />
      <path
        className="cls-1"
        d="m45.44,47.19c.1.17.17.4.45.31.03.01.07.03.1.04-.22.17-.47.23-.75.2.31-.1.15-.37.2-.56Z"
      />
      <path
        className="cls-1"
        d="m35.09,50.76c-.07-.01-.14-.03-.21-.04.25-.17.52-.25.82-.21-.07.08-.17.14-.17.26-.15,0-.29,0-.44,0Z"
      />
      <path
        className="cls-1"
        d="m31.89,44.77c.16.28.22.58.18.9-.13-.29-.22-.58-.18-.9Z"
      />
      <path
        className="cls-1"
        d="m58.14,39.07c-.11-.21-.16-.44-.12-.68.11.21.21.43.12.68Z"
      />
      <path
        className="cls-1"
        d="m58.99,43.45c-.13-.21-.2-.43-.13-.68.1.21.17.43.13.68Z"
      />
      <path
        className="cls-1"
        d="m58,38.25c-.08-.16-.2-.32-.17-.52.22.12.24.3.17.52Z"
      />
      <path
        className="cls-1"
        d="m32.1,45.81c.13.12.16.27.09.43-.08-.13-.17-.26-.09-.43Z"
      />
      <path
        className="cls-1"
        d="m49.67,46.76c.08-.16.23-.17.38-.14-.07.22-.24.13-.38.14Z"
      />
      <path
        className="cls-1"
        d="m58.55,41.23c-.11-.09-.13-.19-.05-.3.1.09.08.2.05.3Z"
      />
      <path
        className="cls-1"
        d="m31.7,43.96c.13.08.15.18.09.31-.13-.08-.1-.2-.09-.31Z"
      />
      <path
        className="cls-1"
        d="m58.47,40.78c-.1-.06-.13-.14-.05-.23.09.06.08.15.05.23Z"
      />
      <path
        className="cls-1"
        d="m31.82,44.4c.1.06.1.14.04.23-.1-.06-.13-.14-.04-.23Z"
      />
      <path
        className="cls-1"
        d="m49.24,46.84c.06-.1.15-.07.23-.05-.05.13-.13.16-.23.05Z"
      />
      <path
        className="cls-1"
        d="m44.5,47.95c.05-.11.13-.14.24-.08-.06.11-.15.09-.24.08Z"
      />
      <path
        className="cls-1"
        d="m58.08,36.75c.06.05.08.11.02.18-.06-.05-.07-.11-.02-.18Z"
      />
      <path
        className="cls-1"
        d="m40.88,48.79c.04-.07.09-.09.16-.04-.04.07-.09.12-.16.04Z"
      />
      <path
        className="cls-1"
        d="m46.28,47.51c.03-.08.09-.08.16-.05-.03.09-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m59.08,43.8s-.16-.07-.01-.13c0,.04,0,.08.01.13Z"
      />
      <path
        className="cls-1"
        d="m34.74,50.71s-.06.03-.08.04c0-.06.03-.08.08-.04Z"
      />
      <path
        className="cls-1"
        d="m46.53,52.49c-.17-.04-.12-.19-.15-.3-.1-.43-.17-.86-.28-1.29-.08-.3-.23-.31-.47-.25-.56.14-1.12.28-1.67.42-.09.02-.18.07-.29.04.35-.26.79-.29,1.19-.39,1.24-.34,2.49-.62,3.74-.92.26-.06.52-.13.79-.13-.03.07-.06.15-.09.22-.24-.05-.33.05-.31.3.04.47.2.93.16,1.41-.08-.02-.12-.06-.14-.14-.05-.36-.11-.72-.15-1.08-.05-.44-.1-.48-.53-.38-.51.12-1.02.25-1.54.38-.11.03-.22.04-.24.18-.3-.06-.35.05-.29.34.11.53.3,1.05.27,1.6Z"
      />
      <path
        className="cls-1"
        d="m47.39,49.71c.26-.17.57-.2.86-.26.29-.06.43-.19.46-.47.11.26.3.25.51.15.33.03.62-.13.92-.22.61-.19,1.26-.18,1.84-.44.08-.04.19,0,.29,0-.02.13-.13.13-.22.15-1.48.37-2.96.74-4.44,1.11-.08.02-.16.09-.23-.02Z"
      />
      <path
        className="cls-1"
        d="m34.51,53.26c.15-.2.37-.24.59-.29.18-.04.34-.1.39-.3.33.16.38-.03.37-.3.16.36.47.24.74.24-.37.3-.85.33-1.27.47-.26.09-.52.23-.82.17Z"
      />
      <path
        className="cls-1"
        d="m35.76,53.79s-.11-.04-.11-.06c0-.28-.18-.32-.4-.32.27-.22.58-.26.91-.27,0,.09,0,.18-.01.28-.26-.11-.46-.14-.34.25.02.05,0,.1-.05.12Z"
      />
      <path
        className="cls-1"
        d="m65.12,53.89c-.24-.29-.24-.66-.34-.99-.03-.1-.18-.23-.02-.36.23.42.37.87.36,1.35Z"
      />
      <path
        className="cls-1"
        d="m60.26,47.13s-.02.06-.03.09c-.25-.07-.25.19-.37.29-.18-.19-.42-.13-.64-.15.31-.22.67-.23,1.04-.23Z"
      />
      <path
        className="cls-1"
        d="m54.14,48.03c.4-.29.87-.3,1.32-.36-.41.25-.87.27-1.32.36Z"
      />
      <path
        className="cls-1"
        d="m60.33,46.54c.42-.23.88-.3,1.35-.34-.41.26-.88.29-1.35.34Z"
      />
      <path
        className="cls-1"
        d="m55.84,48.11c-.4.21-.82.34-1.27.32.39-.23.83-.28,1.27-.32Z"
      />
      <path
        className="cls-1"
        d="m64.76,52.46c-.22-.34-.21-.73-.29-1.11.26.33.32.7.29,1.11Z"
      />
      <path
        className="cls-1"
        d="m57.76,47.66c-.34.25-.73.28-1.12.28.34-.23.73-.27,1.12-.28Z"
      />
      <path
        className="cls-1"
        d="m52.27,49c-.39.12-.77.26-1.19.28.37-.22.75-.34,1.19-.28Z"
      />
      <path
        className="cls-1"
        d="m43.91,50.6c.3-.17.64-.22.97-.27-.3.18-.59.41-.97.27Z"
      />
      <path
        className="cls-1"
        d="m60.05,46.47s.07.04.07.09c-.14.18-.31.22-.52.14,0-.1.02-.21.03-.31.13.08.25.24.42.08Z"
      />
      <path
        className="cls-1"
        d="m50.72,49.37c-.26.12-.53.19-.82.2.24-.21.51-.29.82-.2Z"
      />
      <path
        className="cls-1"
        d="m39.09,51.93c.2-.24.49-.16.75-.22-.19.26-.48.19-.75.22Z"
      />
      <path
        className="cls-1"
        d="m63.73,48.4c-.15-.17-.26-.36-.2-.6.1.19.26.36.2.6Z"
      />
      <path
        className="cls-1"
        d="m35.11,53.45c-.19.1-.39.16-.61.17.17-.16.36-.28.61-.17Z"
      />
      <path
        className="cls-1"
        d="m42.28,51.04c.19-.11.38-.18.6-.18-.17.17-.36.27-.6.18Z"
      />
      <path
        className="cls-1"
        d="m63.88,49.13c-.12-.15-.17-.33-.14-.52.18.14.22.31.14.52Z"
      />
      <path
        className="cls-1"
        d="m52.94,48.31c.16-.1.34-.15.53-.13-.15.16-.32.22-.53.13Z"
      />
      <path
        className="cls-1"
        d="m57.15,47.29c.13-.14.28-.16.46-.12-.12.16-.28.17-.46.12Z"
      />
      <path
        className="cls-1"
        d="m40.88,51.42c.13-.1.29-.11.45-.12-.11.18-.25.27-.45.12Z"
      />
      <path
        className="cls-1"
        d="m65.77,56.16c-.09-.11-.13-.23-.11-.37.15.09.23.2.11.37Z"
      />
      <path
        className="cls-1"
        d="m37.77,52.29c.12-.07.23-.15.38-.12-.09.15-.21.22-.38.12Z"
      />
      <path
        className="cls-1"
        d="m55.96,47.57c.1-.14.24-.14.39-.1-.09.18-.25.11-.39.1Z"
      />
      <path
        className="cls-1"
        d="m36.74,52.59c.12-.07.23-.15.38-.12-.09.15-.21.22-.38.12Z"
      />
      <path
        className="cls-1"
        d="m65.94,56.72c-.1-.12-.14-.26-.13-.41.17.1.21.24.13.41Z"
      />
      <path
        className="cls-1"
        d="m56.79,47.37c.05-.11.14-.08.23-.06-.05.12-.13.15-.23.06Z"
      />
      <path
        className="cls-1"
        d="m63.35,47c-.11-.06-.15-.13-.05-.24.09.06.08.15.05.24Z"
      />
      <path
        className="cls-1"
        d="m47.09,49.78c.03-.09.09-.06.16-.04-.03.1-.07.16-.16.04Z"
      />
      <path
        className="cls-1"
        d="m63.97,49.54c-.07-.05-.1-.12-.05-.2.1.05.11.11.05.2Z"
      />
      <path
        className="cls-1"
        d="m43.62,50.68c.03-.09.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-1"
        d="m63.5,47.67c-.09-.03-.14-.08-.04-.16.06.04.06.1.04.16Z"
      />
      <path
        className="cls-1"
        d="m56.49,47.44c.03-.08.09-.08.16-.05-.03.09-.08.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m63.42,47.3c-.08-.04-.14-.08-.04-.17.07.04.07.1.04.17Z"
      />
      <path
        className="cls-1"
        d="m57.75,47.14c.03-.08.09-.08.16-.05-.03.09-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m58.71,46.91c.04-.07.1-.07.16-.04-.03.1-.08.14-.16.04Z"
      />
      <path
        className="cls-1"
        d="m41.99,51.12c.03-.08.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-1"
        d="m41.69,51.19c.03-.09.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-1"
        d="m63.28,46.64c-.08-.03-.12-.09-.13-.17.14-.02.16.06.13.17Z"
      />
      <path
        className="cls-1"
        d="m40.58,51.49c.03-.09.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-1"
        d="m61.82,46.18c.03-.08.09-.08.16-.05-.03.09-.07.14-.16.05Z"
      />
      <path
        className="cls-1"
        d="m40.06,51.64c.03-.09.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-1"
        d="m38.29,52.15c.03-.08.09-.06.16-.04-.03.1-.06.17-.16.04Z"
      />
      <path
        className="cls-1"
        d="m37.48,52.37c.03-.09.09-.07.16-.05-.03.1-.07.16-.16.05Z"
      />
      <path
        className="cls-2"
        d="m50.35,58.3s-.02-.1-.03-.14c.07-.45-.05-.87-.26-1.26-.01-.07-.03-.14-.04-.22.12-.08.08-.12-.03-.15-.32-1.42-.54-2.86-.75-4.29-.03-.22-.1-.43-.08-.65.04-.48-.11-.94-.16-1.41-.02-.25.07-.34.31-.3.19,1.1.31,2.21.58,3.31.22.9.32,1.83.47,2.75.08.4.1.82.29,1.19.12.75.32,1.48.49,2.21.09.37.17.75.26,1.12-.3.13-.52.1-.54-.29,0-.08-.03-.14-.12-.16-.21-.47-.21-.98-.33-1.47.12-.11.09-.18-.05-.22Z"
      />
      <path
        className="cls-2"
        d="m35.76,53.79s.07-.07.05-.12c-.12-.4.08-.36.34-.25.16.66.3,1.32.48,1.97.72,2.57,1.45,5.15,2.18,7.72.01.05,0,.1,0,.15-.11.32-.22.33-.58.07-.04-.54-.3-1.02-.39-1.54.03-.02.09-.04.09-.05-.09-.37-.07-.77-.37-1.07-.11-.39-.21-.78-.34-1.16-.04-.11-.03-.21-.04-.32.03-.51-.12-.97-.38-1.41-.2-.51-.33-1.04-.43-1.59.07-.22.04-.41-.15-.56-.06-.43-.19-.84-.31-1.25.11-.08.06-.13-.04-.16-.01-.05-.02-.09-.03-.14.11-.08.06-.13-.04-.16-.01-.05-.02-.09-.03-.14Z"
      />
      <path
        className="cls-2"
        d="m35.77,61.64c.22.79.44,1.57.66,2.36-.5.15-.52.15-.67-.35-.34-1.1-.56-2.24-.86-3.35-.5-1.89-.92-3.79-1.39-5.69-.01-.06-.02-.12-.04-.18-.14-.36.03-.45.35-.4.02.12.12.23.09.36.12.93.4,1.82.65,2.72,0,.02.04.02.06.03.06.29.13.58.19.86-.07.11-.11.22-.05.35.25.56.31,1.18.51,1.76.11.31.05.69.33.94,0,.05.02.09.02.14-.11.09-.04.13.05.16.01.05.03.09.04.14-.13.1-.04.12.05.15Z"
      />
      <path
        className="cls-2"
        d="m46.68,51.07s.02.09.03.13c-.09.1-.06.18.05.23.2,1.14.49,2.26.76,3.39.24,1,.45,2.01.67,3.02.06.29.11.59.17.89.02.14-.07.31.13.39.03.19.06.38.09.57.02.14-.06.3.12.39,0,.07.02.14.03.21-.1.09-.03.12.05.16,0,.05.01.09.02.14-.11.13.14.41-.16.44-.31.03-.23-.27-.28-.43-.09-.25-.12-.52-.17-.79-.02-.12-.04-.22-.16-.26-.04-.48-.3-.91-.29-1.4.1-.09.06-.13-.05-.15-.01-.05-.02-.1-.03-.15.1-.33.03-.63-.19-.89,0-.05-.02-.1-.03-.14.12-.08.08-.13-.04-.16,0-.05-.02-.09-.03-.14.05-.32.01-.63-.19-.9-.04-.17-.07-.34-.11-.51.07-.3.02-.58-.18-.82-.05-.25-.1-.51-.15-.76.06-.13.1-.26-.08-.34-.04-.23-.09-.47-.13-.7.03-.55-.17-1.07-.27-1.6-.06-.29,0-.4.29-.34.03.1.05.19.08.29-.08.1-.06.18.05.23Z"
      />
      <path
        className="cls-2"
        d="m49.59,63.86c-.21.15-.43.13-.64,0-.21-.68-.33-1.37-.45-2.07.19-.09.39-.12.58,0,.17.69.33,1.38.5,2.08Z"
      />
      <path
        className="cls-2"
        d="m52.06,63.1c-.03.33-.26.29-.48.26-.1-.38-.16-.77-.31-1.13.16-.28-.06-.52-.09-.79-.02-.15-.07-.28.11-.37.22-.1.22.12.31.19.15.61.3,1.23.45,1.84Z"
      />
      <path
        className="cls-2"
        d="m48.99,61.32s-.01.05-.03.06c-.01,0-.04-.01-.06-.02,0-.02.01-.05.03-.06.01,0,.04.01.06.02Z"
      />
      <path
        className="cls-1"
        d="m62.71,57.86c.05.01.07.05.07.1,0,.07-.04.11-.11.12-.46.05-.89.29-1.37.23.13-.17.33-.14.5-.18.27-.05.36-.16.29-.46-.11-.48-.32-.93-.29-1.44.13,0,.14.1.16.2.09.39.23.77.27,1.17.04.38.2.38.47.25Z"
      />
      <path
        className="cls-1"
        d="m61.89,58.62c-.22.23-.54.17-.81.24-.61.16-1.22.28-1.83.41-.06.01-.12,0-.18-.02.01-.13.12-.13.22-.15.82-.18,1.64-.36,2.46-.55.07-.02.12,0,.15.06Z"
      />
      <path
        className="cls-1"
        d="m64.19,57.72s.02-.09.04-.1c.55-.13,1.09-.31,1.67-.33-.02.03-.03.09-.05.09-.55.1-1.09.29-1.66.33Z"
      />
      <path
        className="cls-1"
        d="m63.22,58.31c-.3.15-.23.42-.22.66-.15-.21-.2-.58-.61-.38l-.02-.02s.02-.02.02-.02c.22-.29.53-.21.83-.24Z"
      />
      <path
        className="cls-1"
        d="m65.74,57.8c-.35.19-.71.28-1.11.22.34-.21.71-.32,1.11-.22Z"
      />
      <path
        className="cls-1"
        d="m58.49,59.34c-.31.24-.68.25-1.04.28.29-.29.68-.24,1.04-.28Z"
      />
      <path
        className="cls-1"
        d="m55.82,59.93c-.23.24-.52.23-.82.21.24-.21.51-.28.82-.21Z"
      />
      <path
        className="cls-1"
        d="m54.86,60.16c-.3.18-.62.25-.96.22.29-.2.63-.21.96-.22Z"
      />
      <path
        className="cls-1"
        d="m56.35,59.8c-.09.18-.23.16-.39.12.08-.22.25-.12.39-.12Z"
      />
      <path
        className="cls-1"
        d="m61.5,38.72c-.14-.05-.14-.18-.16-.3-.06-.4-.12-.8-.19-1.2.29.46.3.98.35,1.5Z"
      />
      <path
        className="cls-2"
        d="m60.05,46.47c-.18.15-.29,0-.42-.08-.03-.17-.07-.34-.1-.51.11-.11.02-.13-.07-.15,0-.1-.01-.19-.02-.29.1-.07.11-.29.31-.22.16.4.19.84.31,1.25Z"
      />
      <path
        className="cls-1"
        d="m48.81,46.63c-.09-.06-.12-.14-.09-.24.09.06.15.13.09.24Z"
      />
      <path
        className="cls-1"
        d="m47.46,39.66c-.07-.07-.09-.14-.02-.22.08.07.08.14.02.22Z"
      />
      <path
        className="cls-1"
        d="m45.22,46.01c.17.33.21.68.2,1.05-.2-.32-.26-.67-.2-1.05Z"
      />
      <path
        className="cls-1"
        d="m44.44,42.17c.17.07.22.2.15.37-.16-.08-.18-.21-.15-.37Z"
      />
      <path
        className="cls-1"
        d="m44.73,43.58c.18.06.18.17.08.3-.15-.07-.08-.19-.08-.3Z"
      />
      <path
        className="cls-1"
        d="m44.63,42.75c.1.06.13.14.04.24-.08-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m44.85,44.01c.1.06.13.14.04.24-.08-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m44.92,44.38c.11.06.14.14.04.24-.08-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m45,44.82c.1.06.13.14.04.24-.09-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m45.06,45.2c.11.06.14.14.04.24-.08-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m45.15,45.64c.1.06.13.14.04.24-.09-.07-.09-.15-.04-.24Z"
      />
      <path
        className="cls-1"
        d="m44.68,43.2c.1.03.16.07.04.16-.08-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m47.33,41.21c.25.21.2.49.2.76-.21-.21-.19-.49-.2-.76Z"
      />
      <path
        className="cls-1"
        d="m48.27,46.47c.08.04.08.1.05.18-.05-.05-.15-.08-.05-.18Z"
      />
      <path
        className="cls-1"
        d="m33.63,43.88s.1.05.11.08c.17.83.34,1.66.51,2.49,0,.03-.03.07-.04.1-.25-.25-.18-.59-.25-.88-.13-.59-.34-1.17-.33-1.79Z"
      />
      <path
        className="cls-1"
        d="m34.4,47.58c.2.4.31.81.27,1.26-.21-.39-.27-.82-.27-1.26Z"
      />
      <path
        className="cls-1"
        d="m34.32,47.21c.06.04.06.1.04.16-.07-.04-.12-.08-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m34.23,46.84c.07.04.08.09.05.16-.08-.03-.11-.08-.05-.16Z"
      />
      <path
        className="cls-1"
        d="m33.05,40.03c.09.07.08.16.03.25-.08-.07-.12-.15-.03-.25Z"
      />
      <path
        className="cls-1"
        d="m33.11,40.55c.09.06.1.13.03.22-.09-.06-.1-.13-.03-.22Z"
      />
      <path
        className="cls-2"
        d="m62.4,58.6c.41-.21.46.16.61.38,0,.04.02.08.03.11-.04.07-.03.13.04.18.15.59.23,1.2.43,1.78-.19.07-.38.1-.56,0-.04-.17-.08-.34-.12-.51.13-.09.06-.13-.04-.15-.04-.17-.08-.34-.12-.51.15-.09.07-.12-.04-.15-.01-.05-.02-.1-.03-.14.14-.09.07-.13-.04-.15-.01-.05-.02-.09-.03-.14.13-.09.06-.13-.04-.16-.03-.17-.11-.34-.09-.52Z"
      />
      <path
        className="cls-1"
        d="m62.49,59.11c.1.03.17.07.04.16-.06-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m62.56,59.41c.1.03.18.07.04.15-.06-.04-.07-.09-.04-.15Z"
      />
      <path
        className="cls-1"
        d="m62.63,59.71c.11.03.18.06.04.15-.06-.04-.06-.09-.04-.15Z"
      />
      <path
        className="cls-1"
        d="m62.79,60.37c.1.03.17.07.04.15-.06-.04-.07-.09-.04-.15Z"
      />
      <path
        className="cls-1"
        d="m63.07,59.27c-.07-.05-.08-.11-.04-.18.06.05.11.1.04.18Z"
      />
      <path
        className="cls-2"
        d="m35.85,52.38c.01.26-.04.46-.37.3-.16-.63-.35-1.26-.4-1.92.15,0,.29,0,.44,0,.11.54.22,1.07.33,1.61Z"
      />
      <path
        className="cls-2"
        d="m49.22,49.13c-.22.1-.4.11-.51-.15,0-.04,0-.08-.01-.12,0-.12.1-.26-.08-.34-.08-.31-.12-.63-.13-.96.15,0,.29-.1.45-.06.15.53.2,1.08.29,1.62Z"
      />
      <path
        className="cls-1"
        d="m59.45,45.73c.09.02.18.04.07.15-.06-.03-.09-.08-.07-.15Z"
      />
      <path
        className="cls-2"
        d="m46.4,49.8c-.25.13-.38.08-.42-.23-.05-.35-.14-.7-.2-1.05-.04-.21,0-.38.27-.35,0,.43.23.82.24,1.25-.02.08.02.12.08.16.01.07.03.14.04.21Z"
      />
      <path
        className="cls-1"
        d="m48.62,48.52c.18.08.09.22.08.34-.11-.09-.13-.21-.08-.34Z"
      />
      <path
        className="cls-1"
        d="m46.36,49.59c-.06-.04-.1-.09-.08-.16.05.04.14.06.08.16Z"
      />
      <path
        className="cls-2"
        d="m62.71,57.86c-.27.13-.43.13-.47-.25-.04-.39-.18-.78-.27-1.17-.02-.1-.03-.2-.16-.2-.09-.32-.19-.64-.21-.97.11-.15.14-.28-.07-.37-.01-.05-.02-.1-.04-.15.05,0,.09-.04.07-.09-.01-.03-.07-.04-.11-.06-.03-.15-.07-.29-.1-.44.04-.38-.04-.73-.26-1.05-.01-.07-.02-.14-.03-.22.1-.18.06-.33-.1-.46-.01-.07-.03-.14-.04-.21.11-.08.07-.13-.04-.16-.02-.11-.05-.21-.07-.32.06-.14.1-.27-.09-.34-.11-.12-.06-.28-.1-.42.08-.23,0-.46-.06-.68-.12-.42-.1-.89-.36-1.27-.11-.52-.21-1.03-.32-1.55.12-.1.12-.35.37-.29.21,1.2.53,2.38.79,3.58.16.73.33,1.45.49,2.18-.03.11,0,.19.1.24.01.04.02.09.03.13-.04.39.11.75.24,1.11.27,1.07.54,2.15.81,3.22.01.06,0,.12,0,.18Z"
      />
      <path
        className="cls-1"
        d="m60.19,49.06c.26.38.24.84.36,1.27.06.22.14.44.06.68-.21-.1-.15-.32-.19-.48-.12-.42-.19-.85-.28-1.27-.02-.07-.04-.14.05-.19Z"
      />
      <path
        className="cls-1"
        d="m61.08,53.12c.22.32.31.66.26,1.05-.23-.31-.29-.67-.26-1.05Z"
      />
      <path
        className="cls-1"
        d="m50.64,57.12c-.19-.37-.21-.79-.29-1.19.23.36.25.78.29,1.19Z"
      />
      <path
        className="cls-1"
        d="m60.95,52.45c.16.13.2.28.1.46-.08-.14-.16-.28-.1-.46Z"
      />
      <path
        className="cls-1"
        d="m61.51,54.9c.21.09.18.22.07.37-.14-.1-.08-.24-.07-.37Z"
      />
      <path
        className="cls-1"
        d="m60.71,51.42c.19.07.15.2.09.34-.16-.08-.1-.21-.09-.34Z"
      />
      <path
        className="cls-1"
        d="m60.87,52.08c.11.03.15.07.04.16-.07-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m61.44,54.61s.09.03.11.06c.02.05-.02.08-.07.09-.06-.04-.06-.09-.03-.15Z"
      />
      <path
        className="cls-1"
        d="m47.18,55.64c.21.27.24.57.19.9-.17-.28-.26-.57-.19-.9Z"
      />
      <path
        className="cls-1"
        d="m46.89,54.3c.2.24.25.52.18.82-.18-.25-.24-.52-.18-.82Z"
      />
      <path
        className="cls-1"
        d="m47.47,56.97c.22.26.29.56.19.89-.12-.28-.19-.58-.19-.89Z"
      />
      <path
        className="cls-1"
        d="m46.66,53.19c.18.08.13.21.08.34-.16-.09-.1-.22-.08-.34Z"
      />
      <path
        className="cls-1"
        d="m47.69,58.01c.11.02.16.06.05.15-.08-.03-.08-.09-.05-.15Z"
      />
      <path
        className="cls-1"
        d="m47.4,56.67c.12.03.15.07.04.16-.06-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m61.89,54.46c-.13-.36-.27-.71-.24-1.11.14.36.28.71.24,1.11Z"
      />
      <path
        className="cls-1"
        d="m61.62,53.22c-.1-.05-.13-.13-.1-.24.1.05.16.12.1.24Z"
      />
      <path
        className="cls-1"
        d="m35.61,61.05c-.28-.25-.22-.63-.33-.94-.2-.58-.25-1.2-.51-1.76-.06-.13-.01-.24.05-.35.29,1.01.67,2,.78,3.05Z"
      />
      <path
        className="cls-1"
        d="m34.64,57.13s-.06-.02-.06-.03c-.25-.9-.53-1.79-.65-2.72.02.01.05.02.06.04.24.9.51,1.79.65,2.71Z"
      />
      <path
        className="cls-1"
        d="m36.8,57.79c.26.43.41.9.38,1.41-.25-.43-.39-.9-.38-1.41Z"
      />
      <path
        className="cls-1"
        d="m37.56,60.67c.3.29.28.7.37,1.07,0,0-.06.03-.09.05-.14-.36-.32-.71-.28-1.11Z"
      />
      <path
        className="cls-1"
        d="m36.22,55.64c.19.15.22.34.15.56-.12-.17-.16-.36-.15-.56Z"
      />
      <path
        className="cls-1"
        d="m35.69,61.34c-.09-.03-.16-.06-.05-.16.08.03.07.09.05.16Z"
      />
      <path
        className="cls-1"
        d="m35.77,61.64c-.08-.03-.18-.06-.05-.15.08.03.06.09.05.15Z"
      />
      <path
        className="cls-1"
        d="m35.79,53.93c.1.03.15.07.04.16-.07-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m35.86,54.23c.1.03.15.07.04.16-.06-.04-.07-.09-.04-.16Z"
      />
      <path
        className="cls-1"
        d="m50.06,56.9c.21.39.33.81.26,1.26-.14-.41-.34-.81-.26-1.26Z"
      />
      <path
        className="cls-1"
        d="m48.49,59.12c-.19-.08-.11-.25-.13-.39.17.09.14.24.13.39Z"
      />
      <path
        className="cls-1"
        d="m48.71,60.09c-.18-.09-.1-.25-.12-.39.15.1.15.24.12.39Z"
      />
      <path
        className="cls-1"
        d="m50.35,58.3c.14.05.17.12.05.22-.08-.06-.08-.14-.05-.22Z"
      />
      <path
        className="cls-1"
        d="m46.77,51.44c-.11-.06-.14-.13-.05-.23.07.06.08.14.05.23Z"
      />
      <path
        className="cls-1"
        d="m46.68,51.07c-.11-.06-.13-.14-.05-.23.07.07.08.15.05.23Z"
      />
      <path
        className="cls-1"
        d="m48.78,60.46c-.08-.03-.14-.07-.05-.16.08.03.07.09.05.16Z"
      />
      <path
        className="cls-1"
        d="m49.98,56.53c.11.03.15.08.03.15-.06-.04-.06-.09-.03-.15Z"
      />
    </Icon>
  );
}

export function IconCotton({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="35 33 34 36"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #7d7d7d; }`}
          {`.cls-2 { fill: #2c2c2c; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m35.98,53.97c-.13-.21-.27-.42-.31-.67.08-.15-.03-.29-.04-.44-.04-.48-.02-.5.42-.4,0,.03,0,.05,0,.08-.06.37.05.62.46.71.15.03.28.16.4.27.3.3.68.53,1.02.73.3.18.63.43,1.02.48.15.02.16.13.11.22-.27.45.13.4.3.34.47-.18.8.16,1.19.26.62.15,1.24.34,1.88.37.57.02,1.14-.01,1.71.03.38.03.79,0,1.13.2.34.2.75.2,1.1.38.17.1.33.21.43.38.2.33.51.56.79.81-.01.15.05.24.21.24.08.05.13.12.14.22-.07,0-.12.03-.09.1.03.06.09.05.15.01,0,0,.01.01.01.01-.07.12,0,.16.11.18.01.02.02.05.02.07-.12.12-.16.24.05.31-.05.15.22.46-.21.43-.11-.23-.29-.32-.54-.29-.31-.36-.73-.43-1.17-.45-.46-.02-.93-.02-1.39-.03-.04-.02-.09-.06-.13-.05-.85.15-1.69,0-2.53-.13-.17-.03-.36-.13-.54-.04-.22-.12-.47-.11-.71-.15-.14-.27-.44-.16-.65-.27-.3-.15-.54-.39-.88-.47-.02,0-.04,0-.06-.01-.27-.35-.66-.46-1.07-.52-.25-.2-.47-.43-.68-.68.05-.13,0-.23-.11-.29-.43-.27-.63-.72-.9-1.13-.19-.3-.31-.65-.65-.84Z"
      />
      <path
        className="cls-2"
        d="m60.07,59.62s-.09.02-.13.04c-.15-.1-.29-.13-.38.08-.24.02-.47.05-.71.07-.15-.04-.31-.12-.42.08-.3,0-.59,0-.89,0-.09-.15-.19-.14-.31-.04-.46-.04-.9-.05-1.33-.33-.23-.15-.71-.03-.98.25-.08.08-.15.06-.23.08-.07-.02-.14-.05-.16.06-.07.01-.14.02-.2.03-.21-.05-.41-.1-.14-.36.07-.07.3-.19.03-.4-.15-.11-.15-.5.08-.66.67-.44,1.4-.68,2.2-.72.45-.02.89-.05,1.34-.08.05,0,.09.01.14.02.21.31.48.13.73.08.18-.04.34-.14.53-.04,0,.1-.26.1-.07.25.25.2.54.31.78.12.23-.19-.15-.27-.18-.43.05-.11.27-.02.26-.21.02-.01.04-.02.06-.02.14.07.26-.07.4-.04.43.06.85.07,1.22-.21.41-.3.88-.52,1.1-1.02h0c.24.1.6-.18.73.29.11-.27.39-.33.49-.57.05,0,.1,0,.14-.01.37-.11.78-.16,1-.55.01-.01.02-.02.03-.03.25-.02.49-.12.75-.09-.12.3-.32.51-.6.65-.48-.07-.63.35-.89.6h0c-.32.1-.53.35-.79.52-.09.06-.25.37-.35-.03-.03-.11-.14-.02-.18.06-.22.45-.56.77-.93,1.1-.58.52-1.19.97-1.89,1.3-.09.04-.2.05-.23.17Z"
      />
      <path
        className="cls-2"
        d="m52.99,33.57c-.73.08-1.43.26-2.08.59-.37-.02-.67.18-.98.33-.28.14-.52.37-.87.38-.42.01-.33.28-.21.53,0,0-.02.03-.02.03-.1-.08-.17-.05-.2.07-.18.1-.23.32-.43.41-.15,0-.31.01-.3.23-.03.04-.06.09-.09.13-.38.1-.66.43-.68.83h0c-.14,0-.17.07-.09.18,0,0-.02.02-.02.02-.4-.02-.41.26-.41.54-.25.24-.45.52-.61.83-.15.29-.38.51-.59.76-.13.1-.36.08-.36.32,0,.02-.02.03-.04.04-.21.06-.22.23-.19.41.04.23-.26.34-.21.58-.03.03-.08.06-.1.1-.1.21-.24.38-.49.25-.24-.12-.22-.32-.14-.55.13-.34.23-.7.35-1.05.08-.12.25-.18.28-.35.12-.09.15-.23.15-.37.05-.08.09-.16.14-.24.12.03.18-.02.16-.15.32-.32.62-.65.81-1.08.03-.02.06-.04.08-.07.21-.01.41-.03.35-.33.04-.04.08-.08.11-.12.22,0,.35-.08.36-.31v.02s0-.02,0-.02c.11.03.23.05.31-.06.35-.48.71-.95,1.12-1.38.05-.16.27-.13.32-.28.21,0,.35-.08.37-.31.09-.07.18-.13.27-.2.29.03.43-.13.5-.38.38-.15.76-.3,1.13-.46.14.05.29.18.38-.07.07,0,.14-.01.22-.02.4.16.69.08.91-.22.12,0,.24,0,.37,0,0,.09.05.16.14.11.36-.23.76-.05,1.12-.14.42-.1.83.02,1.24-.05.11-.02.24-.03.34,0,.7.25,1.39.5,2.05.85.04.02.07.07.05.14-.14.04-.32-.1-.45.05-.3-.12-.59-.26-.86-.46-.4-.3-.89-.26-1.36-.26-.43,0-.85.03-1.28.05-.19,0-.39-.09-.55.09Z"
      />
      <path
        className="cls-2"
        d="m51.88,43.56c0-.07.01-.14.02-.22.12-.02.12-.12.11-.2-.03-.25.08-.49.1-.73,0-.1.02-.21.16-.2.14,0,.14.11.15.22.02.22.03.45.05.67,0,.1-.04.24.13.26.02.12.01.25-.05.36-.17.29-.07.6-.06.9-.02.37.04.74-.05,1.11-.25.33-.27.7-.24,1.09,0,.41-.2.77-.27,1.17-.21.06-.21.07-.23.51-.06.16-.13.33-.19.49-.16.01-.17.11-.14.24,0,0,0,0,0,0-.05-.02-.09,0-.13.03-.39.41-.51.96-.7,1.47-.03.07-.06.14-.09.21-.36.11-.43.37-.35.7-.25.39-.28.85-.47,1.26-.13.11-.13.28-.16.43-.02.43-.09.87-.06,1.3-.14.25-.08.5.06.7.13.18.07.26-.08.36-.21.04-.3-.15-.45-.22-.04-.34.05-.7-.22-1-.1-.11-.08-.27-.04-.43.16-.59.32-1.17.45-1.76.06-.31.14-.6.27-.89.05-.12.14-.25.07-.39,0-.02,0-.04.02-.05.1.02.12-.06.16-.13.35-.6.64-1.23,1.03-1.81.13-.19.33-.37.39-.62.07-.34.22-.66.26-1,.04-.31.28-.6.25-.87-.06-.53.48-.95.2-1.48,0,0,0-.02.01-.03.18-.47.11-.96.12-1.44Z"
      />
      <path
        className="cls-2"
        d="m48.07,61.85c-.07-.11.08-.19.05-.29.18.04.27-.21.48-.14.38.12.39.42.38.72,0,.12-.06.22.11.24.03.73.01,1.45.13,2.18.06.39-.02.81-.04,1.21-.13.08-.1.13.03.17,0,.12.01.24.02.35-.09,0-.2-.02-.19.1,0,.12.11.15.22.12.02.01.03.03.03.06-.06.14-.12.29.03.41.02.07.05.15.07.22.1.27.28.29.54.25.56-.1,1.13-.28,1.71-.09.02.16,0,.31-.06.45-.23.26-.46.51-.69.77-.39.08-.76.03-1.13-.09-.02-.11-.05-.19-.15-.05-.05-.01-.09-.03-.14-.04-.09-.17-.2-.31-.43-.24-.02,0-.03-.02-.04-.04-.22-.2-.44-.4-.57-.68,0-.01-.07,0-.11,0-.02-.01-.03-.03-.05-.05.15-.69-.03-1.36-.14-2.04-.02-.08-.03-.15-.05-.23.02-.12.09-.24-.06-.33,0-.05,0-.1,0-.15.03-.04.09-.07.09-.11,0-.34-.02-.67.13-1,.05-.1-.02-.17-.13-.18-.04-.22.13-.4.09-.62.02-.19-.02-.37.05-.56.06-.16,0-.29-.19-.35Z"
      />
      <path
        className="cls-2"
        d="m66.16,44.5c-.99-.65-1.87-1.45-2.97-1.94-.28-.14-.58-.27-.88-.19-.3.08-.53.14-.65-.24-.05-.15-.17-.21-.23.01-.02.09-.08.12-.14.15-.02,0-.04-.01-.06-.02-.04-.13-.07-.25-.11-.38,0,0,0,0,0,0,.26.1.26-.07.26-.25.06-.03.12-.05.17-.08.05.01.1.05.14.04.61-.18,1.23-.17,1.85-.15.09,0,.18,0,.23-.09.05.01.09.02.14.03.06.18.24.16.38.22.04.17.26.08.31.21.17.29.5.36.74.54.05.06.09.12.14.18.06.24.26.3.47.35.21,0,.29.22.46.29.02.26.1.44.35.59.28.16.51.44.6.74.1.34.16.67.46.9.12.09.12.26.07.38-.07.19-.21.03-.32.03-.11,0-.22,0-.34,0-.03-.07-.12-.11-.1-.21.03-.19-.04-.26-.23-.22-.05-.05-.1-.1-.15-.15.02-.11,0-.17-.13-.17-.09-.09-.17-.18-.26-.27.04-.19-.06-.27-.23-.3Z"
      />
      <path
        className="cls-1"
        d="m44.22,39.54c-.11.35-.22.7-.35,1.05-.08.23-.1.43.14.55.25.12.39-.04.49-.25.02-.04.07-.07.1-.1.15.37-.05.67-.2.98-.07.14-.19.14-.32.14-.64,0-1.28.02-1.91,0-.39,0-.73.17-1.09.25-.64.15-1.26.37-1.89.58-.26.09-.44.31-.63.5-.33.33-.63.72-.99,1.01-.47.37-.83.8-1.09,1.33-.03.06-.08.16-.18.17-.05-.16.1-.37-.09-.48-.14-.08-.29.02-.41.09-.15.09-.17.26-.16.43.01.17,0,.33-.23.34-.02-.37.03-.73.29-1.02.14-.15.1-.35.17-.53.48-1.05,1.28-1.82,2.17-2.52.68-.53,1.4-1.01,2.23-1.26.76-.23,1.51-.51,2.34-.44.33.03.66,0,.99.07.16.03.18-.08.2-.2.03-.18.06-.37.1-.55.04-.16.13-.24.3-.16Zm-2.11,1.77c-.43-.11-.89-.02-1.26-.32-.15-.11-.29-.08-.35.11-.06.19-.17.2-.35.18-.27-.03-.58-.11-.71.28-.02.06-.1.11-.16.16-.42.44-1.21.38-1.44,1.06,0,.02-.07.02-.1.04-.78.36-1.2,1.03-1.53,1.77-.04.09-.16.22,0,.3.12.06.27.05.39-.04.1-.07.17-.17.22-.29.06-.15.13-.31.29-.38.33-.14.52-.4.64-.7.17-.41.52-.66.87-.78.85-.29,1.61-.86,2.56-.83.26,0,.42-.22.65-.21.22.01.45.05.67.07.37.04.74-.03,1.1-.15.12-.04.23-.13.2-.28-.03-.14-.15-.16-.27-.15-.18.02-.33-.08-.44-.18-.15-.15-.34-.21-.52-.28-.26-.11-.37.12-.54.24-.22.16.06.24.07.38Z"
      />
      <path
        className="cls-1"
        d="m57.03,34.15c.13-.15.31,0,.45-.05.03-.07,0-.11-.05-.14-.66-.35-1.35-.61-2.05-.85-.1-.04-.23-.03-.34,0-.41.07-.82-.05-1.24.05-.36.08-.76-.09-1.12.14-.08.05-.14-.01-.14-.11.56-.29,1.17-.37,1.79-.39.39-.01.78,0,1.16,0,.29,0,.52.33.84.14.92.49,1.96.78,2.72,1.56.42.42.71.94,1.03,1.44.33.52.7,1.01.92,1.6.09.25.2.46.11.74-.07.21.17.4.2.64.03.25.01.49.06.73-.09.02-.13-.01-.15-.06-.2-.71-.65-1.34-.76-2.07-.04-.24-.15-.35-.27-.49-.4-.47-.81-.94-1.24-1.39-.52-.55-1.16-.96-1.79-1.38-.05-.03-.09-.08-.14-.12Z"
      />
      <path
        className="cls-2"
        d="m54.58,60.34c.1-.08.2-.15.29-.23.32-.02.48.22.68.39-.08.17-.16.34-.24.51-.3.11-.27.4-.33.64-.02.09-.05.19-.07.28-.15.09-.24.2-.11.38-.08.3-.17.59-.25.89-.14.07-.13.17-.06.28-.16.23-.15.51-.2.76-.03.13-.06.26-.09.4-.19.12-.29.29-.3.51-.04.55-.16,1.08-.37,1.59-.15,0-.3,0-.28-.22,0-.08.02-.18-.08-.22,0-.2.02-.39.03-.59.18-.39.21-.77.01-1.16,0-.09,0-.18,0-.26.1-.04.12-.13.1-.22-.15-.61.33-1.09.35-1.68.02-.51.43-.92.51-1.43.02-.1.07-.21.18-.22.29-.03.24-.22.22-.41Z"
      />
      <path
        className="cls-2"
        d="m56.57,52.98c0,.05-.01.1-.02.15-.19.05-.19.21-.2.36-.02.23-.09.44-.19.64-.06.14-.16.32-.29.3-.16-.03-.14-.24-.13-.39,0-.52,0-1.04.01-1.56.01-.36-.34-.62-.24-.99.08-.29,0-.53-.13-.8-.15-.29-.12-.66-.28-.95-.17-.32-.15-.74-.48-.98-.02-.09-.04-.18-.05-.27.12-.33-.07-.63-.09-.95-.01-.26.1-.22.23-.16.09.04.16.12.22.2.32.44.53.94.84,1.39.56.8.72,1.73.66,2.7-.01.24-.01.52.19.72,0,.12,0,.24,0,.37-.13.06-.16.13-.04.23Z"
      />
      <path
        className="cls-2"
        d="m65.52,54.19s.04-.01.07-.01c.34,0,.64-.14.93-.3.12-.11.28-.13.43-.14.07.14.28-.01.35.18-.23.18-.47.35-.77.42-.21.05-.35.16-.21.4,0,0-.02.02-.02.02-.13-.1-.16-.02-.18.1h-.03s-.03.01-.03.01c-.38.05-.74.19-1.12.22-.23.02-.47-.09-.69.05-.05,0-.1-.02-.15-.02,0-.06-.04-.1-.09-.09-.41.05-.81.11-1.21.16-.09,0-.19-.02-.28-.02-.11-.14-.25-.09-.39-.06-.05,0-.09,0-.14-.01-.42-.11-.78-.42-1.25-.37-.08,0-.19.04-.23-.07-.04-.13.09-.16.17-.2.17-.07.4-.05.48-.29.07.04.15.04.22,0,.2.17.68,0,.59.55.11-.19.3-.22.39-.37.08,0,.15,0,.23,0,.63,0,1.25.05,1.88-.06.28,0,.56,0,.84,0,.13.11.2.06.23-.09Z"
      />
      <path
        className="cls-2"
        d="m45.49,54.68s-.09-.02-.13-.03c-.46-.27-.99-.4-1.47-.62-.1-.04-.22-.02-.32.05-.53-.25-1.12-.2-1.67-.35-.38-.1-.76-.17-1.14-.26-.05-.21-.2-.13-.33-.11-.12,0-.25-.02-.37-.03-.11-.1-.25-.14-.39-.11-.41-.08-.72-.37-1.09-.53-.18-.08-.37-.1-.54-.19,0-.16,0-.3.23-.27.08,0,.18.02.22-.09.05,0,.09.02.14.03.03.13.1.14.2.06.02.01.05.02.07.03-.01.21.09.19.23.12.07.02.13.03.2.05.02.12.01.39.07.35.24-.18.46.08.67-.04.63.05,1.21.3,1.81.45-.06.21.08.29.24.3.19,0,.13-.17.14-.28.47.12.94.25,1.42.31.01.04.05.06.09.05.04,0,.09.02.13.03-.1.25-.04.38.26.37.25-.02.5-.01.75-.02.17.04.33.07.5.11.02.16.1.28.25.34.53.21,1.09.36,1.65.45h0c-.03.25.19.24.33.32.17.09.38.19.12.41-.11.03-.18-.02-.24-.11-.16-.29-.45-.24-.71-.27-.26-.18-.56-.26-.86-.35-.09-.23-.28-.17-.46-.17Z"
      />
      <path
        className="cls-1"
        d="m67.25,45.82c.11,0,.22,0,.34,0,.11,0,.24.16.32-.03.05-.13.05-.29-.07-.38-.3-.23-.36-.56-.46-.9-.09-.31-.32-.58-.6-.74-.25-.15-.33-.34-.35-.59.43.3.89.64,1.08,1.11.2.47.54.85.71,1.33.21.62.37,1.25.46,1.91.04.36.11.71.15,1.07.12.86.29,1.72.07,2.59-.07.28-.16.54-.36.75-.04-.09-.11-.17-.06-.28.15-.3.13-.65.3-.94.06-.11.12-.29-.05-.35-.16-.06-.17.12-.23.23-.06.12,0,.32-.22.34.15-.68.07-1.37.12-2.06.02-.21-.18-.36-.19-.56-.08-.93-.44-1.74-.96-2.5Z"
      />
      <path
        className="cls-1"
        d="m46.38,56.52c-.35-.17-.75-.18-1.1-.38-.35-.2-.75-.17-1.13-.2-.57-.04-1.14,0-1.71-.03-.65-.02-1.26-.22-1.88-.37-.39-.09-.72-.44-1.19-.26-.17.07-.57.12-.3-.34.05-.09.04-.2-.11-.22-.39-.05-.71-.3-1.02-.48-.34-.2-.72-.43-1.02-.73-.11-.11-.25-.24-.4-.27-.4-.09-.52-.34-.46-.71.61.7,1.55.9,2.21,1.53.55.03.81.55,1.28.73.68.26,1.29.72,2.04.75.4.01.78.06,1.16.12.5.08.99-.03,1.49,0,.54.04,1,.32,1.5.34.39.02.55.18.64.51Z"
      />
      <path
        className="cls-2"
        d="m57.74,54.82c-.45.1-.88.23-1.26.49-.13-.11-.29-.21-.42-.09-.13.11.04.25.07.37,0,.04.06.07.1.1-.19.18-.43.31-.59.52-.14-.03-.41.09-.34-.17.08-.32.18-.68.46-.87.3-.2.46-.49.65-.76.19-.1.39-.2.58-.31.11.04.22.02.33,0,.39-.08.79-.11,1.18-.05.07.01.22-.03.19.11-.04.18.04.28.18.31.17.05.32-.03.41-.18.16-.26.4-.27.66-.22.13.02.18.14.19.25.01.14-.12.09-.19.1-.19.02-.31.14-.38.31h0c-.4,0-.8,0-1.2,0-.21,0-.45-.1-.63.1Z"
      />
      <path
        className="cls-1"
        d="m56.62,52.38c-.2-.2-.2-.48-.19-.72.06-.97-.1-1.9-.66-2.7-.31-.45-.53-.95-.84-1.39-.06-.08-.13-.16-.22-.2-.14-.06-.25-.1-.23.16.02.32.21.62.09.95-.2-.14-.22-.38-.26-.57-.09-.4-.22-.79-.31-1.19.14,0,.22.09.31.18.06.06.16.08.24.01.09-.08.03-.16-.02-.23-.15-.17-.3-.34-.46-.52-.12.21-.02.35-.07.48-.21-.24-.24-.52-.23-.82.16.01.29.15.46.08.03.14.11.24.2.35.16.18.27.39.35.64.13.36.41.67.63.99.72,1.01,1.2,2.1,1.28,3.35.02.38-.05.77-.07,1.15Z"
      />
      <path
        className="cls-1"
        d="m56.41,54.4c-.19.28-.36.56-.65.76-.28.19-.38.55-.46.87-.06.27.21.15.34.17,0,.14.01.31-.2.27-.24-.04-.39-.21-.34-.46.08-.37.28-.7.53-.97.2-.22.28-.35.02-.6-.37-.35-.21-.84-.17-1.25.02-.27-.01-.52-.04-.77-.1-.9-.15-1.81-.49-2.67-.13-.33-.33-.64-.32-1.01.34.24.31.66.48.98.16.3.13.67.28.95.14.27.21.51.13.8-.11.37.25.63.24.99-.02.52-.01,1.04-.01,1.56,0,.15-.02.36.13.39.13.02.23-.16.29-.3.1-.21.17-.42.19-.64.02-.15,0-.31.2-.36,0,.29-.05.58-.16.86-.06.15-.06.28.01.41Z"
      />
      <path
        className="cls-1"
        d="m51.88,43.56c0,.48.06.97-.12,1.44,0,.01-.02.03-.01.03.28.53-.26.96-.2,1.48.03.26-.2.55-.25.87-.04.34-.19.66-.26,1-.06.26-.25.43-.39.62-.4.58-.68,1.21-1.03,1.81-.04.07-.06.14-.16.13-.03-.33.09-.64.24-.9.33-.57.74-1.09,1.03-1.68.07-.15.08-.31.12-.46.19-.66.53-1.29.55-1.98.02-.68.39-1.28.31-1.97-.02-.13,0-.3.16-.39Z"
      />
      <path
        className="cls-1"
        d="m59.57,54.71c.07-.17.19-.29.38-.31.08,0,.2.04.19-.1,0-.11-.06-.23-.19-.25-.26-.04-.5-.04-.66.22-.09.16-.24.23-.41.18-.14-.04-.22-.13-.18-.31.03-.14-.11-.1-.19-.11-.4-.06-.79-.03-1.18.05-.11.02-.22.04-.33,0,.33-.33.77-.25,1.15-.23.39.03.77.03,1.15,0,.65-.05,1.26.04,1.86.29-.07.24-.3.22-.48.29-.09.04-.21.07-.17.2.03.11.15.07.23.07.47-.05.83.26,1.25.37-.31.1-.61,0-.89-.09-.49-.16-1.02-.1-1.51-.27Z"
      />
      <path
        className="cls-1"
        d="m35.77,47.93c0,.1,0,.2,0,.29-.35-.08-.44.08-.37.4.03.13.04.27.07.4.05.21.16.4.38.4.28,0-.02-.28.13-.36.2.11.17.32.2.5.07.46.14.91.35,1.33.04.09.08.16-.02.23-.12.09-.18-.02-.24-.09-.26-.29-.43-.65-.55-1-.09-.26-.19-.52-.31-.77-.19-.38-.18-.79-.2-1.2-.03-.42,0-.83.05-1.25.02-.13-.06-.28.09-.37.17.33.34.63.08,1.02-.16.24.01.43.34.48Z"
      />
      <path
        className="cls-1"
        d="m60.07,59.62c.03-.12.14-.13.23-.17.7-.33,1.32-.78,1.89-1.3.36-.33.71-.65.93-1.1.04-.08.15-.17.18-.06.1.4.27.09.35.03.26-.18.48-.42.79-.52.02.17-.12.23-.23.31-.48.35-.95.71-1.43,1.07-.04.03-.09.06-.11.1-.3.74-1.02,1.04-1.61,1.46-.26.19-.63.34-1.01.17Z"
      />
      <path
        className="cls-1"
        d="m62.79,56.21c-.22.5-.69.73-1.1,1.02-.37.27-.8.27-1.22.21-.14-.02-.26.12-.4.04.06-.32.32-.43.57-.5.18-.05.34-.06.42-.25.04-.11.14-.15.23-.17.49-.13.97-.33,1.49-.35Z"
      />
      <path
        className="cls-2"
        d="m35.77,47.93c-.33-.05-.5-.24-.34-.48.26-.39.09-.69-.08-1.02-.06-.12.07-.19.06-.3.23,0,.24-.17.23-.34-.01-.17.01-.34.16-.43.12-.07.28-.17.41-.09.19.11.03.32.09.48-.01.02-.02.04-.02.06-.31.13-.3.38-.23.65-.09.49-.18.98-.28,1.47Z"
      />
      <path
        className="cls-1"
        d="m49.45,51c.07.15-.02.28-.07.39-.13.29-.2.58-.27.89-.13.59-.29,1.18-.45,1.76-.04.16-.06.32.04.43.27.3.18.66.22,1-.52-.45-.57-1.07-.48-1.67.1-.68.31-1.34.5-2,.09-.31.19-.62.49-.81Z"
      />
      <path
        className="cls-1"
        d="m57.84,57.71c-.45.03-.89.06-1.34.08-.8.04-1.54.28-2.2.72-.24.16-.23.54-.08.66.27.21.04.33-.03.4-.28.26-.08.3.14.36-.19.14-.37.05-.49-.09-.14-.16.07-.22.15-.31.03-.03.04-.13.02-.14-.42-.26.07-.51.02-.78-.03-.14.18-.32.35-.41.51-.26,1.04-.49,1.6-.63.37-.1.76.06,1.14-.02.17-.03.34.02.52-.04.18-.07.22.05.21.2Z"
      />
      <path
        className="cls-1"
        d="m54.58,60.34c.02.19.07.38-.22.41-.11,0-.17.12-.18.22-.08.51-.5.92-.51,1.43-.02.59-.5,1.06-.35,1.68.02.08,0,.18-.1.22,0-.65-.17-1.29.14-1.95.16-.33.24-.74.36-1.1.14-.39.35-.82.87-.9Z"
      />
      <path
        className="cls-2"
        d="m54.22,45.9c-.17.07-.3-.07-.46-.08-.28-.45-.37-.96-.52-1.45-.02-.07-.06-.13-.08-.2,0-.23.07-.45-.05-.68-.08-.15.03-.22.18-.21.16.47.32.94.47,1.41.14.31.17.66.42.92.01.1.02.19.03.29Z"
      />
      <path
        className="cls-1"
        d="m68.51,51.99c-.05.45-.39.7-.67.99-.06.07-.16.09-.24.04-.1-.07-.02-.16,0-.24.16-.54.33-1.09.48-1.63.03-.11.09-.14.18-.15.13.27-.06.48-.13.7-.05.14-.14.29.02.41.16.12.23-.1.35-.12Z"
      />
      <path
        className="cls-1"
        d="m60.02,57.5c.02.19-.2.1-.26.21.03.16.41.24.18.43-.24.19-.53.08-.78-.12-.19-.15.06-.15.07-.25-.19-.1-.35,0-.53.04-.24.06-.52.23-.73-.08.22-.06.47-.01.64-.24.11-.15.27.06.42.02.33-.07.66-.07.99-.01Z"
      />
      <path
        className="cls-1"
        d="m38.48,52.14c-.04.11-.13.1-.22.09-.22-.02-.24.11-.23.27-.52-.07-1.06-.06-1.46-.49-.11-.12-.2-.23-.04-.37.19-.17.24-.03.32.11.07.14.21.13.35.17.42.1.87.03,1.27.22Z"
      />
      <path
        className="cls-1"
        d="m52.6,43.35c-.17-.02-.12-.16-.13-.26-.02-.22-.03-.45-.05-.67,0-.1-.01-.21-.15-.22-.14,0-.15.1-.16.2-.02.25-.13.48-.1.73,0,.09,0,.18-.11.2-.1-.19-.05-.4-.03-.59.05-.32.15-.62.15-.95,0-.13.03-.33.22-.34.19,0,.22.17.24.32.01.12.04.25.05.37.02.28.13.15.24.06.1.15-.02.28-.06.42-.23.2,0,.49-.12.71Z"
      />
      <path
        className="cls-1"
        d="m36.05,52.46c-.44-.1-.46-.08-.42.4.01.15.12.28.04.44-.23-.61-.7-1.17-.48-1.93.44.27.61.71.86,1.1Z"
      />
      <path
        className="cls-1"
        d="m47.75,55.58c.26-.22.05-.32-.12-.41-.14-.08-.35-.07-.33-.32.33,0,.56.23.83.38.2.11.3.36.56.41.09.01.13.11.1.21-.02.09-.09.18-.18.15-.3-.11-.65-.11-.86-.41Z"
      />
      <path
        className="cls-2"
        d="m35.99,49.06c-.16.08.15.37-.13.36-.22,0-.33-.19-.38-.4-.03-.13-.04-.27-.07-.4-.08-.32.02-.47.37-.4.38.2.15.56.21.84Z"
      />
      <path
        className="cls-2"
        d="m68.51,51.99c-.12.03-.19.25-.35.12-.16-.12-.07-.27-.02-.41.07-.23.27-.44.13-.7,0-.02,0-.04.02-.06.22-.02.15-.22.22-.34.06-.1.07-.29.23-.23.16.06.11.24.05.35-.17.29-.15.65-.3.94-.05.11.01.19.06.28,0,.02-.02.04-.03.06Z"
      />
      <path
        className="cls-1"
        d="m49.1,62.39c-.18-.02-.12-.13-.11-.24,0-.3,0-.6-.38-.72-.21-.07-.3.18-.48.14.01-.06.04-.12.04-.17,0-.27.09-.54.39-.54.28,0,.38.29.45.52.1.33.18.67.1,1.02Z"
      />
      <path
        className="cls-1"
        d="m41.68,58.32c.19-.09.37.01.54.04.84.13,1.68.28,2.53.13.04,0,.09.03.13.05-.17.13-.37.13-.56.14-.8.06-1.58-.03-2.36-.19-.11-.02-.22-.06-.28-.17Z"
      />
      <path
        className="cls-1"
        d="m51.66,67.36c-.58-.19-1.15,0-1.71.09-.26.04-.45.03-.54-.25.6.12,1.17-.22,1.76-.13.2.03.48-.06.5.29Z"
      />
      <path
        className="cls-1"
        d="m66.32,54.74c-.14-.24,0-.35.21-.4.3-.07.54-.24.77-.42-.06-.19-.28-.04-.35-.18.01-.02.02-.05.03-.06.25-.09.59-.33.74-.12.13.19-.25.4-.45.55-.31.22-.59.48-.95.63Z"
      />
      <path
        className="cls-1"
        d="m48.85,35.39c-.12-.25-.21-.51.21-.53.35,0,.59-.24.87-.38.31-.15.61-.36.98-.33-.23.29-.61.29-.91.45-.41.22-.67.66-1.14.78Z"
      />
      <path
        className="cls-1"
        d="m35.98,53.97c.34.19.46.54.65.84.26.41.46.86.9,1.13.1.06.16.16.11.29-.71-.38-1.02-1.09-1.39-1.74-.1-.17-.26-.31-.27-.52Z"
      />
      <path
        className="cls-1"
        d="m47.3,54.84c-.57-.09-1.12-.24-1.65-.45-.15-.06-.24-.18-.25-.34.28-.07.46.18.72.23.36.07.75.17,1.07.4.06.04.14.07.12.17Z"
      />
      <path
        className="cls-1"
        d="m48.1,35.11c-.42.42-.78.89-1.12,1.38-.07.1-.2.09-.31.06.34-.43.56-.97,1.02-1.31.11-.08.25-.17.41-.12Z"
      />
      <path
        className="cls-1"
        d="m53.17,66.31c.1.05.09.14.08.22-.03.23.12.22.28.22.03.3-.2.5-.3.75-.03.09-.11.09-.17.01-.1-.12-.04-1.08.07-1.2,0,0,.02,0,.04,0Z"
      />
      <path
        className="cls-1"
        d="m63.78,41.36c-.05.1-.14.09-.23.09-.62-.02-1.25-.03-1.85.15-.04.01-.09-.02-.14-.04.45-.29.96-.32,1.46-.32.18,0,.36.05.55.01.1-.02.21-.06.21.11Z"
      />
      <path
        className="cls-1"
        d="m61.3,42.28c.07-.03.12-.06.14-.15.06-.22.18-.16.23-.01.12.38.34.32.65.24.3-.08.6.05.88.19-.58.05-1.15.05-1.71-.11-.09-.03-.16-.06-.18-.15Z"
      />
      <path
        className="cls-1"
        d="m64.24,55.14c.22-.14.46-.03.69-.05.39-.03.74-.17,1.12-.22-.03.13-.15.23-.11.38-.26-.04-.5.06-.75.09-.18-.13-.4-.08-.6-.1-.12-.01-.27.06-.36-.1Z"
      />
      <path
        className="cls-1"
        d="m48.14,65.36c.12.67.29,1.34.14,2.04-.22-.19-.09-.45-.13-.67-.07-.34-.1-.69-.17-1.03-.03-.14-.01-.28.16-.33Z"
      />
      <path
        className="cls-1"
        d="m53.29,43.28c-.15,0-.26.06-.18.21.11.23.05.45.05.68-.24-.24-.42-1.01-.29-1.29.12,0,.23,0,.35,0,.1.12.09.26.07.4Z"
      />
      <path
        className="cls-2"
        d="m53.22,42.88c-.12,0-.23,0-.35,0-.02-.1-.08-.17-.15-.23.04-.14.15-.26.06-.42-.13-.13-.04-.21.07-.25.12-.05.2.04.23.14.06.25.1.51.14.76Z"
      />
      <path
        className="cls-1"
        d="m49.39,55.7c.15-.09.2-.18.08-.36-.14-.2-.2-.46-.06-.7.18.31.21.67.43.96.04.06.05.21-.05.22-.13.02-.33.13-.4-.12Z"
      />
      <path
        className="cls-1"
        d="m43.56,54.08c.1-.07.23-.09.32-.05.48.22,1.01.35,1.47.62-.44.02-.82-.19-1.21-.32-.19-.06-.43-.07-.58-.25Z"
      />
      <path
        className="cls-1"
        d="m39.44,57.44c.34.07.58.32.88.47.21.1.51,0,.65.27-.56.08-1.34-.3-1.53-.73Z"
      />
      <path
        className="cls-1"
        d="m64.46,54.28c-.62.11-1.25.06-1.88.06.02-.09.09-.13.16-.13.53-.01,1.07-.02,1.6-.01.04,0,.07.06.11.09Z"
      />
      <path
        className="cls-1"
        d="m50.9,68.58c.23-.26.46-.51.69-.77.1.29-.09.53-.18.77-.06.17-.34.12-.51,0Z"
      />
      <path
        className="cls-1"
        d="m50.54,50.73c.18-.51.3-1.06.7-1.47.04-.04.08-.05.13-.03-.26.51-.4,1.09-.83,1.5Z"
      />
      <path
        className="cls-1"
        d="m57.74,54.82c.18-.2.42-.09.63-.1.4-.01.8,0,1.2,0-.03.12-.11.16-.22.15-.53-.04-1.07.03-1.61-.05Z"
      />
      <path
        className="cls-1"
        d="m44.89,53.94c-.25,0-.5,0-.75.02-.3.02-.35-.12-.26-.37.23.05.45.12.68.15.11.01.29,0,.32.2Z"
      />
      <path
        className="cls-2"
        d="m54,46.64c.05-.13-.05-.27.07-.48.16.18.31.35.46.52.06.07.11.15.02.23-.07.06-.17.05-.24-.01-.09-.09-.17-.18-.31-.18,0-.03,0-.05,0-.08Z"
      />
      <path
        className="cls-1"
        d="m38.31,56.91c.41.06.8.17,1.07.52-.41-.06-.83-.1-1.07-.52Z"
      />
      <path
        className="cls-1"
        d="m64.02,55.93c-.1.24-.38.3-.49.57-.13-.47-.49-.2-.73-.29.03-.07.08-.15.15-.14.37.05.71-.15,1.07-.13Z"
      />
      <path
        className="cls-1"
        d="m65.16,55.37c-.22.39-.63.44-1,.55-.06-.22.13-.24.25-.29.24-.1.44-.34.75-.26Z"
      />
      <path
        className="cls-1"
        d="m64.45,56.5c.26-.26.41-.67.89-.6-.22.32-.54.48-.89.6Z"
      />
      <path
        className="cls-1"
        d="m62.35,54.33c-.09.15-.28.19-.39.37.1-.55-.39-.38-.59-.55.14-.12.32-.11.43-.03.17.12.4.06.55.21Z"
      />
      <path
        className="cls-1"
        d="m47.14,37.08c.02-.4.3-.73.68-.83-.19.3-.35.64-.68.83Z"
      />
      <path
        className="cls-1"
        d="m48.11,63.37c.11.01.17.07.13.18-.14.32-.13.66-.13,1,0,.04-.06.07-.09.11-.17-.44-.11-.86.08-1.28Z"
      />
      <path
        className="cls-1"
        d="m45.76,37.37c-.19.42-.49.75-.81,1.08.08-.5.39-.83.81-1.08Z"
      />
      <path
        className="cls-1"
        d="m55.56,60.51c-.2-.17-.37-.41-.68-.39.14-.24.37-.25.6-.22.03.16-.05.37.19.44-.01.07,0,.16-.11.18Z"
      />
      <path
        className="cls-1"
        d="m62.78,55.18c.4-.05.81-.11,1.21-.16.05,0,.09.03.09.09-.09.21-.28.12-.41.11-.3-.02-.6.15-.89-.04Z"
      />
      <path
        className="cls-1"
        d="m52.19,33.18c-.22.3-.51.38-.91.22.26-.26.59-.19.91-.22Z"
      />
      <path
        className="cls-1"
        d="m53.21,64.55c.2.39.17.78-.01,1.16-.08-.39-.06-.78.01-1.16Z"
      />
      <path
        className="cls-2"
        d="m55.67,60.33c-.24-.07-.16-.28-.19-.44.05,0,.1,0,.14,0,.11.04.29-.1.32.12.03.2-.1.29-.28.31Z"
      />
      <path
        className="cls-1"
        d="m52.2,46.82c-.03-.39,0-.76.24-1.09-.07.36.06.78-.24,1.09Z"
      />
      <path
        className="cls-1"
        d="m56.23,55.69s-.09-.06-.1-.1c-.03-.13-.2-.26-.07-.37.13-.12.29-.02.42.09-.08.13-.17.25-.25.38Z"
      />
      <path
        className="cls-1"
        d="m48.33,67.44s.1-.01.11,0c.13.28.35.48.57.68-.41.04-.54-.09-.68-.68Z"
      />
      <path
        className="cls-1"
        d="m40.06,52.74c-.21.13-.44-.14-.67.04-.05.04-.04-.23-.07-.35.28.03.5.19.74.31Z"
      />
      <path
        className="cls-1"
        d="m54.19,45.61c-.25-.26-.29-.61-.42-.92.31.23.37.57.42.92Z"
      />
      <path
        className="cls-1"
        d="m48.07,61.85c.18.05.24.19.19.35-.07.19-.03.37-.05.56-.2.03-.19-.11-.18-.24.01-.22.03-.44.04-.67Z"
      />
      <path
        className="cls-1"
        d="m66.51,53.88c-.29.16-.58.3-.93.3.26-.25.57-.35.93-.3Z"
      />
      <path
        className="cls-1"
        d="m65.36,42.36c-.25-.18-.58-.25-.74-.54.38,0,.69.23.74.54Z"
      />
      <path
        className="cls-1"
        d="m50.09,51.64c-.08-.33,0-.59.35-.7-.04.27-.2.48-.35.7Z"
      />
      <path
        className="cls-1"
        d="m52.49,44.62c0-.3-.11-.61.06-.9.09.31.19.62-.06.9Z"
      />
      <path
        className="cls-1"
        d="m46.61,37.84c0-.28.01-.56.41-.54-.15.17-.18.44-.41.54Z"
      />
      <path
        className="cls-1"
        d="m42.25,53.21c0,.12.05.29-.14.28-.15,0-.3-.09-.24-.3.13-.04.25-.05.37.01Z"
      />
      <path
        className="cls-1"
        d="m54.99,61.66c.06-.24.03-.52.33-.64-.01.26-.12.48-.33.64Z"
      />
      <path
        className="cls-1"
        d="m46.81,55.2c.26.03.55-.02.71.27-.24-.06-.54-.01-.71-.27Z"
      />
      <path
        className="cls-1"
        d="m65.96,42.89c-.21-.05-.4-.11-.47-.35.31-.08.41.1.47.35Z"
      />
      <path
        className="cls-1"
        d="m49.56,33.94c-.07.25-.21.41-.5.38.12-.19.25-.37.5-.38Z"
      />
      <path
        className="cls-1"
        d="m53.9,65.15c0-.23.12-.39.3-.51.02.24-.06.42-.3.51Z"
      />
      <path
        className="cls-1"
        d="m36.04,46.46c-.07-.27-.08-.52.23-.65-.02.23-.12.45-.23.65Z"
      />
      <path
        className="cls-1"
        d="m47.43,59.01c.25-.03.43.05.54.29-.26.06-.4-.11-.54-.29Z"
      />
      <path
        className="cls-1"
        d="m51.7,48.49c.01-.44.02-.45.23-.51-.05.18,0,.4-.23.51Z"
      />
      <path
        className="cls-1"
        d="m52.99,33.57c.16-.18.36-.1.55-.09-.14.27-.36.11-.55.09Z"
      />
      <path
        className="cls-1"
        d="m49.46,53.33c.04-.15.03-.32.16-.43.09.2.05.35-.16.43Z"
      />
      <path
        className="cls-1"
        d="m46.19,36.98c.06.3-.14.31-.35.33.07-.15.17-.28.35-.33Z"
      />
      <path
        className="cls-1"
        d="m44.66,38.83c0,.14-.03.28-.15.37-.13-.2-.1-.33.15-.37Z"
      />
      <path
        className="cls-1"
        d="m45.49,54.68c.17,0,.37-.06.46.17-.19.06-.32-.07-.46-.17Z"
      />
      <path
        className="cls-1"
        d="m49.06,68.16c.23-.07.34.06.43.24-.21.05-.37,0-.43-.24Z"
      />
      <path
        className="cls-1"
        d="m48.79,34.52c-.02.23-.16.31-.37.31.06-.18.16-.31.37-.31Z"
      />
      <path
        className="cls-1"
        d="m44.82,40.19c-.03-.18-.02-.34.19-.41.02.18.02.34-.19.41Z"
      />
      <path
        className="cls-1"
        d="m46.67,36.54c-.01.23-.15.32-.36.31.09-.14.14-.33.36-.31Z"
      />
      <path
        className="cls-1"
        d="m61.39,41.63c0,.18,0,.35-.26.25.02-.15.06-.29.26-.25Z"
      />
      <path
        className="cls-1"
        d="m62.11,55.1c.14-.03.28-.07.39.06-.15.1-.28.09-.39-.06Z"
      />
      <path
        className="cls-1"
        d="m45.05,39.74c0-.25.23-.22.36-.32.01.25-.19.27-.36.32Z"
      />
      <path
        className="cls-1"
        d="m49.33,66.98c-.16-.13-.09-.27-.03-.41.15.13.13.27.03.41Z"
      />
      <path
        className="cls-1"
        d="m54.81,62.31c-.13-.18-.04-.28.11-.38.06.15-.03.26-.11.38Z"
      />
      <path
        className="cls-1"
        d="m59.56,59.74c.09-.22.23-.18.38-.08-.09.19-.25.08-.38.08Z"
      />
      <path
        className="cls-1"
        d="m58.43,59.89c.11-.2.27-.12.42-.08-.12.13-.27.11-.42.08Z"
      />
      <path
        className="cls-1"
        d="m39.66,53.22c.15-.03.28,0,.39.11-.16.08-.29,0-.39-.11Z"
      />
      <path
        className="cls-1"
        d="m64.3,41.61c-.13-.06-.31-.04-.38-.22.17,0,.37-.07.38.22Z"
      />
      <path
        className="cls-1"
        d="m61.12,41.89c.04.13.07.25.11.38-.22-.1-.25-.19-.11-.38Z"
      />
      <path
        className="cls-1"
        d="m47.91,36.13c-.01-.22.15-.22.3-.23-.02.18-.13.24-.3.23Z"
      />
      <path
        className="cls-1"
        d="m51.06,33.42c-.09.25-.24.12-.38.07.1-.15.24-.08.38-.07Z"
      />
      <path
        className="cls-1"
        d="m48.18,58.86c-.21-.07-.17-.18-.05-.31.14.08.09.2.05.31Z"
      />
      <path
        className="cls-1"
        d="m66.16,44.5c.17.03.26.11.23.3-.15-.04-.22-.15-.23-.3Z"
      />
      <path
        className="cls-1"
        d="m57.23,59.85c.12-.1.23-.11.31.04-.11.03-.22.09-.31-.04Z"
      />
      <path
        className="cls-1"
        d="m40.43,53.36c.13-.01.28-.09.33.11-.12,0-.26.04-.33-.11Z"
      />
      <path
        className="cls-1"
        d="m49.26,66.52c-.11.04-.21,0-.22-.12,0-.12.1-.11.19-.1.05.07.06.14.03.22Z"
      />
      <path
        className="cls-1"
        d="m48.03,64.8c.15.09.08.21.06.33-.21-.08-.2-.19-.06-.33Z"
      />
      <path
        className="cls-1"
        d="m66.93,45.39c.19-.04.26.04.23.22-.14,0-.23-.07-.23-.22Z"
      />
      <path
        className="cls-1"
        d="m47.81,57.95c-.16,0-.22-.09-.21-.24.15,0,.23.08.21.24Z"
      />
      <path
        className="cls-1"
        d="m65.52,54.19c-.03.15-.1.2-.23.09.03-.15.13-.12.23-.09Z"
      />
      <path
        className="cls-1"
        d="m56.57,52.98c-.12-.1-.09-.18.04-.23.04.09.05.17-.04.23Z"
      />
      <path
        className="cls-1"
        d="m54.49,63.48c-.07-.11-.08-.21.06-.28.05.11.06.21-.06.28Z"
      />
      <path
        className="cls-1"
        d="m39.12,52.38c-.14.07-.24.09-.23-.12.1-.01.18.02.23.12Z"
      />
      <path
        className="cls-1"
        d="m51.37,49.22c-.03-.12-.02-.22.14-.24.03.12,0,.21-.14.24Z"
      />
      <path
        className="cls-1"
        d="m48.63,35.49c.03-.12.09-.15.2-.07-.03.13-.1.12-.2.07Z"
      />
      <path
        className="cls-1"
        d="m49.22,65.94c-.13-.03-.16-.09-.03-.17.08.04.08.1.03.17Z"
      />
      <path
        className="cls-1"
        d="m48,58.28c-.05.04-.12.05-.15-.01-.03-.07.03-.1.09-.1l.05.11Z"
      />
      <path
        className="cls-1"
        d="m38.82,52.23c-.1.08-.17.07-.2-.06.09-.04.15-.02.2.06Z"
      />
      <path
        className="cls-1"
        d="m48.12,58.47c-.11-.02-.18-.06-.11-.18.1.02.14.08.11.18Z"
      />
      <path
        className="cls-1"
        d="m66.65,45.07c.12,0,.15.06.13.17-.1-.01-.16-.06-.13-.17Z"
      />
      <path
        className="cls-1"
        d="m54.52,59.9c.02-.1.09-.08.16-.06-.02.1-.06.18-.16.06Z"
      />
      <path
        className="cls-1"
        d="m66.11,54.85c.02-.11.05-.2.18-.1-.03.09-.09.12-.18.1Z"
      />
      <path
        className="cls-1"
        d="m44.95,38.44c.02.13-.03.17-.16.15-.01-.12.04-.16.16-.15Z"
      />
      <path
        className="cls-1"
        d="m49.62,68.44c.1-.14.13-.06.15.05-.07.04-.12.03-.15-.05Z"
      />
      <path
        className="cls-1"
        d="m47.04,37.27c-.07-.11-.04-.18.09-.18.02.09,0,.16-.09.18Z"
      />
      <path
        className="cls-1"
        d="m43.76,53.57s-.08,0-.09-.05c.06-.04.08,0,.09.05Z"
      />
      <path
        className="cls-2"
        d="m42.12,41.31c0-.15-.29-.22-.07-.38.16-.12.27-.35.54-.24.18.08.37.14.52.28.11.11.26.2.44.18.12-.01.24.02.27.15.03.15-.08.24-.2.28-.36.11-.73.19-1.1.15-.22-.02-.45-.06-.67-.07-.23-.01-.39.21-.65.21-.94-.03-1.71.54-2.56.83-.35.12-.7.36-.87.78-.12.3-.32.56-.64.7-.16.07-.23.23-.29.38-.05.12-.12.22-.22.29-.12.09-.27.1-.39.04-.15-.08-.03-.21,0-.3.33-.74.75-1.41,1.53-1.77.03-.02.09-.02.1-.04.24-.69,1.03-.62,1.44-1.06.05-.05.13-.1.16-.16.13-.38.43-.31.71-.28.17.02.29.02.35-.18.06-.2.2-.23.35-.11.37.3.83.21,1.26.32Z"
      />
    </Icon>
  );
}

export function IconMachineWashable({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="30 27 37 48"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #272222; }`}
          {`.cls-2 { fill: #7c7979; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m54.13,43.56c.43-.49.93-.26,1.35-.05.31.15.65.21.95.39.24.15.49.26.64.53.1.18.31.3.47.37.5.23.79.66,1.12,1.04.64.74,1.16,1.56,1.51,2.48.39,1.03.56,2.09.69,3.18.13,1.09-.02,2.13-.22,3.17-.15.77-.41,1.52-.72,2.26-.28.68-.6,1.32-.99,1.95-.16.27-.37.49-.57.73-.3.35-.51.76-.84,1.1-.67.7-1.39,1.33-2.19,1.86-.85.56-1.77,1-2.74,1.36-1.38.51-2.77.65-4.21.53-1.08-.09-2.11-.35-3.11-.83-.58-.28-1.14-.58-1.65-.96-1.37-1.02-2.38-2.34-2.98-3.92-.2-.54-.46-1.07-.52-1.67-.1-.95-.24-1.88-.1-2.86.09-.63.21-1.27.22-1.91,0-.22.14-.38.2-.58.25-.85.57-1.67,1.03-2.44.25-.41.52-.81.78-1.21.11-.16.25-.26.38-.38.28-.27.47-.6.72-.88.57-.64,1.2-1.22,1.91-1.69.93-.61,1.9-1.18,2.98-1.51.68-.2,1.36-.46,2.07-.47.59-.01,1.17-.13,1.76-.05,0,.25-.2.13-.3.12-.25-.02-.27.08-.19.27-.35.03-.71.03-1.05.09-.48.09-.98.1-1.44.28-1.05.42-2.1.83-3.04,1.49-.55.39-1.07.83-1.53,1.3-.78.78-1.45,1.67-2.02,2.63-.47.79-.84,1.62-1.09,2.49-.17.62-.3,1.25-.34,1.91-.06,1.21-.1,2.39.23,3.58.32,1.14.87,2.14,1.57,3.08.32.43.67.8,1.11,1.13.28.21.47.56.87.63.04,0,.06.1.1.13.26.18.49.46.84.45.14,0,.23.04.34.07.25.07.46.19.68.3.52.24,1.08.22,1.63.29.4.05.83-.09,1.21.14.23-.24.54-.18.82-.22.96-.12,1.86-.42,2.76-.75.65-.24,1.22-.61,1.77-.97.53-.35,1.07-.77,1.5-1.28.26-.3.6-.54.82-.86.51-.72,1.02-1.44,1.39-2.24.16-.35.27-.73.45-1.07.25-.48.2-1.04.49-1.51.11-.19.17-.48.12-.68-.08-.31,0-.58.04-.86.06-.35.07-.7.09-1.05.02-.32-.1-.61-.12-.92-.07-1.09-.47-2.09-.95-3.04-.41-.81-1-1.51-1.67-2.14-.79-.75-1.74-1.23-2.72-1.68-.27-.12-.43-.23-.41-.53-.02-.06,0-.11.06-.12Z"
      />
      <path
        className="cls-1"
        d="m45.33,41.97c.26-.26.67-.18.95-.41.55-.07,1.11-.14,1.65-.3.2-.06.39.02.6.08-.11.13-.3,0-.34.18-.35.19-.75.16-1.12.28-.66.22-1.3.47-1.93.78-.17.09-.4.1-.5.31-.09-.02-.2-.06-.27,0-.17.17-.42.22-.6.4-.18.19-.43.39-.64.44-.39.1-.5.38-.66.65-.03.02-.05.04-.08.06-.09-.02-.13.02-.15.1,0,0-.02.02-.02.02-.2.14-.4.26-.52.49-.58.73-1.26,1.38-1.65,2.25-.18.39-.41.76-.63,1.14-.09.04-.21-.02-.3.08.07.08.16.05.23.06-.17.52-.33,1.03-.5,1.55-.13.37-.18.74-.2,1.13-.1.08-.31.13-.08.3-.17.72-.11,1.45-.13,2.18-.18.21.03.49-.1.71.04.02.08.04.12.06.09.48.07.98.24,1.45-.12.09-.09.16.03.21.01.07.02.14.04.21-.32.2.05.23.08.35.04.16.07.31.11.47-.1.11-.08.17.06.2.35,1.5,1.13,2.8,1.86,4.13-.01.32.26.49.38.75.04.09.11.04.17,0,.12.07.14.2.21.3-.05.23.02.4.19.58.35.38.71.75,1.08,1.11.28.27.59.5.89.73.16.12.34.31.6.27.33.08.53.43.89.44.03.15.24.13.26.28-.05.13-.22,0-.28.14.19.06.33,0,.48-.1.4.06.78.25,1.2.21.15.24.39.22.63.2.56.19,1.14.18,1.72.12.07.13.2.08.31.09.8.07,1.59-.05,2.39-.08.27,0,.61.04.82-.24.05,0,.1,0,.14.01.12.05.23.06.27-.09l.41-.02c.16.13.17-.02.22-.11.1-.04.2-.08.31-.12.09.05.15.03.18-.07.05,0,.09-.01.14-.02.06.02.1,0,.12-.06.4-.02.67-.35,1.04-.44.3-.05.57-.16.77-.4.39-.22.73-.54,1.12-.72.4-.18.59-.54.9-.77.28-.2.49-.48.72-.74.44-.1.55-.47.69-.82.03-.23.19-.4.33-.56.25-.3.46-.63.58-1.01.1-.03.13-.09.05-.17.06-.08.12-.16.17-.24.15-.11.17-.26.17-.43h0c.07.02.1-.02.13-.08.19-.39.2-.87.54-1.19.03-.03.02-.05,0-.09-.13-.22-.04-.46-.1-.69.11-.53.48-1,.36-1.58.06,0,.12-.02.13-.08.05-.39.09-.78.13-1.17,0-.05,0-.09,0-.14.13-.34.14-.69.12-1.04-.02-.08.04-.13.07-.19.06-.55.05-1.09.02-1.65-.04-.71-.15-1.4-.35-2.07-.12-.41-.19-.87-.57-1.17-.02-.36-.24-.65-.38-.95-.27-.57-.64-1.09-.98-1.63-.16-.26-.42-.45-.56-.72-.01-.19-.06-.35-.26-.43-.02-.02-.05-.04-.07-.07.01-.15-.09-.21-.2-.28-.62-.65-1.37-1.11-2.17-1.5-.27-.13-.53-.29-.79-.43-.3-.26-.63-.44-1.03-.48-.1-.12-.24-.02-.35-.07-.06-.23-.27-.26-.45-.31-.21-.06-.32-.17-.29-.41.03-.26.2-.26.39-.23.46.07.91.14,1.37.21.26.23.63.17.91.34.03.04.04.09.08.11.46.17.79.53,1.2.78.3.18.56.55,1,.43.25-.02.37.21.49.34.36.37.74.75,1,1.19.44.76,1.03,1.42,1.4,2.23.09.2.08.44.28.59-.05,0-.1.03-.08.08.16.34.22.73.49,1.02.1.59.47,1.1.44,1.72-.09.07-.06.12.04.15.01.23,0,.46.09.68-.02.37-.07.74.06,1.1.12.25,0,.5.02.75.06.89-.17,1.76-.16,2.64,0,.65-.3,1.26-.39,1.9-.09.07-.1.15-.05.25,0,.04-.02.08-.03.11-.1.05-.08.13-.06.22-.14.41-.28.81-.41,1.22-.24.75-.49,1.5-.95,2.16-.18.27-.22.63-.47.87-.04,0-.06.01-.06.06-.02.03-.05.05-.07.08-.21.04-.21.19-.19.35,0,.02-.02.04-.03.05-.11-.01-.14.04-.12.14h0c-.18-.02-.23.07-.19.23,0,.02-.02.03-.03.05-.1,0-.13.05-.12.14h0c-.18,0-.14.11-.13.22-.01.05.01.12-.08.13-.27.01-.5.24-.48.48-.04.27-.36.23-.48.42-.04-.08-.13-.09-.17-.04-.35.39-.8.66-1.2.99,0,0,0,.02,0,.03-.29.12-.57.27-.76.53-.56.12-1.09.3-1.6.56-.18.09-.47.05-.54.33-.04,0-.08.02-.11.03-.1-.03-.2-.05-.22.1-.06,0-.12.02-.17.02-.14-.04-.3-.14-.32.13-.11.07-.21.14-.34.13-.07-.08-.12-.06-.16.03-.04,0-.08.02-.12.03-.12-.07-.24-.09-.34.04-.06,0-.12.02-.18.03-.09-.04-.17-.06-.24.04-.05,0-.09,0-.14,0-.22-.3-.26-.29-.42.04-.16.04-.32.08-.48.13-.32-.09-.65-.1-.97,0-.81.04-1.62.08-2.41-.07-.46-.09-.91-.18-1.37-.26-.04-.06-.03-.15-.13-.18-.39-.12-.78-.24-1.14-.42-.1-.05-.21-.09-.32,0-1.07-.53-2.01-1.21-2.85-2.08-.45-.46-.79-1-1.2-1.48-.13-.15-.13-.39-.32-.5-.02-.22-.06-.42-.3-.52-.02-.01-.03-.02-.03-.04.03-.14-.04-.21-.17-.24-.14-.15-.23-.34-.31-.53.09-.25,0-.42-.25-.5-.01-.05.09-.09.02-.15-.54-.48-.56-1.2-.85-1.8-.11-.24-.29-.45-.29-.74,0-.41-.06-.81-.19-1.21,0-.02-.06-.02-.09-.03-.12-.1-.02-.24-.07-.35.02-.02.05-.04.05-.04-.17-.39.16-.87-.21-1.23-.03-.03-.02-.14,0-.2.11-.31-.05-.58-.09-.88.03-.48-.17-.96.04-1.43.1-.03.1-.12.1-.19,0-.94.25-1.83.51-2.73.09-.3.19-.52.64-.56-.32-.16-.25-.3-.16-.47.11-.21.33-.49.31-.61-.07-.33.09-.5.27-.68.12-.12.17-.24.07-.4.03-.04.07-.09.1-.13.06.03.1,0,.15-.04.2-.14.23-.38.38-.55.44-.49.88-.97,1.32-1.46.07-.08.19-.14.16-.28.11-.28.28-.49.55-.62.11.04.2-.02.28-.08.27-.2.55-.39.81-.6.15-.12.37-.18.44-.4h0c.53-.28,1.07-.56,1.6-.83Z"
      />
      <path
        className="cls-1"
        d="m31.23,40.68c0,.32,0,.63,0,.95-.35.08-.11.18-.01.28.02.04.04.08.06.11-.08.19-.1.41-.1.59,0,.31-.09.65.11.95,0,.05,0,.09,0,.14-.06,0-.14.04-.13.08.02.28-.08.62-.02.84.17.63.2,1.25.2,1.88,0,.12.02.22.12.3,0,.5.06.99.09,1.48.03.49.12,1,.01,1.53-.06.3.05.67.03,1.01-.05.81-.12,1.62-.14,2.44-.01.8-.06,1.6-.02,2.41.01.22-.01.46-.02.7-.09.11-.17.23-.03.36.08.39.08.78.05,1.17-.06.37-.09.74.04,1.1.04.64.13,1.27-.06,1.9,0,.09-.06.21.1.24,0,.09,0,.18,0,.26-.1.04-.15.08-.02.14l.03.9c-.1.75-.05,1.51-.03,2.27,0,.04,0,.09,0,.13-.12.08-.17.16,0,.23,0,.08-.01.16-.02.25-.12.04-.12.14-.1.23.14.61.01,1.23.07,1.84.01.11.05.25,0,.33-.2.36.02.67.09.99,0,.03,0,.07,0,.1-.02,0-.05-.04-.05.02.02,0,.04,0,.05-.01.04.07.03.15,0,.23-.23.26-.25.59-.05.85.07,1-.06,1.98-.27,2.95-.12.02-.15.11-.11.2.05.1.15.11.25.04.04,0,.08.02.12.03.07.09.14.12.23.01.07,0,.13.02.2.03.05.12.12.15.22.04l.14.07c.02.33.03.33.41.09.46.11.92.23,1.38.34.05.12.14.08.22.04.04,0,.08,0,.12,0,.31.11.63.22.96.1.24-.01.47,0,.69.13,0,.07.03.16-.07.2,0,0-.02,0-.02-.01,0,0,.02,0,.03.01,0,.08,0,.16-.01.26.18-.11.09-.44.38-.4.53.08,1.06-.04,1.59.02.3.03.64-.01.9.07.31.1.38,0,.46-.22.15-.04.3-.07.45-.11.1.04.18.06.23-.06.47-.05.95-.1,1.42-.15.07.04.13.04.17-.05.2-.01.39-.02.59-.03.07.06.13.06.17-.03.1-.01.21-.03.31-.04.06.06.12.07.17-.02,1.03-.07,2.07-.14,3.1-.2.04.26.27.25.38.16.21-.19.46-.13.69-.19.59,0,1.18,0,1.76.11,0,.05.01.09.07.1.05,0,.08-.03.08-.08.3-.03.6-.04.89.05.03.26-.11.37-.35.37-.09,0-.18-.04-.22.08-.24,0-.49,0-.73,0-.06-.11-.14-.1-.22-.02-.16,0-.32-.02-.48-.02-.26-.2-.35-.21-.42-.04-.22-.04-.41.1-.62.1-.32-.08-.64-.13-.96.01-.66.07-1.34.09-1.99.22-.39.08-.78.2-1.18.2-.06-.11-.16-.05-.24-.07-.4-.07-.79.32-1.19.02,0,0-.05.01-.06.03-.08.2-.32.15-.45.27-.22.07-.46.09-.69.09-.07-.06-.15-.06-.23-.05-.41.05-.82.08-1.22.18-.19.04-.43-.12-.56.13-.83.11-1.65-.09-2.47-.06-.3-.31-.68-.18-1.04-.19-.22.02-.41-.12-.62-.15-.24-.09-.48-.2-.76-.15-.36-.04-.7-.23-1.04-.28-.43-.06-.86-.21-1.3-.17,0-.08-.05-.14-.1-.17-.32-.17-.3-.43-.26-.75.08-.55.27-1.09.22-1.66,0-.08.02-.16-.08-.2,0-.06-.02-.12-.02-.17.03-.25.2-.46.18-.72-.01-.17-.18-.28-.14-.48.13-.58-.14-1.17.06-1.76.13-.4-.33-.8-.13-1.24.01-.03-.04-.1-.08-.14-.05-.07-.08-.15-.04-.23.17-.38,0-.81.15-1.19.07-.18-.04-.19-.17-.18-.07-.03-.05-.08-.04-.13.09,0,.18-.06.16-.14-.07-.47.12-.95-.07-1.4.01-.06.02-.13.03-.19.13-.13.11-.33-.06-.5-.03-.14,0-.27.05-.4.15-.15.05-.31.03-.47-.02-.11-.13-.23-.03-.32.17-.15.13-.32.12-.51,0-.22-.08-.42-.1-.63-.08-.89.12-1.78.05-2.67-.02-.23.24-.51-.09-.7,0-.05,0-.09,0-.14.26-.21-.05-.42,0-.63,0-.11,0-.22,0-.32.06-.06.1-.12.09-.21-.08-.7.09-1.39.16-2.08.04-.45-.09-.91.15-1.35.07-.12.05-.33,0-.47-.1-.3.05-.51.26-.63.17-.1.14-.19.03-.23-.32-.14-.31-.42-.26-.66.07-.3.04-.58-.03-.87.08-.25-.11-.49-.04-.74.11-.1.03-.13-.06-.15,0-.13.02-.27.03-.4.06,0,.12.02.13-.06,0-.08-.06-.08-.12-.08-.03-.21-.06-.41-.09-.62.25-.04.3-.2.18-.38-.08-.12-.08-.23-.08-.35,0-.34,0-.68-.01-1.02,0-.11.07-.26-.12-.31,0-.04,0-.07,0-.11.03-.26.09-.53,0-.79-.14-.5,0-1,.01-1.49,0-.23-.2-.41-.09-.65.24-.15.29-.38.19-.62-.08-.2-.13-.46,0-.58.19-.19.08-.27-.04-.38,0-.05,0-.09,0-.14.12-.06.12-.13,0-.21,0-.05-.02-.09-.03-.14q.23-.45.5-.21c.02.18.04.36.06.55-.18.09-.19.19,0,.29Zm.2,10.24s-.04-.03-.06-.02c-.01,0-.02.04-.03.05.02,0,.04.03.06.02.01,0,.02-.04.03-.05Z"
      />
      <path
        className="cls-1"
        d="m53.32,27.91c.23-.05.45-.03.67.02.03.2.19.13.29.13.38,0,.75.03,1.12.09.35.05.72.11,1.07-.03.2.08.42.05.63.07.46.27,1.01.04,1.48.27.23.11.5,0,.75.02.25,0,.49.07.74.09.1,0,.22.01.22-.14.06,0,.12,0,.18,0,.01.11.04.18.15.06.14.02.28.03.41.05.24.18.51.06.77.06.32-.09.59.11.89.15.4.05.81.08,1.21.11.81.07,1.62.06,2.43.09.07.09.16.08.24.02.07,0,.15.01.22.02-.09.43.27.15.39.25-.2.26-.49.29-.79.27-.06-.05-.1-.06-.14.02-.3.01-.59.02-.89.04-.09-.15-.18-.19-.28-.02-.64.19-1.29,0-1.93.03-.03-.08-.08-.09-.15-.06-.68.02-1.37.04-2.05-.01-.07-.09-.14-.09-.21,0-1.1-.03-2.2-.05-3.3-.16-.05,0-.1-.05-.15-.08-.18-.12-.37-.07-.55-.04-.2,0-.41-.01-.61-.02-.22-.28-.51-.21-.8-.15-.77-.05-1.53-.09-2.3-.14-.03-.1-.12-.08-.2-.1-.35-.07-.7,0-1.05,0-.53,0-1.05-.2-1.59-.06-.94-.07-1.88-.14-2.81-.22-.23-.16-.47-.15-.71-.03-.15.05-.27-.09-.41-.06-.17-.24-.35-.29-.56-.04-.34-.13-.71-.09-1.06-.15-.2-.03-.39-.11-.59-.14-.24-.19-.53-.02-.78-.12-.24.06-.49-.01-.73,0-.12-.08-.26-.17-.4-.15-.39.06-.78.16-1.16-.04-.15-.08-.25,0-.31.15-.07.01-.13.02-.2.04-.13-.1-.25-.15-.35.03-.6,0-1.19,0-1.79,0-.05-.09-.14-.06-.21-.06-.45-.03-.91.1-1.36-.1-.1-.04-.31,0-.29.22-.04.03-.08.05-.12.08-.08-.36-.32-.46-.59-.23-.09.08-.14.08-.23.03-.11-.06-.03-.14-.01-.2.02-.06.05-.13.07-.19.21.02.39-.15.6-.11.06.17.14.15.22.02.06,0,.12,0,.19,0,.13.03.22-.03.29-.12.04,0,.08.02.13.02,0,.08.06.12.13.11.07,0,.1-.05.1-.11.12-.08.27-.06.4-.07.24.2.49-.07.74.02-.02.08-.15.05-.15.15.34.25.42-.26.7-.23.28.03.57-.02.85-.04.04,0,.08,0,.12,0,.48,0,.97.13,1.45-.04.07-.03.16-.01.24-.01.5-.01,1-.01,1.5.06.57.08,1.15.13,1.72.17.44.03.88.2,1.33.07.08,0,.16,0,.24,0,.07.15.23.16.35.16.54,0,1.07,0,1.61-.01.18-.01.36-.03.53-.04.04.08.09.08.16.04.04,0,.07.01.11.02.08.05.15.05.23,0,.09,0,.18.01.26.02.19.15.4.11.62.08.24-.04.46.13.69.06.06.09.14.08.22.04.03,0,.07,0,.1,0,.67.17,1.35.05,2.03.07Z"
      />
      <path
        className="cls-1"
        d="m67.33,51.75c.1.1.08.24.07.36-.02.87.07,1.74,0,2.61-.2.22-.06.48-.06.72-.02.52-.01,1.05-.01,1.58.08.36-.02.72.01,1.09-.17.05-.1.18-.09.29.13.11,0,.21,0,.32,0,.91,0,1.81,0,2.72,0,.2-.06.41.05.6v.48c-.25.5-.15,1.04-.18,1.56-.02.47.07.94.04,1.41-.03.52-.02,1.04.05,1.56,0,.16,0,.32,0,.49-.12.06-.09.11,0,.15.03.97,0,1.93-.02,2.9,0,.47.08.94.02,1.42-.28.18-.5.39-.41.79-.04-.1-.04-.19-.04-.28,0-.59-.13-1.18-.04-1.79.07-.43-.05-.89-.2-1.32.01-.02.01-.03,0-.05,0-.03,0-.06,0-.09-.13-.22-.02-.45-.02-.67.09-.41.14-.82-.15-1.19-.01-.29-.02-.59-.03-.88.2-.34.18-.68.09-1.07-.13-.59-.1-1.2-.09-1.8,0-.55.03-1.09-.04-1.64,0-.03,0-.05.01-.08.01-.24.13-.48,0-.73-.05-.09.01-.24.05-.36.07-.24.32-.48-.02-.7.04-.67-.13-1.34-.02-2.01.05-.32.03-.64.04-.95,0-.45-.08-.9-.13-1.34-.02-.17-.03-.35.21-.4.08-.01.13-.07.09-.15-.17-.34-.11-.71-.1-1.05,0-.38,0-.78.09-1.16.02-.09.08-.24-.12-.26,0-.02,0-.04-.01-.06.05-.24-.06-.5.13-.72.03-.04.03-.16,0-.2-.17-.18-.09-.39-.1-.59-.01-.52.16-1.05.12-1.56-.09-1.05.36-2.06.18-3.13-.06-.38.04-.8-.04-1.21.07-.36-.09-.72,0-1.09.05-.23.04-.47,0-.71.11-.29-.04-.59.01-.89.06-.01.12-.04.12-.1,0-.4.09-.81-.04-1.21,0-.06.01-.13.02-.19.11-.07.13-.14.02-.22,0-.16,0-.32.01-.48.2-.09.15-.22.04-.35,0-.44.02-.89.03-1.33,0-.48.03-.96-.05-1.45-.02-.11.07-.25.17-.37.24.71.3,1.45.34,2.19-.04.22-.09.44-.12.67-.01.09-.05.21.1.25,0,.08,0,.16,0,.24-.16.05-.1.19-.1.29,0,.38.01.76.03,1.15,0,.17-.14.35.04.51.04.32.02.65,0,.97-.05,0-.09.03-.08.08,0,.05.06.06.1.06.08.21-.07.41,0,.62-.15.11-.18.23,0,.35.06,1.01-.04,2.02.05,3.03-.08.16-.09.32,0,.48,0,.34,0,.68,0,1.03-.04,0-.09,0-.08.06,0,.01.05.02.08.03,0,.07,0,.13,0,.2-.07.06-.05.1.02.14,0,.07-.01.14-.02.21-.02.57-.27,1.14-.05,1.72,0,.02,0,.05,0,.07-.01.16-.05.32.03.47Zm-.83,12.66s-.03,0-.04-.01c0,0,0,.02,0,.02,0,0,.02,0,.04,0Z"
      />
      <path
        className="cls-2"
        d="m38.41,35.37c.18-.02.36-.05.55-.02.04.14-.08.4.23.34.37-.07.74-.06,1.11.01.25.05.32-.06.23-.29,1.04-.19,2.09-.16,3.14-.19.81-.02,1.62-.03,2.43-.12.43-.05.87-.01,1.3-.03,1.49-.08,2.98-.07,4.47-.14,1.4-.07,2.8-.06,4.19-.01,1.2.04,2.39.21,3.59.33.1,0,.2.05.34.08-1.31-.03-2.55-.11-3.8-.17-1.18-.06-2.36.04-3.54.09-.96.04-1.92.1-2.88.16-1.51.1-3.01.21-4.52.27-1.25.05-2.5.05-3.75.08-.78.02-1.55.04-2.33.06-.18,0-.37.01-.54-.06.09-.11.25-.23-.05-.27-.08,0-.16-.02-.16-.12Z"
      />
      <path
        className="cls-1"
        d="m62.54,34.47c-.1.07-.21.13-.34.14-.29-.11-.61-.04-.9-.13-.45-.22-.84-.5-1-1.01-.18-.61-.1-1.18.27-1.7.02-.03.02-.09.03-.13h0c.14-.02.29-.05.43-.06.29-.01.5.13.61.4-.57.02-.75.16-.76.56,0,.14,0,.27,0,.41-.03.2.02.37.2.48.2.35.48.54.92.56.49.02.83-.14,1.05-.56.11-.21.45-.18.44-.48.19-.14.21-.27.07-.42-.01-.05-.02-.09-.04-.14.4-.22-.04-.5.03-.75.29.06.23.39.42.5.07.21.03.43.02.65-.15.02-.12.13-.1.22,0,.07,0,.16-.07.21-.35-.06-.28.23-.34.41-.09.12-.18.23-.27.35-.13,0-.22.05-.2.21-.05.08-.12.12-.21.14-.16-.09-.22.03-.28.13Z"
      />
      <path
        className="cls-2"
        d="m34.2,30.72c.34-.04.68,0,1.01-.02.38-.02.76,0,1.14-.11,1.34-.39,2.73-.31,4.11-.35.54-.02,1.09-.07,1.63-.04.13,0,.28-.04.42.1-.18.07-.35.18-.5.17-.62-.03-1.24.05-1.84.16-1.2.21-2.42.04-3.61.33-.59.14-1.23.23-1.86.09.11-.17.36.03.48-.19-.17-.09-.34-.03-.5-.05-.16-.02-.34.09-.47-.09Z"
      />
      <path
        className="cls-2"
        d="m66.52,69.39c.15.43.27.88.2,1.32-.09.61.04,1.19.04,1.79,0,.09,0,.18.04.28-.1-.39.13-.61.41-.79.1.43.06.87,0,1.29-.07.58-.05,1.16-.11,1.73-.02.17.03.44-.16.46-.19.02-.16-.27-.19-.42-.1-.56-.12-1.13-.16-1.7-.06-.8-.01-1.61-.15-2.41-.08-.47,0-.96,0-1.45,0-.04.04-.07.07-.11Z"
      />
      <path
        className="cls-2"
        d="m48.19,41.53c.04-.18.23-.05.34-.18-.21-.05-.4-.14-.6-.08-.54.16-1.09.23-1.65.3.02-.17.17-.18.28-.19.84-.12,1.66-.41,2.53-.29.1.01.21-.05.25.1.02.08.07.06.13.02.28-.22.57-.17.85,0,.13.08.31.02.42.14-.03.3.17.33.39.3.23-.03.02-.17.04-.25.64.11,1.25.26,1.79.66.22.16.47.31.71.45.11.06.17.13.12.23-.08.16-.18.01-.24-.03-.27-.18-.55-.41-.82-.53-.47-.21-.99-.4-1.53-.4-.43,0-.85-.1-1.26-.19-.46-.1-.93,0-1.4-.02-.11,0-.23.04-.33-.03Z"
      />
      <path
        className="cls-2"
        d="m33.68,28.5c-.18.22-.45.28-.7.32-.52.09-1.04.19-1.57.21-.2,0-.38.17-.6.07-.08-.03-.17.04-.15.2.04.27.03.55.04.83-.13.04-.23.1-.16.26.06.15-.04.22-.13.3-.23-.12-.11-.35-.15-.52-.06-.3-.07-.65.02-.93.1-.29.23-.6.67-.65.59-.07,1.13-.39,1.75-.39.04.15-.1.37.14.43.21.05.42,0,.55-.21.17-.28.22-.07.29.07Z"
      />
      <path
        className="cls-2"
        d="m66.39,52.8c.19.01.14.16.12.26-.09.38-.09.78-.09,1.16,0,.34-.07.72.1,1.05.04.08-.01.13-.09.15-.24.04-.22.23-.21.4.04.45.13.9.13,1.34,0,.31.02.63-.04.95-.11.67.06,1.34.02,2.01.34.23.09.46.02.7-.04.12-.1.27-.05.36.13.25.02.49,0,.73-.13-.1-.16-.25-.16-.39,0-1.15,0-2.31,0-3.46,0-.78,0-1.55-.02-2.33-.02-.7.05-1.41.1-2.11.02-.28-.05-.58.16-.82Z"
      />
      <path
        className="cls-2"
        d="m49.22,73.76c.04-.12.13-.08.22-.08.24,0,.38-.11.35-.37.57.03,1.14.07,1.71.19.62.13,1.27.11,1.89.22.67.12,1.36,0,2.04.18-.09.16-.28.22-.4.14-.18-.11-.35-.06-.53-.05-.73.05-1.46-.09-2.2-.07-.23,0-.46.02-.69,0-.58-.05-1.15-.15-1.73-.18-.22-.01-.44.11-.67,0Z"
      />
      <path
        className="cls-2"
        d="m64,32.15c-.2-.11-.14-.44-.42-.5-.07.25.37.53-.03.75-.02-.04-.05-.08-.05-.11-.05-.72-.62-1.25-1.36-.8-.09.05-.26.06-.23.19.02.11.17.09.27.09.08,0,.17-.01.17.11,0,.11-.08.12-.17.12-.17,0-.34-.01-.51-.02-.11-.27-.31-.41-.61-.4-.14,0-.29.04-.43.06.14-.28.41-.2.64-.2.22,0,.37-.03.51-.24.27-.39,1.13-.6,1.66-.15.33.28.61.62.58,1.1Z"
      />
      <path
        className="cls-1"
        d="m67.54,31.19c0,.07,0,.15,0,.22-.11.49-.09.99.03,1.48,0,.25-.07.48-.12.72-.02.1-.06.19-.17.17-.08-.01-.09-.11-.13-.18-.21-.43-.15-.88-.18-1.33.13-.05.09-.17.1-.26.03-.32.01-.67.12-.97.08-.23.02-.3-.16-.36,0-.25,0-.49.01-.74.21-.07.33.08.47.2.02.3.03.6.05.9-.06.05-.06.1-.02.16Z"
      />
      <path
        className="cls-2"
        d="m30.82,49.26c.06.29.1.57.03.87-.05.24-.06.52.26.66.11.05.14.13-.03.23-.22.12-.36.32-.26.63.05.14.06.35,0,.47-.24.44-.1.9-.15,1.35-.06.69-.23,1.38-.16,2.08,0,.09-.04.15-.09.21-.19-.16-.12-.39-.11-.57.02-.47,0-.95.07-1.41.09-.61.1-1.22.18-1.83.11-.79.24-1.59.1-2.4-.02-.13-.05-.29.17-.3Z"
      />
      <path
        className="cls-2"
        d="m30.34,64.92c.13,0,.24,0,.17.18-.15.38.02.81-.15,1.19-.03.07,0,.16.04.23.03.04.09.11.08.14-.2.45.26.84.13,1.24-.2.59.07,1.18-.06,1.76-.04.2.13.31.14.48.02.26-.15.47-.18.72-.24-.12-.15-.37-.15-.54.01-.9-.02-1.8-.09-2.7-.02-.33-.03-.66-.06-.99-.04-.45.1-.9.01-1.35-.03-.15.14-.24.12-.38Z"
      />
      <path
        className="cls-2"
        d="m39.53,46.97c.09.15.04.28-.07.4-.18.19-.33.35-.27.68.02.12-.19.41-.31.61-.09.17-.17.31.16.47-.45.04-.55.25-.64.56-.26.9-.51,1.79-.51,2.73,0,.08,0,.17-.1.19-.13-.15-.05-.33-.05-.5-.01-1.18.35-2.29.8-3.35.12-.29.18-.58.3-.86.16-.36.43-.65.7-.94Z"
      />
      <path
        className="cls-2"
        d="m66.67,45.35c.08.4-.03.83.04,1.21.18,1.07-.26,2.07-.18,3.13.04.51-.13,1.03-.12,1.56,0,.2-.07.41.1.59.03.04.04.16,0,.2-.19.22-.08.48-.13.72-.17-.06-.15-.23-.14-.35.06-.83.04-1.67.09-2.5.06-1.12.25-2.24.2-3.37-.01-.31.05-.61,0-.92-.01-.09-.06-.25.14-.25Z"
      />
      <path
        className="cls-2"
        d="m46.16,27.48c-.45.13-.89-.03-1.33-.07-.58-.05-1.15-.09-1.72-.17-.5-.07-1-.07-1.5-.06-.08,0-.17-.01-.24.01-.48.17-.97.03-1.45.04.03-.17.15-.13.27-.13.45-.02.92-.08,1.36-.08.74,0,1.5-.09,2.24.11.11.03.2,0,.29,0,.66-.08,1.28.23,1.93.25.07,0,.13.03.15.11Z"
      />
      <path
        className="cls-2"
        d="m30.41,56.86c.32.19.07.47.09.7.07.89-.14,1.78-.05,2.67.02.21.09.41.1.63,0,.19.05.36-.12.51-.1.09,0,.22.03.32.03.16.13.32-.03.47-.11,0-.24-.03-.19-.17.1-.29,0-.57.03-.86.07-.52,0-1.05.02-1.57.02-.44-.12-.87-.05-1.3.07-.47-.03-.96.16-1.41Z"
      />
      <path
        className="cls-2"
        d="m35.59,27.59c-.02.06-.05.13-.07.19-.02.07-.1.14.01.2.09.05.13.05.23-.03.27-.23.51-.12.59.23-.79.19-1.61.17-2.4.34-.05.01-.11,0-.17,0,.17-.3.49-.28.73-.26.38.03.57-.11.73-.46-.18.03-.37,0-.44.09-.32.37-.63.11-.94.02.37-.21.81-.13,1.2-.26.15-.05.34-.13.53-.07Z"
      />
      <path
        className="cls-2"
        d="m31.18,39.84q-.27-.24-.5.21c-.05-.43-.19-.85-.05-1.28.04-.11.04-.22,0-.33-.15-.35.02-.74-.11-1.1-.01-.04.05-.13.1-.16.05-.03.1.03.14.07.11.11.27.2.19.4-.26,0-.21.2-.21.36,0,.36.1.71.03,1.08-.02.09-.04.25.13.26.17.01.2-.09.23-.23.05-.25-.14-.49,0-.73.18.23.09.5.11.75.02.24.01.47-.04.7Z"
      />
      <path
        className="cls-2"
        d="m61.64,48.39c.37.3.44.77.57,1.17.2.67.31,1.36.35,2.07.03.55.04,1.1-.02,1.65-.16-.04-.13-.17-.13-.28.02-.73.03-1.47-.1-2.19-.14-.74-.26-1.49-.61-2.18-.04-.08-.09-.16-.06-.25Z"
      />
      <path
        className="cls-1"
        d="m33.87,27.92c.31.09.62.34.94-.02.07-.08.27-.06.44-.09-.16.35-.35.5-.73.46-.24-.02-.57-.04-.73.26-.04,0-.07-.02-.11-.02-.07-.14-.12-.34-.29-.07-.13.21-.34.26-.55.21-.24-.06-.1-.28-.14-.43.18-.03.36-.06.55-.09.17.15.19,0,.22-.11.13-.03.27-.06.4-.09Z"
      />
      <path
        className="cls-2"
        d="m55.85,41.09c-.46-.07-.91-.14-1.37-.21-.2-.03-.36-.03-.39.23-.03.24.08.35.29.41.18.05.39.08.45.31-.2-.06-.4-.05-.6-.06-.46-.03-.74-.56-.53-.95.07-.13.14-.15.27-.14.45.05.9.11,1.35.14.19.01.49-.09.53.26Z"
      />
      <path
        className="cls-2"
        d="m44.42,65.25c-.26.04-.43-.15-.6-.27-.31-.23-.61-.46-.89-.73-.37-.36-.73-.73-1.08-1.11-.17-.18-.24-.35-.19-.58.08.02.15.05.18.14.12.31.33.56.56.79.59.58,1.18,1.14,1.88,1.58.08.05.1.11.14.18Z"
      />
      <path
        className="cls-1"
        d="m54.13,43.56c-.07.01-.09.05-.06.12-.82-.2-1.64-.22-2.48-.2-.09-.19-.06-.29.19-.27.1,0,.29.13.3-.12.69-.02,1.33.19,1.99.37.03,0,.05.07.07.1Z"
      />
      <path
        className="cls-2"
        d="m66.29,61.99c.07.54.04,1.09.04,1.64,0,.6-.03,1.22.09,1.8.09.39.11.73-.09,1.07-.05,0-.11,0-.11-.05-.02-1.32-.04-2.65-.04-3.97,0-.16-.11-.37.12-.49Z"
      />
      <path
        className="cls-2"
        d="m67.2,67.05c-.07-.52-.08-1.04-.05-1.56.03-.48-.07-.94-.04-1.41.03-.52-.08-1.06.17-1.56,0,.48,0,.96,0,1.45,0,.89,0,1.78-.01,2.67,0,.14.05.3-.08.42Z"
      />
      <path
        className="cls-2"
        d="m41.64,44.51c.04.14-.08.2-.16.28-.44.49-.88.98-1.32,1.46-.15.17-.19.41-.38.55-.05.04-.09.07-.15.04-.05-.07-.02-.13.02-.18.05-.06.13-.11.16-.18.31-.79,1.01-1.26,1.55-1.87.09-.1.16-.15.28-.1Z"
      />
      <path
        className="cls-2"
        d="m59.03,42.74c-.44.12-.7-.25-1-.43-.4-.24-.74-.6-1.2-.78-.03-.01-.05-.07-.08-.11.39-.15.66.13.91.32.24.18.54.23.75.45.19.2.51.25.62.54Z"
      />
      <path
        className="cls-2"
        d="m30.54,71.04c.11.03.08.12.08.2.05.57-.14,1.11-.22,1.66-.05.32-.06.58.26.75.06.03.11.09.1.17-.25.09-.45-.01-.54-.3-.05-.17-.04-.36-.04-.55,0-.58.24-1.12.23-1.69,0-.08.04-.18.12-.23Z"
      />
      <path
        className="cls-2"
        d="m30.59,33.23c-.15-.51-.26-1.03-.18-1.57.19,0,.1-.37.36-.29.1.21.05.42.03.63-.11.05-.31.01-.26.23.03.13,0,.33.24.29.16.32.19.65.13,1-.16-.05-.17-.24-.33-.3Z"
      />
      <path
        className="cls-2"
        d="m31.46,46.8c-.1-.07-.12-.17-.12-.3,0-.63-.03-1.26-.2-1.88-.06-.22.03-.55.02-.84,0-.04.07-.08.13-.08.08,1.03.3,2.05.17,3.1Z"
      />
      <path
        className="cls-2"
        d="m60.28,28.43c0,.16-.12.15-.22.14-.25-.02-.49-.08-.74-.09-.25,0-.52.1-.75-.02-.47-.23-1.02,0-1.48-.27,1.07-.08,2.12.14,3.18.24Z"
      />
      <path
        className="cls-2"
        d="m52.83,66.32c-.21.28-.56.23-.82.24-.8.03-1.59.14-2.39.08-.11,0-.23.04-.31-.09.39-.12.78,0,1.18-.04.74-.09,1.49-.04,2.23-.22.05-.01.09-.01.12.03Z"
      />
      <path
        className="cls-2"
        d="m39.32,73.88c-.08.23-.15.33-.46.22-.26-.09-.6-.04-.9-.07-.53-.06-1.06.06-1.59-.02-.29-.04-.2.29-.38.4,0-.1,0-.18.01-.26h0c.1-.04.06-.12.07-.2.56-.13,1.14-.02,1.7-.07.51-.04,1.03.09,1.54,0Z"
      />
      <path
        className="cls-1"
        d="m36.49,35.44c.15-.06.28.03.42.06-.02.12-.04.23-.07.35-.08,0-.15,0-.23,0,0-.04,0-.09-.05-.1-.07-.01-.08.04-.09.09-.48-.02-.95.06-1.43,0-.04-.12.05-.2.07-.3.04-.02.08-.03.12-.05.1.16.17.13.22-.04.21-.06.41.07.61.07,0,.05.02.09.07.09.06,0,.06-.04.07-.09.03,0,.07,0,.1,0,.1.07.16.04.17-.08Z"
      />
      <path
        className="cls-2"
        d="m33.74,31.08c-.65-.14-1.33.02-1.98-.17.74-.24,1.51-.14,2.27-.17-.01.11-.09.15-.19.14-.19-.01-.11.11-.1.2Z"
      />
      <path
        className="cls-1"
        d="m40.53,35.41c.09.23.02.34-.23.29-.37-.07-.74-.08-1.11-.01-.31.06-.19-.2-.23-.34.53-.03,1.05-.09,1.57.06Z"
      />
      <path
        className="cls-1"
        d="m31.11,38.4c-.13.24.06.48,0,.73-.03.14-.06.24-.23.23-.18-.01-.15-.17-.13-.26.07-.36-.03-.72-.03-1.08,0-.16-.05-.36.21-.36.11.24.15.49.17.74Z"
      />
      <path
        className="cls-2"
        d="m31.56,68.7c-.07-.32-.29-.63-.09-.99.05-.09.01-.22,0-.33-.06-.61.07-1.23-.07-1.84-.02-.08-.03-.19.1-.23.08.2.09.42.09.63,0,.8.02,1.6.02,2.4,0,.12.04.25-.05.36Z"
      />
      <path
        className="cls-2"
        d="m56.48,28.13c-.35.14-.72.08-1.07.03-.37-.06-.74-.1-1.12-.09-.11,0-.27.07-.29-.13.53-.03,1.05-.15,1.58.05.19.07.43,0,.65,0,.1,0,.25-.06.26.13Z"
      />
      <path
        className="cls-2"
        d="m54.48,66.7c.07-.28.36-.24.54-.33.5-.26,1.04-.44,1.6-.56-.19.29-.53.33-.81.44-.43.18-.83.45-1.33.45Z"
      />
      <path
        className="cls-2"
        d="m42.48,44.39c.17-.27.27-.55.66-.65.2-.05.45-.25.64-.44.17-.18.42-.22.6-.4.06-.06.18-.02.27,0-.42.34-.91.59-1.33.92-.17.14-.35.28-.54.41-.09.06-.16.16-.29.15Z"
      />
      <path
        className="cls-2"
        d="m67.29,62.02c-.11-.19-.05-.4-.05-.6,0-.91,0-1.81,0-2.72.13,0,.13.1.13.2,0,1-.02,2-.03,3.01,0,.04-.04.08-.05.12Z"
      />
      <path
        className="cls-2"
        d="m61.72,57.48c.06.23-.02.48.1.69.02.03.03.06,0,.09-.34.32-.36.8-.54,1.19-.03.06-.06.1-.13.08.11-.4.21-.81.33-1.21.06-.19.13-.39.08-.56-.05-.19.06-.21.16-.27Z"
      />
      <path
        className="cls-2"
        d="m48.36,27.63c-.54,0-1.07.02-1.61.01-.12,0-.28-.01-.35-.16.37-.06.75-.14,1.13-.08.2.03.4.08.6.06.12,0,.19.05.22.16Z"
      />
      <path
        className="cls-2"
        d="m39.8,27.23c-.28.02-.57.07-.85.04-.29-.03-.37.48-.7.23,0-.1.13-.07.15-.15-.24-.09-.5.18-.74-.02.14-.17.37-.2.52-.17.4.08.76-.08,1.14-.09.17,0,.37-.04.48.16Z"
      />
      <path
        className="cls-2"
        d="m37.74,54.03c.04.29.2.57.09.88-.02.06-.04.17,0,.2.37.36.04.84.21,1.23,0,0-.03.03-.05.04-.14-.06-.17-.19-.16-.31.03-.59-.26-1.15-.18-1.74.01-.1-.07-.23.09-.29Z"
      />
      <path
        className="cls-1"
        d="m30.77,31.37c-.27-.08-.17.29-.36.29-.05-.32-.1-.65,0-.97.09-.08.19-.15.13-.3-.07-.16.04-.22.16-.26-.06.42.11.82.07,1.24Z"
      />
      <path
        className="cls-2"
        d="m50.21,28.78c.53-.15,1.06.06,1.59.06.35,0,.7-.08,1.05,0,.08.02.16,0,.2.1-.85.06-1.71-.02-2.56-.05-.1,0-.24.08-.27-.11Z"
      />
      <path
        className="cls-1"
        d="m38.41,35.37c0,.11.08.12.16.12.3.03.14.16.05.27-.2.03-.4.13-.61.07-.02-.04-.03-.1-.05-.1-.06-.02-.1.02-.11.09-.18,0-.35.02-.53.03,0-.17.01-.26.25-.23.22.02.48,0,.66-.22.06,0,.13-.01.19-.02Z"
      />
      <path
        className="cls-2"
        d="m43.73,42.81c-.07.22-.29.27-.44.4-.26.21-.54.4-.81.6-.08.06-.17.12-.28.08.43-.47.91-.88,1.53-1.08Z"
      />
      <path
        className="cls-1"
        d="m30.59,33.23c.15.05.17.25.33.3.05.35.07.71.02,1.07-.15-.03-.09-.29-.29-.27-.03-.36-.08-.73-.06-1.09Z"
      />
      <path
        className="cls-2"
        d="m38,74.82c.14-.25.38-.08.56-.13.4-.09.81-.12,1.22-.18.08-.01.16-.01.23.05-.51.15-1.03.24-1.56.26-.15,0-.3,0-.45,0Z"
      />
      <path
        className="cls-2"
        d="m30.64,45.15c.19.04.12.2.12.31.01.34,0,.68.01,1.02,0,.12,0,.23.08.35.12.18.07.35-.18.38-.05-.68-.14-1.37-.03-2.06Z"
      />
      <path
        className="cls-2"
        d="m35.12,35.53c-.02.1-.12.19-.07.3-.39.04-.79.06-1.18.03.04-.09.13-.07.21-.08.2-.01.1-.12.07-.21.32-.19.65-.09.98-.04Z"
      />
      <path
        className="cls-2"
        d="m57.37,65.28s0-.03,0-.03c.4-.33.85-.61,1.2-.99.04-.05.13-.04.17.04-.37.46-.78.86-1.38.99Z"
      />
      <path
        className="cls-2"
        d="m36.48,28.11c-.02-.23.2-.26.29-.22.45.2.91.07,1.36.1.08,0,.16-.02.21.06-.03.02-.05.05-.08.05-.42.03-.84-.01-1.26.08-.18.04-.36-.03-.53-.08Z"
      />
      <path
        className="cls-2"
        d="m38.22,35.39c-.17.21-.43.24-.66.22-.23-.02-.25.07-.25.23-.16.05-.32.01-.47,0,.02-.12.04-.23.07-.35.43-.13.87-.13,1.31-.1Z"
      />
      <path
        className="cls-2"
        d="m60.61,31.64s0,.1-.03.13c-.37.52-.46,1.09-.27,1.7-.44-.56-.34-1.52.31-1.83Z"
      />
      <path
        className="cls-2"
        d="m40.69,74.48c.13-.12.37-.07.45-.27,0-.01.05-.03.06-.03.4.3.79-.09,1.19-.02.08.01.19-.04.24.07-.64.12-1.28.25-1.93.24Z"
      />
      <path
        className="cls-2"
        d="m30.4,63.24c.19.46,0,.94.07,1.4.01.08-.07.13-.16.14-.14-.16-.03-.35-.03-.52,0-.25-.02-.5-.04-.75-.01-.12-.02-.26.16-.28Z"
      />
      <path
        className="cls-2"
        d="m40.68,27.98c.05-.15.15-.23.31-.15.38.2.77.1,1.16.04.15-.02.28.07.4.15-.62.04-1.25.14-1.87-.05Z"
      />
      <path
        className="cls-2"
        d="m31.49,64.7c-.02-.76-.07-1.51.03-2.27.15.17.05.38.05.56.02.48.01.96,0,1.44,0,.1.04.21-.09.27Z"
      />
      <path
        className="cls-1"
        d="m33.74,31.08c0-.09-.1-.21.1-.2.1,0,.18-.03.19-.14.06,0,.11-.01.17-.02.13.18.31.07.47.09.16.02.33-.04.5.05-.12.22-.37.02-.48.19-.07-.01-.13-.02-.2-.03-.02-.02-.04-.04-.05-.05,0,.02-.02.03-.03.05-.22.06-.44.1-.68.08Z"
      />
      <path
        className="cls-2"
        d="m67.32,57.01c0-.53,0-1.05.01-1.58,0-.24-.13-.49.06-.72.07.64.03,1.29.02,1.94,0,.12,0,.25-.1.35Z"
      />
      <path
        className="cls-2"
        d="m67.3,51.21c-.21-.58.03-1.15.05-1.72.08.58.15,1.15-.05,1.72Z"
      />
      <path
        className="cls-2"
        d="m53.32,27.91c-.68-.02-1.36.1-2.03-.07.01-.12.09-.09.17-.09.47.03.93.08,1.4.01.17-.02.34,0,.45.15Z"
      />
      <path
        className="cls-2"
        d="m44.89,66.52c.1-.09.22-.06.32,0,.36.19.75.3,1.14.42.1.03.09.12.13.18-.54-.16-1.08-.35-1.59-.6Z"
      />
      <path
        className="cls-2"
        d="m67.03,30.68c.18.06.24.12.16.36-.1.3-.08.64-.12.97-.01.1.03.21-.1.26-.01-.08-.04-.15-.04-.23.03-.45.06-.91.09-1.36Z"
      />
      <path
        className="cls-2"
        d="m67.28,42.25c-.17-.16-.03-.34-.04-.51-.02-.38-.03-.76-.03-1.15,0-.1-.05-.24.1-.29,0,.65.1,1.3-.04,1.95Z"
      />
      <path
        className="cls-2"
        d="m30.7,40.53c.12.11.23.19.04.38-.12.12-.07.38,0,.58.1.24.04.47-.19.62,0-.49-.02-.98.05-1.46,0-.06.03-.11.1-.12Z"
      />
      <path
        className="cls-2"
        d="m45.33,41.97l-1.6.83c.09-.2.28-.3.45-.39.37-.19.72-.42,1.15-.45Z"
      />
      <path
        className="cls-2"
        d="m31.29,43.56c-.2-.29-.12-.64-.11-.95,0-.18.02-.4.1-.59.11.51.01,1.03.01,1.54Z"
      />
      <path
        className="cls-2"
        d="m67.58,32.89c-.12-.49-.14-.98-.03-1.48.11.49.12.98.03,1.48Z"
      />
      <path
        className="cls-2"
        d="m33.42,35.79c-.3.22-.63.05-.95.05-.05,0-.11-.05-.09-.11.02-.06.08-.09.14-.08.32.03.63-.03.94-.05-.01.07-.03.13-.04.2Z"
      />
      <path
        className="cls-2"
        d="m46.99,73.15c-.23.06-.47,0-.69.19-.1.09-.34.11-.38-.16.35-.14.7-.27,1.06-.04Z"
      />
      <path
        className="cls-2"
        d="m66.77,41.36c.12.4.03.81.04,1.21,0,.06-.07.09-.12.1-.08-.34.14-.71-.08-1.05-.03-.05.04-.22.17-.26Z"
      />
      <path
        className="cls-2"
        d="m38.06,56.73s.09,0,.09.03c.13.39.19.79.19,1.21-.28-.24-.18-.59-.27-.89-.03-.1,0-.22-.01-.34Z"
      />
      <path
        className="cls-2"
        d="m66.36,67.38c.29.37.23.78.15,1.19-.1.02-.13-.05-.13-.11.02-.36-.08-.72-.02-1.08Z"
      />
      <path
        className="cls-2"
        d="m67.51,30.13c-.14-.11-.26-.27-.47-.2-.1-.16-.09-.34.07-.41.19-.09.24.12.31.24.06.11.12.24.09.38Z"
      />
      <path
        className="cls-2"
        d="m62.34,54.65c-.04.39-.08.78-.13,1.17,0,.07-.07.08-.13.08-.08-.34.13-.67.08-1.01-.01-.09.03-.23.18-.24Z"
      />
      <path
        className="cls-2"
        d="m34.49,74.57c.36.01.74-.12,1.04.19-.36,0-.72.02-1.04-.19Z"
      />
      <path
        className="cls-1"
        d="m33.42,35.79l.04-.2.68-.02c.03.09.13.19-.07.21-.08,0-.17-.02-.21.08-.15-.04-.31.04-.45-.07Z"
      />
      <path
        className="cls-2"
        d="m59.85,61.94c-.14.35-.25.72-.69.82.25-.26.35-.64.69-.82Z"
      />
      <path
        className="cls-2"
        d="m63.23,51.83c-.13-.36-.08-.73-.06-1.1.13.36.19.73.06,1.1Z"
      />
      <path
        className="cls-2"
        d="m55.17,41.91c.4.04.73.22,1.03.48-.38-.08-.71-.27-1.03-.48Z"
      />
      <path
        className="cls-2"
        d="m31.47,58.99c-.14-.36-.1-.73-.04-1.1.16.36.07.73.04,1.1Z"
      />
      <path
        className="cls-2"
        d="m41.45,62.27c-.05.05-.12.1-.17,0-.12-.25-.39-.43-.38-.75.27.18.34.51.54.74Z"
      />
      <path
        className="cls-2"
        d="m62.61,48.18c-.27-.29-.33-.68-.49-1.02-.02-.05.03-.08.08-.08.13.37.4.68.41,1.1Z"
      />
      <path
        className="cls-1"
        d="m30.78,32.52c-.24.04-.21-.16-.24-.29-.05-.22.15-.17.26-.23,0,.17-.02.35-.02.52Z"
      />
      <path
        className="cls-2"
        d="m35.38,73.82c-.34.11-.65,0-.96-.1.34-.15.65,0,.96.1Z"
      />
      <path
        className="cls-2"
        d="m62.47,53.47c.02.36,0,.71-.12,1.04-.14-.37-.07-.71.12-1.04Z"
      />
      <path
        className="cls-2"
        d="m45.79,73.8c.32-.14.64-.09.96-.01-.32.15-.64.11-.96.01Z"
      />
      <path
        className="cls-2"
        d="m38.49,54.51s-.08-.04-.12-.06c.13-.22-.08-.49.1-.71.1.25.17.51.02.76Z"
      />
      <path
        className="cls-2"
        d="m50.27,67.44c.32-.1.65-.09.97,0-.32.16-.65.11-.97,0Z"
      />
      <path
        className="cls-2"
        d="m55.34,29.07c.29-.06.58-.13.8.15-.28,0-.56.04-.8-.15Z"
      />
      <path
        className="cls-2"
        d="m56.42,65c-.2.24-.47.35-.77.4.24-.17.44-.4.77-.4Z"
      />
      <path
        className="cls-2"
        d="m45.77,66.02c-.14.09-.29.16-.48.1.06-.15.23,0,.28-.14-.02-.15-.23-.13-.26-.28.25-.04.38.11.46.32Z"
      />
      <path
        className="cls-2"
        d="m67.32,40.07c-.14-.04-.11-.16-.1-.25.03-.22.08-.44.12-.67.11.31.02.61-.02.91Z"
      />
      <path
        className="cls-2"
        d="m31.51,69.88c-.2-.26-.18-.58.05-.85.08.29-.06.56-.05.85Z"
      />
      <path
        className="cls-2"
        d="m30.64,34.32c.2-.02.14.23.29.27.03.13.12.31-.11.33-.18.02-.12-.16-.14-.27-.02-.11-.03-.22-.05-.32Z"
      />
      <path
        className="cls-2"
        d="m43.29,28.02c.25.1.55-.07.78.12-.27.02-.57.23-.78-.12Z"
      />
      <path
        className="cls-2"
        d="m61.3,34.48c.29.09.61.02.9.13-.33.16-.63.1-.9-.13Z"
      />
      <path
        className="cls-2"
        d="m59.23,63.87c-.02-.24.21-.46.48-.48-.16.16-.23.41-.48.48Z"
      />
      <path
        className="cls-1"
        d="m51.15,41.4c-.03.08.19.22-.04.25-.22.03-.41,0-.39-.3.05-.07.11-.05.17-.03.01.1.04.15.13.06.04.01.08.02.12.03Z"
      />
      <path
        className="cls-2"
        d="m33.11,74.26c.27-.05.51.06.76.15-.31.22-.5-.1-.76-.15Z"
      />
      <path
        className="cls-2"
        d="m41.72,45.06c.11-.22.32-.35.52-.49-.07.27-.24.44-.52.49Z"
      />
      <path
        className="cls-2"
        d="m61.8,28.6c-.26,0-.53.12-.77-.06.27-.08.53-.19.77.06Z"
      />
      <path
        className="cls-2"
        d="m67.19,29.24c-.12-.1-.48.18-.39-.25.15.02.29.13.46.1.05-.01.12.02.1.1-.03.08-.09.09-.16.05Z"
      />
      <path
        className="cls-2"
        d="m50.27,27.74c-.21.03-.43.07-.62-.08.32-.13.49-.1.62.08Z"
      />
      <path
        className="cls-2"
        d="m47.59,66.42c-.24.03-.47.05-.63-.2.21.07.48-.08.63.2Z"
      />
      <path
        className="cls-2"
        d="m46.69,28.53c.24-.11.48-.13.71.03-.24.05-.48.13-.71-.03Z"
      />
      <path
        className="cls-2"
        d="m30.64,44.25c.1.26.04.53,0,.79-.22-.26-.14-.53,0-.79Z"
      />
      <path
        className="cls-2"
        d="m45.72,28.43c.2-.26.39-.2.56.04-.19,0-.38.07-.56-.04Z"
      />
      <path
        className="cls-2"
        d="m66.67,43.55c.04.24.04.47,0,.71-.16-.24-.2-.47,0-.71Z"
      />
      <path
        className="cls-2"
        d="m30.41,56.09c-.06.21.26.42,0,.63-.15-.21-.22-.42,0-.63Z"
      />
      <path
        className="cls-2"
        d="m63.51,33.64c.06-.18-.01-.47.34-.41-.03.21-.12.37-.34.41Z"
      />
      <path
        className="cls-2"
        d="m39.46,60.64c.24.09.34.25.25.5-.18-.12-.21-.31-.25-.5Z"
      />
      <path
        className="cls-2"
        d="m30.38,62.56c.16.17.19.37.06.5-.18-.15-.17-.31-.06-.5Z"
      />
      <path
        className="cls-2"
        d="m51.72,67.32c.16-.34.2-.34.42-.04-.13.08-.28.03-.42.04Z"
      />
      <path
        className="cls-2"
        d="m40.22,61.95c.24.09.28.3.3.52-.18-.12-.22-.33-.3-.52Z"
      />
      <path
        className="cls-2"
        d="m56.75,29.24c.19-.03.38-.09.55.04-.19.07-.38.11-.55-.04Z"
      />
      <path
        className="cls-2"
        d="m32.69,73.33c-.38.24-.39.24-.41-.09.12.09.31-.11.41.09Z"
      />
      <path
        className="cls-2"
        d="m47.38,73.69c.06-.17.16-.16.42.04-.14.02-.29.09-.42-.04Z"
      />
      <path
        className="cls-2"
        d="m67.33,51.75c-.08-.15-.04-.31-.03-.47.21.15.19.3.03.47Z"
      />
      <path
        className="cls-2"
        d="m67.35,47.83c-.1-.16-.09-.32,0-.48.15.16.15.32,0,.48Z"
      />
      <path
        className="cls-2"
        d="m38.88,56.73c-.03-.12-.4-.16-.08-.35.02.12.13.22.08.35Z"
      />
      <path
        className="cls-2"
        d="m59.45,44.66c.2.07.25.24.26.43-.14-.11-.22-.25-.26-.43Z"
      />
      <path
        className="cls-2"
        d="m60.41,62.43c-.02-.16-.02-.31.19-.35,0,.15,0,.3-.19.35Z"
      />
      <path
        className="cls-2"
        d="m31.38,73.06c-.1.07-.2.07-.25-.04-.05-.09,0-.17.11-.2-.03.12.15.12.14.23Z"
      />
      <path
        className="cls-2"
        d="m31.22,41.91c-.1-.1-.33-.2.01-.28.02.09.1.19-.01.28Z"
      />
      <path
        className="cls-2"
        d="m53.65,66.98c.01-.27.18-.17.32-.13-.07.14-.17.18-.32.13Z"
      />
      <path
        className="cls-2"
        d="m52.69,67.21c.1-.13.22-.11.34-.04-.11.08-.22.09-.34.04Z"
      />
      <path
        className="cls-2"
        d="m61.15,59.53c0,.16-.02.32-.17.43-.07-.19-.03-.34.17-.43Z"
      />
      <path
        className="cls-2"
        d="m67.29,44.32c-.17-.12-.15-.24,0-.35.06.12.03.23,0,.35Z"
      />
      <path
        className="cls-2"
        d="m66.87,40.12c.1.13.16.26-.04.35-.05-.12-.04-.24.04-.35Z"
      />
      <path
        className="cls-2"
        d="m40.13,28.05c.1-.19.22-.14.35-.03-.11.11-.23.06-.35.03Z"
      />
      <path
        className="cls-2"
        d="m31.38,56.72c-.15-.13-.07-.25.03-.36.03.12.08.25-.03.36Z"
      />
      <path
        className="cls-2"
        d="m39.38,48.59c-.07-.02-.15.01-.23-.06.08-.1.21-.04.3-.08.02.07-.05.1-.07.14Z"
      />
      <path
        className="cls-2"
        d="m38.6,51.56c-.23-.17-.02-.22.08-.3.05.12-.06.2-.08.3Z"
      />
      <path
        className="cls-2"
        d="m59.17,44.32c.11.06.21.13.2.28-.14-.04-.18-.15-.2-.28Z"
      />
      <path
        className="cls-2"
        d="m67.24,58.38c-.01-.11-.08-.24.09-.29.07.13.07.23-.09.29Z"
      />
      <path
        className="cls-2"
        d="m31.23,40.68c-.18-.1-.18-.19,0-.29.03.1.03.19,0,.29Z"
      />
      <path
        className="cls-2"
        d="m62.54,34.47c.06-.11.12-.22.28-.13-.07.09-.15.16-.28.13Z"
      />
      <path
        className="cls-2"
        d="m65.1,29.55c.1-.18.2-.14.28.02-.1.05-.19.08-.28-.02Z"
      />
      <path
        className="cls-2"
        d="m36.9,27.37c-.08.1-.17.16-.29.12.04-.18.14-.22.29-.12Z"
      />
      <path
        className="cls-2"
        d="m53.24,66.23c-.05.15-.15.15-.27.09.04-.17.15-.15.27-.09Z"
      />
      <path
        className="cls-2"
        d="m33.46,28.01c-.03.12-.05.26-.22.11.03-.11.1-.17.22-.11Z"
      />
      <path
        className="cls-2"
        d="m60.07,62.85c-.04-.16,0-.25.19-.22-.03.1-.05.21-.19.22Z"
      />
      <path
        className="cls-2"
        d="m53.87,66.1c-.05.09-.06.24-.22.11.03-.11.09-.17.22-.11Z"
      />
      <path
        className="cls-2"
        d="m40.01,61.67c.14.02.2.1.17.24-.1-.05-.21-.08-.17-.24Z"
      />
      <path
        className="cls-2"
        d="m62.64,57.36c-.06-.1-.04-.18.05-.25.05.1.04.18-.05.25Z"
      />
      <path
        className="cls-2"
        d="m30.76,47.83c.06,0,.12,0,.12.08,0,.08-.07.07-.13.06-.09-.05-.08-.1.01-.14Z"
      />
      <path
        className="cls-2"
        d="m31.51,61.13c-.16-.03-.1-.14-.1-.24.17.02.16.12.1.24Z"
      />
      <path
        className="cls-2"
        d="m35.46,35.45c-.05.16-.12.19-.22.04.06-.09.14-.04.22-.04Z"
      />
      <path
        className="cls-2"
        d="m37.26,27.4c0,.07-.03.11-.1.11-.08,0-.13-.03-.13-.11.08-.04.15-.03.23,0Z"
      />
      <path
        className="cls-2"
        d="m36.42,27.49c-.09.14-.16.15-.22-.02.08-.05.16-.08.22.02Z"
      />
      <path
        className="cls-2"
        d="m30.7,40.19c.11.07.11.14,0,.21-.15-.08-.12-.14,0-.21Z"
      />
      <path
        className="cls-2"
        d="m48.27,73.75c.08-.08.16-.09.22.02-.08.03-.15.06-.22-.02Z"
      />
      <path
        className="cls-2"
        d="m40,73.71c-.05.12-.14.11-.23.06.04-.14.12-.17.23-.06Z"
      />
      <path
        className="cls-2"
        d="m62.55,57.69c-.01-.08-.04-.16.06-.22.07.1.04.17-.06.22Z"
      />
      <path
        className="cls-2"
        d="m39.05,57.4c-.14-.03-.17-.09-.06-.2.11.04.05.13.06.2Z"
      />
      <path
        className="cls-2"
        d="m66.81,40.94c.12.08.09.16-.02.22-.05-.08-.07-.16.02-.22Z"
      />
      <path
        className="cls-2"
        d="m34.3,73.71c-.08.04-.17.08-.22-.04.1-.11.17-.09.22.04Z"
      />
      <path
        className="cls-2"
        d="m51.19,27.84c-.08.04-.16.05-.22-.04.1-.12.17-.11.22.04Z"
      />
      <path
        className="cls-2"
        d="m66.58,28.97c-.09.06-.17.07-.24-.02.09-.09.17-.07.24.02Z"
      />
      <path
        className="cls-2"
        d="m54.14,66.82c.03-.14.12-.12.22-.1-.02.16-.11.15-.22.1Z"
      />
      <path
        className="cls-2"
        d="m38.76,56.17c-.12-.05-.15-.12-.03-.21.06.06.06.13.03.21Z"
      />
      <path
        className="cls-2"
        d="m63.03,34.2c-.02-.16.07-.2.2-.21-.02.11-.11.17-.2.21Z"
      />
      <path
        className="cls-2"
        d="m31.5,65.06c-.18-.07-.12-.15,0-.23.02.08.05.15,0,.23Z"
      />
      <path
        className="cls-2"
        d="m60.75,29.52c.07-.1.14-.1.21,0-.07.08-.14.06-.21,0Z"
      />
      <path
        className="cls-2"
        d="m32.14,73.17c-.09.12-.16.09-.22-.04.08-.05.16-.07.22.04Z"
      />
      <path
        className="cls-2"
        d="m63.92,33.02c-.02-.1-.05-.2.1-.22.07.12,0,.18-.1.22Z"
      />
      <path
        className="cls-2"
        d="m31.73,73.1c-.08.1-.16.08-.23-.01.08-.04.16-.08.23.01Z"
      />
      <path
        className="cls-2"
        d="m52.27,67.27c.06-.1.15-.08.24-.04-.07.08-.15.11-.24.04Z"
      />
      <path
        className="cls-2"
        d="m49.39,27.64c-.07.05-.15.05-.23,0-.01-.08.04-.13.11-.13.07,0,.13.04.12.12Z"
      />
      <path
        className="cls-2"
        d="m67.37,49.28c-.07-.04-.1-.08-.02-.14.08.03.14.07.02.14Z"
      />
      <path
        className="cls-2"
        d="m59.79,63.26c-.02-.11-.05-.22.13-.22.03.11-.04.17-.13.22Z"
      />
      <path
        className="cls-2"
        d="m31.49,61.54c-.13-.06-.09-.11.02-.14.03.05.04.1-.02.14Z"
      />
      <path
        className="cls-2"
        d="m60.26,62.62c-.02-.1,0-.15.12-.14.03.1-.07.1-.12.14Z"
      />
      <path
        className="cls-2"
        d="m63.09,50.04c-.1-.03-.13-.07-.04-.15.09.03.08.08.04.15Z"
      />
      <path
        className="cls-2"
        d="m53.15,67.14c.03-.1.09-.11.16-.03-.04.05-.09.07-.16.03Z"
      />
      <path
        className="cls-2"
        d="m30.72,48.37c.09.02.17.05.06.15-.09-.02-.09-.08-.06-.15Z"
      />
      <path
        className="cls-2"
        d="m66.27,29.53c.04-.08.08-.07.14-.02-.04.06-.08.08-.14.02Z"
      />
      <path
        className="cls-2"
        d="m36.48,35.84c0-.05.02-.1.09-.09.06,0,.05.05.05.1-.05.03-.09.02-.14,0Z"
      />
      <path
        className="cls-2"
        d="m67.2,67.68c-.09-.05-.13-.1,0-.15.05.05.05.1,0,.15Z"
      />
      <path
        className="cls-2"
        d="m36.21,35.52s0,.09-.07.09c-.06,0-.07-.04-.07-.09.05-.1.09-.1.14,0Z"
      />
      <path
        className="cls-2"
        d="m67.54,31.19c-.04-.06-.03-.11.02-.16.05.06.05.12-.02.16Z"
      />
      <path
        className="cls-2"
        d="m37.85,35.81c0-.07.05-.1.11-.09.03,0,.04.07.05.1-.05,0-.11-.01-.16-.02Z"
      />
      <path
        className="cls-2"
        d="m42.26,44.55c.02-.08.06-.12.15-.1,0,.11-.07.11-.15.1Z"
      />
      <path
        className="cls-2"
        d="m54.35,65.91c-.03.1-.09.12-.18.07.03-.12.1-.11.18-.07Z"
      />
      <path
        className="cls-2"
        d="m67.3,43.35s-.1,0-.1-.06c0-.05.03-.08.08-.08.05.04.05.08.02.13Z"
      />
      <path
        className="cls-2"
        d="m54.62,65.83c-.02.07-.06.07-.12.06.02-.07.02-.15.12-.06Z"
      />
      <path
        className="cls-2"
        d="m60.8,60.2c.09.09.06.14-.05.17-.06-.08-.04-.13.05-.17Z"
      />
      <path
        className="cls-2"
        d="m60.61,28.49c-.11.12-.13.05-.15-.06.08-.06.13-.05.15.06Z"
      />
      <path
        className="cls-2"
        d="m48.9,73.27c0,.05-.03.09-.08.08-.05,0-.07-.05-.07-.1.05-.02.1-.03.15.01Z"
      />
      <path
        className="cls-2"
        d="m49.05,27.63c-.07.04-.12.04-.16-.04.09-.14.13-.07.16.04Z"
      />
      <path
        className="cls-2"
        d="m42.83,73.39c-.05.09-.11.08-.17.02.05-.09.1-.11.17-.02Z"
      />
      <path
        className="cls-2"
        d="m42.35,73.45c-.04.09-.1.09-.17.03.05-.07.1-.12.17-.03Z"
      />
      <path
        className="cls-2"
        d="m41.59,73.51c-.03.09-.09.09-.17.05.04-.08.08-.14.17-.05Z"
      />
      <path
        className="cls-2"
        d="m59.92,63.04c-.01-.09.01-.15.12-.14.03.11-.03.14-.12.14Z"
      />
      <path
        className="cls-2"
        d="m51.03,41.37c-.09.09-.12.04-.13-.06.06-.03.11-.02.13.06Z"
      />
      <path
        className="cls-2"
        d="m36.49,35.44c-.01.12-.07.15-.17.08.02-.1.08-.12.17-.08Z"
      />
      <path
        className="cls-2"
        d="m63.01,29.53c.07-.03.12-.02.15.06-.08.06-.12.01-.15-.06Z"
      />
      <path
        className="cls-2"
        d="m67.35,48.95s-.08-.02-.08-.03c0-.06.04-.06.08-.06,0,.03,0,.06,0,.09Z"
      />
      <path
        className="cls-2"
        d="m60.67,62s.01-.06.06-.06c-.02.02-.04.04-.06.06Z"
      />
      <path
        className="cls-2"
        d="m66.53,69.24s0,.06,0,.09c-.02-.02-.04-.03-.06-.05.02-.02.04-.03.07-.05Z"
      />
      <path
        className="cls-2"
        d="m31.55,68.81s-.04,0-.05.01c0-.05.03-.02.05-.02,0,0,0,0,0,0Z"
      />
      <path
        className="cls-2"
        d="m34.41,31.01s.02-.03.03-.05c.02.02.04.04.05.05-.03,0-.06,0-.08,0Z"
      />
      <path
        className="cls-2"
        d="m31.43,50.92s-.01.05-.03.05c-.01,0-.04-.01-.06-.02,0-.02.01-.05.03-.05.01,0,.04.01.06.02Z"
      />
      <path
        className="cls-2"
        d="m36.01,74.14s-.02,0-.03-.01c0,0,.02,0,.02.01,0,0,0,0,0,0Z"
      />
      <path
        className="cls-2"
        d="m66.5,64.41s-.03,0-.04,0c0,0,0-.01,0-.02.01,0,.02,0,.04.01Z"
      />
      <path
        className="cls-2"
        d="m60.9,32.95c.14.13.22.29.2.48-.18-.11-.23-.28-.2-.48Z"
      />
      <path
        className="cls-2"
        d="m63.51,32.95c-.06-.15.09-.27.07-.42.14.14.12.27-.07.42Z"
      />
      <path
        className="cls-1"
        d="m47.58,51.9c-.45-.26-.94-.4-1.45-.47-.34-.04-.66.06-.97.13-.13.03-.26.05-.4.06-.36-.03-.66.06-.9.35-.53.25-.92.66-1.24,1.14-.16.24-.31.49-.47.73-.08-.05-.09-.12-.08-.21.06-.41.21-.78.42-1.14.2-.34.42-.66.63-.99.26-.21.57-.32.87-.45.1,0,.21.02.21-.14.13-.04.26-.07.39-.11.13.06.26.01.4,0,.31-.04.63-.42.94.04.04.06.27.05.29-.07.04-.2.23-.18.33-.29.18.01.37.02.55.03.04.09.1.09.17.04.1.02.2.04.31.05,0,.16.15.18.23.21.35.13.67.27.88.64.07.12.28.39.56.31.4.48.62,1.08.97,1.58-.1.12-.08.19.09.18.06.15.12.29.19.44-.11.14-.15.26.06.35,0,.04.02.08.03.12,0,.27.05.52.38.58.12.15.25.31.37.46-.05.22-.04.39.26.36.21.26.5.43.75.64.06.24.27.11.4.15.75.24,1.51.44,2.31.39.49-.03.99-.02,1.43-.27.25,0,.5-.01.75-.02.16,0,.17.08.11.2-.19.07-.18.4-.35.38-.38-.06-.43.38-.73.4-.05,0-.05.09-.05.15-.01.02-.03.03-.05.03-.15-.03-.21.11-.29.19-.05.02-.09.03-.14.05-.06-.04-.12-.03-.15.04-.78.1-1.55.04-2.33,0-.02-.09-.05-.16-.15-.05l-.13-.02c-.1-.16-.23-.24-.42-.14-.07,0-.16.04-.2-.06-.01-.19-.16-.22-.3-.25-.26-.05-.52-.11-.79-.17-.33-.24-.68-.47-.91-.82,0-.1-.02-.18-.14-.2h0c-.32-.89-.83-1.69-1.17-2.57-.06-.17-.11-.41-.36-.45-.1-.23-.34-.38-.4-.63.01-.05,0-.07-.05-.07-.02,0-.03-.02-.03-.05-.05-.28-.24-.47-.46-.64h0c-.01-.09-.05-.15-.15-.13Z"
      />
      <path
        className="cls-2"
        d="m56.48,56.73c-.45.26-.95.24-1.43.27-.8.05-1.56-.15-2.31-.39-.13-.04-.34.09-.4-.15.33-.05.63.06.95.14.52.14,1.06.16,1.6.2.54.04,1.06-.11,1.59-.07Z"
      />
      <path
        className="cls-2"
        d="m48.68,53.42c.25.04.3.28.36.45.33.88.85,1.68,1.17,2.57-.25-.03-.25-.27-.34-.42-.42-.66-.73-1.37-.99-2.1-.06-.17-.23-.29-.2-.49Z"
      />
      <path
        className="cls-2"
        d="m43.12,51.5c-.21.33-.43.66-.63.99-.21.35-.35.73-.42,1.14-.01.09,0,.16.08.21,0,.1,0,.21,0,.31,0,.11-.02.23-.15.23-.13,0-.15-.12-.16-.23-.03-.37.07-.73.17-1.07.16-.52.44-.99.83-1.39.08-.08.13-.19.27-.18Z"
      />
      <path
        className="cls-2"
        d="m46.55,50.48c-.1.11-.29.09-.33.29-.03.12-.25.13-.29.07-.3-.45-.63-.07-.94-.04-.14.02-.26.06-.4,0,.21-.34.58-.22.87-.29.32-.07.66-.02.98-.12.06-.02.11,0,.11.08Z"
      />
      <path
        className="cls-2"
        d="m49.24,51.76c-.28.08-.49-.18-.56-.31-.21-.37-.52-.51-.88-.64-.09-.03-.24-.05-.23-.21.37-.01.68.17.96.38.28.21.56.44.71.78Z"
      />
      <path
        className="cls-2"
        d="m56.21,57.83c0-.06,0-.15.05-.15.3-.02.36-.46.73-.4.16.03.16-.31.35-.38-.04.48-.42.65-.77.83-.11.05-.24.06-.35.1Z"
      />
      <path
        className="cls-2"
        d="m51.26,57.46c.26.06.52.12.79.17.15.03.29.06.3.25-.38-.1-.8-.08-1.09-.41Z"
      />
      <path
        className="cls-2"
        d="m43.86,51.96c.23-.28.54-.38.9-.35-.27.18-.61.19-.9.35Z"
      />
      <path
        className="cls-2"
        d="m50.95,55c-.34-.05-.37-.31-.38-.58.18.15.39.29.38.58Z"
      />
      <path
        className="cls-2"
        d="m47.73,52.03c.22.17.41.36.46.64-.22-.16-.35-.4-.46-.64Z"
      />
      <path
        className="cls-2"
        d="m51.58,55.82c-.29.03-.31-.14-.26-.36.12.09.29.16.26.36Z"
      />
      <path
        className="cls-2"
        d="m52.55,57.94c.19-.1.32-.02.42.14-.17.06-.3-.02-.42-.14Z"
      />
      <path
        className="cls-2"
        d="m55.86,58.05c.09-.08.14-.21.29-.19-.03.17-.09.29-.29.19Z"
      />
      <path
        className="cls-2"
        d="m50.54,54.31c-.2-.09-.17-.21-.06-.35.13.1.07.23.06.35Z"
      />
      <path
        className="cls-2"
        d="m50.3,53.52c-.17,0-.19-.06-.09-.18.09.03.1.1.09.18Z"
      />
      <path
        className="cls-2"
        d="m44.19,50.92c0,.16-.11.14-.21.14.02-.11.07-.19.21-.14Z"
      />
      <path
        className="cls-2"
        d="m50.22,56.44c.12.02.14.1.14.2-.13,0-.11-.12-.14-.2Z"
      />
      <path
        className="cls-2"
        d="m47.27,50.55c-.07.05-.13.05-.17-.04.09-.11.13-.06.17.04Z"
      />
      <path className="cls-2" d="m47.58,51.9c.1-.01.13.04.15.13l-.15-.13Z" />
      <path
        className="cls-2"
        d="m53.1,58.09c.09-.11.12-.04.15.05-.07.03-.13.04-.15-.05Z"
      />
      <path
        className="cls-2"
        d="m55.57,58.15c.03-.08.09-.08.15-.04,0,.16-.1.04-.15.04Z"
      />
      <path
        className="cls-2"
        d="m48.22,52.71s.07.03.05.07c-.02-.02-.04-.05-.05-.07Z"
      />
    </Icon>
  );
}

export function IconHandwashOnly({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="26 29 48 41"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #a3a1a1; }`}
          {`.cls-2 { fill: #5c5858; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m48.01,37.83c.06-.05.13-.1.19-.15.22.11.4-.04.59-.11.27-.11.57-.02.64.2.16.56.44,1.02.81,1.45.19.21-.06.57.2.79,0,.11-.02.23-.03.34-.09.01-.19.03-.2.15-.01.16.1.18.21.2,0,.23.02.46.02.69-.15.22-.27.43.07.58.03,2.75.21,5.5-.05,8.25-.07.75.17,1.56-.37,2.24-.09-.05-.14-.12-.16-.22-.08-.61-.32-1.18-.36-1.81-.02-.45.23-1.09-.49-1.31-.06-.02-.1-.1-.15-.16.03-.24-.14-.5.14-.73.21-.17-.11-.31-.16-.47-.22-.68.16-1.35.02-2.02.13-.13.12-.25-.04-.34,0-.16,0-.33.14-.45.08.01.17-.01.18-.09.02-.13-.08-.15-.18-.15,0-.57,0-1.15,0-1.72.13-.04.29-.19.24-.26-.38-.63.12-1.32-.16-1.94-.08-.45-.29-.88-.2-1.35.16-.19.21-.36-.06-.49-.06-.16-.16-.21-.3-.1-.29.18-.54.34-.71.71-.31.68-.4,1.39-.56,2.1-.34,1.48-.58,2.97-.66,4.48-.04.75-.11,1.48-.4,2.17-.11.25-.28.54-.59.41-.27-.12-.57-.33-.51-.73.11-.7-.07-1.39-.06-2.08,0-.42-.3-.98.36-1.25.2-.08.2-.33,0-.47-.26-.19-.2-.32.03-.47.09-.06.2-.16.21-.25.04-.81.28-1.54.69-2.24.1-.17.29-.44-.02-.65.04-.1.08-.21.12-.31.33-.13.46-.33.22-.65.07-.69.73-.99.99-1.55.18.02.34.01.34-.23Z"
      />
      <path
        className="cls-2"
        d="m41.57,33.02c0,.11.02.23.03.34-.21.1-.14.18,0,.26.15.62-.05,1.25.02,1.88-.06.33-.21.69.11.96.34.28.29.62.24.99-.06.49-.19.97-.25,1.47-.1.81-.14,1.62-.16,2.43-.03.91-.23,1.8.05,2.72.11.35.43.81.13,1.15-.25.28-.14.52-.02.68.25.33.2.67.07.96-.21.46-.28.89-.11,1.37.03.1.07.27-.12.32-.19-.1.02-.47-.23-.45-.32.03-.47.3-.47.68-.22-.39-.37-.74-.29-1.14.06-.34.37-.72-.18-.94-.04-.02-.03-.18-.04-.27-.01-1.5-.11-3-.25-4.5-.02-.26-.06-.53.14-.77.08-.09.09-.22,0-.32-.21-.25-.12-.54-.17-.82-.12-.79.56-1.53.11-2.33.34-.51.34-1.02.14-1.6-.09-.27.14-.64.1-.95-.04-.37.21-.83-.27-1.09.03-.38.06-.76.1-1.14.08-.02.09-.06.1-.15.05-.45.11-.89.2-1.33.04-.22.22-.35.46-.35.11,0,.21.07.19.16-.11.48.23.9.16,1.38-.02.16-.05.36.19.41Zm-.81,13.38c.17-.05.21-.2.22-.35.02-.12-.05-.25-.17-.26-.19-.02-.26.13-.26.3,0,.14.04.26.21.31Z"
      />
      <path
        className="cls-2"
        d="m30.78,68.61c-.82-.69-1.52-1.52-1.81-2.54-.28-1-.95-1.79-1.3-2.73-.12-.38-.08-.85-.58-1.02-.6-.65-.77-1.49-.99-2.31-.03-.11-.01-.23-.03-.34-.1-.5.1-.66.68-.54.04.15.14.19.28.14.35.18.31.57.47.85.23.42.56.79.85,1.18-.08.72.52.83.96,1.08.3.61.96.99,1.07,1.72-.08.02-.14.09-.09.15.03.04.12.04.19.06.26.42.41.88.6,1.32.33.75.38,1.57.79,2.29.14.25.03.52.04.78-.39.13-.74-.18-1.12-.1Z"
      />
      <path
        className="cls-1"
        d="m35.47,40.95c-.25-.08-.19-.31-.19-.48,0-.98.09-2.01-.1-2.92-.19-.96-.05-1.96-.38-2.87-.19-.51-.52-.96-.82-1.42-.18-.28-.35-.09-.39.11-.15.79-.44,1.54-.42,2.38.03,1.04-.13,2.09,0,3.13.05.37.04.75.06,1.12-.26,0-.23-.19-.24-.36-.01-.24-.04-.48-.07-.73-.06,0-.12,0-.18,0v1.45c-.25-.08-.2-.3-.2-.48,0-.76-.08-1.53.03-2.27.18-1.18-.1-2.4.28-3.56.11-.33.23-.65.4-.94.34-.58.73-.6,1.14-.04.62.84,1.1,1.73,1.24,2.81.19,1.49.46,2.97.91,4.43.16-1.65.04-3.33.37-4.96.06,0,.11,0,.17,0,0,.76.08,1.53-.04,2.27-.06.37.15.61.14.92-.02.83-.06,1.66-.05,2.49,0,.61.15,1.23.13,1.84-.03,1.1.37,2.15.34,3.25-.11-.01-.23-.01-.28-.15,0-.01.02-.02.02-.03,0,.01-.01.02-.02.03-.39.16-.2.36-.06.58.13.2.04.39-.12.5-.19.13-.24-.11-.34-.2-.12-.11-.19-.23-.18-.4.08-.81-.08-1.59-.24-2.37-.05-.24-.14-.5-.1-.73.31-1.54-.3-3-.42-4.49-.01-.12-.02-.35-.25-.3-.17.04-.12.22-.12.34-.04.68.06,1.37-.05,2.05Z"
      />
      <path
        className="cls-1"
        d="m40.17,34.05c.49.26.23.72.27,1.09.03.31-.19.67-.1.95.2.58.19,1.09-.14,1.6.44.8-.23,1.55-.11,2.33.04.28-.04.57.17.82.08.1.07.23,0,.32-.2.23-.16.51-.14.77.14,1.5.23,3,.25,4.5,0,.09,0,.26.04.27.55.23.25.61.18.94-.07.4.07.75.29,1.14,0-.38.15-.65.47-.68.25-.02.04.35.23.45.19-.05.15-.22.12-.32-.17-.48-.1-.91.11-1.37.13-.29.17-.63-.07-.96-.11-.15-.22-.39.02-.68.29-.34-.03-.8-.13-1.15-.27-.92-.08-1.82-.05-2.72.03-.81.06-1.62.16-2.43.06-.5.19-.98.25-1.47.04-.37.1-.71-.24-.99-.32-.27-.17-.63-.11-.96.25.04.34-.13.39-.32.02-.09-.01-.2.02-.28.13-.3.24-.79.61-.69.31.08.04.47-.02.74-.08.36-.13.72-.17,1.09-.13,1.26-.36,2.5-.31,3.78.06,1.63.02,3.27.02,4.9,0,1.74.01,3.47-.38,5.18-.06.27-.13.48-.44.51-.33.03-.5-.11-.65-.41-.44-.87-.45-1.81-.51-2.72-.09-1.29-.31-2.58-.34-3.87-.04-1.63-.07-3.27,0-4.91.05-1.29.24-2.57.17-3.86,0-.17,0-.41.17-.57Z"
      />
      <path
        className="cls-2"
        d="m66.41,36.23c.14.47-.12.89-.18,1.34-.31,2.36-.38,4.72-.39,7.09,0,.93.01,1.86.02,2.79-.15.05-.23.12-.07.25-.01.15-.02.29-.03.44-.11.01-.16.08-.22.16-.11.15-.21.35-.44.29-.25-.07-.31-.28-.36-.52-.06-.36-.08-.71-.09-1.07-.03-.85.07-1.7-.07-2.55,0-.4,0-.8-.01-1.2.17-.05.21-.15.12-.3-.01-.04-.02-.08-.03-.13.1-.19.1-.38.01-.57,0-.12,0-.24,0-.36.2-.67.03-1.35.09-2.02.11-1.16.09-2.31.1-3.46,0-.19.04-.38.11-.56.11-.32.34-.27.42-.02.12.37.29.41.58.22.23-.14.26.19.43.17Z"
      />
      <path
        className="cls-1"
        d="m66.41,36.23c-.17.02-.2-.31-.43-.17-.29.19-.46.15-.58-.22-.08-.25-.31-.29-.42.02-.06.18-.11.37-.11.56,0,1.15.01,2.31-.1,3.46-.06.66.11,1.35-.09,2.02-.27-.17-.18-.45-.17-.68.02-1.81.08-3.61.08-5.42,0-.7-.19-1.39-.19-2.1,0-.28-.19-.55-.47-.66-.32-.13-.39.2-.55.38-.21.24-.31.51-.37.82-.06.31-.1.64-.37.87,0-.11-.04-.24,0-.32.29-.51-.05-.51-.4-.51.11-.8.61-1.38,1.11-1.95.23-.26,1.43.04,1.5.41.14.67.71,1.17.7,1.89,0,.26.03.53.04.81.63-.15,1.18-.43,1.75-.68.91-.4,1.31-.25,1.52.68.25,1.12.54,2.25.39,3.42-.05.4.25.78.02,1.17-.17-.27-.38-.44-.71-.25-.52-.65-.37-1.45-.48-2.19-.08-.48,0-.99-.01-1.48-.01-.32.12-.8-.32-.87-.38-.06-.75.21-1,.55-.11.14-.1.38-.33.42Z"
      />
      <path
        className="cls-1"
        d="m46.34,40.58c.31.2.12.48.02.65-.41.7-.65,1.43-.69,2.24,0,.09-.12.19-.21.25-.23.15-.29.29-.03.47.2.14.21.39,0,.47-.67.27-.36.83-.36,1.25,0,.69.17,1.38.06,2.08-.06.39.24.61.51.73.3.13.48-.16.59-.41.3-.69.37-1.42.4-2.17.08-1.51.32-3.01.66-4.48.16-.7.24-1.42.56-2.1.17-.38.41-.53.71-.71.05.39-.29.62-.47.87-.54.78-.53,1.69-.7,2.55-.21,1.05-.31,2.13-.43,3.19-.11.94-.18,1.89-.28,2.83-.06.55-.6,1.18-1.11,1.32-.17.05-.3,0-.39-.14-.41-.68-.56-1.45-.53-2.22.01-.42-.01-.83-.03-1.24-.03-1.3-.06-2.6-.11-3.9-.03-.72.03-1.43.16-2.12.04-.2-.19-.39.02-.57.42.38.67.27.8-.26.01-.05.11-.08.17-.11.03.6.26,1.17.14,1.82.22-.12.38-.21.54-.3Zm-.75,1.61s-.03-.1-.06-.17c-.05-.18-.08-.42-.33-.39-.28.03-.19.29-.19.46,0,.24.11.46.01.72-.06.16.06.4.29.4.22,0,.16-.22.18-.35.03-.2.06-.41.09-.66Z"
      />
      <path
        className="cls-1"
        d="m57.44,40.83c.02-1.85.31-3.66.94-5.4.13-.34.37-.67.76-.69.41-.03.68.27.93.57.61.75.57,1.62.62,2.53.06,1.14.08,2.31.47,3.42-.03.45-.06.91-.1,1.5-.42-.61-.28-1.18-.39-1.7-.03-.13.05-.36-.2-.31-.18.03-.23.21-.15.37.29.57.11,1.19.12,1.76.02,1.04-.05,2.07.08,3.11.06.48.09.98-.03,1.47-.26,0-.24-.19-.24-.36-.02-1.47-.35-2.91-.47-4.38-.05-.67-.19-1.41.23-2.05.07-.11.05-.22,0-.33-.12-.29-.14-.62-.07-.9.2-.77.03-1.53,0-2.28-.03-.53-.24-1.06-.39-1.58-.05-.17-.24-.26-.32-.04-.11.33-.34.6-.37.99-.07.91-.22,1.81-.34,2.71-.01.1-.06.18-.16.22-.1-.36.08-.75-.07-1.1-.17,0-.18.11-.23.18-.36.5-.17,1.05-.17,1.58,0,.31.05.69-.45.7Z"
      />
      <path
        className="cls-2"
        d="m60.47,47.45c.13-.49.09-.99.03-1.47-.12-1.04-.06-2.07-.08-3.11,0-.57.16-1.19-.12-1.76-.08-.16-.03-.33.15-.37.25-.05.18.18.2.31.11.52-.04,1.09.39,1.7.04-.59.07-1.05.1-1.5,0-.07.02-.13.03-.2.1-.03.12-.08.05-.16,0-.21.01-.43.02-.64.08-.02.15-.05.15-.14,0-.03-.07-.06-.11-.09-.06-.26.02-.47.25-.62.01.33.29.41.52.53,0,.13,0,.26,0,.4-.27.08-.2.31-.17.47.12.52-.02,1.04.03,1.55.03.29-.1.6.07.88,0,.46,0,.92,0,1.38-.23,1.07-.1,2.15-.08,3.22-.1.61.03,1.23-.12,1.83-.7-.05-.83-.17-.92-.88-.03-.24-.07-.49-.1-.73-.02-.19-.15-.25-.31-.26,0-.11.01-.22.02-.34Z"
      />
      <path
        className="cls-2"
        d="m36.55,58.58c.47.15.91.33,1.14.81,0,.25,0,.51.32.59.55.78.26,1.62.19,2.52-.22-.3-.31-.56-.29-.87.06-.87-.36-1.51-.96-2.1-.24-.24-.5-.22-.78-.25-.43-.46-.89-.43-1.38-.11-.15-.05-.31-.05-.46.01-.54-.05-1.05-.43-1.61-.1-.51-.22-1.11-.25-1.5-.71-.04-.41-.4-.52-.67-.7-.28-.83-1.06-1.4-1.22-2.3-.02-.11-.04-.22-.06-.32.03-.26.29-.59-.19-.71-.07-.33.07-.7-.17-1,.19-.23.14-.42-.09-.59-.09-.33-.18-.67-.27-1,.04-.43-.14-.75-.51-.97-.1-.12-.19-.24-.21-.4.22-.3.44,0,.5.09.31.44.76.76.96,1.3.17.47.26.97.44,1.43.11.37.23.75.24,1.14-.02.15.06.22.19.26,0,.11,0,.22,0,.33-.03.02-.07.03-.1.05-.15.1-.31-.38-.42-.02-.07.23.14.29.37.28.27,0,.27.24.36.43.21.45.24,1.05.86,1.21.34.73.93,1.11,1.67,1.36.89.3,1.8.2,2.7.21.19,0,.38.02.57.03.09.18.23.12.36.08Z"
      />
      <path
        className="cls-1"
        d="m58.01,43.8c.22.3.07.63.08.94.05,1.24.1,2.47.11,3.71,0,1.01-.05,2.02-.08,3.03-.01.48-.29.89-.3,1.37,0,.18-.2.34-.41.33-.15,0-.19-.17-.2-.31-.06-1.22-.31-2.43-.38-3.64-.07-1.39-.03-2.78-.02-4.17,0-.14-.05-.32.19-.35.19.06.17.22.19.37.02.17.13.23.28.19.23-.05.09-.17.05-.29-.09-.3,0-.61-.02-.91-.02-.52.21-.41.5-.27Z"
      />
      <path
        className="cls-2"
        d="m65.13,58.51c-.01.07-.02.14-.04.21-.21.19-.42.35-.6-.03.06-1.21.74-2.03,1.93-2.39.28-.08.52-.29.78-.44.28-.04.41-.2.44-.47h0c.55-.09.45-.48.4-.85.2-.34.05-.78.33-1.09.24.11.27-.06.26-.22-.1-1.14.52-2.01,1.08-2.9.09-.15.27-.3.12-.51.02-.07.05-.14.07-.2.19.02.28-.04.2-.24.09-.11.17-.22.26-.33.33-.26.66-.52.98-.79.16-.14.32-.33.54-.2.29.16,0,.36-.02.54-.26,0-.42.18-.58.36-.16-.01-.24.06-.22.22h0c-.58.69-.82,1.58-1.43,2.24-.08.09-.08.21.03.3,0,.12,0,.24-.01.35-.08.06-.08.14-.06.23,0,.07-.02.14-.03.21-.3.07-.32.3-.36.55-.05.26,0,.52-.04.79-.13.78-.42,1.49-.74,2.2,0,0-.02.02-.02.02-.13.07-.25.15-.21.32h-.01c-.16.02-.28.08-.31.26-.19.12-.38.24-.56.36-.56-.07-1.11-.09-1.51.42-.16.12-.31.25-.47.37-.2.21-.25.45-.18.72Z"
      />
      <path
        className="cls-2"
        d="m35.47,40.95c.11-.68.01-1.37.05-2.05,0-.12-.05-.3.12-.34.23-.05.24.18.25.3.12,1.5.73,2.95.42,4.49-.05.23.05.49.1.73.16.78.32,1.56.24,2.37-.02.17.06.29.18.4.1.09.15.33.34.2.15-.11.25-.3.12-.5-.14-.21-.33-.42.06-.58h0c.05.13.17.13.28.14-.04.78.12,1.57.01,2.35-.26.34-.35.76-.51,1.15-.09.23-.23.41-.5.39-.31-.02-.34-.25-.35-.49,0-.19.01-.39-.05-.56-.26-.67-.2-1.37-.26-2.06-.04-.49.06-1,.04-1.5-.02-.66-.23-1.31-.17-1.97.06-.62-.26-1.22-.07-1.85.04-.12-.06-.34-.23-.43-.03-.06-.05-.13-.08-.19Z"
      />
      <path
        className="cls-2"
        d="m55.92,43.33c-.26,1.07-.55,2.13-.75,3.21-.1.57-.06,1.18-.04,1.77.05,2.02.17,4.03.11,6.05-.01.48-.05.94-.22,1.39-.35.02-.42-.21-.48-.48-.06-.3.1-.63-.12-.9-.04-.46-.11-.92,0-1.38.13-.09.22-.2.19-.37-.09-.48-.05-.95.01-1.44.04-.33.04-.73-.17-1.06-.04-1.26.02-2.5.15-3.76.13-1.16.75-2.16.83-3.3.03-.39.28-.68.56-.94.34.09.16.37.21.58-.08.15-.16.29-.23.44-.08.06-.07.13-.04.21Z"
      />
      <path
        className="cls-2"
        d="m68.39,66.36c0-.48.48-.75.55-1.2.35.02.38-.29.45-.49.1-.33.13-.69.18-1.04.29-.78.36-1.65,1-2.36.21.73-.1,1.32-.17,1.93-.1.95-.39,1.85-.68,2.75-.4,1.23-1.15,2.21-2.11,3.05-.11.09-.28.11-.42.17-.1-.04-.2-.09-.3-.13-.09-.63.46-.94.72-1.4.41-.33.78-.69.78-1.28Z"
      />
      <path
        className="cls-1"
        d="m35.54,41.14c.18.09.27.31.23.43-.2.63.13,1.24.07,1.85-.07.66.15,1.31.17,1.97.01.51-.08,1.01-.04,1.5.06.69,0,1.39.26,2.06.07.17.04.38.05.56.01.24.04.48.35.49.27.01.41-.16.5-.39.15-.39.24-.81.51-1.15.11.75-.21,1.41-.5,2.06-.16.35-.63.32-.92,0-.22-.25-.4-.55-.37-.88.06-.54-.11-1.05-.1-1.58,0-.56-.33-1.07-.23-1.66.2-1.18-.06-2.36-.05-3.54,0-.58-.16-1.15.09-1.72Z"
      />
      <path
        className="cls-2"
        d="m55.06,61.27c0,.05,0,.1,0,.16,0,.18,0,.36.01.54,0,1.08-.28,2.11-.67,3.13.23-1.59.09-3.18.14-4.77.13-1.07-.24-2.17.2-3.23.05-.12-.02-.26-.1-.37-.12-.19-.18-.39,0-.58.2-.22.38-.03.55.06,0,.57,0,1.13.01,1.7-.08.07-.08.14-.01.22-.13.92-.06,1.84-.07,2.76-.12.11-.1.24-.07.38Z"
      />
      <path
        className="cls-2"
        d="m68.57,39.79c.33-.19.54-.02.71.25.05.48.1.96.15,1.44-.35.23-.27.48-.04.74.02.26.03.52.05.77-.19.19-.16.36.07.49-.1.52.15,1.06-.04,1.58-.54.08-.79-.03-.84-.69-.07-1,0-2.01-.12-3-.03-.25.09-.64-.27-.81,0-.06,0-.13,0-.19.25-.03.21-.21.18-.38.05-.07.1-.13.15-.2Z"
      />
      <path
        className="cls-2"
        d="m49.73,64.23c.01-.23.02-.46.03-.7.14-.38.18-.76,0-1.14-.07-.16-.05-.31,0-.46.36-.35-.02-.71,0-1.07.02-.56.04-1.12.06-1.68.21.03.26-.27.47-.23.13,1.23.11,2.47.1,3.7,0,1.34-.06,2.67-.29,4-.08.06-.08.14-.05.22,0,.04,0,.07,0,.11-.44,0-.5-.23-.4-.61.06-.23.26-.52-.15-.66,0-.11,0-.21,0-.32.44-.32.1-.78.22-1.16Z"
      />
      <path
        className="cls-1"
        d="m71.86,48.59c.02-.18.31-.38.02-.54-.22-.12-.38.06-.54.2-.32.27-.65.53-.98.79.17-.87,1.33-1.61,2.16-1.39.22.06.37.22.47.39.35.56.65,1.15.57,1.85-.22-.21-.43-.34-.49.12-.03.22-.07.46-.05.68.06.66.3,1.31.15,2-.13.58-.07,1.2-.26,1.77-.22-.79.18-1.57.05-2.36-.17-1.05-.08-2.16-.6-3.14-.11-.21-.19-.42-.49-.38Zm.48-.07c.04-.07.07-.1.08-.14,0-.02-.05-.07-.06-.07-.04.01-.1.04-.11.07,0,.03.04.07.09.14Z"
      />
      <path
        className="cls-1"
        d="m41.57,33.02c-.24-.05-.22-.25-.19-.41.07-.47-.27-.9-.16-1.38.02-.1-.08-.16-.19-.16-.24,0-.41.13-.46.35-.09.44-.15.89-.2,1.33-.01.09-.02.13-.1.15-.28-.11-.17-.35-.16-.54.02-.58.03-1.17.11-1.75.07-.55-.18-1-.36-1.47-.12-.31-.41-.41-.8-.43,1.08-.47,2.05.12,2.22,1.28.12.82.22,1.64.32,2.46.02.19.05.38-.02.56Z"
      />
      <path
        className="cls-1"
        d="m68.24,40.56c.37.17.24.56.27.81.12.99.05,2,.12,3,.05.66.3.77.84.69.02.16.03.32-.04.48-.75-.02-.89.19-.72,1.04.1.51.23,1.02.11,1.55-.06.26-.11.65.2.75.28.09.39-.27.52-.48.02-.03.07-.03.1-.05.18.36-.08.7-.06,1.06.01.2-.2.25-.39.25-.22,0-.32-.11-.42-.31-.37-.74-.29-1.55-.38-2.33-.19-1.53.02-3.07-.08-4.61-.04-.62-.26-1.23-.07-1.86Z"
      />
      <path
        className="cls-2"
        d="m33.35,51.5c0,.38,0,.75,0,1.13-.13.11-.25.32-.41,0-.17-.35-.12-.69-.06-1.05.05-.3.24-.61-.03-.9-.06-.92-.08-1.84.01-2.75.14-.14.12-.23-.09-.25-.06-.25-.04-.51,0-.77.3-.06.17-.3.18-.46.02-.36.16-.44.46-.24.07,1.34.11,2.68-.01,4.02-.15.19-.17.38,0,.57.08.19.05.38.02.57-.07.03-.11.07-.06.15Z"
      />
      <path
        className="cls-2"
        d="m58.01,43.8c-.29-.14-.52-.25-.5.27,0,.3-.07.61.02.91.04.12.18.24-.05.29-.15.03-.26-.03-.28-.19-.02-.15,0-.31-.19-.37.02-.11.05-.23.07-.34.14-.86.28-1.72.41-2.58,0-.02-.09-.05-.14-.08,0-.1,0-.2,0-.3.21-.09.26-.21.07-.37,0-.07.01-.14.02-.22.5-.01.45-.39.45-.7,0-.54-.2-1.09.17-1.58.05-.07.06-.19.23-.18.15.35-.02.74.07,1.1-.1,1.45-.45,2.88-.34,4.35Z"
      />
      <path
        className="cls-1"
        d="m44.7,39.09c-.25-.38-.16-.83-.21-1.24-.09-.71-.23-1.43-.15-2.16.01-.11.01-.23-.01-.34-.06-.27-.26-.64.15-.7.33-.05.71.15.77.6.09.78.32,1.54.35,2.34.01.4.05.79.07,1.18-.28-.12-.34-.37-.3-.61.06-.34.01-.63-.21-.9-.07-.09.02-.31-.2-.27-.2.04-.27.2-.25.39.02.17.06.34.06.51.01.4.19.82-.07,1.21Z"
      />
      <path
        className="cls-2"
        d="m72.9,54.47c.19-.58.14-1.19.26-1.77.15-.69-.09-1.33-.15-2-.02-.22.02-.45.05-.68.06-.45.26-.33.49-.12,0,.07.02.14.03.21-.09.35-.11.69.04,1.03-.11.61.23,1.2.05,1.81-.26.44-.18.93-.21,1.4-.03.19-.05.38-.08.58-.07.06-.15.12-.12.23,0,.04,0,.08,0,.11-.09.1-.07.33-.27.28-.15-.04-.09-.22-.08-.34.01-.18.04-.37-.03-.54,0-.07.02-.13.03-.2Z"
      />
      <path
        className="cls-2"
        d="m33.33,41.27c.03,1.33.06,2.67.09,4-.21.08-.42.15-.57-.1-.03-.99-.07-1.99-.09-2.98,0-.31-.12-.64.1-.93.16,0,.31,0,.47,0Z"
      />
      <path
        className="cls-2"
        d="m69.64,48.36s-.08.02-.1.05c-.13.21-.24.57-.52.48-.31-.1-.26-.49-.2-.75.12-.54,0-1.04-.11-1.55-.17-.85-.03-1.07.72-1.04,0,.14.01.28.02.43-.24-.02-.37.09-.33.32.04.27-.05.62.36.71.11.1.08.23.1.36-.18.22-.2.42.06.6v.41Z"
      />
      <path
        className="cls-1"
        d="m62.06,39.93c-.23-.12-.51-.2-.52-.53-.08-.08-.23-.17-.22-.24.07-1.06-.42-2.18.29-3.19.1.63.11,1.27-.02,1.9-.03.15-.1.34.09.38.27.05.2-.19.22-.34.04-.29-.01-.61.32-.78-.06.93-.28,1.86-.16,2.8Z"
      />
      <path
        className="cls-2"
        d="m62.21,37.13c-.33.17-.28.49-.32.78-.02.15.04.4-.22.34-.19-.04-.12-.23-.09-.38.13-.63.12-1.27.02-1.9.02-.07.04-.13.06-.2.16-.05.12-.16.07-.27.03-.13.06-.26.09-.4.37-.13.39-.43.38-.74,0-.03.02-.06.04-.08.35,0,.69,0,.4.51-.05.08,0,.21,0,.32-.02.06-.05.13-.07.19-.48.05-.37.31-.2.59-.01.15-.02.3-.03.45-.03.05-.05.09-.08.14-.01.22-.03.44-.04.66Z"
      />
      <path
        className="cls-1"
        d="m64.58,44.44c.14.85.05,1.7.07,2.55.01.36.03.72.09,1.07.04.25.11.46.36.52.23.06.33-.13.44-.29.06-.08.11-.15.22-.16.14.4.28.85-.26,1.02-.56.17-.86-.11-.98-.78-.22-1.23-.06-2.48-.08-3.71,0-.07.1-.15.15-.22Z"
      />
      <path
        className="cls-1"
        d="m55.19,56.21c-.18-.09-.35-.28-.55-.06-.17.18-.12.39,0,.58.08.12.15.26.1.37-.44,1.05-.07,2.16-.2,3.23-.35-.29-.22-.7-.22-1.06.02-.95-.04-1.89-.03-2.83.01-.68-.19-1.41.13-2.09.22.28.06.6.12.9.06.28.13.51.48.48.02.17.28.25.17.47Z"
      />
      <path
        className="cls-2"
        d="m44.7,39.09c.26-.39.08-.8.07-1.21,0-.17-.04-.34-.06-.51-.02-.19.05-.35.25-.39.22-.04.13.19.2.27.22.27.27.56.21.9-.04.25.02.5.3.61,0,.1,0,.19,0,.29-.06.04-.16.06-.17.11-.13.53-.38.64-.8.26,0-.12,0-.23.01-.35Z"
      />
      <path
        className="cls-1"
        d="m29.77,53.21c-.18-.47-.27-.96-.44-1.43-.2-.54-.64-.87-.96-1.3-.06-.08-.28-.39-.5-.09-.4-.11-.75-.38-1.19-.37-.09,0-.21,0-.21-.13,0-.13.11-.21.22-.21.47,0,.96-.13,1.38.18,1.06.77,1.56,1.86,1.77,3.1.01.08-.05.18-.08.26Z"
      />
      <path
        className="cls-1"
        d="m50.44,40.01c-.26-.22-.02-.58-.2-.79-.37-.43-.65-.89-.81-1.45-.06-.22-.36-.31-.64-.2-.19.07-.36.22-.59.11.21-.4.74-.56,1.26-.35.35.14.69.29.79.74.14.65.44,1.27.19,1.95Z"
      />
      <path
        className="cls-1"
        d="m48.95,48.96c.05.05.09.14.15.16.72.22.46.86.49,1.31.03.63.28,1.2.36,1.81.01.1.07.17.16.22-.32.1-.46-.16-.51-.36-.26-.98-.48-1.96-.71-2.94-.02-.08,0-.15.07-.19Z"
      />
      <path
        className="cls-1"
        d="m57.35,41.71s.14.06.14.08c-.13.86-.27,1.72-.41,2.58-.48-.22-.21-.56-.15-.87.11-.55-.18-.88-.73-.82-.04-.2.14-.48-.21-.58.16-.2.42-.41.61-.19.47.57.56.04.76-.21Z"
      />
      <path
        className="cls-1"
        d="m60.45,47.78c.17.01.29.06.31.26.03.24.07.49.1.73.09.71.21.83.92.88.03.27.07.57-.33.59-.3.01-.7.06-.76-.33-.11-.7-.28-1.4-.24-2.12Z"
      />
      <path
        className="cls-1"
        d="m69.83,49.82c.15.21-.03.36-.12.51-.56.89-1.17,1.76-1.08,2.9.01.16-.01.33-.26.22,0-1.4.43-2.64,1.45-3.63Z"
      />
      <path
        className="cls-1"
        d="m68.41,56.04c.32-.71.61-1.42.74-2.2.05-.27,0-.52.04-.79.04-.25.07-.48.36-.55-.1.97-.34,1.92-.6,2.86-.09.3-.25.54-.54.68Z"
      />
      <path
        className="cls-1"
        d="m49.77,56.53c-.16-.75-.28-1.51-.14-2.3.26.67.54,1.33.43,2.07-.17-.03-.2.15-.29.22Z"
      />
      <path
        className="cls-2"
        d="m33.24,53.69c-.23.73-.02,1.54-.47,2.24,0-.92-.13-1.84.06-2.76.41-.04.45.21.41.52Z"
      />
      <path
        className="cls-1"
        d="m33.24,53.69c.04-.31,0-.57-.41-.52-.29-.83-.28-1.66.03-2.49.27.29.09.6.03.9-.06.36-.11.7.06,1.05.15.32.27.11.41,0,.05.36.18.74-.11,1.06Z"
      />
      <path
        className="cls-1"
        d="m50.31,58.94c-.22-.04-.27.26-.47.23-.15-.46.01-.92,0-1.37.15,0,.31,0,.46,0,.12.38.14.76,0,1.15Z"
      />
      <path
        className="cls-1"
        d="m32.85,45.17c.15.25.36.19.57.1-.02.31.25.62,0,.93-.3-.2-.44-.11-.46.24,0,.16.12.4-.18.46-.06-.58-.06-1.16.07-1.74Z"
      />
      <path
        className="cls-1"
        d="m69.66,51.71c-.11-.09-.11-.22-.03-.3.61-.66.85-1.55,1.43-2.23-.37.9-.68,1.83-1.39,2.53Z"
      />
      <path
        className="cls-1"
        d="m61.9,47.82c-.02-1.07-.15-2.15.08-3.22.17,1.04.08,2.08.05,3.12,0,.04-.08.07-.13.1Z"
      />
      <path
        className="cls-1"
        d="m31.25,56.88c-.62-.16-.65-.76-.86-1.21-.09-.19-.08-.44-.36-.43-.23,0-.43-.06-.37-.28.11-.36.27.12.42.02.03-.02.07-.03.1-.05.47.59.64,1.34,1.06,1.95Z"
      />
      <path
        className="cls-1"
        d="m54.45,50.11c.2.33.21.73.17,1.06-.06.49-.1.96-.01,1.44.03.17-.05.28-.19.37-.14-.96-.18-1.91.03-2.87Z"
      />
      <path
        className="cls-2"
        d="m32.73,40.37v-1.45c.06,0,.12,0,.18,0,.02.24.05.48.07.73,0,.17-.02.36.24.36.02.16.05.32.07.48-.15.15.04.63-.44.47-.15-.13-.13-.31-.11-.48.02-.02.05-.05.07-.07-.03,0-.05-.02-.08-.02h0Z"
      />
      <path
        className="cls-1"
        d="m61.99,43.22c-.17-.28-.05-.59-.07-.88-.05-.52.09-1.03-.03-1.55-.04-.16-.1-.39.17-.47.17.97.13,1.94-.07,2.9Z"
      />
      <path
        className="cls-2"
        d="m50.31,57.8c-.15,0-.31,0-.46,0-.26-.41-.01-.85-.08-1.27.1-.08.12-.25.29-.22.04.38.09.76.13,1.15-.02.07.01.11.08.14l.04.21Z"
      />
      <path
        className="cls-1"
        d="m72.87,54.67c.07.18.05.36.03.54,0,.12-.07.3.08.34.2.05.18-.18.27-.28.07.34.02.65-.18.94-.09-.15-.24-.16-.39-.14-.08-.49-.05-.96.18-1.41Z"
      />
      <path
        className="cls-1"
        d="m26.42,52.16c-.03.89.26,1.8-.15,2.67-.12-.89.04-1.78.05-2.67,0,0,.05,0,.05,0h.05Z"
      />
      <path
        className="cls-1"
        d="m49.13,40.79c.29.62-.22,1.32.16,1.94.05.08-.11.22-.24.26-.28-.68-.1-1.39-.09-2.08,0-.04.11-.08.17-.13Z"
      />
      <path
        className="cls-1"
        d="m49.52,65.7c.41.14.21.44.15.66-.1.37-.04.61.4.61,0,.19-.08.41-.26.32-.27-.14-.51-.43-.43-.77.07-.27.1-.55.14-.82Z"
      />
      <path
        className="cls-2"
        d="m26.23,55.08c.06.71-.11,1.42-.03,2.17-.29-.28-.29-1.18.03-2.17Z"
      />
      <path
        className="cls-1"
        d="m72.98,56.63c.01.29-.03.57-.12.84-.09.03-.19.06-.28.09-.08-.4-.18-.79.07-1.17.03.17.05.34.09.56.11-.14.18-.23.24-.32Z"
      />
      <path
        className="cls-1"
        d="m64.49,58.69c.18.38.39.21.6.03.07.09.05.19,0,.27-.12.17-.11.54-.41.42-.26-.11-.38-.41-.19-.71Z"
      />
      <path
        className="cls-1"
        d="m69.56,63.63c-.06.35-.08.71-.18,1.04-.06.2-.1.51-.45.49.28-.48.21-1.11.63-1.53Z"
      />
      <path
        className="cls-1"
        d="m34.81,59.18c.49-.32.95-.35,1.38.11-.46-.04-.94.16-1.38-.11Z"
      />
      <path
        className="cls-1"
        d="m29.3,62.39c-.44-.25-1.04-.37-.96-1.08.37.32.77.61.96,1.08Z"
      />
      <path
        className="cls-1"
        d="m32.75,59.09c.56-.33,1.07.05,1.61.1-.56.3-1.07-.04-1.61-.1Z"
      />
      <path
        className="cls-1"
        d="m65.78,57.41c.4-.51.95-.49,1.51-.42-.47.27-1.01.26-1.51.42Z"
      />
      <path
        className="cls-1"
        d="m68.39,66.36c0,.59-.37.94-.78,1.28.09-.53.43-.91.78-1.28Z"
      />
      <path
        className="cls-1"
        d="m72.76,58.46c-.03.25.05.67-.22.66-.33-.02-.09-.43-.14-.66-.03-.13,0-.27.14-.34.07.11-.04.35.22.34Z"
      />
      <path
        className="cls-1"
        d="m73.45,54.35c.03-.47-.05-.96.21-1.4.08.49.01.96-.21,1.4Z"
      />
      <path
        className="cls-1"
        d="m32.85,40.94c.48.16.29-.31.44-.47.14.26.16.53.04.8-.16,0-.31,0-.47,0,0-.11,0-.22,0-.33Z"
      />
      <path
        className="cls-1"
        d="m68.04,54.54c.05.37.15.76-.4.85.04-.33.1-.65.4-.85Z"
      />
      <path
        className="cls-1"
        d="m27.09,62.31c.5.16.46.63.58,1.02-.23-.32-.54-.59-.58-1.02Z"
      />
      <path
        className="cls-1"
        d="m69.48,47c-.41-.09-.33-.43-.36-.71-.03-.23.1-.35.33-.32-.13.35.13.68.03,1.03Z"
      />
      <path
        className="cls-1"
        d="m30.78,68.61c.38-.08.74.23,1.12.1-.28.38-.63.34-1.12-.1Z"
      />
      <path
        className="cls-1"
        d="m49.77,62.39c.17.38.14.76,0,1.14-.18-.38-.15-.76,0-1.14Z"
      />
      <path
        className="cls-2"
        d="m72.98,56.63c-.07.09-.13.17-.24.32-.03-.22-.06-.39-.09-.56.01-.11.03-.21.04-.32.15-.02.3-.01.39.14-.03.14-.07.28-.1.42Z"
      />
      <path
        className="cls-1"
        d="m49.78,60.85c-.03.36.35.72,0,1.07-.13-.36-.2-.72,0-1.07Z"
      />
      <path
        className="cls-2"
        d="m72.76,58.46c-.26,0-.15-.23-.22-.34.01-.18.02-.37.04-.55.09-.03.19-.06.28-.09-.03.33-.07.66-.1.99Z"
      />
      <path
        className="cls-1"
        d="m49.73,64.23c-.12.38.23.84-.22,1.16.1-.38-.17-.83.22-1.16Z"
      />
      <path
        className="cls-1"
        d="m28.07,50.78c.37.22.55.54.51.97-.24-.29-.46-.58-.51-.97Z"
      />
      <path
        className="cls-1"
        d="m73.61,51.14c-.15-.34-.13-.68-.04-1.03.24.33.18.68.04,1.03Z"
      />
      <path
        className="cls-1"
        d="m30.58,57.67c.28.18.63.29.67.7-.33-.14-.58-.34-.67-.7Z"
      />
      <path
        className="cls-1"
        d="m62.2,34.36c.01.32-.01.62-.38.74-.01-.32.01-.62.38-.74Z"
      />
      <path
        className="cls-1"
        d="m46.68,39.62c.24.32.11.52-.22.65-.18-.3-.09-.51.22-.65Z"
      />
      <path
        className="cls-1"
        d="m29.1,54.34c.49.12.22.45.19.71-.35-.16-.12-.47-.19-.71Z"
      />
      <path
        className="cls-1"
        d="m28.85,52.75c.22.17.28.36.09.59-.25-.16-.2-.37-.09-.59Z"
      />
      <path
        className="cls-2"
        d="m26.42,52.16h-.05s-.05,0-.05,0c0-.46,0-.92,0-1.38h-.01c.28.44.03.92.11,1.37Z"
      />
      <path
        className="cls-1"
        d="m69.39,42.22c-.23-.26-.31-.51.04-.74.05.25.1.5-.04.74Z"
      />
      <path
        className="cls-1"
        d="m62.37,35.88c-.17-.28-.28-.53.2-.59-.06.2,0,.44-.2.59Z"
      />
      <path
        className="cls-1"
        d="m67.64,55.39c-.02.27-.16.44-.44.47.08-.22.18-.42.44-.47Z"
      />
      <path
        className="cls-1"
        d="m65.13,58.51c-.08-.27-.03-.52.18-.72-.05.24.07.53-.18.72Z"
      />
      <path
        className="cls-1"
        d="m69.64,47.95c-.26-.18-.24-.38-.06-.6.18.18.11.39.06.6Z"
      />
      <path
        className="cls-1"
        d="m33.4,50.79c-.17-.19-.14-.38,0-.57.2.19.13.38,0,.57Z"
      />
      <path
        className="cls-1"
        d="m50.52,41.97c-.34-.16-.22-.37-.07-.58.24.17.11.38.07.58Z"
      />
      <path
        className="cls-1"
        d="m38.02,59.98c-.33-.08-.32-.34-.32-.59.23.13.3.35.32.59Z"
      />
      <path
        className="cls-1"
        d="m66.89,69.04c.1.04.2.09.3.13-.06.19-.19.22-.33.12-.11-.08-.11-.18.03-.25Z"
      />
      <path
        className="cls-1"
        d="m55.08,61.97c0-.18,0-.36-.01-.54.16.18.15.36.01.54Z"
      />
      <path
        className="cls-1"
        d="m64.68,42.25c.09.19.09.38-.01.57-.23-.19-.23-.38.01-.57Z"
      />
      <path
        className="cls-1"
        d="m69.51,43.48c-.23-.13-.26-.29-.07-.49.22.13.12.31.07.49Z"
      />
      <path
        className="cls-1"
        d="m48.87,38.95c.27.13.22.3.06.49-.16-.14-.14-.31-.06-.49Z"
      />
      <path
        className="cls-1"
        d="m57.42,41.04c.19.16.14.28-.07.37-.07-.14-.1-.27.07-.37Z"
      />
      <path
        className="cls-1"
        d="m67.85,56.64c.03-.18.15-.23.31-.24-.03.17-.14.26-.31.24Z"
      />
      <path
        className="cls-1"
        d="m50.42,40.7c-.11-.02-.23-.04-.21-.2.01-.12.11-.14.2-.15,0,.12,0,.23.01.35Z"
      />
      <path
        className="cls-1"
        d="m55.06,61.27c-.04-.14-.05-.27.07-.38.07.14.08.27-.07.38Z"
      />
      <path
        className="cls-1"
        d="m48.91,45.4c.16.1.17.21.04.34-.18-.09-.19-.21-.04-.34Z"
      />
      <path
        className="cls-1"
        d="m36.55,58.58c-.14.04-.28.1-.36-.08.17-.19.27-.09.36.08Z"
      />
      <path
        className="cls-1"
        d="m48.01,37.83c0,.25-.16.25-.34.23.03-.19.16-.26.34-.23Z"
      />
      <path
        className="cls-1"
        d="m68.18,56.38c-.04-.18.08-.26.21-.32,0,.15-.01.3-.21.32Z"
      />
      <path
        className="cls-1"
        d="m68.41,39.99c.03.17.07.34-.18.38-.08-.19,0-.31.18-.38Z"
      />
      <path
        className="cls-1"
        d="m49.05,44.71c.1,0,.2.02.18.15-.01.08-.1.1-.18.09,0-.08,0-.16,0-.24Z"
      />
      <path
        className="cls-1"
        d="m32.78,47.68c.21.02.23.11.09.25-.1-.06-.11-.15-.09-.25Z"
      />
      <path
        className="cls-1"
        d="m71.06,49.17c-.02-.16.06-.24.22-.22,0,.14-.11.18-.22.22Z"
      />
      <path
        className="cls-1"
        d="m50.08,66.86c-.03-.08-.04-.16.05-.22.25.13,0,.16-.05.22Z"
      />
      <path
        className="cls-1"
        d="m73.25,55.16c-.03-.11.05-.17.12-.23.12.16-.08.16-.12.23Z"
      />
      <path
        className="cls-1"
        d="m61.73,35.5c.05.11.09.21-.07.27-.17-.14-.08-.21.07-.27Z"
      />
      <path
        className="cls-1"
        d="m30.19,54.6c-.12-.04-.21-.11-.19-.26.12.05.25.08.19.26Z"
      />
      <path
        className="cls-1"
        d="m27.02,59.28c-.14.05-.24,0-.28-.14.18-.13.27-.06.28.14Z"
      />
      <path
        className="cls-1"
        d="m61.29,40.01s.11.06.11.09c0,.09-.07.12-.15.14-.08-.09-.08-.17.03-.23Z"
      />
      <path
        className="cls-1"
        d="m69.58,52.29c-.02-.09-.02-.17.06-.23.2.13-.02.16-.06.23Z"
      />
      <path
        className="cls-1"
        d="m55.92,43.33c-.02-.08-.03-.15.04-.21.25.12-.01.14-.04.21Z"
      />
      <path
        className="cls-1"
        d="m65.79,47.7c-.15-.14-.07-.2.07-.25.06.11.05.2-.07.25Z"
      />
      <path
        className="cls-1"
        d="m64.69,42.95c.08.15.04.25-.12.3-.08-.15-.02-.24.12-.3Z"
      />
      <path
        className="cls-1"
        d="m41.61,33.62c-.15-.08-.22-.17,0-.26.12.08.09.17,0,.26Z"
      />
      <path
        className="cls-1"
        d="m70.09,49.38c.09.2,0,.26-.2.24,0-.14.07-.21.2-.24Z"
      />
      <path
        className="cls-1"
        d="m30.47,64.32c-.07-.02-.16-.02-.19-.06-.04-.07,0-.13.09-.15.11.04.12.12.1.21Z"
      />
      <path
        className="cls-1"
        d="m55.19,58.14c-.07-.08-.07-.15.01-.22.09.08.1.15-.01.22Z"
      />
      <path
        className="cls-1"
        d="m61.23,40.88c.07.08.05.13-.05.16-.13-.1,0-.12.05-.16Z"
      />
      <path
        className="cls-1"
        d="m32.73,40.37s.05.02.08.02c-.02.02-.05.05-.07.07-.03-.03-.03-.06,0-.1Z"
      />
      <path
        className="cls-2"
        d="m26.33,50.79s-.03-.01-.04-.02c0,0,0-.02,0-.03,0,.02.02.04.02.06,0,0,.01,0,.01,0Z"
      />
      <path
        className="cls-1"
        d="m33.35,51.5c-.04-.08,0-.12.06-.15-.02.05-.04.1-.06.15Z"
      />
      <path
        className="cls-1"
        d="m50.27,57.58c-.07-.02-.09-.07-.08-.14.03.05.05.09.08.14Z"
      />
      <path
        className="cls-1"
        d="m62.25,36.47s.05-.09.08-.14c.04.08,0,.12-.08.14Z"
      />
      <path
        className="cls-1"
        d="m40.76,46.4c-.17-.05-.21-.17-.21-.31,0-.17.07-.32.26-.3.12.01.19.14.17.26-.02.15-.05.3-.22.35Z"
      />
      <path
        className="cls-2"
        d="m37.34,45.98s.01-.02.02-.03c0,.01-.02.02-.02.03,0,0,0,0,0,0Z"
      />
      <path
        className="cls-2"
        d="m45.59,42.19c-.03.25-.05.46-.09.66-.02.14.04.36-.18.35-.23,0-.35-.24-.29-.4.1-.26,0-.48-.01-.72,0-.17-.09-.43.19-.46.25-.03.27.21.33.39.02.07.05.14.06.17Z"
      />
      <path
        className="cls-2"
        d="m72.34,48.52c-.04-.07-.09-.11-.09-.14,0-.03.06-.06.11-.07.01,0,.06.05.06.07,0,.04-.04.08-.08.14Z"
      />
    </Icon>
  );
}

export function IconDryCleanOnly({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="19 27 61 48"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #232323; }`}
          {`.cls-2 { fill: #828282; }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m23.39,65.45c.68-.53,1.4-1.01,2.03-1.61.54-.17,1.04-.39,1.41-.87.15-.19.34-.38.62-.38.16,0,.29-.1.33-.2.18-.38.51-.61.83-.82.56-.37.94-.99,1.67-1.12.31-.05.66-.16.56-.64-.03-.13.12-.23.21-.33.11-.12.27-.22.2-.42,0,0,0,0,0,0,.17.04.32.05.31-.2.36-.35.72-.7,1.07-1.05.21.08.24-.06.27-.21.02-.02.05-.04.08-.05.8-.31,1.4-.85,1.9-1.53.03-.03.07-.07.1-.1.34-.07.55-.31.72-.59.03-.04.06-.07.09-.11.14.02.26,0,.37-.1.31-.3.66-.57.93-.91.15-.18.43-.13.48-.3.25-.76,1.02-1.03,1.45-1.63.5-.71,1.3-1.16,1.77-1.91.09-.14.16-.3.26-.43.16-.22.38-.17.59-.07.27.13.09.31.02.46-.13.29-.29.56-.26.89-.06.08-.11.17-.17.25-.65.38-1.02,1.02-1.39,1.62-.19.31-.32.64-.61.87-.36.29-.56.6-.31,1.06,0,.03-.01.06-.02.08-.5.02-.78.42-1.15.66-.25.16.05.45-.02.69,0,0,0,0,0,0-.47-.09-.48.26-.53.56h0c-.31,0-.64.06-.83.28-.58.67-1.45,1-2.02,1.7-.19.23-.42.54-.65.65-.33.15-.68.26-.93.53-.36.38-.85.65-.99,1.21-.07.07-.13.14-.2.21-.41-.15-.67.08-.9.37-.09.12-.14.26-.28.35-.5.32-1,.63-1.46,1.03-1,.88-2.1,1.66-3.14,2.5-.47.39-1.02.64-1.47,1.12-.41.43-.91.8-1.31,1.29-.19.23-.4.4-.4.72l-.11.1c-.62.24-1,.7-1.2,1.32-.33.43-.45.97-.76,1.41-.27.38.18,1.31.65,1.49.15.06.26.2.41.26.13.05.29.04.44.06-.31.47-.71.59-1.29.39-.15-.29-.37-.53-.63-.69-.61-.36-.83-.95-.54-1.58q.05-.1-.06-.26c-.07-.12-.05-.25-.02-.37.13,0,.15-.09.2-.19.32-.67.44-1.43.94-2.02.36-.43.63-.92.89-1.41.14-.26.37-.52.67-.65.63-.27,1.04-.72,1.19-1.4Z"
      />
      <path
        className="cls-1"
        d="m42.3,44.93s-.05-.03-.07-.04c.02-.27-.28-.41-.29-.66,0-.26-.19-.27-.38-.28-.08-.13-.16-.26-.24-.39.14-.06.13-.19.11-.29-.16-.76-.67-1.41-.74-2.2,0-.01-.06-.02-.09-.03-.03-.32-.43-.45-.39-.81.3-.27-.03-.48-.07-.71-.13-.71-.54-1.38-.42-2.13.06-.4-.11-.85.14-1.18.35-.46.39-1.1.88-1.48.06-.05.07-.15.03-.23-.07-.15.01-.26.12-.35.41-.34.52-.82.63-1.3.05-.22.07-.51.21-.65.23-.22.23-.43.18-.68-.07-.33.04-.63.12-.93.06-.21.1-.42.1-.64,0-.12.02-.29-.13-.27-.41.04-.42-.32-.54-.54-.09-.17-.13-.35-.37-.33-.04-.04-.07-.08-.11-.12-.19-.52-.77-.8-1.55-.75-1.23-.3-2.44-.32-3.63.21-.11-.06-.19-.03-.24.09-.09.04-.17.08-.26.12-.38-.03-.71.03-.84.45-.12.06-.24.12-.35.18-.16-.11-.42.15-.54-.14.27-.4.64-.67,1.08-.85.53.24.8.13.93-.37,0,0,0,0,0,0,.63.09.9-.4,1.24-.77.56-.16,1.13-.1,1.7-.13.01.1.09.16.17.13.54-.19,1.08-.06,1.62,0,.11.05.22.1.33.14.05.04.09.1.15.12q.61.24.35.83c.14,0,.28,0,.41,0,.33-.02.59.18.87.29.25.1.03.36.04.54,0,.13.09.22.24.29.57.28.8,1.03.52,1.63-.06.13-.1.4.01.37.33-.08.25.14.23.27-.08.42.03.83,0,1.24.05.28-.22.43-.26.68-.27.07-.32.32-.4.53-.12.33-.16.68-.36.98-.24.36-.32.76-.23,1.19-.12.6-.13,1.17.17,1.75.36.7.43,1.51.78,2.22.07.25-.05.56.22.75.03.09.05.17.08.26.19.66.36,1.33.7,1.93.05.32.14.65.02.97-.28.14-.16.43-.25.65-.1.23-.22.45-.48.34-.33-.14-.46.05-.6.26-.03,0-.06.01-.08.02-.04,0-.09,0-.13,0,0,0,0,0,0,0-.01-.26-.17-.22-.33-.15Zm-2.83-17.24l.02-.03h-.03s.01.03.01.03Z"
      />
      <path
        className="cls-1"
        d="m79.45,48.55c-.32-.01-.4-.21-.41-.5,0-.46.05-.92-.08-1.37-.05-.44-.08-.87-.05-1.32.02-.21-.04-.57-.3-.56-.36,0-.66-.18-1.01-.16-.03-.01-.05-.03-.08-.05-.02-.05-.02-.12-.06-.15-.05-.04-.11-.02-.12.06-.4-.23-.84-.36-1.31-.35-.36-.31-.83-.48-1.24-.58-.77-.18-1.57-.29-2.37-.21-.23.02-.49,0-.65.37.25-.07.44-.12.62-.16.08-.02.17,0,.2.1.02.08-.02.16-.07.16-.4,0-.65.38-1.05.4-.31.02-.64,0-.94.06-.7.15-1.37.41-2.09.43-.4.01-.86.41-1.22-.13-.04-.06-.19-.06-.28,0-.07.05-.05.12-.01.18.32.45-.08.38-.3.38-.44,0-.85.04-1.2.34-.28-.04-.52,0-.78.17-.24.15-.52.28-.83.18-.52-.24-1.03.03-1.54.04-.05,0-.11,0-.16.01-.29,0-.62-.23-.85.13-.9.07-1.81.14-2.71.2-.53-.1-1.05-.08-1.52.22h-.05s-.05,0-.05,0c-.06-.14-.13-.13-.2,0-1.15,0-2.3,0-3.45.03-.77.02-1.51-.16-2.25-.32-1.04-.23-2.09-.35-3.13-.58-.37-.08-.51-.58-.95-.45-.3-.23-.07-.57-.19-.84.95,0,1.89.02,2.84.03.27,0,.52.07.76.19,1.12.14,2.19.56,3.36.45,1.26-.13,2.54-.14,3.81-.21.34-.02.67-.27,1.02-.16.25.08.47.08.73.02.26-.06.54-.03.8-.08.39-.07.13.38.31.39.6.03,1.2,0,1.8,0,0-.04,0-.08,0-.13-.31-.02-.68.25-.94-.21.78-.09,1.53.07,2.24-.13.66-.19,1.33.04,1.98-.15.76-.23,1.53-.44,2.34-.45.21,0,.44-.02.53-.29.29-.02.58-.03.87-.05.33-.05.65-.09,1-.14-.05.27-.39.09-.39.38.42.17.78-.08,1.15-.18.13-.03.4.01.39-.12-.04-.6.45-.4.71-.53.29-.15.68.08.92-.25.09-.01.19-.02.28-.03.16.17.33.09.51.04.13-.04.29-.1.37.04.2.33.53.26.83.31.57.11,1.07-.33,1.66-.18.24.06.51.19.78.08.15-.03.28.03.39.11q-.02.66.68.6c.37-.03.81.25.72.51-.15.42.11.53.38.68.11.06.26.15.29.26.26.77.58,1.55.09,2.36-.21.35-.39.73-.58,1.1Zm-3.02-5.51c-.21-.03-.31.09-.36.27-.06.25.16.2.28.24.14.05.28.13.42.16.18.04.41.1.5-.09.11-.23-.14-.3-.29-.39-.17-.1-.34-.22-.56-.19Zm-10,1.58c-.23-.05-.42-.13-.6.06-.02.02,0,.12,0,.12.22.08.4,0,.59-.19Z"
      />
      <path
        className="cls-1"
        d="m50.73,64.35c-.1.1-.21.2-.31.29-.39.05-.74.19-1.04.45-.39.12-.74.41-1.18.36-.39-.02-.74.08-1.04.32-.06.02-.12.03-.17.05-.04-.02-.09-.07-.12-.06-1.05.33-2.13.53-3.22.7-.08.01-.19.04-.23.1-.24.35-.62.34-.98.39h0c.21-.38.6-.57.94-.8.26-.17.52-.33.67-.61.24-.03.47-.05.71-.08.14.19.3.07.44.01.87-.39,1.68-.93,2.62-1.17.08-.02.09-.09.07-.16,0,0,0,0,0,0,.65-.12,1.17-.53,1.77-.77.15-.06.18-.18.15-.33.52-.13,1.04-.25,1.51-.52.21.04.33-.12.48-.21.32-.21.58-.49.95-.64,1.47-.57,2.81-1.43,4.28-2.02.26-.1.58-.18.74-.46.03-.04.07-.07.1-.11.29.14.47-.12.68-.21.88-.37,1.77-.73,2.54-1.31.57-.27,1.19-.44,1.72-.81.63-.25,1.31-.38,1.85-.84.08-.03.17-.06.25-.09.6.16,1.09-.15,1.59-.4.4-.2.79-.59,1.15-.64.62-.08,1.07-.35,1.52-.73.25.39-.29.47-.23.76-.38.27-.76.53-1.14.8-1.01.43-1.94,1.01-2.88,1.56-.45.26-.96.46-1.32.87-.26.09-.46.28-.68.43-.14-.02-.26.01-.39.06-.77.27-1.33.95-2.18,1.07-.16.02-.2.21-.17.37,0,0,0,0,0,0-.65.06-1.2.42-1.79.65-.1.04-.13.14-.14.25-.34.05-.52.43-.89.43-.45.06-.92.06-1.21.5-.04.03-.08.05-.12.08-.08,0-.19-.01-.24.03-.39.36-.86.54-1.38.62-.12.02-.26.14-.29.31-.29-.05-.28.32-.5.37-.22-.05-.42,0-.62.09-.58.27-1.14.58-1.79.68-.21.03-.41.13-.5.35Z"
      />
      <path
        className="cls-2"
        d="m68.96,54.82c-.06-.29.48-.37.23-.76-.45.39-.9.65-1.52.73-.36.05-.75.44-1.15.64-.5.25-.99.56-1.59.4.5-.26.95-.61,1.5-.73.24-.05.41-.14.61-.28.76-.53,1.57-.98,2.45-1.3.6-.22,1.16-.57,1.72-.9.85-.51,1.78-.85,2.67-1.28.53-.26,1.05-.52,1.58-.77.2-.09.4-.26.68-.08-.64.55-1.32.98-2.06,1.3-.79.34-1.48.87-2.25,1.23-.88.41-1.72.83-2.38,1.56-.12.13-.27.26-.48.23Z"
      />
      <path
        className="cls-2"
        d="m68.39,43.58c-.08.27-.32.28-.53.29-.81,0-1.58.22-2.34.45-.65.2-1.32-.04-1.98.15-.71.2-1.46.04-2.24.13.26.46.64.19.94.21,0,.04,0,.08,0,.13-.6,0-1.2.02-1.8,0-.18,0,.08-.46-.31-.39-.26.05-.54.02-.8.08-.25.06-.47.06-.73-.02-.35-.11-.68.13-1.02.16-1.27.08-2.55.09-3.81.21-1.17.12-2.24-.31-3.36-.45.43-.39.96-.22,1.36-.07.68.25,1.33.13,2,.13.56,0,1.13-.06,1.68.03.82.14,1.58-.17,2.37-.22.99-.06,1.99-.05,2.97-.11.7-.04,1.42.06,2.13-.05.52-.08,1.1-.04,1.61-.2.96-.29,1.98-.18,2.95-.45.29-.08.61.06.91-.02Z"
      />
      <path
        className="cls-2"
        d="m41.08,28.79c.24-.02.28.16.37.33.12.22.13.58.54.54.15-.01.14.16.13.27,0,.22-.04.43-.1.64-.08.3-.19.61-.12.93.05.25.05.46-.18.68-.14.14-.16.42-.21.65-.11.48-.22.97-.63,1.3-.11.09-.19.19-.12.35.04.09.03.18-.03.23-.49.38-.53,1.02-.88,1.48-.25.33-.08.79-.14,1.18-.12.75.3,1.41.42,2.13.04.23.37.45.07.71-.29-.14-.36-.43-.39-.7-.06-.57-.27-1.09-.43-1.63-.19-.62-.06-1.24.04-1.88.2-1.26,1.07-2.15,1.61-3.22.24-.48.35-.98.36-1.52,0-.26-.06-.5.15-.79.22-.29-.11-.68-.23-1.02-.08-.22-.31-.39-.24-.67Z"
      />
      <path
        className="cls-2"
        d="m41.39,51.25c-.03-.33.13-.6.26-.89.07-.15.24-.33-.02-.46-.21-.1-.42-.15-.59.07-.1.13-.17.29-.26.43-.48.75-1.27,1.2-1.77,1.91-.43.6-1.2.87-1.45,1.63-.05.17-.34.11-.48.3-.27.34-.62.6-.93.91-.11.11-.23.12-.37.1-.07-.44.32-.61.55-.83.54-.52,1.14-1.01,1.61-1.57.4-.47.88-.86,1.28-1.34.35-.43.74-.86,1.13-1.28.65-.71,1.29-1.41,1.68-2.3.06-.14.12-.36.34-.31.15.04.1.22.06.3-.4.98-.32,2.08-.81,3.03-.06.11-.06.27-.23.3Z"
      />
      <path
        className="cls-2"
        d="m65.45,45.49c.35-.3.76-.34,1.2-.34.22,0,.62.07.3-.38-.04-.06-.06-.13.01-.18.09-.06.24-.06.28,0,.36.53.82.14,1.22.13.72-.02,1.39-.28,2.09-.43.3-.06.62-.05.94-.06.4-.02.65-.39,1.05-.4.05,0,.1-.09.07-.16-.03-.1-.12-.12-.2-.1-.19.04-.37.09-.62.16.15-.37.42-.34.65-.37.8-.08,1.61.03,2.37.21.42.1.88.27,1.24.58-.31.12-.58-.1-.87-.13-.96-.1-1.88.09-2.82.28-.95.19-1.88.44-2.84.58-.87.13-1.73.32-2.59.51-.45.1-.97.32-1.47.09Z"
      />
      <path
        className="cls-2"
        d="m22.6,68.99c0-.32.22-.49.4-.72.4-.49.9-.86,1.31-1.29.45-.47,1-.73,1.47-1.12,1.04-.84,2.14-1.62,3.14-2.5.46-.4.96-.71,1.46-1.03.14-.09.19-.23.28-.35.23-.29.49-.51.9-.37-.28.44-.69.76-1.1,1.06-.94.69-1.78,1.5-2.74,2.15-.8.55-1.58,1.13-2.39,1.68-.73.49-1.36,1.15-2,1.77-.24.24-.48.49-.75.7Z"
      />
      <path
        className="cls-1"
        d="m40.26,67.12c.3-.43.77-.22,1.16-.29.34.04.69.08,1.03.12,0,0,0,0,0,0-.07.1-.14.19-.21.29-.1.12-.24.14-.38.13-.34.03-.67.13-1.02.15-.2,0-.45.02-.65.2-.27.23-.57.52-.97.2-.03-.02-.13,0-.13,0-.12.55-.69.44-1,.69-.39.16-.76.37-1.19.46-.15-.19-.17-.03-.22.07l-.19.06c-.19-.17-.28-.34.06-.43.23-.06.39-.17.45-.4.65-.42,1.39-.66,2.11-.93.44.09.8-.11,1.14-.33Z"
      />
      <path
        className="cls-2"
        d="m31.24,59.08c.07.21-.09.3-.2.42-.09.1-.24.19-.21.33.1.48-.25.58-.56.64-.73.12-1.11.75-1.67,1.12-.32.21-.65.44-.83.82-.04.09-.17.2-.33.2-.28,0-.47.18-.62.38-.36.47-.86.7-1.41.87-.06-.4.38-.54.54-.63.75-.43,1.16-1.2,1.86-1.67.51-.34.97-.75,1.53-1.04.42-.21.73-.59,1.12-.87.26-.19.55-.34.79-.55Z"
      />
      <path
        className="cls-2"
        d="m33.56,28.81c.12.29.37.03.54.14-.23.29-.62.31-.9.57-.65.6-1.08,1.3-1.35,2.13-.43-.2-.39.17-.46.39-.1.3.09.32.31.29.2.33-.06.62-.06.94-.28.05-.29.25-.25.47.04.26.23.06.34.11.18.31-.05.66.11.98.01.03-.03.12-.05.12-.06,0-.13-.01-.19-.04-.16-.07-.21-.28-.2-.38.02-.62-.2-1.2-.22-1.83-.02-.88.29-1.53.69-2.23.13-.23.23-.52.37-.78.3-.51.86-.61,1.32-.88Z"
      />
      <path
        className="cls-2"
        d="m24.09,73.82c.09-.32.41-.38.64-.51,1.38-.77,2.88-1.22,4.4-1.65.54-.15,1.03-.49,1.55-.74.28-.13.52-.36.86-.34.02.15-.06.19-.19.22-.35.08-.02.18,0,.27-1.35.6-2.73,1.09-4.13,1.57-.87.3-1.71.66-2.57.98-.19.07-.38.13-.57.19h0Z"
      />
      <path
        className="cls-2"
        d="m43.46,32.55c.02-.41-.09-.83,0-1.24.02-.13.1-.34-.23-.27-.11.03-.07-.24-.01-.37.28-.6.05-1.36-.52-1.63-.14-.07-.23-.17-.24-.29-.01-.19.2-.44-.04-.54-.28-.11-.54-.31-.87-.29-.13,0-.27,0-.41,0q.26-.59-.35-.83c-.06-.02-.1-.08-.15-.12.03-.13.13-.14.23-.12,1.18.22,1.95.86,2.4,2.01.42,1.09.36,2.19.39,3.3,0,.17.02.35-.2.4Z"
      />
      <path
        className="cls-2"
        d="m79.45,48.55c.19-.37.36-.75.58-1.1.49-.81.16-1.58-.09-2.36-.04-.11-.18-.19-.29-.26-.27-.15-.53-.26-.38-.68.09-.26-.35-.54-.72-.51q-.7.06-.68-.6c.95.04,1.74.47,2.19,1.27.49.87.75,1.84.32,2.87-.18.43-.31.88-.63,1.24-.08.09-.14.2-.28.13Z"
      />
      <path
        className="cls-2"
        d="m37.01,68.38c-.06.23-.23.34-.45.4-.34.09-.25.26-.06.43-.93.4-1.86.78-2.84,1.05.07-.21-.23-.26-.18-.45.14-.43.61-.39.9-.5.87-.33,1.7-.79,2.64-.92Z"
      />
      <path
        className="cls-2"
        d="m31.77,61.42c.14-.56.64-.83.99-1.21.26-.27.6-.38.93-.53.23-.11.46-.41.65-.65.57-.7,1.43-1.03,2.02-1.7.19-.22.52-.29.83-.28-.29.49-.85.67-1.21,1.08-.48.55-1.14.88-1.71,1.33-.76.6-1.49,1.23-2.24,1.84-.08.06-.15.14-.26.11Z"
      />
      <path
        className="cls-2"
        d="m23.39,65.45c-.15.68-.56,1.13-1.19,1.4-.3.13-.54.39-.67.65-.26.5-.53.99-.89,1.41-.5.59-.62,1.35-.94,2.02-.04.09-.07.19-.2.19-.08-.08-.12-.19-.06-.27.44-.65.31-1.53.87-2.14.76-.83,1.27-1.88,2.21-2.55.16-.11.26-.3.41-.43.13-.12.19-.39.47-.27Z"
      />
      <path
        className="cls-2"
        d="m57.79,59.2c-.17.28-.49.35-.74.46-1.47.59-2.8,1.45-4.28,2.02-.36.14-.63.43-.95.64-.15.1-.27.25-.48.21-.03-.12,0-.21.11-.3.67-.55,1.41-.95,2.24-1.24.49-.17.93-.5,1.38-.79.73-.46,1.6-.56,2.34-1.01.11-.07.26-.05.39,0Z"
      />
      <path
        className="cls-2"
        d="m73.04,42.67c-.24.33-.62.1-.92.25-.27.14-.76-.06-.71.53.01.14-.26.09-.39.12-.37.1-.73.35-1.15.18,0-.29.35-.11.39-.38-.34.05-.67.09-1,.14.18-.36.59-.49.89-.56.77-.16,1.53-.46,2.34-.33.18.03.36.02.54.03Z"
      />
      <path
        className="cls-2"
        d="m77.46,42.94c-.27.12-.54-.01-.78-.08-.59-.16-1.09.28-1.66.18-.3-.06-.63.02-.83-.31-.08-.13-.24-.07-.37-.04-.17.05-.35.13-.51-.04.13-.33.42-.34.7-.32,1.01.07,2.02.15,3.01.35.16.03.39.02.44.27Z"
      />
      <path
        className="cls-2"
        d="m38.92,55.06c-.25-.46-.06-.77.31-1.06.28-.23.42-.57.61-.87.37-.6.74-1.24,1.39-1.62-.05.47-.33.86-.66,1.12-.5.39-.52,1-.85,1.45-.2.28-.44.54-.53.89-.03.11-.17.07-.27.08Z"
      />
      <path
        className="cls-2"
        d="m63.62,58.06c.35-.42.87-.61,1.32-.87.94-.55,1.87-1.13,2.88-1.56.03.52-.48.5-.74.66-.95.6-1.95,1.11-2.94,1.65-.16.09-.33.16-.52.12Z"
      />
      <path
        className="cls-2"
        d="m42.24,67.24c.07-.1.14-.19.21-.29.36-.05.74-.04.98-.39.04-.06.15-.09.23-.1,1.09-.17,2.16-.37,3.22-.7.03,0,.08.04.12.06-.17.36-.59.34-.85.39-.96.18-1.87.49-2.81.73-.36.09-.66.41-1.08.3Z"
      />
      <path
        className="cls-1"
        d="m33.47,69.81c-.04.19.26.24.18.45-.78.23-1.5.65-2.31.82,0-.09-.34-.2,0-.27.13-.03.21-.07.19-.22.07-.12.21-.05.3-.1.2-.04.47.03.52-.29.07-.03.14-.07.21-.1.25.02.49,0,.62-.27.09,0,.19-.01.28-.02Z"
      />
      <path
        className="cls-2"
        d="m38.08,68.62c.32-.26.88-.14,1-.69,0-.01.1-.03.13,0,.4.32.7.04.97-.2.2-.18.45-.19.65-.2.35-.02.68-.12,1.02-.15-.32.38-.79.41-1.22.55-.69.22-1.38.44-2.07.65-.15.05-.31.14-.48.04Z"
      />
      <path
        className="cls-2"
        d="m42.45,66.96c-.34-.04-.69-.08-1.03-.12.08-.3.38-.35.6-.45.66-.33,1.31-.7,2.05-.83-.15.28-.41.43-.67.61-.34.23-.73.42-.94.8Z"
      />
      <path
        className="cls-2"
        d="m77.61,44.64c.35-.02.65.17,1.01.16.26,0,.31.35.3.56-.03.45,0,.88.05,1.32-.24,0-.23-.23-.27-.36-.2-.62-.38-1.23-1.03-1.55-.03-.02-.03-.09-.05-.14Z"
      />
      <path
        className="cls-2"
        d="m47.91,64.15c.01.07,0,.14-.07.16-.94.25-1.75.78-2.62,1.17-.14.06-.3.18-.44-.01-.02-.23.14-.34.31-.4.87-.32,1.75-.62,2.63-.93.06-.02.13,0,.19,0Z"
      />
      <path
        className="cls-2"
        d="m42.22,35.93c-.09-.43-.02-.82.23-1.19.2-.3.25-.65.36-.98.08-.22.12-.46.4-.53.09.14.17.29.08.46-.36.75-.71,1.49-1.07,2.24Z"
      />
      <path
        className="cls-2"
        d="m19.51,71.49q.11.16.06.26c-.29.63-.07,1.22.54,1.58.27.16.48.4.63.69-1-.24-1.69-1.31-1.52-2.33.02-.14.12-.24.28-.2Z"
      />
      <path
        className="cls-2"
        d="m61.11,57.57c-.77.58-1.67.94-2.54,1.31-.21.09-.39.35-.68.21.22-.45.7-.54,1.08-.68.49-.18.95-.38,1.39-.66.23-.15.47-.25.75-.18Z"
      />
      <path
        className="cls-2"
        d="m34.87,56.05c-.5.68-1.1,1.22-1.9,1.53,0-.05-.02-.12,0-.14.55-.57,1.07-1.19,1.9-1.39Z"
      />
      <path
        className="cls-2"
        d="m40.6,41.03s.09.01.09.03c.07.79.58,1.44.74,2.2.02.11.03.24-.11.29-.26-.61-.55-1.21-.77-1.83-.07-.2-.15-.48.06-.69Z"
      />
      <path
        className="cls-2"
        d="m37.74,56.49c.07-.23-.23-.52.02-.69.37-.24.65-.64,1.15-.66-.21.6-.69.98-1.17,1.35Z"
      />
      <path
        className="cls-2"
        d="m50.73,64.35c.09-.22.29-.32.5-.35.65-.1,1.21-.41,1.79-.68.2-.09.4-.14.62-.09-.17.32-.54.28-.8.44-.56.33-1.17.52-1.78.69-.11.03-.23.05-.34,0Z"
      />
      <path
        className="cls-2"
        d="m60.2,59.99c-.03-.16.01-.35.17-.37.84-.12,1.41-.8,2.18-1.07.13-.05.25-.07.39-.06-.59.41-1.2.79-1.85,1.08-.3.13-.6.25-.88.41Z"
      />
      <path
        className="cls-2"
        d="m42.85,45.06c.15-.21.27-.4.6-.26.26.11.39-.11.48-.34.09-.21-.03-.51.25-.65.16.46-.09.85-.26,1.23-.05.12-.25.28-.36.18-.22-.2-.49-.04-.71-.17Z"
      />
      <path
        className="cls-2"
        d="m49.83,63.05c.03.15,0,.27-.15.33-.59.24-1.12.65-1.77.77-.01-.33.28-.38.48-.48.47-.23.95-.41,1.43-.61Z"
      />
      <path
        className="cls-2"
        d="m44.17,42.84c-.34-.6-.51-1.27-.7-1.93.05,0,.13,0,.14.02.37.58.63,1.2.56,1.91Z"
      />
      <path
        className="cls-2"
        d="m54.15,62.86c.03-.17.16-.29.29-.31.52-.08.98-.26,1.38-.62.05-.04.16-.02.24-.03-.11.25-.3.42-.54.53-.37.17-.74.33-1.11.49-.09.04-.19.07-.25-.06Z"
      />
      <path
        className="cls-2"
        d="m64.67,55.93c-.54.46-1.22.59-1.85.84.02-.31.3-.32.48-.41.44-.2.86-.45,1.36-.43Z"
      />
      <path
        className="cls-2"
        d="m58.28,60.89c0-.11.04-.21.14-.25.59-.23,1.14-.59,1.79-.65-.57.44-1.24.68-1.92.9Z"
      />
      <path
        className="cls-2"
        d="m21.29,70.41c.2-.62.58-1.08,1.2-1.32-.37.47-.69.98-1.2,1.32Z"
      />
      <path
        className="cls-2"
        d="m36.81,26.82c-.34.38-.61.86-1.24.77.25-.52.73-.66,1.24-.77Z"
      />
      <path
        className="cls-2"
        d="m39.42,27.91c.78-.05,1.36.23,1.55.75-.49-.31-1.08-.41-1.55-.75Z"
      />
      <path
        className="cls-2"
        d="m40.3,26.82c-.54-.05-1.08-.18-1.62,0-.08.03-.16-.03-.17-.13.55-.23,1.1-.24,1.66-.06.1.03.12.1.13.18Z"
      />
      <path
        className="cls-2"
        d="m46.81,44.3c.11.27-.12.61.19.84-.24.02-.48-.02-.6-.24-.1-.19.05-.38.12-.55.05-.12.17-.13.29-.05Z"
      />
      <path
        className="cls-2"
        d="m62.31,45.88c.51-.01,1.02-.28,1.54-.04-.42.29-1.23.31-1.54.04Z"
      />
      <path
        className="cls-2"
        d="m57.07,46.46c.47-.3.99-.32,1.52-.22-.5.14-.99.28-1.52.22Z"
      />
      <path
        className="cls-1"
        d="m31.71,32.33c-.22.03-.41.01-.31-.29.07-.22.03-.59.46-.39-.17.2-.08.46-.15.68Z"
      />
      <path
        className="cls-2"
        d="m35.57,27.59c-.13.5-.4.61-.93.37.24-.29.57-.37.93-.37Z"
      />
      <path
        className="cls-2"
        d="m40.26,67.12c-.35.22-.71.42-1.14.33.34-.27.69-.47,1.14-.33Z"
      />
      <path
        className="cls-2"
        d="m56.17,61.82c.29-.44.76-.44,1.21-.5-.34.31-.77.43-1.21.5Z"
      />
      <path
        className="cls-2"
        d="m41.55,43.94c.19,0,.37.01.38.28,0,.26.3.39.29.66-.55-.08-.44-.63-.67-.94Z"
      />
      <path
        className="cls-2"
        d="m49.38,65.09c.3-.26.65-.4,1.04-.45-.27.33-.61.49-1.04.45Z"
      />
      <path
        className="cls-2"
        d="m47.16,65.77c.3-.25.65-.35,1.04-.32-.32.21-.61.5-1.04.32Z"
      />
      <path
        className="cls-1"
        d="m31.73,33.85c-.11-.06-.3.15-.34-.11-.04-.23-.03-.42.25-.47.07.19-.07.41.09.58Z"
      />
      <path
        className="cls-2"
        d="m34.45,28.77c.14-.42.47-.48.84-.45-.23.25-.56.3-.84.45Z"
      />
      <path
        className="cls-2"
        d="m35.69,55.35c-.17.28-.37.52-.72.59.12-.35.29-.62.72-.59Z"
      />
      <path
        className="cls-2"
        d="m61.3,46.03c.23-.36.56-.13.85-.13-.24.3-.57.04-.85.13Z"
      />
      <path
        className="cls-2"
        d="m37.19,57.06c.06-.3.07-.65.53-.56-.14.22-.25.48-.53.56Z"
      />
      <path
        className="cls-2"
        d="m43.39,40.66c-.27-.19-.15-.5-.22-.75.36.17.31.45.22.75Z"
      />
      <path
        className="cls-2"
        d="m33.19,69.82c-.14.26-.37.29-.62.27.16-.2.37-.29.62-.27Z"
      />
      <path
        className="cls-2"
        d="m32.36,70.19c-.05.32-.31.25-.52.29.07-.27.31-.25.52-.29Z"
      />
      <path
        className="cls-2"
        d="m31.55,58.88c.01.25-.14.23-.31.2-.03-.28.15-.22.31-.2Z"
      />
      <path
        className="cls-2"
        d="m42.3,44.93c.17-.07.32-.11.33.15-.14.02-.3.06-.33-.15Z"
      />
      <path
        className="cls-2"
        d="m32.89,57.62c-.03.15-.06.29-.27.21.03-.15.02-.34.27-.21Z"
      />
      <path
        className="cls-2"
        d="m35.56,28.21c.05-.12.12-.15.24-.09-.04.13-.11.2-.24.09Z"
      />
      <path
        className="cls-2"
        d="m77.35,44.5c.01-.08.07-.1.12-.06.04.03.04.1.06.15-.08.03-.15,0-.18-.08Z"
      />
      <path
        className="cls-2"
        d="m24.09,73.82s-.06.07-.09.11c-.01-.02-.03-.04-.04-.06.05-.01.09-.03.14-.04,0,0,0,0,0,0Z"
      />
      <path
        className="cls-2"
        d="m36.68,69.15c.04-.1.07-.26.22-.07-.03.13-.13.1-.22.07Z"
      />
      <path
        className="cls-2"
        d="m56.77,46.45c.07-.13.14-.14.2,0-.01.07-.06.12-.13.1-.03,0-.05-.07-.07-.1Z"
      />
      <path
        className="cls-2"
        d="m42.63,45.08s.09,0,.13,0c-.02.03-.05.06-.07.09-.02-.03-.04-.06-.07-.09Z"
      />
      <polygon
        className="cls-2"
        points="39.46 27.68 39.45 27.65 39.48 27.65 39.46 27.68"
      />
      <path
        className="cls-2"
        d="m76.43,43.04c.22-.03.39.09.56.19.15.09.4.16.29.39-.09.2-.33.13-.5.09-.15-.03-.28-.11-.42-.16-.13-.05-.34,0-.28-.24.04-.18.15-.3.36-.27Z"
      />
      <path
        className="cls-2"
        d="m66.42,44.62c-.19.19-.37.27-.59.19-.02,0-.03-.1,0-.12.18-.19.37-.11.6-.06Z"
      />
    </Icon>
  );
}

export function IconPersonalizeMe({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="26 21 59 55"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #fafafa; }`}
          {`.cls-2 { fill: #5e5e5e; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m32.8,69.16c.14-.65.28-1.29.42-1.94.13-.28.14-.58.17-.88.04-.16.08-.32.13-.48.17-.16.2-.37.17-.59,0-.03.02-.06.03-.1.14-.21.21-.43.17-.68,0-.06.01-.13.02-.19.23-.1.18-.31.18-.5,0,0,0-.01,0-.01.02,0,.05-.02.07-.03-.02-.01-.05-.02-.07-.03.04-.13.13-.26.1-.41.11-.03.1-.11.08-.19.17-.84.34-1.68.5-2.53.1-.03.09-.12.08-.2.04-.19.08-.39.12-.58.1-.04.08-.12.07-.2.11-.68.22-1.35.34-2.03.14-.08.06-.2.07-.3.29-1.33.58-2.67.87-4,.03-.16.08-.31.12-.46.25-.66.49-1.32.48-2.04,0-.06,0-.11.01-.17.18-.02.24-.17.26-.31.13-.99.38-1.95.6-2.92.31-.78.48-1.59.64-2.4.09-.44-.01-.89.15-1.32.39-1.07.26-2.25.65-3.33.17-.47.05-.67-.44-.81-1.02-.29-2.02-.66-2.95-1.15-1.3-.69-2.61-1.37-3.8-2.28-1.37-1.05-2.66-2.19-3.95-3.32-.55-.48-1.05-1.03-1.37-1.71.03-.01.06-.02.09-.04,1.24,1.53,2.79,2.72,4.32,3.94.97.77,1.98,1.5,3.03,2.14.47.29.96.59,1.52.76.46.14.88.41,1.34.6.19.08.45.24.58-.1-.09.19-.09.19-.02.25.48.36,1.07.45,1.63.61.16.05.24-.09.24-.23.05-1,.51-1.86.92-2.74.19-.41.62-.49.88-.8.37.29.94.23,1.21.69-.09.73.06,1.47-.09,2.21-.08.41-.29.74-.41,1.13-.1.33-.03.39.27.46.24.05.48.01.71.07.14.16.33.05.49.07.03,0,.07,0,.1,0,.32.17.64.15.97.03.1,0,.19,0,.29,0,.44.18.92.13,1.35.05.49-.08,1.02.06,1.48-.22.16.07.32.09.48.04.86-.08,1.69-.26,2.53-.47.06,0,.13-.02.19-.03.31-.04.59-.14.88-.26.38.02.73-.08,1.07-.23.39-.03.75-.15,1.07-.37.14-.01.28.01.39-.1.07,0,.13,0,.2-.01h.1c.07.02.09-.02.11-.07.35-.16.76-.2,1.06-.48.51-.06.93-.33,1.36-.58.18-.02.36-.06.48-.21.21-.02.38-.1.49-.29.07-.02.16,0,.2-.09.24-.11.52-.14.68-.4.03,0,.06-.02.09-.03.15.03.25-.03.31-.16,0,0,0,0,0,0,.19-.03.32-.14.43-.29.35-.17.65-.42.93-.68.17-.05.29-.17.41-.29.13-.01.2-.11.26-.21.6-.44,1.07-1.01,1.57-1.55.31-.38.71-.69.89-1.16.03-.07.05-.13.08-.2,0,0,0,0,0,0,.06-.01.09-.05.07-.11.07-.1.14-.19.21-.29.21-.18.35-.4.37-.69.09-.23.35-.38.35-.66.02-.07.04-.14.06-.21.15-.13.18-.3.2-.48.1-.04.11-.11.07-.2,0-.13.02-.25.02-.38.36-.46.29-.76-.2-.86-.09,0-.19-.02-.28-.03-.06-.14-.16-.19-.3-.17-.11-.09-.23-.13-.37-.12-.02-.05-.04-.1-.11-.07-.06-.01-.13-.02-.19-.04-.13-.23-.38-.21-.58-.3-.23-.16-.46-.31-.69-.47,0-.05-.03-.09-.1-.08-.03-.01-.06-.02-.09-.02-.02-.05-.04-.1-.11-.07-.1-.07-.19-.14-.29-.21,0-.06-.03-.09-.1-.08-.07-.07-.14-.14-.21-.22.01-.06-.02-.09-.08-.08-.05-.04-.1-.08-.15-.13-.17-.29-.37-.56-.62-.78-.12-.55-.43-1.04-.48-1.62.18-.15.04-.34.07-.51.04-.19.08-.39.12-.58.11-.04.08-.12.06-.2.07-.08.15-.16.13-.29.39-.34.81-.64,1.35-.7.03,0,.06.01.1.02.18.16.39.07.59.08.03,0,.06.02.09.03.25.16.49.31.78.38.05.13.16.19.29.19.07.12.16.23.29.29.09.2.25.34.4.48-.02.2.11.27.27.31,0,.16.04.29.19.38,0,.15.07.24.19.31.08.19.15.38.23.57-.05.2-.05.38.16.5.19.66.22,1.35.32,2.03.01.07.02.13.03.2-.13.25-.05.52-.07.78.07.34.32.14.5.18.03,0,.07,0,.1,0,.21.15.45.1.68.12.02.03.05.04.08.04.16.21.39.16.6.14.03,0,.07,0,.1,0,.17.16.38.12.58.1.03,0,.07,0,.1,0,.17.16.38.12.58.1.03,0,.07,0,.1,0,.12.07.24.15.39.1.12,0,.25.02.37.03.08.13.2.09.31.07.1,0,.19.02.29.03.42.1.83.23,1.27.16l.09.03c.07.15.19.18.35.2.44.04.87.1,1.31.16.15.01.31.03.46.04.15.25.38.2.61.17.06,0,.12.01.18.02.14.25.38.19.6.18.06,0,.12.01.18.02.08.36.45.07.6.26.03,0,.07,0,.1,0,.21.13.42.26.68.2.03.01.06.02.09.02.5.35,1.11.45,1.66.69.06.11.19.08.28.11.14.3.47.24.69.37.05.11.16.08.24.11.18.24.43.36.73.38.06.06.12.12.18.18.02.05.05.09.11.08.03,0,.07.02.1.02.23.37.6.57.98.77.1.1.19.2.29.3.04.14.15.2.28.23.02.15.13.21.25.27.11.33.39.53.63.76,0,.03.01.06.01.09-.09.04-.11.07,0,.11.03.03.07.06.1.09.02.19.13.31.28.42.11.25.21.5.32.75.06.27.06.56.27.78.01.06.03.13.04.19.11,1.1.29,2.19.3,3.3-.02.03-.03.06-.05.09-.08.04-.11.08,0,.13,0,0,0,0,0,0,0,.13,0,.25.01.38-.18,1.71-.7,3.35-.98,5.03-.08.06-.14.15-.26.11-.14-.64.15-1.23.22-1.85.08-.64.28-1.26.37-1.9.05-.39.18-.79.23-1.2,0-.1,0-.2,0-.29.06-.65.07-1.29.04-1.94.1-.03.09-.07,0-.11,0-.63-.05-1.25-.29-1.84-.03-.21,0-.43-.19-.59-.34-1.09-.99-1.97-1.82-2.73-.1-.1-.21-.19-.32-.28-.14-.17-.25-.37-.49-.43-.29-.18-.58-.36-.87-.55-.16-.26-.46-.28-.7-.39-.04-.11-.12-.13-.22-.12-.1-.18-.25-.28-.46-.24-.18-.1-.35-.23-.57-.21-.05-.3-.28-.28-.5-.27-.11-.1-.24-.12-.38-.12-.14-.23-.38-.22-.6-.26-.23-.07-.41-.27-.68-.23-.04-.11-.12-.07-.2-.06-.13-.04-.26-.09-.39-.13-.04-.09-.12-.08-.2-.06-.16-.05-.32-.11-.48-.16-.09-.07-.19-.07-.3-.04-.19-.03-.37-.16-.58-.11-.07,0-.13,0-.2,0-.43-.23-.89-.25-1.36-.29-.2.01-.37-.18-.58-.1-.58-.05-1.14-.23-1.73-.21-.14-.17-.33-.09-.5-.08-.51-.12-1.01-.21-1.54-.21-.05-.28-.26-.15-.41-.16-.68-.13-1.36-.27-2.04-.4-.06-.01-.1.01-.08.08-.01.03-.02.06-.02.09-.29.17-.16.45-.19.69-.1.03-.08.12-.1.19-.13.17-.14.38-.18.58,0,.06-.01.13-.02.19-.08.04-.11.11-.11.2-.01.03-.03.05-.04.08,0,.01,0,.03.01.04-.12.05-.17.15-.14.27-.11.19-.22.38-.33.57-.07.06-.07.13-.05.21-.14.21-.28.42-.42.63-.25.14-.39.36-.46.63-.09.03-.1.11-.11.19-.14-.01-.2.06-.21.19-.09.13-.19.25-.28.38-.13,0-.19.08-.19.21,0,0,0,0,0,0-.3.08-.38.35-.52.58-.15,0-.15.17-.26.21-.07-.01-.09.02-.09.08-.04.05-.08.11-.12.16-.14.01-.28.03-.29.22,0,0,0,0,0,0-.14,0-.24.06-.28.2-.55.55-1.23.92-1.85,1.38-.2.06-.4.12-.51.33-.16.16-.46.07-.57.32-.16.02-.33-.01-.39.2-.56.19-1.04.52-1.55.8-.19-.06-.34.08-.5.13-.16.05-.31.11-.47.16-.07-.02-.09.02-.11.07-.11.08-.24.11-.38.12-.07-.02-.09.02-.1.08-.03,0-.06.01-.09.02-.07-.02-.09.03-.11.08-.03,0-.06.01-.09.02-.17-.03-.29.05-.39.17-.7.14-1.39.33-2.07.55-.07-.08-.13-.07-.17.03-.03,0-.06.02-.09.03-.1,0-.22-.06-.29.07-.06.01-.13.02-.19.03-.06-.02-.09.02-.1.07-.1.01-.19.03-.29.04-.08-.01-.15-.03-.19.07-.1,0-.2.02-.29.02-.22.09-.48,0-.68.16-.1.03-.19.06-.29.09-.06-.1-.13-.12-.2,0-.1.01-.19.03-.29.04-.11-.02-.22-.07-.29.07-.19,0-.39.01-.58.02-.22.08-.48.03-.68.18-.07,0-.13,0-.2,0-.1-.12-.19-.14-.29,0-.13,0-.26.02-.39.02-.11,0-.22-.06-.29.07h-.05s-.05,0-.05,0c-.1-.13-.2-.13-.3,0-.18.07-.31-.1-.48-.07-.08-.02-.16-.04-.2.06-.29,0-.58,0-.87.01-.07-.09-.13-.09-.19,0-.24.09-.44-.15-.68-.08-.16,0-.32,0-.49,0-.16,0-.32-.01-.49-.02-.88-.29-1.19-.12-1.28.67-.21.1-.23.3-.28.49-.11.03-.12.11-.09.2-.03.13-.07.25-.1.38-.28.19-.33.49-.36.79-.01.06-.02.12-.03.18-.35.12-.24.45-.29.69-.03.06-.07.12-.1.17-.11.11-.21.23-.17.41-.13.53-.44.97-.65,1.47-.27.12-.23.35-.22.57-.12.26-.16.53-.14.82-.34.14-.16.42-.17.64-.02.02-.02.05-.01.07-.17.12-.23.3-.27.48-.1.56-.19,1.12-.29,1.68-.08.24-.13.49-.13.75-.47.43-.39,1.05-.58,1.58-.22.24-.22.53-.21.83-.11.09-.22.18-.18.34,0,.03,0,.06,0,.1-.08.08-.13.17-.09.29-.17.76-.34,1.52-.5,2.28-.23.16-.19.4-.17.63-.08.33-.16.66-.23.99-.2.39-.34.8-.32,1.25,0,.06-.02.13-.03.19-.19.14-.06.33-.08.49-.11.02-.1.11-.12.19-.14.18-.07.39-.07.59-.01.06-.02.12-.03.19-.18.14-.05.33-.06.49-.04.09-.12.16-.09.27-.03.17-.05.34-.08.51-.03,0-.05.02-.04.05-.17.42-.23.86-.29,1.3,0,.05-.01.1-.02.15-.5.93-.66,1.95-.85,2.96,0,.06-.01.12-.02.17-.34.09-.08.44-.26.6,0,.06-.01.13-.02.19-.21.77-.53,1.51-.47,2.33,0,.03,0,.07,0,.1-.31.58-.52,1.18-.53,1.84-.02.07-.05.13-.07.2-.16.05-.1.18-.1.29,0,.12-.01.24-.02.36-.14.01-.22.07-.17.23,0,.1,0,.2,0,.29-.11.02-.12.1-.09.19-.02.02-.02.05-.02.08-.06.02-.09.05-.08.12,0,.1,0,.2,0,.3-.1.02-.1.11-.12.18-.02.09-.02.22-.13.22-.13,0-.16-.12-.18-.23-.01-.06-.04-.11-.07-.17.21-.24.06-.52.1-.78.31-.37.31-.82.3-1.27.16-.62.34-1.23.45-1.86.04-.24.2-.43.22-.67.11-.04.09-.12.06-.2Zm32.69-42.48c0-.24.03-.48-.01-.7-.16-.79-.29-1.6-.7-2.3-.57-.96-1.25-1.82-2.41-2.1-.45-.11-1.02.09-1.25.44-.09.08-.2.16-.2.3-.03.06-.06.12-.09.19-.27.14-.2.37-.17.59-.1,1.52.76,2.5,1.9,3.31.08.33.4.25.61.36.02.02.05.02.08.02.08.11.17.18.31.17.02.02.05.03.08.02.07.27.35.18.5.29.03.11.13.07.2.09.14.17.32.07.49.09.24.09.53.51.69-.09.12-.16.14-.33,0-.49,0-.03,0-.06,0-.09.09-.04.09-.07,0-.11Zm-25.03,12.93c.19-.02.5-.02.49-.18-.04-.35.17-.6.26-.88.2-.61.08-1.27.39-1.86.08-.15-.06-.34-.18-.44-.14-.12-.31.02-.36.13-.17.33-.41.61-.46,1.02-.07.58-.24,1.15-.43,1.71-.15.44-.14.51.29.5Zm-.99,3.78c.16-.31.3-.48.36-.74.19-.78.4-1.56.64-2.33.07-.24,0-.34-.2-.38-.2-.04-.42-.07-.43.22,0,.44-.25.82-.27,1.24-.03.63-.26,1.24-.1,2Z"
      />
      <path
        className="cls-1"
        d="m37.78,47.39c-.21.97-.47,1.93-.6,2.92-.02.14-.08.28-.26.31-.03-.67.26-1.28.32-1.93.03-.38.02-.77.3-1.1.07-.08.1-.2.24-.21Z"
      />
      <path
        className="cls-1"
        d="m84.87,40.09c0-1.11-.19-2.2-.3-3.3.45.22.26.67.31.99.1.63.19,1.27.14,1.92-.01.15-.02.29-.16.38Z"
      />
      <path
        className="cls-1"
        d="m31.66,73.92c.02.06.06.11.07.17.02.11.04.24.18.23.11,0,.12-.13.13-.22.02-.08.02-.16.12-.18.14.28-.07.52-.12.76-.09.36-.33.68-.45,1.05-.16-.63-.08-1.22.08-1.81Z"
      />
      <path
        className="cls-1"
        d="m34.01,66.63c.19-1.02.35-2.04.85-2.96-.08,1.01-.39,1.96-.72,2.91-.01.03-.08.04-.13.06Z"
      />
      <path
        className="cls-1"
        d="m47.61,39.94c-.46.28-.98.13-1.48.22-.43.07-.91.13-1.35-.05.68-.19,1.39-.14,2.08-.23.19-.02.53-.23.74.06Z"
      />
      <path
        className="cls-1"
        d="m50.62,39.52c-.83.2-1.67.38-2.53.47.02-.04.03-.12.06-.13.78-.19,1.54-.47,2.36-.42.04,0,.07.05.11.08Z"
      />
      <path
        className="cls-1"
        d="m38.19,50.21c.09-.56.19-1.12.29-1.68.03-.19.1-.37.27-.48.09.69-.13,1.33-.3,1.98-.03.12-.13.18-.25.19Z"
      />
      <path
        className="cls-1"
        d="m33.24,69.94c-.06-.82.27-1.56.47-2.33.23.25.02.49-.01.73-.07.47-.19.94-.28,1.41-.02.11-.07.18-.18.19Z"
      />
      <path
        className="cls-1"
        d="m26.79,31.02s-.06.02-.09.04c-.28-.14-.92-1.11-.91-1.38,0-.07.04-.14.11-.13.05,0,.12.05.14.1.17.5.64.84.75,1.38Z"
      />
      <path
        className="cls-1"
        d="m36.91,50.79c.01.72-.23,1.38-.48,2.04-.31-.48.16-.86.17-1.31,0-.25-.01-.58.31-.74Z"
      />
      <path
        className="cls-1"
        d="m32.72,71.88c0-.66.22-1.27.53-1.84.03.67-.22,1.27-.53,1.84Z"
      />
      <path
        className="cls-1"
        d="m62.88,33.2c-.5.54-.97,1.11-1.57,1.55,0-.11,0-.23.09-.32.36-.36.73-.73,1.08-1.09.11-.11.24-.15.4-.14Z"
      />
      <path
        className="cls-1"
        d="m41.37,41.16c.09-.79.4-.96,1.28-.67-.03.24-.23.21-.37.18-.38-.08-.7-.09-.75.42,0,.03-.11.05-.16.07Z"
      />
      <path
        className="cls-1"
        d="m78.8,30.78c-.55-.23-1.16-.34-1.66-.69.54-.13.93.34,1.44.35.12,0,.22.17.21.34Z"
      />
      <path
        className="cls-1"
        d="m73.65,29.18c-.44-.05-.87-.12-1.31-.16-.16-.01-.28-.05-.35-.2.33,0,.67-.02,1,0,.25.02.56,0,.66.35Z"
      />
      <path
        className="cls-1"
        d="m37.49,52.54c.19-.53.1-1.16.58-1.58-.01.48-.22.91-.3,1.38-.02.14-.14.2-.28.21Z"
      />
      <path
        className="cls-1"
        d="m61.99,21.23c-.54.06-.96.36-1.35.7-.06-.04-.11-.1-.07-.16.28-.44.74-.57,1.2-.71.09-.03.17.08.22.16Z"
      />
      <path
        className="cls-1"
        d="m71.9,28.79c-.44.07-.85-.05-1.27-.16,0-.03,0-.08.02-.09.27-.2,1.04-.04,1.24.25Z"
      />
      <path
        className="cls-1"
        d="m57.04,37.39c-.43.25-.85.51-1.36.58,0-.14.07-.24.19-.3.37-.18.75-.3,1.17-.28Z"
      />
      <path
        className="cls-1"
        d="m42.44,36.14c-.27-.46-.84-.41-1.21-.69.85-.14,1.06-.02,1.21.69Z"
      />
      <path
        className="cls-1"
        d="m34.87,63.52c.06-.44.12-.88.29-1.3.03.01.07.02.08.04.18.28-.06,1.1-.37,1.26Z"
      />
      <path
        className="cls-1"
        d="m82.11,32.8c-.37-.2-.74-.4-.98-.77.52,0,.83.29.98.77Z"
      />
      <path
        className="cls-1"
        d="m35.78,59.25c-.02-.45.12-.85.32-1.25.01.45.19.94-.32,1.25Z"
      />
      <path
        className="cls-1"
        d="m65,27.97c.49.11.56.4.2.86-.16-.26-.06-.59-.2-.86Z"
      />
      <path
        className="cls-1"
        d="m32.06,71.88c0,.45,0,.89-.3,1.27,0-.45.1-.87.3-1.27Z"
      />
      <path
        className="cls-1"
        d="m53.82,38.63c-.32.22-.68.34-1.07.37.34-.16.61-.55,1.07-.37Z"
      />
      <path
        className="cls-1"
        d="m44.5,40.11c-.33.12-.65.14-.97-.03.33-.14.66-.26.97.03Z"
      />
      <path
        className="cls-1"
        d="m83.55,34.37c-.23-.24-.51-.43-.63-.76.4.09.67.43.63.76Z"
      />
      <path
        className="cls-1"
        d="m51.69,39.23c-.28.12-.57.22-.88.26.22-.33.49-.5.88-.26Z"
      />
      <path
        className="cls-1"
        d="m60.73,25.11c.25.22.45.49.62.78-.44-.08-.65-.33-.62-.78Z"
      />
      <path
        className="cls-1"
        d="m40.54,43.01c.03-.3.08-.6.36-.79-.02.31.03.65-.36.79Z"
      />
      <path
        className="cls-1"
        d="m79.77,31.26c-.22-.13-.55-.07-.69-.37.33-.06.58.01.69.37Z"
      />
      <path
        className="cls-1"
        d="m58.88,36.41c-.16.25-.44.29-.68.4.15-.27.26-.59.68-.4Z"
      />
      <path
        className="cls-1"
        d="m33.39,66.34c-.03.3-.03.6-.17.88-.19-.34-.1-.62.17-.88Z"
      />
      <path
        className="cls-1"
        d="m83.58,45.82c.12.04.19-.05.26-.11,0,.06.01.13,0,.19,0,.11.03.24-.11.29-.08.03-.17.03-.22-.04-.09-.12-.07-.24.06-.33Z"
      />
      <path
        className="cls-1"
        d="m63.54,21.73c-.29-.07-.53-.23-.78-.38.4-.15.6.1.78.38Z"
      />
      <path
        className="cls-1"
        d="m62.44,34.26c.13-.23.22-.5.52-.58,0,.35-.19.53-.52.58Z"
      />
      <path
        className="cls-1"
        d="m40.21,43.89c.06-.25-.06-.57.29-.69-.02.26.1.59-.29.69Z"
      />
      <path
        className="cls-1"
        d="m84.53,36.6c-.21-.22-.21-.51-.27-.78.34.17.34.47.27.78Z"
      />
      <path
        className="cls-1"
        d="m80.75,31.75c-.3-.02-.55-.14-.73-.38.32-.02.57.09.73.38Z"
      />
      <path
        className="cls-1"
        d="m67.82,28.23c-.22.02-.44.08-.6-.14.27-.25.46-.16.6.14Z"
      />
      <path
        className="cls-1"
        d="m77.06,30.07c-.26.06-.47-.07-.68-.2.29-.14.52-.12.68.2Z"
      />
      <path
        className="cls-1"
        d="m47.61,40.49c.2-.15.46-.1.68-.18-.13.41-.41.3-.68.18Z"
      />
      <path
        className="cls-1"
        d="m64.5,30.77c-.02.28-.16.51-.37.69,0-.29,0-.59.37-.69Z"
      />
      <path
        className="cls-1"
        d="m59.05,36.85c.11-.21.3-.27.51-.33-.06.27-.15.51-.51.33Z"
      />
      <path
        className="cls-1"
        d="m83.97,36.11c.19.15.16.38.19.59-.31-.12-.39-.31-.19-.59Z"
      />
      <path
        className="cls-1"
        d="m67.14,28.05c-.23-.02-.47.03-.68-.12.3-.39.47,0,.68.12Z"
      />
      <path
        className="cls-1"
        d="m38.76,47.97c.02-.22-.17-.5.17-.64-.07.21.33.55-.17.64Z"
      />
      <path
        className="cls-1"
        d="m63.75,32.71c.07-.27.21-.5.46-.63-.04.29-.14.55-.46.63Z"
      />
      <path
        className="cls-1"
        d="m79.78,31.73c.24.12.54.13.7.39-.3-.01-.58-.05-.7-.39Z"
      />
      <path
        className="cls-1"
        d="m65.58,29.11c.04-.24-.09-.52.19-.69-.06.23.17.54-.19.69Z"
      />
      <path
        className="cls-1"
        d="m49.94,40.1c.2-.16.46-.07.68-.16-.16.34-.42.25-.68.16Z"
      />
      <path
        className="cls-1"
        d="m76.28,29.87c-.16-.19-.52.1-.6-.26.21.06.56-.2.6.26Z"
      />
      <path
        className="cls-1"
        d="m63.16,27.25c.2.09.45.07.58.3-.3.11-.48-.01-.58-.3Z"
      />
      <path
        className="cls-1"
        d="m33.88,64.49c.04.25-.03.48-.17.68-.07-.26-.09-.5.17-.68Z"
      />
      <path
        className="cls-1"
        d="m33.68,65.27c.03.22,0,.42-.17.59-.16-.26-.08-.44.17-.59Z"
      />
      <path
        className="cls-1"
        d="m33.73,67.41c.18-.16-.08-.51.26-.6-.06.21.2.56-.26.6Z"
      />
      <path
        className="cls-1"
        d="m62.67,21.32c-.2,0-.41.08-.59-.08.21-.12.43-.24.59.08Z"
      />
      <path
        className="cls-1"
        d="m78.03,30.88c.22,0,.45-.03.5.27-.22,0-.46.05-.5-.27Z"
      />
      <path
        className="cls-1"
        d="m58.01,36.89c-.1.19-.28.27-.49.29.06-.27.19-.42.49-.29Z"
      />
      <path
        className="cls-1"
        d="m65.31,29.89c.04-.2.05-.41.18-.58.19.27.1.46-.18.58Z"
      />
      <path
        className="cls-1"
        d="m35.47,60.7c0-.2-.07-.41.07-.59.13.21.24.43-.07.59Z"
      />
      <path
        className="cls-1"
        d="m77.05,30.5c.22.04.46.03.6.26-.23-.02-.52.11-.6-.26Z"
      />
      <path
        className="cls-1"
        d="m74.72,29.39c-.23.02-.46.07-.61-.17.2.05.49-.17.61.17Z"
      />
      <path
        className="cls-1"
        d="m81.35,32.66c.24.05.35.26.49.43-.3.02-.49-.1-.49-.43Z"
      />
      <path
        className="cls-1"
        d="m36.33,57.01c-.02-.23-.06-.47.17-.63-.04.22.18.5-.17.63Z"
      />
      <path
        className="cls-1"
        d="m39.08,46.51c-.01-.22-.05-.46.22-.57.04.23.03.45-.22.57Z"
      />
      <path
        className="cls-1"
        d="m72.1,29.32c.21-.08.38.11.58.1-.25.29-.42.1-.58-.1Z"
      />
      <path
        className="cls-1"
        d="m68.5,28.32c-.2.02-.41.06-.58-.1.21-.09.44-.22.58.1Z"
      />
      <path
        className="cls-1"
        d="m69.18,28.42c-.2.02-.41.06-.58-.1.21-.08.43-.22.58.1Z"
      />
      <path
        className="cls-1"
        d="m75.5,29.59c-.22.02-.46.07-.6-.18.2.06.48-.16.6.18Z"
      />
      <path
        className="cls-1"
        d="m56.04,38.3c.16-.05.31-.19.5-.13-.13.2-.27.34-.5.13Z"
      />
      <path
        className="cls-1"
        d="m35.37,61.38c.02-.17-.11-.35.06-.49.15.19.22.36-.06.49Z"
      />
      <path
        className="cls-1"
        d="m35.66,59.93c.02-.16-.1-.35.08-.49.13.19.19.37-.08.49Z"
      />
      <path
        className="cls-1"
        d="m43.13,40.51c.16,0,.32,0,.49,0-.17.25-.33.26-.49,0Z"
      />
      <path
        className="cls-1"
        d="m66.36,27.93c-.17-.03-.43.17-.5-.18.17.04.42-.12.5.18Z"
      />
      <path
        className="cls-1"
        d="m43.43,40.08c-.16-.01-.35.09-.49-.07.19-.15.36-.21.49.07Z"
      />
      <path
        className="cls-1"
        d="m67.92,28.65c.15.01.36-.12.41.16-.2.11-.36.12-.41-.16Z"
      />
      <path
        className="cls-1"
        d="m79.1,31.36c.22-.04.36.06.46.24-.22.04-.4,0-.46-.24Z"
      />
      <path
        className="cls-1"
        d="m69.86,29.02c.17,0,.36-.09.5.08-.18.05-.39.27-.5-.08Z"
      />
      <path
        className="cls-1"
        d="m74.82,29.82c.11-.03.21-.03.3.04-.01.1-.02.21-.15.21-.16,0-.14-.14-.15-.25Z"
      />
      <path
        className="cls-1"
        d="m60.32,22.99c-.03.17.1.36-.07.51-.05-.18-.27-.38.07-.51Z"
      />
      <path
        className="cls-1"
        d="m65.58,24.75c-.21-.12-.22-.3-.16-.5.28.09.13.33.16.5Z"
      />
      <path
        className="cls-1"
        d="m34.08,63.81c0,.19.06.39-.18.5.04-.17-.11-.41.18-.5Z"
      />
      <path
        className="cls-1"
        d="m64.13,22.21c-.13-.06-.22-.17-.29-.29.24-.08.26-.06.29.29Z"
      />
      <path
        className="cls-1"
        d="m54.31,39.02c.11-.11.23-.2.39-.17-.08.18-.16.34-.39.17Z"
      />
      <path
        className="cls-1"
        d="m84.82,40.68c0-.13,0-.25-.01-.38.12,0,.2.04.21.18,0,.13-.07.19-.19.2Z"
      />
      <path
        className="cls-1"
        d="m61.05,34.96c-.12.12-.24.24-.41.29-.04-.35.19-.31.41-.29Z"
      />
      <path
        className="cls-1"
        d="m35.21,62.17c.03-.17.06-.34.08-.51.34.23.09.36-.08.51Z"
      />
      <path
        className="cls-1"
        d="m83.94,35.07c-.15-.1-.26-.23-.28-.42.27.02.31.2.28.42Z"
      />
      <path
        className="cls-1"
        d="m59.71,35.93c-.11.15-.24.26-.43.29,0-.3.2-.32.43-.29Z"
      />
      <path
        className="cls-1"
        d="m58.1,37.37c.06-.21.24-.18.39-.2-.03.27-.24.18-.39.2Z"
      />
      <path
        className="cls-1"
        d="m64.8,23c-.16-.04-.29-.1-.27-.31.19.02.28.12.27.31Z"
      />
      <path
        className="cls-1"
        d="m69.67,28.51c-.15.05-.27-.03-.39-.1.16-.11.31-.16.39.1Z"
      />
      <path
        className="cls-1"
        d="m51.68,39.7c.07-.13.19-.07.29-.07-.06.2-.16.22-.29.07Z"
      />
      <path
        className="cls-1"
        d="m35.45,57.3c0,.1.07.23-.07.3-.18-.14-.15-.24.07-.3Z"
      />
      <path
        className="cls-1"
        d="m39.94,44.47c-.04-.18.06-.3.17-.41-.01.15.09.36-.17.41Z"
      />
      <path
        className="cls-1"
        d="m84.4,40.58c0,.1,0,.2,0,.29-.22-.09-.23-.19,0-.29Z"
      />
      <path
        className="cls-1"
        d="m46.44,40.58c.07-.13.19-.08.29-.07-.06.2-.15.22-.29.07Z"
      />
      <path
        className="cls-1"
        d="m32.55,72.37c0-.11-.06-.23.1-.29.14.15.11.25-.1.29Z"
      />
      <path
        className="cls-1"
        d="m48.87,40.29c.07-.13.18-.09.29-.07-.06.2-.16.21-.29.07Z"
      />
      <path
        className="cls-1"
        d="m61.69,34.94c0-.19.14-.21.29-.22.02.22-.13.23-.29.22Z"
      />
      <path
        className="cls-1"
        d="m47.12,40.49c.1-.14.19-.12.29,0-.1.12-.19.12-.29,0Z"
      />
      <path
        className="cls-1"
        d="m37.01,54.09c-.04-.12.01-.21.09-.29.17.16.12.25-.09.29Z"
      />
      <path
        className="cls-1"
        d="m70.35,28.61c-.11.03-.23.07-.31-.07.12-.03.26-.19.31.07Z"
      />
      <path
        className="cls-1"
        d="m37.11,53.7c-.04-.16.07-.25.18-.34.01.15.05.32-.18.34Z"
      />
      <path
        className="cls-1"
        d="m82.68,33.33c-.13-.04-.24-.1-.28-.23.16,0,.3.02.28.23Z"
      />
      <path
        className="cls-1"
        d="m65.19,23.69c-.12-.07-.2-.16-.19-.31.21,0,.2.16.19.31Z"
      />
      <path
        className="cls-1"
        d="m61.41,35.14c.04-.14.14-.2.28-.2,0,.2-.14.2-.28.2Z"
      />
      <path
        className="cls-1"
        d="m46.05,40.58c.1-.12.2-.12.3,0-.1.03-.2.16-.3,0Z"
      />
      <path
        className="cls-1"
        d="m64.42,27.78c.14-.02.25.03.3.17-.13,0-.28.02-.3-.17Z"
      />
      <path
        className="cls-1"
        d="m59.28,36.22c-.06.14-.16.19-.31.16.03-.2.17-.17.31-.16Z"
      />
      <path
        className="cls-1"
        d="m49.45,40.19c.07-.11.14-.1.2,0-.07.1-.14.1-.2,0Z"
      />
      <path
        className="cls-1"
        d="m34.85,60.41c.01.08.03.16-.08.2-.15-.13-.05-.17.08-.2Z"
      />
      <path
        className="cls-1"
        d="m45.36,40.57c.04-.1.12-.08.2-.06-.03.14-.08.22-.2.06Z"
      />
      <path
        className="cls-1"
        d="m32.26,73.43c-.02-.09-.02-.17.09-.19.14.15.02.17-.09.19Z"
      />
      <path
        className="cls-1"
        d="m75.6,30.02c.08-.02.15-.02.2.06-.12.15-.17.07-.2-.06Z"
      />
      <path
        className="cls-1"
        d="m32.35,72.95c-.04-.15.04-.21.17-.23.02.13-.03.21-.17.23Z"
      />
      <path
        className="cls-1"
        d="m41,41.85c-.02-.09-.01-.17.09-.2.15.15.04.18-.09.2Z"
      />
      <path
        className="cls-1"
        d="m54.41,38.52c-.07,0-.13,0-.2.01,0-.06.01-.14.09-.14.08,0,.09.07.1.13Z"
      />
      <path
        className="cls-1"
        d="m64.91,29.89c-.02.07-.04.14-.06.21-.19-.13-.11-.18.06-.21Z"
      />
      <path
        className="cls-1"
        d="m50.91,39.91c.04-.09.12-.08.19-.07-.03.12-.07.21-.19.07Z"
      />
      <path
        className="cls-1"
        d="m60.51,22.21c.02.08.05.16-.06.2-.15-.12-.07-.17.06-.2Z"
      />
      <path
        className="cls-1"
        d="m65.18,30.28c0-.09.02-.16.11-.2.16.17.02.18-.11.2Z"
      />
      <path
        className="cls-1"
        d="m76.18,30.21c.08-.01.16-.05.2.06-.11.15-.17.08-.2-.06Z"
      />
      <path
        className="cls-1"
        d="m65.94,26.98c-.01-.07-.02-.13-.03-.2.16.04.22.1.03.2Z"
      />
      <path
        className="cls-1"
        d="m32.8,69.16c.03.08.04.16-.06.2-.14-.12-.06-.17.06-.2Z"
      />
      <path
        className="cls-1"
        d="m64.63,31.45c-.02-.08-.01-.15.05-.21.17.12.1.17-.05.21Z"
      />
      <path
        className="cls-1"
        d="m65.18,29.21c.04.09.02.16-.07.2-.15-.13-.06-.17.07-.2Z"
      />
      <path
        className="cls-1"
        d="m63.85,31.85c-.03.07-.05.13-.08.2-.06-.03-.12-.08-.08-.14.02-.04.11-.04.16-.06Z"
      />
      <path
        className="cls-1"
        d="m74.04,29.71c.07,0,.13,0,.2,0-.01.06-.02.14-.1.14-.08,0-.09-.08-.1-.14Z"
      />
      <path
        className="cls-1"
        d="m62.96,33.68c0-.13.06-.2.19-.21,0,.13-.05.21-.19.21Z"
      />
      <path
        className="cls-1"
        d="m34.27,63.13c.01.08.03.16-.08.19-.15-.14-.04-.17.08-.19Z"
      />
      <path
        className="cls-1"
        d="m63.43,33.09c.01-.13.07-.21.21-.19,0,.14-.07.2-.21.19Z"
      />
      <path
        className="cls-1"
        d="m65.01,30.67c-.02-.13.03-.22.14-.27.05.14.03.25-.14.27Z"
      />
      <path
        className="cls-1"
        d="m35.05,59.63c.01.08.03.16-.07.2-.15-.13-.06-.17.07-.2Z"
      />
      <path
        className="cls-1"
        d="m44.3,40.59c.06-.1.13-.1.19,0-.06.1-.13.1-.19,0Z"
      />
      <path
        className="cls-1"
        d="m54.98,38.73c.01-.06.04-.1.1-.08-.03.03-.07.05-.1.08Z"
      />
      <path
        className="cls-1"
        d="m62.19,26.61c.07-.02.09.02.11.07-.04-.02-.07-.05-.11-.07Z"
      />
      <path
        className="cls-1"
        d="m84.45,38.53c.09.04.09.08,0,.11,0-.04,0-.07,0-.11Z"
      />
      <path
        className="cls-1"
        d="m61.8,26.32c.06-.02.09.02.1.08-.03-.03-.07-.05-.1-.08Z"
      />
      <path
        className="cls-1"
        d="m54.79,38.83s.04-.1.11-.08c-.04.03-.07.05-.11.08Z"
      />
      <path
        className="cls-1"
        d="m34.09,63.73s.05.02.07.03c-.02,0-.05.02-.07.03,0-.02,0-.04,0-.06Z"
      />
      <path
        className="cls-1"
        d="m61.5,26.02c.06,0,.09.02.08.08-.03-.03-.05-.05-.08-.08Z"
      />
      <path
        className="cls-1"
        d="m81.04,32.01c-.07.02-.09-.02-.11-.08.04.03.08.05.11.08Z"
      />
      <path
        className="cls-1"
        d="m52.07,39.61c.04-.1.1-.11.17-.03-.06.01-.11.02-.17.03Z"
      />
      <path
        className="cls-1"
        d="m62.38,26.7c.07-.02.09.02.1.08-.03-.03-.06-.05-.1-.08Z"
      />
      <path
        className="cls-1"
        d="m55.47,38.54c.02-.05.04-.09.11-.07-.04.02-.07.05-.11.07Z"
      />
      <path
        className="cls-1"
        d="m63.92,31.74c.01.06-.02.1-.07.11.02-.04.05-.07.07-.11Z"
      />
      <path
        className="cls-1"
        d="m51.39,39.8c.01-.05.04-.09.1-.07-.03.02-.07.05-.1.07Z"
      />
      <path
        className="cls-1"
        d="m62.1,34.56c0-.06.02-.1.09-.08-.03.03-.06.06-.09.08Z"
      />
      <path
        className="cls-1"
        d="m54.62,38.45c-.01.06-.04.1-.11.08.04-.03.07-.05.11-.08Z"
      />
      <path className="cls-1" d="m63.94,27.58c.07-.03.09.02.11.07l-.11-.07Z" />
      <path
        className="cls-1"
        d="m65.79,28.34c-.01-.07.02-.09.08-.08-.03.03-.06.05-.08.08Z"
      />
      <path
        className="cls-1"
        d="m84.82,40.3c-.11-.04-.08-.09,0-.13,0,.04,0,.08,0,.13Z"
      />
      <path
        className="cls-1"
        d="m32.16,73.63c-.01-.07.02-.1.08-.12-.03.04-.05.08-.08.12Z"
      />
      <path
        className="cls-1"
        d="m83.57,34.56c-.11-.04-.09-.07,0-.11,0,.04,0,.07,0,.11Z"
      />
      <path
        className="cls-1"
        d="m40.46,39.6c-.43,0-.44-.07-.29-.5.19-.55.36-1.13.43-1.71.05-.42.29-.7.46-1.02.06-.11.22-.25.36-.13.12.1.26.29.18.44-.31.58-.19,1.25-.39,1.86-.09.28-.3.53-.26.88.02.17-.3.17-.49.18Z"
      />
      <path
        className="cls-1"
        d="m39.47,43.39c-.16-.75.08-1.37.1-2,.02-.43.26-.81.27-1.24,0-.29.23-.26.43-.22.21.05.27.15.2.38-.24.77-.45,1.55-.64,2.33-.06.26-.2.43-.36.74Z"
      />
      <path
        className="cls-1"
        d="m62.55,26.4c.25.04.5.08.61.36-.21-.11-.53-.03-.61-.36Z"
      />
      <path
        className="cls-1"
        d="m60.82,22.5c-.06.2.15.47-.17.59-.02-.22-.1-.46.17-.59Z"
      />
      <path
        className="cls-1"
        d="m63.62,26.98c.23,0,.48-.05.5.29-.16-.11-.43-.02-.5-.29Z"
      />
      <path
        className="cls-1"
        d="m65.5,27.37c-.15-.16-.15-.33,0-.49.14.16.12.33,0,.49Z"
      />
      <path
        className="cls-1"
        d="m64.32,27.36c.19-.13.37-.2.49.09-.16-.02-.35.08-.49-.09Z"
      />
      <path
        className="cls-1"
        d="m63.24,26.79c.14,0,.29-.03.31.17-.14.01-.23-.06-.31-.17Z"
      />
      <path
        className="cls-1"
        d="m61.11,22.01c0,.15,0,.3-.2.3,0-.14.11-.22.2-.3Z"
      />
      <path
        className="cls-1"
        d="m65.49,26.79s0-.08,0-.11c.09.04.09.08,0,.11Z"
      />
    </Icon>
  );
}

export function IconEcoFriendly({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="19 24 53 51"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #2b2b2b; }`}
          {`.cls-2 { fill: #838383; }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m26.39,66.89c-.25-.23-.55-.4-.78-.66.03-.15-.03-.2-.18-.18-.06-.06-.12-.12-.19-.17,0-.25-.15-.35-.36-.42-.29-.24-.45-.58-.71-.84-.19-.57-.55-1.01-1.01-1.38-.05-.06-.09-.11-.14-.17.01-.1.03-.19-.12-.18-.05-.05-.1-.11-.15-.16.06-.11.02-.14-.09-.13,0,0,0,0,0,0,.03-.08-.01-.14-.06-.19-.43-.43-.71-.96-1.06-1.45-.11-.16-.11-.42-.36-.47-.05-.12-.1-.24-.15-.37.1-.3-.09-.5-.25-.71-.07-.24-.13-.48-.2-.72.04-.02.05-.06.04-.1-.16-.59-.33-1.18-.49-1.77-.02-.06-.04-.11-.11-.11-.08-.46-.16-.93-.25-1.39.07-.1.03-.14-.08-.15-.06-.14-.05-.28-.06-.42.08-.02.1-.09.1-.15,0-.04-.05-.05-.09-.03,0-.04-.02-.08-.03-.12.14-.25.19-.51.12-.79-.17-.7-.12-1.42-.23-2.13-.03-.23,0-.47,0-.71,0-.09,0-.19-.12-.2,0-.04,0-.08,0-.12.11-.09.1-.16-.05-.19,0-.05.01-.1.02-.16.18-.09.07-.25.08-.38-.09-.29-.11-.59-.1-.89.07-.02.08-.08.1-.13.09-.18-.08-.38-.02-.54.13-.34.1-.7.19-1.04.08-.33.19-.66.22-.98.05-.47.16-.92.26-1.38.03-.15.06-.31-.02-.47-.03-.09.08-.11.1-.18.15-.02.13-.17.15-.25.07-.32.14-.65.22-.97.12-.46.35-.89.57-1.32.09-.18.15-.35.09-.55-.02-.05,0-.09.03-.14.15-.2.19-.44.25-.67.08-.31.28-.57.38-.87.13-.38.31-.77.45-1.16.16-.44.46-.77.67-1.16.19-.35.41-.68.75-.91.03-.02.05-.08.06-.13.08-.23.19-.43.35-.61.32-.35.59-.72.83-1.13.13-.23.27-.47.54-.58.19-.07.31-.21.42-.37.2-.29.46-.5.72-.74.22-.2.37-.48.55-.72,0,0,0,0,0,0,.23.08.31-.09.44-.23.35-.38.72-.74,1.08-1.11.1-.06.2-.13.3-.19.24-.13.42-.32.59-.53.29-.3.75-.34,1.01-.68.03.13.09.11.19.07.18-.06.24-.24.37-.35.27-.22.61-.29.88-.48.33-.23.69-.42,1.04-.61.91-.5,1.81-1.03,2.83-1.29.17-.04.36-.13.38-.36.4-.12.8-.23,1.17-.4.23.06.5.02.65-.09.18-.14.37-.21.57-.28.8-.27,1.58-.56,2.39-.79.07-.02.15-.06.14-.16.36-.08.72-.15,1.08-.23.24-.05.48-.14.74-.17.18-.02.36-.15.56-.11.19.06.31-.03.42-.17.75-.09,1.49-.22,2.24-.04-.06.18.26.24.13.43-.38.02-.77.06-1.15.09-.3.02-.61.04-.89.19-.22.12-.5.11-.75.09-.06-.02-.11,0-.17,0-.35.02-.64.22-.99.25-.2.02-.47.08-.58.33-.08.03-.15.05-.23.08-.06-.09-.14-.15-.25-.07-.17.13-.39.14-.56.23-.22.13-.52.09-.69.31-.36.19-.76.26-1.13.45-.42.22-.89.36-1.34.51-.32.11-.62.28-.92.43-.1.05-.19.09-.29.14-.11-.06-.25-.07-.35-.02-.28.12-.59.16-.85.36-.27.22-.62.33-.94.48-.48.22-.95.47-1.37.8-.21.16-.43.32-.74.31-.29-.01-.24.46-.55.48-.04,0-.07.03-.1.05-.18.11-.38.18-.52.33-.3.3-.65.52-1.01.73-.11.07-.26.11-.3.27-.01,0-.03.01-.04.02-.13.01-.2.11-.29.19-.14.13-.24.3-.43.37-.16.06-.23.16-.25.33,0,.02-.01.03-.02.05-.12,0-.18.06-.17.18,0,.01-.02.02-.04.02-.23.1-.46.21-.63.41-.42.52-.99.9-1.36,1.47-.04.06-.1.12-.16.13-.21.05-.11.16-.06.26-.2.16-.29.39-.45.58-.1-.02-.2.03-.28.07-.13.08-.03.1.05.11-.06.21-.18.37-.37.48-.12-.03-.15.02-.11.13,0,.05,0,.1-.06.12-.12-.1-.21-.11-.31.06-.2.36-.35.74-.56,1.09-.18.29-.34.6-.39.95,0,.02,0,.03-.02.05-.21.1-.2.3-.23.49h0c-.13,0-.13.09-.12.18-.01.17-.18.29-.17.47-.33.19-.34.52-.36.84-.03.08-.06.15-.08.23-.11.1-.23.19-.16.37-.17.26-.27.55-.37.84-.25.17-.22.44-.26.69-.05.12-.09.25-.14.37-.15.16-.19.36-.18.58-.25.52-.4,1.07-.51,1.63-.02.09-.08.17-.12.26-.05,0-.1.01-.1.07,0,.04.03.07.08.06,0,.03-.01.06-.02.09-.16.15-.23.5-.14.68-.06.26-.12.52-.18.78-.04.02-.08.03-.07.08,0,.02.04.03.07.04,0,.1,0,.19,0,.29-.08.02-.08.1-.1.17-.07.35-.06.71-.07,1.06,0,.31-.04.62.04.93,0,.09-.02.19-.03.28,0,.49-.03.98-.02,1.47,0,.21-.07.43.04.64,0,.06,0,.12,0,.18-.07.14-.06.29-.02.44,0,.03,0,.07,0,.1-.16.28-.07.58-.04.87.02.22.1.45.05.65-.05.23-.03.34.19.41.08.51.21,1.01.29,1.51.14.94.46,1.82.69,2.73.17.7.41,1.37.73,2.02-.03.54.12.77.59.96.06.1.12.2.18.3-.06.04-.18.12-.14.13.27.07.29.41.55.47.03.18.25.26.25.46.4.74.74,1.52,1.29,2.19.3.37.73.62.98,1.03.05.08.12.17.24.13.02,0,.03.01.04.03,0,.11.07.17.18.16.02.02.04.04.06.06,0,.13.06.19.19.17.02.02.04.04.06.06-.03.1,0,.14.11.13.1.09.19.17.29.26.15.2.31.39.52.51.26.15.36.28.26.58-.29-.11-.5-.38-.84-.39-.12-.1-.23-.21-.35-.31-.13-.26-.35-.42-.61-.53Z"
      />
      <path
        className="cls-1"
        d="m64.55,32.92c-.21-.27-.52-.44-.72-.72-.14-.27-.34-.46-.62-.6-.32-.15-.45-.55-.82-.65-.01,0-.03-.01-.05-.01-.03-.09-.1-.11-.18-.11-.19-.11-.29-.34-.53-.37-.15-.25-.4-.34-.67-.4-.22-.17-.41-.36-.66-.47.02-.09-.02-.14-.12-.13,0,0,0,0,0,0-.05-.19-.18-.25-.36-.23-.11-.05-.15-.2-.29-.19-.09-.16-.22-.26-.41-.24-.36-.31-.79-.49-1.2-.72-.05-.03-.09-.07-.13-.11,0-.07.03-.17-.04-.19-.32-.1-.52-.39-.81-.52-.4-.17-.82-.29-1.21-.47-.42-.2-.88-.3-1.28-.55-.11-.07-.27-.18-.43-.05-.6-.13-1.14-.43-1.72-.64-.18-.07-.35-.16-.55-.16.02-.12-.13-.1-.15-.19.22-.1.41-.08.59.08.03.03.09.15.15.02.14-.3.22-.08.29.05.09-.08.08-.16.07-.24.12.02.23.04.35.06.03.08.08.12.16.06.63.2,1.27.31,1.89.55.34.13.7.25,1.07.33.06.21-.25.12-.22.27.03.18.29.01.35.19,0,0,.01.02.02.02.13.02.28-.01.25-.15-.03-.12.09-.11.08-.18.14.11.27.24.48.2.18.16.37.26.61.28l.16.08c.14.22.37.3.61.35.02,0,.03,0,.05.01.08.19.19.36.37.45.1.05.26-.04.34.09.18.28.49.24.74.34.09.03.19.06.28.09.18.12.27.38.55.34.32.2.64.39.97.59.18.21.36.41.67.4.01,0,.03.02.04.03.01.12.06.22.2.22.03.01.06.03.09.04.02.11.07.19.21.14.15.13.31.25.4.44.03.19.19.18.32.22.11.25.32.35.57.38,0,0,0,0,0,0,.02.35.27.38.53.42.02.04.05.08.07.11,0,.05.02.07.07.05.02,0,.03,0,.05.01-.06.21.11.36.2.5.17.27.42.49.66.72.03.03.15-.02.22-.03,0,0,0,0,0,0,.09.15.09.4.37.34.04.04.07.09.11.13,0,.03-.01.07,0,.09.29.39.73.66.84,1.18,0,.04.07.08.11.09.18.03.22.17.27.31.02.06,0,.15.08.18.27.08.35.33.48.53.06.09.08.25.25.19.04.04.07.09.11.13-.01.12.04.19.16.19.03.05.07.1.1.15-.06.11-.02.17.09.2.04.06.08.12.12.18,0,.45.29.76.52,1.09,0,0,.02,0,.02,0,0,.04.03.05.07.04.02.04.04.08.06.12-.04.23.08.44.29.48.17.33.34.66.51.99-.05.1-.03.19,0,.29.06.2.08.41.2.59.12.18,0,.43.09.56.22.3.24.65.33.97.04.13,0,.28.15.36,0,.06,0,.11,0,.17,0,.17.03.33.05.49.03.19.04.41.21.55,0,.03,0,.06,0,.1-.15.15-.18.29.06.38,0,.1,0,.19,0,.29-.14.24-.05.49-.05.74-.01.48-.05.97-.04,1.45,0,.2.06.41.06.61-.01.52-.01,1.05-.01,1.57,0,.1-.04.2.04.28,0,.06-.02.12-.03.19-.14.32-.1.64-.05.97.02.19-.02.38-.05.57-.12.07-.13.15-.04.25.02.18.02.35-.01.53-.13.07-.13.15-.03.25l-.18,1.01c-.25.1-.14.35-.2.52-.1.29-.18.6-.27.9-.11.4.01.85-.29,1.2-.03.03,0,.1-.02.14-.11.33-.23.67-.35,1-.02.05-.05.12-.13.1-.08-.02-.05-.09-.06-.15,0-.11.06-.18.11-.27.03-.06.13-.12.08-.2-.11-.16-.01-.3.05-.41.18-.33,0-.75.29-1.04-.16-.23.05-.48-.04-.71,0-.1.1-.18.05-.29.3-.49.32-1.03.28-1.59,0-.04,0-.09,0-.13.05-.15.05-.3,0-.45,0-.13-.01-.26-.02-.38.21-.33.15-.74.14-1.07-.03-.59.05-1.17-.02-1.76-.1-.91.11-1.82.03-2.74-.06-.69-.11-1.38-.17-2.07-.18.09-.36.19-.55.29-.2.05-.4.11-.6.16-.37.04-.73.08-1.02.34-.14.06-.24.16-.34.27-.08.02-.2.01-.13.16-.02.06-.05.12-.07.18-.19.11-.28.27-.29.49,0,.02,0,.04.01.05-.1.06-.06.16-.07.25,0,.01-.01.03-.02.05-.25.26-.42.57-.52.92-.12.26-.34.41-.54.6-.18.02-.35.06-.49.18-.26.07-.51.17-.77.03-.05-.38-.33-.28-.56-.27-.16-.15-.39-.23-.42-.49.11-.46.38-.59.8-.37.07.03.15.04.22.06.07.1.16.05.25.05.15.1.21.02.23-.12h0c.13.02.25-.02.33-.11.2-.23.32-.52.63-.63.06-.02.09-.08.06-.15-.15-.31.06-.52.22-.73.06-.08.13-.13.15-.24.04-.27.2-.5.41-.63.47-.3.99-.54,1.48-.8.13-.07.31.01.41-.14.02,0,.04,0,.07,0,.14.06.28.06.42,0,.03,0,.06.02.09.02.08.13.22.15.35.2.16.07.23.03.17-.15-.1-.29-.23-.57-.31-.86-.11-.39-.37-.72-.47-1.12-.08-.31-.2-.6-.36-.88-.08-.14-.08-.24.15-.29-.23-.06-.34-.14-.38-.33-.03-.13-.11-.25-.19-.36-.37-.51-.7-1.05-.97-1.62-.06-.13-.13-.3-.32-.32-.22-.3-.44-.59-.66-.89-.07-.25-.16-.49-.45-.55-.15-.14-.18-.37-.37-.48-.16-.39-.45-.66-.8-.87-.12-.05-.1-.22-.23-.25-.19-.36-.46-.65-.83-.84Z"
      />
      <path
        className="cls-2"
        d="m70.52,53.61c.09.23-.12.48.04.71-.28.29-.11.71-.29,1.04-.06.11-.16.26-.05.41.06.09-.04.14-.08.2-.05.09-.11.16-.11.27,0,.06-.02.13.06.15.07.02.11-.05.13-.1.12-.33.24-.66.35-1,.02-.05,0-.11.02-.14.3-.35.18-.81.29-1.2.09-.3.16-.6.27-.9.06-.17-.06-.42.2-.52-.08.54-.14,1.09-.24,1.63-.08.43-.18.86-.33,1.26-.12.31-.24.62-.34.94-.14.49-.28.97-.42,1.46-.14.52-.37,1.02-.6,1.51-.32.7-.62,1.42-1.01,2.08-.35.59-.6,1.23-1.05,1.77-.25.29-.45.62-.66.95-.07.11-.16.2-.26.29-.38.33-.63.8-1.02,1.1-.28.21-.42.49-.64.74-.05.06-.11.11-.18.14-.2.1-.37.23-.5.43-.23.35-.61.56-.89.86-.2.21-.51.31-.59.63-.02.08-.11.07-.17.1-.1.05-.27.05-.2.25.02.06-.04.11-.09.14-.37.22-.64.56-.97.83-.41.34-.81.69-1.2,1.06-.37.35-.86.48-1.26.77-.56.42-1.29.55-1.85.96-.44.32-.94.48-1.42.7-.57.25-1.16.44-1.76.58-.42.1-.86.12-1.27.24-.44.13-.93.03-1.33.2-.39.16-.82.1-1.18.33-.06.04-.15.06-.23.07-1.32.22-2.65.19-3.99.13-.6-.03-1.21-.05-1.81-.07-.67-.03-1.33-.12-1.99-.27-.39-.08-.81-.12-1.22-.11-.48.01-.93-.15-1.37-.29-.58-.19-1.17-.38-1.74-.6-.66-.26-1.36-.39-2.04-.59-.76-.22-1.44-.64-2.13-1.03-.54-.3-1.08-.62-1.62-.92-.64-.36-1.26-.74-1.87-1.16-.06-.04-.15-.08-.13-.18.09-.01.15.04.22.08.49.31.98.64,1.47.94.82.5,1.71.86,2.49,1.44.09.06.2.08.28.04.12-.05,0-.15,0-.24.01-.13-.05-.19-.18-.13-.12.05-.22.02-.34-.04-.42-.22-.79-.53-1.23-.71-.1-.04-.29-.11-.25-.31.01-.07,0-.1-.07-.04-.16.14-.29,0-.39-.08-.11-.08.01-.2.04-.3.43.19.86.38,1.27.61.67.37,1.29.83,2.02,1.12.8.31,1.61.56,2.43.82.58.18,1.16.38,1.73.63.39.17.84.23,1.27.3.64.1,1.29.22,1.93.3.84.11,1.68.17,2.53.17.64,0,1.29,0,1.93.02,1.05.02,2.11.05,3.14-.26,1.26-.38,2.56-.49,3.85-.69.68-.11,1.29-.42,1.91-.7.52-.24,1.04-.5,1.53-.79.59-.35,1.22-.61,1.79-.98.71-.46,1.19-1.2,1.91-1.62.86-.5,1.36-1.33,2.01-2.01.38-.39.82-.7,1.17-1.12.27-.33.59-.59.84-.96.25-.38.48-.85.92-1.09.14-.07.26-.18.29-.31.1-.38.42-.62.58-.96.05-.11.17-.12.27-.15-.03.2-.11.39-.23.56-.26.35-.53.69-.78,1.04-.05.07-.13.17-.02.24.1.07.17-.03.22-.1.37-.48.82-.89,1.07-1.46.1-.23.32-.4.43-.62.24-.46.5-.9.74-1.36.06-.12.17-.22.06-.37-.12-.17-.23-.02-.35-.02.15-.52.3-1.03.75-1.38.05.04.06.31,0,.36-.21.15-.31.38-.46.57-.06.07-.17.16-.06.25.08.07.18.02.28-.03.12-.06.18-.17.21-.28.08-.32.4-.53.35-.94-.02-.21.17-.51.31-.7.19-.28.11-.63.33-.87.05-.06.02-.14-.05-.18-.07-.04-.14,0-.14.06.03.35-.26.54-.4.79-.14.25-.16.57-.43.74,0-.25.06-.48.21-.69.2-.27.35-.56.36-.92.02-.43.24-.81.38-1.21.1-.28.15-.59.22-.88.09-.39.09-.78.16-1.17.02-.12.04-.22.18-.22Zm-25.98,20.69s0,0,0,0c-.27,0-.54,0-.8,0-.09,0-.13.01-.16.09-.02.05.02.09.05.08.23-.1.44.03.67.02.4-.03.8-.02,1.2,0,.37.01.74-.06,1.11.06.05.02.13.02.14-.07,0-.07-.03-.14-.11-.16-.07-.01-.14-.01-.21-.01-.63,0-1.26,0-1.89,0Zm5.38-.16c.14.13.23.08.31.07.34-.02.63-.22.98-.26.4-.05.84.02,1.21-.23.03-.02.1.02.1-.06,0-.06-.06-.09-.1-.08-.19.05-.4-.07-.55.01-.38.2-.83.08-1.2.3-.21.13-.45.19-.74.25Z"
      />
      <path
        className="cls-1"
        d="m57.62,57.61c.07.01.14.03.21.04-.01.12-.02.23-.03.35-.22.13-.36-.06-.52-.13-.19-.09-.33-.25-.55-.31-.28-.08-.51-.05-.72.15-.11.02-.26-.07-.31.08-.19.49-.82.54-1.03,1.02-.06.14-.28.09-.34.25l-.17.02c-.11-.04-.2.01-.26.1-.09.04-.19.06-.29.03-.03-.04-.06-.05-.11-.02-.22-.06-.44.16-.66,0-.07-.12-.13-.09-.18.02-.64.12-1.27-.13-1.91-.08-.02-.16-.17-.1-.26-.15-.1-.06-.25-.11-.2-.25.04-.11.19-.12.31-.08.08.02.15.09.23.02,0-.07-.03-.12-.08-.13-.3-.08-.49-.4-.84-.35-.08,0-.16-.01-.21-.09-.16-.26-.48-.28-.68-.46-.04-.04-.08-.08-.12-.12-.06-.11-.14-.2-.26-.25,0,0-.02-.02-.03-.03,0-.08-.05-.12-.12-.14-.02-.02-.05-.04-.07-.06.04-.19-.12-.31-.18-.46-.14-.38-.16-.77-.2-1.16,0-.04.01-.07.02-.11.13-.02.14-.11.13-.22.02-.04.05-.08.07-.12.16-.15.25-.34.27-.56.07-.14.18-.26.31-.35.24-.19.22-.47.28-.73,0-.04,0-.08,0-.11.19-.05.11-.21.12-.32,0-.13.01-.25.17-.28.09.13-.07.33.12.43,0,.03,0,.07,0,.1-.05.02-.12,0-.13.07,0,.02.05.04.08.06.02.36-.15.66-.32.94-.22.35-.34.73-.55,1.09-.18.31.08.65.16.98.04.18.1.37.3.46-.04.24.17.31.31.41.21.15.38.31.35.6-.01.1.06.23.14.17.23-.17.4.05.59.07h0c.02.21.17.31.35.35.58.13,1.17.09,1.75.06.15,0,.29,0,.44,0,.07.04.13.06.19-.01.04,0,.08,0,.13,0,.04.1.11.13.21.11.04,0,.08,0,.11,0,0,0,0,0,0,0,.04,0,.07.02.11.03.14.02.23-.01.21-.18.08-.17.26-.18.39-.28.28-.12.56-.25.65-.59.1-.17.23-.3.41-.38.25,0,.45-.14.65-.25.42-.05.83-.04,1.15.3.07.08.22.05.27.17.02.12-.11.32.16.31Z"
      />
      <path
        className="cls-1"
        d="m60.77,47.92c-.13.08-.25.18-.41.2,0-.02-.02-.05-.03-.05-.36.03-.72.02-1.07-.06-.07-.02-.13.04-.18.08-.14-.09-.31.07-.45-.04-.29-.26-.68-.29-1.02-.3-.77-.02-1.53-.18-2.29-.23-.39-.03-.82-.06-1.16-.22-.4-.19-.78-.21-1.19-.18-.25.02-.5.12-.75.08-.02-.27.12-.37.35-.4.16-.02.32-.02.47-.08.29-.12.55.07.83.06.15,0,.31-.09.46,0,0,0,.01.01.01.01h-.01c.08-.2.24-.24.42-.24.82,0,1.64.08,2.46.18.51.06,1.01.23,1.52.23.22,0,.42.13.63.05.04,0,.07.02.11.02.02.16-.07.19-.19.15-.16-.06-.23.07-.26.16-.04.13.1.12.18.15.25.11.5.05.64-.14.18-.23.42-.27.67-.35.03,0,.07,0,.1,0,.09.02.17.03.26,0,.14-.06.3-.24.38.06,0,.01.1.01.1,0,.07-.31.32-.09.47-.16.02.02.04.04.06.06.01.17.15.21.28.26.23.1.5.2.34.56-.02.03,0,.1.03.14.14.21-.03.2-.15.23-.23-.19-.53-.24-.78-.38-.07-.13-.14-.12-.21,0-.04,0-.07.01-.11.02-.19-.07-.36-.07-.48.12Z"
      />
      <path
        className="cls-1"
        d="m40.63,43.33s.1,0,.12-.07c.24-.09.47-.06.7.04-.12.29-.34.47-.55.66-.13.12-.32.19-.38.38-.04.22-.23.3-.39.42-.1.07-.22.12-.33.18-.04.01-.08.01-.11.03-.31.27-.56.61-.98.74-.08.03-.1.11-.14.18-.15.27-.46.41-.69.35,0,0,0,0,0,0,0-.15-.15-.13-.22-.13-.35.02-.64-.08-.92-.28-.05-.07-.17-.06-.19-.17-.16-.36-.37-.68-.75-.86-.1-.11-.22-.18-.36-.23.02-.09-.37-.1-.06-.26.07-.04,0-.11-.03-.15-.05-.08-.1-.03-.13.02-.08.14-.21.18-.36.14-.19-.04-.38-.09-.56-.16-.2-.08-.32-.03-.39.16-.15.02-.22.15-.31.23-.15,0-.25.08-.35.19-.16.18-.35.27-.6.24-.13-.02-.16-.05-.11-.17.13-.36.37-.66.62-.93.21-.22.53-.29.84-.35.16-.03.27.04.31.16.06.23.24.19.34.12.24-.18.48-.14.73-.08.36.09.78.13,1.01.45.18.25.42.4.65.57.01.02.02.03.04.04.01.07.05.11.12.12.02.04.05.09.07.13.13.34.42.46.74.53.17.04.31,0,.39-.2.08-.19.22-.35.41-.45.18-.1.36-.2.5-.34.35-.34.59-.79,1.04-1.04.11-.06.24-.11.28-.25Z"
      />
      <path
        className="cls-2"
        d="m59.34,47.02c-.22.08-.42-.05-.63-.05-.51,0-1.01-.16-1.52-.23-.82-.1-1.63-.18-2.46-.18-.18,0-.34.04-.42.23h0c-.15-.11-.31-.02-.46-.01-.28.01-.54-.18-.83-.06-.14.06-.31.06-.47.08-.23.03-.37.13-.35.4.25.04.5-.06.75-.08.41-.04.79-.02,1.19.18.34.17.77.2,1.16.22.77.05,1.52.22,2.29.23.34,0,.73.03,1.02.3-.04,0-.08.02-.12,0-.62-.22-1.29-.12-1.93-.27-.31-.07-.63-.12-.94-.12-.71.01-1.37-.16-2.02-.41-.14-.06-.28-.05-.41-.03-.65.07-1.28.19-1.85.55-.44.27-.84.58-1.2.95-.08.09-.18.18-.19.29-.04.62-.26,1.2-.31,1.82-.05.64-.08,1.28-.11,1.93,0,.09-.02.18-.03.27-.19-.1-.03-.29-.12-.43-.15.03-.16.14-.17.28,0,.11.07.27-.12.32,0-.48.03-.97.11-1.45.03-.2-.06-.37-.05-.56.04-.97.2-1.93.7-2.76.22-.36.5-.73.92-.96.32-.17.56-.49.92-.62.55-.2,1.1-.38,1.68-.46.43-.06.88-.13,1.28-.04.56.14,1.12-.15,1.64.05.35.13.7.05,1.04.12.23.05.47.09.7.15.14.03.29.05.44,0,.28-.08.72.12.85.36Z"
      />
      <path
        className="cls-1"
        d="m42.33,72.2c-.05-.03-.11-.07-.16-.1-.02-.14-.1-.22-.24-.24-.02-.02-.04-.04-.06-.06.02-.09-.04-.11-.11-.13-.28-.31-.23-.7-.24-1.08.07-.04.04-.1.04-.16.02-.26,0-.53.05-.78.1-.53.21-1.08.56-1.53.03-.04.05-.11.05-.16-.01-.22.09-.4.17-.59.07-.18.22-.33.22-.54h0s.09-.01.11-.04c.37-.48.67-1.01.82-1.59.17-.65.18-1.34.15-2.01.18-.09.17-.21.08-.36.05-.09.03-.14-.07-.16-.01-.03-.03-.07-.04-.1.1-.02.07-.1.08-.17.01-.11.05-.2.18-.2.11,0,.2.07.22.17.09.35.23.69.21,1.07-.02.41,0,.81,0,1.22-.06.64-.29,1.24-.58,1.8-.19.38-.43.75-.7,1.09-.18.23-.24.48-.35.72-.11.26-.17.54-.35.76-.2.24-.09.55-.17.82-.04.13-.09.28-.08.43-.05.03-.08.07-.02.12.04.3-.05.6,0,.9-.08.1-.06.16.06.19,0,.17.18.25.21.41-.13.08.13.21-.03.29Z"
      />
      <path
        className="cls-1"
        d="m41.04,52.42s.03.01.05.02c.02.08.04.16.13.04.14.04.25.14.41.14,0,.09.05.12.13.1h0c-.03.1-.03.22.08.26.23.09.31.33.52.44.12.07.32.21.21.37-.1.13-.25-.04-.38-.1-.19-.09-.31-.31-.56-.3-.24-.01-.38-.22-.62-.27-1.07-.22-2.13-.47-3.23-.58-.71-.07-1.43-.05-2.13-.24-.16-.17-.37-.18-.58-.21-.55-.06-1.09-.18-1.61-.39-.18-.07-.36-.22-.28-.42.1-.23.02-.42-.05-.62-.03-.09-.1-.17.04-.21.12-.03.18.03.2.15.02.12,0,.29.19.32.13.12.3.19.46.27.39.55,1.03.47,1.57.61.12.03.3-.02.45.01.14.02.36.11.39-.17.39.18.81,0,1.21.11.09.05.19.09.3.04.04.02.08.04.12.06.38-.03.69.46,1.12.15.04-.03.13.03.2.05.1.02.18.09.29.06.1,0,.19.01.29.02.08.17.19.12.31.04.04,0,.07.01.11.02.2.15.43.18.67.21Z"
      />
      <path
        className="cls-2"
        d="m62.35,48.16c.12-.03.29-.02.15-.23-.03-.04-.05-.1-.03-.14.17-.36-.1-.45-.34-.56-.13-.06-.26-.09-.28-.26.41-.11.65.19.89.42.44.43.48.99.38,1.57-.02.14-.08.26-.07.41,0,.6,0,.62.59.66.74.06,1.49.07,2.24.12.67.04,1.35.07,2.02.06.44,0,.78.27,1.16.45.33.15.44.39.45.72,0,.15.02.3.07.44.15.48-.04.94-.11,1.41,0,.05-.02.11-.09.1-.09-.02-.14-.09-.2-.16-.39-.46-.34-1.04-.45-1.58-.05-.22-.1-.39-.31-.52-.34-.21-.71-.31-1.1-.4-1.28-.3-2.57-.1-3.86-.22-.41-.04-.84-.38-.92-.8-.04-.21.02-.45-.02-.69-.05-.27-.08-.54-.19-.79Zm7.1,4.23c.03-.24-.02-.41-.05-.59-.02-.1-.04-.18-.16-.16-.11.02-.22.06-.21.2.02.18.01.36.07.52.05.14,0,.41.24.37.2-.03.08-.27.1-.35Z"
      />
      <path
        className="cls-1"
        d="m41.23,40.09c-.06-.1-.19-.15-.19-.29.04-.02.04-.06.04-.1-.03-.34-.27-.66-.05-1.02.04-.07-.02-.13-.11-.14-.03-.12-.06-.24-.08-.36.2-.19.18-.33-.09-.48-.01-.1-.02-.19-.03-.29.16-.17.09-.31-.04-.45-.39-.42-.55-1.4-.31-1.91.02-.05.07-.1.12-.13.17-.08.18-.22.15-.38.01-.01.03-.02.04-.02.13.02.22-.02.26-.15.04-.03.07-.05.11-.08.39,0,.77.03,1.16-.04.07,0,.14.02.21.03.03.08.08.08.14.04.21.02.41.04.62.06.03.08.07.14.14.02.06.02.13.04.19.05-.06.08-.1.15.02.21.11.05.23.1.28-.07.1.03.21.03.28.11-.02.15.04.2.19.17.18.18.35.37.53.55.03.18-.09.21-.23.23-.16-.13-.34-.23-.48-.41-.21-.28-.57-.21-.85-.33-.07-.08-.12-.07-.18.02-.31.06-.63.01-.94.02-.31-.1-.61-.03-.9.07-.01,0-.01.05-.02.08-.05.06-.1.12-.15.18-.15.12-.12.26-.04.4.09.13.09.26.04.41-.03.26.06.48.17.71.04.07.34.33-.08.34-.05,0-.04.06-.04.1,0,.17-.01.34.01.51.03.2.11.36.36.19,0,.32.15.61.09.91,0,.01.06.04.09.06.18.27.18.62.4.87-.09.28.2.29.32.43-.4.19-.44.18-.68-.12-.16-.2-.32-.16-.48,0Zm1.34-5.61c-.12,0-.22-.02-.32-.02-.11,0-.29-.07-.3.08,0,.16.17.18.32.19.16,0,.25-.07.3-.26Zm-1.17,4.27c-.02-.05,0-.14-.11-.13-.08,0-.13.06-.13.13,0,.07.03.14.11.15.09,0,.11-.07.12-.15Z"
      />
      <path
        className="cls-1"
        d="m55.8,43.54c-.31.01-.62.02-.92.08-.09.02-.16.04-.22.11-.23-.01-.36.13-.46.31l-.12.06c-.19.05-.38.06-.48-.16.25-.1.46-.28.68-.43.12.02.17-.07.26-.12.27-.15.47-.45.8-.46.76-.04,1.49-.26,2.24-.29.12-.03.22,0,.33.04.02.07.07.13.15.11.42-.11.79,0,1.18.17.22.1.39.31.66.31h0c.02.18-.06.38.16.49-.02.33-.02.67-.05,1-.04.41.13.63.56.66.05,0,.09.02.14.04-.06.14-.11.28-.1.44-.27-.09-.58.03-.84-.15-.31-.22-.36-.56-.41-.89-.03-.2-.02-.41-.02-.62.14-.32-.1-.66-.46-.64h.01s-.01,0-.01,0c0-.02,0-.04,0-.04-.04,0-.03.02-.03.04-.8-.11-1.6-.08-2.41-.09-.21-.06-.42-.11-.61.05Zm3.77.39s-.01-.08-.03-.09c-.04-.03-.08,0-.09.04,0,.02.02.05.04.06.02,0,.05,0,.08-.01Z"
      />
      <path
        className="cls-1"
        d="m54.8,37.89c-.07.06-.15.11-.24.12-.21-.11-.59.12-.58.37-.04.04-.09.07-.13.11-.28-.01-.38.11-.27.38-.2.18-.21.48-.43.65-.25.04-.48.1-.61.34-.14.14-.11.38-.31.47-.1-.03-.19.03-.28.06-.3.1-.6.19-.89.29-.06.02-.13.05-.16-.01-.04-.08.02-.15.08-.17.12-.04.18-.14.26-.22.37-.37.63-.89,1.24-.96.09-.01.21-.06.16-.16-.14-.27.08-.49.07-.74-.02-.13.13-.17.16-.28.14-.02.13-.15.17-.25.03-.07.02-.17.1-.21.31-.13.45-.43.67-.65,0,0,.02-.01.02-.02.24-.05.51-.05.72-.15.66-.34,1.21-.05,1.76.27.12.07.15.16.08.27-.12.19-.04.28.14.31.11.02.2.02.17.17-.03.13-.12.14-.23.13-.27-.02-.49-.14-.71-.28-.05-.04-.1-.13-.17-.08-.16.11-.35.05-.52.08-.11.02-.24.02-.28.17Z"
      />
      <path
        className="cls-2"
        d="m41.23,40.09c.16-.16.32-.2.48,0,.24.3.28.31.68.12-.11-.14-.4-.15-.32-.43.28.3.6.29.95.14.08-.03.19-.13.29,0-.25.08-.31.35-.51.49.11.12.24.09.32.03.39-.31.83-.44,1.33-.42.07,0,.15-.01.15-.1,0-.08-.06-.12-.12-.15-.1-.07-.24.04-.33-.09.08-.19.25-.13.39-.12.45,0,.78.35.78.78,0,.12.02.23.05.35.12.56.03,1.06-.37,1.48-.31.32-.73.44-1.14.55-.69.18-1.35.41-1.97.77-.47.27-.86.67-1.38.87.07-.19.25-.26.38-.38.2-.19.42-.37.55-.66-.22-.1-.45-.12-.7-.04.19-.3.53-.37.8-.54.22-.15.43-.36.74-.36.02.16-.1.16-.2.2-.1.04-.24.07-.2.25.18,0,.42-.2.48.17.01.07.1.03.14-.01.1-.09.2-.19.3-.29.15-.16.22-.32-.04-.45.36-.13.72-.26,1.1-.27.4-.01.7-.14.98-.46.2-.22.28-.3.1-.56-.06-.09-.06-.31-.1-.47-.06-.29-.18-.34-.47-.27-.46.11-.87.34-1.3.52-.46.2-1.33.17-1.57-.15-.11-.15-.25-.28-.29-.47Z"
      />
      <path
        className="cls-1"
        d="m57.31,65.93c-.04-.08-.08-.15-.08-.24.59-.21.4-.85.67-1.23.07-.1.01-.19-.01-.28,0-.02,0-.03,0-.05.21-.05.08-.27.2-.39.15-.15.3-.33.06-.55-.06-.06-.03-.2.01-.29.15-.28-.02-.41-.23-.52,0,0-.01-.01-.01-.01.01-.05,0-.09-.06-.09-.03-.1-.11-.18-.09-.29.07-.2.08-.44.03-.6-.1-.31-.18-.64-.05-.9.12-.24,0-.28-.13-.37-.03-.19-.03-.38.13-.53.11-.04.14-.16.2-.24.17-.22.26-.51.6-.54-.32.47-.42.99-.36,1.56.04.33.12.64.23.95-.05,0-.12,0-.11.06.05.27.31.51.1.81,0,0,.01.04.03.05.26.12.28.42.47.6,0,.15,0,.31,0,.46-.13.21-.2.43-.07.67-.02.06-.05.12-.07.19-.06,0-.12,0-.17-.02-.07-.02-.08-.21-.19-.09-.08.08-.09.23.01.29.23.15.15.35.11.55,0,.04-.01.08-.02.11-.11.09-.25.11-.45.16.2.07.33.15.3.32,0,.04,0,.07-.01.11-.09,0-.16.07-.17.14-.03.23-.18.25-.39.22.13.13.17.26.22.41.06.22,0,.45.1.66.02.16.04.32.06.48-.01.02-.04.05-.03.07.05.14.08.27-.07.36-.15.1-.2-.07-.29-.11-.03-.01-.06-.02-.08-.02-.28-.37-.45-.79-.47-1.25.08-.19.17-.38.11-.59Zm.61-6.09c-.07,0-.12.05-.13.13-.01.08,0,.18.09.19.11.02.15-.1.17-.17.02-.07-.06-.12-.13-.15Zm.05-.14c.06,0,.09-.04.1-.09,0-.04-.02-.07-.07-.07-.06,0-.09.02-.09.08,0,.04,0,.08.06.08Z"
      />
      <path
        className="cls-1"
        d="m59.99,33.51c-.06,0-.11.02-.17.03-.01-.01-.03-.04-.04-.04-.34.08-.68.14-.99-.09-.08-.06-.17,0-.16.13-.22-.16-.47.02-.72-.07-.64-.24-1.33-.2-1.99-.36-.3-.07-.7.33-.68.65-.15.01-.16.12-.12.21.05.13.19.06.29.08,0,0,0,0,0,0,0,.14.1.17.21.2.04.05.08.09.12.14.12.17.1.51.46.39.26.13.45.38.76.4.01.23-.11.32-.33.32-.1,0-.2-.02-.29.04-.04,0-.07,0-.11,0,0-.07-.14-.13.01-.22.05-.03.08-.24-.02-.32-.12-.1-.21.04-.3.1-.06.04-.05.1-.05.16h0c-.14.03-.22-.15-.37-.11-.01-.01-.03-.02-.05-.02-.15-.23-.33-.41-.61-.46-.23-.08-.27-.33-.42-.48.02-.02.04-.05.07-.06.34-.09.35-.1.11-.38-.06-.07-.03-.12-.02-.18.11-.54.55-.84.88-1.22.27-.06.54-.05.81,0,.03.08.07.13.13.02.05.02.11.03.16.05.08.1.17.1.26,0,.38,0,.71.19,1.08.25.07.11.15.11.24.03.03,0,.07.02.1.02.11.25.25.42.56.27.04-.02.09.02.12.06.13.14.28.13.43.05.11-.05.22-.11.3.05.03.06.1.05.16.04.17-.03.33.03.51.04-.05.19-.29.11-.34.28Zm-4.53-.82c.12.14.2.24.35.23.08,0,.2.04.21-.09,0-.09-.07-.15-.18-.14-.11,0-.21,0-.37,0Zm2.63.57c.1-.03.12-.1.11-.18,0-.07-.04-.15-.12-.13-.09.01-.11.1-.11.18,0,.07.05.12.13.13Zm-2.29,1.6s-.03-.05-.03-.07c-.02.02-.05.03-.06.05,0,.01.02.04.03.06.02-.01.05-.03.06-.04Z"
      />
      <path
        className="cls-1"
        d="m46.56,35.52c.07-.01.14-.03.21-.04.13.01.27,0,.29-.14.03-.22.03-.45-.16-.62-.02-.12-.05-.23-.07-.35.13-.3.05-.51-.27-.62-.27-.46-.75-.57-1.21-.71-.03-.05-.03-.16-.12-.05-.06,0-.11-.02-.17-.02-.03-.17-.25-.3-.13-.51.06,0,.12,0,.18-.01.02.02.05.04.07.05.3.04.62-.1.9.13.03.03.16,0,.17-.11.04,0,.07,0,.11,0,.28.17.53.4.87.44.33.32.45.76.62,1.17-.19.14,0,.17.07.24,0,.26,0,.51,0,.77-.16.2-.31.41-.52.56-.11.08,0,.15,0,.23-.32.26-.41.69-.73.95-.22.11-.45.19-.69.04-.12-.07-.25-.15-.38-.22-.01-.01-.02-.03-.02-.05.15-.1.4-.1.37-.37h0c.13,0,.27,0,.31-.15.06-.22.22-.39.3-.59Z"
      />
      <path
        className="cls-2"
        d="m26.57,46.73c.28.16.24.48.31.72.1.32.03.67.03,1,0,.07-.07.09-.11.13-.05-.18.09-.39-.1-.58.1.25-.19.29-.22.51-.05.42.25.64.39.95.17.36.49.53.86.61.11.02.22.05.29.13.07.08.08.21.24.12.18-.1,0-.21.03-.31.32.07.46.37.66.57.51.5.9,1.1,1.08,1.81.08.32.14.66.12.99-.04.66.1,1.3.13,1.95.02.4,0,.79,0,1.19,0,.09.03.21-.11.25-.19-.21.04-.45-.06-.68-.03-.06.1-.19-.04-.21-.08,0-.2.05-.23.18-.05.26-.17.51-.11.78.02.08.05.21-.12.21-.12-.81-.02-1.61.04-2.42,0-.05-.01-.1-.03-.14-.19-.47-.15-.94-.08-1.43.04-.28-.21-.48-.2-.75,0-.04,0-.08,0-.11.09-.01.14.02.18.11.05.14.13.27.19.4.02.05.06.09.12.07.05-.01.07-.06.07-.12-.04-.43-.16-.83-.44-1.18-.07-.09-.19-.09-.25-.19-.2-.37-.2-.37-.51-.1,0,0-.02,0-.03,0-.22-.11-.3-.35-.47-.51-.34-.31-.75-.5-1.13-.76-.37-.25-.65-.62-.7-1.03-.05-.39-.12-.81-.04-1.19.07-.34-.09-.51-.26-.7-.2-.23-.36-.47-.52-.72.34,0,.61.22.64.55.01.2.12.31.26.4.06.04.12.1.19.05.08-.05.03-.13,0-.19-.04-.13-.09-.26-.07-.41Zm3.35,8.08c-.13-.01-.18.05-.18.17,0,.13,0,.26,0,.39,0,.09-.03.2.08.23.05.01.15-.03.18-.07.05-.09.05-.18-.06-.25-.12-.07-.11-.14.03-.17.09-.02.2,0,.16-.14-.02-.11-.09-.18-.21-.16Z"
      />
      <path
        className="cls-2"
        d="m30.16,57.02c-.04.6-.3,1.12-.58,1.64-.39.74-.86,1.45-1.06,2.28,0,.04-.02.08-.03.12-.08.4-.07.44.34.52.71.15,1.35.43,1.9.92.18.16.41.24.59.41.06.06.15.02.23.02.52.03,1.04-.09,1.56.13.2.09.48.05.7.17.05.03.13.04.11.12-.03.09-.11.07-.17.05-.73-.27-1.49-.32-2.26-.29-.3.01-.54-.11-.77-.28-.38-.27-.76-.52-1.23-.64-.3-.08-.58-.13-.88-.17-.28-.04-.6-.15-.73-.5-.11-.29-.09-.57.11-.78.16-.18.27-.35.21-.59-.05-.22.11-.37.18-.54.36-.79.72-1.57,1.09-2.35.03-.06.04-.14.14-.13.07.08.1.16.03.26-.05.08-.21.17-.08.26.13.09.12-.14.23-.16.08-.02.07-.1.08-.17,0-.19.11-.28.29-.3Z"
      />
      <path
        className="cls-2"
        d="m54.8,37.89c.04-.15.17-.16.28-.17.17-.02.35.03.52-.08.07-.05.12.04.17.08.21.15.44.26.71.28.11,0,.2,0,.23-.13.03-.15-.06-.15-.17-.17-.18-.03-.26-.12-.14-.31.07-.11.04-.2-.08-.27-.55-.32-1.1-.6-1.76-.27-.21.11-.48.11-.72.15-.09-.22.08-.22.2-.21.33,0,.62-.06.89-.25.21-.15.44.01.66.05.1.02.19.05.3.05.39,0,.61.29.84.54.33.38.44.85.55,1.33.08.39.37.58.75.49.45-.11.88-.24,1.3-.44.85-.4,1.72-.76,2.67-.88.49-.06.96-.33,1.47-.28.31.03.63-.04.91.13-.02.07-.08.1-.14.08-.29-.08-.59-.04-.89-.04-.32,0-.64-.03-.89.25-.03.03-.09.04-.14.03-.58-.04-1.13.13-1.67.32-.33.12-.59.38-.95.46-.2.04-.41.23-.51.48.81-.34,1.61-.66,2.51-.49-.03.1-.12.08-.19.1-.24.06-.5.06-.74.05-.44-.01-.79.2-1.12.39-.37.21-.77.24-1.15.35-.27.08-.55.12-.84.13-.7.03-.92-.33-1.05-.82-.13-.5-.38-.85-.96-.93-.29-.04-.56-.06-.84,0Z"
      />
      <path
        className="cls-2"
        d="m52.69,38.41c0,.25-.21.47-.07.74.05.1-.06.15-.16.16-.61.07-.87.59-1.24.96-.08.08-.14.18-.26.22-.06.02-.12.09-.08.17.03.06.1.03.16.01.3-.1.6-.19.89-.29.09-.03.18-.09.28-.06-.25.22-.53.4-.83.54-.25.12-.46.34-.77.34-.02,0-.07.04-.07.05.06.32-.27.55-.17.92.11.42.41.66.66.95.29.33.63.61,1.02.81.4.21.83.26,1.26.11.09-.03.17-.11.28-.09.11.22.29.2.48.16-.28.23-.61.34-.95.42-.94.2-1.61-.32-2.27-.86-.24-.2-.45-.44-.71-.62-.7-.49-.56-1.78.1-2.29.75-.58,1.55-1.14,2.04-2,.09-.17.23-.28.41-.34Z"
      />
      <path
        className="cls-1"
        d="m61.69,38.62c-.9-.16-1.7.16-2.51.49.1-.24.31-.43.51-.48.36-.08.62-.34.95-.46.54-.19,1.09-.36,1.67-.32.05,0,.11,0,.14-.03.24-.28.57-.25.89-.25.3,0,.6-.04.89.04.06.02.12-.01.14-.08.19,0,.28-.16.41-.26.31-.11.67-.09.92-.39.11-.14.31-.2.48-.29.1-.05.11.03.12.11-.11.13-.26.23-.32.41-.26.18-.4.43-.46.73,0,0,0,0,0,0-.04,0-.08,0-.11.02-.36.25-.7.53-1.17.5-.08,0-.12.06-.12.14-.09.03-.17.03-.26,0-.03-.07-.08-.1-.14-.03-.54-.17-1.03.13-1.55.14-.16,0-.32,0-.48.01Zm2.04-.67c.06-.01.17.03.17-.07,0-.11-.11-.1-.18-.1-.06,0-.16-.04-.17.06,0,.12.11.09.18.11Z"
      />
      <path
        className="cls-2"
        d="m59.99,33.51c.05-.17.28-.08.34-.28-.17,0-.34-.07-.51-.04-.06.01-.13.02-.16-.04-.08-.16-.19-.1-.3-.05-.16.07-.31.09-.43-.05-.03-.04-.08-.08-.12-.06-.31.15-.45-.02-.56-.27.14-.05.3-.02.4.03.52.23.98-.02,1.46-.15.3-.08.55-.1.89-.01.45.12.63.38.78.72.18.42.13.86-.06,1.27-.09.2-.34.26-.5.4-.07.06-.18.07-.13.22.03.07-.06.12-.12.15-.41.21-.84.29-1.29.15-.1-.03-.13-.1-.14-.2,0-.14.07-.23.19-.27.24-.07.49-.11.73-.2.43-.16.77-.36.68-.79-.08-.4-.3-.79-.84-.55-.1.04-.19.06-.29.03Z"
      />
      <path
        className="cls-2"
        d="m27.21,31.89c-.18.24-.33.52-.55.72-.26.23-.52.45-.72.74-.11.16-.23.29-.42.37-.27.11-.41.35-.54.58-.23.41-.51.79-.83,1.13-.16.18-.27.39-.35.61-.02.05-.03.11-.06.13-.34.23-.56.57-.75.91-.21.39-.51.72-.67,1.16-.14.39-.31.78-.45,1.16-.11.31-.3.57-.38.87-.06.23-.11.47-.25.67-.03.04-.04.08-.03.14.06.2,0,.36-.09.55-.22.43-.45.86-.57,1.32-.08.32-.15.65-.22.97-.02.09,0,.23-.15.25-.28-.28,0-.53.06-.78.03-.11.07-.23.1-.35.11-.57.31-1.12.53-1.66.27-.66.53-1.31.81-1.96.3-.68.62-1.36.92-2.03.48-1.08,1.23-1.96,1.97-2.87.39-.48.72-1.03,1.18-1.43.47-.41.81-1,1.46-1.2Z"
      />
      <path
        className="cls-2"
        d="m37.04,44.78c-.23-.17-.47-.32-.65-.57-.23-.33-.65-.36-1.01-.45-.25-.06-.49-.1-.73.08-.1.07-.27.11-.34-.12-.04-.13-.15-.19-.31-.16-.3.06-.63.13-.84.35-.26.27-.49.57-.62.93-.04.11-.01.15.11.17.25.03.45-.06.6-.24.1-.11.2-.18.35-.19-.35.41-.55.93-.99,1.28.04-.15.08-.3.13-.45.04-.1.06-.19-.05-.26-.12-.08-.25-.11-.4-.04-.11.05-.23.17-.2.23.18.33-.27.47-.2.76-.32.16-.42.53-.7.75-.38.29-.7.65-.52,1.21.04.12.02.27-.05.4-.15.3-.05.55.27.74.07.08.06.16-.03.2-.11.04-.25.04-.32-.08-.13-.22-.38-.38-.23-.73.12-.28-.08-.6,0-.91.09-.32.18-.63.51-.79.4-.19.5-.58.66-.94.33-.74.78-1.41,1.32-2.01.27-.3.66-.48,1.04-.59.32-.09.66.07.98.16.07.02.15.07.23.06.52-.02.96.23,1.37.49.25.16.52.39.58.73Z"
      />
      <path
        className="cls-2"
        d="m44.34,64.69c0-.41-.02-.82,0-1.22.02-.38-.13-.72-.21-1.07-.03-.1-.11-.17-.22-.17-.13,0-.17.09-.18.2,0,.07.02.15-.08.17-.14.04-.12-.11-.13-.14-.02-.31-.17-.62-.02-.93.05-.1.02-.19,0-.29-.03-.19-.06-.39.09-.54.13-.13,0-.26.03-.39.13-.6.12-1.22.1-1.82,0-.23-.12-.45-.19-.67-.02-.06-.05-.11-.05-.17-.02-.71-.41-1.3-.65-1.93-.06-.16-.16-.3-.11-.48.24.17.2.55.5.67-.09.28.12.48.23.69.15.28.13.59.16.88.01.13.03.3.17.3.15,0,.17-.16.17-.3,0-.11,0-.22.01-.33.2.14.15.37.18.56.08.42.21.84.16,1.27-.01.09.05.2-.08.26-.1-.12-.03-.27-.05-.4-.02-.12-.11-.15-.19-.16-.13-.02-.09.1-.1.17-.01.32.01.63-.04.95-.02.14-.12.39.08.43.11.02.1-.26.12-.41.02-.17,0-.35.17-.46.03.44-.07.85-.16,1.27-.04.19-.08.38-.1.58-.02.26-.02.5.14.73.24.34.26.77.3,1.17.05.49.04.99,0,1.49,0,.05-.03.09-.09.11Z"
      />
      <path
        className="cls-2"
        d="m37.51,69.82s-.09-.08-.11-.14c-.18-.74-.5-1.46-.62-2.2-.09-.56-.27-1.06-.48-1.56-.14-.33-.3-.67-.62-.89-.06-.04-.17-.1-.11-.18.06-.08.16-.07.26,0,.41.27.76.64.88,1.08.14.51.5.91.58,1.45.05.35.29.66.4,1.01.4,1.22.94,2.39,1.21,3.65.03.12.11.16.18.22.1.09.07.17-.02.24-.24.17-.73.01-.82-.28,0,0,.03-.02.04-.03.04,0,.08,0,.12,0,.36,0,.42-.06.28-.38-.16-.37-.2-.76-.33-1.14-.21-.63-.43-1.25-.68-1.85-.04-.1-.1-.2-.21-.17-.12.03-.04.14-.04.22,0,.32.14.62.08.95Z"
      />
      <path
        className="cls-1"
        d="m26.57,46.73c-.02.14.03.27.07.41.02.06.08.13,0,.19-.07.05-.13-.01-.19-.05-.14-.1-.25-.2-.26-.4-.02-.33-.3-.56-.64-.55-.13.02-.17-.11-.24-.17,0-.11-.07-.17-.18-.17,0,0,0,0,0,0-.05-.27-.09-.56-.4-.67-.02-.1-.13-.11-.19-.17-.05-.2-.04-.45-.36-.42-.21-.09-.31-.27-.36-.48,0-.15-.08-.15-.18-.12-.01-.02-.02-.04-.04-.06.08-.02.17-.05.26-.08-.08-.09-.1-.35-.26-.07,0,0-.04,0-.06,0-.06-.08-.09-.17-.09-.28.09-.09-.12-.4.23-.3.26.41.55.81.94,1.12-.11.07-.03.1.02.15.27.28.67.47.74.92,0,.02.04.04.07.05.42.23.68.6.9,1.01.06.1.12.15.23.14h0Z"
      />
      <path
        className="cls-1"
        d="m30.91,49.19c-.32-.18-.42-.43-.27-.74.07-.14.08-.29.05-.4-.18-.56.14-.92.52-1.21.28-.22.38-.59.7-.75-.07-.28.38-.43.2-.76-.04-.07.09-.18.2-.23.14-.07.27-.04.4.04.11.07.09.16.05.26-.05.15-.09.3-.13.45-.02.11,0,.24-.15.28-.12.01-.17.11-.23.2-.06.11-.14.25-.28.23-.28-.04-.34.12-.36.34,0,.06,0,.1-.09.13-.32.12-.57.5-.57.84,0,.07-.03.17.09.19-.04.16-.12.31-.1.48-.17.12-.16.24,0,.37,0,.1.03.2-.02.29Z"
      />
      <path
        className="cls-1"
        d="m31.85,70.11c-.03.1-.15.21-.04.3.1.08.23.23.39.08.06-.06.09-.03.07.04-.04.21.16.27.25.31.45.18.81.49,1.23.71.12.06.22.09.34.04.13-.06.2,0,.18.13,0,.08.12.18,0,.24-.09.04-.2.02-.28-.04-.77-.57-1.67-.94-2.49-1.44-.5-.3-.98-.63-1.47-.94-.07-.04-.13-.1-.22-.08-.02-.01-.03-.03-.05-.04-.05-.15-.19-.22-.29-.32-.05-.05-.13-.13-.04-.19.07-.04.21-.14.26-.01.14.34.46.25.71.34.02,0,.03.01.05.02-.01.06-.02.12-.03.17-.05.19.13.21.22.26.14.08.14-.08.18-.15.04,0,.07.02.11.03.02.48.39.71.92.56h0Z"
      />
      <path
        className="cls-1"
        d="m43.98,57.14c0,.11-.01.22-.01.33,0,.14-.01.3-.17.3-.15,0-.16-.17-.17-.3-.03-.3-.01-.6-.16-.88-.11-.21-.32-.4-.23-.69-.3-.12-.27-.5-.5-.67,0-.04-.02-.07-.03-.11.04-.01.06-.03.05-.07,0-.04-.04-.05-.08-.05.03-.14.06-.28-.03-.41.03-.18-.12-.26-.19-.38-.04-.06-.05-.13.01-.19.07-.07.12-.02.18.03.21.15.44.28.56.53,0,.04.02.08.02.12-.07.04-.06.08,0,.12.02.08.05.17.07.25-.08.13,0,.26.03.35.09.26.07.61.42.73.07.33.14.67.21,1Z"
      />
      <path
        className="cls-2"
        d="m30.4,69.22c-.24-.09-.57,0-.71-.34-.05-.12-.19-.03-.26.01-.1.06-.02.14.04.19.11.1.24.17.29.32-.02,0-.04.02-.05.02-.48-.38-1.03-.66-1.48-1.08-.18-.17-.42-.21-.61-.36-.1-.08-.21-.14-.28-.26.34,0,.55.28.84.39.09-.3,0-.43-.26-.58-.21-.12-.38-.31-.52-.51.39.02.62.33.88.54.46.37.97.67,1.42,1.04.24.2.47.4.7.61Z"
      />
      <path
        className="cls-2"
        d="m29.74,30.94c.04-.15.18-.2.3-.27.36-.21.71-.43,1.01-.73.14-.14.35-.22.52-.33.03-.02.07-.05.1-.05.31-.02.26-.49.55-.48.31.01.53-.15.74-.31.42-.33.89-.59,1.37-.8.32-.15.67-.26.94-.48.26-.21.57-.25.85-.36.1-.04.24-.04.35.02-.26.23-.62.27-.92.42-1.32.68-2.64,1.37-3.88,2.19-.54.36-1.06.73-1.59,1.11-.11.08-.22.07-.34.06Z"
      />
      <path
        className="cls-1"
        d="m37.51,69.82c.06-.32-.08-.63-.08-.95,0-.08-.08-.19.04-.22.11-.03.17.08.21.17.26.61.48,1.23.68,1.85.12.38.16.78.33,1.14.14.32.09.38-.28.38-.04,0-.08,0-.12,0-.02-.04-.05-.08-.07-.12-.03-.64-.3-1.24-.24-1.89,0-.06-.05-.09-.1-.08-.17.03-.23-.13-.35-.18,0-.04-.02-.08-.03-.12Z"
      />
      <path
        className="cls-2"
        d="m70.29,43.42c.19-.1.37-.2.55-.29.06.69.11,1.38.17,2.07.08.91-.14,1.83-.03,2.74.07.59-.01,1.17.02,1.76.02.33.08.74-.14,1.07-.09-.04-.09-.13-.08-.21.09-.59,0-1.19.03-1.78.03-.65.01-1.3,0-1.95,0-.55.1-1.11.03-1.64-.06-.42-.1-.85-.19-1.27-.01-.06-.04-.12-.03-.17.04-.27-.09-.34-.33-.32Z"
      />
      <path
        className="cls-1"
        d="m68.31,60.31c.11,0,.23-.14.35.02.11.16,0,.25-.06.37-.24.46-.5.9-.74,1.36-.11.21-.33.38-.43.62-.25.57-.7.98-1.07,1.46-.05.07-.12.17-.22.1-.1-.07-.02-.17.02-.24.26-.35.53-.69.78-1.04.12-.16.19-.35.23-.56h0c.14.02.21-.07.27-.18.17-.33.35-.66.51-1,.12-.25.2-.52.3-.79.06-.03.05-.08.05-.13Z"
      />
      <path
        className="cls-2"
        d="m52.7,25.11c0,.08.01.16-.07.24-.07-.14-.14-.35-.29-.05-.06.12-.12,0-.15-.02-.18-.16-.37-.18-.59-.08.02.09.17.07.15.19-1.13-.35-2.33-.43-3.38-1.04.61.13,1.25.12,1.85.29.06.02.11.05.17.04.6-.04,1.15.22,1.73.32.2.03.41-.02.59.13Z"
      />
      <path
        className="cls-2"
        d="m69.65,42.5c-.1.15-.28.08-.41.14-.5.26-1.01.5-1.48.8-.21.13-.37.36-.41.63-.02.11-.09.16-.15.24-.16.22-.37.42-.22.73.03.07,0,.13-.06.15-.31.11-.43.41-.63.63-.08.09-.2.13-.33.11.37-.41.67-.87.85-1.4.1-.28.16-.58.33-.83.31-.45.8-.66,1.23-.96.32-.22.66-.36,1.05-.36.09,0,.18-.01.22.1Z"
      />
      <path
        className="cls-2"
        d="m33.57,50.92c-.19-.03-.16-.2-.19-.32-.02-.12-.08-.19-.2-.15-.14.04-.07.12-.04.21.07.2.15.38.05.62-.08.2.1.35.28.42.52.21,1.05.33,1.61.39.21.02.42.03.58.21-.51-.05-1.02-.11-1.51-.26-.27-.08-.55-.13-.8-.27-.41-.23-.57-.59-.57-1.03,0-.27,0-.53-.07-.79-.03-.1,0-.2.03-.29.08-.16.2-.2.27-.03.15.4.52.69.55,1.14,0,.05,0,.1,0,.15Z"
      />
      <path
        className="cls-2"
        d="m67.9,36.81c.19.02.25.19.32.32.27.57.6,1.11.97,1.62.08.11.17.23.19.36.04.18.15.27.38.33-.24.06-.23.15-.15.29.16.28.28.57.36.88.1.39.36.72.47,1.12.08.29.21.57.31.86.06.18,0,.22-.17.15-.12-.05-.26-.08-.35-.2.22,0,.2-.12.16-.27-.33-1.18-.74-2.32-1.36-3.38-.37-.64-.75-1.28-1.13-1.93-.02-.04,0-.1,0-.14Z"
      />
      <path
        className="cls-2"
        d="m37.57,29.25c-.09-.31-.07-.66-.09-1.01,0-.21.07-.41.11-.61.02-.1.09-.18.22-.16.12.02.15.12.14.23-.05.52,0,1.05-.03,1.57-.02.35.1.61.31.86.05.06.16.12.09.22-.07.1-.17.03-.24,0-.23-.11-.42-.23-.41-.54,0-.18-.16-.34-.1-.56Z"
      />
      <path
        className="cls-2"
        d="m36.32,26.12c-.02.23-.21.32-.38.36-1.02.26-1.92.8-2.83,1.29-.35.19-.71.38-1.04.61-.27.19-.61.26-.88.48-.13.11-.19.29-.37.35-.1.03-.17.06-.19-.07.3-.33.61-.65,1.08-.73.09-.02.18-.07.24-.16.1-.16.26-.25.43-.3.35-.1.63-.31.95-.47.62-.32,1.24-.66,1.9-.92.32-.13.63-.29.94-.44.05-.03.11-.06.16,0Z"
      />
      <path
        className="cls-2"
        d="m20.08,44.35c.07.15.04.32.02.47-.09.46-.21.91-.26,1.38-.03.32-.15.65-.22.98-.08.34-.06.7-.19,1.04-.06.16.11.35.02.54-.02.05-.03.12-.1.13-.07-.25-.08-.52-.06-.78.07-.96.29-1.9.41-2.85.04-.28.21-.51.24-.79,0-.06.05-.14.14-.12Z"
      />
      <path
        className="cls-1"
        d="m69.01,58.7c.27-.17.29-.49.43-.74.14-.25.43-.45.4-.79,0-.05.07-.1.14-.06.07.04.1.12.05.18-.22.25-.14.6-.33.87-.14.2-.33.5-.31.7.04.41-.28.61-.35.94-.03.11-.09.22-.21.28-.09.05-.2.09-.28.03-.11-.09,0-.18.06-.25.15-.19.24-.43.46-.57.06-.04.05-.32,0-.36-.03-.08-.08-.15-.06-.24Z"
      />
      <path
        className="cls-2"
        d="m40.63,43.33c-.04.14-.17.19-.28.25-.45.25-.69.69-1.04,1.04-.14.14-.33.24-.5.34-.19.11-.33.26-.41.45-.08.2-.22.23-.39.2-.32-.07-.61-.19-.74-.53.14-.03.24.04.34.13.24.21.43.18.66-.02.39-.33.76-.69,1.14-1.02.24-.21.44-.47.72-.65.16-.1.3-.19.49-.17Z"
      />
      <path
        className="cls-2"
        d="m19.39,50.62c.13.01.12.11.12.2,0,.24-.04.48,0,.71.11.71.06,1.43.23,2.13.07.27.02.54-.12.79-.2-.29-.12-.65-.2-.96-.01-.04,0-.09-.01-.12-.23-.43,0-.88-.07-1.32-.07-.45.01-.9.02-1.36,0-.02.03-.05.04-.07Z"
      />
      <path
        className="cls-2"
        d="m41.67,38.91s-.09-.05-.09-.06c.06-.3-.09-.58-.09-.91-.25.17-.33,0-.36-.19-.03-.17-.01-.34-.01-.51,0-.04,0-.1.04-.1.42-.01.12-.27.08-.34-.11-.23-.21-.45-.17-.71.04-.01.09,0,.1.03.21.49.51.95.52,1.51,0,.43.06.85-.02,1.28Z"
      />
      <path
        className="cls-1"
        d="m28.3,50.03c-.03.1.16.21-.03.31-.16.09-.18-.05-.24-.12-.08-.09-.18-.11-.29-.13-.37-.08-.69-.25-.86-.61-.15-.31-.44-.53-.39-.95.03-.22.32-.26.22-.51.19.18.05.39.1.58,0,.21,0,.41.14.59.03.2.14.31.35.31.13.15.3.19.48.25.19.06.38.15.53.29Z"
      />
      <path
        className="cls-2"
        d="m26.46,66.16c-.12.04-.2-.05-.24-.13-.25-.42-.68-.66-.98-1.03-.55-.67-.88-1.45-1.29-2.19.31.1.42.42.55.65.41.8.99,1.46,1.57,2.13.15.17.3.35.39.57Z"
      />
      <path
        className="cls-2"
        d="m43.21,54.57c-.12-.25-.35-.38-.56-.53-.06-.04-.11-.09-.18-.03-.06.06-.05.12-.01.19.07.12.23.2.19.38-.22-.03-.28-.22-.31-.38-.05-.23-.19-.37-.36-.5-.13-.09-.26-.18-.34-.32.25-.01.36.22.56.3.13.06.28.23.38.1.11-.15-.09-.3-.21-.37-.21-.12-.29-.36-.52-.44-.11-.04-.11-.15-.08-.26.04,0,.09-.02.12,0,.61.46,1.15.98,1.38,1.74.02.05.01.1-.05.12Z"
      />
      <path
        className="cls-2"
        d="m42.61,66.84c0,.21-.15.36-.22.54-.08.19-.18.37-.17.59,0,.05-.02.12-.05.16-.36.45-.47.99-.56,1.53-.04.24-.03.52-.05.78,0,.06.02.12-.04.16-.17-.32-.12-.68-.05-1,.16-.82.35-1.64.79-2.38.09-.16.17-.31.36-.38Z"
      />
      <path
        className="cls-2"
        d="m31.03,48.05c-.12-.02-.09-.11-.09-.19,0-.34.25-.73.57-.84.08-.03.08-.07.09-.13.02-.22.08-.38.36-.34.14.02.22-.11.28-.23.05-.1.1-.19.23-.2,0,.53-.39,1.12-.88,1.25-.34.09-.47.3-.5.61,0,.02-.04.04-.06.06Z"
      />
      <path
        className="cls-1"
        d="m28.67,51.22s.02,0,.03,0c.31-.27.31-.27.51.1.06.11.18.11.25.19.28.35.4.75.44,1.18,0,.06-.02.1-.07.12-.05.02-.09-.02-.12-.07-.06-.13-.14-.26-.19-.4-.04-.09-.09-.13-.18-.11,0-.01-.02-.03-.02-.04-.09-.21-.01-.56-.4-.55-.11-.12-.23-.23-.24-.41Z"
      />
      <path
        className="cls-2"
        d="m41.24,24.39c.02.11-.06.14-.14.16-.81.22-1.59.52-2.39.79-.2.07-.39.14-.57.28-.15.11-.42.15-.65.09.01-.1.1-.17.17-.19.56-.14,1.06-.46,1.62-.6.57-.14,1.14-.3,1.69-.51.09-.03.17-.03.26-.03Z"
      />
      <path
        className="cls-2"
        d="m71.76,48.77c-.08-.08-.05-.19-.04-.28,0-.52,0-1.05.01-1.57,0-.21-.05-.41-.06-.61,0-.48.03-.97.04-1.45,0-.25-.09-.5.05-.74.15.4.14.83.13,1.25-.02.99-.04,1.98-.06,2.96,0,.15.05.32-.08.45Z"
      />
      <path
        className="cls-2"
        d="m54.02,26.17c.16-.12.32-.02.43.05.4.25.86.36,1.28.55.39.18.81.3,1.21.47.29.13.49.42.81.52.07.02.05.12.04.19-.41-.15-.74-.45-1.13-.63-.78-.33-1.56-.66-2.33-.99-.1-.04-.23-.06-.3-.17Z"
      />
      <path
        className="cls-2"
        d="m43.69,63.2c.03.68.02,1.36-.15,2.01-.15.58-.45,1.11-.82,1.59-.02.02-.07.02-.11.03,0-.32.23-.53.36-.78.29-.59.53-1.19.53-1.87,0-.29.08-.58.06-.88,0-.08.03-.13.13-.1Z"
      />
      <path
        className="cls-2"
        d="m49.01,57.61c.21.18.53.2.68.46.05.07.13.1.21.09.35-.04.54.28.84.35.04.01.08.06.08.13-.08.07-.15,0-.23-.02-.12-.04-.27-.03-.31.08-.05.14.11.18.2.25.08.05.24,0,.26.15-.24.05-.43-.04-.57-.22-.27-.34-.6-.62-.9-.93-.1-.1-.23-.19-.25-.35Z"
      />
      <path
        className="cls-2"
        d="m68.63,35.78c-.17.06-.19-.1-.25-.19-.13-.2-.22-.45-.48-.53-.08-.03-.06-.12-.08-.18-.05-.14-.09-.28-.27-.31-.04,0-.11-.05-.11-.09-.11-.52-.56-.79-.84-1.18-.01-.02,0-.06,0-.09.33.14.5.45.72.7.43.5.83,1.02,1.2,1.56.06.09.13.17.13.29Z"
      />
      <path
        className="cls-1"
        d="m44.15,39.68c.08.13.23.02.33.09.06.04.13.08.12.15,0,.09-.08.11-.15.1-.5-.03-.94.1-1.33.42-.08.06-.2.09-.32-.03.2-.14.26-.41.51-.49.3-.01.54-.23.84-.25Z"
      />
      <path
        className="cls-2"
        d="m55.47,32.35c-.33.38-.77.68-.88,1.22-.01.07-.04.12.02.18.24.28.24.29-.11.38-.03,0-.04.04-.07.06-.22-.23-.2-.49-.09-.76.14-.35.38-.61.64-.87.13-.13.27-.27.48-.21Z"
      />
      <path
        className="cls-2"
        d="m37.88,46.25c.23.07.54-.08.69-.35.04-.07.06-.16.14-.18.41-.13.67-.46.98-.74.03-.02.07-.02.11-.03.01.08.04.17-.02.23-.49.44-.88,1-1.54,1.23-.14.05-.34.12-.35-.16Z"
      />
      <path
        className="cls-2"
        d="m26.3,34.37c-.05-.1-.15-.21.06-.26.06-.01.12-.08.16-.13.36-.57.93-.95,1.36-1.47.16-.2.4-.31.63-.41,0,.3-.27.41-.45.54-.47.33-.82.78-1.2,1.2-.17.19-.34.38-.54.54Z"
      />
      <path
        className="cls-2"
        d="m36.44,51.65c-.03.28-.25.19-.39.17-.16-.03-.33.02-.45-.01-.55-.14-1.18-.07-1.57-.61.29-.03.53.18.82.2.53.05,1.06.17,1.59.25Z"
      />
      <path
        className="cls-2"
        d="m37.54,69.94c.12.05.18.21.35.18.05,0,.11.02.1.08-.06.65.21,1.25.24,1.89-.13-.04-.14-.17-.16-.26-.14-.6-.39-1.17-.56-1.76-.01-.05-.01-.1.03-.13Z"
      />
      <path
        className="cls-2"
        d="m57.89,64.18c.02.09.08.18.01.28-.27.39-.08,1.02-.67,1.23-.19-.16-.07-.36-.02-.51.1-.28.25-.54.39-.81.06-.11.16-.17.29-.18Z"
      />
      <path
        className="cls-1"
        d="m30.16,57.02c-.18.02-.28.11-.29.3,0,.07,0,.16-.08.17-.11.02-.11.25-.23.16-.13-.09.02-.18.08-.26.07-.1.04-.18-.03-.26,0-.02,0-.04.02-.05.17,0,.14-.13.12-.21-.06-.28.06-.52.11-.78.02-.13.14-.19.23-.18.15.02.02.15.04.21.11.22-.13.47.06.68,0,.08-.02.16-.02.23Z"
      />
      <path
        className="cls-2"
        d="m57.57,42.64c-.76.03-1.49.25-2.24.29-.34.02-.53.32-.8.46-.08.05-.14.14-.26.12-.01-.04-.02-.08.02-.11.47-.35.95-.68,1.56-.71.44-.02.87-.16,1.32-.16.15,0,.29-.03.4.11Z"
      />
      <path
        className="cls-2"
        d="m66.29,36.7c0-.07-.01-.16-.12-.11-.17.09-.37.16-.48.29-.25.3-.61.28-.92.39.44-.4.83-.87,1.49-.91.08,0,.19-.09.24.02.04.08-.04.16-.1.23-.03.04-.08.06-.11.09Z"
      />
      <path
        className="cls-2"
        d="m34.01,63.46c.42.08.76.32,1.07.6.14.12.26.27.39.4.06.07.16.17.07.25-.08.07-.2.03-.28-.07-.11-.14-.25-.26-.36-.4-.25-.31-.64-.46-.89-.78Z"
      />
      <path
        className="cls-2"
        d="m50.44,57.97c-.19-.02-.36-.24-.59-.07-.08.06-.15-.07-.14-.17.03-.29-.14-.45-.35-.6-.14-.1-.35-.17-.31-.41.29-.03.42.23.6.37.26.2.48.45.72.68.05.05.08.11.07.19Z"
      />
      <path
        className="cls-2"
        d="m45.95,36.27c.03.27-.23.27-.37.37-.23-.25-.48-.48-.69-.75-.09-.11-.29-.04-.31-.23.14-.01.25-.05.23-.23.26.15.63.54.92.99.11,0,.08-.19.22-.16Z"
      />
      <path
        className="cls-2"
        d="m60.49,47.02c-.24.07-.49.11-.67.35-.15.2-.39.25-.64.14-.08-.03-.22-.02-.18-.15.03-.09.1-.22.26-.16.13.05.22.02.19-.15.3-.05.61-.09.91-.15.13-.02.08.08.12.12Z"
      />
      <path
        className="cls-2"
        d="m26.57,46.73c-.11,0-.18-.04-.23-.14-.22-.41-.49-.77-.9-1.01-.03-.01-.07-.03-.07-.05-.08-.45-.47-.63-.74-.92-.05-.05-.13-.09-.02-.15.38.19.64.49.85.86.11.19.3.33.46.48.28.27.48.59.65.93Z"
      />
      <path
        className="cls-2"
        d="m40.63,34.55c.03.16.02.29-.15.38-.05.02-.1.08-.12.13-.24.51-.09,1.48.31,1.91.13.14.2.29.04.45-.17-.1-.11-.31-.19-.45-.2-.33-.32-.7-.42-1.07-.1-.34.14-1.14.42-1.34.03-.02.07,0,.11,0Z"
      />
      <path
        className="cls-2"
        d="m57.94,62.39c.21.11.38.24.23.52-.05.09-.08.23-.01.29.24.22.09.41-.06.55-.12.12,0,.34-.2.39-.15-.21-.07-.46-.02-.66.08-.37.1-.72.06-1.09Z"
      />
      <path
        className="cls-2"
        d="m44.93,32.45c-.12.21.1.34.13.51-.41-.24-.89-.09-1.32-.24-.11-.04-.23-.06-.33-.2.53-.02,1.02-.05,1.52-.07Z"
      />
      <path
        className="cls-1"
        d="m44.24,59.34c-.17.11-.15.3-.17.46-.02.15,0,.43-.12.41-.21-.03-.11-.29-.08-.43.05-.32.03-.63.04-.95,0-.07-.04-.19.1-.17.08.01.17.03.19.16.02.13-.05.28.05.4.04.04.02.08,0,.11Z"
      />
      <path
        className="cls-2"
        d="m66.09,32.75c-.08.01-.19.06-.22.03-.23-.23-.49-.45-.66-.72-.09-.14-.26-.29-.2-.5.49.28.81.71,1.08,1.19Z"
      />
      <path
        className="cls-2"
        d="m28.73,30.54c-.36.37-.73.73-1.08,1.11-.13.14-.21.32-.44.23.08-.25.3-.4.49-.55.28-.22.43-.56.73-.77.11-.07.19-.08.29-.02Z"
      />
      <path
        className="cls-1"
        d="m42.78,42.22c.25.13.19.29.04.45-.09.1-.2.2-.3.29-.04.04-.13.08-.14.01-.06-.37-.3-.17-.48-.17-.04-.17.1-.2.2-.25.1-.04.22-.05.2-.2.07-.02.15-.04.22-.06.08.07.13.07.15-.04.04,0,.08-.02.12-.03Z"
      />
      <path
        className="cls-2"
        d="m59.89,43.26c-.26,0-.44-.21-.66-.31-.39-.18-.76-.28-1.18-.17-.08.02-.12-.04-.15-.11.21-.15.44-.15.68-.08.18.05.36.11.55.05.09-.03.2.01.27.08.17.17.38.3.48.52Z"
      />
      <path
        className="cls-2"
        d="m71.44,42.13c-.14-.08-.11-.24-.15-.36-.1-.33-.11-.68-.33-.97-.1-.13.03-.38-.09-.56-.12-.18-.15-.39-.2-.59-.03-.1-.05-.19,0-.29.12.05.14.18.15.27.05.36.16.72.29,1.04.17.43.22.87.38,1.29.03.07.05.13-.04.17Z"
      />
      <path
        className="cls-2"
        d="m68.26,60.44c-.1.26-.18.53-.3.79-.16.34-.34.66-.51,1-.06.12-.12.2-.27.18-.03-.26.12-.48.26-.63.19-.21.24-.49.42-.7.07-.08.09-.19.1-.3.02-.18.1-.31.3-.33Z"
      />
      <path
        className="cls-2"
        d="m60.02,28.06c-.26-.1-.57-.06-.74-.34-.08-.12-.24-.03-.34-.09-.18-.09-.29-.26-.37-.45.61.09,1.04.47,1.46.87Z"
      />
      <path
        className="cls-2"
        d="m33.92,44.34c.07-.19.19-.24.39-.16.18.07.37.12.56.16.14.03.27,0,.36-.14.03-.06.08-.1.13-.02.03.04.1.12.03.15-.31.17.08.17.06.26-.43.05-.82-.17-1.23-.21-.09,0-.19,0-.29-.04Z"
      />
      <path
        className="cls-2"
        d="m23.83,37.95c.05-.35.21-.66.39-.95.22-.35.36-.73.56-1.09.09-.16.18-.15.31-.06.04.12-.06.19-.12.26-.42.49-.72,1.05-.98,1.63-.03.08-.06.17-.16.2Z"
      />
      <path
        className="cls-2"
        d="m21.18,60.49c.25.05.25.31.36.47.35.49.64,1.02,1.06,1.45.05.05.09.11.06.19-.19.04-.21-.15-.29-.25-.43-.5-.79-1.04-1.12-1.61-.04-.07-.09-.16-.07-.25Z"
      />
      <path
        className="cls-2"
        d="m54.32,59.04c.06-.16.28-.11.34-.25.21-.48.83-.53,1.03-1.02.06-.15.21-.06.31-.08-.48.44-.88.96-1.44,1.31-.07.05-.14.16-.24.05Z"
      />
      <path
        className="cls-2"
        d="m20.01,56.71c.08,0,.1.05.11.11.16.59.33,1.18.49,1.77.01.04,0,.08-.04.1-.08-.02-.11-.08-.13-.15-.15-.58-.31-1.15-.46-1.73,0-.03.01-.07.02-.11Z"
      />
      <path
        className="cls-2"
        d="m52.55,58.37c-.59.04-1.17.07-1.75-.06-.18-.04-.33-.13-.35-.35.58.28,1.21.27,1.83.31.1,0,.22-.05.28.09Z"
      />
      <path
        className="cls-2"
        d="m57.62,60.13c.12.09.25.12.13.37-.13.26-.05.59.05.9.05.16.05.4-.03.6-.21-.37-.23-.78-.22-1.18,0-.23-.08-.47.07-.68Z"
      />
      <path
        className="cls-2"
        d="m64.11,38.49c0-.08.04-.14.12-.14.48.03.82-.25,1.17-.5.03-.02.07-.02.11-.02-.06.32-.45.62-.92.69-.16.02-.33.07-.49-.03Z"
      />
      <path
        className="cls-2"
        d="m70.86,51.73c.04.55.02,1.09-.28,1.59-.14,0-.12-.11-.11-.19.08-.42.16-.84.25-1.26.01-.06.04-.14.13-.13Z"
      />
      <path
        className="cls-2"
        d="m58.91,62.83c-.19-.17-.21-.48-.47-.6-.01,0-.03-.04-.03-.05.21-.3-.05-.54-.1-.81-.01-.05.06-.06.11-.06.19.43.4.86.52,1.32.02.07,0,.13-.04.19Z"
      />
      <path
        className="cls-2"
        d="m53.8,37.03c-.22.22-.36.52-.67.65-.08.03-.07.14-.1.21-.04.1-.03.22-.17.25-.17-.11-.13-.28-.05-.39.16-.22.34-.47.6-.56.13-.05.18-.31.39-.16Z"
      />
      <path
        className="cls-2"
        d="m31.85,70.1c-.53.14-.9-.08-.92-.56.43-.01.66.3.92.56Z"
      />
      <path
        className="cls-2"
        d="m62.39,30.95c.37.09.51.49.82.65.28.14.48.33.62.6-.08.03-.14-.03-.18-.08-.23-.33-.61-.46-.92-.69-.17-.12-.35-.23-.35-.48Z"
      />
      <path
        className="cls-2"
        d="m20.64,49.19c-.08-.31-.04-.62-.04-.93,0-.36,0-.71.07-1.06.01-.07.01-.14.1-.17.03.51-.04,1.02-.07,1.53-.01.21.14.43-.05.63Z"
      />
      <path
        className="cls-2"
        d="m56.35,35.54c.09-.06.19-.04.29-.04.21,0,.34-.09.33-.32.2-.07.41.17.62,0,0,0,.05.03.06.05,0,.02-.01.05-.03.07-.28.3-.86.41-1.26.24Z"
      />
      <path
        className="cls-2"
        d="m41.87,25.07c.12-.24.38-.31.58-.33.35-.03.64-.24.99-.25.06,0,.11-.02.17,0-.4.24-.83.39-1.28.47-.16.03-.29.16-.47.12Z"
      />
      <path
        className="cls-2"
        d="m39.67,52.12c-.11.03-.19-.04-.29-.06-.07-.01-.16-.07-.2-.05-.43.31-.74-.18-1.12-.15.03-.14.16-.11.24-.1.39.05.78.11,1.16.18.09.02.21.03.2.17Z"
      />
      <path
        className="cls-2"
        d="m58.09,67.01c-.11-.21-.04-.44-.1-.66-.04-.15-.09-.28-.22-.41.2.03.36,0,.39-.22,0-.07.08-.13.17-.14.04.18-.11.3-.15.46-.09.33.07.67-.09.98Z"
      />
      <path
        className="cls-2"
        d="m56.67,70.68c-.03-.46.35-.72.48-1.09.02-.06.1-.11.17-.07.06.03.07.1.02.15-.24.27-.32.63-.52.92-.04.06-.09.06-.15.09Z"
      />
      <path
        className="cls-2"
        d="m20.81,54.22c-.22-.06-.24-.18-.19-.41.05-.2-.03-.43-.05-.65-.03-.29-.12-.59.04-.87.14.27.03.56.09.84.08.35.08.72.12,1.08Z"
      />
      <path
        className="cls-2"
        d="m48.03,55.39c.05.39.06.78.2,1.16.06.15.22.27.18.46-.31-.15-.34-.47-.44-.73-.09-.24-.05-.51-.05-.77,0-.07.03-.11.11-.12Z"
      />
      <path
        className="cls-2"
        d="m23.16,63.24c.46.37.82.81,1.01,1.38-.27-.12-.34-.41-.5-.61-.19-.24-.44-.44-.51-.76Z"
      />
      <path
        className="cls-2"
        d="m40.92,38.54c.08,0,.15.07.11.14-.23.36.01.68.05,1.02,0,.04,0,.08-.04.1-.25-.15-.39-.76-.24-1.05.03-.07.08-.13.13-.2Z"
      />
      <path
        className="cls-2"
        d="m61.79,46.91c-.15.07-.4-.15-.47.16,0,0-.1,0-.1,0-.09-.3-.24-.12-.38-.06-.09.04-.17.03-.26,0,0-.14.1-.2.19-.23.31-.1.63-.09.95.01.05.02.07.06.07.12Z"
      />
      <path
        className="cls-2"
        d="m55.88,35.25c0-.06,0-.12.05-.16.09-.06.19-.2.3-.1.1.08.07.29.02.32-.15.09,0,.15-.01.22-.34.04-.54-.16-.74-.39.15-.04.22.14.37.11,0,0,0,.02,0,.03,0,0,.01-.01.02-.02,0,0-.02,0-.03,0Zm.27-.04s-.02.03-.02.05c0,0,.01.02.02.02,0,0,.02-.01.02-.02,0-.02-.01-.03-.02-.05Z"
      />
      <path
        className="cls-2"
        d="m20.64,51.58c-.11-.21-.03-.42-.04-.64,0-.49,0-.98.02-1.47.09.04.09.13.09.21,0,.61,0,1.23,0,1.84,0,.02-.04.04-.06.06Z"
      />
      <path
        className="cls-2"
        d="m36.74,45.83c.27.2.57.31.92.28.08,0,.21-.02.22.13-.63.25-.68.2-1.14-.41Z"
      />
      <path
        className="cls-2"
        d="m58.52,64.87c.03-.2.12-.39-.11-.55-.1-.06-.09-.21-.01-.29.11-.11.12.07.19.09.05.02.11.02.17.02-.02.19.03.37-.04.56-.04.1-.06.19-.19.16Z"
      />
      <path
        className="cls-2"
        d="m65.5,46.02c-.07-.02-.16-.03-.22-.06-.42-.22-.7-.09-.8.37-.17-.19-.03-.56.27-.61.19-.04.39-.03.59.03.15.04.22.12.17.28Z"
      />
      <path
        className="cls-2"
        d="m57.67,67.78s.06.01.08.02c.09.04.14.21.29.11.14-.1.12-.23.07-.36,0-.02.02-.05.03-.07.2.27.1.26,0,.96-.1-.06-.42-.51-.47-.66Z"
      />
      <path
        className="cls-2"
        d="m58.63,33.54c0-.12.09-.19.16-.13.32.23.65.17.99.09,0,0,.03.03.04.04-.4.27-.85.37-1.2,0Z"
      />
      <path
        className="cls-2"
        d="m28.73,31.85c.01-.16.09-.27.25-.33.19-.07.29-.24.43-.37.09-.08.16-.18.29-.19-.02.33-.37.4-.52.64-.09.14-.24.26-.45.25Z"
      />
      <path
        className="cls-2"
        d="m58.04,68.7c0,.13-.34.62-.45.65-.12.03-.14-.05-.12-.13.05-.25.18-.46.39-.61.14-.1.16.02.19.09Z"
      />
      <path
        className="cls-2"
        d="m40.14,25.62c.18-.22.47-.18.69-.31.17-.1.39-.11.56-.23.1-.08.18-.02.25.07-.49.19-.96.44-1.5.47Z"
      />
      <path
        className="cls-2"
        d="m45.59,36.68c.13.07.25.15.38.22.24.14.47.07.69-.04-.09.22-.52.37-.76.26-.18-.09-.34-.19-.3-.44Z"
      />
      <path
        className="cls-2"
        d="m56.65,26.26c0,.07-.11.06-.08.18.03.13-.12.17-.25.15,0,0-.02-.01-.02-.02-.06-.18-.32-.01-.35-.19-.03-.15.29-.06.22-.27.16.05.34.04.48.15Z"
      />
      <path
        className="cls-2"
        d="m46.42,24.11c.12-.2-.2-.26-.13-.43.24-.06.44.16.69.11.01,0,.05.03.06.05.01.06-.02.08-.07.11-.17.08-.35.13-.54.17Z"
      />
      <path
        className="cls-2"
        d="m43.77,56.14c-.35-.11-.33-.46-.42-.73-.03-.09-.12-.23-.03-.35.24.33.38.69.46,1.08Z"
      />
      <path
        className="cls-2"
        d="m64.55,32.92c.37.19.64.48.83.84-.15.04-.21-.1-.28-.18-.19-.22-.44-.38-.55-.66Z"
      />
      <path
        className="cls-2"
        d="m58.56,58.82c-.34.03-.43.33-.6.54-.06.08-.1.19-.2.24,0-.33.39-.84.68-.9.09-.02.13.01.12.12Z"
      />
      <path
        className="cls-2"
        d="m59.08,48.09c.06-.04.11-.1.18-.08.35.08.71.09,1.07.06,0,0,.02.03.03.05-.43.18-.86.16-1.28-.03Z"
      />
      <path
        className="cls-2"
        d="m46.56,35.52c-.09.2-.24.37-.3.59-.04.15-.19.15-.31.15.07-.3.26-.52.46-.74.04-.05.1-.07.15,0Z"
      />
      <path
        className="cls-2"
        d="m23.11,61.44c-.48-.19-.62-.43-.59-.96.16.35.4.64.59.96Z"
      />
      <path
        className="cls-2"
        d="m47.39,35.92c0-.08-.11-.15,0-.23.22-.15.37-.36.52-.56,0,.38-.14.67-.52.79Z"
      />
      <path
        className="cls-2"
        d="m69.72,37.72c-.23-.34-.52-.64-.52-1.09.22.34.51.65.52,1.09Z"
      />
      <path
        className="cls-2"
        d="m35.8,44.81c.38.17.59.49.75.86-.35-.2-.56-.52-.75-.86Z"
      />
      <path
        className="cls-2"
        d="m46.25,32.51c-.01.11-.14.14-.17.11-.28-.23-.6-.1-.9-.13-.02,0-.05-.03-.07-.05.39-.1.77-.14,1.14.07Z"
      />
      <path
        className="cls-2"
        d="m22.94,39.98c.03-.32.04-.65.36-.84-.09.3-.12.61-.36.84Z"
      />
      <path
        className="cls-2"
        d="m23.67,43.34c-.34-.1-.13.21-.23.3-.18-.23-.22-.47.04-.74,0,.2.16.29.19.45Z"
      />
      <path
        className="cls-2"
        d="m65.61,34.01c.35.22.64.49.8.87-.33-.23-.58-.54-.8-.87Z"
      />
      <path
        className="cls-2"
        d="m46.9,34.72c.19.17.19.4.16.62-.02.14-.16.15-.29.14-.03-.08-.07-.19,0-.25.18-.15.09-.34.13-.51Z"
      />
      <path
        className="cls-2"
        d="m68.67,43.92c.29-.26.66-.3,1.02-.34-.32.19-.67.26-1.02.34Z"
      />
      <path
        className="cls-2"
        d="m42.2,34.26c-.38.07-.77.05-1.16.04,0-.03.01-.08.02-.08.38-.05.76-.12,1.14.04Z"
      />
      <path
        className="cls-2"
        d="m54.99,57.46c-.09.34-.37.47-.65.59.12-.31.43-.4.65-.59Z"
      />
      <path
        className="cls-2"
        d="m67.25,46.27c.1-.35.27-.65.52-.92-.12.34-.18.71-.52.92Z"
      />
      <path
        className="cls-2"
        d="m71.7,43.34c-.17-.14-.18-.36-.21-.55-.02-.16-.05-.33-.05-.49.1-.02.16.03.17.12.03.31.14.61.1.92Z"
      />
      <path
        className="cls-2"
        d="m41.21,35.12s0-.08.02-.08c.29-.1.59-.17.9-.07-.29.14-.62.09-.92.15Z"
      />
      <path
        className="cls-2"
        d="m71.68,49.92c-.04-.33-.09-.65.05-.97.07.33.09.65-.05.97Z"
      />
      <path
        className="cls-2"
        d="m24.72,45.3c.32.11.35.4.4.67-.21-.18-.37-.38-.4-.67Z"
      />
      <path
        className="cls-2"
        d="m58.85,43.58c.36-.02.61.33.46.64-.1-.25-.17-.53-.46-.64Z"
      />
      <path
        className="cls-2"
        d="m47.23,32.95c-.34-.04-.59-.27-.87-.44.37,0,.65.15.87.44Z"
      />
      <path
        className="cls-2"
        d="m23.69,62.35c-.26-.06-.28-.4-.55-.47-.04-.01.08-.09.14-.13.22.14.35.35.41.6Z"
      />
      <path
        className="cls-2"
        d="m65.51,37.83c.06-.3.21-.55.46-.73-.07.29-.16.58-.46.73Z"
      />
      <path
        className="cls-2"
        d="m30.82,69.51c-.04.08-.04.23-.18.15-.09-.05-.27-.07-.22-.26.01-.06.02-.11.03-.17.16.05.3.12.37.28Z"
      />
      <path
        className="cls-2"
        d="m54.85,34.67c.28.05.47.23.61.46-.29-.04-.49-.21-.61-.46Z"
      />
      <path
        className="cls-2"
        d="m64.89,46.82c.23,0,.51-.11.56.27-.23-.01-.41-.1-.56-.27Z"
      />
      <path
        className="cls-2"
        d="m29.62,29.82c-.16.21-.35.4-.59.53.05-.28.36-.56.59-.53Z"
      />
      <path
        className="cls-2"
        d="m66.78,35.36c.29.07.38.31.45.55-.18-.16-.35-.33-.45-.55Z"
      />
      <path
        className="cls-2"
        d="m64.83,31.38c-.26-.04-.52-.07-.53-.42.26.04.42.2.53.42Z"
      />
      <path
        className="cls-2"
        d="m46.56,33.75c.32.11.39.32.27.62-.09-.21-.18-.41-.27-.62Z"
      />
      <path
        className="cls-2"
        d="m53.98,38.37c0-.24.37-.48.58-.37-.17.16-.38.25-.58.37Z"
      />
      <path
        className="cls-2"
        d="m56.05,56.83c-.2.12-.4.25-.65.25.12-.23.5-.37.65-.25Z"
      />
      <path
        className="cls-2"
        d="m57.8,57.99c.01-.12.02-.23.03-.35.15,0,.28.04.31.19.02.1-.07.15-.17.16-.06,0-.12,0-.18,0Z"
      />
      <path
        className="cls-2"
        d="m52.53,39.86c.13-.25.37-.3.61-.34-.08.34-.38.29-.61.34Z"
      />
      <path
        className="cls-2"
        d="m26.39,66.89c.26.11.48.27.61.53-.28-.08-.49-.26-.61-.53Z"
      />
      <path
        className="cls-2"
        d="m64.3,30.95c-.25-.04-.47-.13-.57-.38.25.04.47.12.57.38Z"
      />
      <path
        className="cls-2"
        d="m20.95,45.84c-.1-.18-.03-.53.14-.68.03.24-.02.47-.14.68Z"
      />
      <path
        className="cls-2"
        d="m70.16,38.37c-.21-.04-.34-.25-.29-.48.2.1.31.25.29.48Z"
      />
      <path
        className="cls-2"
        d="m58.34,65.46c.03-.18-.09-.25-.3-.32.21-.05.35-.07.45-.16.06.2,0,.36-.16.48Z"
      />
      <path
        className="cls-2"
        d="m57.31,65.93c.06.22-.03.4-.11.59-.19-.22-.14-.5.11-.59Z"
      />
      <path
        className="cls-2"
        d="m60.95,30.05c.27.06.52.15.67.4-.29-.03-.47-.23-.67-.4Z"
      />
      <path
        className="cls-2"
        d="m20.78,59.41c.15.21.35.41.25.71-.11-.23-.23-.45-.25-.71Z"
      />
      <path
        className="cls-2"
        d="m28.91,51.63c.39,0,.31.34.4.55-.21-.13-.29-.35-.4-.55Z"
      />
      <path
        className="cls-2"
        d="m58.51,27.17c-.24-.05-.47-.13-.61-.35.28-.02.49.08.61.35Z"
      />
      <path
        className="cls-2"
        d="m56.2,34.78c-.37.12-.34-.22-.46-.39.23.04.31.26.46.39Z"
      />
      <path
        className="cls-2"
        d="m42.33,72.2c.16-.08-.1-.21.03-.29.09.02.12.1.15.16.04.1.28.15.14.28-.12.11-.23-.05-.32-.15Z"
      />
      <path
        className="cls-2"
        d="m49.11,53.3c-.06.26-.04.55-.28.73-.01-.29.07-.53.28-.73Z"
      />
      <path
        className="cls-2"
        d="m62.48,29.48c-.31,0-.49-.19-.67-.4.28.03.48.21.67.4Z"
      />
      <path
        className="cls-2"
        d="m57.74,26.74c-.24-.01-.44-.12-.61-.28.28-.08.45.1.61.28Z"
      />
      <path
        className="cls-2"
        d="m60.84,28.49c-.28.03-.37-.22-.55-.34.29-.06.42.15.55.34Z"
      />
      <path
        className="cls-2"
        d="m22.07,42.1c.04-.25,0-.52.26-.69,0,.26-.09.49-.26.69Z"
      />
      <path
        className="cls-2"
        d="m60.59,45.89c0-.16.04-.3.1-.44.19.01.17.17.16.28-.01.14-.13.17-.26.16Z"
      />
      <path
        className="cls-2"
        d="m24.17,44.71c.32-.04.31.21.36.42-.16-.11-.26-.26-.36-.42Z"
      />
      <path
        className="cls-2"
        d="m54.2,44.04c.1-.18.23-.32.46-.31-.12.15-.23.31-.46.31Z"
      />
      <path
        className="cls-2"
        d="m58.83,63.96c-.12-.24-.06-.46.07-.67,0,.23-.01.45-.07.67Z"
      />
      <path
        className="cls-2"
        d="m55.8,43.54c.19-.16.4-.11.61-.05-.19.16-.4.08-.61.05Z"
      />
      <path
        className="cls-2"
        d="m43.8,34.61c-.05.18-.16.13-.28.07-.13-.06-.08-.14-.02-.21.12,0,.25-.02.3.14Z"
      />
      <path
        className="cls-2"
        d="m48.51,54.38c-.01.22-.11.4-.27.56-.07-.26.07-.42.27-.56Z"
      />
      <path
        className="cls-2"
        d="m67.84,45.01c0-.22.1-.38.29-.49-.02.21-.09.38-.29.49Z"
      />
      <path
        className="cls-2"
        d="m66.22,47.06c.14-.13.31-.17.49-.18-.09.27-.27.28-.49.18Z"
      />
      <path
        className="cls-2"
        d="m41.04,52.42c-.24-.03-.47-.07-.67-.21.25-.01.49,0,.67.21Z"
      />
      <path
        className="cls-2"
        d="m59.12,28.78c.19-.01.32.08.41.24-.21.05-.34-.06-.41-.24Z"
      />
      <path
        className="cls-2"
        d="m40.75,37.7c.27.15.29.29.09.48-.1-.15-.03-.33-.09-.48Z"
      />
      <path
        className="cls-2"
        d="m55.4,34.05c-.1-.01-.24.05-.29-.08-.04-.09-.02-.2.12-.21.05.1.11.19.16.29Z"
      />
      <path
        className="cls-2"
        d="m53.57,38.86c-.11-.27,0-.39.27-.38-.08.14-.13.29-.27.38Z"
      />
      <path
        className="cls-2"
        d="m23.59,38.49c.02-.19.01-.39.23-.49-.02.19-.03.38-.23.49Z"
      />
      <path
        className="cls-2"
        d="m60.77,47.92c.13-.18.3-.19.48-.12-.14.11-.3.18-.48.12Z"
      />
      <path
        className="cls-2"
        d="m24.89,65.46c.21.07.37.17.36.42-.15-.12-.32-.21-.36-.42Z"
      />
      <path
        className="cls-2"
        d="m59.81,29.22c.18-.01.31.04.36.23-.18.02-.31-.05-.36-.23Z"
      />
      <path
        className="cls-2"
        d="m21.75,43.05c-.01-.21.03-.41.18-.58,0,.21-.03.41-.18.58Z"
      />
      <path
        className="cls-2"
        d="m60.05,43.75c-.22-.11-.14-.31-.16-.49.19.12.16.31.16.49Z"
      />
      <path
        className="cls-2"
        d="m70.87,51.14c.04.15.05.3,0,.45-.22-.16-.15-.31,0-.45Z"
      />
      <path
        className="cls-2"
        d="m27.29,49.48c-.2,0-.32-.11-.35-.31.17.04.32.11.35.31Z"
      />
      <path
        className="cls-2"
        d="m22.7,40.58c-.07-.17.05-.27.16-.37.03.16.01.29-.16.37Z"
      />
      <path
        className="cls-2"
        d="m66.47,33.09c-.28.06-.29-.19-.37-.34.22.01.24.23.37.34Z"
      />
      <path
        className="cls-2"
        d="m20.62,52.2c-.04-.15-.05-.29.02-.44.1.15.1.3-.02.44Z"
      />
      <path
        className="cls-2"
        d="m44.04,23.72c-.11.14-.23.23-.42.17.07-.22.26-.16.42-.17Z"
      />
      <path
        className="cls-2"
        d="m63.73,30.57c-.13-.04-.29-.03-.32-.22.18-.03.32,0,.32.22Z"
      />
      <path
        className="cls-2"
        d="m71.76,43.82c-.23-.1-.21-.23-.06-.38.02.13.09.25.06.38Z"
      />
      <path
        className="cls-2"
        d="m23.54,43.91s.05,0,.06,0c.16-.29.18-.03.26.07-.1.03-.18.05-.26.08-.01-.05-.08-.07-.05-.14Z"
      />
      <path
        className="cls-2"
        d="m41.03,35.69c-.08-.14-.11-.28.04-.4.05.14.06.27-.04.4Z"
      />
      <path
        className="cls-2"
        d="m70.14,42.5c-.14.07-.28.06-.42,0,.14-.15.28-.12.42,0Z"
      />
      <path
        className="cls-2"
        d="m25.63,35.13c-.08,0-.19-.03-.05-.11.07-.05.17-.1.28-.07-.02.13-.09.19-.22.18Z"
      />
      <path
        className="cls-2"
        d="m30.93,48.89c-.15-.13-.17-.25,0-.37.04.12.03.25,0,.37Z"
      />
      <path
        className="cls-2"
        d="m37.95,51.8c-.11.04-.2,0-.3-.04.11-.15.15-.14.3.04Z"
      />
      <path
        className="cls-2"
        d="m19.45,49.78c0,.13.09.29-.08.38-.06-.15-.1-.29.08-.38Z"
      />
      <path
        className="cls-2"
        d="m48.17,55.07c.02.11,0,.2-.13.22-.09-.18-.08-.2.13-.22Z"
      />
      <path
        className="cls-2"
        d="m48.63,57.24c.12.05.2.13.26.25-.13-.04-.27-.06-.26-.25Z"
      />
      <path
        className="cls-2"
        d="m57.62,57.61c-.27,0-.14-.19-.16-.31.17.04.08.22.16.31Z"
      />
      <path
        className="cls-2"
        d="m41.93,71.86c.14.02.22.09.24.24-.12-.04-.24-.08-.24-.24Z"
      />
      <path
        className="cls-2"
        d="m40.27,52.18c-.12.08-.23.12-.31-.04.11-.03.22-.06.31.04Z"
      />
      <path
        className="cls-2"
        d="m65.98,45.95c-.03.14-.08.22-.23.12.05-.1.13-.13.23-.12Z"
      />
      <path
        className="cls-2"
        d="m53.95,58.32c.01.16-.08.2-.21.18-.01-.16.1-.17.21-.18Z"
      />
      <path
        className="cls-2"
        d="m55.61,34.25c-.11-.03-.21-.06-.21-.2.09.04.23.04.21.2Z"
      />
      <path
        className="cls-2"
        d="m56.83,32.42c-.09.1-.17.1-.26,0,.09-.05.17-.09.26,0Z"
      />
      <path
        className="cls-2"
        d="m53.52,58.47c-.1.02-.17,0-.21-.11,0-.07.04-.09.09-.07.07.03.15.07.12.17Z"
      />
      <path
        className="cls-2"
        d="m58.15,32.7c-.09.08-.17.08-.24-.03.09-.08.17-.1.24.03Z"
      />
      <path
        className="cls-2"
        d="m47.91,34.36c-.07-.07-.25-.1-.07-.24.05.07.1.15.07.24Z"
      />
      <path
        className="cls-2"
        d="m62.71,29.73c-.14,0-.19-.09-.2-.22.16-.01.2.09.2.22Z"
      />
      <path
        className="cls-2"
        d="m40.94,34.38c-.04.13-.13.17-.26.15.02-.16.12-.18.26-.15Z"
      />
      <path
        className="cls-2"
        d="m53.88,59.16c.07-.09.15-.14.26-.1-.06.11-.14.16-.26.1Z"
      />
      <path
        className="cls-2"
        d="m68.2,44.34c-.07-.15.05-.13.13-.16,0,.1-.02.16-.13.16Z"
      />
      <path
        className="cls-2"
        d="m71.54,51.52c-.09-.1-.09-.18.03-.25.03.09.06.18-.03.25Z"
      />
      <path
        className="cls-2"
        d="m71.59,50.74c-.08-.1-.08-.19.04-.25.05.1.07.19-.04.25Z"
      />
      <path
        className="cls-2"
        d="m63.01,29.91c-.13.04-.18-.03-.21-.14.13-.04.21,0,.21.14Z"
      />
      <path
        className="cls-2"
        d="m25.13,45.97c.11,0,.17.06.18.17-.1-.02-.15-.09-.18-.17Z"
      />
      <path
        className="cls-2"
        d="m28.54,32.07c0-.12.05-.18.17-.18.04.15-.03.2-.17.18Z"
      />
      <path
        className="cls-2"
        d="m37.2,44.94c-.07-.01-.11-.06-.12-.12.05-.04.1-.04.15.01.04.05.02.08-.03.11Z"
      />
      <path
        className="cls-2"
        d="m19.63,54.57s.09,0,.09.03c0,.06-.02.13-.1.15-.09-.06-.1-.12,0-.18Z"
      />
      <path
        className="cls-2"
        d="m26.94,66.58c-.13.02-.19-.03-.19-.17.12-.01.18.05.19.17Z"
      />
      <path
        className="cls-2"
        d="m26.68,66.36c-.12,0-.17-.05-.18-.16.14-.03.19.03.18.16Z"
      />
      <path
        className="cls-2"
        d="m68.9,36.1c-.12,0-.17-.07-.16-.19.12.01.17.07.16.19Z"
      />
      <path
        className="cls-2"
        d="m52.64,59.18c.05-.1.11-.13.18-.02-.05.09-.11.09-.18.02Z"
      />
      <path
        className="cls-2"
        d="m23.47,38.67c-.01-.09-.01-.18.12-.18,0,.09.01.18-.12.18Z"
      />
      <path
        className="cls-2"
        d="m19.35,50.31c.14.03.16.09.05.19-.09-.04-.09-.11-.05-.19Z"
      />
      <path
        className="cls-2"
        d="m61.36,47.78c.07-.13.14-.13.21,0-.07.03-.14.03-.21,0Z"
      />
      <path
        className="cls-2"
        d="m43.08,34.94c.05-.09.11-.1.18-.02-.05.06-.11.08-.18.02Z"
      />
      <path
        className="cls-2"
        d="m42.16,71.5c-.12-.03-.15-.09-.06-.19.07.05.08.11.06.19Z"
      />
      <path
        className="cls-2"
        d="m67.79,45.31c0-.09-.03-.19.07-.25.12.12-.02.17-.07.25Z"
      />
      <path
        className="cls-2"
        d="m43.24,54.81c-.06-.04-.07-.07,0-.12.09.04.11.07,0,.12Z"
      />
      <path
        className="cls-2"
        d="m25.43,66.05c.14-.02.21.03.18.18-.11-.01-.16-.08-.18-.18Z"
      />
      <path
        className="cls-2"
        d="m44.28,34.89c-.14.03-.21-.03-.19-.17.1.01.15.09.19.17Z"
      />
      <path
        className="cls-2"
        d="m53.18,58.36c-.06.07-.12.05-.19.01.06-.13.12-.13.19-.01Z"
      />
      <path
        className="cls-2"
        d="m48.48,57.07c.06.03.11.07.12.14-.14.04-.12-.06-.12-.14Z"
      />
      <path
        className="cls-2"
        d="m23.63,44.11c.11-.03.19-.03.18.12-.09,0-.15-.03-.18-.12Z"
      />
      <path
        className="cls-2"
        d="m69.09,36.45c-.11-.03-.16-.09-.09-.2.1.03.11.11.09.2Z"
      />
      <path
        className="cls-2"
        d="m62.16,30.82c.08,0,.15.02.18.11-.1.03-.15-.02-.18-.11Z"
      />
      <path
        className="cls-2"
        d="m49.47,53.26s-.08-.04-.08-.06c.01-.07.09-.05.13-.07.04.07-.04.09-.06.13Z"
      />
      <path
        className="cls-2"
        d="m22.9,62.9c.15-.01.14.08.12.18-.09-.03-.13-.08-.12-.18Z"
      />
      <path
        className="cls-2"
        d="m43.32,34.41c-.07.12-.1.06-.14-.02.06-.05.1-.04.14.02Z"
      />
      <path
        className="cls-2"
        d="m41.76,71.67c.07.02.13.04.11.13-.09,0-.13-.04-.11-.13Z"
      />
      <path
        className="cls-2"
        d="m19.69,55.17c.11,0,.15.05.08.15-.08-.02-.11-.07-.08-.15Z"
      />
      <path
        className="cls-2"
        d="m45.23,32.98c.09-.1.1,0,.12.05-.05.01-.11.02-.12-.05Z"
      />
      <path
        className="cls-2"
        d="m42.68,54.99s.07,0,.08.05c0,.04-.02.06-.05.07-.06-.03-.08-.06-.03-.12Z"
      />
      <path
        className="cls-2"
        d="m43.7,62.69c.1.02.12.07.07.16-.11-.01-.12-.07-.07-.16Z"
      />
      <path
        className="cls-2"
        d="m42.66,42.25c-.02.11-.07.12-.15.04.04-.06.08-.09.15-.04Z"
      />
      <path
        className="cls-2"
        d="m22.67,62.61c.11,0,.15.02.09.13-.08-.01-.11-.06-.09-.13Z"
      />
      <path
        className="cls-2"
        d="m27.11,66.77c-.1.01-.14-.03-.11-.13.09,0,.13.04.11.13Z"
      />
      <path
        className="cls-2"
        d="m53.21,25.23c-.08.06-.13.02-.16-.06.07-.04.13-.02.16.06Z"
      />
      <path
        className="cls-2"
        d="m21.1,45.07s-.08-.02-.08-.06c0-.06.05-.07.1-.07.02.05.02.1-.03.14Z"
      />
      <path
        className="cls-2"
        d="m56.41,32.36c-.06.11-.1.06-.13-.02.05-.04.1-.05.13.02Z"
      />
      <path
        className="cls-2"
        d="m41.76,52.72c-.08.02-.13,0-.13-.1.1-.04.14,0,.13.1Z"
      />
      <path
        className="cls-2"
        d="m63.71,38.46c.06-.07.1-.04.14.03-.06.05-.1.05-.14-.03Z"
      />
      <path
        className="cls-2"
        d="m42.56,34.33c-.06.04-.11.04-.14-.04.07-.09.11-.03.14.04Z"
      />
      <path
        className="cls-2"
        d="m53.49,59.17s.08-.02.11.02c0,.04,0,.09-.06.07-.02,0-.03-.06-.05-.09Z"
      />
      <path
        className="cls-2"
        d="m41.22,52.48c-.09.12-.11.04-.13-.04.06-.02.11-.05.13.04Z"
      />
      <path
        className="cls-2"
        d="m20.77,46.74s-.06-.03-.07-.04c-.01-.05.04-.06.07-.08,0,.04,0,.08,0,.12Z"
      />
      <path
        className="cls-2"
        d="m60.18,29.45c.1-.01.13.03.12.13-.09,0-.13-.04-.12-.13Z"
      />
      <path
        className="cls-2"
        d="m42.09,70.41c-.06-.05-.03-.08.02-.12.05.05.06.09-.02.12Z"
      />
      <path
        className="cls-2"
        d="m57.86,62.28c.06,0,.07.04.06.09-.04.03-.07.01-.08-.02,0-.02.01-.04.02-.07Z"
      />
      <path
        className="cls-2"
        d="m25.15,35.74c-.03-.11,0-.16.11-.13.02.09-.04.12-.11.13Z"
      />
      <path
        className="cls-2"
        d="m69.81,37.77s-.06,0-.07-.04c.05-.03.07,0,.07.04Z"
      />
      <path
        className="cls-2"
        d="m64.97,31.54s-.07,0-.07-.05c.02.02.05.03.07.05Z"
      />
      <path
        className="cls-2"
        d="m53.62,58.47s0,0,0,0c0,0-.02-.02-.02-.02.01-.03.02-.03.03,0,0,0-.01.01-.02.02Z"
      />
      <path
        className="cls-2"
        d="m58.82,43.58s0-.05.03-.04c0,0,0,.03,0,.04,0,0-.02.01-.02.01h-.02Z"
      />
      <path
        className="cls-1"
        d="m44.55,74.3c.63,0,1.26,0,1.89,0,.07,0,.14,0,.21.01.08.02.11.09.11.16,0,.08-.09.08-.14.07-.37-.12-.74-.05-1.11-.06-.4-.01-.8-.02-1.2,0-.23.01-.44-.12-.67-.02-.03.02-.07-.03-.05-.08.03-.08.07-.09.16-.09.27.01.54,0,.8,0,0,0,0,0,0,0Z"
      />
      <path
        className="cls-1"
        d="m49.93,74.15c.29-.06.53-.12.74-.25.37-.22.82-.1,1.2-.3.15-.08.36.04.55-.01.05-.01.1.01.1.08,0,.08-.07.04-.1.06-.37.25-.8.18-1.21.23-.34.04-.63.24-.98.26-.09,0-.17.05-.31-.07Z"
      />
      <polygon
        className="cls-2"
        points="54.32 46.79 54.33 46.81 54.32 46.79 54.32 46.79"
      />
      <path
        className="cls-1"
        d="m69.45,52.39c-.03.08.1.32-.1.35-.23.04-.18-.24-.24-.37-.06-.16-.06-.35-.07-.52-.01-.15.1-.18.21-.2.12-.02.14.06.16.16.03.18.08.35.05.59Z"
      />
      <path
        className="cls-2"
        d="m42.57,34.48c-.04.18-.14.26-.3.26-.14,0-.32-.03-.32-.19,0-.15.19-.08.3-.08.1,0,.2.01.32.02Z"
      />
      <path
        className="cls-2"
        d="m41.4,38.74c-.02.08-.04.15-.12.15-.08,0-.11-.08-.11-.15,0-.08.05-.13.13-.13.1,0,.09.08.11.13Z"
      />
      <path
        className="cls-2"
        d="m59.57,43.93s-.06.02-.08.01c-.02-.01-.04-.05-.04-.06.01-.04.05-.06.09-.04.02.01.02.05.03.09Z"
      />
      <path
        className="cls-2"
        d="m57.92,59.84c.07.03.15.08.13.15-.02.07-.06.19-.17.17-.09-.01-.1-.11-.09-.19.01-.08.06-.12.13-.13Z"
      />
      <path
        className="cls-2"
        d="m57.97,59.7c-.05,0-.06-.05-.06-.08,0-.06.03-.09.09-.08.05,0,.07.03.07.07-.01.05-.04.09-.1.09Z"
      />
      <path
        className="cls-2"
        d="m55.46,32.69c.15,0,.26,0,.37,0,.11,0,.19.05.18.14,0,.13-.13.08-.21.09-.15.01-.23-.09-.35-.23Z"
      />
      <path
        className="cls-2"
        d="m58.1,33.26c-.08,0-.13-.06-.13-.13,0-.08.03-.16.11-.18.08-.01.11.06.12.13,0,.08-.01.15-.11.18Z"
      />
      <path
        className="cls-2"
        d="m55.81,34.86s-.04.02-.06.04c-.01-.02-.03-.04-.03-.06,0-.02.04-.03.06-.05,0,.01.01.03.03.07Z"
      />
      <path
        className="cls-1"
        d="m29.93,54.81c.12-.02.19.05.21.16.03.14-.08.13-.16.14-.14.03-.15.1-.03.17.12.07.11.16.06.25-.03.05-.13.09-.18.07-.11-.03-.08-.14-.08-.23,0-.13,0-.26,0-.39,0-.13.05-.19.18-.17Z"
      />
      <path
        className="cls-2"
        d="m63.73,37.94c-.07-.02-.19,0-.18-.11,0-.1.11-.06.17-.06.08,0,.19,0,.18.1,0,.09-.11.06-.17.07Z"
      />
      <path
        className="cls-1"
        d="m56.15,35.22s.01.03.02.05c0,0-.01.02-.02.02,0,0-.02-.01-.02-.02,0-.02.02-.03.02-.05Z"
      />
      <path
        className="cls-1"
        d="m55.88,35.25s.02,0,.03,0c0,0-.01.01-.02.02,0,0,0-.02,0-.03,0,0,0,0,0,0Z"
      />
    </Icon>
  );
}

export function IconSilk({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="27 35 42 37"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #545353; }`}
          {`.cls-2 { fill: #9b9999; }`}
          {`.cls-3 { fill: #3d3838; }`}
        </style>
      </defs>
      <path
        className="cls-3"
        d="m66.32,53.9c-.64-.22-1.24-.5-1.83-.82-.03-.18-.2-.25-.32-.29-.81-.28-1.63-.55-2.49-.66-.45-.16-.94-.17-1.39-.16-.42.02-.89.03-1.28.16-.61.21-1.22.21-1.84.25-.27-.17-.56-.09-.84-.05-.12.02-.26.09-.33-.05-.09-.16.09-.21.18-.27.27-.16.48-.39.65-.63.34-.47.73-.85,1.32-.96.2-.04.35-.12.31-.36.16-.05.32-.11.49-.16.26.02.51.07.77.06.65-.02,1.29-.15,1.95-.07.32.04.58.17.85.28.68.27,1.39.41,2.05.77.53.29,1.04.64,1.65.78.25.35.67.44,1.01.65.12.29.23.58.6.63-.04.21.2.15.26.27-.02.15.05.2.19.18,0,0,0,0,0,0-.03.37.4.61.28,1.01-.41.02-.83.04-1.24-.05-.17-.17-.44-.16-.63-.3-.04-.22-.16-.29-.37-.22Z"
      />
      <path
        className="cls-3"
        d="m41.41,66.2c.01-.11.02-.22.04-.33.48-.59.67-1.33.87-2.02.27-.92.32-1.91.91-2.72.11-.15.09-.25-.02-.36.1-.12.2-.24.29-.36.14.02.2-.05.19-.18.11-.12.21-.23.32-.35.23-.12.43-.29.59-.5.73-.68,1.52-1.27,2.38-1.79.12.09.38-.21.41.14-.4.38-.79.76-1.19,1.13-.41.23-.83.46-.96.97-.71.72-1.35,1.49-1.58,2.5-.27,1.22-.56,2.44-.73,3.68-.05.35-.08.69-.1,1.04-.1.66-.08,1.33-.09,1.99,0,.14-.06.36.16.44.05.23.1.47.16.7.02.37.04.4.26.39.06,0,.11,0,.17.01.23.16.33.13.65-.21.33-.2.63-.45,1-.58.24-.05.46-.16.72-.1.27.06.53.07.61-.29.04-.17.18-.13.3-.11.5.07,1.02.28,1.42-.24.08-.11.19-.05.29.01.14.09.02.16,0,.26-.14.63-.56.78-1.15.81-.28.01-.64.08-.81.4-.06,0-.13,0-.19.01-.6.32-1.21.62-1.74,1.07-.19.16-.43.35-.6.24-.45-.28-.81-.02-1.23.04-.67.09-1.08-.11-1.24-.8-.16-.71.13-1.41-.19-2.14-.17-.4-.12-1.04.01-1.57.1-.38.12-.79.05-1.2Zm1.36-2.25c-.08,0-.17,0-.16.11.01.15.11.26.25.29.09.02.2-.03.18-.14-.02-.14-.1-.26-.27-.26Z"
      />
      <path
        className="cls-3"
        d="m34.54,55.31s.04.02.06.03c0,.12.05.18.17.19,0,0,0,0,0,0,0,.25.08.41.35.49.53.16.98.49,1.39.86.15.14.31.24.52.27.13.01.33-.04.33.15,0,.18-.15.29-.34.32-.1.02-.21.03-.31.04-1.1-.23-2.14-.64-3.21-.96-.03-.38-.44-.23-.61-.44-.14-.18-.32-.11-.44.07-.08-.02-.16-.04-.24-.07-.18-.47-.52-.47-.92-.32-.37-.08-.58-.41-.91-.55-.07-.15-.15-.29-.35-.28-.04-.03-.07-.06-.11-.09-.08-.3-.29-.49-.55-.61-.87-.43-1.28-1.12-1.32-2.09-.01-.34.13-.54.4-.64.25-.09.5-.07.32-.47-.08-.18.18-.13.3-.14.48-.04.95-.07,1.26-.5.44-.62,1.06-.93,1.78-1.11.32-.08.5-.01.64.25,0,.02-.02.04-.05.05-.39-.1-1.44.48-1.58.86,0,.02-.02.04-.03.07-.21.06-.26.21-.22.41-.04.06-.08.12-.12.18-.28-.06-.34.11-.41.35-.1.38-.1.71.3.91,0,.03.01.06,0,.09-.03.06-.03.11.02.16.67.76,1.45,1.37,2.36,1.78.51.23.93.64,1.49.74Z"
      />
      <path
        className="cls-3"
        d="m55.32,36.31c.12-.01.24-.02.35-.04.34.07.67-.02,1-.02.54,0,1.17-.38,1.6.28.02.03.14,0,.22,0,.18,0,.34-.15.55-.09-.06.3-.34.47-.43.74-.26.03-.52.05-.78.08-.17-.06-.34-.09-.5,0-.15.08-.29.17-.44.25-.79-.12-1.53.07-2.22.41-.38.19-.82.17-1.15.42-.48.36-.97.69-1.56.87-.29.09-.65.35-.37.81-.04.03-.07.06-.11.09-.39,0-.72.31-.85.82-.73.71-.9,1.63-.95,2.59-.29.27-.3.46-.03.62,0,.19,0,.38,0,.57-.03.02-.09.04-.1.07-.02.07.03.11.1.11-.02.42-.02.85-.07,1.27-.02.2-.18.3-.4.3-.23,0-.27-.12-.35-.32-.18-.46.03-.97-.21-1.41.1-.2-.01-.35-.14-.48-.08-.28-.05-.55-.02-.83.2-.09.16-.22.07-.36-.03-.08-.07-.17-.1-.25.07-.12.08-.23-.05-.31.01-.12.02-.23.04-.35.54.04.28-.29.23-.52,0-.07,0-.14-.01-.21.28-.4.55-.8.79-1.22.33-.56.78-1.06,1.17-1.58.55-.53,1.19-.93,1.87-1.28.27.01.58.08.8-.1.39-.3.82-.49,1.29-.65.25-.08.55-.06.76-.27Zm2.68.68c-.07-.03-.1-.05-.14-.05-.02,0-.05.02-.07.04.03.02.05.06.08.07.03,0,.07-.03.13-.05Z"
      />
      <path
        className="cls-3"
        d="m51.46,55.31c-.19-.32-.4-.62-.5-.99,0-.17,0-.33-.08-.49-.19-.37-.39-.75-.54-1.14-.15-.38-.39-.67-.74-.88-.52-.96-.95-1.97-1.29-3.01-.23-.71-.67-1.33-.86-2.06,0-.08.02-.16,0-.23-.19-.51-.53-.94-.65-1.48-.04-.17-.21-.2-.37-.22-.17-.19-.35-.37-.62-.66.04.94.73,1.51.85,2.29-.05.12-.04.28-.22.3,0,0,0,0,0,0,.04-.15-.02-.21-.17-.2-.43-.21-.44-.71-.71-1.03-.12-.14-.15-.35-.23-.53,0-.47,0-.94,0-1.4,0-.11.06-.18.14-.24.14-.01.31.03.35-.19.11.04.22.07.32.11.02.15.12.23.27.26.29.74.82,1.34,1.26,1.99.16.23.3.47.36.75-.01.12.03.2.16.21.01.02.03.04.04.06-.02.14-.11.32.17.28,0,0,0,0,0,0-.04.22-.07.43.23.5,0,.03.01.06.02.08-.04.48.22.81.56,1.1.03.06.06.12.1.18-.14.15-.12.25.1.28.24.54.5,1.08.73,1.62.04.11.09.18.18.24.1.85.57,1.49,1.19,2.04.02.02.03.05.02.08-.11.19-.1.37.05.54.17.2.27.43.27.7-.15.03-.37-.14-.41.06-.03.17.19.18.35.17.42,0,.55.25.5.62-.02.17.03.28.13.41.34.4.77.74.96,1.26.17.49.45.93.78,1.33.19.24.21.5.04.76-.14.22-.28.35-.45.01-.09-.19-.21-.42-.4-.48-.33-.1-.5-.34-.65-.6-.26-.47-.47-.96-.65-1.47-.04-.1,0-.37-.27-.22,0,0-.03-.03-.02-.03q.25-.57-.29-.69Z"
      />
      <path
        className="cls-1"
        d="m51.78,56.03c.27-.16.24.11.27.22.18.51.39,1,.65,1.47.15.26.32.5.65.6.19.06.31.29.4.48.16.33.31.2.45-.01.17-.26.15-.52-.04-.76-.33-.4-.6-.84-.78-1.33-.18-.53-.61-.86-.96-1.26-.11-.13-.16-.24-.13-.41.05-.37-.08-.62-.5-.62-.15,0-.38,0-.35-.17.04-.2.26-.03.41-.06,0-.27-.1-.5-.27-.7-.14-.17-.16-.35-.05-.54.4.53.84,1.02.98,1.71.05.24.25.45.4.66.5.73.85,1.54,1.25,2.33.34.68.83,1.28,1.13,1.98.25.57.46,1.16.26,1.77-.09.25-.2.74-.71.47-.1-.05-.13.04-.16.11-.04.11-.14.14-.22.08-.51-.4-1.2-.6-1.57-1.13-.36-.52-.77-1.08-.72-1.79,0-.13-.06-.27-.07-.41,0-.14-.09-.33.17-.34.23-.1.41.15.63.14.02-.34-.3-.33-.44-.5.15-.29-.11-.49-.18-.73-.13-.43-.49-.78-.5-1.26Z"
      />
      <path
        className="cls-2"
        d="m58.62,37.16c.09-.27.37-.44.43-.74-.22-.06-.37.09-.55.09-.07,0-.19.04-.22,0-.44-.66-1.06-.28-1.6-.28-.33,0-.66.09-1,.02.24-.31.64-.3.95-.32.3-.02.69-.35.96.09,0,.01.08,0,.08,0,.11-.46.54-.3.82-.37.35-.08.7-.22,1.08-.21.92.03,1.4.35,1.65,1.23.08.27.18.52.28.77.06.17.18.33.05.52-.18-.1-.17-.31-.26-.46-.08-.13-.11-.35-.3-.26-.2.09-.08.29-.03.44.2.6.4,1.2.59,1.8-.03.02-.05.05-.08.07-.44-.33-.54-.87-.76-1.33-.16-.34-.31-.69-.37-1.07-.05-.28-.21-.33-.51-.27-.4.09-.75.45-1.2.26Z"
      />
      <path
        className="cls-2"
        d="m32.76,49.72c-.14-.27-.31-.33-.64-.25-.73.18-1.34.49-1.78,1.11-.31.43-.79.47-1.26.5-.11,0-.38-.04-.3.14.19.41-.07.38-.32.47-.27.1-.41.3-.4.64.04.96.44,1.66,1.32,2.09.26.13.47.32.55.61-.26.04-.42-.13-.6-.27-.69-.5-1.28-1.1-1.75-1.8-.16-.25-.36-.56-.19-.92.02-.05,0-.12-.02-.17-.23-.43-.06-.66.38-.77.01,0,.04,0,.04-.02.43-.85,1.16-.37,1.77-.38.21,0,.38-.07.48-.22.41-.63,1-.99,1.7-1.18.63-.18.96-.71,1.39-1.12.23-.22.38-.57.79-.53-.3.38-.54.82-1,1.04-.19.09-.19.25-.12.38.07.15.24.12.37.08.14-.04.24-.13.32-.25.12-.16.26-.29.47-.32-.27.52-.74.83-1.2,1.15Z"
      />
      <path
        className="cls-3"
        d="m33.96,48.57c-.21.03-.35.16-.47.32-.08.12-.19.21-.32.25-.13.04-.3.07-.37-.08-.06-.13-.07-.29.12-.38.46-.22.69-.66,1-1.04.08-.02.16-.05.24-.07.05.09.17.15.22.11.12-.12.02-.28.01-.42.03-.02.07-.04.1-.06.13.09.22.08.21-.11.43-.32.92-.46,1.45-.54.38-.06.67-.39,1.05-.53.12-.04.25-.08.38-.14.35.06.7.23,1.03-.05.64-.34,1.33-.15,2-.17.12.31.51.14.68.37-.17.17-.37.12-.56.13-.19.01-.4-.08-.56.1-.33.12-.66.12-1.01.08-.19-.25-.39-.22-.58,0-.06.03-.12.06-.18.08-.44-.09-.86-.08-1.13.36-.11.04-.21.08-.32.12-.16-.09-.32-.18-.41.08-.85.54-1.88.79-2.59,1.57Z"
      />
      <path
        className="cls-2"
        d="m61.69,38.52c.39.29.42.77.42,1.15,0,.46.19.89.13,1.36-.11.85-.21,1.67-.63,2.46-.29.55-.47,1.18-.68,1.77-.34.94-.99,1.65-1.54,2.43-.09.13-.19.48-.4.34-.21-.15.02-.43.14-.56.51-.52.77-1.2,1.15-1.8.51-.8.88-1.67,1-2.6.06-.49.33-.87.42-1.34.12-.66-.16-1.23-.18-1.85,0-.11-.04-.21-.06-.32.03-.02.05-.05.08-.07.28.06.31-.11.29-.32-.03-.22-.09-.44-.13-.66Z"
      />
      <path
        className="cls-2"
        d="m36.72,57.68c.1-.01.21-.02.31-.04.18-.03.34-.14.34-.32,0-.2-.2-.14-.33-.15-.21-.02-.37-.13-.52-.27-.41-.37-.86-.7-1.39-.86-.27-.08-.35-.25-.35-.49.43,0,.69.34,1.04.51.45.22.85.53,1.28.8.66.42,1.39.32,2.11.16.98-.21,1.95-.45,2.93-.7.15-.04.28-.08.34.1.06.21-.11.24-.26.29-.54.18-1.08.32-1.59.56-.77.36-1.62.43-2.46.49-.35.03-.7-.02-1.05.06-.13.03-.32.07-.38-.15Z"
      />
      <path
        className="cls-2"
        d="m41.41,66.2c.08.4.05.82-.05,1.2-.14.54-.19,1.17-.01,1.57.32.73.02,1.43.19,2.14.16.68.57.89,1.24.8.41-.06.78-.32,1.23-.04.17.1.41-.08.6-.24.52-.44,1.13-.75,1.74-1.07-.28.53-.83.79-1.22,1.2-.45.46-1.1.46-1.61.78-.46.28-1.38-.04-1.74-.48-.45-.54-.57-1.2-.74-1.85-.02-.07-.02-.18.02-.22.29-.34.06-.68.03-1.03-.05-.46-.02-.94.03-1.4.03-.32.08-.63.08-.96,0-.18.05-.34.24-.39Z"
      />
      <path
        className="cls-2"
        d="m66.22,51.73c-.6-.15-1.12-.49-1.65-.78-.66-.36-1.37-.5-2.05-.77-.27-.11-.54-.24-.85-.28-.66-.08-1.3.05-1.95.07-.26,0-.51-.04-.77-.06.16-.31.48-.25.75-.29.89-.12,1.8-.32,2.68-.07,1.04.29,2.08.6,3.02,1.19.41.26.72.52.82,1Z"
      />
      <path
        className="cls-3"
        d="m63.42,60.81c-.17,0-.35.02-.52.03-.09-.1-.18-.1-.27,0-.49-.11-1.02.06-1.48-.23-.03-.24.27-.14.31-.31.29-.09.59-.03.89-.06.22.2.79.11,1.03-.17.31-.05.64-.04.93-.19.92,0,1.75-.59,2.69-.45-.25.72-.87.79-1.43.99-.43.15-.9.09-1.31.3-.05,0-.1.01-.16.02-.24-.07-.47-.14-.68.07Z"
      />
      <path
        className="cls-2"
        d="m64.25,60.72c.41-.21.88-.15,1.31-.3.56-.2,1.18-.27,1.43-.99-.94-.14-1.78.44-2.69.45-.01-.16.11-.16.21-.17.67-.1,1.31-.32,1.92-.59.49-.22.88-.64,1.42-.79.06-.02.11-.02.17-.04.06.28-.13.34-.34.38-.25.05-.35.2-.38.44,0,.08-.05.15.05.18.05.01.15.02.17-.01.19-.25.51-.37.68-.67.15-.26.06-.31-.15-.36.1-.34.18-.7.32-1.03.06-.15.19-.35.41-.3.25.05.2.29.18.46-.09.83-.47,1.51-1.07,2.07-.89.82-1.97,1.2-3.16,1.33-.17.02-.34.03-.5-.04Z"
      />
      <path
        className="cls-2"
        d="m46.52,70.54c.17-.33.53-.39.81-.4.59-.03,1-.18,1.15-.81.02-.1.14-.17,0-.26-.1-.06-.21-.12-.29-.01-.4.52-.92.31-1.42.24-.12-.02-.26-.05-.3.11-.09.36-.34.35-.61.29-.26-.06-.48.05-.72.1-.01-.12.06-.16.15-.2.71-.34,1.42-.74,2.24-.66.34.03.58-.1.86-.21.65.27.38-.45.65-.61.17-.1.14-.29.07-.45-.04-.1-.15-.07-.24-.06.16-.32.46-.51.7-.76.16-.16.25-.06.23.13-.01.14-.03.28-.08.4-.26.67-.58,1.32-.78,2-.14.48-.44.69-.84.81-.52.15-1.05.23-1.57.33Z"
      />
      <path
        className="cls-2"
        d="m51.59,40.01c-.28-.45.08-.71.37-.81.59-.19,1.08-.51,1.56-.87.33-.25.78-.23,1.15-.42.68-.34,1.43-.53,2.22-.41-.38.32-.89.22-1.32.39-1.05.4-2.11.81-3.07,1.41-.32.2-.57.53-.92.71Z"
      />
      <path
        className="cls-2"
        d="m34.54,55.31c-.57-.1-.99-.51-1.49-.74-.91-.41-1.7-1.02-2.36-1.78-.05-.05-.05-.11-.02-.16.36.11.71.24.93.58.03.05.13.05.2.09.44.2.98.22,1.23.78.08.17.42.21.63.34.36.23.64.54.89.89Z"
      />
      <path
        className="cls-2"
        d="m58.47,50.06c.04.25-.11.33-.31.36-.59.11-.98.49-1.32.96-.17.23-.38.47-.65.63-.09.05-.27.1-.18.27.07.14.21.07.33.05.28-.05.57-.12.84.05-.37.35-.83.24-1.22.14-.35-.09-.39-.73-.03-1.05.63-.56,1.27-1.14,2.14-1.32.06.04.1.02.13-.04.08-.11.18-.08.28-.03Z"
      />
      <path
        className="cls-2"
        d="m43.21,60.77c.1.12.12.21.02.36-.59.81-.65,1.8-.91,2.72-.2.69-.38,1.43-.87,2.02-.09,0-.17-.06-.14-.14.15-.4.13-.85.4-1.23.48-.66.46-1.49.69-2.24.14-.46.33-.91.56-1.33.05-.1.13-.17.25-.17Z"
      />
      <path
        className="cls-2"
        d="m67.32,54.42c.41.08.82.07,1.24.05.12-.4-.31-.64-.28-1.01.41.11.48.5.56.8.12.44.06.91-.1,1.35-.02.07-.03.16-.13.16-.08,0-.18-.04-.18-.11.03-.78-.62-.94-1.11-1.25Z"
      />
      <path
        className="cls-3"
        d="m61.69,38.52c.05.22.1.44.13.66.03.2,0,.38-.29.32-.2-.6-.4-1.2-.59-1.8-.05-.15-.17-.35.03-.44.19-.08.22.13.3.26.09.15.08.36.26.46.05.18.1.36.15.53Z"
      />
      <path
        className="cls-2"
        d="m57.1,50.07c.56-.63.98-1.39,1.78-1.89-.05.61-1.14,1.79-1.78,1.89Z"
      />
      <path
        className="cls-2"
        d="m55.32,36.31c-.21.21-.5.19-.76.27-.46.16-.89.35-1.29.65-.22.17-.53.11-.8.1.03-.35.39-.3.58-.41.62-.34,1.26-.65,1.99-.7.11,0,.22-.03.27.1Z"
      />
      <path
        className="cls-2"
        d="m50.61,38.6c-.4.52-.85,1.02-1.17,1.58-.25.42-.51.83-.79,1.22-.23-.46.14-.76.33-1.07.35-.55.8-1.04,1.2-1.56.12-.15.25-.23.43-.18Z"
      />
      <path
        className="cls-2"
        d="m49.6,51.81c.35.21.58.5.74.88.16.39.35.77.54,1.14.08.16.08.32.08.49-.64-.74-.98-1.64-1.36-2.51Z"
      />
      <path
        className="cls-2"
        d="m40.17,46.26c.16-.18.37-.09.56-.1.19-.01.4.04.56-.13-.17-.23-.56-.06-.68-.37.5-.03.91.21,1.31.46-.12.16.08.31.03.47-.57-.25-1.19-.23-1.79-.32Z"
      />
      <path
        className="cls-2"
        d="m61.68,52.13c.86.11,1.68.38,2.49.66.12.04.29.11.32.29-.42.06-.75-.2-1.11-.33-.57-.2-1.13-.42-1.7-.63Z"
      />
      <path
        className="cls-2"
        d="m46.43,44.81c.16.02.33.05.37.22.12.54.46.98.65,1.48.03.07,0,.15,0,.23-.36-.55-.73-1.09-1.09-1.64-.06-.1,0-.21.07-.29Z"
      />
      <path
        className="cls-2"
        d="m51.51,52.85c-.62-.55-1.09-1.19-1.19-2.04.26.15.33.45.47.68.19.34.34.7.63.97.11.1.06.26.09.39Z"
      />
      <path
        className="cls-3"
        d="m41.95,46.58c.05-.16-.15-.3-.03-.47.36.14.71.28,1.1.43-.39.32-.73.12-1.07.04Z"
      />
      <path
        className="cls-2"
        d="m42.9,69.49c-.22-.08-.16-.3-.16-.44.02-.66-.01-1.33.09-1.99.25.36.05.77.09,1.15.04.42.07.85-.03,1.28Z"
      />
      <path
        className="cls-3"
        d="m48.86,67.62c.09,0,.2-.04.24.06.07.16.09.35-.07.45-.27.16,0,.88-.65.61,0-.1.01-.19.02-.29.3-.13.37-.37.35-.66.04-.06.07-.11.11-.17Z"
      />
      <path
        className="cls-2"
        d="m30.66,52.54c-.41-.2-.41-.53-.3-.91.06-.23.12-.4.41-.35-.09.41-.23.82-.1,1.26Z"
      />
      <path
        className="cls-2"
        d="m31.14,50.63c.14-.38,1.18-.96,1.58-.86-.17.26-.48.33-.72.42-.31.12-.57.3-.86.44Z"
      />
      <path
        className="cls-2"
        d="m50.63,40.93c.13-.51.46-.83.85-.82-.21.35-.4.72-.85.82Z"
      />
      <path
        className="cls-2"
        d="m32.46,56.34c.12-.18.3-.25.44-.07.17.21.58.06.61.44-.42.09-.72-.18-1.05-.37Z"
      />
      <path
        className="cls-2"
        d="m38.61,45.83c-.33.28-.68.11-1.03.05.33-.34.68-.19,1.03-.05Z"
      />
      <path
        className="cls-2"
        d="m45.24,59.84c.13-.51.55-.73.96-.97-.18.46-.64.65-.96.97Z"
      />
      <path
        className="cls-2"
        d="m37.28,46.8c.27-.45.68-.45,1.13-.36-.38.12-.75.24-1.13.36Z"
      />
      <path
        className="cls-2"
        d="m45.33,43.58c0,.47,0,.94,0,1.4-.26-.29-.26-1.15,0-1.4Z"
      />
      <path
        className="cls-2"
        d="m31.3,55.95c.4-.15.74-.15.92.32-.37.08-.61-.22-.92-.32Z"
      />
      <path
        className="cls-2"
        d="m49.22,48.49c-.34-.29-.6-.62-.56-1.1.31.3.44.7.56,1.1Z"
      />
      <path
        className="cls-2"
        d="m51.46,55.31q.54.12.29.69c-.22-.18-.27-.43-.29-.69Z"
      />
      <path
        className="cls-2"
        d="m43.62,56.43c.34-.1.68-.18,1.02.03-.34.07-.68.08-1.02-.03Z"
      />
      <path
        className="cls-2"
        d="m63.37,60.06c-.24.28-.81.38-1.03.17.32-.22.69-.08,1.03-.17Z"
      />
      <path
        className="cls-3"
        d="m52.45,58.02c.14.16.46.15.44.5-.22.01-.4-.24-.63-.14-.02-.17,0-.3.19-.35Z"
      />
      <path
        className="cls-2"
        d="m67.83,53.01c-.37-.05-.48-.34-.6-.63.38.03.48.35.6.63Z"
      />
      <path
        className="cls-2"
        d="m46.44,46.74c.18-.03.17-.19.22-.3.37.23-.04.49.02.64.01-.09-.24-.14-.24-.34Z"
      />
      <path
        className="cls-2"
        d="m47.39,57.74c-.03-.35-.29-.05-.41-.14.1-.19.24-.31.47-.2.09.04.21.07.19.22-.03.16-.16.11-.25.13Z"
      />
      <path
        className="cls-2"
        d="m44.13,70.38c-.32.34-.42.38-.65.21.2-.13.4-.25.65-.21Z"
      />
      <path
        className="cls-2"
        d="m49.64,44.14c-.26-.16-.25-.35.03-.62.05.21.05.42-.03.62Z"
      />
      <path
        className="cls-2"
        d="m48.75,67.79c.03.3-.05.54-.35.66-.05-.31.15-.49.35-.66Z"
      />
      <path
        className="cls-2"
        d="m48.66,41.62c.05.23.31.55-.23.52-.13-.27.07-.38.23-.52Z"
      />
      <path
        className="cls-2"
        d="m44.6,59.39c-.16.21-.36.37-.59.5.01-.38.32-.42.59-.5Z"
      />
      <path
        className="cls-2"
        d="m63.42,60.81c.21-.21.44-.15.68-.07-.21.17-.44.11-.68.07Z"
      />
      <path
        className="cls-2"
        d="m61.45,60.29c-.05.16-.34.07-.31.31-.1.03-.19,0-.23-.1-.05-.13.08-.15.15-.17.12-.04.25-.12.39-.04Z"
      />
      <path
        className="cls-2"
        d="m48.64,47.31c-.3-.06-.27-.28-.23-.5.23.1.26.28.23.5Z"
      />
      <path
        className="cls-2"
        d="m38.59,46.35c.19-.23.38-.25.58,0-.19,0-.38,0-.58,0Z"
      />
      <path
        className="cls-2"
        d="m34.39,47.25c.01.14.1.3-.01.42-.04.04-.17-.01-.22-.11.05-.13.05-.28.23-.31Z"
      />
      <path
        className="cls-2"
        d="m48.49,44.24c.13.14.24.28.14.48-.19-.12-.24-.28-.14-.48Z"
      />
      <path
        className="cls-2"
        d="m57.33,37.24c.17-.09.34-.07.5,0-.16.28-.33.26-.5,0Z"
      />
      <path
        className="cls-2"
        d="m43.31,70.58c-.22,0-.24-.02-.26-.39.19.06.21.24.26.39Z"
      />
      <path
        className="cls-2"
        d="m36.55,47c.09-.26.25-.17.41-.08-.11.15-.27.07-.41.08Z"
      />
      <path
        className="cls-2"
        d="m30.03,55.12c.2,0,.28.13.35.28-.2.01-.33-.06-.35-.28Z"
      />
      <path
        className="cls-2"
        d="m66.32,53.9c.21-.07.33,0,.37.22-.17,0-.32-.03-.37-.22Z"
      />
      <path
        className="cls-2"
        d="m48.54,43.04c.09.14.14.27-.07.36-.12-.15-.17-.28.07-.36Z"
      />
      <path
        className="cls-2"
        d="m30.88,51.11c-.04-.2,0-.35.22-.41,0,.17-.07.31-.22.41Z"
      />
      <path
        className="cls-2"
        d="m46.42,43.52c-.15-.03-.24-.11-.27-.26.21-.04.28.07.27.26Z"
      />
      <path
        className="cls-2"
        d="m45.82,43.16c-.04.21-.21.17-.35.19.02-.24.15-.28.35-.19Z"
      />
      <path
        className="cls-2"
        d="m48.4,46.81c-.28.04-.19-.15-.17-.28.16.03.18.15.17.28Z"
      />
      <path
        className="cls-2"
        d="m62.63,60.83c.09-.1.18-.1.27,0-.09.12-.18.12-.27,0Z"
      />
      <path
        className="cls-2"
        d="m48.39,42.48c.14.08.12.19.05.31-.2-.07-.21-.17-.05-.31Z"
      />
      <path
        className="cls-2"
        d="m49.41,48.95c-.21-.03-.24-.12-.1-.28.14.05.1.17.1.28Z"
      />
      <path
        className="cls-2"
        d="m48.19,46.47c-.13,0-.17-.09-.16-.21.13.01.19.07.16.21Z"
      />
      <path
        className="cls-2"
        d="m49.65,44.88c-.07,0-.11-.04-.1-.11,0-.03.06-.04.1-.07.09.06.08.12,0,.18Z"
      />
      <path
        className="cls-2"
        d="m46.27,46.54c.15-.02.21.05.17.2-.12,0-.17-.09-.17-.2Z"
      />
      <path
        className="cls-2"
        d="m43.69,60.24c0,.13-.05.2-.19.18,0-.13.05-.19.19-.18Z"
      />
      <path
        className="cls-2"
        d="m34.78,55.53c-.12,0-.18-.07-.17-.19.17-.04.21.04.17.19Z"
      />
      <path
        className="cls-2"
        d="m34.69,47.08c0,.18-.07.2-.21.11.04-.1.1-.14.21-.11Z"
      />
      <path
        className="cls-2"
        d="m68.28,53.46c-.14.02-.21-.03-.19-.18.15-.03.21.03.19.18Z"
      />
      <path
        className="cls-3"
        d="m58.19,50.1c-.03.07-.07.08-.13.04.04-.01.09-.03.13-.04Z"
      />
      <path
        className="cls-2"
        d="m42.77,63.95c.17,0,.25.12.27.26.02.12-.08.16-.18.14-.14-.03-.24-.14-.25-.29,0-.1.08-.11.16-.11Z"
      />
      <path
        className="cls-2"
        d="m58,36.98c-.06.03-.1.06-.13.05-.03,0-.05-.04-.08-.07.02-.01.05-.04.07-.04.04,0,.07.03.14.05Z"
      />
      <path
        className="cls-3"
        d="m68.07,58.23c.21.05.3.11.15.36-.17.3-.49.41-.68.67-.02.03-.12.02-.17.01-.11-.03-.06-.1-.05-.18.03-.24.13-.39.38-.44.2-.04.4-.1.34-.38,0-.02.02-.03.04-.04Z"
      />
    </Icon>
  );
}

export function IconHasPockets({ classes, ...props }) {
  return (
    <Icon
      id="Layer_1"
      data-name="Layer 1"
      viewBox="34 22 34 58"
      {...props}
      className={classes}
    >
      <defs>
        <style>
          {`.cls-1 { fill: #918f8f; }`}
          {`.cls-2 { fill: #504c4c; }`}
        </style>
      </defs>
      <path
        className="cls-2"
        d="m63.9,78.11c.38,0,.74-.15,1.12-.1.06.02.11.03.16-.02.4-.13.81-.15,1.22-.14,0,.05,0,.1,0,.16-.26.08-.52.16-.78.25-.28-.03-.58-.11-.78.18-.06,0-.11,0-.17,0-.25,0-.54-.2-.7.17-.69.08-1.32.38-1.96.61-.12.04-.24.09-.36.1-.11,0-.23-.03-.28.12-.06.01-.12.02-.18.04-.14,0-.29-.04-.34.16,0,0-.01,0-.01,0-.37-.01-.72.02-.94.36-.68.32-1.37.13-2.06.07-.05-.08-.12-.07-.2-.03-.63.02-1.23-.18-1.84-.23-.81-.08-1.56-.41-2.37-.41-.03-.09-.04-.2-.18-.1-.05-.01-.1-.02-.16-.03-.31-.15-.62-.25-.97-.14-.12-.02-.23-.04-.35-.06-.08-.1-.19-.09-.29-.05-.05,0-.09-.02-.14-.03-.04-.09-.09-.11-.17-.04-.05,0-.11,0-.16,0-.03-.11-.07-.18-.18-.07-.6-.15-1.2-.17-1.81-.18-.03-.02-.06-.04-.1-.07-.23-.03-.46-.05-.69-.08-.46-.12-.93-.25-1.42-.15-.07,0-.13,0-.2,0-.33-.11-.67-.04-1.01-.02-.58.04-1.17.07-1.75.11-.24-.01-.48-.04-.72-.03-.2,0-.44-.03-.53.24-.48-.04-.91.14-1.36.28-.35.11-.73.15-1.09.24-.42.11-.83.25-1.24.38-.32-.1-.63.05-.95.05-.16,0-.22.09-.22.24-.44.2-.89.24-1.36.18-.15-.36-.1-.59.35-.65.15-.02.33-.08.45-.22.06,0,.11,0,.17,0,.3.05.55-.09.82-.21.37-.16.8-.12,1.16-.28.56-.25,1.12-.51,1.72-.69.87-.27,1.79-.2,2.65-.49l.91-.05c.25.14.48.03.7-.09.36,0,.72-.02,1.08-.03.11.06.22.06.34,0,.13.01.26.02.39.03.11.15.25.11.39.05.19.01.38.02.57.04,0,.09.04.17.15.17.72-.01,1.43.17,2.15.12.04.01.08.02.13.03.33.14.66.33,1.04.2,1.25.22,2.49.46,3.71.81,0,.22.03.44.26.54.17.07.38.06.47-.09.11-.19.23-.13.38-.13.62,0,1.23.24,1.86.08.54,0,1.08.07,1.61-.08.24.06.43.07.67-.11.28-.21.62-.38.96-.45.72-.16,1.44-.35,2.19-.3.12,0,.23,0,.27-.14Z"
      />
      <path
        className="cls-1"
        d="m64.62,63.71c.08,1.06.12,2.12.24,3.18.07.58.14,1.18.34,1.75.09.27.12.56.13.85.02.79.26,1.55.4,2.32.31,1.7.94,3.31,1.39,4.97.14.53.56.96.63,1.53,0,.03,0,.05-.02.1-.32-.04-.5-.3-.63-.52-.59-.98-1.02-2.01-1.29-3.14-.11-.47-.22-.96-.37-1.43-.27-.88-.57-1.78-.62-2.7-.03-.52-.28-1-.2-1.53.02-.17-.1-.36.05-.53.02-.02.04-.09.02-.11-.64-.86-.4-1.86-.47-2.81-.02-.27-.08-.54-.14-.8-.03-.15-.04-.28.05-.41.28.08.52-.04.34-.3-.21-.3,0-.32.15-.43Z"
      />
      <path
        className="cls-1"
        d="m47.79,33.57c.38.17.56.53.77.85.3.46.8.42,1.23.56.12.04.26-.09.33-.24.66-1.35,1.58-2.48,2.88-3.27.32-.19.69-.29,1.06-.32.53-.05.88-.38,1.25-.69.06-.05.1-.15.1-.23,0-.76.14-1.53.12-2.28-.02-.81,0-1.63-.04-2.44-.01-.16-.07-.35.11-.48.07-.05.04-.14-.02-.19-.45-.39-.17-.93-.26-1.39-.01-.07,0-.16.09-.17.1,0,.15.09.14.18-.02.73.33,1.4.35,2.13,0,.34-.06.68.02,1.04.27,1.18-.04,2.36-.19,3.53-.08.69-.63,1.44-1.58,1.4-.31-.02-.64.22-.95.37-.72.36-1.26.96-1.74,1.56-.33.42-.62.89-.96,1.33-.53.67-1.63.77-2.2.13-.32-.36-.7-.67-.87-1.14.16-.08.29.1.45.04-.04-.1-.08-.18-.11-.27Z"
      />
      <path
        className="cls-1"
        d="m46.72,33.04c-.54-.24-1.02-.6-1.56-.85-.49-.23-1.01-.27-1.5-.43-1.13-.38-2.05-.92-2.42-2.16-.12-.39-.28-.78-.31-1.17-.04-.42-.07-.85-.1-1.28-.02-.27-.17-.5-.13-.77.02-.12-.07-.26.11-.35.26.36.19.8.26,1.19.14.69.25,1.39.45,2.07.16.53.5.94.88,1.33.49.49,1.11.61,1.74.68.6.07,1.08.43,1.66.53.32.05.3.29.28.63.25-.39.43-.28.55-.02.07.15.14.22.3.24.08,0,.21.06.12.2-.11.05-.22.11-.33.16Z"
      />
      <path
        className="cls-1"
        d="m57.25,42.98c-.03-.74-.03-1.48.21-2.2.02-.07.05-.14.04-.21-.1-.96.24-1.84.48-2.75.21-.81.31-1.64.62-2.42.04-.09.02-.21.12-.27.1-.06.19-.15.31-.11.15.04.1.18.1.29,0,.42-.2.79-.28,1.2-.27,1.29-.67,2.56-.89,3.85-.11.66-.43,1.3-.28,2,.02.1.05.24-.13.26-.21.02-.05.36-.3.35Z"
      />
      <path
        className="cls-2"
        d="m36.36,57.94c-.07-.21,0-.4.04-.61.3-.32.47-.69.41-1.13.25-.82.5-1.65.73-2.47.28-.99.72-1.94,1.01-2.94.04-.14.17-.26.27-.38.05.03.11.06.16.09.05.56-.23,1.05-.4,1.54-.39,1.13-.68,2.3-1.04,3.43-.39,1.19-.72,2.39-1.07,3.59-.29.06-.07-.36-.32-.34,0-.1.05-.17.1-.25.29-.14.3-.18.09-.36,0-.04.02-.07.03-.11.02,0,.05-.02.07-.03-.02,0-.04-.02-.06-.02Z"
      />
      <path
        className="cls-2"
        d="m58.96,52.82c-.89.06-1.65-.31-2.41-.69-.06-.14-.12-.28-.18-.42-.13-.27-.32-.39-.6-.18-.26-.51-.78-.85-.88-1.45.03-.2.09-.38.36-.36.27.16.37.51.7.6.15.19.05.6.48.53.29.36.73.5,1.11.73.14.09.32.12.41.28.03.4.2.54.6.48.21-.03.45.25.42.48Z"
      />
      <path
        className="cls-1"
        d="m34.76,71.93c.15.64.15,1.29.22,1.93.08.79.09,1.57.1,2.35,0,.58.15,1.17,0,1.75-.02.1-.02.23-.13.25-.16.03-.14-.14-.21-.23-.22-.29.01-.6-.03-.91-.2-1.3-.34-2.61-.35-3.93,0-.39-.19-.78-.07-1.18.15-.02.32.1.47-.03Z"
      />
      <path
        className="cls-2"
        d="m39.17,53.59c.37-.1.72-.26,1.11-.28.11.09.16.04.19-.07.07-.03.13-.07.2-.1.21.09.34.03.39-.19.56-.3,1.08-.66,1.6-1.02.22,0,.43-.04.46-.32.17-.29.3-.6.61-.77.29-.03.25.18.26.35-.43.67-.98,1.24-1.65,1.68-.95.63-1.97,1.08-3.11,1.23-.36-.13-.25-.32-.06-.52Z"
      />
      <path
        className="cls-2"
        d="m39.57,41.15c.05.26.11.51.16.77-.37.02-.29-.28-.31-.47-.03-.2-.01-.4-.25-.47-.01-.06-.02-.11-.03-.17.1-.32-.01-.55-.3-.71-.12-.38-.27-.77-.37-1.16-.05-.2-.24-.26-.3-.45-.16-.47-.24-.95-.22-1.44,0-.18.01-.36-.04-.54.1-.27.27-.54.02-.82-.03-.27-.13-.53-.1-.81.03,0,.06.04.06-.02-.02,0-.04.01-.06.02-.04-.12-.05-.25,0-.37.14-.02.24-.15.4-.11.02.35.23.67.13,1.03-.07,0-.13.04-.13.12,0,.06.05.09.11.09.07.33-.03.67-.02,1-.03.43,0,.85.21,1.24h.01c-.01.15,0,.29.15.35.03.29.01.59.21.84.02.03.05.07.07.1.2.6.42,1.19.53,1.81-.02.08.01.13.08.17Z"
      />
      <path
        className="cls-2"
        d="m44.7,56.89c-.04-.58-.05-1.15.08-1.72.21-.19-.1-.31-.06-.47.01-.22.02-.43.03-.65.11-.04.14-.09.03-.17,0-.8.01-1.6.15-2.4.17-.11.3-.22.07-.39-.07-.37,0-.73.02-1.1.07,0,.14.01.22.02.07,1.05.05,2.1-.04,3.15-.07,0-.15.02-.16.1,0,.08.06.11.14.1.09.72.08,1.44.02,2.16-.1.08-.09.18-.05.29.02.39.08.79-.04,1.18-.16.05-.28-.06-.41-.09Z"
      />
      <path
        className="cls-2"
        d="m64.62,63.71c-.15.1-.35.12-.15.43.18.27-.06.38-.34.3-.03-.15-.05-.3-.07-.45.1-.36.25-.72-.07-1.04,0-.2,0-.4,0-.6.11-.4.26-.82.04-1.22-.24-.43-.28-.88-.3-1.35-.01-.22.02-.49-.24-.63.03-.31-.15-.57-.18-.86.16-.14.02-.29.01-.43-.02-.23,0-.43.32-.26.07.38.31.72.27,1.13-.12.11-.06.16.06.19.01.05.02.11.03.16-.06.33-.03.63.22.88.03.28.07.57.1.85-.07.34-.18.68.13.97,0,.08.01.16.02.24-.08.06-.06.12.02.16.01.23.02.46.04.68.01.22-.11.45.1.64l.02.22Z"
      />
      <path
        className="cls-2"
        d="m39.32,61.01c-.78-.05-1.56.09-2.34.1-.02-.13-.05-.25-.07-.38.25-.18.55-.13.82-.19.15-.03.3-.05.42-.15.13.07.25.09.32-.08.25,0,.51,0,.76,0,.05.13.11.15.18,0,.1-.01.2-.02.3-.04.16.07.33.13.48-.02.02,0,.05,0,.07-.01.19,0,.37,0,.56.01.17.02.22.17.24.31.01.08-.02.19-.12.19-.32.02-.64.21-.97.09-.27-.11-.46-.02-.65.15Z"
      />
      <path
        className="cls-1"
        d="m58.23,29.63c.2.8.41,1.59.63,2.38.16.59.32,1.22.17,1.86-.04.19.1.36.02.54-.04.09-.04.22-.16.23-.15,0-.22-.15-.19-.24.17-.6-.19-1.14-.17-1.72,0-.19-.05-.36-.13-.54-.35-.8-.5-1.63-.49-2.5.11,0,.21-.02.32-.02Z"
      />
      <path
        className="cls-2"
        d="m56.61,22.69c-.14.04-.28.07-.42.11-.15-.28-.3-.22-.45,0-.01,0-.03,0-.04-.01-.13-.08-.37-.07-.37-.24,0-.24.26-.15.4-.22.4-.21.86-.12,1.27-.3.33-.14.41.17.49.43.19.63.15,1.29.25,1.93.11.67.26,1.34.22,2.03-.2.05-.17-.19-.29-.24-.09-.88-.36-1.74-.34-2.63,0-.37,0-.74-.09-1.1.07-.08.11-.19-.01-.22-.13-.03-.16.11-.18.21-.02.02-.03.03-.06.03-.17-.02-.31.04-.38.21Z"
      />
      <path
        className="cls-1"
        d="m60.48,50.32c.33.26.43.68.58,1.03.41.93.92,1.82,1.27,2.78-.19.01-.19.12-.14.26.07.17.05.35.04.53-.14-.05-.2-.19-.22-.3-.13-.76-.64-1.35-.93-2.03-.31-.72-.63-1.43-.94-2.15.11-.04.22-.08.33-.12Z"
      />
      <path
        className="cls-1"
        d="m55.59,59.79c-.17.1-.34,0-.39-.12-.19-.41-.48-.81-.4-1.3.04-.21-.11-.41-.02-.62.34.08.29.34.27.58-.03.34.02.63.37.78.07.03.14.06.2,0,.07-.06.06-.15,0-.19-.45-.29-.18-.72-.21-1.09.17.04.14.2.17.32.29,1.11.77,1.43,1.92,1.23.66-.11,1.31-.04,1.97-.08-.05.24-.24.17-.38.17-.75-.02-1.48.14-2.23.08-.38-.03-.05.15-.06.23-.12,0-.25.02-.37.02.03-.16.05-.37-.19-.32-.26.06-.49-.04-.74-.08.03.15.05.26.07.37Z"
      />
      <path
        className="cls-2"
        d="m34.87,67.96c0,.2,0,.4,0,.59-.31.22-.09.53-.13.8h0c-.29-.2-.38-.73-.17-1,.14-.18.13-.37.03-.56-.07-.12-.14-.22-.05-.35.15-.22.08-.43-.03-.64.06-.45.04-.91.24-1.34.26-.11.21-.27.06-.44,0-.06.01-.11.02-.17.1,0,.16-.04.17-.14,0-.1.02-.23.13-.24.18-.02.09.17.16.25.03.03.07.04.1.07-.16.94-.44,1.87-.48,2.84-.06.11-.18.21-.04.34Z"
      />
      <path
        className="cls-1"
        d="m44.7,56.89c.14.03.26.14.41.09.01.46.01.92.09,1.38.09.53-.04,1.03-.36,1.47-.01-.15-.01-.32-.24-.2-.27.15-.57.24-.86.33-.32.09-.39.31-.17.58-.18.25-.47.17-.72.22q.33-.46-.08-.71c.53-.07,1.02-.32,1.54-.44.24-.05.35-.24.38-.47.06-.57.09-1.13,0-1.7-.03-.18,0-.37.01-.55Z"
      />
      <path
        className="cls-1"
        d="m35.39,64.78s-.07-.04-.1-.07c-.07-.07.02-.27-.16-.25-.11.01-.13.14-.13.24,0,.11-.07.14-.17.14-.07-.52.18-.99.22-1.5.05-.55.08-1.13.44-1.6.11-.15-.23-.35.07-.47.13.1.17.32.4.28-.12,1.08-.47,2.13-.56,3.21Z"
      />
      <path
        className="cls-1"
        d="m38.1,27.81c-.18-.69-.04-1.39-.09-2.08-.03-.35.19-.61.26-.93.05,0,.1,0,.15,0,.16.17.1.39.1.57.03,1.02.14,2.05-.03,3.07-.17-.04-.22-.15-.15-.31.09-.23-.05-.29-.24-.31Z"
      />
      <path
        className="cls-1"
        d="m58.92,48.62c-.47-.49-.72-1.12-1.05-1.7-.18-.3-.26-.73-.3-1.12-.01-.13,0-.29.16-.31.15-.02.25.11.27.23.1.9.66,1.58,1.13,2.3.04.07.06.16.08.24-.31-.05-.21.23-.28.36Z"
      />
      <path
        className="cls-2"
        d="m56.81,59.8c0-.08-.32-.26.06-.23.75.06,1.49-.1,2.23-.08.14,0,.34.07.38-.17.3-.02.61-.06.9.08.11.1.24.06.36.08.22.05.35.17.28.42-.19,0-.39,0-.58-.01-.13-.21-.28-.19-.45-.04-.46.04-.91,0-1.37-.05-.08-.16-.14-.13-.19.02-.54,0-1.08-.02-1.62-.03Z"
      />
      <path
        className="cls-2"
        d="m34.76,71.93c-.15.13-.31,0-.47.03,0-.15-.08-.29.03-.43.1-.04.17-.1.13-.21-.03-.08-.11-.06-.18-.03-.1-.62-.09-1.24.01-1.86.15,0,.3.01.44.02.06.83.11,1.66.03,2.49Z"
      />
      <path
        className="cls-1"
        d="m58.96,52.82c.03-.23-.22-.51-.42-.48-.4.06-.57-.09-.6-.48.1-.03.2-.04.3,0,.81.4,1.64.76,2.63.79-.71.52-1.36.57-1.9.17Z"
      />
      <path
        className="cls-1"
        d="m43.69,77.52c-.86.29-1.78.23-2.65.49-.6.18-1.15.44-1.72.69-.36.16-.79.12-1.16.28-.26.11-.51.26-.82.21.23-.28.59-.26.88-.36,1.21-.43,2.39-.94,3.66-1.17.48-.09.97-.07,1.44-.23.11-.04.26-.05.35.09Z"
      />
      <path
        className="cls-2"
        d="m42.78,60.06q.41.26.08.71c-.42.21-.86.07-1.29.09,0-.17-.15-.27-.24-.39-.09-.12-.18-.2-.1-.35.2,0,.39-.02.59-.03.08.11.13.07.18-.03.26,0,.51,0,.77-.01Z"
      />
      <path
        className="cls-2"
        d="m55.42,57.84c.02.37-.25.79.21,1.09.06.04.06.13,0,.19-.06.06-.13.03-.2,0-.35-.15-.4-.44-.37-.78.02-.24.06-.5-.27-.58-.01-.12-.04-.24.01-.35.07,0,.09-.04.06-.1-.17-.47-.11-.94-.09-1.42.09-.03.18-.06.28-.09,0,.11.02.22.03.33-.25.26-.03.44.11.63l.04.15c-.09.13-.08.25.04.36.05.19.1.39.16.58Z"
      />
      <path
        className="cls-1"
        d="m63.9,78.11c-.04.14-.15.15-.27.14-.75-.05-1.47.14-2.19.3-.34.08-.68.24-.96.45-.23.18-.43.17-.67.11.69-.69,1.62-.8,2.5-.95.51-.09,1.05-.16,1.58-.05Z"
      />
      <path
        className="cls-2"
        d="m37.92,33.02c.06-.72-.11-1.45.1-2.16.11-.13.1-.46.41-.25,0,.05,0,.1,0,.15-.18.06-.21.15-.05.27,0,.26.18.52-.02.77-.07,0-.14.02-.16.1-.02.1.02.16.12.18,0,.28,0,.55,0,.83-.15.07-.17.17-.03.28,0,.06-.01.11-.02.17-.31.08-.19-.28-.36-.34Z"
      />
      <path
        className="cls-1"
        d="m61.03,59.91c.07-.25-.06-.37-.28-.42-.12-.03-.26.02-.36-.08.29-.27.64-.12.97-.14.42-.02.83-.21,1.27-.11.08.02.19-.02.21.09.02.1-.04.23-.14.24-.57.09-1.05.51-1.66.42Z"
      />
      <path
        className="cls-2"
        d="m62.23,54.92c0-.18.03-.36-.04-.53-.05-.14-.04-.25.14-.26.41.66.61,1.42.91,2.13-.02.31-.22.33-.46.28-.03-.08-.05-.17-.08-.25-.03-.35-.06-.71-.37-.95.03-.15-.07-.28-.11-.41Z"
      />
      <path
        className="cls-1"
        d="m62.79,56.54c.24.04.44.02.46-.28.15.44.4.85.37,1.34-.31-.17-.34.03-.32.26.01.15.15.29-.01.43-.23-.19-.23-.45-.27-.71-.05-.35-.15-.69-.22-1.03Z"
      />
      <path
        className="cls-2"
        d="m58.92,48.62c.08-.14-.03-.41.28-.36.18.33.49.58.62.94-.13.13-.05.16.08.18.03.03.07.05.1.08.09.29.16.59.45.77,0,.03.02.07.03.1-.11.04-.22.08-.33.12-.19-.23-.33-.49-.46-.77-.12-.26-.32-.53-.54-.75-.09-.09-.21-.16-.23-.3Z"
      />
      <path
        className="cls-1"
        d="m63.47,59.14c.26.14.23.41.24.63.03.47.07.92.3,1.35.22.4.07.82-.04,1.22-.3-.43-.26-.94-.33-1.43-.08-.59-.12-1.19-.18-1.78Z"
      />
      <path
        className="cls-2"
        d="m35.95,61.57c-.23.04-.27-.18-.4-.28,0-.03.01-.06.03-.08.19-.04.29-.15.26-.35-.38-.54.1-.98.17-1.47.15,0,.26.08.36.19-.01.08-.03.16-.04.24-.11.03-.18.07-.07.19-.03.54-.3,1.03-.31,1.57Z"
      />
      <path
        className="cls-1"
        d="m38.43,30.61c-.32-.22-.3.12-.41.25-.11-.74-.08-1.48-.08-2.23,0-.08.06-.13.14-.14.09.21.03.42.04.63.02.47.02.48.41.25,0,.41.11.84-.09,1.23Z"
      />
      <path
        className="cls-1"
        d="m58.21,79.19c-.63.16-1.24-.08-1.86-.08-.15,0-.27-.06-.38.13-.09.15-.3.16-.47.09-.23-.1-.25-.32-.26-.54.56-.05,1.11.13,1.66.19.3.03.6.06.9.07.15,0,.33-.06.42.13Z"
      />
      <path
        className="cls-1"
        d="m41.24,60.12c-.09.15,0,.23.1.35.09.11.23.22.24.39-.01.02-.03.07-.04.07-.74.03-1.47.18-2.21.08.19-.18.38-.26.65-.15.32.13.64-.07.97-.09.11,0,.14-.11.12-.19-.02-.14-.07-.29-.24-.31-.18-.02-.37,0-.56-.01.3-.25.64-.15.98-.13Z"
      />
      <path
        className="cls-1"
        d="m34.92,79.89c-.36-.14-.59-.43-.83-.71-.09-.1-.13-.21-.06-.31.11-.14.2,0,.28.06.45.38,1.01.38,1.55.44-.18.13-.38.24-.59.16-.43-.16-.47,0-.35.35Z"
      />
      <path
        className="cls-1"
        d="m45.24,50c-.07,0-.14-.01-.22-.02-.27.03-.33.26-.45.45-.17.27-.24.62-.58.76-.01-.17.03-.39-.26-.35.17-.34.42-.6.76-.78.12-.06.24-.15.35-.24.1-.09.16-.28.32-.21.14.07.11.24.08.39Z"
      />
      <path
        className="cls-1"
        d="m40.16,46.02c-.25-.19-.37-.45-.32-.69.09-.48-.02-.92-.1-1.37-.02-.14-.04-.27.12-.31.19-.05.22.13.22.24.02.7.29,1.38.08,2.13Z"
      />
      <path
        className="cls-2"
        d="m38.81,50.24s0-.06,0-.08c.13-.06.21-.14.12-.29.2-.61.45-1.2.74-1.78.07.03.14.05.2.08-.19.68-.44,1.32-.73,1.96-.05.11-.17.1-.2.2-.05-.03-.1-.06-.15-.08Z"
      />
      <path
        className="cls-2"
        d="m43.58,60.55c-.21-.28-.14-.49.17-.58.3-.09.59-.18.86-.33.23-.13.23.05.24.2-.35.38-.79.58-1.28.72Z"
      />
      <path
        className="cls-1"
        d="m34.73,69.44c-.15,0-.3-.01-.44-.02-.09-.78,0-1.56.09-2.33.01-.11,0-.24.14-.29.11.21.18.42.03.64-.09.13-.01.24.05.35.1.19.11.38-.03.56-.21.27-.11.8.17,1,0,.03,0,.06,0,.09Z"
      />
      <path
        className="cls-2"
        d="m34.92,79.89c-.11-.35-.07-.52.35-.35.21.08.42-.03.59-.16.09,0,.17,0,.26-.01,0,.25-.32.41-.19.69-.36.09-.68-.09-1.02-.16Z"
      />
      <path
        className="cls-1"
        d="m57.56,43.57c.1.46.08.94.27,1.38.08.18-.06.32-.22.36-.17.04-.2-.12-.23-.25-.08-.48-.08-.97-.09-1.46.09.01.18.03.26-.03Z"
      />
      <path
        className="cls-2"
        d="m38.52,29.37c-.39.23-.39.22-.41-.25,0-.21.05-.42-.04-.63,0-.23.01-.45.02-.68.19.02.34.08.24.31-.07.17-.02.27.15.31.01.31.02.62.03.94Z"
      />
      <path
        className="cls-2"
        d="m38.73,23c.29-.07.57-.14.86-.21.05.09.1.2.21.19.4-.02.23.16.12.32-.28.03-.56.12-.86.09-.17-.08-.39-.12-.33-.39Z"
      />
      <path
        className="cls-2"
        d="m46.72,33.04c.11-.05.22-.11.33-.16.45.02.58.37.74.69.04.09.07.18.11.27-.16.06-.29-.12-.45-.04,0,0,0,0,0,0,.03-.19-.08-.25-.24-.27-.17-.16-.38-.27-.5-.49Z"
      />
      <path
        className="cls-1"
        d="m39.17,40.98c.24.07.23.27.25.47.03.19-.05.49.31.47.07.4.23.8,0,1.2-.04-.02-.08-.03-.09-.05-.16-.7-.32-1.39-.48-2.09Z"
      />
      <path
        className="cls-1"
        d="m54.6,52.24c-.21-.31-.14-.66-.13-1,0-.27,0-.53.04-.8.31.55.29,1.17.28,1.78-.06,0-.12.01-.19.02Z"
      />
      <path
        className="cls-1"
        d="m37.92,33.02c.16.07.05.42.36.34.03.35.07.7-.07,1.04-.15-.04-.26.09-.4.11.05-.5-.05-1,.11-1.49Z"
      />
      <path
        className="cls-1"
        d="m38.73,23c-.06.27.16.31.33.39-.48.02-.59.34-.6.74-.08-.03-.15-.06-.23-.1-.01-.19-.05-.37-.03-.56.03-.3.17-.52.53-.48Z"
      />
      <path
        className="cls-2"
        d="m58.02,27.25c.13.5,0,1.02.14,1.52-.38.06-.12-.4-.36-.45-.02-.28-.04-.56-.05-.84.11-.06.06-.3.27-.23Z"
      />
      <path
        className="cls-1"
        d="m54.75,54.92c-.07-.25-.25-.65-.21-.71.18-.32-.09-.67.11-.96.05,0,.1,0,.14,0,.11.55.19,1.1.16,1.66-.07,0-.14,0-.21,0Z"
      />
      <path
        className="cls-1"
        d="m50.35,77.76c-.72.05-1.43-.13-2.15-.12-.11,0-.14-.08-.15-.17.78,0,1.55,0,2.29.29Z"
      />
      <path
        className="cls-1"
        d="m35.94,80.05c-.13-.28.19-.44.19-.69.35-.05.71-.11,1.06-.16-.12.14-.29.2-.45.22-.45.06-.5.29-.35.65-.15,0-.3,0-.45,0Z"
      />
      <path
        className="cls-1"
        d="m40.39,23.81c.22.65.35,1.2.35,1.77-.26-.52-.38-1.07-.35-1.77Z"
      />
      <path
        className="cls-1"
        d="m58.02,27.25c-.21-.07-.16.17-.27.23-.13-.43-.04-.86-.08-1.3.12.05.09.29.29.24.07.27.17.54.06.82Z"
      />
      <path
        className="cls-1"
        d="m55.24,49.72c-.26-.02-.32.15-.36.36-.03-.02-.07-.05-.1-.07-.18-.14-.21-.34-.13-.53.04-.09.13-.24.25-.19.19.07.34.2.34.44Z"
      />
      <path
        className="cls-2"
        d="m55.59,59.79c-.02-.11-.04-.22-.07-.37.25.04.48.14.74.08.24-.05.22.16.19.32-.29.06-.57,0-.86-.03Z"
      />
      <path
        className="cls-2"
        d="m54.8,53.26s-.1,0-.14,0c-.16-.33-.07-.67-.05-1.01.06,0,.12-.01.19-.02,0,.34,0,.69,0,1.03Z"
      />
      <path
        className="cls-1"
        d="m37.75,79.88c0-.15.05-.24.22-.24.32,0,.63-.15.95-.05-.35.25-.75.29-1.17.29Z"
      />
      <path
        className="cls-1"
        d="m42.61,78.69c.09-.27.33-.23.53-.24.24,0,.48.02.72.03-.39.22-.83.16-1.25.21Z"
      />
      <path
        className="cls-1"
        d="m39.92,23.3c.11-.16.28-.35-.12-.32-.11,0-.16-.1-.21-.19.09-.07.19-.04.29-.03.16.02.41-.05.42.17.01.19-.13.37-.38.37Z"
      />
      <path
        className="cls-2"
        d="m58.23,29.63c-.11,0-.21.02-.32.02-.02-.02-.02-.04-.02-.06.02-.15.04-.3.04-.45,0-.16.03-.28.23-.26,0,.25.15.49.07.75Z"
      />
      <path
        className="cls-1"
        d="m55.76,51.53c.28-.21.47-.09.6.18.07.14.12.28.18.42-.31-.13-.57-.34-.78-.6Z"
      />
      <path
        className="cls-2"
        d="m38.23,24.04c.08.03.15.06.23.1.04.23.07.45-.04.67-.05,0-.1,0-.15,0-.15-.25-.05-.51-.05-.77Z"
      />
      <path
        className="cls-2"
        d="m57.56,43.57c-.08.06-.17.04-.26.03-.11-.2-.06-.41-.05-.62.24,0,.08-.33.3-.35,0,.32.01.63.02.95Z"
      />
      <path
        className="cls-1"
        d="m46.82,78.38c.49-.1.95.03,1.42.15-.48.02-.97.11-1.42-.15Z"
      />
      <path
        className="cls-1"
        d="m36.38,59.58c-.1-.1-.21-.19-.36-.19.04-.23.08-.45.11-.68.25-.03.03.4.32.34.03.18.05.36-.07.53Z"
      />
      <path
        className="cls-1"
        d="m58.16,28.88c-.2-.02-.23.1-.23.26,0,.15-.03.3-.04.45-.28-.4-.13-.84-.08-1.26.24.05-.02.51.36.45,0,.03,0,.07,0,.1Z"
      />
      <path
        className="cls-1"
        d="m59.89,79.99c.23-.35.58-.38.94-.36-.12.12-.75.37-.94.36Z"
      />
      <path
        className="cls-1"
        d="m38.51,37.88c-.2-.39-.24-.81-.21-1.24.28.25.14.6.22.9.03.11,0,.23,0,.34Z"
      />
      <path
        className="cls-2"
        d="m54.75,54.92c.07,0,.14,0,.21,0,.07.19.15.38.09.58-.09,0-.19,0-.28,0,0-.19,0-.38-.01-.57Z"
      />
      <path
        className="cls-1"
        d="m39.17,53.59c-.19.2-.3.38.06.52-.24.09-.47.07-.5-.22-.02-.26.2-.33.43-.29Z"
      />
      <path
        className="cls-1"
        d="m36.82,56.2c.06.45-.12.81-.41,1.13.12-.39.2-.78.41-1.13Z"
      />
      <path
        className="cls-1"
        d="m63.98,62.95c.32.33.17.69.07,1.04-.18-.34-.07-.69-.07-1.04Z"
      />
      <path
        className="cls-1"
        d="m37.92,35.7c.25.28.08.55-.02.82-.19-.28-.22-.55.02-.82Z"
      />
      <path
        className="cls-1"
        d="m51.52,77.99c-.38.13-.71-.06-1.04-.2.37-.03.71.05,1.04.2Z"
      />
      <path
        className="cls-1"
        d="m64.43,61.76c-.31-.29-.2-.63-.13-.97.16.31.1.65.13.97Z"
      />
      <path
        className="cls-1"
        d="m45.61,78.37c.34-.03.67-.09,1.01.02-.34.19-.68.25-1.01-.02Z"
      />
      <path
        className="cls-1"
        d="m64.2,59.94c-.24-.25-.27-.56-.22-.88.26.25.17.58.22.88Z"
      />
      <path
        className="cls-1"
        d="m52.13,79.1c.35-.1.66,0,.97.14-.34.07-.66-.03-.97-.14Z"
      />
      <path
        className="cls-1"
        d="m62.34,55.33c.31.25.34.6.37.95-.24-.27-.23-.64-.37-.95Z"
      />
      <path
        className="cls-1"
        d="m39.88,48.16c-.07-.03-.14-.05-.2-.08.04-.19.08-.39.14-.66.1.2.25.3.11.48,0,0-.02.02-.02.02,0,.02,0,.04.01.05.03.07.02.13-.03.18Z"
      />
      <path
        className="cls-1"
        d="m38.83,40.1c.28.16.4.39.3.71-.1-.24-.2-.47-.3-.71Z"
      />
      <path
        className="cls-1"
        d="m60.45,50.22c-.29-.17-.37-.47-.45-.77.29.17.38.46.45.77Z"
      />
      <path
        className="cls-1"
        d="m56.42,50.85c-.43.07-.33-.35-.48-.53.32.04.36.32.48.53Z"
      />
      <path
        className="cls-1"
        d="m34.74,69.36c.04-.27-.17-.58.13-.8-.02.27.19.58-.13.8Z"
      />
      <path
        className="cls-1"
        d="m36.91,60.73c.02.13.05.25.07.38-.09.12-.25.18-.29.03-.04-.13-.06-.38.22-.4Z"
      />
      <path
        className="cls-1"
        d="m63.97,78.6c.16-.37.45-.17.7-.17-.21.14-.44.21-.7.17Z"
      />
      <path
        className="cls-1"
        d="m64.84,78.43c.21-.29.5-.21.78-.18-.25.11-.5.23-.78.18Z"
      />
      <path
        className="cls-1"
        d="m45.29,77.38c-.22.12-.44.23-.7.09.22-.12.45-.2.7-.09Z"
      />
      <path
        className="cls-1"
        d="m55.18,56.75c-.14-.19-.36-.37-.11-.63.13.19.15.41.11.63Z"
      />
      <path
        className="cls-1"
        d="m55.75,22.8c.15-.22.3-.28.45,0-.15.15-.3.17-.45,0Z"
      />
      <path
        className="cls-1"
        d="m64.61,63.49c-.21-.18-.09-.42-.1-.64.25.18.13.41.1.64Z"
      />
      <path
        className="cls-1"
        d="m40.09,46.31c.15.06.11.2.11.32,0,.08-.04.16-.12.1-.07-.05-.27.01-.19-.19.04-.1.03-.24.2-.23Z"
      />
      <path
        className="cls-1"
        d="m43.12,51.61c-.03.28-.24.31-.46.32.06-.24.26-.28.46-.32Z"
      />
      <path
        className="cls-1"
        d="m44.72,54.69c-.04.17.28.28.06.47-.31-.12-.23-.29-.06-.47Z"
      />
      <path
        className="cls-1"
        d="m54.76,55.49c.09,0,.19,0,.28,0,0,.1,0,.19,0,.29-.09.03-.18.06-.28.09-.06-.13-.05-.26,0-.38Z"
      />
      <path
        className="cls-1"
        d="m60,59.86c.16-.15.31-.18.45.04-.15.05-.3.05-.45-.04Z"
      />
      <path
        className="cls-1"
        d="m34.81,65.03c.15.17.2.33-.06.44-.04-.15-.1-.31.06-.44Z"
      />
      <path
        className="cls-1"
        d="m56.61,22.69c.07-.17.21-.22.38-.21-.05.21-.2.25-.38.21Z"
      />
      <path
        className="cls-1"
        d="m35.85,60.86c.02.2-.08.31-.26.35-.02-.2-.02-.38.26-.35Z"
      />
      <path
        className="cls-1"
        d="m38.81,50.24s.1.06.15.08c.04.03.08.07.12.1-.03.02-.07.05-.1.07-.05-.03-.11-.06-.16-.09-.05-.06-.11-.11,0-.17Z"
      />
      <path
        className="cls-1"
        d="m36.33,58.11c.21.18.2.22-.09.36-.08-.15.04-.24.09-.36Z"
      />
      <path
        className="cls-1"
        d="m45,51.08c.23.17.1.29-.07.39-.07-.15,0-.27.07-.39Z"
      />
      <path
        className="cls-1"
        d="m40.19,60.27c-.15.15-.32.09-.48.02.15-.12.31-.13.48-.02Z"
      />
      <path
        className="cls-1"
        d="m41.07,52.95c-.06.22-.19.28-.39.19.1-.13.23-.2.39-.19Z"
      />
      <path
        className="cls-1"
        d="m38.68,38.22c-.16-.06-.17-.2-.15-.34.18.05.18.19.15.34Z"
      />
      <path
        className="cls-1"
        d="m57.05,22.45c.02-.1.05-.24.18-.21.12.03.09.14.01.22-.06,0-.13,0-.19-.01Z"
      />
      <path
        className="cls-1"
        d="m55.26,57.26c-.12-.11-.14-.23-.04-.36.11.11.09.23.04.36Z"
      />
      <path
        className="cls-1"
        d="m47.5,77.43c-.14.06-.28.1-.39-.05.15-.11.27-.09.39.05Z"
      />
      <path
        className="cls-1"
        d="m47.21,33.53c.16.02.27.09.24.27-.15-.03-.25-.11-.24-.27Z"
      />
      <path
        className="cls-1"
        d="m34.87,67.96c-.14-.13-.01-.23.04-.34.13.13.09.24-.04.34Z"
      />
      <path
        className="cls-1"
        d="m60.85,79.62c.05-.19.2-.17.34-.16-.05.19-.19.2-.34.16Z"
      />
      <path
        className="cls-1"
        d="m38.33,32.08c-.1-.02-.14-.08-.12-.18.02-.08.09-.1.16-.1-.01.09-.03.19-.04.28Z"
      />
      <path
        className="cls-1"
        d="m38.3,33.19c-.13-.11-.12-.2.03-.28.04.1.06.2-.03.28Z"
      />
      <path
        className="cls-1"
        d="m38.47,60.31c-.07.17-.19.15-.32.08.08-.15.19-.15.32-.08Z"
      />
      <path
        className="cls-1"
        d="m46.71,77.35c-.11.06-.22.06-.34,0,.11-.16.22-.16.34,0Z"
      />
      <path
        className="cls-1"
        d="m45.15,55.8c-.04-.11-.05-.21.05-.29.09.12.05.21-.05.29Z"
      />
      <path
        className="cls-1"
        d="m38.39,31.03c-.16-.12-.13-.21.05-.27.05.1.07.2-.05.27Z"
      />
      <path
        className="cls-1"
        d="m51.49,79c.11-.05.21-.06.29.05-.11.09-.21.06-.29-.05Z"
      />
      <path
        className="cls-1"
        d="m45.19,53.35c-.08.01-.15-.02-.14-.1,0-.08.09-.09.16-.1.06.07.07.14-.01.2Z"
      />
      <path
        className="cls-1"
        d="m34.28,71.28c.07-.03.15-.05.18.03.04.11-.03.18-.13.21-.02-.08-.03-.16-.05-.24Z"
      />
      <path
        className="cls-1"
        d="m61.37,79.42c.05-.15.17-.13.28-.12-.06.11-.12.23-.28.12Z"
      />
      <path
        className="cls-1"
        d="m38.94,49.86c.09.15,0,.23-.12.29,0-.12.03-.22.12-.29Z"
      />
      <path
        className="cls-1"
        d="m36.26,60.01c-.11-.11-.04-.16.07-.19.02.08.03.16-.07.19Z"
      />
      <path
        className="cls-1"
        d="m58.44,59.83c.05-.15.11-.18.19-.02-.06,0-.13.01-.19.02Z"
      />
      <path
        className="cls-1"
        d="m39.57,41.15c-.06-.04-.1-.09-.08-.17.04.05.18.05.08.17Z"
      />
      <path
        className="cls-1"
        d="m66.4,78c0-.05,0-.1,0-.16.07-.02.16-.04.17.04.02.1-.08.12-.17.12Z"
      />
      <path
        className="cls-1"
        d="m38.32,35.63c-.06,0-.11-.03-.11-.09,0-.08.06-.11.13-.12.04.07.02.14-.02.21Z"
      />
      <path
        className="cls-1"
        d="m50.83,78.86c.11-.11.16-.04.18.07-.09.04-.16.04-.18-.07Z"
      />
      <path
        className="cls-1"
        d="m59.9,49.38c-.13-.02-.21-.05-.08-.18.1.03.08.1.08.18Z"
      />
      <path
        className="cls-1"
        d="m51.18,78.93c.08-.07.13-.05.17.04-.08.06-.13.03-.17-.04Z"
      />
      <path
        className="cls-1"
        d="m65.18,77.99c-.04.06-.1.05-.16.02.05-.04.08-.2.16-.02Z"
      />
      <path
        className="cls-1"
        d="m40.47,53.24c-.03.11-.08.16-.19.07.03-.1.1-.11.19-.07Z"
      />
      <path
        className="cls-1"
        d="m44.79,53.87c.11.08.07.13-.03.17-.1-.08-.05-.13.03-.17Z"
      />
      <path
        className="cls-1"
        d="m53.25,79.28c.13-.1.15,0,.18.1-.09.03-.14-.03-.18-.1Z"
      />
      <path
        className="cls-1"
        d="m39.41,60.32c-.07.14-.12.12-.18,0,.06-.07.12-.08.18,0Z"
      />
      <path
        className="cls-1"
        d="m63.95,58.9c-.12-.03-.18-.08-.06-.19.11.03.09.11.06.19Z"
      />
      <path
        className="cls-1"
        d="m64.47,62.17c-.08-.05-.1-.1-.02-.16.1.04.09.1.02.16Z"
      />
      <path
        className="cls-1"
        d="m42.01,60.07c-.04.1-.1.14-.18.03.05-.09.1-.11.18-.03Z"
      />
      <path
        className="cls-1"
        d="m57.64,80.03c.07-.04.14-.05.2.03-.09.11-.14.05-.2-.03Z"
      />
      <path
        className="cls-2"
        d="m39.91,47.98s-.01-.04-.01-.05c0,0,.02-.02.02-.02,0,.03,0,.05,0,.08Z"
      />
      <path
        className="cls-1"
        d="m38.97,39.17s-.05-.07-.07-.1c.06,0,.09.03.07.1Z"
      />
      <path
        className="cls-1"
        d="m48.92,78.61s.06.04.1.07c-.06.02-.09,0-.1-.07Z"
      />
      <path
        className="cls-1"
        d="m37.81,34.88s.04-.01.06-.02c0,.06-.04.03-.06.02,0,0,0,0,0,0Z"
      />
      <path
        className="cls-1"
        d="m54.85,57.3c.03.06.01.1-.06.1.02-.04.04-.07.06-.1Z"
      />
      <path
        className="cls-1"
        d="m36.36,57.94s.04.02.06.02c-.02,0-.05.02-.07.03-.02-.02-.01-.04.01-.05Z"
      />
    </Icon>
  );
}

export function IconGift(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      fill="none"
      viewBox="0 0 18 19"
      {...props}
    >
      <path
        fill="#2D2926"
        fillRule="evenodd"
        d="M5.16 2.54c.29 1.196.974 2.174 1.868 2.76H1.8C.96 5.3.3 5.96.3 6.8v2.4c0 .18.12.3.3.3h.3v6.9c0 .84.66 1.5 1.5 1.5h13.2c.84 0 1.5-.66 1.5-1.5V9.5h.3c.18 0 .3-.12.3-.3V6.8c0-.84-.66-1.5-1.5-1.5H10.98c.897-.58 1.593-1.542 1.919-2.7.12-.42-.06-.9-.36-1.2-.3-.3-.66-.36-.96-.24-1.146.41-2.068 1.376-2.539 2.596C8.578 2.508 7.644 1.516 6.48 1.1c-.36-.06-.72 0-.96.24-.36.3-.48.78-.36 1.2zm4.19 2.676a5.174 5.174 0 00-.022-.249C9.53 3.46 10.458 2.153 11.76 1.7h.12c.12 0 .18.06.18.06.12.12.24.3.18.6-.354 1.594-1.522 2.665-2.874 2.87l-.016-.014zm-.11.691l1.98 1.733c.06.06.12.06.18.06.03 0 .075-.015.12-.03a.463.463 0 01.12-.03.29.29 0 000-.42L10.13 5.9H16.2c.48 0 .9.42.9.9v2.1H9.24V5.907zM6.118 1.7c-.119 0-.178.06-.238.12-.12.12-.24.36-.18.6.412 1.531 1.576 2.658 2.867 2.869l.067-.06C8.496 3.58 7.661 2.115 6.3 1.7h-.182zM1.8 5.9h6.068L6.36 7.22a.29.29 0 000 .42c.12.12.3.12.42 0L8.7 5.96V8.9H.9V6.8c0-.48.42-.9.9-.9zm-.3 3.6h7.2v7.8H2.4c-.48 0-.9-.42-.9-.9V9.5zm7.74 0v7.8h6.36c.48 0 .9-.42.9-.9V9.5H9.24z"
        clipRule="evenodd"
      ></path>
    </Icon>
  );
}

export function IconCarat(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
      {...props}
    >
      <path
        stroke="#2D2926"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="16"
        d="M6.545 4.09L11.455 9l-4.91 4.909"
      ></path>
    </Icon>
  );
}

export function IconCheckbox({ checked }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill="#fff" d="M0 0H24V24H0z"></path>
      <path fill="#fff" stroke="#ABA9A8" d="M0.5 0.5H23.5V23.5H0.5z"></path>
      {checked ? (
        <path
          className="checked"
          stroke="#2D2926"
          strokeWidth="1.5"
          d="M5 12l4.667 5L19 7"
        ></path>
      ) : null}
    </Icon>
  );
}

export function IconCheckboxRound({ checked }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      fill="none"
      viewBox="0 0 22 19"
    >
      {checked ? (
        <rect
          x="4.51462"
          y="3"
          width="12.3438"
          height="12.3438"
          rx="6.17188"
          fill="#2D2926"
        />
      ) : null}
      <rect
        x="1.36857"
        y="0"
        width="18.5443"
        height="18.5443"
        rx="9.77214"
        stroke="#2D2926"
        strokeWidth="1.02865"
      />
    </Icon>
  );
}

export function IconCheckbox2({ checked }) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      {checked ? (
        <path fill="#2D2926" d="M4 4.077H16V16.076999999999998H4z"></path>
      ) : null}
      <path stroke="#2D2926" d="M0.5 0.577H19.5V19.576999999999998H0.5z"></path>
    </Icon>
  );
}

export function IconTextCheckbox() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 4.5L5.16667 8.5L12.5 1.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconCircle({ strokeDasharray }) {
  return (
    <svg width="140" height="140" viewBox="0 0 38 38">
      <circle
        cx="19"
        cy="19"
        r="15.91549430918954"
        fill="transparent"
        stroke="#FBFAF6"
        strokeWidth="4"
        strokeDasharray="100 100"
      ></circle>
      <circle
        cx="19"
        cy="19"
        r="15.91549430918954"
        pathLength="100"
        fill="transparent"
        stroke="#879EB4"
        strokeWidth="2"
        strokeDasharray={strokeDasharray}
        strokeLinecap="round"
      ></circle>
    </svg>
  );
}

export function IconLookRight({ classes = '' }) {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="{{ aria_label }}"
      className={classes}
    >
      <path
        d="M8 17.3784L14 11.3784L8 5.37842"
        stroke="#2D2926"
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconLookLeft() {
  return (
    <svg
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="{{ aria_label }}"
      className="w-1.5 h-3"
    >
      <path
        d="M6.5 13.0001L0.5 7.00012L6.5 1.00012"
        stroke="#2D2926"
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconMagnifyingGlass() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path stroke="currentColor" strokeLinecap="round" d="M5 1v8M9 5H1"></path>
    </svg>
  );
}

export function IconBag(props) {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="currentColor"
        d="m17 8-3.16-5.898a2.088 2.088 0 0 0-3.68 0L7 8"
      ></path>
      <path
        stroke="currentColor"
        d="M.669 11.155c-.072-.153-.04-.268.013-.33C1.442 9.957 4.26 7.5 12 7.5s10.559 2.456 11.318 3.326c.054.06.085.176.013.33L17.27 24.21a.5.5 0 0 1-.454.289H7.184a.5.5 0 0 1-.454-.29z"
      ></path>
    </Icon>
  );
}
